const post_codes = [
  {
    code: "00-001",
    city: "Warszawa",
  },
  {
    code: "00-002",
    city: "Warszawa",
  },
  {
    code: "00-003",
    city: "Warszawa",
  },
  {
    code: "00-004",
    city: "Warszawa",
  },
  {
    code: "00-005",
    city: "Warszawa",
  },
  {
    code: "00-006",
    city: "Warszawa",
  },
  {
    code: "00-007",
    city: "Warszawa",
  },
  {
    code: "00-008",
    city: "Warszawa",
  },
  {
    code: "00-009",
    city: "Warszawa",
  },
  {
    code: "00-010",
    city: "Warszawa",
  },
  {
    code: "00-011",
    city: "Warszawa",
  },
  {
    code: "00-012",
    city: "Warszawa",
  },
  {
    code: "00-013",
    city: "Warszawa",
  },
  {
    code: "00-014",
    city: "Warszawa",
  },
  {
    code: "00-015",
    city: "Warszawa",
  },
  {
    code: "00-016",
    city: "Warszawa",
  },
  {
    code: "00-017",
    city: "Warszawa",
  },
  {
    code: "00-018",
    city: "Warszawa",
  },
  {
    code: "00-019",
    city: "Warszawa",
  },
  {
    code: "00-020",
    city: "Warszawa",
  },
  {
    code: "00-021",
    city: "Warszawa",
  },
  {
    code: "00-022",
    city: "Warszawa",
  },
  {
    code: "00-023",
    city: "Warszawa",
  },
  {
    code: "00-024",
    city: "Warszawa",
  },
  {
    code: "00-025",
    city: "Warszawa",
  },
  {
    code: "00-026",
    city: "Warszawa",
  },
  {
    code: "00-027",
    city: "Warszawa",
  },
  {
    code: "00-028",
    city: "Warszawa",
  },
  {
    code: "00-029",
    city: "Warszawa",
  },
  {
    code: "00-030",
    city: "Warszawa",
  },
  {
    code: "00-031",
    city: "Warszawa",
  },
  {
    code: "00-032",
    city: "Warszawa",
  },
  {
    code: "00-033",
    city: "Warszawa",
  },
  {
    code: "00-034",
    city: "Warszawa",
  },
  {
    code: "00-035",
    city: "Warszawa",
  },
  {
    code: "00-036",
    city: "Warszawa",
  },
  {
    code: "00-037",
    city: "Warszawa",
  },
  {
    code: "00-038",
    city: "Warszawa",
  },
  {
    code: "00-039",
    city: "Warszawa",
  },
  {
    code: "00-040",
    city: "Warszawa",
  },
  {
    code: "00-041",
    city: "Warszawa",
  },
  {
    code: "00-042",
    city: "Warszawa",
  },
  {
    code: "00-043",
    city: "Warszawa",
  },
  {
    code: "00-044",
    city: "Warszawa",
  },
  {
    code: "00-046",
    city: "Warszawa",
  },
  {
    code: "00-047",
    city: "Warszawa",
  },
  {
    code: "00-048",
    city: "Warszawa",
  },
  {
    code: "00-049",
    city: "Warszawa",
  },
  {
    code: "00-050",
    city: "Warszawa",
  },
  {
    code: "00-051",
    city: "Warszawa",
  },
  {
    code: "00-052",
    city: "Warszawa",
  },
  {
    code: "00-054",
    city: "Warszawa",
  },
  {
    code: "00-055",
    city: "Warszawa",
  },
  {
    code: "00-056",
    city: "Warszawa",
  },
  {
    code: "00-057",
    city: "Warszawa",
  },
  {
    code: "00-058",
    city: "Warszawa",
  },
  {
    code: "00-059",
    city: "Warszawa",
  },
  {
    code: "00-060",
    city: "Warszawa",
  },
  {
    code: "00-061",
    city: "Warszawa",
  },
  {
    code: "00-062",
    city: "Warszawa",
  },
  {
    code: "00-063",
    city: "Warszawa",
  },
  {
    code: "00-064",
    city: "Warszawa",
  },
  {
    code: "00-065",
    city: "Warszawa",
  },
  {
    code: "00-066",
    city: "Warszawa",
  },
  {
    code: "00-067",
    city: "Warszawa",
  },
  {
    code: "00-068",
    city: "Warszawa",
  },
  {
    code: "00-070",
    city: "Warszawa",
  },
  {
    code: "00-071",
    city: "Warszawa",
  },
  {
    code: "00-072",
    city: "Warszawa",
  },
  {
    code: "00-073",
    city: "Warszawa",
  },
  {
    code: "00-074",
    city: "Warszawa",
  },
  {
    code: "00-075",
    city: "Warszawa",
  },
  {
    code: "00-076",
    city: "Warszawa",
  },
  {
    code: "00-077",
    city: "Warszawa",
  },
  {
    code: "00-078",
    city: "Warszawa",
  },
  {
    code: "00-079",
    city: "Warszawa",
  },
  {
    code: "00-080",
    city: "Warszawa",
  },
  {
    code: "00-081",
    city: "Warszawa",
  },
  {
    code: "00-082",
    city: "Warszawa",
  },
  {
    code: "00-083",
    city: "Warszawa",
  },
  {
    code: "00-084",
    city: "Warszawa",
  },
  {
    code: "00-085",
    city: "Warszawa",
  },
  {
    code: "00-086",
    city: "Warszawa",
  },
  {
    code: "00-087",
    city: "Warszawa",
  },
  {
    code: "00-088",
    city: "Warszawa",
  },
  {
    code: "00-089",
    city: "Warszawa",
  },
  {
    code: "00-090",
    city: "Warszawa",
  },
  {
    code: "00-091",
    city: "Warszawa",
  },
  {
    code: "00-092",
    city: "Warszawa",
  },
  {
    code: "00-093",
    city: "Warszawa",
  },
  {
    code: "00-094",
    city: "Warszawa",
  },
  {
    code: "00-095",
    city: "Warszawa",
  },
  {
    code: "00-096",
    city: "Warszawa",
  },
  {
    code: "00-097",
    city: "Warszawa",
  },
  {
    code: "00-098",
    city: "Warszawa",
  },
  {
    code: "00-099",
    city: "Warszawa",
  },
  {
    code: "00-100",
    city: "Warszawa",
  },
  {
    code: "00-102",
    city: "Warszawa",
  },
  {
    code: "00-103",
    city: "Warszawa",
  },
  {
    code: "00-104",
    city: "Warszawa",
  },
  {
    code: "00-105",
    city: "Warszawa",
  },
  {
    code: "00-107",
    city: "Warszawa",
  },
  {
    code: "00-108",
    city: "Warszawa",
  },
  {
    code: "00-109",
    city: "Warszawa",
  },
  {
    code: "00-110",
    city: "Warszawa",
  },
  {
    code: "00-111",
    city: "Warszawa",
  },
  {
    code: "00-112",
    city: "Warszawa",
  },
  {
    code: "00-113",
    city: "Warszawa",
  },
  {
    code: "00-114",
    city: "Warszawa",
  },
  {
    code: "00-115",
    city: "Warszawa",
  },
  {
    code: "00-116",
    city: "Warszawa",
  },
  {
    code: "00-117",
    city: "Warszawa",
  },
  {
    code: "00-118",
    city: "Warszawa",
  },
  {
    code: "00-119",
    city: "Warszawa",
  },
  {
    code: "00-120",
    city: "Warszawa",
  },
  {
    code: "00-121",
    city: "Warszawa",
  },
  {
    code: "00-123",
    city: "Warszawa",
  },
  {
    code: "00-124",
    city: "Warszawa",
  },
  {
    code: "00-125",
    city: "Warszawa",
  },
  {
    code: "00-126",
    city: "Warszawa",
  },
  {
    code: "00-127",
    city: "Warszawa",
  },
  {
    code: "00-130",
    city: "Warszawa",
  },
  {
    code: "00-131",
    city: "Warszawa",
  },
  {
    code: "00-132",
    city: "Warszawa",
  },
  {
    code: "00-133",
    city: "Warszawa",
  },
  {
    code: "00-135",
    city: "Warszawa",
  },
  {
    code: "00-136",
    city: "Warszawa",
  },
  {
    code: "00-137",
    city: "Warszawa",
  },
  {
    code: "00-138",
    city: "Warszawa",
  },
  {
    code: "00-139",
    city: "Warszawa",
  },
  {
    code: "00-140",
    city: "Warszawa",
  },
  {
    code: "00-141",
    city: "Warszawa",
  },
  {
    code: "00-142",
    city: "Warszawa",
  },
  {
    code: "00-143",
    city: "Warszawa",
  },
  {
    code: "00-144",
    city: "Warszawa",
  },
  {
    code: "00-145",
    city: "Warszawa",
  },
  {
    code: "00-146",
    city: "Warszawa",
  },
  {
    code: "00-147",
    city: "Warszawa",
  },
  {
    code: "00-148",
    city: "Warszawa",
  },
  {
    code: "00-149",
    city: "Warszawa",
  },
  {
    code: "00-150",
    city: "Warszawa",
  },
  {
    code: "00-151",
    city: "Warszawa",
  },
  {
    code: "00-152",
    city: "Warszawa",
  },
  {
    code: "00-153",
    city: "Warszawa",
  },
  {
    code: "00-154",
    city: "Warszawa",
  },
  {
    code: "00-155",
    city: "Warszawa",
  },
  {
    code: "00-156",
    city: "Warszawa",
  },
  {
    code: "00-157",
    city: "Warszawa",
  },
  {
    code: "00-158",
    city: "Warszawa",
  },
  {
    code: "00-159",
    city: "Warszawa",
  },
  {
    code: "00-160",
    city: "Warszawa",
  },
  {
    code: "00-161",
    city: "Warszawa",
  },
  {
    code: "00-162",
    city: "Warszawa",
  },
  {
    code: "00-163",
    city: "Warszawa",
  },
  {
    code: "00-164",
    city: "Warszawa",
  },
  {
    code: "00-165",
    city: "Warszawa",
  },
  {
    code: "00-166",
    city: "Warszawa",
  },
  {
    code: "00-167",
    city: "Warszawa",
  },
  {
    code: "00-168",
    city: "Warszawa",
  },
  {
    code: "00-169",
    city: "Warszawa",
  },
  {
    code: "00-170",
    city: "Warszawa",
  },
  {
    code: "00-171",
    city: "Warszawa",
  },
  {
    code: "00-172",
    city: "Warszawa",
  },
  {
    code: "00-173",
    city: "Warszawa",
  },
  {
    code: "00-174",
    city: "Warszawa",
  },
  {
    code: "00-175",
    city: "Warszawa",
  },
  {
    code: "00-176",
    city: "Warszawa",
  },
  {
    code: "00-177",
    city: "Warszawa",
  },
  {
    code: "00-178",
    city: "Warszawa",
  },
  {
    code: "00-179",
    city: "Warszawa",
  },
  {
    code: "00-180",
    city: "Warszawa",
  },
  {
    code: "00-181",
    city: "Warszawa",
  },
  {
    code: "00-182",
    city: "Warszawa",
  },
  {
    code: "00-183",
    city: "Warszawa",
  },
  {
    code: "00-184",
    city: "Warszawa",
  },
  {
    code: "00-185",
    city: "Warszawa",
  },
  {
    code: "00-186",
    city: "Warszawa",
  },
  {
    code: "00-187",
    city: "Warszawa",
  },
  {
    code: "00-188",
    city: "Warszawa",
  },
  {
    code: "00-189",
    city: "Warszawa",
  },
  {
    code: "00-190",
    city: "Warszawa",
  },
  {
    code: "00-191",
    city: "Warszawa",
  },
  {
    code: "00-192",
    city: "Warszawa",
  },
  {
    code: "00-193",
    city: "Warszawa",
  },
  {
    code: "00-194",
    city: "Warszawa",
  },
  {
    code: "00-195",
    city: "Warszawa",
  },
  {
    code: "00-196",
    city: "Warszawa",
  },
  {
    code: "00-197",
    city: "Warszawa",
  },
  {
    code: "00-198",
    city: "Warszawa",
  },
  {
    code: "00-199",
    city: "Warszawa",
  },
  {
    code: "00-200",
    city: "Warszawa",
  },
  {
    code: "00-201",
    city: "Warszawa",
  },
  {
    code: "00-202",
    city: "Warszawa",
  },
  {
    code: "00-203",
    city: "Warszawa",
  },
  {
    code: "00-204",
    city: "Warszawa",
  },
  {
    code: "00-205",
    city: "Warszawa",
  },
  {
    code: "00-206",
    city: "Warszawa",
  },
  {
    code: "00-207",
    city: "Warszawa",
  },
  {
    code: "00-208",
    city: "Warszawa",
  },
  {
    code: "00-209",
    city: "Warszawa",
  },
  {
    code: "00-210",
    city: "Warszawa",
  },
  {
    code: "00-211",
    city: "Warszawa",
  },
  {
    code: "00-213",
    city: "Warszawa",
  },
  {
    code: "00-214",
    city: "Warszawa",
  },
  {
    code: "00-215",
    city: "Warszawa",
  },
  {
    code: "00-216",
    city: "Warszawa",
  },
  {
    code: "00-217",
    city: "Warszawa",
  },
  {
    code: "00-218",
    city: "Warszawa",
  },
  {
    code: "00-219",
    city: "Warszawa",
  },
  {
    code: "00-220",
    city: "Warszawa",
  },
  {
    code: "00-221",
    city: "Warszawa",
  },
  {
    code: "00-222",
    city: "Warszawa",
  },
  {
    code: "00-223",
    city: "Warszawa",
  },
  {
    code: "00-224",
    city: "Warszawa",
  },
  {
    code: "00-225",
    city: "Warszawa",
  },
  {
    code: "00-227",
    city: "Warszawa",
  },
  {
    code: "00-228",
    city: "Warszawa",
  },
  {
    code: "00-229",
    city: "Warszawa",
  },
  {
    code: "00-230",
    city: "Warszawa",
  },
  {
    code: "00-231",
    city: "Warszawa",
  },
  {
    code: "00-232",
    city: "Warszawa",
  },
  {
    code: "00-233",
    city: "Warszawa",
  },
  {
    code: "00-234",
    city: "Warszawa",
  },
  {
    code: "00-235",
    city: "Warszawa",
  },
  {
    code: "00-236",
    city: "Warszawa",
  },
  {
    code: "00-237",
    city: "Warszawa",
  },
  {
    code: "00-238",
    city: "Warszawa",
  },
  {
    code: "00-240",
    city: "Warszawa",
  },
  {
    code: "00-241",
    city: "Warszawa",
  },
  {
    code: "00-242",
    city: "Warszawa",
  },
  {
    code: "00-243",
    city: "Warszawa",
  },
  {
    code: "00-244",
    city: "Warszawa",
  },
  {
    code: "00-245",
    city: "Warszawa",
  },
  {
    code: "00-246",
    city: "Warszawa",
  },
  {
    code: "00-248",
    city: "Warszawa",
  },
  {
    code: "00-249",
    city: "Warszawa",
  },
  {
    code: "00-251",
    city: "Warszawa",
  },
  {
    code: "00-252",
    city: "Warszawa",
  },
  {
    code: "00-253",
    city: "Warszawa",
  },
  {
    code: "00-254",
    city: "Warszawa",
  },
  {
    code: "00-255",
    city: "Warszawa",
  },
  {
    code: "00-256",
    city: "Warszawa",
  },
  {
    code: "00-257",
    city: "Warszawa",
  },
  {
    code: "00-258",
    city: "Warszawa",
  },
  {
    code: "00-259",
    city: "Warszawa",
  },
  {
    code: "00-260",
    city: "Warszawa",
  },
  {
    code: "00-261",
    city: "Warszawa",
  },
  {
    code: "00-262",
    city: "Warszawa",
  },
  {
    code: "00-263",
    city: "Warszawa",
  },
  {
    code: "00-264",
    city: "Warszawa",
  },
  {
    code: "00-265",
    city: "Warszawa",
  },
  {
    code: "00-266",
    city: "Warszawa",
  },
  {
    code: "00-267",
    city: "Warszawa",
  },
  {
    code: "00-268",
    city: "Warszawa",
  },
  {
    code: "00-270",
    city: "Warszawa",
  },
  {
    code: "00-271",
    city: "Warszawa",
  },
  {
    code: "00-272",
    city: "Warszawa",
  },
  {
    code: "00-273",
    city: "Warszawa",
  },
  {
    code: "00-274",
    city: "Warszawa",
  },
  {
    code: "00-275",
    city: "Warszawa",
  },
  {
    code: "00-277",
    city: "Warszawa",
  },
  {
    code: "00-278",
    city: "Warszawa",
  },
  {
    code: "00-279",
    city: "Warszawa",
  },
  {
    code: "00-280",
    city: "Warszawa",
  },
  {
    code: "00-281",
    city: "Warszawa",
  },
  {
    code: "00-282",
    city: "Warszawa",
  },
  {
    code: "00-283",
    city: "Warszawa",
  },
  {
    code: "00-284",
    city: "Warszawa",
  },
  {
    code: "00-285",
    city: "Warszawa",
  },
  {
    code: "00-286",
    city: "Warszawa",
  },
  {
    code: "00-287",
    city: "Warszawa",
  },
  {
    code: "00-288",
    city: "Warszawa",
  },
  {
    code: "00-301",
    city: "Warszawa",
  },
  {
    code: "00-302",
    city: "Warszawa",
  },
  {
    code: "00-303",
    city: "Warszawa",
  },
  {
    code: "00-304",
    city: "Warszawa",
  },
  {
    code: "00-305",
    city: "Warszawa",
  },
  {
    code: "00-306",
    city: "Warszawa",
  },
  {
    code: "00-307",
    city: "Warszawa",
  },
  {
    code: "00-308",
    city: "Warszawa",
  },
  {
    code: "00-309",
    city: "Warszawa",
  },
  {
    code: "00-310",
    city: "Warszawa",
  },
  {
    code: "00-311",
    city: "Warszawa",
  },
  {
    code: "00-312",
    city: "Warszawa",
  },
  {
    code: "00-313",
    city: "Warszawa",
  },
  {
    code: "00-314",
    city: "Warszawa",
  },
  {
    code: "00-315",
    city: "Warszawa",
  },
  {
    code: "00-316",
    city: "Warszawa",
  },
  {
    code: "00-317",
    city: "Warszawa",
  },
  {
    code: "00-318",
    city: "Warszawa",
  },
  {
    code: "00-321",
    city: "Warszawa",
  },
  {
    code: "00-322",
    city: "Warszawa",
  },
  {
    code: "00-324",
    city: "Warszawa",
  },
  {
    code: "00-325",
    city: "Warszawa",
  },
  {
    code: "00-327",
    city: "Warszawa",
  },
  {
    code: "00-328",
    city: "Warszawa",
  },
  {
    code: "00-330",
    city: "Warszawa",
  },
  {
    code: "00-331",
    city: "Warszawa",
  },
  {
    code: "00-332",
    city: "Warszawa",
  },
  {
    code: "00-333",
    city: "Warszawa",
  },
  {
    code: "00-334",
    city: "Warszawa",
  },
  {
    code: "00-335",
    city: "Warszawa",
  },
  {
    code: "00-336",
    city: "Warszawa",
  },
  {
    code: "00-337",
    city: "Warszawa",
  },
  {
    code: "00-338",
    city: "Warszawa",
  },
  {
    code: "00-339",
    city: "Warszawa",
  },
  {
    code: "00-340",
    city: "Warszawa",
  },
  {
    code: "00-341",
    city: "Warszawa",
  },
  {
    code: "00-342",
    city: "Warszawa",
  },
  {
    code: "00-343",
    city: "Warszawa",
  },
  {
    code: "00-344",
    city: "Warszawa",
  },
  {
    code: "00-345",
    city: "Warszawa",
  },
  {
    code: "00-346",
    city: "Warszawa",
  },
  {
    code: "00-347",
    city: "Warszawa",
  },
  {
    code: "00-348",
    city: "Warszawa",
  },
  {
    code: "00-349",
    city: "Warszawa",
  },
  {
    code: "00-350",
    city: "Warszawa",
  },
  {
    code: "00-351",
    city: "Warszawa",
  },
  {
    code: "00-353",
    city: "Warszawa",
  },
  {
    code: "00-354",
    city: "Warszawa",
  },
  {
    code: "00-355",
    city: "Warszawa",
  },
  {
    code: "00-356",
    city: "Warszawa",
  },
  {
    code: "00-357",
    city: "Warszawa",
  },
  {
    code: "00-358",
    city: "Warszawa",
  },
  {
    code: "00-359",
    city: "Warszawa",
  },
  {
    code: "00-360",
    city: "Warszawa",
  },
  {
    code: "00-362",
    city: "Warszawa",
  },
  {
    code: "00-363",
    city: "Warszawa",
  },
  {
    code: "00-364",
    city: "Warszawa",
  },
  {
    code: "00-365",
    city: "Warszawa",
  },
  {
    code: "00-366",
    city: "Warszawa",
  },
  {
    code: "00-367",
    city: "Warszawa",
  },
  {
    code: "00-368",
    city: "Warszawa",
  },
  {
    code: "00-369",
    city: "Warszawa",
  },
  {
    code: "00-370",
    city: "Warszawa",
  },
  {
    code: "00-372",
    city: "Warszawa",
  },
  {
    code: "00-373",
    city: "Warszawa",
  },
  {
    code: "00-374",
    city: "Warszawa",
  },
  {
    code: "00-375",
    city: "Warszawa",
  },
  {
    code: "00-377",
    city: "Warszawa",
  },
  {
    code: "00-378",
    city: "Warszawa",
  },
  {
    code: "00-379",
    city: "Warszawa",
  },
  {
    code: "00-380",
    city: "Warszawa",
  },
  {
    code: "00-381",
    city: "Warszawa",
  },
  {
    code: "00-382",
    city: "Warszawa",
  },
  {
    code: "00-384",
    city: "Warszawa",
  },
  {
    code: "00-385",
    city: "Warszawa",
  },
  {
    code: "00-386",
    city: "Warszawa",
  },
  {
    code: "00-388",
    city: "Warszawa",
  },
  {
    code: "00-389",
    city: "Warszawa",
  },
  {
    code: "00-390",
    city: "Warszawa",
  },
  {
    code: "00-391",
    city: "Warszawa",
  },
  {
    code: "00-392",
    city: "Warszawa",
  },
  {
    code: "00-393",
    city: "Warszawa",
  },
  {
    code: "00-394",
    city: "Warszawa",
  },
  {
    code: "00-400",
    city: "Warszawa",
  },
  {
    code: "00-401",
    city: "Warszawa",
  },
  {
    code: "00-402",
    city: "Warszawa",
  },
  {
    code: "00-403",
    city: "Warszawa",
  },
  {
    code: "00-404",
    city: "Warszawa",
  },
  {
    code: "00-405",
    city: "Warszawa",
  },
  {
    code: "00-406",
    city: "Warszawa",
  },
  {
    code: "00-407",
    city: "Warszawa",
  },
  {
    code: "00-408",
    city: "Warszawa",
  },
  {
    code: "00-409",
    city: "Warszawa",
  },
  {
    code: "00-410",
    city: "Warszawa",
  },
  {
    code: "00-411",
    city: "Warszawa",
  },
  {
    code: "00-412",
    city: "Warszawa",
  },
  {
    code: "00-413",
    city: "Warszawa",
  },
  {
    code: "00-414",
    city: "Warszawa",
  },
  {
    code: "00-415",
    city: "Warszawa",
  },
  {
    code: "00-416",
    city: "Warszawa",
  },
  {
    code: "00-417",
    city: "Warszawa",
  },
  {
    code: "00-418",
    city: "Warszawa",
  },
  {
    code: "00-419",
    city: "Warszawa",
  },
  {
    code: "00-420",
    city: "Warszawa",
  },
  {
    code: "00-421",
    city: "Warszawa",
  },
  {
    code: "00-422",
    city: "Warszawa",
  },
  {
    code: "00-423",
    city: "Warszawa",
  },
  {
    code: "00-424",
    city: "Warszawa",
  },
  {
    code: "00-425",
    city: "Warszawa",
  },
  {
    code: "00-427",
    city: "Warszawa",
  },
  {
    code: "00-428",
    city: "Warszawa",
  },
  {
    code: "00-429",
    city: "Warszawa",
  },
  {
    code: "00-430",
    city: "Warszawa",
  },
  {
    code: "00-431",
    city: "Warszawa",
  },
  {
    code: "00-432",
    city: "Warszawa",
  },
  {
    code: "00-433",
    city: "Warszawa",
  },
  {
    code: "00-434",
    city: "Warszawa",
  },
  {
    code: "00-435",
    city: "Warszawa",
  },
  {
    code: "00-436",
    city: "Warszawa",
  },
  {
    code: "00-438",
    city: "Warszawa",
  },
  {
    code: "00-439",
    city: "Warszawa",
  },
  {
    code: "00-440",
    city: "Warszawa",
  },
  {
    code: "00-441",
    city: "Warszawa",
  },
  {
    code: "00-442",
    city: "Warszawa",
  },
  {
    code: "00-443",
    city: "Warszawa",
  },
  {
    code: "00-444",
    city: "Warszawa",
  },
  {
    code: "00-446",
    city: "Warszawa",
  },
  {
    code: "00-447",
    city: "Warszawa",
  },
  {
    code: "00-448",
    city: "Warszawa",
  },
  {
    code: "00-449",
    city: "Warszawa",
  },
  {
    code: "00-450",
    city: "Warszawa",
  },
  {
    code: "00-451",
    city: "Warszawa",
  },
  {
    code: "00-452",
    city: "Warszawa",
  },
  {
    code: "00-453",
    city: "Warszawa",
  },
  {
    code: "00-454",
    city: "Warszawa",
  },
  {
    code: "00-455",
    city: "Warszawa",
  },
  {
    code: "00-456",
    city: "Warszawa",
  },
  {
    code: "00-457",
    city: "Warszawa",
  },
  {
    code: "00-458",
    city: "Warszawa",
  },
  {
    code: "00-459",
    city: "Warszawa",
  },
  {
    code: "00-460",
    city: "Warszawa",
  },
  {
    code: "00-461",
    city: "Warszawa",
  },
  {
    code: "00-462",
    city: "Warszawa",
  },
  {
    code: "00-463",
    city: "Warszawa",
  },
  {
    code: "00-464",
    city: "Warszawa",
  },
  {
    code: "00-465",
    city: "Warszawa",
  },
  {
    code: "00-466",
    city: "Warszawa",
  },
  {
    code: "00-467",
    city: "Warszawa",
  },
  {
    code: "00-468",
    city: "Warszawa",
  },
  {
    code: "00-477",
    city: "Warszawa",
  },
  {
    code: "00-478",
    city: "Warszawa",
  },
  {
    code: "00-479",
    city: "Warszawa",
  },
  {
    code: "00-480",
    city: "Warszawa",
  },
  {
    code: "00-481",
    city: "Warszawa",
  },
  {
    code: "00-482",
    city: "Warszawa",
  },
  {
    code: "00-483",
    city: "Warszawa",
  },
  {
    code: "00-484",
    city: "Warszawa",
  },
  {
    code: "00-485",
    city: "Warszawa",
  },
  {
    code: "00-486",
    city: "Warszawa",
  },
  {
    code: "00-487",
    city: "Warszawa",
  },
  {
    code: "00-488",
    city: "Warszawa",
  },
  {
    code: "00-489",
    city: "Warszawa",
  },
  {
    code: "00-490",
    city: "Warszawa",
  },
  {
    code: "00-491",
    city: "Warszawa",
  },
  {
    code: "00-492",
    city: "Warszawa",
  },
  {
    code: "00-493",
    city: "Warszawa",
  },
  {
    code: "00-495",
    city: "Warszawa",
  },
  {
    code: "00-496",
    city: "Warszawa",
  },
  {
    code: "00-497",
    city: "Warszawa",
  },
  {
    code: "00-498",
    city: "Warszawa",
  },
  {
    code: "00-499",
    city: "Warszawa",
  },
  {
    code: "00-501",
    city: "Warszawa",
  },
  {
    code: "00-502",
    city: "Warszawa",
  },
  {
    code: "00-503",
    city: "Warszawa",
  },
  {
    code: "00-504",
    city: "Warszawa",
  },
  {
    code: "00-505",
    city: "Warszawa",
  },
  {
    code: "00-507",
    city: "Warszawa",
  },
  {
    code: "00-508",
    city: "Warszawa",
  },
  {
    code: "00-509",
    city: "Warszawa",
  },
  {
    code: "00-510",
    city: "Warszawa",
  },
  {
    code: "00-511",
    city: "Warszawa",
  },
  {
    code: "00-512",
    city: "Warszawa",
  },
  {
    code: "00-513",
    city: "Warszawa",
  },
  {
    code: "00-514",
    city: "Warszawa",
  },
  {
    code: "00-515",
    city: "Warszawa",
  },
  {
    code: "00-516",
    city: "Warszawa",
  },
  {
    code: "00-517",
    city: "Warszawa",
  },
  {
    code: "00-518",
    city: "Warszawa",
  },
  {
    code: "00-519",
    city: "Warszawa",
  },
  {
    code: "00-521",
    city: "Warszawa",
  },
  {
    code: "00-522",
    city: "Warszawa",
  },
  {
    code: "00-524",
    city: "Warszawa",
  },
  {
    code: "00-525",
    city: "Warszawa",
  },
  {
    code: "00-526",
    city: "Warszawa",
  },
  {
    code: "00-527",
    city: "Warszawa",
  },
  {
    code: "00-528",
    city: "Warszawa",
  },
  {
    code: "00-529",
    city: "Warszawa",
  },
  {
    code: "00-530",
    city: "Warszawa",
  },
  {
    code: "00-532",
    city: "Warszawa",
  },
  {
    code: "00-533",
    city: "Warszawa",
  },
  {
    code: "00-534",
    city: "Warszawa",
  },
  {
    code: "00-535",
    city: "Warszawa",
  },
  {
    code: "00-536",
    city: "Warszawa",
  },
  {
    code: "00-537",
    city: "Warszawa",
  },
  {
    code: "00-538",
    city: "Warszawa",
  },
  {
    code: "00-539",
    city: "Warszawa",
  },
  {
    code: "00-540",
    city: "Warszawa",
  },
  {
    code: "00-541",
    city: "Warszawa",
  },
  {
    code: "00-542",
    city: "Warszawa",
  },
  {
    code: "00-543",
    city: "Warszawa",
  },
  {
    code: "00-544",
    city: "Warszawa",
  },
  {
    code: "00-545",
    city: "Warszawa",
  },
  {
    code: "00-546",
    city: "Warszawa",
  },
  {
    code: "00-547",
    city: "Warszawa",
  },
  {
    code: "00-548",
    city: "Warszawa",
  },
  {
    code: "00-549",
    city: "Warszawa",
  },
  {
    code: "00-550",
    city: "Warszawa",
  },
  {
    code: "00-551",
    city: "Warszawa",
  },
  {
    code: "00-552",
    city: "Warszawa",
  },
  {
    code: "00-553",
    city: "Warszawa",
  },
  {
    code: "00-554",
    city: "Warszawa",
  },
  {
    code: "00-555",
    city: "Warszawa",
  },
  {
    code: "00-556",
    city: "Warszawa",
  },
  {
    code: "00-557",
    city: "Warszawa",
  },
  {
    code: "00-558",
    city: "Warszawa",
  },
  {
    code: "00-559",
    city: "Warszawa",
  },
  {
    code: "00-560",
    city: "Warszawa",
  },
  {
    code: "00-561",
    city: "Warszawa",
  },
  {
    code: "00-562",
    city: "Warszawa",
  },
  {
    code: "00-563",
    city: "Warszawa",
  },
  {
    code: "00-564",
    city: "Warszawa",
  },
  {
    code: "00-565",
    city: "Warszawa",
  },
  {
    code: "00-566",
    city: "Warszawa",
  },
  {
    code: "00-567",
    city: "Warszawa",
  },
  {
    code: "00-568",
    city: "Warszawa",
  },
  {
    code: "00-569",
    city: "Warszawa",
  },
  {
    code: "00-570",
    city: "Warszawa",
  },
  {
    code: "00-571",
    city: "Warszawa",
  },
  {
    code: "00-572",
    city: "Warszawa",
  },
  {
    code: "00-573",
    city: "Warszawa",
  },
  {
    code: "00-574",
    city: "Warszawa",
  },
  {
    code: "00-575",
    city: "Warszawa",
  },
  {
    code: "00-576",
    city: "Warszawa",
  },
  {
    code: "00-577",
    city: "Warszawa",
  },
  {
    code: "00-578",
    city: "Warszawa",
  },
  {
    code: "00-580",
    city: "Warszawa",
  },
  {
    code: "00-581",
    city: "Warszawa",
  },
  {
    code: "00-582",
    city: "Warszawa",
  },
  {
    code: "00-583",
    city: "Warszawa",
  },
  {
    code: "00-584",
    city: "Warszawa",
  },
  {
    code: "00-585",
    city: "Warszawa",
  },
  {
    code: "00-586",
    city: "Warszawa",
  },
  {
    code: "00-587",
    city: "Warszawa",
  },
  {
    code: "00-588",
    city: "Warszawa",
  },
  {
    code: "00-589",
    city: "Warszawa",
  },
  {
    code: "00-590",
    city: "Warszawa",
  },
  {
    code: "00-591",
    city: "Warszawa",
  },
  {
    code: "00-592",
    city: "Warszawa",
  },
  {
    code: "00-594",
    city: "Warszawa",
  },
  {
    code: "00-605",
    city: "Warszawa",
  },
  {
    code: "00-608",
    city: "Warszawa",
  },
  {
    code: "00-609",
    city: "Warszawa",
  },
  {
    code: "00-610",
    city: "Warszawa",
  },
  {
    code: "00-611",
    city: "Warszawa",
  },
  {
    code: "00-613",
    city: "Warszawa",
  },
  {
    code: "00-614",
    city: "Warszawa",
  },
  {
    code: "00-620",
    city: "Warszawa",
  },
  {
    code: "00-621",
    city: "Warszawa",
  },
  {
    code: "00-622",
    city: "Warszawa",
  },
  {
    code: "00-623",
    city: "Warszawa",
  },
  {
    code: "00-624",
    city: "Warszawa",
  },
  {
    code: "00-625",
    city: "Warszawa",
  },
  {
    code: "00-626",
    city: "Warszawa",
  },
  {
    code: "00-627",
    city: "Warszawa",
  },
  {
    code: "00-628",
    city: "Warszawa",
  },
  {
    code: "00-629",
    city: "Warszawa",
  },
  {
    code: "00-630",
    city: "Warszawa",
  },
  {
    code: "00-631",
    city: "Warszawa",
  },
  {
    code: "00-632",
    city: "Warszawa",
  },
  {
    code: "00-633",
    city: "Warszawa",
  },
  {
    code: "00-634",
    city: "Warszawa",
  },
  {
    code: "00-635",
    city: "Warszawa",
  },
  {
    code: "00-636",
    city: "Warszawa",
  },
  {
    code: "00-637",
    city: "Warszawa",
  },
  {
    code: "00-638",
    city: "Warszawa",
  },
  {
    code: "00-639",
    city: "Warszawa",
  },
  {
    code: "00-640",
    city: "Warszawa",
  },
  {
    code: "00-641",
    city: "Warszawa",
  },
  {
    code: "00-642",
    city: "Warszawa",
  },
  {
    code: "00-643",
    city: "Warszawa",
  },
  {
    code: "00-644",
    city: "Warszawa",
  },
  {
    code: "00-645",
    city: "Warszawa",
  },
  {
    code: "00-646",
    city: "Warszawa",
  },
  {
    code: "00-647",
    city: "Warszawa",
  },
  {
    code: "00-648",
    city: "Warszawa",
  },
  {
    code: "00-649",
    city: "Warszawa",
  },
  {
    code: "00-650",
    city: "Warszawa",
  },
  {
    code: "00-651",
    city: "Warszawa",
  },
  {
    code: "00-653",
    city: "Warszawa",
  },
  {
    code: "00-654",
    city: "Warszawa",
  },
  {
    code: "00-655",
    city: "Warszawa",
  },
  {
    code: "00-656",
    city: "Warszawa",
  },
  {
    code: "00-657",
    city: "Warszawa",
  },
  {
    code: "00-658",
    city: "Warszawa",
  },
  {
    code: "00-659",
    city: "Warszawa",
  },
  {
    code: "00-660",
    city: "Warszawa",
  },
  {
    code: "00-661",
    city: "Warszawa",
  },
  {
    code: "00-662",
    city: "Warszawa",
  },
  {
    code: "00-663",
    city: "Warszawa",
  },
  {
    code: "00-664",
    city: "Warszawa",
  },
  {
    code: "00-665",
    city: "Warszawa",
  },
  {
    code: "00-666",
    city: "Warszawa",
  },
  {
    code: "00-667",
    city: "Warszawa",
  },
  {
    code: "00-668",
    city: "Warszawa",
  },
  {
    code: "00-669",
    city: "Warszawa",
  },
  {
    code: "00-670",
    city: "Warszawa",
  },
  {
    code: "00-671",
    city: "Warszawa",
  },
  {
    code: "00-672",
    city: "Warszawa",
  },
  {
    code: "00-673",
    city: "Warszawa",
  },
  {
    code: "00-674",
    city: "Warszawa",
  },
  {
    code: "00-675",
    city: "Warszawa",
  },
  {
    code: "00-676",
    city: "Warszawa",
  },
  {
    code: "00-677",
    city: "Warszawa",
  },
  {
    code: "00-678",
    city: "Warszawa",
  },
  {
    code: "00-679",
    city: "Warszawa",
  },
  {
    code: "00-680",
    city: "Warszawa",
  },
  {
    code: "00-681",
    city: "Warszawa",
  },
  {
    code: "00-682",
    city: "Warszawa",
  },
  {
    code: "00-683",
    city: "Warszawa",
  },
  {
    code: "00-684",
    city: "Warszawa",
  },
  {
    code: "00-685",
    city: "Warszawa",
  },
  {
    code: "00-686",
    city: "Warszawa",
  },
  {
    code: "00-687",
    city: "Warszawa",
  },
  {
    code: "00-688",
    city: "Warszawa",
  },
  {
    code: "00-689",
    city: "Warszawa",
  },
  {
    code: "00-691",
    city: "Warszawa",
  },
  {
    code: "00-692",
    city: "Warszawa",
  },
  {
    code: "00-693",
    city: "Warszawa",
  },
  {
    code: "00-694",
    city: "Warszawa",
  },
  {
    code: "00-695",
    city: "Warszawa",
  },
  {
    code: "00-696",
    city: "Warszawa",
  },
  {
    code: "00-697",
    city: "Warszawa",
  },
  {
    code: "00-698",
    city: "Warszawa",
  },
  {
    code: "00-699",
    city: "Warszawa",
  },
  {
    code: "00-701",
    city: "Warszawa",
  },
  {
    code: "00-702",
    city: "Warszawa",
  },
  {
    code: "00-703",
    city: "Warszawa",
  },
  {
    code: "00-704",
    city: "Warszawa",
  },
  {
    code: "00-705",
    city: "Warszawa",
  },
  {
    code: "00-706",
    city: "Warszawa",
  },
  {
    code: "00-707",
    city: "Warszawa",
  },
  {
    code: "00-708",
    city: "Warszawa",
  },
  {
    code: "00-709",
    city: "Warszawa",
  },
  {
    code: "00-710",
    city: "Warszawa",
  },
  {
    code: "00-711",
    city: "Warszawa",
  },
  {
    code: "00-712",
    city: "Warszawa",
  },
  {
    code: "00-713",
    city: "Warszawa",
  },
  {
    code: "00-714",
    city: "Warszawa",
  },
  {
    code: "00-715",
    city: "Warszawa",
  },
  {
    code: "00-716",
    city: "Warszawa",
  },
  {
    code: "00-717",
    city: "Warszawa",
  },
  {
    code: "00-718",
    city: "Warszawa",
  },
  {
    code: "00-719",
    city: "Warszawa",
  },
  {
    code: "00-720",
    city: "Warszawa",
  },
  {
    code: "00-721",
    city: "Warszawa",
  },
  {
    code: "00-722",
    city: "Warszawa",
  },
  {
    code: "00-723",
    city: "Warszawa",
  },
  {
    code: "00-724",
    city: "Warszawa",
  },
  {
    code: "00-725",
    city: "Warszawa",
  },
  {
    code: "00-726",
    city: "Warszawa",
  },
  {
    code: "00-727",
    city: "Warszawa",
  },
  {
    code: "00-728",
    city: "Warszawa",
  },
  {
    code: "00-730",
    city: "Warszawa",
  },
  {
    code: "00-731",
    city: "Warszawa",
  },
  {
    code: "00-732",
    city: "Warszawa",
  },
  {
    code: "00-733",
    city: "Warszawa",
  },
  {
    code: "00-734",
    city: "Warszawa",
  },
  {
    code: "00-735",
    city: "Warszawa",
  },
  {
    code: "00-736",
    city: "Warszawa",
  },
  {
    code: "00-737",
    city: "Warszawa",
  },
  {
    code: "00-738",
    city: "Warszawa",
  },
  {
    code: "00-739",
    city: "Warszawa",
  },
  {
    code: "00-740",
    city: "Warszawa",
  },
  {
    code: "00-741",
    city: "Warszawa",
  },
  {
    code: "00-742",
    city: "Warszawa",
  },
  {
    code: "00-743",
    city: "Warszawa",
  },
  {
    code: "00-745",
    city: "Warszawa",
  },
  {
    code: "00-746",
    city: "Warszawa",
  },
  {
    code: "00-747",
    city: "Warszawa",
  },
  {
    code: "00-748",
    city: "Warszawa",
  },
  {
    code: "00-749",
    city: "Warszawa",
  },
  {
    code: "00-750",
    city: "Warszawa",
  },
  {
    code: "00-752",
    city: "Warszawa",
  },
  {
    code: "00-753",
    city: "Warszawa",
  },
  {
    code: "00-754",
    city: "Warszawa",
  },
  {
    code: "00-758",
    city: "Warszawa",
  },
  {
    code: "00-759",
    city: "Warszawa",
  },
  {
    code: "00-761",
    city: "Warszawa",
  },
  {
    code: "00-762",
    city: "Warszawa",
  },
  {
    code: "00-763",
    city: "Warszawa",
  },
  {
    code: "00-764",
    city: "Warszawa",
  },
  {
    code: "00-765",
    city: "Warszawa",
  },
  {
    code: "00-766",
    city: "Warszawa",
  },
  {
    code: "00-767",
    city: "Warszawa",
  },
  {
    code: "00-768",
    city: "Warszawa",
  },
  {
    code: "00-769",
    city: "Warszawa",
  },
  {
    code: "00-770",
    city: "Warszawa",
  },
  {
    code: "00-771",
    city: "Warszawa",
  },
  {
    code: "00-772",
    city: "Warszawa",
  },
  {
    code: "00-773",
    city: "Warszawa",
  },
  {
    code: "00-774",
    city: "Warszawa",
  },
  {
    code: "00-775",
    city: "Warszawa",
  },
  {
    code: "00-777",
    city: "Warszawa",
  },
  {
    code: "00-778",
    city: "Warszawa",
  },
  {
    code: "00-780",
    city: "Warszawa",
  },
  {
    code: "00-781",
    city: "Warszawa",
  },
  {
    code: "00-782",
    city: "Warszawa",
  },
  {
    code: "00-783",
    city: "Warszawa",
  },
  {
    code: "00-784",
    city: "Warszawa",
  },
  {
    code: "00-785",
    city: "Warszawa",
  },
  {
    code: "00-787",
    city: "Warszawa",
  },
  {
    code: "00-788",
    city: "Warszawa",
  },
  {
    code: "00-789",
    city: "Warszawa",
  },
  {
    code: "00-790",
    city: "Warszawa",
  },
  {
    code: "00-791",
    city: "Warszawa",
  },
  {
    code: "00-792",
    city: "Warszawa",
  },
  {
    code: "00-793",
    city: "Warszawa",
  },
  {
    code: "00-794",
    city: "Warszawa",
  },
  {
    code: "00-795",
    city: "Warszawa",
  },
  {
    code: "00-800",
    city: "Warszawa",
  },
  {
    code: "00-801",
    city: "Warszawa",
  },
  {
    code: "00-802",
    city: "Warszawa",
  },
  {
    code: "00-803",
    city: "Warszawa",
  },
  {
    code: "00-804",
    city: "Warszawa",
  },
  {
    code: "00-805",
    city: "Warszawa",
  },
  {
    code: "00-806",
    city: "Warszawa",
  },
  {
    code: "00-807",
    city: "Warszawa",
  },
  {
    code: "00-808",
    city: "Warszawa",
  },
  {
    code: "00-809",
    city: "Warszawa",
  },
  {
    code: "00-810",
    city: "Warszawa",
  },
  {
    code: "00-811",
    city: "Warszawa",
  },
  {
    code: "00-812",
    city: "Warszawa",
  },
  {
    code: "00-813",
    city: "Warszawa",
  },
  {
    code: "00-814",
    city: "Warszawa",
  },
  {
    code: "00-815",
    city: "Warszawa",
  },
  {
    code: "00-816",
    city: "Warszawa",
  },
  {
    code: "00-817",
    city: "Warszawa",
  },
  {
    code: "00-818",
    city: "Warszawa",
  },
  {
    code: "00-819",
    city: "Warszawa",
  },
  {
    code: "00-820",
    city: "Warszawa",
  },
  {
    code: "00-821",
    city: "Warszawa",
  },
  {
    code: "00-822",
    city: "Warszawa",
  },
  {
    code: "00-823",
    city: "Warszawa",
  },
  {
    code: "00-824",
    city: "Warszawa",
  },
  {
    code: "00-825",
    city: "Warszawa",
  },
  {
    code: "00-826",
    city: "Warszawa",
  },
  {
    code: "00-827",
    city: "Warszawa",
  },
  {
    code: "00-828",
    city: "Warszawa",
  },
  {
    code: "00-830",
    city: "Warszawa",
  },
  {
    code: "00-831",
    city: "Warszawa",
  },
  {
    code: "00-832",
    city: "Warszawa",
  },
  {
    code: "00-833",
    city: "Warszawa",
  },
  {
    code: "00-834",
    city: "Warszawa",
  },
  {
    code: "00-835",
    city: "Warszawa",
  },
  {
    code: "00-836",
    city: "Warszawa",
  },
  {
    code: "00-837",
    city: "Warszawa",
  },
  {
    code: "00-838",
    city: "Warszawa",
  },
  {
    code: "00-839",
    city: "Warszawa",
  },
  {
    code: "00-840",
    city: "Warszawa",
  },
  {
    code: "00-841",
    city: "Warszawa",
  },
  {
    code: "00-842",
    city: "Warszawa",
  },
  {
    code: "00-844",
    city: "Warszawa",
  },
  {
    code: "00-845",
    city: "Warszawa",
  },
  {
    code: "00-846",
    city: "Warszawa",
  },
  {
    code: "00-847",
    city: "Warszawa",
  },
  {
    code: "00-848",
    city: "Warszawa",
  },
  {
    code: "00-849",
    city: "Warszawa",
  },
  {
    code: "00-850",
    city: "Warszawa",
  },
  {
    code: "00-851",
    city: "Warszawa",
  },
  {
    code: "00-852",
    city: "Warszawa",
  },
  {
    code: "00-853",
    city: "Warszawa",
  },
  {
    code: "00-854",
    city: "Warszawa",
  },
  {
    code: "00-855",
    city: "Warszawa",
  },
  {
    code: "00-862",
    city: "Warszawa",
  },
  {
    code: "00-863",
    city: "Warszawa",
  },
  {
    code: "00-864",
    city: "Warszawa",
  },
  {
    code: "00-865",
    city: "Warszawa",
  },
  {
    code: "00-866",
    city: "Warszawa",
  },
  {
    code: "00-867",
    city: "Warszawa",
  },
  {
    code: "00-868",
    city: "Warszawa",
  },
  {
    code: "00-869",
    city: "Warszawa",
  },
  {
    code: "00-870",
    city: "Warszawa",
  },
  {
    code: "00-871",
    city: "Warszawa",
  },
  {
    code: "00-872",
    city: "Warszawa",
  },
  {
    code: "00-873",
    city: "Warszawa",
  },
  {
    code: "00-874",
    city: "Warszawa",
  },
  {
    code: "00-875",
    city: "Warszawa",
  },
  {
    code: "00-876",
    city: "Warszawa",
  },
  {
    code: "00-877",
    city: "Warszawa",
  },
  {
    code: "00-878",
    city: "Warszawa",
  },
  {
    code: "00-879",
    city: "Warszawa",
  },
  {
    code: "00-888",
    city: "Warszawa",
  },
  {
    code: "00-890",
    city: "Warszawa",
  },
  {
    code: "00-891",
    city: "Warszawa",
  },
  {
    code: "00-892",
    city: "Warszawa",
  },
  {
    code: "00-893",
    city: "Warszawa",
  },
  {
    code: "00-894",
    city: "Warszawa",
  },
  {
    code: "00-895",
    city: "Warszawa",
  },
  {
    code: "00-896",
    city: "Warszawa",
  },
  {
    code: "00-897",
    city: "Warszawa",
  },
  {
    code: "00-898",
    city: "Warszawa",
  },
  {
    code: "00-899",
    city: "Warszawa",
  },
  {
    code: "00-900",
    city: "Warszawa",
  },
  {
    code: "00-901",
    city: "Warszawa",
  },
  {
    code: "00-902",
    city: "Warszawa",
  },
  {
    code: "00-904",
    city: "Warszawa",
  },
  {
    code: "00-905",
    city: "Warszawa",
  },
  {
    code: "00-906",
    city: "Warszawa",
  },
  {
    code: "00-908",
    city: "Warszawa",
  },
  {
    code: "00-909",
    city: "Warszawa",
  },
  {
    code: "00-910",
    city: "Warszawa",
  },
  {
    code: "00-911",
    city: "Warszawa",
  },
  {
    code: "00-912",
    city: "Warszawa",
  },
  {
    code: "00-914",
    city: "Warszawa",
  },
  {
    code: "00-915",
    city: "Warszawa",
  },
  {
    code: "00-916",
    city: "Warszawa",
  },
  {
    code: "00-918",
    city: "Warszawa",
  },
  {
    code: "00-919",
    city: "Warszawa",
  },
  {
    code: "00-920",
    city: "Warszawa",
  },
  {
    code: "00-921",
    city: "Warszawa",
  },
  {
    code: "00-922",
    city: "Warszawa",
  },
  {
    code: "00-923",
    city: "Warszawa",
  },
  {
    code: "00-924",
    city: "Warszawa",
  },
  {
    code: "00-925",
    city: "Warszawa",
  },
  {
    code: "00-926",
    city: "Warszawa",
  },
  {
    code: "00-927",
    city: "Warszawa",
  },
  {
    code: "00-928",
    city: "Warszawa",
  },
  {
    code: "00-929",
    city: "Warszawa",
  },
  {
    code: "00-930",
    city: "Warszawa",
  },
  {
    code: "00-931",
    city: "Warszawa",
  },
  {
    code: "00-932",
    city: "Warszawa",
  },
  {
    code: "00-933",
    city: "Warszawa",
  },
  {
    code: "00-934",
    city: "Warszawa",
  },
  {
    code: "00-937",
    city: "Warszawa",
  },
  {
    code: "00-939",
    city: "Warszawa",
  },
  {
    code: "00-940",
    city: "Warszawa",
  },
  {
    code: "00-941",
    city: "Warszawa",
  },
  {
    code: "00-942",
    city: "Warszawa",
  },
  {
    code: "00-943",
    city: "Warszawa",
  },
  {
    code: "00-944",
    city: "Warszawa",
  },
  {
    code: "00-945",
    city: "Warszawa",
  },
  {
    code: "00-950",
    city: "Warszawa",
  },
  {
    code: "00-951",
    city: "Warszawa",
  },
  {
    code: "00-952",
    city: "Warszawa",
  },
  {
    code: "00-953",
    city: "Warszawa",
  },
  {
    code: "00-954",
    city: "Warszawa",
  },
  {
    code: "00-955",
    city: "Warszawa",
  },
  {
    code: "00-956",
    city: "Warszawa",
  },
  {
    code: "00-957",
    city: "Warszawa",
  },
  {
    code: "00-958",
    city: "Warszawa",
  },
  {
    code: "00-959",
    city: "Warszawa",
  },
  {
    code: "00-960",
    city: "Warszawa",
  },
  {
    code: "00-961",
    city: "Warszawa",
  },
  {
    code: "00-962",
    city: "Warszawa",
  },
  {
    code: "00-963",
    city: "Warszawa",
  },
  {
    code: "00-964",
    city: "Warszawa",
  },
  {
    code: "00-965",
    city: "Warszawa",
  },
  {
    code: "00-967",
    city: "Warszawa",
  },
  {
    code: "00-968",
    city: "Warszawa",
  },
  {
    code: "00-970",
    city: "Warszawa",
  },
  {
    code: "00-971",
    city: "Warszawa",
  },
  {
    code: "00-972",
    city: "Warszawa",
  },
  {
    code: "00-973",
    city: "Warszawa",
  },
  {
    code: "00-974",
    city: "Warszawa",
  },
  {
    code: "00-975",
    city: "Warszawa",
  },
  {
    code: "00-976",
    city: "Warszawa",
  },
  {
    code: "00-977",
    city: "Warszawa",
  },
  {
    code: "00-978",
    city: "Warszawa",
  },
  {
    code: "00-979",
    city: "Warszawa",
  },
  {
    code: "00-980",
    city: "Warszawa",
  },
  {
    code: "00-981",
    city: "Warszawa",
  },
  {
    code: "00-982",
    city: "Warszawa",
  },
  {
    code: "00-983",
    city: "Warszawa",
  },
  {
    code: "00-984",
    city: "Warszawa",
  },
  {
    code: "00-986",
    city: "Warszawa",
  },
  {
    code: "00-987",
    city: "Warszawa",
  },
  {
    code: "00-988",
    city: "Warszawa",
  },
  {
    code: "00-989",
    city: "Warszawa",
  },
  {
    code: "00-991",
    city: "Warszawa",
  },
  {
    code: "00-992",
    city: "Warszawa",
  },
  {
    code: "00-993",
    city: "Warszawa",
  },
  {
    code: "00-996",
    city: "Warszawa",
  },
  {
    code: "00-997",
    city: "Warszawa",
  },
  {
    code: "00-998",
    city: "Warszawa",
  },
  {
    code: "00-999",
    city: "Warszawa",
  },
  {
    code: "01-001",
    city: "Warszawa",
  },
  {
    code: "01-002",
    city: "Warszawa",
  },
  {
    code: "01-003",
    city: "Warszawa",
  },
  {
    code: "01-004",
    city: "Warszawa",
  },
  {
    code: "01-005",
    city: "Warszawa",
  },
  {
    code: "01-006",
    city: "Warszawa",
  },
  {
    code: "01-007",
    city: "Warszawa",
  },
  {
    code: "01-008",
    city: "Warszawa",
  },
  {
    code: "01-009",
    city: "Warszawa",
  },
  {
    code: "01-010",
    city: "Warszawa",
  },
  {
    code: "01-011",
    city: "Warszawa",
  },
  {
    code: "01-012",
    city: "Warszawa",
  },
  {
    code: "01-013",
    city: "Warszawa",
  },
  {
    code: "01-014",
    city: "Warszawa",
  },
  {
    code: "01-015",
    city: "Warszawa",
  },
  {
    code: "01-016",
    city: "Warszawa",
  },
  {
    code: "01-017",
    city: "Warszawa",
  },
  {
    code: "01-018",
    city: "Warszawa",
  },
  {
    code: "01-019",
    city: "Warszawa",
  },
  {
    code: "01-020",
    city: "Warszawa",
  },
  {
    code: "01-021",
    city: "Warszawa",
  },
  {
    code: "01-022",
    city: "Warszawa",
  },
  {
    code: "01-023",
    city: "Warszawa",
  },
  {
    code: "01-024",
    city: "Warszawa",
  },
  {
    code: "01-025",
    city: "Warszawa",
  },
  {
    code: "01-026",
    city: "Warszawa",
  },
  {
    code: "01-027",
    city: "Warszawa",
  },
  {
    code: "01-029",
    city: "Warszawa",
  },
  {
    code: "01-030",
    city: "Warszawa",
  },
  {
    code: "01-031",
    city: "Warszawa",
  },
  {
    code: "01-032",
    city: "Warszawa",
  },
  {
    code: "01-033",
    city: "Warszawa",
  },
  {
    code: "01-034",
    city: "Warszawa",
  },
  {
    code: "01-036",
    city: "Warszawa",
  },
  {
    code: "01-037",
    city: "Warszawa",
  },
  {
    code: "01-038",
    city: "Warszawa",
  },
  {
    code: "01-039",
    city: "Warszawa",
  },
  {
    code: "01-040",
    city: "Warszawa",
  },
  {
    code: "01-041",
    city: "Warszawa",
  },
  {
    code: "01-042",
    city: "Warszawa",
  },
  {
    code: "01-043",
    city: "Warszawa",
  },
  {
    code: "01-044",
    city: "Warszawa",
  },
  {
    code: "01-045",
    city: "Warszawa",
  },
  {
    code: "01-046",
    city: "Warszawa",
  },
  {
    code: "01-047",
    city: "Warszawa",
  },
  {
    code: "01-048",
    city: "Warszawa",
  },
  {
    code: "01-049",
    city: "Warszawa",
  },
  {
    code: "01-050",
    city: "Warszawa",
  },
  {
    code: "01-051",
    city: "Warszawa",
  },
  {
    code: "01-052",
    city: "Warszawa",
  },
  {
    code: "01-053",
    city: "Warszawa",
  },
  {
    code: "01-054",
    city: "Warszawa",
  },
  {
    code: "01-056",
    city: "Warszawa",
  },
  {
    code: "01-057",
    city: "Warszawa",
  },
  {
    code: "01-058",
    city: "Warszawa",
  },
  {
    code: "01-059",
    city: "Warszawa",
  },
  {
    code: "01-060",
    city: "Warszawa",
  },
  {
    code: "01-061",
    city: "Warszawa",
  },
  {
    code: "01-063",
    city: "Warszawa",
  },
  {
    code: "01-064",
    city: "Warszawa",
  },
  {
    code: "01-065",
    city: "Warszawa",
  },
  {
    code: "01-066",
    city: "Warszawa",
  },
  {
    code: "01-067",
    city: "Warszawa",
  },
  {
    code: "01-068",
    city: "Warszawa",
  },
  {
    code: "01-100",
    city: "Warszawa",
  },
  {
    code: "01-101",
    city: "Warszawa",
  },
  {
    code: "01-102",
    city: "Warszawa",
  },
  {
    code: "01-103",
    city: "Warszawa",
  },
  {
    code: "01-104",
    city: "Warszawa",
  },
  {
    code: "01-105",
    city: "Warszawa",
  },
  {
    code: "01-106",
    city: "Warszawa",
  },
  {
    code: "01-107",
    city: "Warszawa",
  },
  {
    code: "01-108",
    city: "Warszawa",
  },
  {
    code: "01-109",
    city: "Warszawa",
  },
  {
    code: "01-110",
    city: "Warszawa",
  },
  {
    code: "01-111",
    city: "Warszawa",
  },
  {
    code: "01-112",
    city: "Warszawa",
  },
  {
    code: "01-113",
    city: "Warszawa",
  },
  {
    code: "01-114",
    city: "Warszawa",
  },
  {
    code: "01-115",
    city: "Warszawa",
  },
  {
    code: "01-116",
    city: "Warszawa",
  },
  {
    code: "01-117",
    city: "Warszawa",
  },
  {
    code: "01-118",
    city: "Warszawa",
  },
  {
    code: "01-119",
    city: "Warszawa",
  },
  {
    code: "01-120",
    city: "Warszawa",
  },
  {
    code: "01-121",
    city: "Warszawa",
  },
  {
    code: "01-122",
    city: "Warszawa",
  },
  {
    code: "01-123",
    city: "Warszawa",
  },
  {
    code: "01-124",
    city: "Warszawa",
  },
  {
    code: "01-125",
    city: "Warszawa",
  },
  {
    code: "01-126",
    city: "Warszawa",
  },
  {
    code: "01-127",
    city: "Warszawa",
  },
  {
    code: "01-128",
    city: "Warszawa",
  },
  {
    code: "01-129",
    city: "Warszawa",
  },
  {
    code: "01-130",
    city: "Warszawa",
  },
  {
    code: "01-131",
    city: "Warszawa",
  },
  {
    code: "01-132",
    city: "Warszawa",
  },
  {
    code: "01-133",
    city: "Warszawa",
  },
  {
    code: "01-134",
    city: "Warszawa",
  },
  {
    code: "01-135",
    city: "Warszawa",
  },
  {
    code: "01-136",
    city: "Warszawa",
  },
  {
    code: "01-137",
    city: "Warszawa",
  },
  {
    code: "01-138",
    city: "Warszawa",
  },
  {
    code: "01-139",
    city: "Warszawa",
  },
  {
    code: "01-140",
    city: "Warszawa",
  },
  {
    code: "01-141",
    city: "Warszawa",
  },
  {
    code: "01-142",
    city: "Warszawa",
  },
  {
    code: "01-143",
    city: "Warszawa",
  },
  {
    code: "01-144",
    city: "Warszawa",
  },
  {
    code: "01-145",
    city: "Warszawa",
  },
  {
    code: "01-146",
    city: "Warszawa",
  },
  {
    code: "01-147",
    city: "Warszawa",
  },
  {
    code: "01-148",
    city: "Warszawa",
  },
  {
    code: "01-149",
    city: "Warszawa",
  },
  {
    code: "01-150",
    city: "Warszawa",
  },
  {
    code: "01-151",
    city: "Warszawa",
  },
  {
    code: "01-152",
    city: "Warszawa",
  },
  {
    code: "01-153",
    city: "Warszawa",
  },
  {
    code: "01-154",
    city: "Warszawa",
  },
  {
    code: "01-155",
    city: "Warszawa",
  },
  {
    code: "01-156",
    city: "Warszawa",
  },
  {
    code: "01-157",
    city: "Warszawa",
  },
  {
    code: "01-158",
    city: "Warszawa",
  },
  {
    code: "01-159",
    city: "Warszawa",
  },
  {
    code: "01-160",
    city: "Warszawa",
  },
  {
    code: "01-161",
    city: "Warszawa",
  },
  {
    code: "01-162",
    city: "Warszawa",
  },
  {
    code: "01-163",
    city: "Warszawa",
  },
  {
    code: "01-164",
    city: "Warszawa",
  },
  {
    code: "01-165",
    city: "Warszawa",
  },
  {
    code: "01-166",
    city: "Warszawa",
  },
  {
    code: "01-167",
    city: "Warszawa",
  },
  {
    code: "01-168",
    city: "Warszawa",
  },
  {
    code: "01-169",
    city: "Warszawa",
  },
  {
    code: "01-170",
    city: "Warszawa",
  },
  {
    code: "01-171",
    city: "Warszawa",
  },
  {
    code: "01-172",
    city: "Warszawa",
  },
  {
    code: "01-173",
    city: "Warszawa",
  },
  {
    code: "01-174",
    city: "Warszawa",
  },
  {
    code: "01-175",
    city: "Warszawa",
  },
  {
    code: "01-176",
    city: "Warszawa",
  },
  {
    code: "01-177",
    city: "Warszawa",
  },
  {
    code: "01-178",
    city: "Warszawa",
  },
  {
    code: "01-179",
    city: "Warszawa",
  },
  {
    code: "01-180",
    city: "Warszawa",
  },
  {
    code: "01-181",
    city: "Warszawa",
  },
  {
    code: "01-182",
    city: "Warszawa",
  },
  {
    code: "01-183",
    city: "Warszawa",
  },
  {
    code: "01-184",
    city: "Warszawa",
  },
  {
    code: "01-186",
    city: "Warszawa",
  },
  {
    code: "01-187",
    city: "Warszawa",
  },
  {
    code: "01-188",
    city: "Warszawa",
  },
  {
    code: "01-189",
    city: "Warszawa",
  },
  {
    code: "01-190",
    city: "Warszawa",
  },
  {
    code: "01-191",
    city: "Warszawa",
  },
  {
    code: "01-192",
    city: "Warszawa",
  },
  {
    code: "01-193",
    city: "Warszawa",
  },
  {
    code: "01-194",
    city: "Warszawa",
  },
  {
    code: "01-195",
    city: "Warszawa",
  },
  {
    code: "01-196",
    city: "Warszawa",
  },
  {
    code: "01-197",
    city: "Warszawa",
  },
  {
    code: "01-198",
    city: "Warszawa",
  },
  {
    code: "01-199",
    city: "Warszawa",
  },
  {
    code: "01-201",
    city: "Warszawa",
  },
  {
    code: "01-202",
    city: "Warszawa",
  },
  {
    code: "01-203",
    city: "Warszawa",
  },
  {
    code: "01-204",
    city: "Warszawa",
  },
  {
    code: "01-205",
    city: "Warszawa",
  },
  {
    code: "01-206",
    city: "Warszawa",
  },
  {
    code: "01-207",
    city: "Warszawa",
  },
  {
    code: "01-208",
    city: "Warszawa",
  },
  {
    code: "01-209",
    city: "Warszawa",
  },
  {
    code: "01-210",
    city: "Warszawa",
  },
  {
    code: "01-211",
    city: "Warszawa",
  },
  {
    code: "01-212",
    city: "Warszawa",
  },
  {
    code: "01-213",
    city: "Warszawa",
  },
  {
    code: "01-214",
    city: "Warszawa",
  },
  {
    code: "01-216",
    city: "Warszawa",
  },
  {
    code: "01-217",
    city: "Warszawa",
  },
  {
    code: "01-218",
    city: "Warszawa",
  },
  {
    code: "01-219",
    city: "Warszawa",
  },
  {
    code: "01-220",
    city: "Warszawa",
  },
  {
    code: "01-221",
    city: "Warszawa",
  },
  {
    code: "01-222",
    city: "Warszawa",
  },
  {
    code: "01-223",
    city: "Warszawa",
  },
  {
    code: "01-224",
    city: "Warszawa",
  },
  {
    code: "01-225",
    city: "Warszawa",
  },
  {
    code: "01-226",
    city: "Warszawa",
  },
  {
    code: "01-227",
    city: "Warszawa",
  },
  {
    code: "01-228",
    city: "Warszawa",
  },
  {
    code: "01-229",
    city: "Warszawa",
  },
  {
    code: "01-230",
    city: "Warszawa",
  },
  {
    code: "01-231",
    city: "Warszawa",
  },
  {
    code: "01-232",
    city: "Warszawa",
  },
  {
    code: "01-233",
    city: "Warszawa",
  },
  {
    code: "01-234",
    city: "Warszawa",
  },
  {
    code: "01-235",
    city: "Warszawa",
  },
  {
    code: "01-236",
    city: "Warszawa",
  },
  {
    code: "01-237",
    city: "Warszawa",
  },
  {
    code: "01-238",
    city: "Warszawa",
  },
  {
    code: "01-239",
    city: "Warszawa",
  },
  {
    code: "01-240",
    city: "Warszawa",
  },
  {
    code: "01-241",
    city: "Warszawa",
  },
  {
    code: "01-242",
    city: "Warszawa",
  },
  {
    code: "01-243",
    city: "Warszawa",
  },
  {
    code: "01-244",
    city: "Warszawa",
  },
  {
    code: "01-245",
    city: "Warszawa",
  },
  {
    code: "01-246",
    city: "Warszawa",
  },
  {
    code: "01-247",
    city: "Warszawa",
  },
  {
    code: "01-248",
    city: "Warszawa",
  },
  {
    code: "01-249",
    city: "Warszawa",
  },
  {
    code: "01-250",
    city: "Warszawa",
  },
  {
    code: "01-251",
    city: "Warszawa",
  },
  {
    code: "01-252",
    city: "Warszawa",
  },
  {
    code: "01-253",
    city: "Warszawa",
  },
  {
    code: "01-254",
    city: "Warszawa",
  },
  {
    code: "01-255",
    city: "Warszawa",
  },
  {
    code: "01-258",
    city: "Warszawa",
  },
  {
    code: "01-259",
    city: "Warszawa",
  },
  {
    code: "01-261",
    city: "Warszawa",
  },
  {
    code: "01-262",
    city: "Warszawa",
  },
  {
    code: "01-263",
    city: "Warszawa",
  },
  {
    code: "01-264",
    city: "Warszawa",
  },
  {
    code: "01-265",
    city: "Warszawa",
  },
  {
    code: "01-266",
    city: "Warszawa",
  },
  {
    code: "01-267",
    city: "Warszawa",
  },
  {
    code: "01-301",
    city: "Warszawa",
  },
  {
    code: "01-302",
    city: "Warszawa",
  },
  {
    code: "01-303",
    city: "Warszawa",
  },
  {
    code: "01-304",
    city: "Warszawa",
  },
  {
    code: "01-305",
    city: "Warszawa",
  },
  {
    code: "01-306",
    city: "Warszawa",
  },
  {
    code: "01-307",
    city: "Warszawa",
  },
  {
    code: "01-308",
    city: "Warszawa",
  },
  {
    code: "01-309",
    city: "Warszawa",
  },
  {
    code: "01-310",
    city: "Warszawa",
  },
  {
    code: "01-312",
    city: "Warszawa",
  },
  {
    code: "01-313",
    city: "Warszawa",
  },
  {
    code: "01-314",
    city: "Warszawa",
  },
  {
    code: "01-315",
    city: "Warszawa",
  },
  {
    code: "01-317",
    city: "Warszawa",
  },
  {
    code: "01-318",
    city: "Warszawa",
  },
  {
    code: "01-319",
    city: "Warszawa",
  },
  {
    code: "01-320",
    city: "Warszawa",
  },
  {
    code: "01-321",
    city: "Warszawa",
  },
  {
    code: "01-323",
    city: "Warszawa",
  },
  {
    code: "01-327",
    city: "Warszawa",
  },
  {
    code: "01-328",
    city: "Warszawa",
  },
  {
    code: "01-329",
    city: "Warszawa",
  },
  {
    code: "01-330",
    city: "Warszawa",
  },
  {
    code: "01-336",
    city: "Warszawa",
  },
  {
    code: "01-337",
    city: "Warszawa",
  },
  {
    code: "01-338",
    city: "Warszawa",
  },
  {
    code: "01-339",
    city: "Warszawa",
  },
  {
    code: "01-340",
    city: "Warszawa",
  },
  {
    code: "01-341",
    city: "Warszawa",
  },
  {
    code: "01-342",
    city: "Warszawa",
  },
  {
    code: "01-343",
    city: "Warszawa",
  },
  {
    code: "01-345",
    city: "Warszawa",
  },
  {
    code: "01-346",
    city: "Warszawa",
  },
  {
    code: "01-347",
    city: "Warszawa",
  },
  {
    code: "01-348",
    city: "Warszawa",
  },
  {
    code: "01-349",
    city: "Warszawa",
  },
  {
    code: "01-350",
    city: "Warszawa",
  },
  {
    code: "01-351",
    city: "Warszawa",
  },
  {
    code: "01-352",
    city: "Warszawa",
  },
  {
    code: "01-353",
    city: "Warszawa",
  },
  {
    code: "01-354",
    city: "Warszawa",
  },
  {
    code: "01-355",
    city: "Warszawa",
  },
  {
    code: "01-356",
    city: "Warszawa",
  },
  {
    code: "01-357",
    city: "Warszawa",
  },
  {
    code: "01-358",
    city: "Warszawa",
  },
  {
    code: "01-359",
    city: "Warszawa",
  },
  {
    code: "01-360",
    city: "Warszawa",
  },
  {
    code: "01-361",
    city: "Warszawa",
  },
  {
    code: "01-362",
    city: "Warszawa",
  },
  {
    code: "01-364",
    city: "Warszawa",
  },
  {
    code: "01-365",
    city: "Warszawa",
  },
  {
    code: "01-366",
    city: "Warszawa",
  },
  {
    code: "01-367",
    city: "Warszawa",
  },
  {
    code: "01-368",
    city: "Warszawa",
  },
  {
    code: "01-373",
    city: "Warszawa",
  },
  {
    code: "01-374",
    city: "Warszawa",
  },
  {
    code: "01-376",
    city: "Warszawa",
  },
  {
    code: "01-377",
    city: "Warszawa",
  },
  {
    code: "01-378",
    city: "Warszawa",
  },
  {
    code: "01-380",
    city: "Warszawa",
  },
  {
    code: "01-381",
    city: "Warszawa",
  },
  {
    code: "01-382",
    city: "Warszawa",
  },
  {
    code: "01-383",
    city: "Warszawa",
  },
  {
    code: "01-384",
    city: "Warszawa",
  },
  {
    code: "01-385",
    city: "Warszawa",
  },
  {
    code: "01-386",
    city: "Warszawa",
  },
  {
    code: "01-387",
    city: "Warszawa",
  },
  {
    code: "01-388",
    city: "Warszawa",
  },
  {
    code: "01-389",
    city: "Warszawa",
  },
  {
    code: "01-390",
    city: "Warszawa",
  },
  {
    code: "01-391",
    city: "Warszawa",
  },
  {
    code: "01-401",
    city: "Warszawa",
  },
  {
    code: "01-402",
    city: "Warszawa",
  },
  {
    code: "01-405",
    city: "Warszawa",
  },
  {
    code: "01-406",
    city: "Warszawa",
  },
  {
    code: "01-407",
    city: "Warszawa",
  },
  {
    code: "01-408",
    city: "Warszawa",
  },
  {
    code: "01-409",
    city: "Warszawa",
  },
  {
    code: "01-410",
    city: "Warszawa",
  },
  {
    code: "01-411",
    city: "Warszawa",
  },
  {
    code: "01-413",
    city: "Warszawa",
  },
  {
    code: "01-416",
    city: "Warszawa",
  },
  {
    code: "01-417",
    city: "Warszawa",
  },
  {
    code: "01-418",
    city: "Warszawa",
  },
  {
    code: "01-419",
    city: "Warszawa",
  },
  {
    code: "01-420",
    city: "Warszawa",
  },
  {
    code: "01-421",
    city: "Warszawa",
  },
  {
    code: "01-422",
    city: "Warszawa",
  },
  {
    code: "01-423",
    city: "Warszawa",
  },
  {
    code: "01-424",
    city: "Warszawa",
  },
  {
    code: "01-425",
    city: "Warszawa",
  },
  {
    code: "01-426",
    city: "Warszawa",
  },
  {
    code: "01-428",
    city: "Warszawa",
  },
  {
    code: "01-429",
    city: "Warszawa",
  },
  {
    code: "01-431",
    city: "Warszawa",
  },
  {
    code: "01-432",
    city: "Warszawa",
  },
  {
    code: "01-433",
    city: "Warszawa",
  },
  {
    code: "01-434",
    city: "Warszawa",
  },
  {
    code: "01-436",
    city: "Warszawa",
  },
  {
    code: "01-437",
    city: "Warszawa",
  },
  {
    code: "01-438",
    city: "Warszawa",
  },
  {
    code: "01-439",
    city: "Warszawa",
  },
  {
    code: "01-441",
    city: "Warszawa",
  },
  {
    code: "01-442",
    city: "Warszawa",
  },
  {
    code: "01-443",
    city: "Warszawa",
  },
  {
    code: "01-444",
    city: "Warszawa",
  },
  {
    code: "01-445",
    city: "Warszawa",
  },
  {
    code: "01-446",
    city: "Warszawa",
  },
  {
    code: "01-447",
    city: "Warszawa",
  },
  {
    code: "01-448",
    city: "Warszawa",
  },
  {
    code: "01-449",
    city: "Warszawa",
  },
  {
    code: "01-450",
    city: "Warszawa",
  },
  {
    code: "01-451",
    city: "Warszawa",
  },
  {
    code: "01-452",
    city: "Warszawa",
  },
  {
    code: "01-456",
    city: "Warszawa",
  },
  {
    code: "01-457",
    city: "Warszawa",
  },
  {
    code: "01-458",
    city: "Warszawa",
  },
  {
    code: "01-459",
    city: "Warszawa",
  },
  {
    code: "01-460",
    city: "Warszawa",
  },
  {
    code: "01-461",
    city: "Warszawa",
  },
  {
    code: "01-462",
    city: "Warszawa",
  },
  {
    code: "01-464",
    city: "Warszawa",
  },
  {
    code: "01-465",
    city: "Warszawa",
  },
  {
    code: "01-466",
    city: "Warszawa",
  },
  {
    code: "01-467",
    city: "Warszawa",
  },
  {
    code: "01-468",
    city: "Warszawa",
  },
  {
    code: "01-469",
    city: "Warszawa",
  },
  {
    code: "01-470",
    city: "Warszawa",
  },
  {
    code: "01-471",
    city: "Warszawa",
  },
  {
    code: "01-472",
    city: "Warszawa",
  },
  {
    code: "01-473",
    city: "Warszawa",
  },
  {
    code: "01-474",
    city: "Warszawa",
  },
  {
    code: "01-475",
    city: "Warszawa",
  },
  {
    code: "01-476",
    city: "Warszawa",
  },
  {
    code: "01-477",
    city: "Warszawa",
  },
  {
    code: "01-478",
    city: "Warszawa",
  },
  {
    code: "01-479",
    city: "Warszawa",
  },
  {
    code: "01-480",
    city: "Warszawa",
  },
  {
    code: "01-481",
    city: "Warszawa",
  },
  {
    code: "01-482",
    city: "Warszawa",
  },
  {
    code: "01-483",
    city: "Warszawa",
  },
  {
    code: "01-485",
    city: "Warszawa",
  },
  {
    code: "01-486",
    city: "Warszawa",
  },
  {
    code: "01-487",
    city: "Warszawa",
  },
  {
    code: "01-488",
    city: "Warszawa",
  },
  {
    code: "01-489",
    city: "Warszawa",
  },
  {
    code: "01-490",
    city: "Warszawa",
  },
  {
    code: "01-491",
    city: "Warszawa",
  },
  {
    code: "01-492",
    city: "Warszawa",
  },
  {
    code: "01-493",
    city: "Warszawa",
  },
  {
    code: "01-494",
    city: "Warszawa",
  },
  {
    code: "01-495",
    city: "Warszawa",
  },
  {
    code: "01-496",
    city: "Warszawa",
  },
  {
    code: "01-497",
    city: "Warszawa",
  },
  {
    code: "01-498",
    city: "Warszawa",
  },
  {
    code: "01-499",
    city: "Warszawa",
  },
  {
    code: "01-501",
    city: "Warszawa",
  },
  {
    code: "01-502",
    city: "Warszawa",
  },
  {
    code: "01-503",
    city: "Warszawa",
  },
  {
    code: "01-504",
    city: "Warszawa",
  },
  {
    code: "01-505",
    city: "Warszawa",
  },
  {
    code: "01-506",
    city: "Warszawa",
  },
  {
    code: "01-507",
    city: "Warszawa",
  },
  {
    code: "01-508",
    city: "Warszawa",
  },
  {
    code: "01-510",
    city: "Warszawa",
  },
  {
    code: "01-511",
    city: "Warszawa",
  },
  {
    code: "01-512",
    city: "Warszawa",
  },
  {
    code: "01-513",
    city: "Warszawa",
  },
  {
    code: "01-514",
    city: "Warszawa",
  },
  {
    code: "01-515",
    city: "Warszawa",
  },
  {
    code: "01-517",
    city: "Warszawa",
  },
  {
    code: "01-518",
    city: "Warszawa",
  },
  {
    code: "01-519",
    city: "Warszawa",
  },
  {
    code: "01-520",
    city: "Warszawa",
  },
  {
    code: "01-521",
    city: "Warszawa",
  },
  {
    code: "01-522",
    city: "Warszawa",
  },
  {
    code: "01-523",
    city: "Warszawa",
  },
  {
    code: "01-524",
    city: "Warszawa",
  },
  {
    code: "01-526",
    city: "Warszawa",
  },
  {
    code: "01-527",
    city: "Warszawa",
  },
  {
    code: "01-528",
    city: "Warszawa",
  },
  {
    code: "01-529",
    city: "Warszawa",
  },
  {
    code: "01-530",
    city: "Warszawa",
  },
  {
    code: "01-531",
    city: "Warszawa",
  },
  {
    code: "01-532",
    city: "Warszawa",
  },
  {
    code: "01-533",
    city: "Warszawa",
  },
  {
    code: "01-534",
    city: "Warszawa",
  },
  {
    code: "01-535",
    city: "Warszawa",
  },
  {
    code: "01-536",
    city: "Warszawa",
  },
  {
    code: "01-537",
    city: "Warszawa",
  },
  {
    code: "01-538",
    city: "Warszawa",
  },
  {
    code: "01-539",
    city: "Warszawa",
  },
  {
    code: "01-540",
    city: "Warszawa",
  },
  {
    code: "01-541",
    city: "Warszawa",
  },
  {
    code: "01-542",
    city: "Warszawa",
  },
  {
    code: "01-543",
    city: "Warszawa",
  },
  {
    code: "01-547",
    city: "Warszawa",
  },
  {
    code: "01-548",
    city: "Warszawa",
  },
  {
    code: "01-549",
    city: "Warszawa",
  },
  {
    code: "01-551",
    city: "Warszawa",
  },
  {
    code: "01-552",
    city: "Warszawa",
  },
  {
    code: "01-553",
    city: "Warszawa",
  },
  {
    code: "01-554",
    city: "Warszawa",
  },
  {
    code: "01-555",
    city: "Warszawa",
  },
  {
    code: "01-556",
    city: "Warszawa",
  },
  {
    code: "01-557",
    city: "Warszawa",
  },
  {
    code: "01-558",
    city: "Warszawa",
  },
  {
    code: "01-559",
    city: "Warszawa",
  },
  {
    code: "01-560",
    city: "Warszawa",
  },
  {
    code: "01-562",
    city: "Warszawa",
  },
  {
    code: "01-563",
    city: "Warszawa",
  },
  {
    code: "01-564",
    city: "Warszawa",
  },
  {
    code: "01-565",
    city: "Warszawa",
  },
  {
    code: "01-566",
    city: "Warszawa",
  },
  {
    code: "01-567",
    city: "Warszawa",
  },
  {
    code: "01-568",
    city: "Warszawa",
  },
  {
    code: "01-569",
    city: "Warszawa",
  },
  {
    code: "01-570",
    city: "Warszawa",
  },
  {
    code: "01-571",
    city: "Warszawa",
  },
  {
    code: "01-572",
    city: "Warszawa",
  },
  {
    code: "01-573",
    city: "Warszawa",
  },
  {
    code: "01-574",
    city: "Warszawa",
  },
  {
    code: "01-576",
    city: "Warszawa",
  },
  {
    code: "01-577",
    city: "Warszawa",
  },
  {
    code: "01-578",
    city: "Warszawa",
  },
  {
    code: "01-579",
    city: "Warszawa",
  },
  {
    code: "01-580",
    city: "Warszawa",
  },
  {
    code: "01-581",
    city: "Warszawa",
  },
  {
    code: "01-582",
    city: "Warszawa",
  },
  {
    code: "01-583",
    city: "Warszawa",
  },
  {
    code: "01-584",
    city: "Warszawa",
  },
  {
    code: "01-585",
    city: "Warszawa",
  },
  {
    code: "01-586",
    city: "Warszawa",
  },
  {
    code: "01-587",
    city: "Warszawa",
  },
  {
    code: "01-588",
    city: "Warszawa",
  },
  {
    code: "01-589",
    city: "Warszawa",
  },
  {
    code: "01-590",
    city: "Warszawa",
  },
  {
    code: "01-592",
    city: "Warszawa",
  },
  {
    code: "01-593",
    city: "Warszawa",
  },
  {
    code: "01-594",
    city: "Warszawa",
  },
  {
    code: "01-595",
    city: "Warszawa",
  },
  {
    code: "01-601",
    city: "Warszawa",
  },
  {
    code: "01-602",
    city: "Warszawa",
  },
  {
    code: "01-603",
    city: "Warszawa",
  },
  {
    code: "01-604",
    city: "Warszawa",
  },
  {
    code: "01-605",
    city: "Warszawa",
  },
  {
    code: "01-606",
    city: "Warszawa",
  },
  {
    code: "01-607",
    city: "Warszawa",
  },
  {
    code: "01-608",
    city: "Warszawa",
  },
  {
    code: "01-609",
    city: "Warszawa",
  },
  {
    code: "01-610",
    city: "Warszawa",
  },
  {
    code: "01-611",
    city: "Warszawa",
  },
  {
    code: "01-612",
    city: "Warszawa",
  },
  {
    code: "01-613",
    city: "Warszawa",
  },
  {
    code: "01-614",
    city: "Warszawa",
  },
  {
    code: "01-615",
    city: "Warszawa",
  },
  {
    code: "01-616",
    city: "Warszawa",
  },
  {
    code: "01-617",
    city: "Warszawa",
  },
  {
    code: "01-618",
    city: "Warszawa",
  },
  {
    code: "01-619",
    city: "Warszawa",
  },
  {
    code: "01-620",
    city: "Warszawa",
  },
  {
    code: "01-621",
    city: "Warszawa",
  },
  {
    code: "01-622",
    city: "Warszawa",
  },
  {
    code: "01-623",
    city: "Warszawa",
  },
  {
    code: "01-624",
    city: "Warszawa",
  },
  {
    code: "01-625",
    city: "Warszawa",
  },
  {
    code: "01-626",
    city: "Warszawa",
  },
  {
    code: "01-627",
    city: "Warszawa",
  },
  {
    code: "01-628",
    city: "Warszawa",
  },
  {
    code: "01-629",
    city: "Warszawa",
  },
  {
    code: "01-630",
    city: "Warszawa",
  },
  {
    code: "01-631",
    city: "Warszawa",
  },
  {
    code: "01-632",
    city: "Warszawa",
  },
  {
    code: "01-633",
    city: "Warszawa",
  },
  {
    code: "01-634",
    city: "Warszawa",
  },
  {
    code: "01-635",
    city: "Warszawa",
  },
  {
    code: "01-636",
    city: "Warszawa",
  },
  {
    code: "01-637",
    city: "Warszawa",
  },
  {
    code: "01-638",
    city: "Warszawa",
  },
  {
    code: "01-639",
    city: "Warszawa",
  },
  {
    code: "01-640",
    city: "Warszawa",
  },
  {
    code: "01-641",
    city: "Warszawa",
  },
  {
    code: "01-643",
    city: "Warszawa",
  },
  {
    code: "01-644",
    city: "Warszawa",
  },
  {
    code: "01-645",
    city: "Warszawa",
  },
  {
    code: "01-646",
    city: "Warszawa",
  },
  {
    code: "01-647",
    city: "Warszawa",
  },
  {
    code: "01-648",
    city: "Warszawa",
  },
  {
    code: "01-649",
    city: "Warszawa",
  },
  {
    code: "01-650",
    city: "Warszawa",
  },
  {
    code: "01-651",
    city: "Warszawa",
  },
  {
    code: "01-652",
    city: "Warszawa",
  },
  {
    code: "01-654",
    city: "Warszawa",
  },
  {
    code: "01-656",
    city: "Warszawa",
  },
  {
    code: "01-658",
    city: "Warszawa",
  },
  {
    code: "01-664",
    city: "Warszawa",
  },
  {
    code: "01-665",
    city: "Warszawa",
  },
  {
    code: "01-669",
    city: "Warszawa",
  },
  {
    code: "01-670",
    city: "Warszawa",
  },
  {
    code: "01-673",
    city: "Warszawa",
  },
  {
    code: "01-674",
    city: "Warszawa",
  },
  {
    code: "01-677",
    city: "Warszawa",
  },
  {
    code: "01-678",
    city: "Warszawa",
  },
  {
    code: "01-679",
    city: "Warszawa",
  },
  {
    code: "01-680",
    city: "Warszawa",
  },
  {
    code: "01-681",
    city: "Warszawa",
  },
  {
    code: "01-682",
    city: "Warszawa",
  },
  {
    code: "01-683",
    city: "Warszawa",
  },
  {
    code: "01-684",
    city: "Warszawa",
  },
  {
    code: "01-685",
    city: "Warszawa",
  },
  {
    code: "01-687",
    city: "Warszawa",
  },
  {
    code: "01-688",
    city: "Warszawa",
  },
  {
    code: "01-689",
    city: "Warszawa",
  },
  {
    code: "01-690",
    city: "Warszawa",
  },
  {
    code: "01-691",
    city: "Warszawa",
  },
  {
    code: "01-692",
    city: "Warszawa",
  },
  {
    code: "01-693",
    city: "Warszawa",
  },
  {
    code: "01-694",
    city: "Warszawa",
  },
  {
    code: "01-695",
    city: "Warszawa",
  },
  {
    code: "01-696",
    city: "Warszawa",
  },
  {
    code: "01-697",
    city: "Warszawa",
  },
  {
    code: "01-698",
    city: "Warszawa",
  },
  {
    code: "01-699",
    city: "Warszawa",
  },
  {
    code: "01-702",
    city: "Warszawa",
  },
  {
    code: "01-703",
    city: "Warszawa",
  },
  {
    code: "01-707",
    city: "Warszawa",
  },
  {
    code: "01-708",
    city: "Warszawa",
  },
  {
    code: "01-709",
    city: "Warszawa",
  },
  {
    code: "01-710",
    city: "Warszawa",
  },
  {
    code: "01-711",
    city: "Warszawa",
  },
  {
    code: "01-715",
    city: "Warszawa",
  },
  {
    code: "01-716",
    city: "Warszawa",
  },
  {
    code: "01-727",
    city: "Warszawa",
  },
  {
    code: "01-728",
    city: "Warszawa",
  },
  {
    code: "01-730",
    city: "Warszawa",
  },
  {
    code: "01-735",
    city: "Warszawa",
  },
  {
    code: "01-736",
    city: "Warszawa",
  },
  {
    code: "01-737",
    city: "Warszawa",
  },
  {
    code: "01-738",
    city: "Warszawa",
  },
  {
    code: "01-739",
    city: "Warszawa",
  },
  {
    code: "01-740",
    city: "Warszawa",
  },
  {
    code: "01-741",
    city: "Warszawa",
  },
  {
    code: "01-742",
    city: "Warszawa",
  },
  {
    code: "01-743",
    city: "Warszawa",
  },
  {
    code: "01-745",
    city: "Warszawa",
  },
  {
    code: "01-747",
    city: "Warszawa",
  },
  {
    code: "01-748",
    city: "Warszawa",
  },
  {
    code: "01-749",
    city: "Warszawa",
  },
  {
    code: "01-755",
    city: "Warszawa",
  },
  {
    code: "01-756",
    city: "Warszawa",
  },
  {
    code: "01-769",
    city: "Warszawa",
  },
  {
    code: "01-770",
    city: "Warszawa",
  },
  {
    code: "01-771",
    city: "Warszawa",
  },
  {
    code: "01-772",
    city: "Warszawa",
  },
  {
    code: "01-773",
    city: "Warszawa",
  },
  {
    code: "01-779",
    city: "Warszawa",
  },
  {
    code: "01-780",
    city: "Warszawa",
  },
  {
    code: "01-783",
    city: "Warszawa",
  },
  {
    code: "01-784",
    city: "Warszawa",
  },
  {
    code: "01-785",
    city: "Warszawa",
  },
  {
    code: "01-786",
    city: "Warszawa",
  },
  {
    code: "01-787",
    city: "Warszawa",
  },
  {
    code: "01-792",
    city: "Warszawa",
  },
  {
    code: "01-793",
    city: "Warszawa",
  },
  {
    code: "01-794",
    city: "Warszawa",
  },
  {
    code: "01-796",
    city: "Warszawa",
  },
  {
    code: "01-797",
    city: "Warszawa",
  },
  {
    code: "01-798",
    city: "Warszawa",
  },
  {
    code: "01-800",
    city: "Warszawa",
  },
  {
    code: "01-801",
    city: "Warszawa",
  },
  {
    code: "01-802",
    city: "Warszawa",
  },
  {
    code: "01-803",
    city: "Warszawa",
  },
  {
    code: "01-804",
    city: "Warszawa",
  },
  {
    code: "01-805",
    city: "Warszawa",
  },
  {
    code: "01-806",
    city: "Warszawa",
  },
  {
    code: "01-807",
    city: "Warszawa",
  },
  {
    code: "01-808",
    city: "Warszawa",
  },
  {
    code: "01-809",
    city: "Warszawa",
  },
  {
    code: "01-810",
    city: "Warszawa",
  },
  {
    code: "01-811",
    city: "Warszawa",
  },
  {
    code: "01-812",
    city: "Warszawa",
  },
  {
    code: "01-813",
    city: "Warszawa",
  },
  {
    code: "01-815",
    city: "Warszawa",
  },
  {
    code: "01-817",
    city: "Warszawa",
  },
  {
    code: "01-818",
    city: "Warszawa",
  },
  {
    code: "01-819",
    city: "Warszawa",
  },
  {
    code: "01-820",
    city: "Warszawa",
  },
  {
    code: "01-821",
    city: "Warszawa",
  },
  {
    code: "01-822",
    city: "Warszawa",
  },
  {
    code: "01-823",
    city: "Warszawa",
  },
  {
    code: "01-824",
    city: "Warszawa",
  },
  {
    code: "01-825",
    city: "Warszawa",
  },
  {
    code: "01-826",
    city: "Warszawa",
  },
  {
    code: "01-827",
    city: "Warszawa",
  },
  {
    code: "01-828",
    city: "Warszawa",
  },
  {
    code: "01-829",
    city: "Warszawa",
  },
  {
    code: "01-830",
    city: "Warszawa",
  },
  {
    code: "01-831",
    city: "Warszawa",
  },
  {
    code: "01-832",
    city: "Warszawa",
  },
  {
    code: "01-833",
    city: "Warszawa",
  },
  {
    code: "01-834",
    city: "Warszawa",
  },
  {
    code: "01-835",
    city: "Warszawa",
  },
  {
    code: "01-836",
    city: "Warszawa",
  },
  {
    code: "01-837",
    city: "Warszawa",
  },
  {
    code: "01-838",
    city: "Warszawa",
  },
  {
    code: "01-839",
    city: "Warszawa",
  },
  {
    code: "01-840",
    city: "Warszawa",
  },
  {
    code: "01-841",
    city: "Warszawa",
  },
  {
    code: "01-842",
    city: "Warszawa",
  },
  {
    code: "01-843",
    city: "Warszawa",
  },
  {
    code: "01-844",
    city: "Warszawa",
  },
  {
    code: "01-845",
    city: "Warszawa",
  },
  {
    code: "01-846",
    city: "Warszawa",
  },
  {
    code: "01-847",
    city: "Warszawa",
  },
  {
    code: "01-848",
    city: "Warszawa",
  },
  {
    code: "01-849",
    city: "Warszawa",
  },
  {
    code: "01-850",
    city: "Warszawa",
  },
  {
    code: "01-851",
    city: "Warszawa",
  },
  {
    code: "01-852",
    city: "Warszawa",
  },
  {
    code: "01-853",
    city: "Warszawa",
  },
  {
    code: "01-854",
    city: "Warszawa",
  },
  {
    code: "01-855",
    city: "Warszawa",
  },
  {
    code: "01-856",
    city: "Warszawa",
  },
  {
    code: "01-857",
    city: "Warszawa",
  },
  {
    code: "01-858",
    city: "Warszawa",
  },
  {
    code: "01-859",
    city: "Warszawa",
  },
  {
    code: "01-860",
    city: "Warszawa",
  },
  {
    code: "01-861",
    city: "Warszawa",
  },
  {
    code: "01-862",
    city: "Warszawa",
  },
  {
    code: "01-863",
    city: "Warszawa",
  },
  {
    code: "01-864",
    city: "Warszawa",
  },
  {
    code: "01-865",
    city: "Warszawa",
  },
  {
    code: "01-866",
    city: "Warszawa",
  },
  {
    code: "01-867",
    city: "Warszawa",
  },
  {
    code: "01-868",
    city: "Warszawa",
  },
  {
    code: "01-869",
    city: "Warszawa",
  },
  {
    code: "01-870",
    city: "Warszawa",
  },
  {
    code: "01-871",
    city: "Warszawa",
  },
  {
    code: "01-872",
    city: "Warszawa",
  },
  {
    code: "01-873",
    city: "Warszawa",
  },
  {
    code: "01-874",
    city: "Warszawa",
  },
  {
    code: "01-875",
    city: "Warszawa",
  },
  {
    code: "01-876",
    city: "Warszawa",
  },
  {
    code: "01-877",
    city: "Warszawa",
  },
  {
    code: "01-880",
    city: "Warszawa",
  },
  {
    code: "01-881",
    city: "Warszawa",
  },
  {
    code: "01-882",
    city: "Warszawa",
  },
  {
    code: "01-883",
    city: "Warszawa",
  },
  {
    code: "01-884",
    city: "Warszawa",
  },
  {
    code: "01-885",
    city: "Warszawa",
  },
  {
    code: "01-886",
    city: "Warszawa",
  },
  {
    code: "01-887",
    city: "Warszawa",
  },
  {
    code: "01-888",
    city: "Warszawa",
  },
  {
    code: "01-890",
    city: "Warszawa",
  },
  {
    code: "01-891",
    city: "Warszawa",
  },
  {
    code: "01-892",
    city: "Warszawa",
  },
  {
    code: "01-893",
    city: "Warszawa",
  },
  {
    code: "01-900",
    city: "Warszawa",
  },
  {
    code: "01-903",
    city: "Warszawa",
  },
  {
    code: "01-904",
    city: "Warszawa",
  },
  {
    code: "01-905",
    city: "Warszawa",
  },
  {
    code: "01-906",
    city: "Warszawa",
  },
  {
    code: "01-908",
    city: "Warszawa",
  },
  {
    code: "01-909",
    city: "Warszawa",
  },
  {
    code: "01-910",
    city: "Warszawa",
  },
  {
    code: "01-911",
    city: "Warszawa",
  },
  {
    code: "01-912",
    city: "Warszawa",
  },
  {
    code: "01-913",
    city: "Warszawa",
  },
  {
    code: "01-914",
    city: "Warszawa",
  },
  {
    code: "01-915",
    city: "Warszawa",
  },
  {
    code: "01-916",
    city: "Warszawa",
  },
  {
    code: "01-917",
    city: "Warszawa",
  },
  {
    code: "01-918",
    city: "Warszawa",
  },
  {
    code: "01-919",
    city: "Warszawa",
  },
  {
    code: "01-920",
    city: "Warszawa",
  },
  {
    code: "01-921",
    city: "Warszawa",
  },
  {
    code: "01-922",
    city: "Warszawa",
  },
  {
    code: "01-923",
    city: "Warszawa",
  },
  {
    code: "01-924",
    city: "Warszawa",
  },
  {
    code: "01-925",
    city: "Warszawa",
  },
  {
    code: "01-926",
    city: "Warszawa",
  },
  {
    code: "01-927",
    city: "Warszawa",
  },
  {
    code: "01-928",
    city: "Warszawa",
  },
  {
    code: "01-929",
    city: "Warszawa",
  },
  {
    code: "01-930",
    city: "Warszawa",
  },
  {
    code: "01-931",
    city: "Warszawa",
  },
  {
    code: "01-932",
    city: "Warszawa",
  },
  {
    code: "01-934",
    city: "Warszawa",
  },
  {
    code: "01-935",
    city: "Warszawa",
  },
  {
    code: "01-936",
    city: "Warszawa",
  },
  {
    code: "01-937",
    city: "Warszawa",
  },
  {
    code: "01-938",
    city: "Warszawa",
  },
  {
    code: "01-939",
    city: "Warszawa",
  },
  {
    code: "01-940",
    city: "Warszawa",
  },
  {
    code: "01-941",
    city: "Warszawa",
  },
  {
    code: "01-942",
    city: "Warszawa",
  },
  {
    code: "01-943",
    city: "Warszawa",
  },
  {
    code: "01-944",
    city: "Warszawa",
  },
  {
    code: "01-945",
    city: "Warszawa",
  },
  {
    code: "01-946",
    city: "Warszawa",
  },
  {
    code: "01-947",
    city: "Warszawa",
  },
  {
    code: "01-948",
    city: "Warszawa",
  },
  {
    code: "01-949",
    city: "Warszawa",
  },
  {
    code: "01-950",
    city: "Warszawa",
  },
  {
    code: "01-951",
    city: "Warszawa",
  },
  {
    code: "01-952",
    city: "Warszawa",
  },
  {
    code: "01-953",
    city: "Warszawa",
  },
  {
    code: "01-954",
    city: "Warszawa",
  },
  {
    code: "01-956",
    city: "Warszawa",
  },
  {
    code: "01-957",
    city: "Warszawa",
  },
  {
    code: "01-958",
    city: "Warszawa",
  },
  {
    code: "01-960",
    city: "Warszawa",
  },
  {
    code: "01-961",
    city: "Warszawa",
  },
  {
    code: "01-962",
    city: "Warszawa",
  },
  {
    code: "01-963",
    city: "Warszawa",
  },
  {
    code: "01-964",
    city: "Warszawa",
  },
  {
    code: "01-966",
    city: "Warszawa",
  },
  {
    code: "01-968",
    city: "Warszawa",
  },
  {
    code: "01-969",
    city: "Warszawa",
  },
  {
    code: "01-970",
    city: "Warszawa",
  },
  {
    code: "01-971",
    city: "Warszawa",
  },
  {
    code: "01-972",
    city: "Warszawa",
  },
  {
    code: "01-973",
    city: "Warszawa",
  },
  {
    code: "01-974",
    city: "Warszawa",
  },
  {
    code: "01-975",
    city: "Warszawa",
  },
  {
    code: "01-976",
    city: "Warszawa",
  },
  {
    code: "01-977",
    city: "Warszawa",
  },
  {
    code: "01-978",
    city: "Warszawa",
  },
  {
    code: "01-979",
    city: "Warszawa",
  },
  {
    code: "01-980",
    city: "Warszawa",
  },
  {
    code: "01-981",
    city: "Warszawa",
  },
  {
    code: "01-982",
    city: "Warszawa",
  },
  {
    code: "01-983",
    city: "Warszawa",
  },
  {
    code: "01-985",
    city: "Warszawa",
  },
  {
    code: "01-986",
    city: "Warszawa",
  },
  {
    code: "01-987",
    city: "Warszawa",
  },
  {
    code: "01-988",
    city: "Warszawa",
  },
  {
    code: "01-989",
    city: "Warszawa",
  },
  {
    code: "01-990",
    city: "Warszawa",
  },
  {
    code: "01-991",
    city: "Warszawa",
  },
  {
    code: "01-992",
    city: "Warszawa",
  },
  {
    code: "01-993",
    city: "Warszawa",
  },
  {
    code: "01-994",
    city: "Warszawa",
  },
  {
    code: "01-995",
    city: "Warszawa",
  },
  {
    code: "01-999",
    city: "Warszawa",
  },
  {
    code: "02-001",
    city: "Warszawa",
  },
  {
    code: "02-002",
    city: "Warszawa",
  },
  {
    code: "02-004",
    city: "Warszawa",
  },
  {
    code: "02-005",
    city: "Warszawa",
  },
  {
    code: "02-006",
    city: "Warszawa",
  },
  {
    code: "02-007",
    city: "Warszawa",
  },
  {
    code: "02-008",
    city: "Warszawa",
  },
  {
    code: "02-009",
    city: "Warszawa",
  },
  {
    code: "02-010",
    city: "Warszawa",
  },
  {
    code: "02-011",
    city: "Warszawa",
  },
  {
    code: "02-012",
    city: "Warszawa",
  },
  {
    code: "02-013",
    city: "Warszawa",
  },
  {
    code: "02-014",
    city: "Warszawa",
  },
  {
    code: "02-015",
    city: "Warszawa",
  },
  {
    code: "02-017",
    city: "Warszawa",
  },
  {
    code: "02-018",
    city: "Warszawa",
  },
  {
    code: "02-019",
    city: "Warszawa",
  },
  {
    code: "02-020",
    city: "Warszawa",
  },
  {
    code: "02-021",
    city: "Warszawa",
  },
  {
    code: "02-022",
    city: "Warszawa",
  },
  {
    code: "02-023",
    city: "Warszawa",
  },
  {
    code: "02-024",
    city: "Warszawa",
  },
  {
    code: "02-025",
    city: "Warszawa",
  },
  {
    code: "02-026",
    city: "Warszawa",
  },
  {
    code: "02-027",
    city: "Warszawa",
  },
  {
    code: "02-028",
    city: "Warszawa",
  },
  {
    code: "02-029",
    city: "Warszawa",
  },
  {
    code: "02-030",
    city: "Warszawa",
  },
  {
    code: "02-031",
    city: "Warszawa",
  },
  {
    code: "02-032",
    city: "Warszawa",
  },
  {
    code: "02-033",
    city: "Warszawa",
  },
  {
    code: "02-034",
    city: "Warszawa",
  },
  {
    code: "02-035",
    city: "Warszawa",
  },
  {
    code: "02-036",
    city: "Warszawa",
  },
  {
    code: "02-038",
    city: "Warszawa",
  },
  {
    code: "02-040",
    city: "Warszawa",
  },
  {
    code: "02-041",
    city: "Warszawa",
  },
  {
    code: "02-042",
    city: "Warszawa",
  },
  {
    code: "02-044",
    city: "Warszawa",
  },
  {
    code: "02-045",
    city: "Warszawa",
  },
  {
    code: "02-046",
    city: "Warszawa",
  },
  {
    code: "02-047",
    city: "Warszawa",
  },
  {
    code: "02-048",
    city: "Warszawa",
  },
  {
    code: "02-049",
    city: "Warszawa",
  },
  {
    code: "02-050",
    city: "Warszawa",
  },
  {
    code: "02-051",
    city: "Warszawa",
  },
  {
    code: "02-052",
    city: "Warszawa",
  },
  {
    code: "02-053",
    city: "Warszawa",
  },
  {
    code: "02-054",
    city: "Warszawa",
  },
  {
    code: "02-055",
    city: "Warszawa",
  },
  {
    code: "02-056",
    city: "Warszawa",
  },
  {
    code: "02-057",
    city: "Warszawa",
  },
  {
    code: "02-059",
    city: "Warszawa",
  },
  {
    code: "02-061",
    city: "Warszawa",
  },
  {
    code: "02-062",
    city: "Warszawa",
  },
  {
    code: "02-063",
    city: "Warszawa",
  },
  {
    code: "02-064",
    city: "Warszawa",
  },
  {
    code: "02-065",
    city: "Warszawa",
  },
  {
    code: "02-066",
    city: "Warszawa",
  },
  {
    code: "02-067",
    city: "Warszawa",
  },
  {
    code: "02-068",
    city: "Warszawa",
  },
  {
    code: "02-069",
    city: "Warszawa",
  },
  {
    code: "02-070",
    city: "Warszawa",
  },
  {
    code: "02-071",
    city: "Warszawa",
  },
  {
    code: "02-072",
    city: "Warszawa",
  },
  {
    code: "02-073",
    city: "Warszawa",
  },
  {
    code: "02-074",
    city: "Warszawa",
  },
  {
    code: "02-075",
    city: "Warszawa",
  },
  {
    code: "02-078",
    city: "Warszawa",
  },
  {
    code: "02-079",
    city: "Warszawa",
  },
  {
    code: "02-080",
    city: "Warszawa",
  },
  {
    code: "02-081",
    city: "Warszawa",
  },
  {
    code: "02-082",
    city: "Warszawa",
  },
  {
    code: "02-083",
    city: "Warszawa",
  },
  {
    code: "02-084",
    city: "Warszawa",
  },
  {
    code: "02-085",
    city: "Warszawa",
  },
  {
    code: "02-086",
    city: "Warszawa",
  },
  {
    code: "02-087",
    city: "Warszawa",
  },
  {
    code: "02-089",
    city: "Warszawa",
  },
  {
    code: "02-090",
    city: "Warszawa",
  },
  {
    code: "02-091",
    city: "Warszawa",
  },
  {
    code: "02-092",
    city: "Warszawa",
  },
  {
    code: "02-093",
    city: "Warszawa",
  },
  {
    code: "02-094",
    city: "Warszawa",
  },
  {
    code: "02-095",
    city: "Warszawa",
  },
  {
    code: "02-096",
    city: "Warszawa",
  },
  {
    code: "02-097",
    city: "Warszawa",
  },
  {
    code: "02-098",
    city: "Warszawa",
  },
  {
    code: "02-100",
    city: "Warszawa",
  },
  {
    code: "02-101",
    city: "Warszawa",
  },
  {
    code: "02-102",
    city: "Warszawa",
  },
  {
    code: "02-103",
    city: "Warszawa",
  },
  {
    code: "02-104",
    city: "Warszawa",
  },
  {
    code: "02-105",
    city: "Warszawa",
  },
  {
    code: "02-106",
    city: "Warszawa",
  },
  {
    code: "02-107",
    city: "Warszawa",
  },
  {
    code: "02-108",
    city: "Warszawa",
  },
  {
    code: "02-109",
    city: "Warszawa",
  },
  {
    code: "02-110",
    city: "Warszawa",
  },
  {
    code: "02-111",
    city: "Warszawa",
  },
  {
    code: "02-112",
    city: "Warszawa",
  },
  {
    code: "02-113",
    city: "Warszawa",
  },
  {
    code: "02-114",
    city: "Warszawa",
  },
  {
    code: "02-115",
    city: "Warszawa",
  },
  {
    code: "02-116",
    city: "Warszawa",
  },
  {
    code: "02-117",
    city: "Warszawa",
  },
  {
    code: "02-118",
    city: "Warszawa",
  },
  {
    code: "02-119",
    city: "Warszawa",
  },
  {
    code: "02-120",
    city: "Warszawa",
  },
  {
    code: "02-121",
    city: "Warszawa",
  },
  {
    code: "02-122",
    city: "Warszawa",
  },
  {
    code: "02-123",
    city: "Warszawa",
  },
  {
    code: "02-124",
    city: "Warszawa",
  },
  {
    code: "02-126",
    city: "Warszawa",
  },
  {
    code: "02-127",
    city: "Warszawa",
  },
  {
    code: "02-128",
    city: "Warszawa",
  },
  {
    code: "02-129",
    city: "Warszawa",
  },
  {
    code: "02-130",
    city: "Warszawa",
  },
  {
    code: "02-131",
    city: "Warszawa",
  },
  {
    code: "02-132",
    city: "Warszawa",
  },
  {
    code: "02-133",
    city: "Warszawa",
  },
  {
    code: "02-134",
    city: "Warszawa",
  },
  {
    code: "02-135",
    city: "Warszawa",
  },
  {
    code: "02-136",
    city: "Warszawa",
  },
  {
    code: "02-137",
    city: "Warszawa",
  },
  {
    code: "02-138",
    city: "Warszawa",
  },
  {
    code: "02-139",
    city: "Warszawa",
  },
  {
    code: "02-140",
    city: "Warszawa",
  },
  {
    code: "02-141",
    city: "Warszawa",
  },
  {
    code: "02-142",
    city: "Warszawa",
  },
  {
    code: "02-143",
    city: "Warszawa",
  },
  {
    code: "02-144",
    city: "Warszawa",
  },
  {
    code: "02-145",
    city: "Warszawa",
  },
  {
    code: "02-146",
    city: "Warszawa",
  },
  {
    code: "02-147",
    city: "Warszawa",
  },
  {
    code: "02-148",
    city: "Warszawa",
  },
  {
    code: "02-149",
    city: "Warszawa",
  },
  {
    code: "02-150",
    city: "Warszawa",
  },
  {
    code: "02-151",
    city: "Warszawa",
  },
  {
    code: "02-152",
    city: "Warszawa",
  },
  {
    code: "02-153",
    city: "Warszawa",
  },
  {
    code: "02-154",
    city: "Warszawa",
  },
  {
    code: "02-155",
    city: "Warszawa",
  },
  {
    code: "02-156",
    city: "Warszawa",
  },
  {
    code: "02-157",
    city: "Warszawa",
  },
  {
    code: "02-158",
    city: "Warszawa",
  },
  {
    code: "02-159",
    city: "Warszawa",
  },
  {
    code: "02-160",
    city: "Warszawa",
  },
  {
    code: "02-161",
    city: "Warszawa",
  },
  {
    code: "02-162",
    city: "Warszawa",
  },
  {
    code: "02-163",
    city: "Warszawa",
  },
  {
    code: "02-164",
    city: "Warszawa",
  },
  {
    code: "02-165",
    city: "Warszawa",
  },
  {
    code: "02-166",
    city: "Warszawa",
  },
  {
    code: "02-168",
    city: "Warszawa",
  },
  {
    code: "02-169",
    city: "Warszawa",
  },
  {
    code: "02-170",
    city: "Warszawa",
  },
  {
    code: "02-172",
    city: "Warszawa",
  },
  {
    code: "02-173",
    city: "Warszawa",
  },
  {
    code: "02-174",
    city: "Warszawa",
  },
  {
    code: "02-175",
    city: "Warszawa",
  },
  {
    code: "02-176",
    city: "Warszawa",
  },
  {
    code: "02-177",
    city: "Warszawa",
  },
  {
    code: "02-178",
    city: "Warszawa",
  },
  {
    code: "02-179",
    city: "Warszawa",
  },
  {
    code: "02-180",
    city: "Warszawa",
  },
  {
    code: "02-181",
    city: "Warszawa",
  },
  {
    code: "02-182",
    city: "Warszawa",
  },
  {
    code: "02-183",
    city: "Warszawa",
  },
  {
    code: "02-184",
    city: "Warszawa",
  },
  {
    code: "02-186",
    city: "Warszawa",
  },
  {
    code: "02-187",
    city: "Warszawa",
  },
  {
    code: "02-188",
    city: "Warszawa",
  },
  {
    code: "02-189",
    city: "Warszawa",
  },
  {
    code: "02-190",
    city: "Warszawa",
  },
  {
    code: "02-191",
    city: "Warszawa",
  },
  {
    code: "02-192",
    city: "Warszawa",
  },
  {
    code: "02-194",
    city: "Warszawa",
  },
  {
    code: "02-195",
    city: "Warszawa",
  },
  {
    code: "02-196",
    city: "Warszawa",
  },
  {
    code: "02-197",
    city: "Warszawa",
  },
  {
    code: "02-198",
    city: "Warszawa",
  },
  {
    code: "02-200",
    city: "Warszawa",
  },
  {
    code: "02-201",
    city: "Warszawa",
  },
  {
    code: "02-202",
    city: "Warszawa",
  },
  {
    code: "02-203",
    city: "Warszawa",
  },
  {
    code: "02-204",
    city: "Warszawa",
  },
  {
    code: "02-205",
    city: "Warszawa",
  },
  {
    code: "02-206",
    city: "Warszawa",
  },
  {
    code: "02-207",
    city: "Warszawa",
  },
  {
    code: "02-208",
    city: "Warszawa",
  },
  {
    code: "02-209",
    city: "Warszawa",
  },
  {
    code: "02-210",
    city: "Warszawa",
  },
  {
    code: "02-211",
    city: "Warszawa",
  },
  {
    code: "02-212",
    city: "Warszawa",
  },
  {
    code: "02-213",
    city: "Warszawa",
  },
  {
    code: "02-214",
    city: "Warszawa",
  },
  {
    code: "02-215",
    city: "Warszawa",
  },
  {
    code: "02-216",
    city: "Warszawa",
  },
  {
    code: "02-217",
    city: "Warszawa",
  },
  {
    code: "02-218",
    city: "Warszawa",
  },
  {
    code: "02-219",
    city: "Warszawa",
  },
  {
    code: "02-220",
    city: "Warszawa",
  },
  {
    code: "02-221",
    city: "Warszawa",
  },
  {
    code: "02-222",
    city: "Warszawa",
  },
  {
    code: "02-223",
    city: "Warszawa",
  },
  {
    code: "02-224",
    city: "Warszawa",
  },
  {
    code: "02-225",
    city: "Warszawa",
  },
  {
    code: "02-226",
    city: "Warszawa",
  },
  {
    code: "02-227",
    city: "Warszawa",
  },
  {
    code: "02-228",
    city: "Warszawa",
  },
  {
    code: "02-229",
    city: "Warszawa",
  },
  {
    code: "02-230",
    city: "Warszawa",
  },
  {
    code: "02-231",
    city: "Warszawa",
  },
  {
    code: "02-232",
    city: "Warszawa",
  },
  {
    code: "02-233",
    city: "Warszawa",
  },
  {
    code: "02-234",
    city: "Warszawa",
  },
  {
    code: "02-235",
    city: "Warszawa",
  },
  {
    code: "02-236",
    city: "Warszawa",
  },
  {
    code: "02-237",
    city: "Warszawa",
  },
  {
    code: "02-238",
    city: "Warszawa",
  },
  {
    code: "02-239",
    city: "Warszawa",
  },
  {
    code: "02-240",
    city: "Warszawa",
  },
  {
    code: "02-241",
    city: "Warszawa",
  },
  {
    code: "02-242",
    city: "Warszawa",
  },
  {
    code: "02-243",
    city: "Warszawa",
  },
  {
    code: "02-244",
    city: "Warszawa",
  },
  {
    code: "02-246",
    city: "Warszawa",
  },
  {
    code: "02-247",
    city: "Warszawa",
  },
  {
    code: "02-248",
    city: "Warszawa",
  },
  {
    code: "02-249",
    city: "Warszawa",
  },
  {
    code: "02-250",
    city: "Warszawa",
  },
  {
    code: "02-251",
    city: "Warszawa",
  },
  {
    code: "02-252",
    city: "Warszawa",
  },
  {
    code: "02-253",
    city: "Warszawa",
  },
  {
    code: "02-254",
    city: "Warszawa",
  },
  {
    code: "02-255",
    city: "Warszawa",
  },
  {
    code: "02-256",
    city: "Warszawa",
  },
  {
    code: "02-257",
    city: "Warszawa",
  },
  {
    code: "02-258",
    city: "Warszawa",
  },
  {
    code: "02-259",
    city: "Warszawa",
  },
  {
    code: "02-260",
    city: "Warszawa",
  },
  {
    code: "02-261",
    city: "Warszawa",
  },
  {
    code: "02-262",
    city: "Warszawa",
  },
  {
    code: "02-263",
    city: "Warszawa",
  },
  {
    code: "02-264",
    city: "Warszawa",
  },
  {
    code: "02-265",
    city: "Warszawa",
  },
  {
    code: "02-266",
    city: "Warszawa",
  },
  {
    code: "02-267",
    city: "Warszawa",
  },
  {
    code: "02-268",
    city: "Warszawa",
  },
  {
    code: "02-269",
    city: "Warszawa",
  },
  {
    code: "02-270",
    city: "Warszawa",
  },
  {
    code: "02-271",
    city: "Warszawa",
  },
  {
    code: "02-272",
    city: "Warszawa",
  },
  {
    code: "02-273",
    city: "Warszawa",
  },
  {
    code: "02-274",
    city: "Warszawa",
  },
  {
    code: "02-275",
    city: "Warszawa",
  },
  {
    code: "02-276",
    city: "Warszawa",
  },
  {
    code: "02-277",
    city: "Warszawa",
  },
  {
    code: "02-278",
    city: "Warszawa",
  },
  {
    code: "02-279",
    city: "Warszawa",
  },
  {
    code: "02-280",
    city: "Warszawa",
  },
  {
    code: "02-281",
    city: "Warszawa",
  },
  {
    code: "02-282",
    city: "Warszawa",
  },
  {
    code: "02-283",
    city: "Warszawa",
  },
  {
    code: "02-284",
    city: "Warszawa",
  },
  {
    code: "02-285",
    city: "Warszawa",
  },
  {
    code: "02-286",
    city: "Warszawa",
  },
  {
    code: "02-287",
    city: "Warszawa",
  },
  {
    code: "02-288",
    city: "Warszawa",
  },
  {
    code: "02-290",
    city: "Warszawa",
  },
  {
    code: "02-291",
    city: "Warszawa",
  },
  {
    code: "02-292",
    city: "Warszawa",
  },
  {
    code: "02-293",
    city: "Warszawa",
  },
  {
    code: "02-294",
    city: "Warszawa",
  },
  {
    code: "02-295",
    city: "Warszawa",
  },
  {
    code: "02-296",
    city: "Warszawa",
  },
  {
    code: "02-298",
    city: "Warszawa",
  },
  {
    code: "02-299",
    city: "Warszawa",
  },
  {
    code: "02-301",
    city: "Warszawa",
  },
  {
    code: "02-302",
    city: "Warszawa",
  },
  {
    code: "02-304",
    city: "Warszawa",
  },
  {
    code: "02-305",
    city: "Warszawa",
  },
  {
    code: "02-306",
    city: "Warszawa",
  },
  {
    code: "02-307",
    city: "Warszawa",
  },
  {
    code: "02-308",
    city: "Warszawa",
  },
  {
    code: "02-309",
    city: "Warszawa",
  },
  {
    code: "02-310",
    city: "Warszawa",
  },
  {
    code: "02-311",
    city: "Warszawa",
  },
  {
    code: "02-312",
    city: "Warszawa",
  },
  {
    code: "02-313",
    city: "Warszawa",
  },
  {
    code: "02-314",
    city: "Warszawa",
  },
  {
    code: "02-315",
    city: "Warszawa",
  },
  {
    code: "02-316",
    city: "Warszawa",
  },
  {
    code: "02-317",
    city: "Warszawa",
  },
  {
    code: "02-318",
    city: "Warszawa",
  },
  {
    code: "02-319",
    city: "Warszawa",
  },
  {
    code: "02-320",
    city: "Warszawa",
  },
  {
    code: "02-321",
    city: "Warszawa",
  },
  {
    code: "02-322",
    city: "Warszawa",
  },
  {
    code: "02-323",
    city: "Warszawa",
  },
  {
    code: "02-324",
    city: "Warszawa",
  },
  {
    code: "02-325",
    city: "Warszawa",
  },
  {
    code: "02-326",
    city: "Warszawa",
  },
  {
    code: "02-327",
    city: "Warszawa",
  },
  {
    code: "02-334",
    city: "Warszawa",
  },
  {
    code: "02-335",
    city: "Warszawa",
  },
  {
    code: "02-336",
    city: "Warszawa",
  },
  {
    code: "02-337",
    city: "Warszawa",
  },
  {
    code: "02-338",
    city: "Warszawa",
  },
  {
    code: "02-339",
    city: "Warszawa",
  },
  {
    code: "02-340",
    city: "Warszawa",
  },
  {
    code: "02-341",
    city: "Warszawa",
  },
  {
    code: "02-342",
    city: "Warszawa",
  },
  {
    code: "02-343",
    city: "Warszawa",
  },
  {
    code: "02-344",
    city: "Warszawa",
  },
  {
    code: "02-345",
    city: "Warszawa",
  },
  {
    code: "02-346",
    city: "Warszawa",
  },
  {
    code: "02-347",
    city: "Warszawa",
  },
  {
    code: "02-348",
    city: "Warszawa",
  },
  {
    code: "02-349",
    city: "Warszawa",
  },
  {
    code: "02-350",
    city: "Warszawa",
  },
  {
    code: "02-351",
    city: "Warszawa",
  },
  {
    code: "02-352",
    city: "Warszawa",
  },
  {
    code: "02-353",
    city: "Warszawa",
  },
  {
    code: "02-354",
    city: "Warszawa",
  },
  {
    code: "02-356",
    city: "Warszawa",
  },
  {
    code: "02-359",
    city: "Warszawa",
  },
  {
    code: "02-360",
    city: "Warszawa",
  },
  {
    code: "02-361",
    city: "Warszawa",
  },
  {
    code: "02-362",
    city: "Warszawa",
  },
  {
    code: "02-363",
    city: "Warszawa",
  },
  {
    code: "02-364",
    city: "Warszawa",
  },
  {
    code: "02-365",
    city: "Warszawa",
  },
  {
    code: "02-366",
    city: "Warszawa",
  },
  {
    code: "02-367",
    city: "Warszawa",
  },
  {
    code: "02-368",
    city: "Warszawa",
  },
  {
    code: "02-369",
    city: "Warszawa",
  },
  {
    code: "02-370",
    city: "Warszawa",
  },
  {
    code: "02-371",
    city: "Warszawa",
  },
  {
    code: "02-372",
    city: "Warszawa",
  },
  {
    code: "02-373",
    city: "Warszawa",
  },
  {
    code: "02-374",
    city: "Warszawa",
  },
  {
    code: "02-375",
    city: "Warszawa",
  },
  {
    code: "02-376",
    city: "Warszawa",
  },
  {
    code: "02-377",
    city: "Warszawa",
  },
  {
    code: "02-378",
    city: "Warszawa",
  },
  {
    code: "02-379",
    city: "Warszawa",
  },
  {
    code: "02-380",
    city: "Warszawa",
  },
  {
    code: "02-381",
    city: "Warszawa",
  },
  {
    code: "02-382",
    city: "Warszawa",
  },
  {
    code: "02-383",
    city: "Warszawa",
  },
  {
    code: "02-384",
    city: "Warszawa",
  },
  {
    code: "02-385",
    city: "Warszawa",
  },
  {
    code: "02-386",
    city: "Warszawa",
  },
  {
    code: "02-387",
    city: "Warszawa",
  },
  {
    code: "02-388",
    city: "Warszawa",
  },
  {
    code: "02-389",
    city: "Warszawa",
  },
  {
    code: "02-390",
    city: "Warszawa",
  },
  {
    code: "02-391",
    city: "Warszawa",
  },
  {
    code: "02-392",
    city: "Warszawa",
  },
  {
    code: "02-393",
    city: "Warszawa",
  },
  {
    code: "02-394",
    city: "Warszawa",
  },
  {
    code: "02-395",
    city: "Warszawa",
  },
  {
    code: "02-396",
    city: "Warszawa",
  },
  {
    code: "02-397",
    city: "Warszawa",
  },
  {
    code: "02-398",
    city: "Warszawa",
  },
  {
    code: "02-400",
    city: "Warszawa",
  },
  {
    code: "02-401",
    city: "Warszawa",
  },
  {
    code: "02-402",
    city: "Warszawa",
  },
  {
    code: "02-403",
    city: "Warszawa",
  },
  {
    code: "02-404",
    city: "Warszawa",
  },
  {
    code: "02-405",
    city: "Warszawa",
  },
  {
    code: "02-406",
    city: "Warszawa",
  },
  {
    code: "02-407",
    city: "Warszawa",
  },
  {
    code: "02-408",
    city: "Warszawa",
  },
  {
    code: "02-409",
    city: "Warszawa",
  },
  {
    code: "02-410",
    city: "Warszawa",
  },
  {
    code: "02-411",
    city: "Warszawa",
  },
  {
    code: "02-412",
    city: "Warszawa",
  },
  {
    code: "02-413",
    city: "Warszawa",
  },
  {
    code: "02-414",
    city: "Warszawa",
  },
  {
    code: "02-415",
    city: "Warszawa",
  },
  {
    code: "02-416",
    city: "Warszawa",
  },
  {
    code: "02-417",
    city: "Warszawa",
  },
  {
    code: "02-419",
    city: "Warszawa",
  },
  {
    code: "02-421",
    city: "Warszawa",
  },
  {
    code: "02-422",
    city: "Warszawa",
  },
  {
    code: "02-423",
    city: "Warszawa",
  },
  {
    code: "02-424",
    city: "Warszawa",
  },
  {
    code: "02-425",
    city: "Warszawa",
  },
  {
    code: "02-427",
    city: "Warszawa",
  },
  {
    code: "02-428",
    city: "Warszawa",
  },
  {
    code: "02-430",
    city: "Warszawa",
  },
  {
    code: "02-431",
    city: "Warszawa",
  },
  {
    code: "02-432",
    city: "Warszawa",
  },
  {
    code: "02-433",
    city: "Warszawa",
  },
  {
    code: "02-434",
    city: "Warszawa",
  },
  {
    code: "02-435",
    city: "Warszawa",
  },
  {
    code: "02-436",
    city: "Warszawa",
  },
  {
    code: "02-437",
    city: "Warszawa",
  },
  {
    code: "02-438",
    city: "Warszawa",
  },
  {
    code: "02-439",
    city: "Warszawa",
  },
  {
    code: "02-440",
    city: "Warszawa",
  },
  {
    code: "02-441",
    city: "Warszawa",
  },
  {
    code: "02-442",
    city: "Warszawa",
  },
  {
    code: "02-443",
    city: "Warszawa",
  },
  {
    code: "02-445",
    city: "Warszawa",
  },
  {
    code: "02-446",
    city: "Warszawa",
  },
  {
    code: "02-447",
    city: "Warszawa",
  },
  {
    code: "02-448",
    city: "Warszawa",
  },
  {
    code: "02-449",
    city: "Warszawa",
  },
  {
    code: "02-450",
    city: "Warszawa",
  },
  {
    code: "02-452",
    city: "Warszawa",
  },
  {
    code: "02-453",
    city: "Warszawa",
  },
  {
    code: "02-454",
    city: "Warszawa",
  },
  {
    code: "02-455",
    city: "Warszawa",
  },
  {
    code: "02-456",
    city: "Warszawa",
  },
  {
    code: "02-457",
    city: "Warszawa",
  },
  {
    code: "02-458",
    city: "Warszawa",
  },
  {
    code: "02-459",
    city: "Warszawa",
  },
  {
    code: "02-460",
    city: "Warszawa",
  },
  {
    code: "02-462",
    city: "Warszawa",
  },
  {
    code: "02-463",
    city: "Warszawa",
  },
  {
    code: "02-464",
    city: "Warszawa",
  },
  {
    code: "02-465",
    city: "Warszawa",
  },
  {
    code: "02-466",
    city: "Warszawa",
  },
  {
    code: "02-467",
    city: "Warszawa",
  },
  {
    code: "02-468",
    city: "Warszawa",
  },
  {
    code: "02-469",
    city: "Warszawa",
  },
  {
    code: "02-470",
    city: "Warszawa",
  },
  {
    code: "02-471",
    city: "Warszawa",
  },
  {
    code: "02-472",
    city: "Warszawa",
  },
  {
    code: "02-473",
    city: "Warszawa",
  },
  {
    code: "02-474",
    city: "Warszawa",
  },
  {
    code: "02-477",
    city: "Warszawa",
  },
  {
    code: "02-479",
    city: "Warszawa",
  },
  {
    code: "02-480",
    city: "Warszawa",
  },
  {
    code: "02-481",
    city: "Warszawa",
  },
  {
    code: "02-482",
    city: "Warszawa",
  },
  {
    code: "02-483",
    city: "Warszawa",
  },
  {
    code: "02-484",
    city: "Warszawa",
  },
  {
    code: "02-485",
    city: "Warszawa",
  },
  {
    code: "02-486",
    city: "Warszawa",
  },
  {
    code: "02-487",
    city: "Warszawa",
  },
  {
    code: "02-488",
    city: "Warszawa",
  },
  {
    code: "02-489",
    city: "Warszawa",
  },
  {
    code: "02-490",
    city: "Warszawa",
  },
  {
    code: "02-491",
    city: "Warszawa",
  },
  {
    code: "02-492",
    city: "Warszawa",
  },
  {
    code: "02-493",
    city: "Warszawa",
  },
  {
    code: "02-494",
    city: "Warszawa",
  },
  {
    code: "02-495",
    city: "Warszawa",
  },
  {
    code: "02-496",
    city: "Warszawa",
  },
  {
    code: "02-497",
    city: "Warszawa",
  },
  {
    code: "02-498",
    city: "Warszawa",
  },
  {
    code: "02-501",
    city: "Warszawa",
  },
  {
    code: "02-502",
    city: "Warszawa",
  },
  {
    code: "02-503",
    city: "Warszawa",
  },
  {
    code: "02-504",
    city: "Warszawa",
  },
  {
    code: "02-505",
    city: "Warszawa",
  },
  {
    code: "02-506",
    city: "Warszawa",
  },
  {
    code: "02-507",
    city: "Warszawa",
  },
  {
    code: "02-508",
    city: "Warszawa",
  },
  {
    code: "02-509",
    city: "Warszawa",
  },
  {
    code: "02-510",
    city: "Warszawa",
  },
  {
    code: "02-511",
    city: "Warszawa",
  },
  {
    code: "02-512",
    city: "Warszawa",
  },
  {
    code: "02-513",
    city: "Warszawa",
  },
  {
    code: "02-514",
    city: "Warszawa",
  },
  {
    code: "02-515",
    city: "Warszawa",
  },
  {
    code: "02-516",
    city: "Warszawa",
  },
  {
    code: "02-517",
    city: "Warszawa",
  },
  {
    code: "02-518",
    city: "Warszawa",
  },
  {
    code: "02-519",
    city: "Warszawa",
  },
  {
    code: "02-520",
    city: "Warszawa",
  },
  {
    code: "02-521",
    city: "Warszawa",
  },
  {
    code: "02-522",
    city: "Warszawa",
  },
  {
    code: "02-523",
    city: "Warszawa",
  },
  {
    code: "02-524",
    city: "Warszawa",
  },
  {
    code: "02-525",
    city: "Warszawa",
  },
  {
    code: "02-526",
    city: "Warszawa",
  },
  {
    code: "02-527",
    city: "Warszawa",
  },
  {
    code: "02-528",
    city: "Warszawa",
  },
  {
    code: "02-529",
    city: "Warszawa",
  },
  {
    code: "02-530",
    city: "Warszawa",
  },
  {
    code: "02-531",
    city: "Warszawa",
  },
  {
    code: "02-532",
    city: "Warszawa",
  },
  {
    code: "02-533",
    city: "Warszawa",
  },
  {
    code: "02-534",
    city: "Warszawa",
  },
  {
    code: "02-535",
    city: "Warszawa",
  },
  {
    code: "02-536",
    city: "Warszawa",
  },
  {
    code: "02-537",
    city: "Warszawa",
  },
  {
    code: "02-538",
    city: "Warszawa",
  },
  {
    code: "02-539",
    city: "Warszawa",
  },
  {
    code: "02-540",
    city: "Warszawa",
  },
  {
    code: "02-541",
    city: "Warszawa",
  },
  {
    code: "02-543",
    city: "Warszawa",
  },
  {
    code: "02-544",
    city: "Warszawa",
  },
  {
    code: "02-545",
    city: "Warszawa",
  },
  {
    code: "02-546",
    city: "Warszawa",
  },
  {
    code: "02-547",
    city: "Warszawa",
  },
  {
    code: "02-548",
    city: "Warszawa",
  },
  {
    code: "02-549",
    city: "Warszawa",
  },
  {
    code: "02-550",
    city: "Warszawa",
  },
  {
    code: "02-551",
    city: "Warszawa",
  },
  {
    code: "02-552",
    city: "Warszawa",
  },
  {
    code: "02-553",
    city: "Warszawa",
  },
  {
    code: "02-554",
    city: "Warszawa",
  },
  {
    code: "02-555",
    city: "Warszawa",
  },
  {
    code: "02-556",
    city: "Warszawa",
  },
  {
    code: "02-557",
    city: "Warszawa",
  },
  {
    code: "02-558",
    city: "Warszawa",
  },
  {
    code: "02-559",
    city: "Warszawa",
  },
  {
    code: "02-560",
    city: "Warszawa",
  },
  {
    code: "02-561",
    city: "Warszawa",
  },
  {
    code: "02-562",
    city: "Warszawa",
  },
  {
    code: "02-563",
    city: "Warszawa",
  },
  {
    code: "02-564",
    city: "Warszawa",
  },
  {
    code: "02-566",
    city: "Warszawa",
  },
  {
    code: "02-567",
    city: "Warszawa",
  },
  {
    code: "02-568",
    city: "Warszawa",
  },
  {
    code: "02-569",
    city: "Warszawa",
  },
  {
    code: "02-570",
    city: "Warszawa",
  },
  {
    code: "02-571",
    city: "Warszawa",
  },
  {
    code: "02-572",
    city: "Warszawa",
  },
  {
    code: "02-574",
    city: "Warszawa",
  },
  {
    code: "02-575",
    city: "Warszawa",
  },
  {
    code: "02-577",
    city: "Warszawa",
  },
  {
    code: "02-578",
    city: "Warszawa",
  },
  {
    code: "02-579",
    city: "Warszawa",
  },
  {
    code: "02-581",
    city: "Warszawa",
  },
  {
    code: "02-582",
    city: "Warszawa",
  },
  {
    code: "02-583",
    city: "Warszawa",
  },
  {
    code: "02-584",
    city: "Warszawa",
  },
  {
    code: "02-585",
    city: "Warszawa",
  },
  {
    code: "02-586",
    city: "Warszawa",
  },
  {
    code: "02-587",
    city: "Warszawa",
  },
  {
    code: "02-588",
    city: "Warszawa",
  },
  {
    code: "02-589",
    city: "Warszawa",
  },
  {
    code: "02-590",
    city: "Warszawa",
  },
  {
    code: "02-591",
    city: "Warszawa",
  },
  {
    code: "02-592",
    city: "Warszawa",
  },
  {
    code: "02-593",
    city: "Warszawa",
  },
  {
    code: "02-594",
    city: "Warszawa",
  },
  {
    code: "02-595",
    city: "Warszawa",
  },
  {
    code: "02-598",
    city: "Warszawa",
  },
  {
    code: "02-600",
    city: "Warszawa",
  },
  {
    code: "02-601",
    city: "Warszawa",
  },
  {
    code: "02-602",
    city: "Warszawa",
  },
  {
    code: "02-603",
    city: "Warszawa",
  },
  {
    code: "02-604",
    city: "Warszawa",
  },
  {
    code: "02-605",
    city: "Warszawa",
  },
  {
    code: "02-606",
    city: "Warszawa",
  },
  {
    code: "02-607",
    city: "Warszawa",
  },
  {
    code: "02-608",
    city: "Warszawa",
  },
  {
    code: "02-609",
    city: "Warszawa",
  },
  {
    code: "02-610",
    city: "Warszawa",
  },
  {
    code: "02-611",
    city: "Warszawa",
  },
  {
    code: "02-612",
    city: "Warszawa",
  },
  {
    code: "02-613",
    city: "Warszawa",
  },
  {
    code: "02-614",
    city: "Warszawa",
  },
  {
    code: "02-615",
    city: "Warszawa",
  },
  {
    code: "02-616",
    city: "Warszawa",
  },
  {
    code: "02-617",
    city: "Warszawa",
  },
  {
    code: "02-618",
    city: "Warszawa",
  },
  {
    code: "02-619",
    city: "Warszawa",
  },
  {
    code: "02-620",
    city: "Warszawa",
  },
  {
    code: "02-621",
    city: "Warszawa",
  },
  {
    code: "02-622",
    city: "Warszawa",
  },
  {
    code: "02-624",
    city: "Warszawa",
  },
  {
    code: "02-625",
    city: "Warszawa",
  },
  {
    code: "02-626",
    city: "Warszawa",
  },
  {
    code: "02-627",
    city: "Warszawa",
  },
  {
    code: "02-628",
    city: "Warszawa",
  },
  {
    code: "02-629",
    city: "Warszawa",
  },
  {
    code: "02-630",
    city: "Warszawa",
  },
  {
    code: "02-631",
    city: "Warszawa",
  },
  {
    code: "02-632",
    city: "Warszawa",
  },
  {
    code: "02-633",
    city: "Warszawa",
  },
  {
    code: "02-634",
    city: "Warszawa",
  },
  {
    code: "02-635",
    city: "Warszawa",
  },
  {
    code: "02-636",
    city: "Warszawa",
  },
  {
    code: "02-637",
    city: "Warszawa",
  },
  {
    code: "02-638",
    city: "Warszawa",
  },
  {
    code: "02-639",
    city: "Warszawa",
  },
  {
    code: "02-640",
    city: "Warszawa",
  },
  {
    code: "02-641",
    city: "Warszawa",
  },
  {
    code: "02-642",
    city: "Warszawa",
  },
  {
    code: "02-643",
    city: "Warszawa",
  },
  {
    code: "02-644",
    city: "Warszawa",
  },
  {
    code: "02-645",
    city: "Warszawa",
  },
  {
    code: "02-646",
    city: "Warszawa",
  },
  {
    code: "02-647",
    city: "Warszawa",
  },
  {
    code: "02-648",
    city: "Warszawa",
  },
  {
    code: "02-649",
    city: "Warszawa",
  },
  {
    code: "02-650",
    city: "Warszawa",
  },
  {
    code: "02-651",
    city: "Warszawa",
  },
  {
    code: "02-652",
    city: "Warszawa",
  },
  {
    code: "02-653",
    city: "Warszawa",
  },
  {
    code: "02-654",
    city: "Warszawa",
  },
  {
    code: "02-655",
    city: "Warszawa",
  },
  {
    code: "02-656",
    city: "Warszawa",
  },
  {
    code: "02-657",
    city: "Warszawa",
  },
  {
    code: "02-658",
    city: "Warszawa",
  },
  {
    code: "02-659",
    city: "Warszawa",
  },
  {
    code: "02-660",
    city: "Warszawa",
  },
  {
    code: "02-661",
    city: "Warszawa",
  },
  {
    code: "02-662",
    city: "Warszawa",
  },
  {
    code: "02-663",
    city: "Warszawa",
  },
  {
    code: "02-664",
    city: "Warszawa",
  },
  {
    code: "02-665",
    city: "Warszawa",
  },
  {
    code: "02-666",
    city: "Warszawa",
  },
  {
    code: "02-668",
    city: "Warszawa",
  },
  {
    code: "02-669",
    city: "Warszawa",
  },
  {
    code: "02-670",
    city: "Warszawa",
  },
  {
    code: "02-671",
    city: "Warszawa",
  },
  {
    code: "02-672",
    city: "Warszawa",
  },
  {
    code: "02-673",
    city: "Warszawa",
  },
  {
    code: "02-674",
    city: "Warszawa",
  },
  {
    code: "02-675",
    city: "Warszawa",
  },
  {
    code: "02-676",
    city: "Warszawa",
  },
  {
    code: "02-677",
    city: "Warszawa",
  },
  {
    code: "02-678",
    city: "Warszawa",
  },
  {
    code: "02-679",
    city: "Warszawa",
  },
  {
    code: "02-680",
    city: "Warszawa",
  },
  {
    code: "02-681",
    city: "Warszawa",
  },
  {
    code: "02-682",
    city: "Warszawa",
  },
  {
    code: "02-683",
    city: "Warszawa",
  },
  {
    code: "02-684",
    city: "Warszawa",
  },
  {
    code: "02-685",
    city: "Warszawa",
  },
  {
    code: "02-690",
    city: "Warszawa",
  },
  {
    code: "02-691",
    city: "Warszawa",
  },
  {
    code: "02-692",
    city: "Warszawa",
  },
  {
    code: "02-693",
    city: "Warszawa",
  },
  {
    code: "02-694",
    city: "Warszawa",
  },
  {
    code: "02-695",
    city: "Warszawa",
  },
  {
    code: "02-696",
    city: "Warszawa",
  },
  {
    code: "02-697",
    city: "Warszawa",
  },
  {
    code: "02-698",
    city: "Warszawa",
  },
  {
    code: "02-699",
    city: "Warszawa",
  },
  {
    code: "02-700",
    city: "Warszawa",
  },
  {
    code: "02-702",
    city: "Warszawa",
  },
  {
    code: "02-703",
    city: "Warszawa",
  },
  {
    code: "02-704",
    city: "Warszawa",
  },
  {
    code: "02-705",
    city: "Warszawa",
  },
  {
    code: "02-707",
    city: "Warszawa",
  },
  {
    code: "02-708",
    city: "Warszawa",
  },
  {
    code: "02-709",
    city: "Warszawa",
  },
  {
    code: "02-710",
    city: "Warszawa",
  },
  {
    code: "02-711",
    city: "Warszawa",
  },
  {
    code: "02-712",
    city: "Warszawa",
  },
  {
    code: "02-713",
    city: "Warszawa",
  },
  {
    code: "02-714",
    city: "Warszawa",
  },
  {
    code: "02-715",
    city: "Warszawa",
  },
  {
    code: "02-716",
    city: "Warszawa",
  },
  {
    code: "02-717",
    city: "Warszawa",
  },
  {
    code: "02-718",
    city: "Warszawa",
  },
  {
    code: "02-720",
    city: "Warszawa",
  },
  {
    code: "02-721",
    city: "Warszawa",
  },
  {
    code: "02-722",
    city: "Warszawa",
  },
  {
    code: "02-725",
    city: "Warszawa",
  },
  {
    code: "02-726",
    city: "Warszawa",
  },
  {
    code: "02-728",
    city: "Warszawa",
  },
  {
    code: "02-729",
    city: "Warszawa",
  },
  {
    code: "02-730",
    city: "Warszawa",
  },
  {
    code: "02-732",
    city: "Warszawa",
  },
  {
    code: "02-733",
    city: "Warszawa",
  },
  {
    code: "02-735",
    city: "Warszawa",
  },
  {
    code: "02-736",
    city: "Warszawa",
  },
  {
    code: "02-737",
    city: "Warszawa",
  },
  {
    code: "02-738",
    city: "Warszawa",
  },
  {
    code: "02-740",
    city: "Warszawa",
  },
  {
    code: "02-741",
    city: "Warszawa",
  },
  {
    code: "02-743",
    city: "Warszawa",
  },
  {
    code: "02-744",
    city: "Warszawa",
  },
  {
    code: "02-745",
    city: "Warszawa",
  },
  {
    code: "02-746",
    city: "Warszawa",
  },
  {
    code: "02-747",
    city: "Warszawa",
  },
  {
    code: "02-748",
    city: "Warszawa",
  },
  {
    code: "02-749",
    city: "Warszawa",
  },
  {
    code: "02-750",
    city: "Warszawa",
  },
  {
    code: "02-751",
    city: "Warszawa",
  },
  {
    code: "02-752",
    city: "Warszawa",
  },
  {
    code: "02-755",
    city: "Warszawa",
  },
  {
    code: "02-757",
    city: "Warszawa",
  },
  {
    code: "02-758",
    city: "Warszawa",
  },
  {
    code: "02-759",
    city: "Warszawa",
  },
  {
    code: "02-760",
    city: "Warszawa",
  },
  {
    code: "02-761",
    city: "Warszawa",
  },
  {
    code: "02-762",
    city: "Warszawa",
  },
  {
    code: "02-763",
    city: "Warszawa",
  },
  {
    code: "02-764",
    city: "Warszawa",
  },
  {
    code: "02-765",
    city: "Warszawa",
  },
  {
    code: "02-766",
    city: "Warszawa",
  },
  {
    code: "02-767",
    city: "Warszawa",
  },
  {
    code: "02-768",
    city: "Warszawa",
  },
  {
    code: "02-769",
    city: "Warszawa",
  },
  {
    code: "02-770",
    city: "Warszawa",
  },
  {
    code: "02-775",
    city: "Warszawa",
  },
  {
    code: "02-776",
    city: "Warszawa",
  },
  {
    code: "02-777",
    city: "Warszawa",
  },
  {
    code: "02-778",
    city: "Warszawa",
  },
  {
    code: "02-780",
    city: "Warszawa",
  },
  {
    code: "02-781",
    city: "Warszawa",
  },
  {
    code: "02-783",
    city: "Warszawa",
  },
  {
    code: "02-784",
    city: "Warszawa",
  },
  {
    code: "02-785",
    city: "Warszawa",
  },
  {
    code: "02-786",
    city: "Warszawa",
  },
  {
    code: "02-787",
    city: "Warszawa",
  },
  {
    code: "02-788",
    city: "Warszawa",
  },
  {
    code: "02-790",
    city: "Warszawa",
  },
  {
    code: "02-791",
    city: "Warszawa",
  },
  {
    code: "02-792",
    city: "Warszawa",
  },
  {
    code: "02-793",
    city: "Warszawa",
  },
  {
    code: "02-794",
    city: "Warszawa",
  },
  {
    code: "02-795",
    city: "Warszawa",
  },
  {
    code: "02-796",
    city: "Warszawa",
  },
  {
    code: "02-797",
    city: "Warszawa",
  },
  {
    code: "02-798",
    city: "Warszawa",
  },
  {
    code: "02-799",
    city: "Warszawa",
  },
  {
    code: "02-800",
    city: "Warszawa",
  },
  {
    code: "02-801",
    city: "Warszawa",
  },
  {
    code: "02-803",
    city: "Warszawa",
  },
  {
    code: "02-804",
    city: "Warszawa",
  },
  {
    code: "02-805",
    city: "Warszawa",
  },
  {
    code: "02-806",
    city: "Warszawa",
  },
  {
    code: "02-807",
    city: "Warszawa",
  },
  {
    code: "02-808",
    city: "Warszawa",
  },
  {
    code: "02-809",
    city: "Warszawa",
  },
  {
    code: "02-811",
    city: "Warszawa",
  },
  {
    code: "02-812",
    city: "Warszawa",
  },
  {
    code: "02-814",
    city: "Warszawa",
  },
  {
    code: "02-815",
    city: "Warszawa",
  },
  {
    code: "02-816",
    city: "Warszawa",
  },
  {
    code: "02-817",
    city: "Warszawa",
  },
  {
    code: "02-818",
    city: "Warszawa",
  },
  {
    code: "02-819",
    city: "Warszawa",
  },
  {
    code: "02-820",
    city: "Warszawa",
  },
  {
    code: "02-821",
    city: "Warszawa",
  },
  {
    code: "02-822",
    city: "Warszawa",
  },
  {
    code: "02-823",
    city: "Warszawa",
  },
  {
    code: "02-824",
    city: "Warszawa",
  },
  {
    code: "02-825",
    city: "Warszawa",
  },
  {
    code: "02-826",
    city: "Warszawa",
  },
  {
    code: "02-827",
    city: "Warszawa",
  },
  {
    code: "02-828",
    city: "Warszawa",
  },
  {
    code: "02-829",
    city: "Warszawa",
  },
  {
    code: "02-830",
    city: "Warszawa",
  },
  {
    code: "02-831",
    city: "Warszawa",
  },
  {
    code: "02-832",
    city: "Warszawa",
  },
  {
    code: "02-833",
    city: "Warszawa",
  },
  {
    code: "02-834",
    city: "Warszawa",
  },
  {
    code: "02-835",
    city: "Warszawa",
  },
  {
    code: "02-836",
    city: "Warszawa",
  },
  {
    code: "02-837",
    city: "Warszawa",
  },
  {
    code: "02-838",
    city: "Warszawa",
  },
  {
    code: "02-840",
    city: "Warszawa",
  },
  {
    code: "02-841",
    city: "Warszawa",
  },
  {
    code: "02-842",
    city: "Warszawa",
  },
  {
    code: "02-843",
    city: "Warszawa",
  },
  {
    code: "02-844",
    city: "Warszawa",
  },
  {
    code: "02-845",
    city: "Warszawa",
  },
  {
    code: "02-846",
    city: "Warszawa",
  },
  {
    code: "02-847",
    city: "Warszawa",
  },
  {
    code: "02-849",
    city: "Warszawa",
  },
  {
    code: "02-850",
    city: "Warszawa",
  },
  {
    code: "02-851",
    city: "Warszawa",
  },
  {
    code: "02-852",
    city: "Warszawa",
  },
  {
    code: "02-853",
    city: "Warszawa",
  },
  {
    code: "02-854",
    city: "Warszawa",
  },
  {
    code: "02-855",
    city: "Warszawa",
  },
  {
    code: "02-856",
    city: "Warszawa",
  },
  {
    code: "02-857",
    city: "Warszawa",
  },
  {
    code: "02-858",
    city: "Warszawa",
  },
  {
    code: "02-859",
    city: "Warszawa",
  },
  {
    code: "02-860",
    city: "Warszawa",
  },
  {
    code: "02-862",
    city: "Warszawa",
  },
  {
    code: "02-863",
    city: "Warszawa",
  },
  {
    code: "02-867",
    city: "Warszawa",
  },
  {
    code: "02-868",
    city: "Warszawa",
  },
  {
    code: "02-869",
    city: "Warszawa",
  },
  {
    code: "02-870",
    city: "Warszawa",
  },
  {
    code: "02-871",
    city: "Warszawa",
  },
  {
    code: "02-872",
    city: "Warszawa",
  },
  {
    code: "02-873",
    city: "Warszawa",
  },
  {
    code: "02-874",
    city: "Warszawa",
  },
  {
    code: "02-875",
    city: "Warszawa",
  },
  {
    code: "02-876",
    city: "Warszawa",
  },
  {
    code: "02-877",
    city: "Warszawa",
  },
  {
    code: "02-878",
    city: "Warszawa",
  },
  {
    code: "02-879",
    city: "Warszawa",
  },
  {
    code: "02-881",
    city: "Warszawa",
  },
  {
    code: "02-882",
    city: "Warszawa",
  },
  {
    code: "02-884",
    city: "Warszawa",
  },
  {
    code: "02-885",
    city: "Warszawa",
  },
  {
    code: "02-886",
    city: "Warszawa",
  },
  {
    code: "02-887",
    city: "Warszawa",
  },
  {
    code: "02-888",
    city: "Warszawa",
  },
  {
    code: "02-889",
    city: "Warszawa",
  },
  {
    code: "02-890",
    city: "Warszawa",
  },
  {
    code: "02-891",
    city: "Warszawa",
  },
  {
    code: "02-892",
    city: "Warszawa",
  },
  {
    code: "02-893",
    city: "Warszawa",
  },
  {
    code: "02-900",
    city: "Warszawa",
  },
  {
    code: "02-901",
    city: "Warszawa",
  },
  {
    code: "02-902",
    city: "Warszawa",
  },
  {
    code: "02-903",
    city: "Warszawa",
  },
  {
    code: "02-904",
    city: "Warszawa",
  },
  {
    code: "02-905",
    city: "Warszawa",
  },
  {
    code: "02-906",
    city: "Warszawa",
  },
  {
    code: "02-907",
    city: "Warszawa",
  },
  {
    code: "02-908",
    city: "Warszawa",
  },
  {
    code: "02-909",
    city: "Warszawa",
  },
  {
    code: "02-910",
    city: "Warszawa",
  },
  {
    code: "02-911",
    city: "Warszawa",
  },
  {
    code: "02-912",
    city: "Warszawa",
  },
  {
    code: "02-913",
    city: "Warszawa",
  },
  {
    code: "02-914",
    city: "Warszawa",
  },
  {
    code: "02-915",
    city: "Warszawa",
  },
  {
    code: "02-916",
    city: "Warszawa",
  },
  {
    code: "02-917",
    city: "Warszawa",
  },
  {
    code: "02-918",
    city: "Warszawa",
  },
  {
    code: "02-919",
    city: "Warszawa",
  },
  {
    code: "02-920",
    city: "Warszawa",
  },
  {
    code: "02-921",
    city: "Warszawa",
  },
  {
    code: "02-922",
    city: "Warszawa",
  },
  {
    code: "02-923",
    city: "Warszawa",
  },
  {
    code: "02-924",
    city: "Warszawa",
  },
  {
    code: "02-925",
    city: "Warszawa",
  },
  {
    code: "02-926",
    city: "Warszawa",
  },
  {
    code: "02-927",
    city: "Warszawa",
  },
  {
    code: "02-928",
    city: "Warszawa",
  },
  {
    code: "02-929",
    city: "Warszawa",
  },
  {
    code: "02-930",
    city: "Warszawa",
  },
  {
    code: "02-931",
    city: "Warszawa",
  },
  {
    code: "02-932",
    city: "Warszawa",
  },
  {
    code: "02-933",
    city: "Warszawa",
  },
  {
    code: "02-934",
    city: "Warszawa",
  },
  {
    code: "02-935",
    city: "Warszawa",
  },
  {
    code: "02-936",
    city: "Warszawa",
  },
  {
    code: "02-937",
    city: "Warszawa",
  },
  {
    code: "02-938",
    city: "Warszawa",
  },
  {
    code: "02-939",
    city: "Warszawa",
  },
  {
    code: "02-940",
    city: "Warszawa",
  },
  {
    code: "02-941",
    city: "Warszawa",
  },
  {
    code: "02-942",
    city: "Warszawa",
  },
  {
    code: "02-943",
    city: "Warszawa",
  },
  {
    code: "02-944",
    city: "Warszawa",
  },
  {
    code: "02-945",
    city: "Warszawa",
  },
  {
    code: "02-946",
    city: "Warszawa",
  },
  {
    code: "02-947",
    city: "Warszawa",
  },
  {
    code: "02-948",
    city: "Warszawa",
  },
  {
    code: "02-949",
    city: "Warszawa",
  },
  {
    code: "02-950",
    city: "Warszawa",
  },
  {
    code: "02-951",
    city: "Warszawa",
  },
  {
    code: "02-952",
    city: "Warszawa",
  },
  {
    code: "02-953",
    city: "Warszawa",
  },
  {
    code: "02-954",
    city: "Warszawa",
  },
  {
    code: "02-955",
    city: "Warszawa",
  },
  {
    code: "02-956",
    city: "Warszawa",
  },
  {
    code: "02-957",
    city: "Warszawa",
  },
  {
    code: "02-958",
    city: "Warszawa",
  },
  {
    code: "02-959",
    city: "Warszawa",
  },
  {
    code: "02-960",
    city: "Warszawa",
  },
  {
    code: "02-961",
    city: "Warszawa",
  },
  {
    code: "02-962",
    city: "Warszawa",
  },
  {
    code: "02-963",
    city: "Warszawa",
  },
  {
    code: "02-964",
    city: "Warszawa",
  },
  {
    code: "02-965",
    city: "Warszawa",
  },
  {
    code: "02-966",
    city: "Warszawa",
  },
  {
    code: "02-967",
    city: "Warszawa",
  },
  {
    code: "02-968",
    city: "Warszawa",
  },
  {
    code: "02-969",
    city: "Warszawa",
  },
  {
    code: "02-970",
    city: "Warszawa",
  },
  {
    code: "02-971",
    city: "Warszawa",
  },
  {
    code: "02-972",
    city: "Warszawa",
  },
  {
    code: "02-973",
    city: "Warszawa",
  },
  {
    code: "02-977",
    city: "Warszawa",
  },
  {
    code: "02-978",
    city: "Warszawa",
  },
  {
    code: "02-979",
    city: "Warszawa",
  },
  {
    code: "02-980",
    city: "Warszawa",
  },
  {
    code: "02-981",
    city: "Warszawa",
  },
  {
    code: "02-982",
    city: "Warszawa",
  },
  {
    code: "02-983",
    city: "Warszawa",
  },
  {
    code: "02-984",
    city: "Warszawa",
  },
  {
    code: "02-985",
    city: "Warszawa",
  },
  {
    code: "02-986",
    city: "Warszawa",
  },
  {
    code: "02-987",
    city: "Warszawa",
  },
  {
    code: "02-988",
    city: "Warszawa",
  },
  {
    code: "02-989",
    city: "Warszawa",
  },
  {
    code: "02-990",
    city: "Warszawa",
  },
  {
    code: "02-991",
    city: "Warszawa",
  },
  {
    code: "02-992",
    city: "Warszawa",
  },
  {
    code: "02-993",
    city: "Warszawa",
  },
  {
    code: "02-994",
    city: "Warszawa",
  },
  {
    code: "02-995",
    city: "Warszawa",
  },
  {
    code: "02-996",
    city: "Warszawa",
  },
  {
    code: "02-997",
    city: "Warszawa",
  },
  {
    code: "02-998",
    city: "Warszawa",
  },
  {
    code: "02-999",
    city: "Warszawa",
  },
  {
    code: "03-001",
    city: "Warszawa",
  },
  {
    code: "03-002",
    city: "Warszawa",
  },
  {
    code: "03-003",
    city: "Warszawa",
  },
  {
    code: "03-004",
    city: "Warszawa",
  },
  {
    code: "03-005",
    city: "Warszawa",
  },
  {
    code: "03-007",
    city: "Warszawa",
  },
  {
    code: "03-008",
    city: "Warszawa",
  },
  {
    code: "03-009",
    city: "Warszawa",
  },
  {
    code: "03-011",
    city: "Warszawa",
  },
  {
    code: "03-012",
    city: "Warszawa",
  },
  {
    code: "03-013",
    city: "Warszawa",
  },
  {
    code: "03-015",
    city: "Warszawa",
  },
  {
    code: "03-016",
    city: "Warszawa",
  },
  {
    code: "03-017",
    city: "Warszawa",
  },
  {
    code: "03-018",
    city: "Warszawa",
  },
  {
    code: "03-019",
    city: "Warszawa",
  },
  {
    code: "03-020",
    city: "Warszawa",
  },
  {
    code: "03-021",
    city: "Warszawa",
  },
  {
    code: "03-022",
    city: "Warszawa",
  },
  {
    code: "03-023",
    city: "Warszawa",
  },
  {
    code: "03-024",
    city: "Warszawa",
  },
  {
    code: "03-025",
    city: "Warszawa",
  },
  {
    code: "03-026",
    city: "Warszawa",
  },
  {
    code: "03-028",
    city: "Warszawa",
  },
  {
    code: "03-029",
    city: "Warszawa",
  },
  {
    code: "03-030",
    city: "Warszawa",
  },
  {
    code: "03-031",
    city: "Warszawa",
  },
  {
    code: "03-032",
    city: "Warszawa",
  },
  {
    code: "03-033",
    city: "Warszawa",
  },
  {
    code: "03-034",
    city: "Warszawa",
  },
  {
    code: "03-035",
    city: "Warszawa",
  },
  {
    code: "03-036",
    city: "Warszawa",
  },
  {
    code: "03-037",
    city: "Warszawa",
  },
  {
    code: "03-041",
    city: "Warszawa",
  },
  {
    code: "03-042",
    city: "Warszawa",
  },
  {
    code: "03-044",
    city: "Warszawa",
  },
  {
    code: "03-046",
    city: "Warszawa",
  },
  {
    code: "03-050",
    city: "Warszawa",
  },
  {
    code: "03-051",
    city: "Warszawa",
  },
  {
    code: "03-052",
    city: "Warszawa",
  },
  {
    code: "03-053",
    city: "Warszawa",
  },
  {
    code: "03-054",
    city: "Warszawa",
  },
  {
    code: "03-055",
    city: "Warszawa",
  },
  {
    code: "03-059",
    city: "Warszawa",
  },
  {
    code: "03-061",
    city: "Warszawa",
  },
  {
    code: "03-062",
    city: "Warszawa",
  },
  {
    code: "03-063",
    city: "Warszawa",
  },
  {
    code: "03-064",
    city: "Warszawa",
  },
  {
    code: "03-068",
    city: "Warszawa",
  },
  {
    code: "03-069",
    city: "Warszawa",
  },
  {
    code: "03-071",
    city: "Warszawa",
  },
  {
    code: "03-074",
    city: "Warszawa",
  },
  {
    code: "03-075",
    city: "Warszawa",
  },
  {
    code: "03-076",
    city: "Warszawa",
  },
  {
    code: "03-077",
    city: "Warszawa",
  },
  {
    code: "03-079",
    city: "Warszawa",
  },
  {
    code: "03-081",
    city: "Warszawa",
  },
  {
    code: "03-082",
    city: "Warszawa",
  },
  {
    code: "03-083",
    city: "Warszawa",
  },
  {
    code: "03-085",
    city: "Warszawa",
  },
  {
    code: "03-087",
    city: "Warszawa",
  },
  {
    code: "03-088",
    city: "Warszawa",
  },
  {
    code: "03-089",
    city: "Warszawa",
  },
  {
    code: "03-090",
    city: "Warszawa",
  },
  {
    code: "03-092",
    city: "Warszawa",
  },
  {
    code: "03-093",
    city: "Warszawa",
  },
  {
    code: "03-100",
    city: "Warszawa",
  },
  {
    code: "03-101",
    city: "Warszawa",
  },
  {
    code: "03-102",
    city: "Warszawa",
  },
  {
    code: "03-103",
    city: "Warszawa",
  },
  {
    code: "03-104",
    city: "Warszawa",
  },
  {
    code: "03-105",
    city: "Warszawa",
  },
  {
    code: "03-106",
    city: "Warszawa",
  },
  {
    code: "03-107",
    city: "Warszawa",
  },
  {
    code: "03-108",
    city: "Warszawa",
  },
  {
    code: "03-109",
    city: "Warszawa",
  },
  {
    code: "03-110",
    city: "Warszawa",
  },
  {
    code: "03-111",
    city: "Warszawa",
  },
  {
    code: "03-112",
    city: "Warszawa",
  },
  {
    code: "03-113",
    city: "Warszawa",
  },
  {
    code: "03-114",
    city: "Warszawa",
  },
  {
    code: "03-115",
    city: "Warszawa",
  },
  {
    code: "03-116",
    city: "Warszawa",
  },
  {
    code: "03-117",
    city: "Warszawa",
  },
  {
    code: "03-118",
    city: "Warszawa",
  },
  {
    code: "03-119",
    city: "Warszawa",
  },
  {
    code: "03-120",
    city: "Warszawa",
  },
  {
    code: "03-122",
    city: "Warszawa",
  },
  {
    code: "03-123",
    city: "Warszawa",
  },
  {
    code: "03-125",
    city: "Warszawa",
  },
  {
    code: "03-126",
    city: "Warszawa",
  },
  {
    code: "03-127",
    city: "Warszawa",
  },
  {
    code: "03-128",
    city: "Warszawa",
  },
  {
    code: "03-129",
    city: "Warszawa",
  },
  {
    code: "03-130",
    city: "Warszawa",
  },
  {
    code: "03-131",
    city: "Warszawa",
  },
  {
    code: "03-133",
    city: "Warszawa",
  },
  {
    code: "03-134",
    city: "Warszawa",
  },
  {
    code: "03-135",
    city: "Warszawa",
  },
  {
    code: "03-136",
    city: "Warszawa",
  },
  {
    code: "03-137",
    city: "Warszawa",
  },
  {
    code: "03-138",
    city: "Warszawa",
  },
  {
    code: "03-139",
    city: "Warszawa",
  },
  {
    code: "03-140",
    city: "Warszawa",
  },
  {
    code: "03-141",
    city: "Warszawa",
  },
  {
    code: "03-142",
    city: "Warszawa",
  },
  {
    code: "03-143",
    city: "Warszawa",
  },
  {
    code: "03-144",
    city: "Warszawa",
  },
  {
    code: "03-145",
    city: "Warszawa",
  },
  {
    code: "03-146",
    city: "Warszawa",
  },
  {
    code: "03-147",
    city: "Warszawa",
  },
  {
    code: "03-148",
    city: "Warszawa",
  },
  {
    code: "03-149",
    city: "Warszawa",
  },
  {
    code: "03-151",
    city: "Warszawa",
  },
  {
    code: "03-152",
    city: "Warszawa",
  },
  {
    code: "03-153",
    city: "Warszawa",
  },
  {
    code: "03-154",
    city: "Warszawa",
  },
  {
    code: "03-155",
    city: "Warszawa",
  },
  {
    code: "03-156",
    city: "Warszawa",
  },
  {
    code: "03-157",
    city: "Warszawa",
  },
  {
    code: "03-158",
    city: "Warszawa",
  },
  {
    code: "03-159",
    city: "Warszawa",
  },
  {
    code: "03-160",
    city: "Warszawa",
  },
  {
    code: "03-161",
    city: "Warszawa",
  },
  {
    code: "03-162",
    city: "Warszawa",
  },
  {
    code: "03-163",
    city: "Warszawa",
  },
  {
    code: "03-164",
    city: "Warszawa",
  },
  {
    code: "03-165",
    city: "Warszawa",
  },
  {
    code: "03-166",
    city: "Warszawa",
  },
  {
    code: "03-167",
    city: "Warszawa",
  },
  {
    code: "03-168",
    city: "Warszawa",
  },
  {
    code: "03-170",
    city: "Warszawa",
  },
  {
    code: "03-171",
    city: "Warszawa",
  },
  {
    code: "03-172",
    city: "Warszawa",
  },
  {
    code: "03-173",
    city: "Warszawa",
  },
  {
    code: "03-174",
    city: "Warszawa",
  },
  {
    code: "03-175",
    city: "Warszawa",
  },
  {
    code: "03-176",
    city: "Warszawa",
  },
  {
    code: "03-178",
    city: "Warszawa",
  },
  {
    code: "03-179",
    city: "Warszawa",
  },
  {
    code: "03-180",
    city: "Warszawa",
  },
  {
    code: "03-181",
    city: "Warszawa",
  },
  {
    code: "03-182",
    city: "Warszawa",
  },
  {
    code: "03-183",
    city: "Warszawa",
  },
  {
    code: "03-184",
    city: "Warszawa",
  },
  {
    code: "03-185",
    city: "Warszawa",
  },
  {
    code: "03-186",
    city: "Warszawa",
  },
  {
    code: "03-187",
    city: "Warszawa",
  },
  {
    code: "03-188",
    city: "Warszawa",
  },
  {
    code: "03-189",
    city: "Warszawa",
  },
  {
    code: "03-190",
    city: "Warszawa",
  },
  {
    code: "03-191",
    city: "Warszawa",
  },
  {
    code: "03-192",
    city: "Warszawa",
  },
  {
    code: "03-193",
    city: "Warszawa",
  },
  {
    code: "03-194",
    city: "Warszawa",
  },
  {
    code: "03-195",
    city: "Warszawa",
  },
  {
    code: "03-196",
    city: "Warszawa",
  },
  {
    code: "03-197",
    city: "Warszawa",
  },
  {
    code: "03-198",
    city: "Warszawa",
  },
  {
    code: "03-199",
    city: "Warszawa",
  },
  {
    code: "03-200",
    city: "Warszawa",
  },
  {
    code: "03-201",
    city: "Warszawa",
  },
  {
    code: "03-202",
    city: "Warszawa",
  },
  {
    code: "03-203",
    city: "Warszawa",
  },
  {
    code: "03-204",
    city: "Warszawa",
  },
  {
    code: "03-206",
    city: "Warszawa",
  },
  {
    code: "03-207",
    city: "Warszawa",
  },
  {
    code: "03-208",
    city: "Warszawa",
  },
  {
    code: "03-209",
    city: "Warszawa",
  },
  {
    code: "03-213",
    city: "Warszawa",
  },
  {
    code: "03-214",
    city: "Warszawa",
  },
  {
    code: "03-215",
    city: "Warszawa",
  },
  {
    code: "03-216",
    city: "Warszawa",
  },
  {
    code: "03-219",
    city: "Warszawa",
  },
  {
    code: "03-226",
    city: "Warszawa",
  },
  {
    code: "03-228",
    city: "Warszawa",
  },
  {
    code: "03-230",
    city: "Warszawa",
  },
  {
    code: "03-231",
    city: "Warszawa",
  },
  {
    code: "03-233",
    city: "Warszawa",
  },
  {
    code: "03-236",
    city: "Warszawa",
  },
  {
    code: "03-237",
    city: "Warszawa",
  },
  {
    code: "03-238",
    city: "Warszawa",
  },
  {
    code: "03-239",
    city: "Warszawa",
  },
  {
    code: "03-241",
    city: "Warszawa",
  },
  {
    code: "03-242",
    city: "Warszawa",
  },
  {
    code: "03-243",
    city: "Warszawa",
  },
  {
    code: "03-244",
    city: "Warszawa",
  },
  {
    code: "03-246",
    city: "Warszawa",
  },
  {
    code: "03-249",
    city: "Warszawa",
  },
  {
    code: "03-251",
    city: "Warszawa",
  },
  {
    code: "03-252",
    city: "Warszawa",
  },
  {
    code: "03-253",
    city: "Warszawa",
  },
  {
    code: "03-254",
    city: "Warszawa",
  },
  {
    code: "03-255",
    city: "Warszawa",
  },
  {
    code: "03-256",
    city: "Warszawa",
  },
  {
    code: "03-257",
    city: "Warszawa",
  },
  {
    code: "03-259",
    city: "Warszawa",
  },
  {
    code: "03-260",
    city: "Warszawa",
  },
  {
    code: "03-262",
    city: "Warszawa",
  },
  {
    code: "03-264",
    city: "Warszawa",
  },
  {
    code: "03-265",
    city: "Warszawa",
  },
  {
    code: "03-266",
    city: "Warszawa",
  },
  {
    code: "03-267",
    city: "Warszawa",
  },
  {
    code: "03-270",
    city: "Warszawa",
  },
  {
    code: "03-272",
    city: "Warszawa",
  },
  {
    code: "03-274",
    city: "Warszawa",
  },
  {
    code: "03-276",
    city: "Warszawa",
  },
  {
    code: "03-279",
    city: "Warszawa",
  },
  {
    code: "03-281",
    city: "Warszawa",
  },
  {
    code: "03-284",
    city: "Warszawa",
  },
  {
    code: "03-285",
    city: "Warszawa",
  },
  {
    code: "03-286",
    city: "Warszawa",
  },
  {
    code: "03-287",
    city: "Warszawa",
  },
  {
    code: "03-288",
    city: "Warszawa",
  },
  {
    code: "03-289",
    city: "Warszawa",
  },
  {
    code: "03-290",
    city: "Warszawa",
  },
  {
    code: "03-291",
    city: "Warszawa",
  },
  {
    code: "03-295",
    city: "Warszawa",
  },
  {
    code: "03-299",
    city: "Warszawa",
  },
  {
    code: "03-301",
    city: "Warszawa",
  },
  {
    code: "03-302",
    city: "Warszawa",
  },
  {
    code: "03-303",
    city: "Warszawa",
  },
  {
    code: "03-305",
    city: "Warszawa",
  },
  {
    code: "03-307",
    city: "Warszawa",
  },
  {
    code: "03-308",
    city: "Warszawa",
  },
  {
    code: "03-309",
    city: "Warszawa",
  },
  {
    code: "03-310",
    city: "Warszawa",
  },
  {
    code: "03-312",
    city: "Warszawa",
  },
  {
    code: "03-314",
    city: "Warszawa",
  },
  {
    code: "03-315",
    city: "Warszawa",
  },
  {
    code: "03-316",
    city: "Warszawa",
  },
  {
    code: "03-317",
    city: "Warszawa",
  },
  {
    code: "03-318",
    city: "Warszawa",
  },
  {
    code: "03-320",
    city: "Warszawa",
  },
  {
    code: "03-321",
    city: "Warszawa",
  },
  {
    code: "03-322",
    city: "Warszawa",
  },
  {
    code: "03-324",
    city: "Warszawa",
  },
  {
    code: "03-325",
    city: "Warszawa",
  },
  {
    code: "03-329",
    city: "Warszawa",
  },
  {
    code: "03-331",
    city: "Warszawa",
  },
  {
    code: "03-332",
    city: "Warszawa",
  },
  {
    code: "03-333",
    city: "Warszawa",
  },
  {
    code: "03-334",
    city: "Warszawa",
  },
  {
    code: "03-335",
    city: "Warszawa",
  },
  {
    code: "03-337",
    city: "Warszawa",
  },
  {
    code: "03-338",
    city: "Warszawa",
  },
  {
    code: "03-340",
    city: "Warszawa",
  },
  {
    code: "03-341",
    city: "Warszawa",
  },
  {
    code: "03-343",
    city: "Warszawa",
  },
  {
    code: "03-345",
    city: "Warszawa",
  },
  {
    code: "03-346",
    city: "Warszawa",
  },
  {
    code: "03-347",
    city: "Warszawa",
  },
  {
    code: "03-348",
    city: "Warszawa",
  },
  {
    code: "03-349",
    city: "Warszawa",
  },
  {
    code: "03-350",
    city: "Warszawa",
  },
  {
    code: "03-352",
    city: "Warszawa",
  },
  {
    code: "03-353",
    city: "Warszawa",
  },
  {
    code: "03-355",
    city: "Warszawa",
  },
  {
    code: "03-356",
    city: "Warszawa",
  },
  {
    code: "03-357",
    city: "Warszawa",
  },
  {
    code: "03-358",
    city: "Warszawa",
  },
  {
    code: "03-359",
    city: "Warszawa",
  },
  {
    code: "03-360",
    city: "Warszawa",
  },
  {
    code: "03-361",
    city: "Warszawa",
  },
  {
    code: "03-362",
    city: "Warszawa",
  },
  {
    code: "03-363",
    city: "Warszawa",
  },
  {
    code: "03-365",
    city: "Warszawa",
  },
  {
    code: "03-367",
    city: "Warszawa",
  },
  {
    code: "03-368",
    city: "Warszawa",
  },
  {
    code: "03-369",
    city: "Warszawa",
  },
  {
    code: "03-370",
    city: "Warszawa",
  },
  {
    code: "03-371",
    city: "Warszawa",
  },
  {
    code: "03-372",
    city: "Warszawa",
  },
  {
    code: "03-373",
    city: "Warszawa",
  },
  {
    code: "03-374",
    city: "Warszawa",
  },
  {
    code: "03-375",
    city: "Warszawa",
  },
  {
    code: "03-376",
    city: "Warszawa",
  },
  {
    code: "03-377",
    city: "Warszawa",
  },
  {
    code: "03-378",
    city: "Warszawa",
  },
  {
    code: "03-379",
    city: "Warszawa",
  },
  {
    code: "03-380",
    city: "Warszawa",
  },
  {
    code: "03-381",
    city: "Warszawa",
  },
  {
    code: "03-382",
    city: "Warszawa",
  },
  {
    code: "03-383",
    city: "Warszawa",
  },
  {
    code: "03-384",
    city: "Warszawa",
  },
  {
    code: "03-385",
    city: "Warszawa",
  },
  {
    code: "03-387",
    city: "Warszawa",
  },
  {
    code: "03-388",
    city: "Warszawa",
  },
  {
    code: "03-390",
    city: "Warszawa",
  },
  {
    code: "03-391",
    city: "Warszawa",
  },
  {
    code: "03-392",
    city: "Warszawa",
  },
  {
    code: "03-393",
    city: "Warszawa",
  },
  {
    code: "03-394",
    city: "Warszawa",
  },
  {
    code: "03-395",
    city: "Warszawa",
  },
  {
    code: "03-396",
    city: "Warszawa",
  },
  {
    code: "03-397",
    city: "Warszawa",
  },
  {
    code: "03-401",
    city: "Warszawa",
  },
  {
    code: "03-402",
    city: "Warszawa",
  },
  {
    code: "03-403",
    city: "Warszawa",
  },
  {
    code: "03-404",
    city: "Warszawa",
  },
  {
    code: "03-405",
    city: "Warszawa",
  },
  {
    code: "03-406",
    city: "Warszawa",
  },
  {
    code: "03-407",
    city: "Warszawa",
  },
  {
    code: "03-408",
    city: "Warszawa",
  },
  {
    code: "03-409",
    city: "Warszawa",
  },
  {
    code: "03-410",
    city: "Warszawa",
  },
  {
    code: "03-411",
    city: "Warszawa",
  },
  {
    code: "03-412",
    city: "Warszawa",
  },
  {
    code: "03-414",
    city: "Warszawa",
  },
  {
    code: "03-415",
    city: "Warszawa",
  },
  {
    code: "03-416",
    city: "Warszawa",
  },
  {
    code: "03-417",
    city: "Warszawa",
  },
  {
    code: "03-418",
    city: "Warszawa",
  },
  {
    code: "03-419",
    city: "Warszawa",
  },
  {
    code: "03-420",
    city: "Warszawa",
  },
  {
    code: "03-421",
    city: "Warszawa",
  },
  {
    code: "03-422",
    city: "Warszawa",
  },
  {
    code: "03-423",
    city: "Warszawa",
  },
  {
    code: "03-424",
    city: "Warszawa",
  },
  {
    code: "03-425",
    city: "Warszawa",
  },
  {
    code: "03-426",
    city: "Warszawa",
  },
  {
    code: "03-427",
    city: "Warszawa",
  },
  {
    code: "03-428",
    city: "Warszawa",
  },
  {
    code: "03-429",
    city: "Warszawa",
  },
  {
    code: "03-430",
    city: "Warszawa",
  },
  {
    code: "03-431",
    city: "Warszawa",
  },
  {
    code: "03-432",
    city: "Warszawa",
  },
  {
    code: "03-433",
    city: "Warszawa",
  },
  {
    code: "03-435",
    city: "Warszawa",
  },
  {
    code: "03-436",
    city: "Warszawa",
  },
  {
    code: "03-437",
    city: "Warszawa",
  },
  {
    code: "03-438",
    city: "Warszawa",
  },
  {
    code: "03-439",
    city: "Warszawa",
  },
  {
    code: "03-440",
    city: "Warszawa",
  },
  {
    code: "03-441",
    city: "Warszawa",
  },
  {
    code: "03-442",
    city: "Warszawa",
  },
  {
    code: "03-443",
    city: "Warszawa",
  },
  {
    code: "03-444",
    city: "Warszawa",
  },
  {
    code: "03-445",
    city: "Warszawa",
  },
  {
    code: "03-446",
    city: "Warszawa",
  },
  {
    code: "03-447",
    city: "Warszawa",
  },
  {
    code: "03-448",
    city: "Warszawa",
  },
  {
    code: "03-450",
    city: "Warszawa",
  },
  {
    code: "03-451",
    city: "Warszawa",
  },
  {
    code: "03-452",
    city: "Warszawa",
  },
  {
    code: "03-453",
    city: "Warszawa",
  },
  {
    code: "03-454",
    city: "Warszawa",
  },
  {
    code: "03-455",
    city: "Warszawa",
  },
  {
    code: "03-456",
    city: "Warszawa",
  },
  {
    code: "03-458",
    city: "Warszawa",
  },
  {
    code: "03-459",
    city: "Warszawa",
  },
  {
    code: "03-460",
    city: "Warszawa",
  },
  {
    code: "03-461",
    city: "Warszawa",
  },
  {
    code: "03-462",
    city: "Warszawa",
  },
  {
    code: "03-463",
    city: "Warszawa",
  },
  {
    code: "03-464",
    city: "Warszawa",
  },
  {
    code: "03-465",
    city: "Warszawa",
  },
  {
    code: "03-468",
    city: "Warszawa",
  },
  {
    code: "03-469",
    city: "Warszawa",
  },
  {
    code: "03-470",
    city: "Warszawa",
  },
  {
    code: "03-471",
    city: "Warszawa",
  },
  {
    code: "03-472",
    city: "Warszawa",
  },
  {
    code: "03-473",
    city: "Warszawa",
  },
  {
    code: "03-474",
    city: "Warszawa",
  },
  {
    code: "03-475",
    city: "Warszawa",
  },
  {
    code: "03-476",
    city: "Warszawa",
  },
  {
    code: "03-477",
    city: "Warszawa",
  },
  {
    code: "03-478",
    city: "Warszawa",
  },
  {
    code: "03-480",
    city: "Warszawa",
  },
  {
    code: "03-481",
    city: "Warszawa",
  },
  {
    code: "03-482",
    city: "Warszawa",
  },
  {
    code: "03-483",
    city: "Warszawa",
  },
  {
    code: "03-484",
    city: "Warszawa",
  },
  {
    code: "03-485",
    city: "Warszawa",
  },
  {
    code: "03-486",
    city: "Warszawa",
  },
  {
    code: "03-488",
    city: "Warszawa",
  },
  {
    code: "03-489",
    city: "Warszawa",
  },
  {
    code: "03-490",
    city: "Warszawa",
  },
  {
    code: "03-501",
    city: "Warszawa",
  },
  {
    code: "03-502",
    city: "Warszawa",
  },
  {
    code: "03-503",
    city: "Warszawa",
  },
  {
    code: "03-504",
    city: "Warszawa",
  },
  {
    code: "03-505",
    city: "Warszawa",
  },
  {
    code: "03-506",
    city: "Warszawa",
  },
  {
    code: "03-507",
    city: "Warszawa",
  },
  {
    code: "03-509",
    city: "Warszawa",
  },
  {
    code: "03-510",
    city: "Warszawa",
  },
  {
    code: "03-511",
    city: "Warszawa",
  },
  {
    code: "03-512",
    city: "Warszawa",
  },
  {
    code: "03-514",
    city: "Warszawa",
  },
  {
    code: "03-515",
    city: "Warszawa",
  },
  {
    code: "03-516",
    city: "Warszawa",
  },
  {
    code: "03-517",
    city: "Warszawa",
  },
  {
    code: "03-518",
    city: "Warszawa",
  },
  {
    code: "03-519",
    city: "Warszawa",
  },
  {
    code: "03-521",
    city: "Warszawa",
  },
  {
    code: "03-522",
    city: "Warszawa",
  },
  {
    code: "03-523",
    city: "Warszawa",
  },
  {
    code: "03-524",
    city: "Warszawa",
  },
  {
    code: "03-525",
    city: "Warszawa",
  },
  {
    code: "03-526",
    city: "Warszawa",
  },
  {
    code: "03-527",
    city: "Warszawa",
  },
  {
    code: "03-528",
    city: "Warszawa",
  },
  {
    code: "03-529",
    city: "Warszawa",
  },
  {
    code: "03-530",
    city: "Warszawa",
  },
  {
    code: "03-531",
    city: "Warszawa",
  },
  {
    code: "03-532",
    city: "Warszawa",
  },
  {
    code: "03-533",
    city: "Warszawa",
  },
  {
    code: "03-534",
    city: "Warszawa",
  },
  {
    code: "03-535",
    city: "Warszawa",
  },
  {
    code: "03-536",
    city: "Warszawa",
  },
  {
    code: "03-538",
    city: "Warszawa",
  },
  {
    code: "03-539",
    city: "Warszawa",
  },
  {
    code: "03-540",
    city: "Warszawa",
  },
  {
    code: "03-541",
    city: "Warszawa",
  },
  {
    code: "03-542",
    city: "Warszawa",
  },
  {
    code: "03-543",
    city: "Warszawa",
  },
  {
    code: "03-544",
    city: "Warszawa",
  },
  {
    code: "03-545",
    city: "Warszawa",
  },
  {
    code: "03-546",
    city: "Warszawa",
  },
  {
    code: "03-547",
    city: "Warszawa",
  },
  {
    code: "03-548",
    city: "Warszawa",
  },
  {
    code: "03-549",
    city: "Warszawa",
  },
  {
    code: "03-550",
    city: "Warszawa",
  },
  {
    code: "03-551",
    city: "Warszawa",
  },
  {
    code: "03-552",
    city: "Warszawa",
  },
  {
    code: "03-553",
    city: "Warszawa",
  },
  {
    code: "03-554",
    city: "Warszawa",
  },
  {
    code: "03-556",
    city: "Warszawa",
  },
  {
    code: "03-557",
    city: "Warszawa",
  },
  {
    code: "03-558",
    city: "Warszawa",
  },
  {
    code: "03-560",
    city: "Warszawa",
  },
  {
    code: "03-561",
    city: "Warszawa",
  },
  {
    code: "03-562",
    city: "Warszawa",
  },
  {
    code: "03-563",
    city: "Warszawa",
  },
  {
    code: "03-564",
    city: "Warszawa",
  },
  {
    code: "03-565",
    city: "Warszawa",
  },
  {
    code: "03-566",
    city: "Warszawa",
  },
  {
    code: "03-567",
    city: "Warszawa",
  },
  {
    code: "03-569",
    city: "Warszawa",
  },
  {
    code: "03-571",
    city: "Warszawa",
  },
  {
    code: "03-572",
    city: "Warszawa",
  },
  {
    code: "03-573",
    city: "Warszawa",
  },
  {
    code: "03-574",
    city: "Warszawa",
  },
  {
    code: "03-575",
    city: "Warszawa",
  },
  {
    code: "03-576",
    city: "Warszawa",
  },
  {
    code: "03-577",
    city: "Warszawa",
  },
  {
    code: "03-578",
    city: "Warszawa",
  },
  {
    code: "03-579",
    city: "Warszawa",
  },
  {
    code: "03-580",
    city: "Warszawa",
  },
  {
    code: "03-581",
    city: "Warszawa",
  },
  {
    code: "03-582",
    city: "Warszawa",
  },
  {
    code: "03-583",
    city: "Warszawa",
  },
  {
    code: "03-584",
    city: "Warszawa",
  },
  {
    code: "03-585",
    city: "Warszawa",
  },
  {
    code: "03-586",
    city: "Warszawa",
  },
  {
    code: "03-587",
    city: "Warszawa",
  },
  {
    code: "03-588",
    city: "Warszawa",
  },
  {
    code: "03-589",
    city: "Warszawa",
  },
  {
    code: "03-590",
    city: "Warszawa",
  },
  {
    code: "03-592",
    city: "Warszawa",
  },
  {
    code: "03-593",
    city: "Warszawa",
  },
  {
    code: "03-594",
    city: "Warszawa",
  },
  {
    code: "03-595",
    city: "Warszawa",
  },
  {
    code: "03-596",
    city: "Warszawa",
  },
  {
    code: "03-597",
    city: "Warszawa",
  },
  {
    code: "03-598",
    city: "Warszawa",
  },
  {
    code: "03-599",
    city: "Warszawa",
  },
  {
    code: "03-601",
    city: "Warszawa",
  },
  {
    code: "03-602",
    city: "Warszawa",
  },
  {
    code: "03-603",
    city: "Warszawa",
  },
  {
    code: "03-604",
    city: "Warszawa",
  },
  {
    code: "03-605",
    city: "Warszawa",
  },
  {
    code: "03-606",
    city: "Warszawa",
  },
  {
    code: "03-607",
    city: "Warszawa",
  },
  {
    code: "03-608",
    city: "Warszawa",
  },
  {
    code: "03-609",
    city: "Warszawa",
  },
  {
    code: "03-610",
    city: "Warszawa",
  },
  {
    code: "03-611",
    city: "Warszawa",
  },
  {
    code: "03-612",
    city: "Warszawa",
  },
  {
    code: "03-613",
    city: "Warszawa",
  },
  {
    code: "03-614",
    city: "Warszawa",
  },
  {
    code: "03-616",
    city: "Warszawa",
  },
  {
    code: "03-617",
    city: "Warszawa",
  },
  {
    code: "03-618",
    city: "Warszawa",
  },
  {
    code: "03-619",
    city: "Warszawa",
  },
  {
    code: "03-620",
    city: "Warszawa",
  },
  {
    code: "03-621",
    city: "Warszawa",
  },
  {
    code: "03-622",
    city: "Warszawa",
  },
  {
    code: "03-623",
    city: "Warszawa",
  },
  {
    code: "03-624",
    city: "Warszawa",
  },
  {
    code: "03-625",
    city: "Warszawa",
  },
  {
    code: "03-626",
    city: "Warszawa",
  },
  {
    code: "03-627",
    city: "Warszawa",
  },
  {
    code: "03-628",
    city: "Warszawa",
  },
  {
    code: "03-629",
    city: "Warszawa",
  },
  {
    code: "03-630",
    city: "Warszawa",
  },
  {
    code: "03-631",
    city: "Warszawa",
  },
  {
    code: "03-632",
    city: "Warszawa",
  },
  {
    code: "03-633",
    city: "Warszawa",
  },
  {
    code: "03-634",
    city: "Warszawa",
  },
  {
    code: "03-636",
    city: "Warszawa",
  },
  {
    code: "03-637",
    city: "Warszawa",
  },
  {
    code: "03-638",
    city: "Warszawa",
  },
  {
    code: "03-639",
    city: "Warszawa",
  },
  {
    code: "03-640",
    city: "Warszawa",
  },
  {
    code: "03-641",
    city: "Warszawa",
  },
  {
    code: "03-642",
    city: "Warszawa",
  },
  {
    code: "03-643",
    city: "Warszawa",
  },
  {
    code: "03-644",
    city: "Warszawa",
  },
  {
    code: "03-645",
    city: "Warszawa",
  },
  {
    code: "03-646",
    city: "Warszawa",
  },
  {
    code: "03-647",
    city: "Warszawa",
  },
  {
    code: "03-648",
    city: "Warszawa",
  },
  {
    code: "03-649",
    city: "Warszawa",
  },
  {
    code: "03-650",
    city: "Warszawa",
  },
  {
    code: "03-652",
    city: "Warszawa",
  },
  {
    code: "03-653",
    city: "Warszawa",
  },
  {
    code: "03-654",
    city: "Warszawa",
  },
  {
    code: "03-655",
    city: "Warszawa",
  },
  {
    code: "03-656",
    city: "Warszawa",
  },
  {
    code: "03-657",
    city: "Warszawa",
  },
  {
    code: "03-658",
    city: "Warszawa",
  },
  {
    code: "03-659",
    city: "Warszawa",
  },
  {
    code: "03-660",
    city: "Warszawa",
  },
  {
    code: "03-661",
    city: "Warszawa",
  },
  {
    code: "03-662",
    city: "Warszawa",
  },
  {
    code: "03-663",
    city: "Warszawa",
  },
  {
    code: "03-664",
    city: "Warszawa",
  },
  {
    code: "03-665",
    city: "Warszawa",
  },
  {
    code: "03-666",
    city: "Warszawa",
  },
  {
    code: "03-667",
    city: "Warszawa",
  },
  {
    code: "03-668",
    city: "Warszawa",
  },
  {
    code: "03-671",
    city: "Warszawa",
  },
  {
    code: "03-672",
    city: "Warszawa",
  },
  {
    code: "03-673",
    city: "Warszawa",
  },
  {
    code: "03-674",
    city: "Warszawa",
  },
  {
    code: "03-675",
    city: "Warszawa",
  },
  {
    code: "03-676",
    city: "Warszawa",
  },
  {
    code: "03-677",
    city: "Warszawa",
  },
  {
    code: "03-678",
    city: "Warszawa",
  },
  {
    code: "03-679",
    city: "Warszawa",
  },
  {
    code: "03-680",
    city: "Warszawa",
  },
  {
    code: "03-681",
    city: "Warszawa",
  },
  {
    code: "03-682",
    city: "Warszawa",
  },
  {
    code: "03-683",
    city: "Warszawa",
  },
  {
    code: "03-684",
    city: "Warszawa",
  },
  {
    code: "03-685",
    city: "Warszawa",
  },
  {
    code: "03-686",
    city: "Warszawa",
  },
  {
    code: "03-687",
    city: "Warszawa",
  },
  {
    code: "03-688",
    city: "Warszawa",
  },
  {
    code: "03-689",
    city: "Warszawa",
  },
  {
    code: "03-690",
    city: "Warszawa",
  },
  {
    code: "03-691",
    city: "Warszawa",
  },
  {
    code: "03-692",
    city: "Warszawa",
  },
  {
    code: "03-693",
    city: "Warszawa",
  },
  {
    code: "03-694",
    city: "Warszawa",
  },
  {
    code: "03-695",
    city: "Warszawa",
  },
  {
    code: "03-696",
    city: "Warszawa",
  },
  {
    code: "03-697",
    city: "Warszawa",
  },
  {
    code: "03-698",
    city: "Warszawa",
  },
  {
    code: "03-699",
    city: "Warszawa",
  },
  {
    code: "03-700",
    city: "Warszawa",
  },
  {
    code: "03-701",
    city: "Warszawa",
  },
  {
    code: "03-703",
    city: "Warszawa",
  },
  {
    code: "03-704",
    city: "Warszawa",
  },
  {
    code: "03-705",
    city: "Warszawa",
  },
  {
    code: "03-707",
    city: "Warszawa",
  },
  {
    code: "03-708",
    city: "Warszawa",
  },
  {
    code: "03-709",
    city: "Warszawa",
  },
  {
    code: "03-710",
    city: "Warszawa",
  },
  {
    code: "03-711",
    city: "Warszawa",
  },
  {
    code: "03-712",
    city: "Warszawa",
  },
  {
    code: "03-713",
    city: "Warszawa",
  },
  {
    code: "03-714",
    city: "Warszawa",
  },
  {
    code: "03-715",
    city: "Warszawa",
  },
  {
    code: "03-716",
    city: "Warszawa",
  },
  {
    code: "03-717",
    city: "Warszawa",
  },
  {
    code: "03-718",
    city: "Warszawa",
  },
  {
    code: "03-719",
    city: "Warszawa",
  },
  {
    code: "03-720",
    city: "Warszawa",
  },
  {
    code: "03-721",
    city: "Warszawa",
  },
  {
    code: "03-722",
    city: "Warszawa",
  },
  {
    code: "03-724",
    city: "Warszawa",
  },
  {
    code: "03-725",
    city: "Warszawa",
  },
  {
    code: "03-726",
    city: "Warszawa",
  },
  {
    code: "03-727",
    city: "Warszawa",
  },
  {
    code: "03-728",
    city: "Warszawa",
  },
  {
    code: "03-729",
    city: "Warszawa",
  },
  {
    code: "03-730",
    city: "Warszawa",
  },
  {
    code: "03-731",
    city: "Warszawa",
  },
  {
    code: "03-732",
    city: "Warszawa",
  },
  {
    code: "03-733",
    city: "Warszawa",
  },
  {
    code: "03-734",
    city: "Warszawa",
  },
  {
    code: "03-735",
    city: "Warszawa",
  },
  {
    code: "03-736",
    city: "Warszawa",
  },
  {
    code: "03-737",
    city: "Warszawa",
  },
  {
    code: "03-738",
    city: "Warszawa",
  },
  {
    code: "03-739",
    city: "Warszawa",
  },
  {
    code: "03-740",
    city: "Warszawa",
  },
  {
    code: "03-741",
    city: "Warszawa",
  },
  {
    code: "03-742",
    city: "Warszawa",
  },
  {
    code: "03-743",
    city: "Warszawa",
  },
  {
    code: "03-744",
    city: "Warszawa",
  },
  {
    code: "03-745",
    city: "Warszawa",
  },
  {
    code: "03-746",
    city: "Warszawa",
  },
  {
    code: "03-747",
    city: "Warszawa",
  },
  {
    code: "03-748",
    city: "Warszawa",
  },
  {
    code: "03-749",
    city: "Warszawa",
  },
  {
    code: "03-750",
    city: "Warszawa",
  },
  {
    code: "03-751",
    city: "Warszawa",
  },
  {
    code: "03-752",
    city: "Warszawa",
  },
  {
    code: "03-753",
    city: "Warszawa",
  },
  {
    code: "03-754",
    city: "Warszawa",
  },
  {
    code: "03-755",
    city: "Warszawa",
  },
  {
    code: "03-756",
    city: "Warszawa",
  },
  {
    code: "03-757",
    city: "Warszawa",
  },
  {
    code: "03-758",
    city: "Warszawa",
  },
  {
    code: "03-759",
    city: "Warszawa",
  },
  {
    code: "03-761",
    city: "Warszawa",
  },
  {
    code: "03-762",
    city: "Warszawa",
  },
  {
    code: "03-763",
    city: "Warszawa",
  },
  {
    code: "03-764",
    city: "Warszawa",
  },
  {
    code: "03-766",
    city: "Warszawa",
  },
  {
    code: "03-767",
    city: "Warszawa",
  },
  {
    code: "03-768",
    city: "Warszawa",
  },
  {
    code: "03-769",
    city: "Warszawa",
  },
  {
    code: "03-770",
    city: "Warszawa",
  },
  {
    code: "03-771",
    city: "Warszawa",
  },
  {
    code: "03-772",
    city: "Warszawa",
  },
  {
    code: "03-774",
    city: "Warszawa",
  },
  {
    code: "03-775",
    city: "Warszawa",
  },
  {
    code: "03-778",
    city: "Warszawa",
  },
  {
    code: "03-779",
    city: "Warszawa",
  },
  {
    code: "03-780",
    city: "Warszawa",
  },
  {
    code: "03-781",
    city: "Warszawa",
  },
  {
    code: "03-782",
    city: "Warszawa",
  },
  {
    code: "03-784",
    city: "Warszawa",
  },
  {
    code: "03-785",
    city: "Warszawa",
  },
  {
    code: "03-786",
    city: "Warszawa",
  },
  {
    code: "03-787",
    city: "Warszawa",
  },
  {
    code: "03-788",
    city: "Warszawa",
  },
  {
    code: "03-789",
    city: "Warszawa",
  },
  {
    code: "03-790",
    city: "Warszawa",
  },
  {
    code: "03-791",
    city: "Warszawa",
  },
  {
    code: "03-792",
    city: "Warszawa",
  },
  {
    code: "03-793",
    city: "Warszawa",
  },
  {
    code: "03-794",
    city: "Warszawa",
  },
  {
    code: "03-795",
    city: "Warszawa",
  },
  {
    code: "03-796",
    city: "Warszawa",
  },
  {
    code: "03-797",
    city: "Warszawa",
  },
  {
    code: "03-798",
    city: "Warszawa",
  },
  {
    code: "03-799",
    city: "Warszawa",
  },
  {
    code: "03-801",
    city: "Warszawa",
  },
  {
    code: "03-802",
    city: "Warszawa",
  },
  {
    code: "03-803",
    city: "Warszawa",
  },
  {
    code: "03-804",
    city: "Warszawa",
  },
  {
    code: "03-805",
    city: "Warszawa",
  },
  {
    code: "03-806",
    city: "Warszawa",
  },
  {
    code: "03-807",
    city: "Warszawa",
  },
  {
    code: "03-808",
    city: "Warszawa",
  },
  {
    code: "03-809",
    city: "Warszawa",
  },
  {
    code: "03-810",
    city: "Warszawa",
  },
  {
    code: "03-811",
    city: "Warszawa",
  },
  {
    code: "03-812",
    city: "Warszawa",
  },
  {
    code: "03-813",
    city: "Warszawa",
  },
  {
    code: "03-814",
    city: "Warszawa",
  },
  {
    code: "03-815",
    city: "Warszawa",
  },
  {
    code: "03-816",
    city: "Warszawa",
  },
  {
    code: "03-821",
    city: "Warszawa",
  },
  {
    code: "03-822",
    city: "Warszawa",
  },
  {
    code: "03-823",
    city: "Warszawa",
  },
  {
    code: "03-824",
    city: "Warszawa",
  },
  {
    code: "03-825",
    city: "Warszawa",
  },
  {
    code: "03-826",
    city: "Warszawa",
  },
  {
    code: "03-828",
    city: "Warszawa",
  },
  {
    code: "03-829",
    city: "Warszawa",
  },
  {
    code: "03-831",
    city: "Warszawa",
  },
  {
    code: "03-832",
    city: "Warszawa",
  },
  {
    code: "03-833",
    city: "Warszawa",
  },
  {
    code: "03-834",
    city: "Warszawa",
  },
  {
    code: "03-835",
    city: "Warszawa",
  },
  {
    code: "03-836",
    city: "Warszawa",
  },
  {
    code: "03-838",
    city: "Warszawa",
  },
  {
    code: "03-839",
    city: "Warszawa",
  },
  {
    code: "03-840",
    city: "Warszawa",
  },
  {
    code: "03-841",
    city: "Warszawa",
  },
  {
    code: "03-842",
    city: "Warszawa",
  },
  {
    code: "03-844",
    city: "Warszawa",
  },
  {
    code: "03-846",
    city: "Warszawa",
  },
  {
    code: "03-847",
    city: "Warszawa",
  },
  {
    code: "03-849",
    city: "Warszawa",
  },
  {
    code: "03-850",
    city: "Warszawa",
  },
  {
    code: "03-851",
    city: "Warszawa",
  },
  {
    code: "03-866",
    city: "Warszawa",
  },
  {
    code: "03-867",
    city: "Warszawa",
  },
  {
    code: "03-868",
    city: "Warszawa",
  },
  {
    code: "03-869",
    city: "Warszawa",
  },
  {
    code: "03-870",
    city: "Warszawa",
  },
  {
    code: "03-871",
    city: "Warszawa",
  },
  {
    code: "03-872",
    city: "Warszawa",
  },
  {
    code: "03-873",
    city: "Warszawa",
  },
  {
    code: "03-874",
    city: "Warszawa",
  },
  {
    code: "03-875",
    city: "Warszawa",
  },
  {
    code: "03-876",
    city: "Warszawa",
  },
  {
    code: "03-877",
    city: "Warszawa",
  },
  {
    code: "03-878",
    city: "Warszawa",
  },
  {
    code: "03-879",
    city: "Warszawa",
  },
  {
    code: "03-885",
    city: "Warszawa",
  },
  {
    code: "03-886",
    city: "Warszawa",
  },
  {
    code: "03-887",
    city: "Warszawa",
  },
  {
    code: "03-888",
    city: "Warszawa",
  },
  {
    code: "03-889",
    city: "Warszawa",
  },
  {
    code: "03-890",
    city: "Warszawa",
  },
  {
    code: "03-891",
    city: "Warszawa",
  },
  {
    code: "03-892",
    city: "Warszawa",
  },
  {
    code: "03-893",
    city: "Warszawa",
  },
  {
    code: "03-900",
    city: "Warszawa",
  },
  {
    code: "03-901",
    city: "Warszawa",
  },
  {
    code: "03-902",
    city: "Warszawa",
  },
  {
    code: "03-903",
    city: "Warszawa",
  },
  {
    code: "03-904",
    city: "Warszawa",
  },
  {
    code: "03-905",
    city: "Warszawa",
  },
  {
    code: "03-906",
    city: "Warszawa",
  },
  {
    code: "03-907",
    city: "Warszawa",
  },
  {
    code: "03-908",
    city: "Warszawa",
  },
  {
    code: "03-909",
    city: "Warszawa",
  },
  {
    code: "03-910",
    city: "Warszawa",
  },
  {
    code: "03-911",
    city: "Warszawa",
  },
  {
    code: "03-912",
    city: "Warszawa",
  },
  {
    code: "03-913",
    city: "Warszawa",
  },
  {
    code: "03-914",
    city: "Warszawa",
  },
  {
    code: "03-915",
    city: "Warszawa",
  },
  {
    code: "03-916",
    city: "Warszawa",
  },
  {
    code: "03-917",
    city: "Warszawa",
  },
  {
    code: "03-918",
    city: "Warszawa",
  },
  {
    code: "03-919",
    city: "Warszawa",
  },
  {
    code: "03-920",
    city: "Warszawa",
  },
  {
    code: "03-921",
    city: "Warszawa",
  },
  {
    code: "03-922",
    city: "Warszawa",
  },
  {
    code: "03-923",
    city: "Warszawa",
  },
  {
    code: "03-924",
    city: "Warszawa",
  },
  {
    code: "03-925",
    city: "Warszawa",
  },
  {
    code: "03-926",
    city: "Warszawa",
  },
  {
    code: "03-927",
    city: "Warszawa",
  },
  {
    code: "03-928",
    city: "Warszawa",
  },
  {
    code: "03-929",
    city: "Warszawa",
  },
  {
    code: "03-930",
    city: "Warszawa",
  },
  {
    code: "03-931",
    city: "Warszawa",
  },
  {
    code: "03-932",
    city: "Warszawa",
  },
  {
    code: "03-933",
    city: "Warszawa",
  },
  {
    code: "03-934",
    city: "Warszawa",
  },
  {
    code: "03-935",
    city: "Warszawa",
  },
  {
    code: "03-936",
    city: "Warszawa",
  },
  {
    code: "03-937",
    city: "Warszawa",
  },
  {
    code: "03-938",
    city: "Warszawa",
  },
  {
    code: "03-939",
    city: "Warszawa",
  },
  {
    code: "03-940",
    city: "Warszawa",
  },
  {
    code: "03-941",
    city: "Warszawa",
  },
  {
    code: "03-942",
    city: "Warszawa",
  },
  {
    code: "03-943",
    city: "Warszawa",
  },
  {
    code: "03-944",
    city: "Warszawa",
  },
  {
    code: "03-945",
    city: "Warszawa",
  },
  {
    code: "03-946",
    city: "Warszawa",
  },
  {
    code: "03-947",
    city: "Warszawa",
  },
  {
    code: "03-948",
    city: "Warszawa",
  },
  {
    code: "03-949",
    city: "Warszawa",
  },
  {
    code: "03-952",
    city: "Warszawa",
  },
  {
    code: "03-953",
    city: "Warszawa",
  },
  {
    code: "03-954",
    city: "Warszawa",
  },
  {
    code: "03-955",
    city: "Warszawa",
  },
  {
    code: "03-956",
    city: "Warszawa",
  },
  {
    code: "03-957",
    city: "Warszawa",
  },
  {
    code: "03-963",
    city: "Warszawa",
  },
  {
    code: "03-964",
    city: "Warszawa",
  },
  {
    code: "03-965",
    city: "Warszawa",
  },
  {
    code: "03-966",
    city: "Warszawa",
  },
  {
    code: "03-967",
    city: "Warszawa",
  },
  {
    code: "03-968",
    city: "Warszawa",
  },
  {
    code: "03-969",
    city: "Warszawa",
  },
  {
    code: "03-970",
    city: "Warszawa",
  },
  {
    code: "03-971",
    city: "Warszawa",
  },
  {
    code: "03-972",
    city: "Warszawa",
  },
  {
    code: "03-973",
    city: "Warszawa",
  },
  {
    code: "03-974",
    city: "Warszawa",
  },
  {
    code: "03-975",
    city: "Warszawa",
  },
  {
    code: "03-976",
    city: "Warszawa",
  },
  {
    code: "03-977",
    city: "Warszawa",
  },
  {
    code: "03-978",
    city: "Warszawa",
  },
  {
    code: "03-979",
    city: "Warszawa",
  },
  {
    code: "03-980",
    city: "Warszawa",
  },
  {
    code: "03-982",
    city: "Warszawa",
  },
  {
    code: "03-983",
    city: "Warszawa",
  },
  {
    code: "03-984",
    city: "Warszawa",
  },
  {
    code: "03-985",
    city: "Warszawa",
  },
  {
    code: "03-986",
    city: "Warszawa",
  },
  {
    code: "03-987",
    city: "Warszawa",
  },
  {
    code: "03-988",
    city: "Warszawa",
  },
  {
    code: "03-989",
    city: "Warszawa",
  },
  {
    code: "03-990",
    city: "Warszawa",
  },
  {
    code: "03-991",
    city: "Warszawa",
  },
  {
    code: "03-992",
    city: "Warszawa",
  },
  {
    code: "03-993",
    city: "Warszawa",
  },
  {
    code: "03-994",
    city: "Warszawa",
  },
  {
    code: "03-995",
    city: "Warszawa",
  },
  {
    code: "03-996",
    city: "Warszawa",
  },
  {
    code: "03-998",
    city: "Warszawa",
  },
  {
    code: "04-001",
    city: "Warszawa",
  },
  {
    code: "04-002",
    city: "Warszawa",
  },
  {
    code: "04-003",
    city: "Warszawa",
  },
  {
    code: "04-004",
    city: "Warszawa",
  },
  {
    code: "04-005",
    city: "Warszawa",
  },
  {
    code: "04-007",
    city: "Warszawa",
  },
  {
    code: "04-008",
    city: "Warszawa",
  },
  {
    code: "04-009",
    city: "Warszawa",
  },
  {
    code: "04-010",
    city: "Warszawa",
  },
  {
    code: "04-011",
    city: "Warszawa",
  },
  {
    code: "04-013",
    city: "Warszawa",
  },
  {
    code: "04-014",
    city: "Warszawa",
  },
  {
    code: "04-015",
    city: "Warszawa",
  },
  {
    code: "04-016",
    city: "Warszawa",
  },
  {
    code: "04-017",
    city: "Warszawa",
  },
  {
    code: "04-019",
    city: "Warszawa",
  },
  {
    code: "04-020",
    city: "Warszawa",
  },
  {
    code: "04-022",
    city: "Warszawa",
  },
  {
    code: "04-023",
    city: "Warszawa",
  },
  {
    code: "04-024",
    city: "Warszawa",
  },
  {
    code: "04-025",
    city: "Warszawa",
  },
  {
    code: "04-026",
    city: "Warszawa",
  },
  {
    code: "04-027",
    city: "Warszawa",
  },
  {
    code: "04-028",
    city: "Warszawa",
  },
  {
    code: "04-029",
    city: "Warszawa",
  },
  {
    code: "04-030",
    city: "Warszawa",
  },
  {
    code: "04-031",
    city: "Warszawa",
  },
  {
    code: "04-032",
    city: "Warszawa",
  },
  {
    code: "04-033",
    city: "Warszawa",
  },
  {
    code: "04-034",
    city: "Warszawa",
  },
  {
    code: "04-035",
    city: "Warszawa",
  },
  {
    code: "04-036",
    city: "Warszawa",
  },
  {
    code: "04-038",
    city: "Warszawa",
  },
  {
    code: "04-039",
    city: "Warszawa",
  },
  {
    code: "04-040",
    city: "Warszawa",
  },
  {
    code: "04-041",
    city: "Warszawa",
  },
  {
    code: "04-042",
    city: "Warszawa",
  },
  {
    code: "04-043",
    city: "Warszawa",
  },
  {
    code: "04-044",
    city: "Warszawa",
  },
  {
    code: "04-045",
    city: "Warszawa",
  },
  {
    code: "04-046",
    city: "Warszawa",
  },
  {
    code: "04-047",
    city: "Warszawa",
  },
  {
    code: "04-048",
    city: "Warszawa",
  },
  {
    code: "04-049",
    city: "Warszawa",
  },
  {
    code: "04-050",
    city: "Warszawa",
  },
  {
    code: "04-051",
    city: "Warszawa",
  },
  {
    code: "04-052",
    city: "Warszawa",
  },
  {
    code: "04-053",
    city: "Warszawa",
  },
  {
    code: "04-055",
    city: "Warszawa",
  },
  {
    code: "04-057",
    city: "Warszawa",
  },
  {
    code: "04-058",
    city: "Warszawa",
  },
  {
    code: "04-059",
    city: "Warszawa",
  },
  {
    code: "04-060",
    city: "Warszawa",
  },
  {
    code: "04-062",
    city: "Warszawa",
  },
  {
    code: "04-063",
    city: "Warszawa",
  },
  {
    code: "04-064",
    city: "Warszawa",
  },
  {
    code: "04-065",
    city: "Warszawa",
  },
  {
    code: "04-066",
    city: "Warszawa",
  },
  {
    code: "04-067",
    city: "Warszawa",
  },
  {
    code: "04-068",
    city: "Warszawa",
  },
  {
    code: "04-069",
    city: "Warszawa",
  },
  {
    code: "04-072",
    city: "Warszawa",
  },
  {
    code: "04-073",
    city: "Warszawa",
  },
  {
    code: "04-074",
    city: "Warszawa",
  },
  {
    code: "04-076",
    city: "Warszawa",
  },
  {
    code: "04-077",
    city: "Warszawa",
  },
  {
    code: "04-078",
    city: "Warszawa",
  },
  {
    code: "04-079",
    city: "Warszawa",
  },
  {
    code: "04-080",
    city: "Warszawa",
  },
  {
    code: "04-081",
    city: "Warszawa",
  },
  {
    code: "04-082",
    city: "Warszawa",
  },
  {
    code: "04-083",
    city: "Warszawa",
  },
  {
    code: "04-085",
    city: "Warszawa",
  },
  {
    code: "04-086",
    city: "Warszawa",
  },
  {
    code: "04-087",
    city: "Warszawa",
  },
  {
    code: "04-088",
    city: "Warszawa",
  },
  {
    code: "04-089",
    city: "Warszawa",
  },
  {
    code: "04-090",
    city: "Warszawa",
  },
  {
    code: "04-091",
    city: "Warszawa",
  },
  {
    code: "04-092",
    city: "Warszawa",
  },
  {
    code: "04-101",
    city: "Warszawa",
  },
  {
    code: "04-102",
    city: "Warszawa",
  },
  {
    code: "04-105",
    city: "Warszawa",
  },
  {
    code: "04-106",
    city: "Warszawa",
  },
  {
    code: "04-109",
    city: "Warszawa",
  },
  {
    code: "04-110",
    city: "Warszawa",
  },
  {
    code: "04-111",
    city: "Warszawa",
  },
  {
    code: "04-112",
    city: "Warszawa",
  },
  {
    code: "04-113",
    city: "Warszawa",
  },
  {
    code: "04-116",
    city: "Warszawa",
  },
  {
    code: "04-118",
    city: "Warszawa",
  },
  {
    code: "04-119",
    city: "Warszawa",
  },
  {
    code: "04-120",
    city: "Warszawa",
  },
  {
    code: "04-121",
    city: "Warszawa",
  },
  {
    code: "04-123",
    city: "Warszawa",
  },
  {
    code: "04-124",
    city: "Warszawa",
  },
  {
    code: "04-125",
    city: "Warszawa",
  },
  {
    code: "04-127",
    city: "Warszawa",
  },
  {
    code: "04-128",
    city: "Warszawa",
  },
  {
    code: "04-129",
    city: "Warszawa",
  },
  {
    code: "04-131",
    city: "Warszawa",
  },
  {
    code: "04-133",
    city: "Warszawa",
  },
  {
    code: "04-134",
    city: "Warszawa",
  },
  {
    code: "04-136",
    city: "Warszawa",
  },
  {
    code: "04-137",
    city: "Warszawa",
  },
  {
    code: "04-138",
    city: "Warszawa",
  },
  {
    code: "04-139",
    city: "Warszawa",
  },
  {
    code: "04-141",
    city: "Warszawa",
  },
  {
    code: "04-142",
    city: "Warszawa",
  },
  {
    code: "04-143",
    city: "Warszawa",
  },
  {
    code: "04-144",
    city: "Warszawa",
  },
  {
    code: "04-145",
    city: "Warszawa",
  },
  {
    code: "04-146",
    city: "Warszawa",
  },
  {
    code: "04-147",
    city: "Warszawa",
  },
  {
    code: "04-148",
    city: "Warszawa",
  },
  {
    code: "04-149",
    city: "Warszawa",
  },
  {
    code: "04-151",
    city: "Warszawa",
  },
  {
    code: "04-152",
    city: "Warszawa",
  },
  {
    code: "04-154",
    city: "Warszawa",
  },
  {
    code: "04-155",
    city: "Warszawa",
  },
  {
    code: "04-156",
    city: "Warszawa",
  },
  {
    code: "04-157",
    city: "Warszawa",
  },
  {
    code: "04-158",
    city: "Warszawa",
  },
  {
    code: "04-160",
    city: "Warszawa",
  },
  {
    code: "04-161",
    city: "Warszawa",
  },
  {
    code: "04-163",
    city: "Warszawa",
  },
  {
    code: "04-164",
    city: "Warszawa",
  },
  {
    code: "04-167",
    city: "Warszawa",
  },
  {
    code: "04-169",
    city: "Warszawa",
  },
  {
    code: "04-170",
    city: "Warszawa",
  },
  {
    code: "04-171",
    city: "Warszawa",
  },
  {
    code: "04-172",
    city: "Warszawa",
  },
  {
    code: "04-173",
    city: "Warszawa",
  },
  {
    code: "04-174",
    city: "Warszawa",
  },
  {
    code: "04-175",
    city: "Warszawa",
  },
  {
    code: "04-180",
    city: "Warszawa",
  },
  {
    code: "04-183",
    city: "Warszawa",
  },
  {
    code: "04-185",
    city: "Warszawa",
  },
  {
    code: "04-186",
    city: "Warszawa",
  },
  {
    code: "04-187",
    city: "Warszawa",
  },
  {
    code: "04-188",
    city: "Warszawa",
  },
  {
    code: "04-189",
    city: "Warszawa",
  },
  {
    code: "04-190",
    city: "Warszawa",
  },
  {
    code: "04-191",
    city: "Warszawa",
  },
  {
    code: "04-192",
    city: "Warszawa",
  },
  {
    code: "04-193",
    city: "Warszawa",
  },
  {
    code: "04-194",
    city: "Warszawa",
  },
  {
    code: "04-196",
    city: "Warszawa",
  },
  {
    code: "04-202",
    city: "Warszawa",
  },
  {
    code: "04-203",
    city: "Warszawa",
  },
  {
    code: "04-204",
    city: "Warszawa",
  },
  {
    code: "04-205",
    city: "Warszawa",
  },
  {
    code: "04-206",
    city: "Warszawa",
  },
  {
    code: "04-207",
    city: "Warszawa",
  },
  {
    code: "04-208",
    city: "Warszawa",
  },
  {
    code: "04-210",
    city: "Warszawa",
  },
  {
    code: "04-211",
    city: "Warszawa",
  },
  {
    code: "04-212",
    city: "Warszawa",
  },
  {
    code: "04-213",
    city: "Warszawa",
  },
  {
    code: "04-214",
    city: "Warszawa",
  },
  {
    code: "04-215",
    city: "Warszawa",
  },
  {
    code: "04-216",
    city: "Warszawa",
  },
  {
    code: "04-217",
    city: "Warszawa",
  },
  {
    code: "04-218",
    city: "Warszawa",
  },
  {
    code: "04-219",
    city: "Warszawa",
  },
  {
    code: "04-221",
    city: "Warszawa",
  },
  {
    code: "04-222",
    city: "Warszawa",
  },
  {
    code: "04-223",
    city: "Warszawa",
  },
  {
    code: "04-224",
    city: "Warszawa",
  },
  {
    code: "04-226",
    city: "Warszawa",
  },
  {
    code: "04-227",
    city: "Warszawa",
  },
  {
    code: "04-228",
    city: "Warszawa",
  },
  {
    code: "04-230",
    city: "Warszawa",
  },
  {
    code: "04-231",
    city: "Warszawa",
  },
  {
    code: "04-232",
    city: "Warszawa",
  },
  {
    code: "04-233",
    city: "Warszawa",
  },
  {
    code: "04-234",
    city: "Warszawa",
  },
  {
    code: "04-235",
    city: "Warszawa",
  },
  {
    code: "04-237",
    city: "Warszawa",
  },
  {
    code: "04-238",
    city: "Warszawa",
  },
  {
    code: "04-239",
    city: "Warszawa",
  },
  {
    code: "04-240",
    city: "Warszawa",
  },
  {
    code: "04-241",
    city: "Warszawa",
  },
  {
    code: "04-242",
    city: "Warszawa",
  },
  {
    code: "04-243",
    city: "Warszawa",
  },
  {
    code: "04-244",
    city: "Warszawa",
  },
  {
    code: "04-246",
    city: "Warszawa",
  },
  {
    code: "04-247",
    city: "Warszawa",
  },
  {
    code: "04-248",
    city: "Warszawa",
  },
  {
    code: "04-252",
    city: "Warszawa",
  },
  {
    code: "04-253",
    city: "Warszawa",
  },
  {
    code: "04-254",
    city: "Warszawa",
  },
  {
    code: "04-255",
    city: "Warszawa",
  },
  {
    code: "04-256",
    city: "Warszawa",
  },
  {
    code: "04-257",
    city: "Warszawa",
  },
  {
    code: "04-258",
    city: "Warszawa",
  },
  {
    code: "04-259",
    city: "Warszawa",
  },
  {
    code: "04-260",
    city: "Warszawa",
  },
  {
    code: "04-261",
    city: "Warszawa",
  },
  {
    code: "04-262",
    city: "Warszawa",
  },
  {
    code: "04-263",
    city: "Warszawa",
  },
  {
    code: "04-266",
    city: "Warszawa",
  },
  {
    code: "04-267",
    city: "Warszawa",
  },
  {
    code: "04-268",
    city: "Warszawa",
  },
  {
    code: "04-269",
    city: "Warszawa",
  },
  {
    code: "04-270",
    city: "Warszawa",
  },
  {
    code: "04-271",
    city: "Warszawa",
  },
  {
    code: "04-272",
    city: "Warszawa",
  },
  {
    code: "04-273",
    city: "Warszawa",
  },
  {
    code: "04-274",
    city: "Warszawa",
  },
  {
    code: "04-275",
    city: "Warszawa",
  },
  {
    code: "04-276",
    city: "Warszawa",
  },
  {
    code: "04-277",
    city: "Warszawa",
  },
  {
    code: "04-278",
    city: "Warszawa",
  },
  {
    code: "04-280",
    city: "Warszawa",
  },
  {
    code: "04-281",
    city: "Warszawa",
  },
  {
    code: "04-282",
    city: "Warszawa",
  },
  {
    code: "04-283",
    city: "Warszawa",
  },
  {
    code: "04-284",
    city: "Warszawa",
  },
  {
    code: "04-285",
    city: "Warszawa",
  },
  {
    code: "04-287",
    city: "Warszawa",
  },
  {
    code: "04-288",
    city: "Warszawa",
  },
  {
    code: "04-289",
    city: "Warszawa",
  },
  {
    code: "04-290",
    city: "Warszawa",
  },
  {
    code: "04-291",
    city: "Warszawa",
  },
  {
    code: "04-292",
    city: "Warszawa",
  },
  {
    code: "04-293",
    city: "Warszawa",
  },
  {
    code: "04-294",
    city: "Warszawa",
  },
  {
    code: "04-301",
    city: "Warszawa",
  },
  {
    code: "04-302",
    city: "Warszawa",
  },
  {
    code: "04-303",
    city: "Warszawa",
  },
  {
    code: "04-304",
    city: "Warszawa",
  },
  {
    code: "04-305",
    city: "Warszawa",
  },
  {
    code: "04-306",
    city: "Warszawa",
  },
  {
    code: "04-307",
    city: "Warszawa",
  },
  {
    code: "04-308",
    city: "Warszawa",
  },
  {
    code: "04-309",
    city: "Warszawa",
  },
  {
    code: "04-310",
    city: "Warszawa",
  },
  {
    code: "04-311",
    city: "Warszawa",
  },
  {
    code: "04-312",
    city: "Warszawa",
  },
  {
    code: "04-313",
    city: "Warszawa",
  },
  {
    code: "04-314",
    city: "Warszawa",
  },
  {
    code: "04-316",
    city: "Warszawa",
  },
  {
    code: "04-317",
    city: "Warszawa",
  },
  {
    code: "04-319",
    city: "Warszawa",
  },
  {
    code: "04-320",
    city: "Warszawa",
  },
  {
    code: "04-321",
    city: "Warszawa",
  },
  {
    code: "04-322",
    city: "Warszawa",
  },
  {
    code: "04-323",
    city: "Warszawa",
  },
  {
    code: "04-324",
    city: "Warszawa",
  },
  {
    code: "04-325",
    city: "Warszawa",
  },
  {
    code: "04-326",
    city: "Warszawa",
  },
  {
    code: "04-327",
    city: "Warszawa",
  },
  {
    code: "04-328",
    city: "Warszawa",
  },
  {
    code: "04-329",
    city: "Warszawa",
  },
  {
    code: "04-330",
    city: "Warszawa",
  },
  {
    code: "04-331",
    city: "Warszawa",
  },
  {
    code: "04-332",
    city: "Warszawa",
  },
  {
    code: "04-333",
    city: "Warszawa",
  },
  {
    code: "04-334",
    city: "Warszawa",
  },
  {
    code: "04-335",
    city: "Warszawa",
  },
  {
    code: "04-336",
    city: "Warszawa",
  },
  {
    code: "04-337",
    city: "Warszawa",
  },
  {
    code: "04-338",
    city: "Warszawa",
  },
  {
    code: "04-339",
    city: "Warszawa",
  },
  {
    code: "04-340",
    city: "Warszawa",
  },
  {
    code: "04-341",
    city: "Warszawa",
  },
  {
    code: "04-342",
    city: "Warszawa",
  },
  {
    code: "04-343",
    city: "Warszawa",
  },
  {
    code: "04-344",
    city: "Warszawa",
  },
  {
    code: "04-345",
    city: "Warszawa",
  },
  {
    code: "04-346",
    city: "Warszawa",
  },
  {
    code: "04-347",
    city: "Warszawa",
  },
  {
    code: "04-348",
    city: "Warszawa",
  },
  {
    code: "04-349",
    city: "Warszawa",
  },
  {
    code: "04-350",
    city: "Warszawa",
  },
  {
    code: "04-351",
    city: "Warszawa",
  },
  {
    code: "04-352",
    city: "Warszawa",
  },
  {
    code: "04-353",
    city: "Warszawa",
  },
  {
    code: "04-354",
    city: "Warszawa",
  },
  {
    code: "04-355",
    city: "Warszawa",
  },
  {
    code: "04-356",
    city: "Warszawa",
  },
  {
    code: "04-357",
    city: "Warszawa",
  },
  {
    code: "04-358",
    city: "Warszawa",
  },
  {
    code: "04-359",
    city: "Warszawa",
  },
  {
    code: "04-360",
    city: "Warszawa",
  },
  {
    code: "04-361",
    city: "Warszawa",
  },
  {
    code: "04-362",
    city: "Warszawa",
  },
  {
    code: "04-363",
    city: "Warszawa",
  },
  {
    code: "04-364",
    city: "Warszawa",
  },
  {
    code: "04-365",
    city: "Warszawa",
  },
  {
    code: "04-366",
    city: "Warszawa",
  },
  {
    code: "04-367",
    city: "Warszawa",
  },
  {
    code: "04-368",
    city: "Warszawa",
  },
  {
    code: "04-369",
    city: "Warszawa",
  },
  {
    code: "04-370",
    city: "Warszawa",
  },
  {
    code: "04-371",
    city: "Warszawa",
  },
  {
    code: "04-372",
    city: "Warszawa",
  },
  {
    code: "04-373",
    city: "Warszawa",
  },
  {
    code: "04-375",
    city: "Warszawa",
  },
  {
    code: "04-376",
    city: "Warszawa",
  },
  {
    code: "04-377",
    city: "Warszawa",
  },
  {
    code: "04-378",
    city: "Warszawa",
  },
  {
    code: "04-379",
    city: "Warszawa",
  },
  {
    code: "04-380",
    city: "Warszawa",
  },
  {
    code: "04-381",
    city: "Warszawa",
  },
  {
    code: "04-382",
    city: "Warszawa",
  },
  {
    code: "04-384",
    city: "Warszawa",
  },
  {
    code: "04-385",
    city: "Warszawa",
  },
  {
    code: "04-386",
    city: "Warszawa",
  },
  {
    code: "04-387",
    city: "Warszawa",
  },
  {
    code: "04-388",
    city: "Warszawa",
  },
  {
    code: "04-389",
    city: "Warszawa",
  },
  {
    code: "04-390",
    city: "Warszawa",
  },
  {
    code: "04-391",
    city: "Warszawa",
  },
  {
    code: "04-392",
    city: "Warszawa",
  },
  {
    code: "04-393",
    city: "Warszawa",
  },
  {
    code: "04-394",
    city: "Warszawa",
  },
  {
    code: "04-395",
    city: "Warszawa",
  },
  {
    code: "04-396",
    city: "Warszawa",
  },
  {
    code: "04-397",
    city: "Warszawa",
  },
  {
    code: "04-398",
    city: "Warszawa",
  },
  {
    code: "04-400",
    city: "Warszawa",
  },
  {
    code: "04-401",
    city: "Warszawa",
  },
  {
    code: "04-402",
    city: "Warszawa",
  },
  {
    code: "04-403",
    city: "Warszawa",
  },
  {
    code: "04-404",
    city: "Warszawa",
  },
  {
    code: "04-406",
    city: "Warszawa",
  },
  {
    code: "04-407",
    city: "Warszawa",
  },
  {
    code: "04-408",
    city: "Warszawa",
  },
  {
    code: "04-409",
    city: "Warszawa",
  },
  {
    code: "04-410",
    city: "Warszawa",
  },
  {
    code: "04-412",
    city: "Warszawa",
  },
  {
    code: "04-413",
    city: "Warszawa",
  },
  {
    code: "04-414",
    city: "Warszawa",
  },
  {
    code: "04-416",
    city: "Warszawa",
  },
  {
    code: "04-417",
    city: "Warszawa",
  },
  {
    code: "04-418",
    city: "Warszawa",
  },
  {
    code: "04-419",
    city: "Warszawa",
  },
  {
    code: "04-420",
    city: "Warszawa",
  },
  {
    code: "04-421",
    city: "Warszawa",
  },
  {
    code: "04-423",
    city: "Warszawa",
  },
  {
    code: "04-424",
    city: "Warszawa",
  },
  {
    code: "04-425",
    city: "Warszawa",
  },
  {
    code: "04-426",
    city: "Warszawa",
  },
  {
    code: "04-428",
    city: "Warszawa",
  },
  {
    code: "04-429",
    city: "Warszawa",
  },
  {
    code: "04-430",
    city: "Warszawa",
  },
  {
    code: "04-431",
    city: "Warszawa",
  },
  {
    code: "04-432",
    city: "Warszawa",
  },
  {
    code: "04-434",
    city: "Warszawa",
  },
  {
    code: "04-435",
    city: "Warszawa",
  },
  {
    code: "04-436",
    city: "Warszawa",
  },
  {
    code: "04-437",
    city: "Warszawa",
  },
  {
    code: "04-438",
    city: "Warszawa",
  },
  {
    code: "04-439",
    city: "Warszawa",
  },
  {
    code: "04-440",
    city: "Warszawa",
  },
  {
    code: "04-441",
    city: "Warszawa",
  },
  {
    code: "04-443",
    city: "Warszawa",
  },
  {
    code: "04-444",
    city: "Warszawa",
  },
  {
    code: "04-445",
    city: "Warszawa",
  },
  {
    code: "04-446",
    city: "Warszawa",
  },
  {
    code: "04-447",
    city: "Warszawa",
  },
  {
    code: "04-448",
    city: "Warszawa",
  },
  {
    code: "04-450",
    city: "Warszawa",
  },
  {
    code: "04-451",
    city: "Warszawa",
  },
  {
    code: "04-452",
    city: "Warszawa",
  },
  {
    code: "04-453",
    city: "Warszawa",
  },
  {
    code: "04-454",
    city: "Warszawa",
  },
  {
    code: "04-455",
    city: "Warszawa",
  },
  {
    code: "04-457",
    city: "Warszawa",
  },
  {
    code: "04-458",
    city: "Warszawa",
  },
  {
    code: "04-459",
    city: "Warszawa",
  },
  {
    code: "04-460",
    city: "Warszawa",
  },
  {
    code: "04-461",
    city: "Warszawa",
  },
  {
    code: "04-462",
    city: "Warszawa",
  },
  {
    code: "04-463",
    city: "Warszawa",
  },
  {
    code: "04-464",
    city: "Warszawa",
  },
  {
    code: "04-465",
    city: "Warszawa",
  },
  {
    code: "04-466",
    city: "Warszawa",
  },
  {
    code: "04-467",
    city: "Warszawa",
  },
  {
    code: "04-468",
    city: "Warszawa",
  },
  {
    code: "04-470",
    city: "Warszawa",
  },
  {
    code: "04-471",
    city: "Warszawa",
  },
  {
    code: "04-473",
    city: "Warszawa",
  },
  {
    code: "04-474",
    city: "Warszawa",
  },
  {
    code: "04-475",
    city: "Warszawa",
  },
  {
    code: "04-476",
    city: "Warszawa",
  },
  {
    code: "04-478",
    city: "Warszawa",
  },
  {
    code: "04-479",
    city: "Warszawa",
  },
  {
    code: "04-480",
    city: "Warszawa",
  },
  {
    code: "04-481",
    city: "Warszawa",
  },
  {
    code: "04-482",
    city: "Warszawa",
  },
  {
    code: "04-483",
    city: "Warszawa",
  },
  {
    code: "04-484",
    city: "Warszawa",
  },
  {
    code: "04-485",
    city: "Warszawa",
  },
  {
    code: "04-487",
    city: "Warszawa",
  },
  {
    code: "04-488",
    city: "Warszawa",
  },
  {
    code: "04-489",
    city: "Warszawa",
  },
  {
    code: "04-491",
    city: "Warszawa",
  },
  {
    code: "04-492",
    city: "Warszawa",
  },
  {
    code: "04-493",
    city: "Warszawa",
  },
  {
    code: "04-494",
    city: "Warszawa",
  },
  {
    code: "04-495",
    city: "Warszawa",
  },
  {
    code: "04-497",
    city: "Warszawa",
  },
  {
    code: "04-498",
    city: "Warszawa",
  },
  {
    code: "04-501",
    city: "Warszawa",
  },
  {
    code: "04-502",
    city: "Warszawa",
  },
  {
    code: "04-504",
    city: "Warszawa",
  },
  {
    code: "04-505",
    city: "Warszawa",
  },
  {
    code: "04-506",
    city: "Warszawa",
  },
  {
    code: "04-507",
    city: "Warszawa",
  },
  {
    code: "04-508",
    city: "Warszawa",
  },
  {
    code: "04-509",
    city: "Warszawa",
  },
  {
    code: "04-510",
    city: "Warszawa",
  },
  {
    code: "04-511",
    city: "Warszawa",
  },
  {
    code: "04-512",
    city: "Warszawa",
  },
  {
    code: "04-513",
    city: "Warszawa",
  },
  {
    code: "04-514",
    city: "Warszawa",
  },
  {
    code: "04-515",
    city: "Warszawa",
  },
  {
    code: "04-516",
    city: "Warszawa",
  },
  {
    code: "04-517",
    city: "Warszawa",
  },
  {
    code: "04-519",
    city: "Warszawa",
  },
  {
    code: "04-520",
    city: "Warszawa",
  },
  {
    code: "04-521",
    city: "Warszawa",
  },
  {
    code: "04-522",
    city: "Warszawa",
  },
  {
    code: "04-523",
    city: "Warszawa",
  },
  {
    code: "04-524",
    city: "Warszawa",
  },
  {
    code: "04-525",
    city: "Warszawa",
  },
  {
    code: "04-526",
    city: "Warszawa",
  },
  {
    code: "04-528",
    city: "Warszawa",
  },
  {
    code: "04-529",
    city: "Warszawa",
  },
  {
    code: "04-530",
    city: "Warszawa",
  },
  {
    code: "04-532",
    city: "Warszawa",
  },
  {
    code: "04-533",
    city: "Warszawa",
  },
  {
    code: "04-534",
    city: "Warszawa",
  },
  {
    code: "04-535",
    city: "Warszawa",
  },
  {
    code: "04-536",
    city: "Warszawa",
  },
  {
    code: "04-537",
    city: "Warszawa",
  },
  {
    code: "04-538",
    city: "Warszawa",
  },
  {
    code: "04-539",
    city: "Warszawa",
  },
  {
    code: "04-540",
    city: "Warszawa",
  },
  {
    code: "04-541",
    city: "Warszawa",
  },
  {
    code: "04-542",
    city: "Warszawa",
  },
  {
    code: "04-543",
    city: "Warszawa",
  },
  {
    code: "04-544",
    city: "Warszawa",
  },
  {
    code: "04-545",
    city: "Warszawa",
  },
  {
    code: "04-547",
    city: "Warszawa",
  },
  {
    code: "04-549",
    city: "Warszawa",
  },
  {
    code: "04-550",
    city: "Warszawa",
  },
  {
    code: "04-551",
    city: "Warszawa",
  },
  {
    code: "04-552",
    city: "Warszawa",
  },
  {
    code: "04-555",
    city: "Warszawa",
  },
  {
    code: "04-556",
    city: "Warszawa",
  },
  {
    code: "04-557",
    city: "Warszawa",
  },
  {
    code: "04-558",
    city: "Warszawa",
  },
  {
    code: "04-559",
    city: "Warszawa",
  },
  {
    code: "04-560",
    city: "Warszawa",
  },
  {
    code: "04-561",
    city: "Warszawa",
  },
  {
    code: "04-562",
    city: "Warszawa",
  },
  {
    code: "04-563",
    city: "Warszawa",
  },
  {
    code: "04-564",
    city: "Warszawa",
  },
  {
    code: "04-565",
    city: "Warszawa",
  },
  {
    code: "04-566",
    city: "Warszawa",
  },
  {
    code: "04-567",
    city: "Warszawa",
  },
  {
    code: "04-568",
    city: "Warszawa",
  },
  {
    code: "04-569",
    city: "Warszawa",
  },
  {
    code: "04-570",
    city: "Warszawa",
  },
  {
    code: "04-601",
    city: "Warszawa",
  },
  {
    code: "04-602",
    city: "Warszawa",
  },
  {
    code: "04-603",
    city: "Warszawa",
  },
  {
    code: "04-604",
    city: "Warszawa",
  },
  {
    code: "04-605",
    city: "Warszawa",
  },
  {
    code: "04-606",
    city: "Warszawa",
  },
  {
    code: "04-607",
    city: "Warszawa",
  },
  {
    code: "04-608",
    city: "Warszawa",
  },
  {
    code: "04-609",
    city: "Warszawa",
  },
  {
    code: "04-610",
    city: "Warszawa",
  },
  {
    code: "04-611",
    city: "Warszawa",
  },
  {
    code: "04-612",
    city: "Warszawa",
  },
  {
    code: "04-613",
    city: "Warszawa",
  },
  {
    code: "04-614",
    city: "Warszawa",
  },
  {
    code: "04-615",
    city: "Warszawa",
  },
  {
    code: "04-616",
    city: "Warszawa",
  },
  {
    code: "04-617",
    city: "Warszawa",
  },
  {
    code: "04-618",
    city: "Warszawa",
  },
  {
    code: "04-619",
    city: "Warszawa",
  },
  {
    code: "04-620",
    city: "Warszawa",
  },
  {
    code: "04-621",
    city: "Warszawa",
  },
  {
    code: "04-622",
    city: "Warszawa",
  },
  {
    code: "04-623",
    city: "Warszawa",
  },
  {
    code: "04-624",
    city: "Warszawa",
  },
  {
    code: "04-625",
    city: "Warszawa",
  },
  {
    code: "04-626",
    city: "Warszawa",
  },
  {
    code: "04-627",
    city: "Warszawa",
  },
  {
    code: "04-628",
    city: "Warszawa",
  },
  {
    code: "04-629",
    city: "Warszawa",
  },
  {
    code: "04-630",
    city: "Warszawa",
  },
  {
    code: "04-632",
    city: "Warszawa",
  },
  {
    code: "04-633",
    city: "Warszawa",
  },
  {
    code: "04-634",
    city: "Warszawa",
  },
  {
    code: "04-635",
    city: "Warszawa",
  },
  {
    code: "04-636",
    city: "Warszawa",
  },
  {
    code: "04-637",
    city: "Warszawa",
  },
  {
    code: "04-638",
    city: "Warszawa",
  },
  {
    code: "04-639",
    city: "Warszawa",
  },
  {
    code: "04-640",
    city: "Warszawa",
  },
  {
    code: "04-641",
    city: "Warszawa",
  },
  {
    code: "04-642",
    city: "Warszawa",
  },
  {
    code: "04-643",
    city: "Warszawa",
  },
  {
    code: "04-644",
    city: "Warszawa",
  },
  {
    code: "04-645",
    city: "Warszawa",
  },
  {
    code: "04-647",
    city: "Warszawa",
  },
  {
    code: "04-648",
    city: "Warszawa",
  },
  {
    code: "04-649",
    city: "Warszawa",
  },
  {
    code: "04-650",
    city: "Warszawa",
  },
  {
    code: "04-651",
    city: "Warszawa",
  },
  {
    code: "04-652",
    city: "Warszawa",
  },
  {
    code: "04-653",
    city: "Warszawa",
  },
  {
    code: "04-654",
    city: "Warszawa",
  },
  {
    code: "04-655",
    city: "Warszawa",
  },
  {
    code: "04-656",
    city: "Warszawa",
  },
  {
    code: "04-657",
    city: "Warszawa",
  },
  {
    code: "04-658",
    city: "Warszawa",
  },
  {
    code: "04-659",
    city: "Warszawa",
  },
  {
    code: "04-660",
    city: "Warszawa",
  },
  {
    code: "04-661",
    city: "Warszawa",
  },
  {
    code: "04-662",
    city: "Warszawa",
  },
  {
    code: "04-663",
    city: "Warszawa",
  },
  {
    code: "04-664",
    city: "Warszawa",
  },
  {
    code: "04-665",
    city: "Warszawa",
  },
  {
    code: "04-666",
    city: "Warszawa",
  },
  {
    code: "04-667",
    city: "Warszawa",
  },
  {
    code: "04-668",
    city: "Warszawa",
  },
  {
    code: "04-669",
    city: "Warszawa",
  },
  {
    code: "04-671",
    city: "Warszawa",
  },
  {
    code: "04-672",
    city: "Warszawa",
  },
  {
    code: "04-673",
    city: "Warszawa",
  },
  {
    code: "04-674",
    city: "Warszawa",
  },
  {
    code: "04-675",
    city: "Warszawa",
  },
  {
    code: "04-676",
    city: "Warszawa",
  },
  {
    code: "04-678",
    city: "Warszawa",
  },
  {
    code: "04-679",
    city: "Warszawa",
  },
  {
    code: "04-680",
    city: "Warszawa",
  },
  {
    code: "04-681",
    city: "Warszawa",
  },
  {
    code: "04-682",
    city: "Warszawa",
  },
  {
    code: "04-683",
    city: "Warszawa",
  },
  {
    code: "04-684",
    city: "Warszawa",
  },
  {
    code: "04-685",
    city: "Warszawa",
  },
  {
    code: "04-686",
    city: "Warszawa",
  },
  {
    code: "04-687",
    city: "Warszawa",
  },
  {
    code: "04-688",
    city: "Warszawa",
  },
  {
    code: "04-689",
    city: "Warszawa",
  },
  {
    code: "04-690",
    city: "Warszawa",
  },
  {
    code: "04-691",
    city: "Warszawa",
  },
  {
    code: "04-692",
    city: "Warszawa",
  },
  {
    code: "04-693",
    city: "Warszawa",
  },
  {
    code: "04-694",
    city: "Warszawa",
  },
  {
    code: "04-695",
    city: "Warszawa",
  },
  {
    code: "04-696",
    city: "Warszawa",
  },
  {
    code: "04-697",
    city: "Warszawa",
  },
  {
    code: "04-701",
    city: "Warszawa",
  },
  {
    code: "04-702",
    city: "Warszawa",
  },
  {
    code: "04-703",
    city: "Warszawa",
  },
  {
    code: "04-704",
    city: "Warszawa",
  },
  {
    code: "04-705",
    city: "Warszawa",
  },
  {
    code: "04-707",
    city: "Warszawa",
  },
  {
    code: "04-708",
    city: "Warszawa",
  },
  {
    code: "04-709",
    city: "Warszawa",
  },
  {
    code: "04-710",
    city: "Warszawa",
  },
  {
    code: "04-711",
    city: "Warszawa",
  },
  {
    code: "04-712",
    city: "Warszawa",
  },
  {
    code: "04-713",
    city: "Warszawa",
  },
  {
    code: "04-714",
    city: "Warszawa",
  },
  {
    code: "04-715",
    city: "Warszawa",
  },
  {
    code: "04-716",
    city: "Warszawa",
  },
  {
    code: "04-717",
    city: "Warszawa",
  },
  {
    code: "04-718",
    city: "Warszawa",
  },
  {
    code: "04-719",
    city: "Warszawa",
  },
  {
    code: "04-720",
    city: "Warszawa",
  },
  {
    code: "04-721",
    city: "Warszawa",
  },
  {
    code: "04-722",
    city: "Warszawa",
  },
  {
    code: "04-723",
    city: "Warszawa",
  },
  {
    code: "04-724",
    city: "Warszawa",
  },
  {
    code: "04-725",
    city: "Warszawa",
  },
  {
    code: "04-726",
    city: "Warszawa",
  },
  {
    code: "04-727",
    city: "Warszawa",
  },
  {
    code: "04-728",
    city: "Warszawa",
  },
  {
    code: "04-729",
    city: "Warszawa",
  },
  {
    code: "04-730",
    city: "Warszawa",
  },
  {
    code: "04-731",
    city: "Warszawa",
  },
  {
    code: "04-732",
    city: "Warszawa",
  },
  {
    code: "04-733",
    city: "Warszawa",
  },
  {
    code: "04-734",
    city: "Warszawa",
  },
  {
    code: "04-735",
    city: "Warszawa",
  },
  {
    code: "04-736",
    city: "Warszawa",
  },
  {
    code: "04-737",
    city: "Warszawa",
  },
  {
    code: "04-738",
    city: "Warszawa",
  },
  {
    code: "04-739",
    city: "Warszawa",
  },
  {
    code: "04-740",
    city: "Warszawa",
  },
  {
    code: "04-741",
    city: "Warszawa",
  },
  {
    code: "04-742",
    city: "Warszawa",
  },
  {
    code: "04-743",
    city: "Warszawa",
  },
  {
    code: "04-744",
    city: "Warszawa",
  },
  {
    code: "04-745",
    city: "Warszawa",
  },
  {
    code: "04-746",
    city: "Warszawa",
  },
  {
    code: "04-747",
    city: "Warszawa",
  },
  {
    code: "04-748",
    city: "Warszawa",
  },
  {
    code: "04-749",
    city: "Warszawa",
  },
  {
    code: "04-750",
    city: "Warszawa",
  },
  {
    code: "04-751",
    city: "Warszawa",
  },
  {
    code: "04-752",
    city: "Warszawa",
  },
  {
    code: "04-754",
    city: "Warszawa",
  },
  {
    code: "04-755",
    city: "Warszawa",
  },
  {
    code: "04-756",
    city: "Warszawa",
  },
  {
    code: "04-757",
    city: "Warszawa",
  },
  {
    code: "04-758",
    city: "Warszawa",
  },
  {
    code: "04-760",
    city: "Warszawa",
  },
  {
    code: "04-761",
    city: "Warszawa",
  },
  {
    code: "04-762",
    city: "Warszawa",
  },
  {
    code: "04-763",
    city: "Warszawa",
  },
  {
    code: "04-764",
    city: "Warszawa",
  },
  {
    code: "04-765",
    city: "Warszawa",
  },
  {
    code: "04-766",
    city: "Warszawa",
  },
  {
    code: "04-767",
    city: "Warszawa",
  },
  {
    code: "04-768",
    city: "Warszawa",
  },
  {
    code: "04-769",
    city: "Warszawa",
  },
  {
    code: "04-770",
    city: "Warszawa",
  },
  {
    code: "04-771",
    city: "Warszawa",
  },
  {
    code: "04-772",
    city: "Warszawa",
  },
  {
    code: "04-773",
    city: "Warszawa",
  },
  {
    code: "04-774",
    city: "Warszawa",
  },
  {
    code: "04-775",
    city: "Warszawa",
  },
  {
    code: "04-776",
    city: "Warszawa",
  },
  {
    code: "04-778",
    city: "Warszawa",
  },
  {
    code: "04-779",
    city: "Warszawa",
  },
  {
    code: "04-780",
    city: "Warszawa",
  },
  {
    code: "04-781",
    city: "Warszawa",
  },
  {
    code: "04-782",
    city: "Warszawa",
  },
  {
    code: "04-783",
    city: "Warszawa",
  },
  {
    code: "04-784",
    city: "Warszawa",
  },
  {
    code: "04-785",
    city: "Warszawa",
  },
  {
    code: "04-786",
    city: "Warszawa",
  },
  {
    code: "04-787",
    city: "Warszawa",
  },
  {
    code: "04-788",
    city: "Warszawa",
  },
  {
    code: "04-789",
    city: "Warszawa",
  },
  {
    code: "04-790",
    city: "Warszawa",
  },
  {
    code: "04-791",
    city: "Warszawa",
  },
  {
    code: "04-792",
    city: "Warszawa",
  },
  {
    code: "04-793",
    city: "Warszawa",
  },
  {
    code: "04-794",
    city: "Warszawa",
  },
  {
    code: "04-795",
    city: "Warszawa",
  },
  {
    code: "04-796",
    city: "Warszawa",
  },
  {
    code: "04-797",
    city: "Warszawa",
  },
  {
    code: "04-798",
    city: "Warszawa",
  },
  {
    code: "04-801",
    city: "Warszawa",
  },
  {
    code: "04-802",
    city: "Warszawa",
  },
  {
    code: "04-803",
    city: "Warszawa",
  },
  {
    code: "04-804",
    city: "Warszawa",
  },
  {
    code: "04-805",
    city: "Warszawa",
  },
  {
    code: "04-806",
    city: "Warszawa",
  },
  {
    code: "04-807",
    city: "Warszawa",
  },
  {
    code: "04-808",
    city: "Warszawa",
  },
  {
    code: "04-809",
    city: "Warszawa",
  },
  {
    code: "04-810",
    city: "Warszawa",
  },
  {
    code: "04-811",
    city: "Warszawa",
  },
  {
    code: "04-812",
    city: "Warszawa",
  },
  {
    code: "04-813",
    city: "Warszawa",
  },
  {
    code: "04-814",
    city: "Warszawa",
  },
  {
    code: "04-815",
    city: "Warszawa",
  },
  {
    code: "04-816",
    city: "Warszawa",
  },
  {
    code: "04-817",
    city: "Warszawa",
  },
  {
    code: "04-818",
    city: "Warszawa",
  },
  {
    code: "04-819",
    city: "Warszawa",
  },
  {
    code: "04-820",
    city: "Warszawa",
  },
  {
    code: "04-822",
    city: "Warszawa",
  },
  {
    code: "04-823",
    city: "Warszawa",
  },
  {
    code: "04-824",
    city: "Warszawa",
  },
  {
    code: "04-825",
    city: "Warszawa",
  },
  {
    code: "04-826",
    city: "Warszawa",
  },
  {
    code: "04-827",
    city: "Warszawa",
  },
  {
    code: "04-828",
    city: "Warszawa",
  },
  {
    code: "04-829",
    city: "Warszawa",
  },
  {
    code: "04-830",
    city: "Warszawa",
  },
  {
    code: "04-831",
    city: "Warszawa",
  },
  {
    code: "04-832",
    city: "Warszawa",
  },
  {
    code: "04-833",
    city: "Warszawa",
  },
  {
    code: "04-834",
    city: "Warszawa",
  },
  {
    code: "04-835",
    city: "Warszawa",
  },
  {
    code: "04-836",
    city: "Warszawa",
  },
  {
    code: "04-837",
    city: "Warszawa",
  },
  {
    code: "04-838",
    city: "Warszawa",
  },
  {
    code: "04-839",
    city: "Warszawa",
  },
  {
    code: "04-840",
    city: "Warszawa",
  },
  {
    code: "04-841",
    city: "Warszawa",
  },
  {
    code: "04-842",
    city: "Warszawa",
  },
  {
    code: "04-843",
    city: "Warszawa",
  },
  {
    code: "04-844",
    city: "Warszawa",
  },
  {
    code: "04-845",
    city: "Warszawa",
  },
  {
    code: "04-846",
    city: "Warszawa",
  },
  {
    code: "04-847",
    city: "Warszawa",
  },
  {
    code: "04-848",
    city: "Warszawa",
  },
  {
    code: "04-849",
    city: "Warszawa",
  },
  {
    code: "04-850",
    city: "Warszawa",
  },
  {
    code: "04-851",
    city: "Warszawa",
  },
  {
    code: "04-852",
    city: "Warszawa",
  },
  {
    code: "04-853",
    city: "Warszawa",
  },
  {
    code: "04-854",
    city: "Warszawa",
  },
  {
    code: "04-855",
    city: "Warszawa",
  },
  {
    code: "04-856",
    city: "Warszawa",
  },
  {
    code: "04-857",
    city: "Warszawa",
  },
  {
    code: "04-858",
    city: "Warszawa",
  },
  {
    code: "04-859",
    city: "Warszawa",
  },
  {
    code: "04-860",
    city: "Warszawa",
  },
  {
    code: "04-861",
    city: "Warszawa",
  },
  {
    code: "04-862",
    city: "Warszawa",
  },
  {
    code: "04-863",
    city: "Warszawa",
  },
  {
    code: "04-864",
    city: "Warszawa",
  },
  {
    code: "04-865",
    city: "Warszawa",
  },
  {
    code: "04-866",
    city: "Warszawa",
  },
  {
    code: "04-867",
    city: "Warszawa",
  },
  {
    code: "04-869",
    city: "Warszawa",
  },
  {
    code: "04-870",
    city: "Warszawa",
  },
  {
    code: "04-871",
    city: "Warszawa",
  },
  {
    code: "04-872",
    city: "Warszawa",
  },
  {
    code: "04-874",
    city: "Warszawa",
  },
  {
    code: "04-875",
    city: "Warszawa",
  },
  {
    code: "04-876",
    city: "Warszawa",
  },
  {
    code: "04-877",
    city: "Warszawa",
  },
  {
    code: "04-878",
    city: "Warszawa",
  },
  {
    code: "04-879",
    city: "Warszawa",
  },
  {
    code: "04-880",
    city: "Warszawa",
  },
  {
    code: "04-881",
    city: "Warszawa",
  },
  {
    code: "04-882",
    city: "Warszawa",
  },
  {
    code: "04-883",
    city: "Warszawa",
  },
  {
    code: "04-884",
    city: "Warszawa",
  },
  {
    code: "04-885",
    city: "Warszawa",
  },
  {
    code: "04-886",
    city: "Warszawa",
  },
  {
    code: "04-888",
    city: "Warszawa",
  },
  {
    code: "04-889",
    city: "Warszawa",
  },
  {
    code: "04-890",
    city: "Warszawa",
  },
  {
    code: "04-891",
    city: "Warszawa",
  },
  {
    code: "04-892",
    city: "Warszawa",
  },
  {
    code: "04-893",
    city: "Warszawa",
  },
  {
    code: "04-894",
    city: "Warszawa",
  },
  {
    code: "04-895",
    city: "Warszawa",
  },
  {
    code: "04-896",
    city: "Warszawa",
  },
  {
    code: "04-897",
    city: "Warszawa",
  },
  {
    code: "04-898",
    city: "Warszawa",
  },
  {
    code: "04-900",
    city: "Warszawa",
  },
  {
    code: "04-901",
    city: "Warszawa",
  },
  {
    code: "04-902",
    city: "Warszawa",
  },
  {
    code: "04-903",
    city: "Warszawa",
  },
  {
    code: "04-904",
    city: "Warszawa",
  },
  {
    code: "04-906",
    city: "Warszawa",
  },
  {
    code: "04-907",
    city: "Warszawa",
  },
  {
    code: "04-908",
    city: "Warszawa",
  },
  {
    code: "04-909",
    city: "Warszawa",
  },
  {
    code: "04-910",
    city: "Warszawa",
  },
  {
    code: "04-911",
    city: "Warszawa",
  },
  {
    code: "04-912",
    city: "Warszawa",
  },
  {
    code: "04-913",
    city: "Warszawa",
  },
  {
    code: "04-914",
    city: "Warszawa",
  },
  {
    code: "04-915",
    city: "Warszawa",
  },
  {
    code: "04-916",
    city: "Warszawa",
  },
  {
    code: "04-917",
    city: "Warszawa",
  },
  {
    code: "04-918",
    city: "Warszawa",
  },
  {
    code: "04-919",
    city: "Warszawa",
  },
  {
    code: "04-920",
    city: "Warszawa",
  },
  {
    code: "04-921",
    city: "Warszawa",
  },
  {
    code: "04-922",
    city: "Warszawa",
  },
  {
    code: "04-923",
    city: "Warszawa",
  },
  {
    code: "04-924",
    city: "Warszawa",
  },
  {
    code: "04-925",
    city: "Warszawa",
  },
  {
    code: "04-926",
    city: "Warszawa",
  },
  {
    code: "04-927",
    city: "Warszawa",
  },
  {
    code: "04-928",
    city: "Warszawa",
  },
  {
    code: "04-929",
    city: "Warszawa",
  },
  {
    code: "04-930",
    city: "Warszawa",
  },
  {
    code: "04-931",
    city: "Warszawa",
  },
  {
    code: "04-932",
    city: "Warszawa",
  },
  {
    code: "04-933",
    city: "Warszawa",
  },
  {
    code: "04-934",
    city: "Warszawa",
  },
  {
    code: "04-935",
    city: "Warszawa",
  },
  {
    code: "04-936",
    city: "Warszawa",
  },
  {
    code: "04-937",
    city: "Warszawa",
  },
  {
    code: "04-938",
    city: "Warszawa",
  },
  {
    code: "04-939",
    city: "Warszawa",
  },
  {
    code: "04-940",
    city: "Warszawa",
  },
  {
    code: "04-941",
    city: "Warszawa",
  },
  {
    code: "04-942",
    city: "Warszawa",
  },
  {
    code: "04-943",
    city: "Warszawa",
  },
  {
    code: "04-944",
    city: "Warszawa",
  },
  {
    code: "04-946",
    city: "Warszawa",
  },
  {
    code: "04-947",
    city: "Warszawa",
  },
  {
    code: "04-948",
    city: "Warszawa",
  },
  {
    code: "04-949",
    city: "Warszawa",
  },
  {
    code: "04-950",
    city: "Warszawa",
  },
  {
    code: "04-951",
    city: "Warszawa",
  },
  {
    code: "04-952",
    city: "Warszawa",
  },
  {
    code: "04-953",
    city: "Warszawa",
  },
  {
    code: "04-954",
    city: "Warszawa",
  },
  {
    code: "04-955",
    city: "Warszawa",
  },
  {
    code: "04-956",
    city: "Warszawa",
  },
  {
    code: "04-957",
    city: "Warszawa",
  },
  {
    code: "04-958",
    city: "Warszawa",
  },
  {
    code: "04-959",
    city: "Warszawa",
  },
  {
    code: "04-960",
    city: "Warszawa",
  },
  {
    code: "04-961",
    city: "Warszawa",
  },
  {
    code: "04-962",
    city: "Warszawa",
  },
  {
    code: "04-963",
    city: "Warszawa",
  },
  {
    code: "04-964",
    city: "Warszawa",
  },
  {
    code: "04-965",
    city: "Warszawa",
  },
  {
    code: "04-966",
    city: "Warszawa",
  },
  {
    code: "04-967",
    city: "Warszawa",
  },
  {
    code: "04-968",
    city: "Warszawa",
  },
  {
    code: "04-969",
    city: "Warszawa",
  },
  {
    code: "04-970",
    city: "Warszawa",
  },
  {
    code: "04-971",
    city: "Warszawa",
  },
  {
    code: "04-972",
    city: "Warszawa",
  },
  {
    code: "04-973",
    city: "Warszawa",
  },
  {
    code: "04-974",
    city: "Warszawa",
  },
  {
    code: "04-975",
    city: "Warszawa",
  },
  {
    code: "04-976",
    city: "Warszawa",
  },
  {
    code: "04-977",
    city: "Warszawa",
  },
  {
    code: "04-979",
    city: "Warszawa",
  },
  {
    code: "04-980",
    city: "Warszawa",
  },
  {
    code: "04-981",
    city: "Warszawa",
  },
  {
    code: "04-982",
    city: "Warszawa",
  },
  {
    code: "04-983",
    city: "Warszawa",
  },
  {
    code: "04-984",
    city: "Warszawa",
  },
  {
    code: "04-985",
    city: "Warszawa",
  },
  {
    code: "04-986",
    city: "Warszawa",
  },
  {
    code: "04-987",
    city: "Warszawa",
  },
  {
    code: "04-988",
    city: "Warszawa",
  },
  {
    code: "04-989",
    city: "Warszawa",
  },
  {
    code: "04-990",
    city: "Warszawa",
  },
  {
    code: "04-991",
    city: "Warszawa",
  },
  {
    code: "04-992",
    city: "Warszawa",
  },
  {
    code: "04-993",
    city: "Warszawa",
  },
  {
    code: "04-994",
    city: "Warszawa",
  },
  {
    code: "04-995",
    city: "Warszawa",
  },
  {
    code: "04-996",
    city: "Warszawa",
  },
  {
    code: "04-997",
    city: "Warszawa",
  },
  {
    code: "04-998",
    city: "Warszawa",
  },
  {
    code: "05-070",
    city: "Sulejówek",
  },
  {
    code: "05-071",
    city: "Sulejówek",
  },
  {
    code: "05-074",
    city: "Halinów",
  },
  {
    code: "05-075",
    city: "Warszawa",
  },
  {
    code: "05-076",
    city: "Warszawa",
  },
  {
    code: "05-077",
    city: "Warszawa",
  },
  {
    code: "05-079",
    city: "Okuniew",
  },
  {
    code: "05-080",
    city: "Izabelin",
  },
  {
    code: "05-082",
    city: "Stare Babice",
  },
  {
    code: "05-083",
    city: "Zaborów",
  },
  {
    code: "05-084",
    city: "Leszno",
  },
  {
    code: "05-085",
    city: "Kampinos",
  },
  {
    code: "05-088",
    city: "Brochów",
  },
  {
    code: "05-089",
    city: "Tułowice",
  },
  {
    code: "05-090",
    city: "Raszyn",
  },
  {
    code: "05-091",
    city: "Ząbki",
  },
  {
    code: "05-092",
    city: "Łomianki",
  },
  {
    code: "05-093",
    city: "Ząbki",
  },
  {
    code: "05-094",
    city: "Janki",
  },
  {
    code: "05-100",
    city: "Nowy Dwór Mazowiecki",
  },
  {
    code: "05-101",
    city: "Nowy Dwór Mazowiecki",
  },
  {
    code: "05-102",
    city: "Nowy Dwór Mazowiecki",
  },
  {
    code: "05-110",
    city: "Jabłonna",
  },
  {
    code: "05-118",
    city: "Legionowo",
  },
  {
    code: "05-119",
    city: "Legionowo",
  },
  {
    code: "05-120",
    city: "Legionowo",
  },
  {
    code: "05-121",
    city: "Legionowo",
  },
  {
    code: "05-122",
    city: "Legionowo",
  },
  {
    code: "05-123",
    city: "Chotomów",
  },
  {
    code: "05-124",
    city: "Skrzeszew",
  },
  {
    code: "05-126",
    city: "Nieporęt",
  },
  {
    code: "05-127",
    city: "Białobrzegi",
  },
  {
    code: "05-130",
    city: "Zegrze Południowe",
  },
  {
    code: "05-131",
    city: "Zegrze",
  },
  {
    code: "05-135",
    city: "Wieliszew",
  },
  {
    code: "05-140",
    city: "Serock",
  },
  {
    code: "05-152",
    city: "Czosnów",
  },
  {
    code: "05-154",
    city: "Kazuń Nowy",
  },
  {
    code: "05-155",
    city: "Leoncin",
  },
  {
    code: "05-156",
    city: "Górki",
  },
  {
    code: "05-160",
    city: "Nowy Dwór Mazowiecki",
  },
  {
    code: "05-170",
    city: "Zakroczym",
  },
  {
    code: "05-180",
    city: "Pomiechówek",
  },
  {
    code: "05-190",
    city: "Nasielsk",
  },
  {
    code: "05-191",
    city: "Nasielsk",
  },
  {
    code: "05-192",
    city: "Cieksyn",
  },
  {
    code: "05-200",
    city: "Wołomin",
  },
  {
    code: "05-202",
    city: "Wołomin",
  },
  {
    code: "05-203",
    city: "Wołomin",
  },
  {
    code: "05-205",
    city: "Klembów",
  },
  {
    code: "05-220",
    city: "Zielonka",
  },
  {
    code: "05-230",
    city: "Kobyłka",
  },
  {
    code: "05-240",
    city: "Tłuszcz",
  },
  {
    code: "05-250",
    city: "Radzymin",
  },
  {
    code: "05-252",
    city: "Dąbrówka",
  },
  {
    code: "05-253",
    city: "Wola Rasztowska",
  },
  {
    code: "05-254",
    city: "Kuligów",
  },
  {
    code: "05-255",
    city: "Stare Załubice",
  },
  {
    code: "05-260",
    city: "Marki",
  },
  {
    code: "05-270",
    city: "Marki",
  },
  {
    code: "05-280",
    city: "Jadów",
  },
  {
    code: "05-281",
    city: "Urle",
  },
  {
    code: "05-282",
    city: "Strachówka",
  },
  {
    code: "05-300",
    city: "Mińsk Mazowiecki",
  },
  {
    code: "05-302",
    city: "Mińsk Mazowiecki",
  },
  {
    code: "05-303",
    city: "Mińsk Mazowiecki",
  },
  {
    code: "05-304",
    city: "Stanisławów",
  },
  {
    code: "05-305",
    city: "Pustelnik",
  },
  {
    code: "05-306",
    city: "Jakubów",
  },
  {
    code: "05-307",
    city: "Dobre",
  },
  {
    code: "05-310",
    city: "Kałuszyn",
  },
  {
    code: "05-311",
    city: "Dębe Wielkie",
  },
  {
    code: "05-317",
    city: "Jeruzal",
  },
  {
    code: "05-319",
    city: "Cegłów",
  },
  {
    code: "05-320",
    city: "Mrozy",
  },
  {
    code: "05-326",
    city: "Poświętne",
  },
  {
    code: "05-332",
    city: "Siennica",
  },
  {
    code: "05-334",
    city: "Latowicz",
  },
  {
    code: "05-340",
    city: "Kołbiel",
  },
  {
    code: "05-400",
    city: "Otwock",
  },
  {
    code: "05-401",
    city: "Otwock",
  },
  {
    code: "05-402",
    city: "Otwock",
  },
  {
    code: "05-408",
    city: "Glinianka",
  },
  {
    code: "05-410",
    city: "Józefów",
  },
  {
    code: "05-420",
    city: "Józefów",
  },
  {
    code: "05-430",
    city: "Celestynów",
  },
  {
    code: "05-462",
    city: "Wiązowna",
  },
  {
    code: "05-480",
    city: "Karczew",
  },
  {
    code: "05-500",
    city: "Piaseczno",
  },
  {
    code: "05-501",
    city: "Piaseczno",
  },
  {
    code: "05-502",
    city: "Piaseczno",
  },
  {
    code: "05-503",
    city: "Głosków",
  },
  {
    code: "05-504",
    city: "Złotokłos",
  },
  {
    code: "05-505",
    city: "Wola Prażmowska",
  },
  {
    code: "05-506",
    city: "Lesznowola",
  },
  {
    code: "05-507",
    city: "Słomczyn",
  },
  {
    code: "05-508",
    city: "Piaseczno",
  },
  {
    code: "05-509",
    city: "Piaseczno",
  },
  {
    code: "05-510",
    city: "Konstancin-Jeziorna",
  },
  {
    code: "05-520",
    city: "Konstancin-Jeziorna",
  },
  {
    code: "05-530",
    city: "Góra Kalwaria",
  },
  {
    code: "05-532",
    city: "Baniocha",
  },
  {
    code: "05-533",
    city: "Sobików",
  },
  {
    code: "05-540",
    city: "Zalesie Górne",
  },
  {
    code: "05-552",
    city: "Wólka Kosowska",
  },
  {
    code: "05-555",
    city: "Tarczyn",
  },
  {
    code: "05-600",
    city: "Grójec",
  },
  {
    code: "05-604",
    city: "Jasieniec",
  },
  {
    code: "05-610",
    city: "Goszczyn",
  },
  {
    code: "05-620",
    city: "Błędów",
  },
  {
    code: "05-622",
    city: "Belsk Duży",
  },
  {
    code: "05-640",
    city: "Mogielnica",
  },
  {
    code: "05-650",
    city: "Chynów",
  },
  {
    code: "05-651",
    city: "Drwalew",
  },
  {
    code: "05-652",
    city: "Pniewy",
  },
  {
    code: "05-660",
    city: "Warka",
  },
  {
    code: "05-800",
    city: "Pruszków",
  },
  {
    code: "05-802",
    city: "Pruszków",
  },
  {
    code: "05-803",
    city: "Pruszków",
  },
  {
    code: "05-804",
    city: "Pruszków",
  },
  {
    code: "05-805",
    city: "Otrębusy",
  },
  {
    code: "05-806",
    city: "Komorów",
  },
  {
    code: "05-807",
    city: "Podkowa Leśna",
  },
  {
    code: "05-816",
    city: "Michałowice",
  },
  {
    code: "05-819",
    city: "Piastów",
  },
  {
    code: "05-820",
    city: "Piastów",
  },
  {
    code: "05-822",
    city: "Milanówek",
  },
  {
    code: "05-824",
    city: "Tłuste",
  },
  {
    code: "05-825",
    city: "Grodzisk Mazowiecki",
  },
  {
    code: "05-826",
    city: "Grodzisk Mazowiecki",
  },
  {
    code: "05-827",
    city: "Grodzisk Mazowiecki",
  },
  {
    code: "05-830",
    city: "Nadarzyn",
  },
  {
    code: "05-831",
    city: "Młochów",
  },
  {
    code: "05-840",
    city: "Brwinów",
  },
  {
    code: "05-850",
    city: "Ożarów Mazowiecki",
  },
  {
    code: "05-860",
    city: "Płochocin",
  },
  {
    code: "05-870",
    city: "Błonie",
  },
  {
    code: "06-100",
    city: "Pułtusk",
  },
  {
    code: "06-102",
    city: "Pułtusk",
  },
  {
    code: "06-114",
    city: "Dzierżenin",
  },
  {
    code: "06-120",
    city: "Winnica",
  },
  {
    code: "06-121",
    city: "Pokrzywnica",
  },
  {
    code: "06-126",
    city: "Gzy",
  },
  {
    code: "06-150",
    city: "Świercze",
  },
  {
    code: "06-200",
    city: "Maków Mazowiecki",
  },
  {
    code: "06-210",
    city: "Płoniawy-Bramura",
  },
  {
    code: "06-211",
    city: "Krasiniec",
  },
  {
    code: "06-212",
    city: "Krasnosielc",
  },
  {
    code: "06-213",
    city: "Gąsewo Poduchowne",
  },
  {
    code: "06-214",
    city: "Drążdżewo",
  },
  {
    code: "06-216",
    city: "Sypniewo",
  },
  {
    code: "06-220",
    city: "Nowy Szelków",
  },
  {
    code: "06-225",
    city: "Rzewnie",
  },
  {
    code: "06-230",
    city: "Różan",
  },
  {
    code: "06-231",
    city: "Młynarze",
  },
  {
    code: "06-232",
    city: "Czerwonka Włościańska",
  },
  {
    code: "06-300",
    city: "Przasnysz",
  },
  {
    code: "06-301",
    city: "Przasnysz",
  },
  {
    code: "06-302",
    city: "Przasnysz",
  },
  {
    code: "06-316",
    city: "Krzynowłoga Mała",
  },
  {
    code: "06-320",
    city: "Baranowo",
  },
  {
    code: "06-322",
    city: "Lipa",
  },
  {
    code: "06-323",
    city: "Jednorożec",
  },
  {
    code: "06-330",
    city: "Chorzele",
  },
  {
    code: "06-333",
    city: "Zaręby",
  },
  {
    code: "06-400",
    city: "[[w:Ciechanów|Ciechanów]",
  },
  {
    code: "06-401",
    city: "Ciechanów",
  },
  {
    code: "06-402",
    city: "Ciechanów",
  },
  {
    code: "06-406",
    city: "Opinogóra Górna",
  },
  {
    code: "06-408",
    city: "Krasne",
  },
  {
    code: "06-409",
    city: "Ciechanów",
  },
  {
    code: "06-410",
    city: "Ciechanów",
  },
  {
    code: "06-413",
    city: "Ciechanów",
  },
  {
    code: "06-415",
    city: "Czernice Borowe",
  },
  {
    code: "06-420",
    city: "Gołymin-Ośrodek",
  },
  {
    code: "06-425",
    city: "Karniewo",
  },
  {
    code: "06-430",
    city: "Sońsk",
  },
  {
    code: "06-440",
    city: "Gąsocin",
  },
  {
    code: "06-445",
    city: "Strzegowo",
  },
  {
    code: "06-450",
    city: "Glinojeck",
  },
  {
    code: "06-452",
    city: "Ościsłowo",
  },
  {
    code: "06-456",
    city: "Ojrzeń",
  },
  {
    code: "06-458",
    city: "Niedzbórz",
  },
  {
    code: "06-460",
    city: "Grudusk",
  },
  {
    code: "06-461",
    city: "Regimin",
  },
  {
    code: "06-500",
    city: "Mława",
  },
  {
    code: "06-501",
    city: "Mława",
  },
  {
    code: "06-513",
    city: "Wieczfnia Kościelna",
  },
  {
    code: "06-516",
    city: "Szydłowo",
  },
  {
    code: "06-520",
    city: "Dzierzgowo",
  },
  {
    code: "06-521",
    city: "Wiśniewo",
  },
  {
    code: "06-522",
    city: "Dąbrowa",
  },
  {
    code: "06-540",
    city: "Radzanów",
  },
  {
    code: "06-545",
    city: "Lipowiec Kościelny",
  },
  {
    code: "06-550",
    city: "Szreńsk",
  },
  {
    code: "06-560",
    city: "Konopki",
  },
  {
    code: "06-561",
    city: "Stupsk",
  },
  {
    code: "06-562",
    city: "Wyszyny Kościelne",
  },
  {
    code: "07-100",
    city: "Węgrów",
  },
  {
    code: "07-104",
    city: "Stoczek",
  },
  {
    code: "07-106",
    city: "Miedzna",
  },
  {
    code: "07-110",
    city: "Grębków",
  },
  {
    code: "07-111",
    city: "Wierzbno",
  },
  {
    code: "07-120",
    city: "Korytnica",
  },
  {
    code: "07-130",
    city: "Łochów",
  },
  {
    code: "07-132",
    city: "Ostrówek",
  },
  {
    code: "07-140",
    city: "Sadowne",
  },
  {
    code: "07-200",
    city: "Wyszków",
  },
  {
    code: "07-201",
    city: "Wyszków",
  },
  {
    code: "07-202",
    city: "Wyszków",
  },
  {
    code: "07-203",
    city: "Somianka",
  },
  {
    code: "07-204",
    city: "Popowo Kościelne",
  },
  {
    code: "07-205",
    city: "Rząśnik",
  },
  {
    code: "07-206",
    city: "Wola Mystkowska",
  },
  {
    code: "07-207",
    city: "Nowy Lubiel",
  },
  {
    code: "07-210",
    city: "Długosiodło",
  },
  {
    code: "07-211",
    city: "Dalekie",
  },
  {
    code: "07-214",
    city: "Pniewo",
  },
  {
    code: "07-215",
    city: "Obryte",
  },
  {
    code: "07-217",
    city: "Zatory",
  },
  {
    code: "07-220",
    city: "Kamieńczyk",
  },
  {
    code: "07-221",
    city: "Brańszczyk",
  },
  {
    code: "07-230",
    city: "Zabrodzie",
  },
  {
    code: "07-300",
    city: "Ostrów Mazowiecka",
  },
  {
    code: "07-302",
    city: "Jelonki",
  },
  {
    code: "07-303",
    city: "Lubotyń",
  },
  {
    code: "07-304",
    city: "Jasienica",
  },
  {
    code: "07-305",
    city: "Andrychów",
  },
  {
    code: "07-306",
    city: "Brok",
  },
  {
    code: "07-308",
    city: "Poręba-Kocęby",
  },
  {
    code: "07-310",
    city: "Ostrów Mazowiecka",
  },
  {
    code: "07-311",
    city: "Wąsewo",
  },
  {
    code: "07-319",
    city: "Prostyń",
  },
  {
    code: "07-320",
    city: "Małkinia",
  },
  {
    code: "07-321",
    city: "Zuzela",
  },
  {
    code: "07-322",
    city: "Nur",
  },
  {
    code: "07-323",
    city: "Zaręby Kościelne",
  },
  {
    code: "07-324",
    city: "Szulborze Wielkie",
  },
  {
    code: "07-325",
    city: "Boguty-Pianki",
  },
  {
    code: "07-400",
    city: "Ostrołęka",
  },
  {
    code: "07-401",
    city: "Ostrołęka",
  },
  {
    code: "07-402",
    city: "Lelis",
  },
  {
    code: "07-405",
    city: "Troszyn",
  },
  {
    code: "07-406",
    city: "Piski",
  },
  {
    code: "07-407",
    city: "Czerwin",
  },
  {
    code: "07-409",
    city: "Ostrołęka",
  },
  {
    code: "07-410",
    city: "Ostrołęka",
  },
  {
    code: "07-411",
    city: "Rzekuń",
  },
  {
    code: "07-412",
    city: "Ostrołęka",
  },
  {
    code: "07-413",
    city: "Ostrołęka",
  },
  {
    code: "07-415",
    city: "Olszewo-Borki",
  },
  {
    code: "07-416",
    city: "Nowa Wieś",
  },
  {
    code: "07-417",
    city: "Ostrołęka",
  },
  {
    code: "07-420",
    city: "Kadzidło",
  },
  {
    code: "07-430",
    city: "Myszyniec",
  },
  {
    code: "07-431",
    city: "Czarnia",
  },
  {
    code: "07-436",
    city: "Lipniki",
  },
  {
    code: "07-437",
    city: "Łyse",
  },
  {
    code: "07-438",
    city: "Zalas",
  },
  {
    code: "07-440",
    city: "Goworowo",
  },
  {
    code: "08-100",
    city: "Siedlce",
  },
  {
    code: "08-101",
    city: "Siedlce",
  },
  {
    code: "08-102",
    city: "Siedlce",
  },
  {
    code: "08-103",
    city: "Siedlce",
  },
  {
    code: "08-104",
    city: "Krześlin",
  },
  {
    code: "08-106",
    city: "Zbuczyn",
  },
  {
    code: "08-107",
    city: "Paprotnia",
  },
  {
    code: "08-108",
    city: "Korczew",
  },
  {
    code: "08-109",
    city: "Przesmyki",
  },
  {
    code: "08-110",
    city: "Siedlce",
  },
  {
    code: "08-111",
    city: "Krzesk-Królowa Niwa",
  },
  {
    code: "08-112",
    city: "Wiśniew",
  },
  {
    code: "08-113",
    city: "Domanice",
  },
  {
    code: "08-114",
    city: "Skórzec",
  },
  {
    code: "08-116",
    city: "Seroczyn",
  },
  {
    code: "08-117",
    city: "Wodynie",
  },
  {
    code: "08-119",
    city: "Siedlce",
  },
  {
    code: "08-122",
    city: "Bojmie",
  },
  {
    code: "08-124",
    city: "Mokobody",
  },
  {
    code: "08-125",
    city: "Suchożebry",
  },
  {
    code: "08-130",
    city: "Kotuń",
  },
  {
    code: "08-140",
    city: "Mordy",
  },
  {
    code: "08-142",
    city: "Czuryły",
  },
  {
    code: "08-200",
    city: "Łosice",
  },
  {
    code: "08-205",
    city: "Stara Kornica",
  },
  {
    code: "08-206",
    city: "Huszlew",
  },
  {
    code: "08-207",
    city: "Olszanka",
  },
  {
    code: "08-210",
    city: "Platerów",
  },
  {
    code: "08-220",
    city: "Sarnaki",
  },
  {
    code: "08-221",
    city: "Hołowczyce-Kolonia",
  },
  {
    code: "08-300",
    city: "Sokołów Podlaski",
  },
  {
    code: "08-301",
    city: "Sokołów Podlaski",
  },
  {
    code: "08-304",
    city: "Jabłonna Lacka",
  },
  {
    code: "08-307",
    city: "Repki",
  },
  {
    code: "08-311",
    city: "Bielany-Jarosławy",
  },
  {
    code: "08-320",
    city: "Sterdyń-Osada",
  },
  {
    code: "08-322",
    city: "Ceranów",
  },
  {
    code: "08-330",
    city: "Kosów Lacki",
  },
  {
    code: "08-331",
    city: "Sabnie",
  },
  {
    code: "08-400",
    city: "Garwolin",
  },
  {
    code: "08-404",
    city: "Górzno",
  },
  {
    code: "08-410",
    city: "Wola Rębkowska",
  },
  {
    code: "08-412",
    city: "Borowie",
  },
  {
    code: "08-420",
    city: "Miastków Kościelny",
  },
  {
    code: "08-430",
    city: "Żelechów",
  },
  {
    code: "08-440",
    city: "Pilawa",
  },
  {
    code: "08-441",
    city: "Parysów",
  },
  {
    code: "08-443",
    city: "Sobienie-Jeziory",
  },
  {
    code: "08-445",
    city: "Osieck",
  },
  {
    code: "08-450",
    city: "Łaskarzew",
  },
  {
    code: "08-455",
    city: "Trojanów",
  },
  {
    code: "08-460",
    city: "Sobolew",
  },
  {
    code: "08-470",
    city: "Wilga",
  },
  {
    code: "08-480",
    city: "Maciejowice",
  },
  {
    code: "08-500",
    city: "Ryki",
  },
  {
    code: "08-503",
    city: "Nowodwór",
  },
  {
    code: "08-504",
    city: "Ułęż",
  },
  {
    code: "08-505",
    city: "Dęblin",
  },
  {
    code: "08-521",
    city: "Dęblin",
  },
  {
    code: "08-530",
    city: "Dęblin",
  },
  {
    code: "08-540",
    city: "Stężyca",
  },
  {
    code: "08-550",
    city: "Kłoczew",
  },
  {
    code: "09-100",
    city: "Płońsk",
  },
  {
    code: "09-101",
    city: "Płońsk",
  },
  {
    code: "09-105",
    city: "Dziektarzewo",
  },
  {
    code: "09-110",
    city: "Sochocin",
  },
  {
    code: "09-120",
    city: "Nowe Miasto",
  },
  {
    code: "09-130",
    city: "Baboszewo",
  },
  {
    code: "09-131",
    city: "Joniec",
  },
  {
    code: "09-135",
    city: "Siemiątkowo Koziebrodzkie",
  },
  {
    code: "09-140",
    city: "Raciąż",
  },
  {
    code: "09-141",
    city: "Szczytno koło Płońska",
  },
  {
    code: "09-142",
    city: "Załuski",
  },
  {
    code: "09-150",
    city: "Czerwińsk nad Wisłą",
  },
  {
    code: "09-151",
    city: "Grodziec",
  },
  {
    code: "09-152",
    city: "Naruszewo",
  },
  {
    code: "09-162",
    city: "Nacpolsk",
  },
  {
    code: "09-164",
    city: "Dzierzążnia",
  },
  {
    code: "09-166",
    city: "Stare Gralewo",
  },
  {
    code: "09-200",
    city: "Sierpc",
  },
  {
    code: "09-204",
    city: "Rościszewo",
  },
  {
    code: "09-205",
    city: "Jeżewo",
  },
  {
    code: "09-206",
    city: "Słupia",
  },
  {
    code: "09-209",
    city: "Łęg Probostwo",
  },
  {
    code: "09-210",
    city: "Drobin",
  },
  {
    code: "09-212",
    city: "Lelice",
  },
  {
    code: "09-213",
    city: "Gozdowo",
  },
  {
    code: "09-214",
    city: "Mochowo",
  },
  {
    code: "09-215",
    city: "Bożewo",
  },
  {
    code: "09-216",
    city: "Gójsk",
  },
  {
    code: "09-226",
    city: "Zawidz Kościelny",
  },
  {
    code: "09-227",
    city: "Szczutowo",
  },
  {
    code: "09-228",
    city: "Ligowo",
  },
  {
    code: "09-230",
    city: "Bielsk",
  },
  {
    code: "09-300",
    city: "Żuromin",
  },
  {
    code: "09-303",
    city: "Syberia",
  },
  {
    code: "09-304",
    city: "Lubowidz",
  },
  {
    code: "09-310",
    city: "Kuczbork-Osada",
  },
  {
    code: "09-311",
    city: "Zielona",
  },
  {
    code: "09-317",
    city: "Lutocin",
  },
  {
    code: "09-320",
    city: "Bieżuń",
  },
  {
    code: "09-400",
    city: "Płock",
  },
  {
    code: "09-401",
    city: "Płock",
  },
  {
    code: "09-402",
    city: "Płock",
  },
  {
    code: "09-403",
    city: "Płock",
  },
  {
    code: "09-404",
    city: "Płock",
  },
  {
    code: "09-405",
    city: "Płock",
  },
  {
    code: "09-406",
    city: "Płock",
  },
  {
    code: "09-407",
    city: "Płock",
  },
  {
    code: "09-408",
    city: "Płock",
  },
  {
    code: "09-409",
    city: "Płock",
  },
  {
    code: "09-410",
    city: "Płock",
  },
  {
    code: "09-411",
    city: "Biała",
  },
  {
    code: "09-412",
    city: "Nowe Proboszczewice",
  },
  {
    code: "09-413",
    city: "Sikórz",
  },
  {
    code: "09-414",
    city: "Brudzeń",
  },
  {
    code: "09-416",
    city: "Siecień",
  },
  {
    code: "09-440",
    city: "Staroźreby",
  },
  {
    code: "09-442",
    city: "Rogozino",
  },
  {
    code: "09-450",
    city: "Wyszogród",
  },
  {
    code: "09-451",
    city: "Radzanowo",
  },
  {
    code: "09-452",
    city: "Blichowo",
  },
  {
    code: "09-454",
    city: "Bulkowo",
  },
  {
    code: "09-460",
    city: "Mała Wieś",
  },
  {
    code: "09-470",
    city: "Bodzanów",
  },
  {
    code: "09-471",
    city: "Miszewo Murowane",
  },
  {
    code: "09-472",
    city: "Słupno",
  },
  {
    code: "09-500",
    city: "Gostynin",
  },
  {
    code: "09-504",
    city: "Lucień",
  },
  {
    code: "09-505",
    city: "Nowy Duninów",
  },
  {
    code: "09-506",
    city: "Soczewka",
  },
  {
    code: "09-520",
    city: "Łąck",
  },
  {
    code: "09-522",
    city: "Dobrzyków",
  },
  {
    code: "09-530",
    city: "Gąbin",
  },
  {
    code: "09-533",
    city: "Słubice",
  },
  {
    code: "09-540",
    city: "Sanniki",
  },
  {
    code: "09-541",
    city: "Pacyna",
  },
  {
    code: "09-542",
    city: "Lipińskie",
  },
  {
    code: "09-543",
    city: "Skrzeszewy",
  },
  {
    code: "09-550",
    city: "Szczawin",
  },
  {
    code: "10-001",
    city: "Olsztyn",
  },
  {
    code: "10-003",
    city: "Olsztyn",
  },
  {
    code: "10-004",
    city: "Olsztyn",
  },
  {
    code: "10-005",
    city: "Olsztyn",
  },
  {
    code: "10-006",
    city: "Olsztyn",
  },
  {
    code: "10-007",
    city: "Olsztyn",
  },
  {
    code: "10-008",
    city: "Olsztyn",
  },
  {
    code: "10-009",
    city: "Olsztyn",
  },
  {
    code: "10-010",
    city: "Olsztyn",
  },
  {
    code: "10-011",
    city: "Olsztyn",
  },
  {
    code: "10-012",
    city: "Olsztyn",
  },
  {
    code: "10-013",
    city: "Olsztyn",
  },
  {
    code: "10-014",
    city: "Olsztyn",
  },
  {
    code: "10-015",
    city: "Olsztyn",
  },
  {
    code: "10-016",
    city: "Olsztyn",
  },
  {
    code: "10-017",
    city: "Olsztyn",
  },
  {
    code: "10-018",
    city: "Olsztyn",
  },
  {
    code: "10-019",
    city: "Olsztyn",
  },
  {
    code: "10-020",
    city: "Olsztyn",
  },
  {
    code: "10-021",
    city: "Olsztyn",
  },
  {
    code: "10-022",
    city: "Olsztyn",
  },
  {
    code: "10-023",
    city: "Olsztyn",
  },
  {
    code: "10-024",
    city: "Olsztyn",
  },
  {
    code: "10-025",
    city: "Olsztyn",
  },
  {
    code: "10-026",
    city: "Olsztyn",
  },
  {
    code: "10-027",
    city: "Olsztyn",
  },
  {
    code: "10-028",
    city: "Olsztyn",
  },
  {
    code: "10-029",
    city: "Olsztyn",
  },
  {
    code: "10-030",
    city: "Olsztyn",
  },
  {
    code: "10-031",
    city: "Olsztyn",
  },
  {
    code: "10-032",
    city: "Olsztyn",
  },
  {
    code: "10-033",
    city: "Olsztyn",
  },
  {
    code: "10-034",
    city: "Olsztyn",
  },
  {
    code: "10-035",
    city: "Olsztyn",
  },
  {
    code: "10-036",
    city: "Olsztyn",
  },
  {
    code: "10-037",
    city: "Olsztyn",
  },
  {
    code: "10-038",
    city: "Olsztyn",
  },
  {
    code: "10-039",
    city: "Olsztyn",
  },
  {
    code: "10-040",
    city: "Olsztyn",
  },
  {
    code: "10-041",
    city: "Olsztyn",
  },
  {
    code: "10-042",
    city: "Olsztyn",
  },
  {
    code: "10-043",
    city: "Olsztyn",
  },
  {
    code: "10-044",
    city: "Olsztyn",
  },
  {
    code: "10-045",
    city: "Olsztyn",
  },
  {
    code: "10-046",
    city: "Olsztyn",
  },
  {
    code: "10-047",
    city: "Olsztyn",
  },
  {
    code: "10-048",
    city: "Olsztyn",
  },
  {
    code: "10-049",
    city: "Olsztyn",
  },
  {
    code: "10-050",
    city: "Olsztyn",
  },
  {
    code: "10-051",
    city: "Olsztyn",
  },
  {
    code: "10-052",
    city: "Olsztyn",
  },
  {
    code: "10-053",
    city: "Olsztyn",
  },
  {
    code: "10-054",
    city: "Olsztyn",
  },
  {
    code: "10-055",
    city: "Olsztyn",
  },
  {
    code: "10-056",
    city: "Olsztyn",
  },
  {
    code: "10-057",
    city: "Olsztyn",
  },
  {
    code: "10-059",
    city: "Olsztyn",
  },
  {
    code: "10-061",
    city: "Olsztyn",
  },
  {
    code: "10-062",
    city: "Olsztyn",
  },
  {
    code: "10-063",
    city: "Olsztyn",
  },
  {
    code: "10-064",
    city: "Olsztyn",
  },
  {
    code: "10-065",
    city: "Olsztyn",
  },
  {
    code: "10-066",
    city: "Olsztyn",
  },
  {
    code: "10-067",
    city: "Olsztyn",
  },
  {
    code: "10-068",
    city: "Olsztyn",
  },
  {
    code: "10-069",
    city: "Olsztyn",
  },
  {
    code: "10-070",
    city: "Olsztyn",
  },
  {
    code: "10-072",
    city: "Olsztyn",
  },
  {
    code: "10-073",
    city: "Olsztyn",
  },
  {
    code: "10-074",
    city: "Olsztyn",
  },
  {
    code: "10-075",
    city: "Olsztyn",
  },
  {
    code: "10-076",
    city: "Olsztyn",
  },
  {
    code: "10-077",
    city: "Olsztyn",
  },
  {
    code: "10-078",
    city: "Olsztyn",
  },
  {
    code: "10-079",
    city: "Olsztyn",
  },
  {
    code: "10-080",
    city: "Olsztyn",
  },
  {
    code: "10-081",
    city: "Olsztyn",
  },
  {
    code: "10-082",
    city: "Olsztyn",
  },
  {
    code: "10-083",
    city: "Olsztyn",
  },
  {
    code: "10-084",
    city: "Olsztyn",
  },
  {
    code: "10-085",
    city: "Olsztyn",
  },
  {
    code: "10-086",
    city: "Olsztyn",
  },
  {
    code: "10-087",
    city: "Olsztyn",
  },
  {
    code: "10-088",
    city: "Olsztyn",
  },
  {
    code: "10-089",
    city: "Olsztyn",
  },
  {
    code: "10-090",
    city: "Olsztyn",
  },
  {
    code: "10-091",
    city: "Olsztyn",
  },
  {
    code: "10-092",
    city: "Olsztyn",
  },
  {
    code: "10-101",
    city: "Olsztyn",
  },
  {
    code: "10-102",
    city: "Olsztyn",
  },
  {
    code: "10-103",
    city: "Olsztyn",
  },
  {
    code: "10-104",
    city: "Olsztyn",
  },
  {
    code: "10-105",
    city: "Olsztyn",
  },
  {
    code: "10-106",
    city: "Olsztyn",
  },
  {
    code: "10-109",
    city: "Olsztyn",
  },
  {
    code: "10-110",
    city: "Olsztyn",
  },
  {
    code: "10-111",
    city: "Olsztyn",
  },
  {
    code: "10-112",
    city: "Olsztyn",
  },
  {
    code: "10-113",
    city: "Olsztyn",
  },
  {
    code: "10-114",
    city: "Olsztyn",
  },
  {
    code: "10-115",
    city: "Olsztyn",
  },
  {
    code: "10-116",
    city: "Olsztyn",
  },
  {
    code: "10-117",
    city: "Olsztyn",
  },
  {
    code: "10-118",
    city: "Olsztyn",
  },
  {
    code: "10-119",
    city: "Olsztyn",
  },
  {
    code: "10-120",
    city: "Olsztyn",
  },
  {
    code: "10-121",
    city: "Olsztyn",
  },
  {
    code: "10-123",
    city: "Olsztyn",
  },
  {
    code: "10-124",
    city: "Olsztyn",
  },
  {
    code: "10-125",
    city: "Olsztyn",
  },
  {
    code: "10-126",
    city: "Olsztyn",
  },
  {
    code: "10-127",
    city: "Olsztyn",
  },
  {
    code: "10-129",
    city: "Olsztyn",
  },
  {
    code: "10-130",
    city: "Olsztyn",
  },
  {
    code: "10-131",
    city: "Olsztyn",
  },
  {
    code: "10-132",
    city: "Olsztyn",
  },
  {
    code: "10-133",
    city: "Olsztyn",
  },
  {
    code: "10-135",
    city: "Olsztyn",
  },
  {
    code: "10-136",
    city: "Olsztyn",
  },
  {
    code: "10-137",
    city: "Olsztyn",
  },
  {
    code: "10-138",
    city: "Olsztyn",
  },
  {
    code: "10-139",
    city: "Olsztyn",
  },
  {
    code: "10-140",
    city: "Olsztyn",
  },
  {
    code: "10-141",
    city: "Olsztyn",
  },
  {
    code: "10-142",
    city: "Olsztyn",
  },
  {
    code: "10-143",
    city: "Olsztyn",
  },
  {
    code: "10-144",
    city: "Olsztyn",
  },
  {
    code: "10-145",
    city: "Olsztyn",
  },
  {
    code: "10-147",
    city: "Olsztyn",
  },
  {
    code: "10-148",
    city: "Olsztyn",
  },
  {
    code: "10-149",
    city: "Olsztyn",
  },
  {
    code: "10-150",
    city: "Olsztyn",
  },
  {
    code: "10-151",
    city: "Olsztyn",
  },
  {
    code: "10-153",
    city: "Olsztyn",
  },
  {
    code: "10-154",
    city: "Olsztyn",
  },
  {
    code: "10-155",
    city: "Olsztyn",
  },
  {
    code: "10-156",
    city: "Olsztyn",
  },
  {
    code: "10-157",
    city: "Olsztyn",
  },
  {
    code: "10-158",
    city: "Olsztyn",
  },
  {
    code: "10-159",
    city: "Olsztyn",
  },
  {
    code: "10-160",
    city: "Olsztyn",
  },
  {
    code: "10-161",
    city: "Olsztyn",
  },
  {
    code: "10-162",
    city: "Olsztyn",
  },
  {
    code: "10-163",
    city: "Olsztyn",
  },
  {
    code: "10-164",
    city: "Olsztyn",
  },
  {
    code: "10-165",
    city: "Olsztyn",
  },
  {
    code: "10-166",
    city: "Olsztyn",
  },
  {
    code: "10-167",
    city: "Olsztyn",
  },
  {
    code: "10-168",
    city: "Olsztyn",
  },
  {
    code: "10-169",
    city: "Olsztyn",
  },
  {
    code: "10-170",
    city: "Olsztyn",
  },
  {
    code: "10-171",
    city: "Olsztyn",
  },
  {
    code: "10-172",
    city: "Olsztyn",
  },
  {
    code: "10-173",
    city: "Olsztyn",
  },
  {
    code: "10-174",
    city: "Olsztyn",
  },
  {
    code: "10-175",
    city: "Olsztyn",
  },
  {
    code: "10-176",
    city: "Olsztyn",
  },
  {
    code: "10-177",
    city: "Olsztyn",
  },
  {
    code: "10-178",
    city: "Olsztyn",
  },
  {
    code: "10-179",
    city: "Olsztyn",
  },
  {
    code: "10-180",
    city: "Olsztyn",
  },
  {
    code: "10-181",
    city: "Olsztyn",
  },
  {
    code: "10-182",
    city: "Olsztyn",
  },
  {
    code: "10-183",
    city: "Olsztyn",
  },
  {
    code: "10-184",
    city: "Olsztyn",
  },
  {
    code: "10-185",
    city: "Olsztyn",
  },
  {
    code: "10-186",
    city: "Olsztyn",
  },
  {
    code: "10-187",
    city: "Olsztyn",
  },
  {
    code: "10-188",
    city: "Olsztyn",
  },
  {
    code: "10-189",
    city: "Olsztyn",
  },
  {
    code: "10-190",
    city: "Olsztyn",
  },
  {
    code: "10-191",
    city: "Olsztyn",
  },
  {
    code: "10-192",
    city: "Olsztyn",
  },
  {
    code: "10-201",
    city: "Olsztyn",
  },
  {
    code: "10-202",
    city: "Olsztyn",
  },
  {
    code: "10-203",
    city: "Olsztyn",
  },
  {
    code: "10-204",
    city: "Olsztyn",
  },
  {
    code: "10-205",
    city: "Olsztyn",
  },
  {
    code: "10-206",
    city: "Olsztyn",
  },
  {
    code: "10-207",
    city: "Olsztyn",
  },
  {
    code: "10-208",
    city: "Olsztyn",
  },
  {
    code: "10-209",
    city: "Olsztyn",
  },
  {
    code: "10-210",
    city: "Olsztyn",
  },
  {
    code: "10-211",
    city: "Olsztyn",
  },
  {
    code: "10-212",
    city: "Olsztyn",
  },
  {
    code: "10-213",
    city: "Olsztyn",
  },
  {
    code: "10-214",
    city: "Olsztyn",
  },
  {
    code: "10-215",
    city: "Olsztyn",
  },
  {
    code: "10-216",
    city: "Olsztyn",
  },
  {
    code: "10-217",
    city: "Olsztyn",
  },
  {
    code: "10-218",
    city: "Olsztyn",
  },
  {
    code: "10-219",
    city: "Olsztyn",
  },
  {
    code: "10-220",
    city: "Olsztyn",
  },
  {
    code: "10-221",
    city: "Olsztyn",
  },
  {
    code: "10-222",
    city: "Olsztyn",
  },
  {
    code: "10-223",
    city: "Olsztyn",
  },
  {
    code: "10-224",
    city: "Olsztyn",
  },
  {
    code: "10-225",
    city: "Olsztyn",
  },
  {
    code: "10-226",
    city: "Olsztyn",
  },
  {
    code: "10-227",
    city: "Olsztyn",
  },
  {
    code: "10-228",
    city: "Olsztyn",
  },
  {
    code: "10-229",
    city: "Olsztyn",
  },
  {
    code: "10-230",
    city: "Olsztyn",
  },
  {
    code: "10-232",
    city: "Olsztyn",
  },
  {
    code: "10-233",
    city: "Olsztyn",
  },
  {
    code: "10-234",
    city: "Olsztyn",
  },
  {
    code: "10-235",
    city: "Olsztyn",
  },
  {
    code: "10-236",
    city: "Olsztyn",
  },
  {
    code: "10-237",
    city: "Olsztyn",
  },
  {
    code: "10-238",
    city: "Olsztyn",
  },
  {
    code: "10-239",
    city: "Olsztyn",
  },
  {
    code: "10-240",
    city: "Olsztyn",
  },
  {
    code: "10-241",
    city: "Olsztyn",
  },
  {
    code: "10-242",
    city: "Olsztyn",
  },
  {
    code: "10-243",
    city: "Olsztyn",
  },
  {
    code: "10-244",
    city: "Olsztyn",
  },
  {
    code: "10-245",
    city: "Olsztyn",
  },
  {
    code: "10-246",
    city: "Olsztyn",
  },
  {
    code: "10-247",
    city: "Olsztyn",
  },
  {
    code: "10-248",
    city: "Olsztyn",
  },
  {
    code: "10-249",
    city: "Olsztyn",
  },
  {
    code: "10-250",
    city: "Olsztyn",
  },
  {
    code: "10-251",
    city: "Olsztyn",
  },
  {
    code: "10-252",
    city: "Olsztyn",
  },
  {
    code: "10-253",
    city: "Olsztyn",
  },
  {
    code: "10-254",
    city: "Olsztyn",
  },
  {
    code: "10-255",
    city: "Olsztyn",
  },
  {
    code: "10-256",
    city: "Olsztyn",
  },
  {
    code: "10-257",
    city: "Olsztyn",
  },
  {
    code: "10-258",
    city: "Olsztyn",
  },
  {
    code: "10-259",
    city: "Olsztyn",
  },
  {
    code: "10-260",
    city: "Olsztyn",
  },
  {
    code: "10-261",
    city: "Olsztyn",
  },
  {
    code: "10-262",
    city: "Olsztyn",
  },
  {
    code: "10-266",
    city: "Olsztyn",
  },
  {
    code: "10-267",
    city: "Olsztyn",
  },
  {
    code: "10-268",
    city: "Olsztyn",
  },
  {
    code: "10-269",
    city: "Olsztyn",
  },
  {
    code: "10-270",
    city: "Olsztyn",
  },
  {
    code: "10-271",
    city: "Olsztyn",
  },
  {
    code: "10-272",
    city: "Olsztyn",
  },
  {
    code: "10-273",
    city: "Olsztyn",
  },
  {
    code: "10-274",
    city: "Olsztyn",
  },
  {
    code: "10-275",
    city: "Olsztyn",
  },
  {
    code: "10-276",
    city: "Olsztyn",
  },
  {
    code: "10-277",
    city: "Olsztyn",
  },
  {
    code: "10-278",
    city: "Olsztyn",
  },
  {
    code: "10-279",
    city: "Olsztyn",
  },
  {
    code: "10-280",
    city: "Olsztyn",
  },
  {
    code: "10-281",
    city: "Olsztyn",
  },
  {
    code: "10-282",
    city: "Olsztyn",
  },
  {
    code: "10-283",
    city: "Olsztyn",
  },
  {
    code: "10-284",
    city: "Olsztyn",
  },
  {
    code: "10-285",
    city: "Olsztyn",
  },
  {
    code: "10-286",
    city: "Olsztyn",
  },
  {
    code: "10-287",
    city: "Olsztyn",
  },
  {
    code: "10-288",
    city: "Olsztyn",
  },
  {
    code: "10-290",
    city: "Olsztyn",
  },
  {
    code: "10-291",
    city: "Olsztyn",
  },
  {
    code: "10-292",
    city: "Olsztyn",
  },
  {
    code: "10-293",
    city: "Olsztyn",
  },
  {
    code: "10-294",
    city: "Olsztyn",
  },
  {
    code: "10-295",
    city: "Olsztyn",
  },
  {
    code: "10-301",
    city: "Olsztyn",
  },
  {
    code: "10-302",
    city: "Olsztyn",
  },
  {
    code: "10-303",
    city: "Olsztyn",
  },
  {
    code: "10-304",
    city: "Olsztyn",
  },
  {
    code: "10-305",
    city: "Olsztyn",
  },
  {
    code: "10-306",
    city: "Olsztyn",
  },
  {
    code: "10-307",
    city: "Olsztyn",
  },
  {
    code: "10-308",
    city: "Olsztyn",
  },
  {
    code: "10-309",
    city: "Olsztyn",
  },
  {
    code: "10-310",
    city: "Olsztyn",
  },
  {
    code: "10-313",
    city: "Olsztyn",
  },
  {
    code: "10-314",
    city: "Olsztyn",
  },
  {
    code: "10-315",
    city: "Olsztyn",
  },
  {
    code: "10-316",
    city: "Olsztyn",
  },
  {
    code: "10-319",
    city: "Olsztyn",
  },
  {
    code: "10-320",
    city: "Olsztyn",
  },
  {
    code: "10-321",
    city: "Olsztyn",
  },
  {
    code: "10-322",
    city: "Olsztyn",
  },
  {
    code: "10-323",
    city: "Olsztyn",
  },
  {
    code: "10-324",
    city: "Olsztyn",
  },
  {
    code: "10-325",
    city: "Olsztyn",
  },
  {
    code: "10-326",
    city: "Olsztyn",
  },
  {
    code: "10-327",
    city: "Olsztyn",
  },
  {
    code: "10-329",
    city: "Olsztyn",
  },
  {
    code: "10-330",
    city: "Olsztyn",
  },
  {
    code: "10-332",
    city: "Olsztyn",
  },
  {
    code: "10-333",
    city: "Olsztyn",
  },
  {
    code: "10-334",
    city: "Olsztyn",
  },
  {
    code: "10-335",
    city: "Olsztyn",
  },
  {
    code: "10-336",
    city: "Olsztyn",
  },
  {
    code: "10-337",
    city: "Olsztyn",
  },
  {
    code: "10-339",
    city: "Olsztyn",
  },
  {
    code: "10-340",
    city: "Olsztyn",
  },
  {
    code: "10-341",
    city: "Olsztyn",
  },
  {
    code: "10-342",
    city: "Olsztyn",
  },
  {
    code: "10-343",
    city: "Olsztyn",
  },
  {
    code: "10-344",
    city: "Olsztyn",
  },
  {
    code: "10-345",
    city: "Olsztyn",
  },
  {
    code: "10-346",
    city: "Olsztyn",
  },
  {
    code: "10-347",
    city: "Olsztyn",
  },
  {
    code: "10-348",
    city: "Olsztyn",
  },
  {
    code: "10-349",
    city: "Olsztyn",
  },
  {
    code: "10-350",
    city: "Olsztyn",
  },
  {
    code: "10-351",
    city: "Olsztyn",
  },
  {
    code: "10-352",
    city: "Olsztyn",
  },
  {
    code: "10-353",
    city: "Olsztyn",
  },
  {
    code: "10-354",
    city: "Olsztyn",
  },
  {
    code: "10-355",
    city: "Olsztyn",
  },
  {
    code: "10-356",
    city: "Olsztyn",
  },
  {
    code: "10-357",
    city: "Olsztyn",
  },
  {
    code: "10-358",
    city: "Olsztyn",
  },
  {
    code: "10-359",
    city: "Olsztyn",
  },
  {
    code: "10-360",
    city: "Olsztyn",
  },
  {
    code: "10-361",
    city: "Olsztyn",
  },
  {
    code: "10-362",
    city: "Olsztyn",
  },
  {
    code: "10-363",
    city: "Olsztyn",
  },
  {
    code: "10-364",
    city: "Olsztyn",
  },
  {
    code: "10-365",
    city: "Olsztyn",
  },
  {
    code: "10-366",
    city: "Olsztyn",
  },
  {
    code: "10-367",
    city: "Olsztyn",
  },
  {
    code: "10-368",
    city: "Olsztyn",
  },
  {
    code: "10-369",
    city: "Olsztyn",
  },
  {
    code: "10-370",
    city: "Olsztyn",
  },
  {
    code: "10-371",
    city: "Olsztyn",
  },
  {
    code: "10-372",
    city: "Olsztyn",
  },
  {
    code: "10-373",
    city: "Olsztyn",
  },
  {
    code: "10-374",
    city: "Olsztyn",
  },
  {
    code: "10-375",
    city: "Olsztyn",
  },
  {
    code: "10-376",
    city: "Olsztyn",
  },
  {
    code: "10-377",
    city: "Olsztyn",
  },
  {
    code: "10-378",
    city: "Olsztyn",
  },
  {
    code: "10-379",
    city: "Olsztyn",
  },
  {
    code: "10-380",
    city: "Olsztyn",
  },
  {
    code: "10-381",
    city: "Olsztyn",
  },
  {
    code: "10-382",
    city: "Olsztyn",
  },
  {
    code: "10-401",
    city: "Olsztyn",
  },
  {
    code: "10-402",
    city: "Olsztyn",
  },
  {
    code: "10-404",
    city: "Olsztyn",
  },
  {
    code: "10-405",
    city: "Olsztyn",
  },
  {
    code: "10-406",
    city: "Olsztyn",
  },
  {
    code: "10-407",
    city: "Olsztyn",
  },
  {
    code: "10-408",
    city: "Olsztyn",
  },
  {
    code: "10-409",
    city: "Olsztyn",
  },
  {
    code: "10-410",
    city: "Olsztyn",
  },
  {
    code: "10-413",
    city: "Olsztyn",
  },
  {
    code: "10-414",
    city: "Olsztyn",
  },
  {
    code: "10-416",
    city: "Olsztyn",
  },
  {
    code: "10-417",
    city: "Olsztyn",
  },
  {
    code: "10-418",
    city: "Olsztyn",
  },
  {
    code: "10-419",
    city: "Olsztyn",
  },
  {
    code: "10-420",
    city: "Olsztyn",
  },
  {
    code: "10-421",
    city: "Olsztyn",
  },
  {
    code: "10-422",
    city: "Olsztyn",
  },
  {
    code: "10-423",
    city: "Olsztyn",
  },
  {
    code: "10-424",
    city: "Olsztyn",
  },
  {
    code: "10-425",
    city: "Olsztyn",
  },
  {
    code: "10-426",
    city: "Olsztyn",
  },
  {
    code: "10-427",
    city: "Olsztyn",
  },
  {
    code: "10-429",
    city: "Olsztyn",
  },
  {
    code: "10-430",
    city: "Olsztyn",
  },
  {
    code: "10-431",
    city: "Olsztyn",
  },
  {
    code: "10-432",
    city: "Olsztyn",
  },
  {
    code: "10-433",
    city: "Olsztyn",
  },
  {
    code: "10-434",
    city: "Olsztyn",
  },
  {
    code: "10-436",
    city: "Olsztyn",
  },
  {
    code: "10-437",
    city: "Olsztyn",
  },
  {
    code: "10-438",
    city: "Olsztyn",
  },
  {
    code: "10-442",
    city: "Olsztyn",
  },
  {
    code: "10-443",
    city: "Olsztyn",
  },
  {
    code: "10-444",
    city: "Olsztyn",
  },
  {
    code: "10-445",
    city: "Olsztyn",
  },
  {
    code: "10-446",
    city: "Olsztyn",
  },
  {
    code: "10-447",
    city: "Olsztyn",
  },
  {
    code: "10-448",
    city: "Olsztyn",
  },
  {
    code: "10-449",
    city: "Olsztyn",
  },
  {
    code: "10-450",
    city: "Olsztyn",
  },
  {
    code: "10-454",
    city: "Olsztyn",
  },
  {
    code: "10-455",
    city: "Olsztyn",
  },
  {
    code: "10-456",
    city: "Olsztyn",
  },
  {
    code: "10-457",
    city: "Olsztyn",
  },
  {
    code: "10-459",
    city: "Olsztyn",
  },
  {
    code: "10-460",
    city: "Olsztyn",
  },
  {
    code: "10-461",
    city: "Olsztyn",
  },
  {
    code: "10-462",
    city: "Olsztyn",
  },
  {
    code: "10-463",
    city: "Olsztyn",
  },
  {
    code: "10-464",
    city: "Olsztyn",
  },
  {
    code: "10-465",
    city: "Olsztyn",
  },
  {
    code: "10-467",
    city: "Olsztyn",
  },
  {
    code: "10-501",
    city: "Olsztyn",
  },
  {
    code: "10-502",
    city: "Olsztyn",
  },
  {
    code: "10-503",
    city: "Olsztyn",
  },
  {
    code: "10-504",
    city: "Olsztyn",
  },
  {
    code: "10-505",
    city: "Olsztyn",
  },
  {
    code: "10-506",
    city: "Olsztyn",
  },
  {
    code: "10-507",
    city: "Olsztyn",
  },
  {
    code: "10-508",
    city: "Olsztyn",
  },
  {
    code: "10-509",
    city: "Olsztyn",
  },
  {
    code: "10-510",
    city: "Olsztyn",
  },
  {
    code: "10-511",
    city: "Olsztyn",
  },
  {
    code: "10-512",
    city: "Olsztyn",
  },
  {
    code: "10-513",
    city: "Olsztyn",
  },
  {
    code: "10-514",
    city: "Olsztyn",
  },
  {
    code: "10-515",
    city: "Olsztyn",
  },
  {
    code: "10-516",
    city: "Olsztyn",
  },
  {
    code: "10-517",
    city: "Olsztyn",
  },
  {
    code: "10-518",
    city: "Olsztyn",
  },
  {
    code: "10-519",
    city: "Olsztyn",
  },
  {
    code: "10-520",
    city: "Olsztyn",
  },
  {
    code: "10-521",
    city: "Olsztyn",
  },
  {
    code: "10-522",
    city: "Olsztyn",
  },
  {
    code: "10-523",
    city: "Olsztyn",
  },
  {
    code: "10-524",
    city: "Olsztyn",
  },
  {
    code: "10-525",
    city: "Olsztyn",
  },
  {
    code: "10-526",
    city: "Olsztyn",
  },
  {
    code: "10-527",
    city: "Olsztyn",
  },
  {
    code: "10-528",
    city: "Olsztyn",
  },
  {
    code: "10-529",
    city: "Olsztyn",
  },
  {
    code: "10-530",
    city: "Olsztyn",
  },
  {
    code: "10-531",
    city: "Olsztyn",
  },
  {
    code: "10-532",
    city: "Olsztyn",
  },
  {
    code: "10-533",
    city: "Olsztyn",
  },
  {
    code: "10-534",
    city: "Olsztyn",
  },
  {
    code: "10-535",
    city: "Olsztyn",
  },
  {
    code: "10-536",
    city: "Olsztyn",
  },
  {
    code: "10-537",
    city: "Olsztyn",
  },
  {
    code: "10-538",
    city: "Olsztyn",
  },
  {
    code: "10-539",
    city: "Olsztyn",
  },
  {
    code: "10-540",
    city: "Olsztyn",
  },
  {
    code: "10-541",
    city: "Olsztyn",
  },
  {
    code: "10-542",
    city: "Olsztyn",
  },
  {
    code: "10-543",
    city: "Olsztyn",
  },
  {
    code: "10-544",
    city: "Olsztyn",
  },
  {
    code: "10-545",
    city: "Olsztyn",
  },
  {
    code: "10-546",
    city: "Olsztyn",
  },
  {
    code: "10-547",
    city: "Olsztyn",
  },
  {
    code: "10-548",
    city: "Olsztyn",
  },
  {
    code: "10-549",
    city: "Olsztyn",
  },
  {
    code: "10-550",
    city: "Olsztyn",
  },
  {
    code: "10-551",
    city: "Olsztyn",
  },
  {
    code: "10-552",
    city: "Olsztyn",
  },
  {
    code: "10-553",
    city: "Olsztyn",
  },
  {
    code: "10-554",
    city: "Olsztyn",
  },
  {
    code: "10-555",
    city: "Olsztyn",
  },
  {
    code: "10-556",
    city: "Olsztyn",
  },
  {
    code: "10-557",
    city: "Olsztyn",
  },
  {
    code: "10-558",
    city: "Olsztyn",
  },
  {
    code: "10-559",
    city: "Olsztyn",
  },
  {
    code: "10-560",
    city: "Olsztyn",
  },
  {
    code: "10-561",
    city: "Olsztyn",
  },
  {
    code: "10-562",
    city: "Olsztyn",
  },
  {
    code: "10-563",
    city: "Olsztyn",
  },
  {
    code: "10-564",
    city: "Olsztyn",
  },
  {
    code: "10-565",
    city: "Olsztyn",
  },
  {
    code: "10-566",
    city: "Olsztyn",
  },
  {
    code: "10-570",
    city: "Olsztyn",
  },
  {
    code: "10-572",
    city: "Olsztyn",
  },
  {
    code: "10-573",
    city: "Olsztyn",
  },
  {
    code: "10-574",
    city: "Olsztyn",
  },
  {
    code: "10-575",
    city: "Olsztyn",
  },
  {
    code: "10-576",
    city: "Olsztyn",
  },
  {
    code: "10-577",
    city: "Olsztyn",
  },
  {
    code: "10-578",
    city: "Olsztyn",
  },
  {
    code: "10-579",
    city: "Olsztyn",
  },
  {
    code: "10-580",
    city: "Olsztyn",
  },
  {
    code: "10-581",
    city: "Olsztyn",
  },
  {
    code: "10-583",
    city: "Olsztyn",
  },
  {
    code: "10-584",
    city: "Olsztyn",
  },
  {
    code: "10-585",
    city: "Olsztyn",
  },
  {
    code: "10-586",
    city: "Olsztyn",
  },
  {
    code: "10-587",
    city: "Olsztyn",
  },
  {
    code: "10-588",
    city: "Olsztyn",
  },
  {
    code: "10-589",
    city: "Olsztyn",
  },
  {
    code: "10-601",
    city: "Olsztyn",
  },
  {
    code: "10-602",
    city: "Olsztyn",
  },
  {
    code: "10-603",
    city: "Olsztyn",
  },
  {
    code: "10-604",
    city: "Olsztyn",
  },
  {
    code: "10-605",
    city: "Olsztyn",
  },
  {
    code: "10-606",
    city: "Olsztyn",
  },
  {
    code: "10-607",
    city: "Olsztyn",
  },
  {
    code: "10-608",
    city: "Olsztyn",
  },
  {
    code: "10-609",
    city: "Olsztyn",
  },
  {
    code: "10-610",
    city: "Olsztyn",
  },
  {
    code: "10-611",
    city: "Olsztyn",
  },
  {
    code: "10-612",
    city: "Olsztyn",
  },
  {
    code: "10-613",
    city: "Olsztyn",
  },
  {
    code: "10-614",
    city: "Olsztyn",
  },
  {
    code: "10-615",
    city: "Olsztyn",
  },
  {
    code: "10-616",
    city: "Olsztyn",
  },
  {
    code: "10-617",
    city: "Olsztyn",
  },
  {
    code: "10-619",
    city: "Olsztyn",
  },
  {
    code: "10-620",
    city: "Olsztyn",
  },
  {
    code: "10-621",
    city: "Olsztyn",
  },
  {
    code: "10-622",
    city: "Olsztyn",
  },
  {
    code: "10-623",
    city: "Olsztyn",
  },
  {
    code: "10-624",
    city: "Olsztyn",
  },
  {
    code: "10-625",
    city: "Olsztyn",
  },
  {
    code: "10-626",
    city: "Olsztyn",
  },
  {
    code: "10-627",
    city: "Olsztyn",
  },
  {
    code: "10-628",
    city: "Olsztyn",
  },
  {
    code: "10-629",
    city: "Olsztyn",
  },
  {
    code: "10-630",
    city: "Olsztyn",
  },
  {
    code: "10-631",
    city: "Olsztyn",
  },
  {
    code: "10-632",
    city: "Olsztyn",
  },
  {
    code: "10-633",
    city: "Olsztyn",
  },
  {
    code: "10-634",
    city: "Olsztyn",
  },
  {
    code: "10-635",
    city: "Olsztyn",
  },
  {
    code: "10-636",
    city: "Olsztyn",
  },
  {
    code: "10-637",
    city: "Olsztyn",
  },
  {
    code: "10-638",
    city: "Olsztyn",
  },
  {
    code: "10-639",
    city: "Olsztyn",
  },
  {
    code: "10-640",
    city: "Olsztyn",
  },
  {
    code: "10-642",
    city: "Olsztyn",
  },
  {
    code: "10-643",
    city: "Olsztyn",
  },
  {
    code: "10-644",
    city: "Olsztyn",
  },
  {
    code: "10-645",
    city: "Olsztyn",
  },
  {
    code: "10-646",
    city: "Olsztyn",
  },
  {
    code: "10-647",
    city: "Olsztyn",
  },
  {
    code: "10-648",
    city: "Olsztyn",
  },
  {
    code: "10-649",
    city: "Olsztyn",
  },
  {
    code: "10-650",
    city: "Olsztyn",
  },
  {
    code: "10-651",
    city: "Olsztyn",
  },
  {
    code: "10-652",
    city: "Olsztyn",
  },
  {
    code: "10-653",
    city: "Olsztyn",
  },
  {
    code: "10-654",
    city: "Olsztyn",
  },
  {
    code: "10-655",
    city: "Olsztyn",
  },
  {
    code: "10-656",
    city: "Olsztyn",
  },
  {
    code: "10-657",
    city: "Olsztyn",
  },
  {
    code: "10-658",
    city: "Olsztyn",
  },
  {
    code: "10-659",
    city: "Olsztyn",
  },
  {
    code: "10-660",
    city: "Olsztyn",
  },
  {
    code: "10-661",
    city: "Olsztyn",
  },
  {
    code: "10-662",
    city: "Olsztyn",
  },
  {
    code: "10-663",
    city: "Olsztyn",
  },
  {
    code: "10-664",
    city: "Olsztyn",
  },
  {
    code: "10-665",
    city: "Olsztyn",
  },
  {
    code: "10-666",
    city: "Olsztyn",
  },
  {
    code: "10-667",
    city: "Olsztyn",
  },
  {
    code: "10-668",
    city: "Olsztyn",
  },
  {
    code: "10-669",
    city: "Olsztyn",
  },
  {
    code: "10-670",
    city: "Olsztyn",
  },
  {
    code: "10-672",
    city: "Olsztyn",
  },
  {
    code: "10-673",
    city: "Olsztyn",
  },
  {
    code: "10-674",
    city: "Olsztyn",
  },
  {
    code: "10-675",
    city: "Olsztyn",
  },
  {
    code: "10-676",
    city: "Olsztyn",
  },
  {
    code: "10-677",
    city: "Olsztyn",
  },
  {
    code: "10-678",
    city: "Olsztyn",
  },
  {
    code: "10-679",
    city: "Olsztyn",
  },
  {
    code: "10-680",
    city: "Olsztyn",
  },
  {
    code: "10-681",
    city: "Olsztyn",
  },
  {
    code: "10-682",
    city: "Olsztyn",
  },
  {
    code: "10-683",
    city: "Olsztyn",
  },
  {
    code: "10-684",
    city: "Olsztyn",
  },
  {
    code: "10-685",
    city: "Olsztyn",
  },
  {
    code: "10-686",
    city: "Olsztyn",
  },
  {
    code: "10-687",
    city: "Olsztyn",
  },
  {
    code: "10-688",
    city: "Olsztyn",
  },
  {
    code: "10-689",
    city: "Olsztyn",
  },
  {
    code: "10-690",
    city: "Olsztyn",
  },
  {
    code: "10-691",
    city: "Olsztyn",
  },
  {
    code: "10-692",
    city: "Olsztyn",
  },
  {
    code: "10-693",
    city: "Olsztyn",
  },
  {
    code: "10-694",
    city: "Olsztyn",
  },
  {
    code: "10-695",
    city: "Olsztyn",
  },
  {
    code: "10-696",
    city: "Olsztyn",
  },
  {
    code: "10-698",
    city: "Olsztyn",
  },
  {
    code: "10-699",
    city: "Olsztyn",
  },
  {
    code: "10-701",
    city: "Olsztyn",
  },
  {
    code: "10-702",
    city: "Olsztyn",
  },
  {
    code: "10-705",
    city: "Olsztyn",
  },
  {
    code: "10-706",
    city: "Olsztyn",
  },
  {
    code: "10-707",
    city: "Olsztyn",
  },
  {
    code: "10-708",
    city: "Olsztyn",
  },
  {
    code: "10-709",
    city: "Olsztyn",
  },
  {
    code: "10-710",
    city: "Olsztyn",
  },
  {
    code: "10-711",
    city: "Olsztyn",
  },
  {
    code: "10-712",
    city: "Olsztyn",
  },
  {
    code: "10-713",
    city: "Olsztyn",
  },
  {
    code: "10-718",
    city: "Olsztyn",
  },
  {
    code: "10-719",
    city: "Olsztyn",
  },
  {
    code: "10-720",
    city: "Olsztyn",
  },
  {
    code: "10-721",
    city: "Olsztyn",
  },
  {
    code: "10-722",
    city: "Olsztyn",
  },
  {
    code: "10-723",
    city: "Olsztyn",
  },
  {
    code: "10-724",
    city: "Olsztyn",
  },
  {
    code: "10-725",
    city: "Olsztyn",
  },
  {
    code: "10-726",
    city: "Olsztyn",
  },
  {
    code: "10-727",
    city: "Olsztyn",
  },
  {
    code: "10-728",
    city: "Olsztyn",
  },
  {
    code: "10-745",
    city: "Olsztyn",
  },
  {
    code: "10-746",
    city: "Olsztyn",
  },
  {
    code: "10-747",
    city: "Olsztyn",
  },
  {
    code: "10-748",
    city: "Olsztyn",
  },
  {
    code: "10-749",
    city: "Olsztyn",
  },
  {
    code: "10-750",
    city: "Olsztyn",
  },
  {
    code: "10-751",
    city: "Olsztyn",
  },
  {
    code: "10-752",
    city: "Olsztyn",
  },
  {
    code: "10-753",
    city: "Olsztyn",
  },
  {
    code: "10-754",
    city: "Olsztyn",
  },
  {
    code: "10-755",
    city: "Olsztyn",
  },
  {
    code: "10-756",
    city: "Olsztyn",
  },
  {
    code: "10-757",
    city: "Olsztyn",
  },
  {
    code: "10-758",
    city: "Olsztyn",
  },
  {
    code: "10-759",
    city: "Olsztyn",
  },
  {
    code: "10-760",
    city: "Olsztyn",
  },
  {
    code: "10-761",
    city: "Olsztyn",
  },
  {
    code: "10-762",
    city: "Olsztyn",
  },
  {
    code: "10-763",
    city: "Olsztyn",
  },
  {
    code: "10-764",
    city: "Olsztyn",
  },
  {
    code: "10-765",
    city: "Olsztyn",
  },
  {
    code: "10-766",
    city: "Olsztyn",
  },
  {
    code: "10-767",
    city: "Olsztyn",
  },
  {
    code: "10-768",
    city: "Olsztyn",
  },
  {
    code: "10-769",
    city: "Olsztyn",
  },
  {
    code: "10-770",
    city: "Olsztyn",
  },
  {
    code: "10-771",
    city: "Olsztyn",
  },
  {
    code: "10-772",
    city: "Olsztyn",
  },
  {
    code: "10-773",
    city: "Olsztyn",
  },
  {
    code: "10-774",
    city: "Olsztyn",
  },
  {
    code: "10-801",
    city: "Olsztyn",
  },
  {
    code: "10-802",
    city: "Olsztyn",
  },
  {
    code: "10-803",
    city: "Olsztyn",
  },
  {
    code: "10-804",
    city: "Olsztyn",
  },
  {
    code: "10-805",
    city: "Olsztyn",
  },
  {
    code: "10-806",
    city: "Olsztyn",
  },
  {
    code: "10-807",
    city: "Olsztyn",
  },
  {
    code: "10-808",
    city: "Olsztyn",
  },
  {
    code: "10-809",
    city: "Olsztyn",
  },
  {
    code: "10-810",
    city: "Olsztyn",
  },
  {
    code: "10-811",
    city: "Olsztyn",
  },
  {
    code: "10-812",
    city: "Olsztyn",
  },
  {
    code: "10-813",
    city: "Olsztyn",
  },
  {
    code: "10-814",
    city: "Olsztyn",
  },
  {
    code: "10-815",
    city: "Olsztyn",
  },
  {
    code: "10-816",
    city: "Olsztyn",
  },
  {
    code: "10-817",
    city: "Olsztyn",
  },
  {
    code: "10-818",
    city: "Olsztyn",
  },
  {
    code: "10-819",
    city: "Olsztyn",
  },
  {
    code: "10-820",
    city: "Olsztyn",
  },
  {
    code: "10-822",
    city: "Olsztyn",
  },
  {
    code: "10-823",
    city: "Olsztyn",
  },
  {
    code: "10-824",
    city: "Olsztyn",
  },
  {
    code: "10-825",
    city: "Olsztyn",
  },
  {
    code: "10-828",
    city: "Olsztyn",
  },
  {
    code: "10-829",
    city: "Olsztyn",
  },
  {
    code: "10-830",
    city: "Olsztyn",
  },
  {
    code: "10-831",
    city: "Olsztyn",
  },
  {
    code: "10-832",
    city: "Olsztyn",
  },
  {
    code: "10-833",
    city: "Olsztyn",
  },
  {
    code: "10-834",
    city: "Olsztyn",
  },
  {
    code: "10-835",
    city: "Olsztyn",
  },
  {
    code: "10-836",
    city: "Olsztyn",
  },
  {
    code: "10-837",
    city: "Olsztyn",
  },
  {
    code: "10-838",
    city: "Olsztyn",
  },
  {
    code: "10-839",
    city: "Olsztyn",
  },
  {
    code: "10-840",
    city: "Olsztyn",
  },
  {
    code: "10-841",
    city: "Olsztyn",
  },
  {
    code: "10-842",
    city: "Olsztyn",
  },
  {
    code: "10-843",
    city: "Olsztyn",
  },
  {
    code: "10-844",
    city: "Olsztyn",
  },
  {
    code: "10-845",
    city: "Olsztyn",
  },
  {
    code: "10-846",
    city: "Olsztyn",
  },
  {
    code: "10-847",
    city: "Olsztyn",
  },
  {
    code: "10-848",
    city: "Olsztyn",
  },
  {
    code: "10-849",
    city: "Olsztyn",
  },
  {
    code: "10-850",
    city: "Olsztyn",
  },
  {
    code: "10-851",
    city: "Olsztyn",
  },
  {
    code: "10-852",
    city: "Olsztyn",
  },
  {
    code: "10-853",
    city: "Olsztyn",
  },
  {
    code: "10-854",
    city: "Olsztyn",
  },
  {
    code: "10-855",
    city: "Olsztyn",
  },
  {
    code: "10-856",
    city: "Olsztyn",
  },
  {
    code: "10-857",
    city: "Olsztyn",
  },
  {
    code: "10-858",
    city: "Olsztyn",
  },
  {
    code: "10-859",
    city: "Olsztyn",
  },
  {
    code: "10-860",
    city: "Olsztyn",
  },
  {
    code: "10-861",
    city: "Olsztyn",
  },
  {
    code: "10-862",
    city: "Olsztyn",
  },
  {
    code: "10-900",
    city: "Olsztyn",
  },
  {
    code: "10-903",
    city: "Olsztyn",
  },
  {
    code: "10-940",
    city: "Olsztyn",
  },
  {
    code: "10-941",
    city: "Olsztyn",
  },
  {
    code: "10-950",
    city: "Olsztyn",
  },
  {
    code: "10-952",
    city: "Olsztyn",
  },
  {
    code: "10-953",
    city: "Olsztyn",
  },
  {
    code: "10-954",
    city: "Olsztyn",
  },
  {
    code: "10-955",
    city: "Olsztyn",
  },
  {
    code: "10-956",
    city: "Olsztyn",
  },
  {
    code: "10-958",
    city: "Olsztyn",
  },
  {
    code: "10-959",
    city: "Olsztyn",
  },
  {
    code: "11-001",
    city: "Dywity",
  },
  {
    code: "11-008",
    city: "Świątki",
  },
  {
    code: "11-010",
    city: "Barczewo",
  },
  {
    code: "11-015",
    city: "Olsztynek",
  },
  {
    code: "11-030",
    city: "Purda",
  },
  {
    code: "11-034",
    city: "Stawiguda",
  },
  {
    code: "11-036",
    city: "Gietrzwałd",
  },
  {
    code: "11-040",
    city: "Dobre Miasto",
  },
  {
    code: "11-041",
    city: "Olsztyn",
  },
  {
    code: "11-042",
    city: "Jonkowo",
  },
  {
    code: "11-100",
    city: "Lidzbark Warmiński",
  },
  {
    code: "11-101",
    city: "Lidzbark Warmiński",
  },
  {
    code: "11-102",
    city: "Lidzbark Warmiński",
  },
  {
    code: "11-106",
    city: "Kiwity",
  },
  {
    code: "11-130",
    city: "Orneta",
  },
  {
    code: "11-135",
    city: "Lubomino",
  },
  {
    code: "11-200",
    city: "Bartoszyce",
  },
  {
    code: "11-201",
    city: "Bartoszyce",
  },
  {
    code: "11-204",
    city: "Bartoszyce",
  },
  {
    code: "11-210",
    city: "Sępopol",
  },
  {
    code: "11-218",
    city: "Sątopy-Samulewo",
  },
  {
    code: "11-220",
    city: "Górowo Iławeckie",
  },
  {
    code: "11-227",
    city: "Kamińsk",
  },
  {
    code: "11-230",
    city: "Bisztynek",
  },
  {
    code: "11-300",
    city: "Biskupiec",
  },
  {
    code: "11-302",
    city: "Biskupiec",
  },
  {
    code: "11-311",
    city: "Kolno",
  },
  {
    code: "11-320",
    city: "Jeziorany",
  },
  {
    code: "11-400",
    city: "Kętrzyn",
  },
  {
    code: "11-401",
    city: "Kętrzyn",
  },
  {
    code: "11-402",
    city: "Kętrzyn",
  },
  {
    code: "11-404",
    city: "Karolewo",
  },
  {
    code: "11-409",
    city: "Kętrzyn",
  },
  {
    code: "11-410",
    city: "Barciany",
  },
  {
    code: "11-414",
    city: "Kętrzyn",
  },
  {
    code: "11-420",
    city: "Srokowo",
  },
  {
    code: "11-430",
    city: "Korsze",
  },
  {
    code: "11-440",
    city: "Reszel",
  },
  {
    code: "11-500",
    city: "Giżycko",
  },
  {
    code: "11-501",
    city: "Giżycko",
  },
  {
    code: "11-503",
    city: "Giżycko",
  },
  {
    code: "11-504",
    city: "Giżycko",
  },
  {
    code: "11-507",
    city: "Giżycko",
  },
  {
    code: "11-508",
    city: "Giżycko",
  },
  {
    code: "11-510",
    city: "Wydminy",
  },
  {
    code: "11-513",
    city: "Miłki",
  },
  {
    code: "11-520",
    city: "Ryn",
  },
  {
    code: "11-600",
    city: "Węgorzewo",
  },
  {
    code: "11-601",
    city: "Węgorzewo",
  },
  {
    code: "11-606",
    city: "Budry",
  },
  {
    code: "11-610",
    city: "Pozezdrze",
  },
  {
    code: "11-612",
    city: "Kruklanki",
  },
  {
    code: "11-700",
    city: "Mrągowo",
  },
  {
    code: "11-702",
    city: "Mrągowo",
  },
  {
    code: "11-709",
    city: "Mrągowo",
  },
  {
    code: "11-710",
    city: "Piecki",
  },
  {
    code: "11-730",
    city: "Mikołajki",
  },
  {
    code: "11-731",
    city: "Sorkwity",
  },
  {
    code: "11-737",
    city: "Krutyń",
  },
  {
    code: "12-100",
    city: "Szczytno",
  },
  {
    code: "12-101",
    city: "Szczytno",
  },
  {
    code: "12-102",
    city: "Szczytno",
  },
  {
    code: "12-114",
    city: "Rozogi",
  },
  {
    code: "12-120",
    city: "Dźwierzuty",
  },
  {
    code: "12-122",
    city: "Jedwabno",
  },
  {
    code: "12-130",
    city: "Pasym",
  },
  {
    code: "12-140",
    city: "Świętajno",
  },
  {
    code: "12-150",
    city: "Spychowo",
  },
  {
    code: "12-160",
    city: "Wielbark",
  },
  {
    code: "12-200",
    city: "Pisz",
  },
  {
    code: "12-201",
    city: "Pisz",
  },
  {
    code: "12-207",
    city: "Bemowo Piskie",
  },
  {
    code: "12-220",
    city: "Ruciane-Nida",
  },
  {
    code: "12-221",
    city: "Ruciane-Nida",
  },
  {
    code: "12-230",
    city: "Biała Piska",
  },
  {
    code: "12-250",
    city: "Orzysz",
  },
  {
    code: "12-251",
    city: "Orzysz",
  },
  {
    code: "13-100",
    city: "Nidzica",
  },
  {
    code: "13-111",
    city: "Janowiec Kościelny",
  },
  {
    code: "13-113",
    city: "Janowo",
  },
  {
    code: "13-124",
    city: "Kozłowo",
  },
  {
    code: "13-200",
    city: "Działdowo",
  },
  {
    code: "13-201",
    city: "Działdowo",
  },
  {
    code: "13-206",
    city: "Płośnica",
  },
  {
    code: "13-210",
    city: "Działdowo",
  },
  {
    code: "13-214",
    city: "Uzdowo",
  },
  {
    code: "13-220",
    city: "Rybno",
  },
  {
    code: "13-230",
    city: "Lidzbark",
  },
  {
    code: "13-240",
    city: "Iłowo-Osada",
  },
  {
    code: "13-300",
    city: "Nowe Miasto Lubawskie",
  },
  {
    code: "13-304",
    city: "Radomno",
  },
  {
    code: "13-306",
    city: "Kurzętnik",
  },
  {
    code: "13-308",
    city: "Mroczno",
  },
  {
    code: "13-314",
    city: "Marzęcice",
  },
  {
    code: "13-315",
    city: "Tereszewo",
  },
  {
    code: "13-324",
    city: "Grodziczno",
  },
  {
    code: "13-330",
    city: "Krotoszyny",
  },
  {
    code: "13-332",
    city: "Jamielnik",
  },
  {
    code: "13-334",
    city: "Łąkorz",
  },
  {
    code: "13-340",
    city: "Biskupiec",
  },
  {
    code: "14-100",
    city: "Ostróda",
  },
  {
    code: "14-101",
    city: "Ostróda",
  },
  {
    code: "14-102",
    city: "Ostróda",
  },
  {
    code: "14-103",
    city: "Ostróda",
  },
  {
    code: "14-104",
    city: "Ostróda",
  },
  {
    code: "14-105",
    city: "Łukta",
  },
  {
    code: "14-107",
    city: "Gierzwałd",
  },
  {
    code: "14-110",
    city: "Grunwald",
  },
  {
    code: "14-120",
    city: "Dąbrówno",
  },
  {
    code: "14-133",
    city: "Stare Jabłonki",
  },
  {
    code: "14-140",
    city: "Miłomłyn",
  },
  {
    code: "14-200",
    city: "Iława",
  },
  {
    code: "14-202",
    city: "Iława",
  },
  {
    code: "14-210",
    city: "Iława",
  },
  {
    code: "14-220",
    city: "Kisielice",
  },
  {
    code: "14-230",
    city: "Zalewo",
  },
  {
    code: "14-240",
    city: "Susz",
  },
  {
    code: "14-260",
    city: "Lubawa",
  },
  {
    code: "14-300",
    city: "Morąg",
  },
  {
    code: "14-301",
    city: "Morąg",
  },
  {
    code: "14-310",
    city: "Miłakowo",
  },
  {
    code: "14-330",
    city: "Małdyty",
  },
  {
    code: "14-400",
    city: "Pasłęk",
  },
  {
    code: "14-401",
    city: "Pasłęk",
  },
  {
    code: "14-405",
    city: "Wilczęta",
  },
  {
    code: "14-407",
    city: "Godkowo",
  },
  {
    code: "14-411",
    city: "Rychliki",
  },
  {
    code: "14-420",
    city: "Młynary",
  },
  {
    code: "14-500",
    city: "Braniewo",
  },
  {
    code: "14-501",
    city: "Braniewo",
  },
  {
    code: "14-502",
    city: "Braniewo",
  },
  {
    code: "14-520",
    city: "Pieniężno",
  },
  {
    code: "14-521",
    city: "Lelkowo",
  },
  {
    code: "14-522",
    city: "Zagaje",
  },
  {
    code: "14-526",
    city: "Płoskinia",
  },
  {
    code: "14-527",
    city: "Żelazna Góra",
  },
  {
    code: "14-528",
    city: "Wola Lipowska",
  },
  {
    code: "14-530",
    city: "Frombork",
  },
  {
    code: "15-001",
    city: "Białystok",
  },
  {
    code: "15-002",
    city: "Białystok",
  },
  {
    code: "15-003",
    city: "Białystok",
  },
  {
    code: "15-004",
    city: "Białystok",
  },
  {
    code: "15-005",
    city: "Białystok",
  },
  {
    code: "15-006",
    city: "Białystok",
  },
  {
    code: "15-007",
    city: "Białystok",
  },
  {
    code: "15-008",
    city: "Białystok",
  },
  {
    code: "15-010",
    city: "Białystok",
  },
  {
    code: "15-011",
    city: "Białystok",
  },
  {
    code: "15-013",
    city: "Białystok",
  },
  {
    code: "15-014",
    city: "Białystok",
  },
  {
    code: "15-016",
    city: "Białystok",
  },
  {
    code: "15-017",
    city: "Białystok",
  },
  {
    code: "15-019",
    city: "Białystok",
  },
  {
    code: "15-021",
    city: "Białystok",
  },
  {
    code: "15-023",
    city: "Białystok",
  },
  {
    code: "15-024",
    city: "Białystok",
  },
  {
    code: "15-025",
    city: "Białystok",
  },
  {
    code: "15-026",
    city: "Białystok",
  },
  {
    code: "15-027",
    city: "Białystok",
  },
  {
    code: "15-028",
    city: "Białystok",
  },
  {
    code: "15-029",
    city: "Białystok",
  },
  {
    code: "15-030",
    city: "Białystok",
  },
  {
    code: "15-032",
    city: "Białystok",
  },
  {
    code: "15-034",
    city: "Białystok",
  },
  {
    code: "15-035",
    city: "Białystok",
  },
  {
    code: "15-037",
    city: "Białystok",
  },
  {
    code: "15-038",
    city: "Białystok",
  },
  {
    code: "15-040",
    city: "Białystok",
  },
  {
    code: "15-042",
    city: "Białystok",
  },
  {
    code: "15-044",
    city: "Białystok",
  },
  {
    code: "15-045",
    city: "Białystok",
  },
  {
    code: "15-046",
    city: "Białystok",
  },
  {
    code: "15-047",
    city: "Białystok",
  },
  {
    code: "15-048",
    city: "Białystok",
  },
  {
    code: "15-050",
    city: "Białystok",
  },
  {
    code: "15-052",
    city: "Białystok",
  },
  {
    code: "15-054",
    city: "Białystok",
  },
  {
    code: "15-055",
    city: "Białystok",
  },
  {
    code: "15-057",
    city: "Białystok",
  },
  {
    code: "15-062",
    city: "Białystok",
  },
  {
    code: "15-063",
    city: "Białystok",
  },
  {
    code: "15-064",
    city: "Białystok",
  },
  {
    code: "15-065",
    city: "Białystok",
  },
  {
    code: "15-066",
    city: "Białystok",
  },
  {
    code: "15-067",
    city: "Białystok",
  },
  {
    code: "15-068",
    city: "Białystok",
  },
  {
    code: "15-070",
    city: "Białystok",
  },
  {
    code: "15-071",
    city: "Białystok",
  },
  {
    code: "15-073",
    city: "Białystok",
  },
  {
    code: "15-074",
    city: "Białystok",
  },
  {
    code: "15-077",
    city: "Białystok",
  },
  {
    code: "15-078",
    city: "Białystok",
  },
  {
    code: "15-080",
    city: "Białystok",
  },
  {
    code: "15-081",
    city: "Białystok",
  },
  {
    code: "15-082",
    city: "Białystok",
  },
  {
    code: "15-083",
    city: "Białystok",
  },
  {
    code: "15-084",
    city: "Białystok",
  },
  {
    code: "15-085",
    city: "Białystok",
  },
  {
    code: "15-086",
    city: "Białystok",
  },
  {
    code: "15-087",
    city: "Białystok",
  },
  {
    code: "15-088",
    city: "Białystok",
  },
  {
    code: "15-089",
    city: "Białystok",
  },
  {
    code: "15-090",
    city: "Białystok",
  },
  {
    code: "15-091",
    city: "Białystok",
  },
  {
    code: "15-092",
    city: "Białystok",
  },
  {
    code: "15-093",
    city: "Białystok",
  },
  {
    code: "15-094",
    city: "Białystok",
  },
  {
    code: "15-096",
    city: "Białystok",
  },
  {
    code: "15-097",
    city: "Białystok",
  },
  {
    code: "15-099",
    city: "Białystok",
  },
  {
    code: "15-100",
    city: "Białystok",
  },
  {
    code: "15-101",
    city: "Białystok",
  },
  {
    code: "15-102",
    city: "Białystok",
  },
  {
    code: "15-103",
    city: "Białystok",
  },
  {
    code: "15-104",
    city: "Białystok",
  },
  {
    code: "15-106",
    city: "Białystok",
  },
  {
    code: "15-107",
    city: "Białystok",
  },
  {
    code: "15-108",
    city: "Białystok",
  },
  {
    code: "15-109",
    city: "Białystok",
  },
  {
    code: "15-110",
    city: "Białystok",
  },
  {
    code: "15-111",
    city: "Białystok",
  },
  {
    code: "15-113",
    city: "Białystok",
  },
  {
    code: "15-114",
    city: "Białystok",
  },
  {
    code: "15-115",
    city: "Białystok",
  },
  {
    code: "15-117",
    city: "Białystok",
  },
  {
    code: "15-118",
    city: "Białystok",
  },
  {
    code: "15-119",
    city: "Białystok",
  },
  {
    code: "15-120",
    city: "Białystok",
  },
  {
    code: "15-121",
    city: "Białystok",
  },
  {
    code: "15-122",
    city: "Białystok",
  },
  {
    code: "15-123",
    city: "Białystok",
  },
  {
    code: "15-124",
    city: "Białystok",
  },
  {
    code: "15-125",
    city: "Białystok",
  },
  {
    code: "15-127",
    city: "Białystok",
  },
  {
    code: "15-128",
    city: "Białystok",
  },
  {
    code: "15-129",
    city: "Białystok",
  },
  {
    code: "15-130",
    city: "Białystok",
  },
  {
    code: "15-131",
    city: "Białystok",
  },
  {
    code: "15-132",
    city: "Białystok",
  },
  {
    code: "15-133",
    city: "Białystok",
  },
  {
    code: "15-134",
    city: "Białystok",
  },
  {
    code: "15-135",
    city: "Białystok",
  },
  {
    code: "15-136",
    city: "Białystok",
  },
  {
    code: "15-137",
    city: "Białystok",
  },
  {
    code: "15-139",
    city: "Białystok",
  },
  {
    code: "15-140",
    city: "Białystok",
  },
  {
    code: "15-142",
    city: "Białystok",
  },
  {
    code: "15-143",
    city: "Białystok",
  },
  {
    code: "15-144",
    city: "Białystok",
  },
  {
    code: "15-145",
    city: "Białystok",
  },
  {
    code: "15-147",
    city: "Białystok",
  },
  {
    code: "15-148",
    city: "Białystok",
  },
  {
    code: "15-149",
    city: "Białystok",
  },
  {
    code: "15-150",
    city: "Białystok",
  },
  {
    code: "15-151",
    city: "Białystok",
  },
  {
    code: "15-152",
    city: "Białystok",
  },
  {
    code: "15-153",
    city: "Białystok",
  },
  {
    code: "15-154",
    city: "Białystok",
  },
  {
    code: "15-155",
    city: "Białystok",
  },
  {
    code: "15-156",
    city: "Białystok",
  },
  {
    code: "15-157",
    city: "Białystok",
  },
  {
    code: "15-159",
    city: "Białystok",
  },
  {
    code: "15-160",
    city: "Białystok",
  },
  {
    code: "15-161",
    city: "Białystok",
  },
  {
    code: "15-162",
    city: "Białystok",
  },
  {
    code: "15-163",
    city: "Białystok",
  },
  {
    code: "15-164",
    city: "Białystok",
  },
  {
    code: "15-165",
    city: "Białystok",
  },
  {
    code: "15-166",
    city: "Białystok",
  },
  {
    code: "15-169",
    city: "Białystok",
  },
  {
    code: "15-170",
    city: "Białystok",
  },
  {
    code: "15-171",
    city: "Białystok",
  },
  {
    code: "15-173",
    city: "Białystok",
  },
  {
    code: "15-174",
    city: "Białystok",
  },
  {
    code: "15-175",
    city: "Białystok",
  },
  {
    code: "15-176",
    city: "Białystok",
  },
  {
    code: "15-177",
    city: "Białystok",
  },
  {
    code: "15-178",
    city: "Białystok",
  },
  {
    code: "15-181",
    city: "Białystok",
  },
  {
    code: "15-182",
    city: "Białystok",
  },
  {
    code: "15-183",
    city: "Białystok",
  },
  {
    code: "15-185",
    city: "Białystok",
  },
  {
    code: "15-186",
    city: "Białystok",
  },
  {
    code: "15-187",
    city: "Białystok",
  },
  {
    code: "15-188",
    city: "Białystok",
  },
  {
    code: "15-189",
    city: "Białystok",
  },
  {
    code: "15-190",
    city: "Białystok",
  },
  {
    code: "15-191",
    city: "Białystok",
  },
  {
    code: "15-192",
    city: "Białystok",
  },
  {
    code: "15-193",
    city: "Białystok",
  },
  {
    code: "15-194",
    city: "Białystok",
  },
  {
    code: "15-195",
    city: "Białystok",
  },
  {
    code: "15-196",
    city: "Białystok",
  },
  {
    code: "15-197",
    city: "Białystok",
  },
  {
    code: "15-198",
    city: "Białystok",
  },
  {
    code: "15-199",
    city: "Białystok",
  },
  {
    code: "15-201",
    city: "Białystok",
  },
  {
    code: "15-202",
    city: "Białystok",
  },
  {
    code: "15-203",
    city: "Białystok",
  },
  {
    code: "15-204",
    city: "Białystok",
  },
  {
    code: "15-205",
    city: "Białystok",
  },
  {
    code: "15-206",
    city: "Białystok",
  },
  {
    code: "15-207",
    city: "Białystok",
  },
  {
    code: "15-208",
    city: "Białystok",
  },
  {
    code: "15-209",
    city: "Białystok",
  },
  {
    code: "15-210",
    city: "Białystok",
  },
  {
    code: "15-211",
    city: "Białystok",
  },
  {
    code: "15-213",
    city: "Białystok",
  },
  {
    code: "15-214",
    city: "Białystok",
  },
  {
    code: "15-215",
    city: "Białystok",
  },
  {
    code: "15-218",
    city: "Białystok",
  },
  {
    code: "15-219",
    city: "Białystok",
  },
  {
    code: "15-220",
    city: "Białystok",
  },
  {
    code: "15-222",
    city: "Białystok",
  },
  {
    code: "15-223",
    city: "Białystok",
  },
  {
    code: "15-224",
    city: "Białystok",
  },
  {
    code: "15-225",
    city: "Białystok",
  },
  {
    code: "15-227",
    city: "Białystok",
  },
  {
    code: "15-229",
    city: "Białystok",
  },
  {
    code: "15-232",
    city: "Białystok",
  },
  {
    code: "15-233",
    city: "Białystok",
  },
  {
    code: "15-234",
    city: "Białystok",
  },
  {
    code: "15-235",
    city: "Białystok",
  },
  {
    code: "15-236",
    city: "Białystok",
  },
  {
    code: "15-237",
    city: "Białystok",
  },
  {
    code: "15-238",
    city: "Białystok",
  },
  {
    code: "15-239",
    city: "Białystok",
  },
  {
    code: "15-240",
    city: "Białystok",
  },
  {
    code: "15-241",
    city: "Białystok",
  },
  {
    code: "15-242",
    city: "Białystok",
  },
  {
    code: "15-244",
    city: "Białystok",
  },
  {
    code: "15-245",
    city: "Białystok",
  },
  {
    code: "15-246",
    city: "Białystok",
  },
  {
    code: "15-247",
    city: "Białystok",
  },
  {
    code: "15-249",
    city: "Białystok",
  },
  {
    code: "15-250",
    city: "Białystok",
  },
  {
    code: "15-251",
    city: "Białystok",
  },
  {
    code: "15-252",
    city: "Białystok",
  },
  {
    code: "15-253",
    city: "Białystok",
  },
  {
    code: "15-254",
    city: "Białystok",
  },
  {
    code: "15-255",
    city: "Białystok",
  },
  {
    code: "15-256",
    city: "Białystok",
  },
  {
    code: "15-257",
    city: "Białystok",
  },
  {
    code: "15-258",
    city: "Białystok",
  },
  {
    code: "15-259",
    city: "Białystok",
  },
  {
    code: "15-260",
    city: "Białystok",
  },
  {
    code: "15-261",
    city: "Białystok",
  },
  {
    code: "15-262",
    city: "Białystok",
  },
  {
    code: "15-263",
    city: "Białystok",
  },
  {
    code: "15-264",
    city: "Białystok",
  },
  {
    code: "15-265",
    city: "Białystok",
  },
  {
    code: "15-266",
    city: "Białystok",
  },
  {
    code: "15-267",
    city: "Białystok",
  },
  {
    code: "15-268",
    city: "Białystok",
  },
  {
    code: "15-269",
    city: "Białystok",
  },
  {
    code: "15-270",
    city: "Białystok",
  },
  {
    code: "15-271",
    city: "Białystok",
  },
  {
    code: "15-272",
    city: "Białystok",
  },
  {
    code: "15-274",
    city: "Białystok",
  },
  {
    code: "15-275",
    city: "Białystok",
  },
  {
    code: "15-276",
    city: "Białystok",
  },
  {
    code: "15-277",
    city: "Białystok",
  },
  {
    code: "15-278",
    city: "Białystok",
  },
  {
    code: "15-279",
    city: "Białystok",
  },
  {
    code: "15-280",
    city: "Białystok",
  },
  {
    code: "15-281",
    city: "Białystok",
  },
  {
    code: "15-282",
    city: "Białystok",
  },
  {
    code: "15-283",
    city: "Białystok",
  },
  {
    code: "15-284",
    city: "Białystok",
  },
  {
    code: "15-285",
    city: "Białystok",
  },
  {
    code: "15-287",
    city: "Białystok",
  },
  {
    code: "15-288",
    city: "Białystok",
  },
  {
    code: "15-289",
    city: "Białystok",
  },
  {
    code: "15-290",
    city: "Białystok",
  },
  {
    code: "15-291",
    city: "Białystok",
  },
  {
    code: "15-292",
    city: "Białystok",
  },
  {
    code: "15-293",
    city: "Białystok",
  },
  {
    code: "15-294",
    city: "Białystok",
  },
  {
    code: "15-295",
    city: "Białystok",
  },
  {
    code: "15-297",
    city: "Białystok",
  },
  {
    code: "15-298",
    city: "Białystok",
  },
  {
    code: "15-301",
    city: "Białystok",
  },
  {
    code: "15-302",
    city: "Białystok",
  },
  {
    code: "15-304",
    city: "Białystok",
  },
  {
    code: "15-305",
    city: "Białystok",
  },
  {
    code: "15-306",
    city: "Białystok",
  },
  {
    code: "15-307",
    city: "Białystok",
  },
  {
    code: "15-308",
    city: "Białystok",
  },
  {
    code: "15-309",
    city: "Białystok",
  },
  {
    code: "15-311",
    city: "Białystok",
  },
  {
    code: "15-312",
    city: "Białystok",
  },
  {
    code: "15-317",
    city: "Białystok",
  },
  {
    code: "15-320",
    city: "Białystok",
  },
  {
    code: "15-321",
    city: "Białystok",
  },
  {
    code: "15-322",
    city: "Białystok",
  },
  {
    code: "15-323",
    city: "Białystok",
  },
  {
    code: "15-324",
    city: "Białystok",
  },
  {
    code: "15-325",
    city: "Białystok",
  },
  {
    code: "15-326",
    city: "Białystok",
  },
  {
    code: "15-327",
    city: "Białystok",
  },
  {
    code: "15-328",
    city: "Białystok",
  },
  {
    code: "15-330",
    city: "Białystok",
  },
  {
    code: "15-333",
    city: "Białystok",
  },
  {
    code: "15-335",
    city: "Białystok",
  },
  {
    code: "15-336",
    city: "Białystok",
  },
  {
    code: "15-337",
    city: "Białystok",
  },
  {
    code: "15-338",
    city: "Białystok",
  },
  {
    code: "15-339",
    city: "Białystok",
  },
  {
    code: "15-340",
    city: "Białystok",
  },
  {
    code: "15-341",
    city: "Białystok",
  },
  {
    code: "15-342",
    city: "Białystok",
  },
  {
    code: "15-343",
    city: "Białystok",
  },
  {
    code: "15-344",
    city: "Białystok",
  },
  {
    code: "15-345",
    city: "Białystok",
  },
  {
    code: "15-346",
    city: "Białystok",
  },
  {
    code: "15-347",
    city: "Białystok",
  },
  {
    code: "15-348",
    city: "Białystok",
  },
  {
    code: "15-349",
    city: "Białystok",
  },
  {
    code: "15-351",
    city: "Białystok",
  },
  {
    code: "15-352",
    city: "Białystok",
  },
  {
    code: "15-353",
    city: "Białystok",
  },
  {
    code: "15-354",
    city: "Białystok",
  },
  {
    code: "15-355",
    city: "Białystok",
  },
  {
    code: "15-356",
    city: "Białystok",
  },
  {
    code: "15-357",
    city: "Białystok",
  },
  {
    code: "15-361",
    city: "Białystok",
  },
  {
    code: "15-362",
    city: "Białystok",
  },
  {
    code: "15-363",
    city: "Białystok",
  },
  {
    code: "15-364",
    city: "Białystok",
  },
  {
    code: "15-365",
    city: "Białystok",
  },
  {
    code: "15-367",
    city: "Białystok",
  },
  {
    code: "15-369",
    city: "Białystok",
  },
  {
    code: "15-370",
    city: "Białystok",
  },
  {
    code: "15-371",
    city: "Białystok",
  },
  {
    code: "15-372",
    city: "Białystok",
  },
  {
    code: "15-373",
    city: "Białystok",
  },
  {
    code: "15-374",
    city: "Białystok",
  },
  {
    code: "15-376",
    city: "Białystok",
  },
  {
    code: "15-377",
    city: "Białystok",
  },
  {
    code: "15-378",
    city: "Białystok",
  },
  {
    code: "15-379",
    city: "Białystok",
  },
  {
    code: "15-380",
    city: "Białystok",
  },
  {
    code: "15-381",
    city: "Białystok",
  },
  {
    code: "15-386",
    city: "Białystok",
  },
  {
    code: "15-387",
    city: "Białystok",
  },
  {
    code: "15-388",
    city: "Białystok",
  },
  {
    code: "15-390",
    city: "Białystok",
  },
  {
    code: "15-391",
    city: "Białystok",
  },
  {
    code: "15-393",
    city: "Białystok",
  },
  {
    code: "15-394",
    city: "Białystok",
  },
  {
    code: "15-395",
    city: "Białystok",
  },
  {
    code: "15-396",
    city: "Białystok",
  },
  {
    code: "15-397",
    city: "Białystok",
  },
  {
    code: "15-398",
    city: "Białystok",
  },
  {
    code: "15-399",
    city: "Białystok",
  },
  {
    code: "15-401",
    city: "Białystok",
  },
  {
    code: "15-402",
    city: "Białystok",
  },
  {
    code: "15-403",
    city: "Białystok",
  },
  {
    code: "15-404",
    city: "Białystok",
  },
  {
    code: "15-405",
    city: "Białystok",
  },
  {
    code: "15-406",
    city: "Białystok",
  },
  {
    code: "15-407",
    city: "Białystok",
  },
  {
    code: "15-408",
    city: "Białystok",
  },
  {
    code: "15-410",
    city: "Białystok",
  },
  {
    code: "15-411",
    city: "Białystok",
  },
  {
    code: "15-412",
    city: "Białystok",
  },
  {
    code: "15-413",
    city: "Białystok",
  },
  {
    code: "15-414",
    city: "Białystok",
  },
  {
    code: "15-415",
    city: "Białystok",
  },
  {
    code: "15-416",
    city: "Białystok",
  },
  {
    code: "15-417",
    city: "Białystok",
  },
  {
    code: "15-418",
    city: "Białystok",
  },
  {
    code: "15-419",
    city: "Białystok",
  },
  {
    code: "15-420",
    city: "Białystok",
  },
  {
    code: "15-421",
    city: "Białystok",
  },
  {
    code: "15-422",
    city: "Białystok",
  },
  {
    code: "15-423",
    city: "Białystok",
  },
  {
    code: "15-424",
    city: "Białystok",
  },
  {
    code: "15-425",
    city: "Białystok",
  },
  {
    code: "15-426",
    city: "Białystok",
  },
  {
    code: "15-427",
    city: "Białystok",
  },
  {
    code: "15-428",
    city: "Białystok",
  },
  {
    code: "15-429",
    city: "Białystok",
  },
  {
    code: "15-430",
    city: "Białystok",
  },
  {
    code: "15-431",
    city: "Białystok",
  },
  {
    code: "15-432",
    city: "Białystok",
  },
  {
    code: "15-434",
    city: "Białystok",
  },
  {
    code: "15-435",
    city: "Białystok",
  },
  {
    code: "15-436",
    city: "Białystok",
  },
  {
    code: "15-437",
    city: "Białystok",
  },
  {
    code: "15-439",
    city: "Białystok",
  },
  {
    code: "15-440",
    city: "Białystok",
  },
  {
    code: "15-441",
    city: "Białystok",
  },
  {
    code: "15-442",
    city: "Białystok",
  },
  {
    code: "15-443",
    city: "Białystok",
  },
  {
    code: "15-444",
    city: "Białystok",
  },
  {
    code: "15-445",
    city: "Białystok",
  },
  {
    code: "15-446",
    city: "Białystok",
  },
  {
    code: "15-447",
    city: "Białystok",
  },
  {
    code: "15-448",
    city: "Białystok",
  },
  {
    code: "15-449",
    city: "Białystok",
  },
  {
    code: "15-450",
    city: "Białystok",
  },
  {
    code: "15-452",
    city: "Białystok",
  },
  {
    code: "15-453",
    city: "Białystok",
  },
  {
    code: "15-455",
    city: "Białystok",
  },
  {
    code: "15-459",
    city: "Białystok",
  },
  {
    code: "15-460",
    city: "Białystok",
  },
  {
    code: "15-461",
    city: "Białystok",
  },
  {
    code: "15-463",
    city: "Białystok",
  },
  {
    code: "15-464",
    city: "Białystok",
  },
  {
    code: "15-465",
    city: "Białystok",
  },
  {
    code: "15-467",
    city: "Białystok",
  },
  {
    code: "15-469",
    city: "Białystok",
  },
  {
    code: "15-470",
    city: "Białystok",
  },
  {
    code: "15-471",
    city: "Białystok",
  },
  {
    code: "15-472",
    city: "Białystok",
  },
  {
    code: "15-473",
    city: "Białystok",
  },
  {
    code: "15-476",
    city: "Białystok",
  },
  {
    code: "15-478",
    city: "Białystok",
  },
  {
    code: "15-480",
    city: "Białystok",
  },
  {
    code: "15-481",
    city: "Białystok",
  },
  {
    code: "15-482",
    city: "Białystok",
  },
  {
    code: "15-483",
    city: "Białystok",
  },
  {
    code: "15-487",
    city: "Białystok",
  },
  {
    code: "15-489",
    city: "Białystok",
  },
  {
    code: "15-490",
    city: "Białystok",
  },
  {
    code: "15-501",
    city: "Białystok",
  },
  {
    code: "15-502",
    city: "Białystok",
  },
  {
    code: "15-503",
    city: "Białystok",
  },
  {
    code: "15-505",
    city: "Białystok",
  },
  {
    code: "15-506",
    city: "Białystok",
  },
  {
    code: "15-507",
    city: "Białystok",
  },
  {
    code: "15-509",
    city: "Białystok",
  },
  {
    code: "15-510",
    city: "Białystok",
  },
  {
    code: "15-511",
    city: "Białystok",
  },
  {
    code: "15-512",
    city: "Białystok",
  },
  {
    code: "15-513",
    city: "Białystok",
  },
  {
    code: "15-514",
    city: "Białystok",
  },
  {
    code: "15-516",
    city: "Białystok",
  },
  {
    code: "15-517",
    city: "Białystok",
  },
  {
    code: "15-518",
    city: "Białystok",
  },
  {
    code: "15-519",
    city: "Białystok",
  },
  {
    code: "15-521",
    city: "Białystok",
  },
  {
    code: "15-522",
    city: "Białystok",
  },
  {
    code: "15-523",
    city: "Białystok",
  },
  {
    code: "15-524",
    city: "Białystok",
  },
  {
    code: "15-528",
    city: "Białystok",
  },
  {
    code: "15-530",
    city: "Białystok",
  },
  {
    code: "15-531",
    city: "Białystok",
  },
  {
    code: "15-532",
    city: "Białystok",
  },
  {
    code: "15-533",
    city: "Białystok",
  },
  {
    code: "15-534",
    city: "Białystok",
  },
  {
    code: "15-535",
    city: "Białystok",
  },
  {
    code: "15-536",
    city: "Białystok",
  },
  {
    code: "15-537",
    city: "Białystok",
  },
  {
    code: "15-539",
    city: "Białystok",
  },
  {
    code: "15-540",
    city: "Białystok",
  },
  {
    code: "15-541",
    city: "Białystok",
  },
  {
    code: "15-542",
    city: "Białystok",
  },
  {
    code: "15-543",
    city: "Białystok",
  },
  {
    code: "15-544",
    city: "Białystok",
  },
  {
    code: "15-545",
    city: "Białystok",
  },
  {
    code: "15-546",
    city: "Białystok",
  },
  {
    code: "15-548",
    city: "Białystok",
  },
  {
    code: "15-549",
    city: "Białystok",
  },
  {
    code: "15-551",
    city: "Białystok",
  },
  {
    code: "15-552",
    city: "Białystok",
  },
  {
    code: "15-553",
    city: "Białystok",
  },
  {
    code: "15-554",
    city: "Białystok",
  },
  {
    code: "15-555",
    city: "Białystok",
  },
  {
    code: "15-556",
    city: "Białystok",
  },
  {
    code: "15-557",
    city: "Białystok",
  },
  {
    code: "15-558",
    city: "Białystok",
  },
  {
    code: "15-559",
    city: "Białystok",
  },
  {
    code: "15-560",
    city: "Białystok",
  },
  {
    code: "15-561",
    city: "Białystok",
  },
  {
    code: "15-562",
    city: "Białystok",
  },
  {
    code: "15-563",
    city: "Białystok",
  },
  {
    code: "15-564",
    city: "Białystok",
  },
  {
    code: "15-565",
    city: "Białystok",
  },
  {
    code: "15-566",
    city: "Białystok",
  },
  {
    code: "15-567",
    city: "Białystok",
  },
  {
    code: "15-568",
    city: "Białystok",
  },
  {
    code: "15-569",
    city: "Białystok",
  },
  {
    code: "15-570",
    city: "Białystok",
  },
  {
    code: "15-571",
    city: "Białystok",
  },
  {
    code: "15-572",
    city: "Białystok",
  },
  {
    code: "15-573",
    city: "Białystok",
  },
  {
    code: "15-574",
    city: "Białystok",
  },
  {
    code: "15-575",
    city: "Białystok",
  },
  {
    code: "15-576",
    city: "Białystok",
  },
  {
    code: "15-578",
    city: "Białystok",
  },
  {
    code: "15-579",
    city: "Białystok",
  },
  {
    code: "15-580",
    city: "Białystok",
  },
  {
    code: "15-581",
    city: "Białystok",
  },
  {
    code: "15-582",
    city: "Białystok",
  },
  {
    code: "15-583",
    city: "Białystok",
  },
  {
    code: "15-584",
    city: "Białystok",
  },
  {
    code: "15-585",
    city: "Białystok",
  },
  {
    code: "15-586",
    city: "Białystok",
  },
  {
    code: "15-587",
    city: "Białystok",
  },
  {
    code: "15-588",
    city: "Białystok",
  },
  {
    code: "15-589",
    city: "Białystok",
  },
  {
    code: "15-590",
    city: "Białystok",
  },
  {
    code: "15-591",
    city: "Białystok",
  },
  {
    code: "15-592",
    city: "Białystok",
  },
  {
    code: "15-593",
    city: "Białystok",
  },
  {
    code: "15-594",
    city: "Białystok",
  },
  {
    code: "15-597",
    city: "Białystok",
  },
  {
    code: "15-601",
    city: "Białystok",
  },
  {
    code: "15-602",
    city: "Białystok",
  },
  {
    code: "15-603",
    city: "Białystok",
  },
  {
    code: "15-604",
    city: "Białystok",
  },
  {
    code: "15-605",
    city: "Białystok",
  },
  {
    code: "15-606",
    city: "Białystok",
  },
  {
    code: "15-607",
    city: "Białystok",
  },
  {
    code: "15-608",
    city: "Białystok",
  },
  {
    code: "15-611",
    city: "Białystok",
  },
  {
    code: "15-612",
    city: "Białystok",
  },
  {
    code: "15-613",
    city: "Białystok",
  },
  {
    code: "15-614",
    city: "Białystok",
  },
  {
    code: "15-615",
    city: "Białystok",
  },
  {
    code: "15-616",
    city: "Białystok",
  },
  {
    code: "15-617",
    city: "Białystok",
  },
  {
    code: "15-618",
    city: "Białystok",
  },
  {
    code: "15-619",
    city: "Białystok",
  },
  {
    code: "15-620",
    city: "Białystok",
  },
  {
    code: "15-621",
    city: "Białystok",
  },
  {
    code: "15-623",
    city: "Białystok",
  },
  {
    code: "15-624",
    city: "Białystok",
  },
  {
    code: "15-625",
    city: "Białystok",
  },
  {
    code: "15-626",
    city: "Białystok",
  },
  {
    code: "15-627",
    city: "Białystok",
  },
  {
    code: "15-628",
    city: "Białystok",
  },
  {
    code: "15-629",
    city: "Białystok",
  },
  {
    code: "15-630",
    city: "Białystok",
  },
  {
    code: "15-631",
    city: "Białystok",
  },
  {
    code: "15-632",
    city: "Białystok",
  },
  {
    code: "15-633",
    city: "Białystok",
  },
  {
    code: "15-634",
    city: "Białystok",
  },
  {
    code: "15-635",
    city: "Białystok",
  },
  {
    code: "15-636",
    city: "Białystok",
  },
  {
    code: "15-637",
    city: "Białystok",
  },
  {
    code: "15-638",
    city: "Białystok",
  },
  {
    code: "15-639",
    city: "Białystok",
  },
  {
    code: "15-640",
    city: "Białystok",
  },
  {
    code: "15-641",
    city: "Białystok",
  },
  {
    code: "15-642",
    city: "Białystok",
  },
  {
    code: "15-643",
    city: "Białystok",
  },
  {
    code: "15-644",
    city: "Białystok",
  },
  {
    code: "15-645",
    city: "Białystok",
  },
  {
    code: "15-646",
    city: "Białystok",
  },
  {
    code: "15-647",
    city: "Białystok",
  },
  {
    code: "15-649",
    city: "Białystok",
  },
  {
    code: "15-650",
    city: "Białystok",
  },
  {
    code: "15-651",
    city: "Białystok",
  },
  {
    code: "15-652",
    city: "Białystok",
  },
  {
    code: "15-654",
    city: "Białystok",
  },
  {
    code: "15-655",
    city: "Białystok",
  },
  {
    code: "15-656",
    city: "Białystok",
  },
  {
    code: "15-657",
    city: "Białystok",
  },
  {
    code: "15-659",
    city: "Białystok",
  },
  {
    code: "15-660",
    city: "Białystok",
  },
  {
    code: "15-661",
    city: "Białystok",
  },
  {
    code: "15-662",
    city: "Białystok",
  },
  {
    code: "15-663",
    city: "Białystok",
  },
  {
    code: "15-664",
    city: "Białystok",
  },
  {
    code: "15-665",
    city: "Białystok",
  },
  {
    code: "15-666",
    city: "Białystok",
  },
  {
    code: "15-667",
    city: "Białystok",
  },
  {
    code: "15-668",
    city: "Białystok",
  },
  {
    code: "15-669",
    city: "Białystok",
  },
  {
    code: "15-670",
    city: "Białystok",
  },
  {
    code: "15-671",
    city: "Białystok",
  },
  {
    code: "15-672",
    city: "Białystok",
  },
  {
    code: "15-673",
    city: "Białystok",
  },
  {
    code: "15-674",
    city: "Białystok",
  },
  {
    code: "15-678",
    city: "Białystok",
  },
  {
    code: "15-679",
    city: "Białystok",
  },
  {
    code: "15-680",
    city: "Białystok",
  },
  {
    code: "15-681",
    city: "Białystok",
  },
  {
    code: "15-682",
    city: "Białystok",
  },
  {
    code: "15-683",
    city: "Białystok",
  },
  {
    code: "15-684",
    city: "Białystok",
  },
  {
    code: "15-685",
    city: "Białystok",
  },
  {
    code: "15-686",
    city: "Białystok",
  },
  {
    code: "15-687",
    city: "Białystok",
  },
  {
    code: "15-688",
    city: "Białystok",
  },
  {
    code: "15-689",
    city: "Białystok",
  },
  {
    code: "15-690",
    city: "Białystok",
  },
  {
    code: "15-691",
    city: "Białystok",
  },
  {
    code: "15-692",
    city: "Białystok",
  },
  {
    code: "15-693",
    city: "Białystok",
  },
  {
    code: "15-694",
    city: "Białystok",
  },
  {
    code: "15-695",
    city: "Białystok",
  },
  {
    code: "15-697",
    city: "Białystok",
  },
  {
    code: "15-698",
    city: "Białystok",
  },
  {
    code: "15-699",
    city: "Białystok",
  },
  {
    code: "15-701",
    city: "Białystok",
  },
  {
    code: "15-702",
    city: "Białystok",
  },
  {
    code: "15-703",
    city: "Białystok",
  },
  {
    code: "15-704",
    city: "Białystok",
  },
  {
    code: "15-705",
    city: "Białystok",
  },
  {
    code: "15-706",
    city: "Białystok",
  },
  {
    code: "15-707",
    city: "Białystok",
  },
  {
    code: "15-709",
    city: "Białystok",
  },
  {
    code: "15-710",
    city: "Białystok",
  },
  {
    code: "15-711",
    city: "Białystok",
  },
  {
    code: "15-712",
    city: "Białystok",
  },
  {
    code: "15-714",
    city: "Białystok",
  },
  {
    code: "15-715",
    city: "Białystok",
  },
  {
    code: "15-717",
    city: "Białystok",
  },
  {
    code: "15-720",
    city: "Białystok",
  },
  {
    code: "15-722",
    city: "Białystok",
  },
  {
    code: "15-723",
    city: "Białystok",
  },
  {
    code: "15-724",
    city: "Białystok",
  },
  {
    code: "15-725",
    city: "Białystok",
  },
  {
    code: "15-727",
    city: "Białystok",
  },
  {
    code: "15-729",
    city: "Białystok",
  },
  {
    code: "15-730",
    city: "Białystok",
  },
  {
    code: "15-732",
    city: "Białystok",
  },
  {
    code: "15-740",
    city: "Białystok",
  },
  {
    code: "15-741",
    city: "Białystok",
  },
  {
    code: "15-743",
    city: "Białystok",
  },
  {
    code: "15-746",
    city: "Białystok",
  },
  {
    code: "15-748",
    city: "Białystok",
  },
  {
    code: "15-750",
    city: "Białystok",
  },
  {
    code: "15-751",
    city: "Białystok",
  },
  {
    code: "15-753",
    city: "Białystok",
  },
  {
    code: "15-754",
    city: "Białystok",
  },
  {
    code: "15-756",
    city: "Białystok",
  },
  {
    code: "15-757",
    city: "Białystok",
  },
  {
    code: "15-758",
    city: "Białystok",
  },
  {
    code: "15-760",
    city: "Białystok",
  },
  {
    code: "15-762",
    city: "Białystok",
  },
  {
    code: "15-763",
    city: "Białystok",
  },
  {
    code: "15-765",
    city: "Białystok",
  },
  {
    code: "15-767",
    city: "Białystok",
  },
  {
    code: "15-769",
    city: "Białystok",
  },
  {
    code: "15-770",
    city: "Białystok",
  },
  {
    code: "15-771",
    city: "Białystok",
  },
  {
    code: "15-772",
    city: "Białystok",
  },
  {
    code: "15-773",
    city: "Białystok",
  },
  {
    code: "15-774",
    city: "Białystok",
  },
  {
    code: "15-775",
    city: "Białystok",
  },
  {
    code: "15-776",
    city: "Białystok",
  },
  {
    code: "15-777",
    city: "Białystok",
  },
  {
    code: "15-778",
    city: "Białystok",
  },
  {
    code: "15-779",
    city: "Białystok",
  },
  {
    code: "15-780",
    city: "Białystok",
  },
  {
    code: "15-782",
    city: "Białystok",
  },
  {
    code: "15-784",
    city: "Białystok",
  },
  {
    code: "15-786",
    city: "Białystok",
  },
  {
    code: "15-788",
    city: "Białystok",
  },
  {
    code: "15-790",
    city: "Białystok",
  },
  {
    code: "15-791",
    city: "Białystok",
  },
  {
    code: "15-792",
    city: "Białystok",
  },
  {
    code: "15-793",
    city: "Białystok",
  },
  {
    code: "15-794",
    city: "Białystok",
  },
  {
    code: "15-795",
    city: "Białystok",
  },
  {
    code: "15-796",
    city: "Białystok",
  },
  {
    code: "15-797",
    city: "Białystok",
  },
  {
    code: "15-798",
    city: "Białystok",
  },
  {
    code: "15-801",
    city: "Białystok",
  },
  {
    code: "15-802",
    city: "Białystok",
  },
  {
    code: "15-803",
    city: "Białystok",
  },
  {
    code: "15-805",
    city: "Białystok",
  },
  {
    code: "15-806",
    city: "Białystok",
  },
  {
    code: "15-807",
    city: "Białystok",
  },
  {
    code: "15-808",
    city: "Białystok",
  },
  {
    code: "15-809",
    city: "Białystok",
  },
  {
    code: "15-810",
    city: "Białystok",
  },
  {
    code: "15-811",
    city: "Białystok",
  },
  {
    code: "15-812",
    city: "Białystok",
  },
  {
    code: "15-813",
    city: "Białystok",
  },
  {
    code: "15-814",
    city: "Białystok",
  },
  {
    code: "15-815",
    city: "Białystok",
  },
  {
    code: "15-817",
    city: "Białystok",
  },
  {
    code: "15-818",
    city: "Białystok",
  },
  {
    code: "15-819",
    city: "Białystok",
  },
  {
    code: "15-820",
    city: "Białystok",
  },
  {
    code: "15-821",
    city: "Białystok",
  },
  {
    code: "15-822",
    city: "Białystok",
  },
  {
    code: "15-825",
    city: "Białystok",
  },
  {
    code: "15-827",
    city: "Białystok",
  },
  {
    code: "15-829",
    city: "Białystok",
  },
  {
    code: "15-831",
    city: "Białystok",
  },
  {
    code: "15-833",
    city: "Białystok",
  },
  {
    code: "15-836",
    city: "Białystok",
  },
  {
    code: "15-837",
    city: "Białystok",
  },
  {
    code: "15-839",
    city: "Białystok",
  },
  {
    code: "15-840",
    city: "Białystok",
  },
  {
    code: "15-843",
    city: "Białystok",
  },
  {
    code: "15-845",
    city: "Białystok",
  },
  {
    code: "15-850",
    city: "Białystok",
  },
  {
    code: "15-852",
    city: "Białystok",
  },
  {
    code: "15-854",
    city: "Białystok",
  },
  {
    code: "15-856",
    city: "Białystok",
  },
  {
    code: "15-858",
    city: "Białystok",
  },
  {
    code: "15-859",
    city: "Białystok",
  },
  {
    code: "15-860",
    city: "Białystok",
  },
  {
    code: "15-861",
    city: "Białystok",
  },
  {
    code: "15-862",
    city: "Białystok",
  },
  {
    code: "15-863",
    city: "Białystok",
  },
  {
    code: "15-864",
    city: "Białystok",
  },
  {
    code: "15-865",
    city: "Białystok",
  },
  {
    code: "15-866",
    city: "Białystok",
  },
  {
    code: "15-867",
    city: "Białystok",
  },
  {
    code: "15-868",
    city: "Białystok",
  },
  {
    code: "15-869",
    city: "Białystok",
  },
  {
    code: "15-870",
    city: "Białystok",
  },
  {
    code: "15-871",
    city: "Białystok",
  },
  {
    code: "15-872",
    city: "Białystok",
  },
  {
    code: "15-873",
    city: "Białystok",
  },
  {
    code: "15-874",
    city: "Białystok",
  },
  {
    code: "15-875",
    city: "Białystok",
  },
  {
    code: "15-879",
    city: "Białystok",
  },
  {
    code: "15-880",
    city: "Białystok",
  },
  {
    code: "15-881",
    city: "Białystok",
  },
  {
    code: "15-883",
    city: "Białystok",
  },
  {
    code: "15-887",
    city: "Białystok",
  },
  {
    code: "15-888",
    city: "Białystok",
  },
  {
    code: "15-889",
    city: "Białystok",
  },
  {
    code: "15-891",
    city: "Białystok",
  },
  {
    code: "15-893",
    city: "Białystok",
  },
  {
    code: "15-895",
    city: "Białystok",
  },
  {
    code: "15-896",
    city: "Białystok",
  },
  {
    code: "15-900",
    city: "Białystok",
  },
  {
    code: "15-950",
    city: "Białystok",
  },
  {
    code: "15-951",
    city: "Białystok",
  },
  {
    code: "15-959",
    city: "Białystok",
  },
  {
    code: "16-001",
    city: "Kleosin",
  },
  {
    code: "16-002",
    city: "Dobrzyniewo Kościelne",
  },
  {
    code: "16-010",
    city: "Wasilków",
  },
  {
    code: "16-020",
    city: "Czarna Białostocka",
  },
  {
    code: "16-030",
    city: "Supraśl",
  },
  {
    code: "16-040",
    city: "Gródek",
  },
  {
    code: "16-050",
    city: "Michałowo",
  },
  {
    code: "16-060",
    city: "Zabłudów",
  },
  {
    code: "16-061",
    city: "Juchnowiec Kościelny",
  },
  {
    code: "16-070",
    city: "Choroszcz",
  },
  {
    code: "16-075",
    city: "Zawady",
  },
  {
    code: "16-080",
    city: "Tykocin",
  },
  {
    code: "16-100",
    city: "Sokółka",
  },
  {
    code: "16-101",
    city: "Sokółka",
  },
  {
    code: "16-113",
    city: "Szudziałowo",
  },
  {
    code: "16-120",
    city: "Krynki",
  },
  {
    code: "16-123",
    city: "Kuźnica",
  },
  {
    code: "16-124",
    city: "Sidra",
  },
  {
    code: "16-130",
    city: "Janów",
  },
  {
    code: "16-140",
    city: "Korycin",
  },
  {
    code: "16-150",
    city: "Suchowola",
  },
  {
    code: "16-200",
    city: "Dąbrowa Białostocka",
  },
  {
    code: "16-205",
    city: "Nowy Dwór",
  },
  {
    code: "16-300",
    city: "Augustów",
  },
  {
    code: "16-301",
    city: "Augustów",
  },
  {
    code: "16-302",
    city: "Augustów",
  },
  {
    code: "16-303",
    city: "Augustów",
  },
  {
    code: "16-304",
    city: "Nowinka",
  },
  {
    code: "16-310",
    city: "Sztabin",
  },
  {
    code: "16-315",
    city: "Lipsk",
  },
  {
    code: "16-320",
    city: "Bargłów Kościelny",
  },
  {
    code: "16-326",
    city: "Płaska",
  },
  {
    code: "16-400",
    city: "Suwałki",
  },
  {
    code: "16-401",
    city: "Suwałki",
  },
  {
    code: "16-402",
    city: "Suwałki",
  },
  {
    code: "16-404",
    city: "Jeleniewo",
  },
  {
    code: "16-406",
    city: "Rutka-Tartak",
  },
  {
    code: "16-407",
    city: "Wiżajny",
  },
  {
    code: "16-411",
    city: "Szypliszki",
  },
  {
    code: "16-420",
    city: "Raczki",
  },
  {
    code: "16-423",
    city: "Bakałarzewo",
  },
  {
    code: "16-424",
    city: "Filipów",
  },
  {
    code: "16-427",
    city: "Przerośl",
  },
  {
    code: "16-430",
    city: "Suwałki",
  },
  {
    code: "16-431",
    city: "Suwałki",
  },
  {
    code: "16-432",
    city: "Suwałki",
  },
  {
    code: "16-433",
    city: "Suwałki",
  },
  {
    code: "16-500",
    city: "Sejny",
  },
  {
    code: "16-503",
    city: "Krasnopol",
  },
  {
    code: "16-506",
    city: "Giby",
  },
  {
    code: "16-515",
    city: "Puńsk",
  },
  {
    code: "17-100",
    city: "Bielsk Podlaski",
  },
  {
    code: "17-101",
    city: "Bielsk Podlaski",
  },
  {
    code: "17-102",
    city: "Bielsk Podlaski",
  },
  {
    code: "17-106",
    city: "Orla",
  },
  {
    code: "17-111",
    city: "Boćki",
  },
  {
    code: "17-120",
    city: "Brańsk",
  },
  {
    code: "17-123",
    city: "Rudka",
  },
  {
    code: "17-132",
    city: "Wyszki",
  },
  {
    code: "17-200",
    city: "Hajnówka",
  },
  {
    code: "17-201",
    city: "Hajnówka",
  },
  {
    code: "17-204",
    city: "Dubicze Cerkiewne",
  },
  {
    code: "17-207",
    city: "Czyże",
  },
  {
    code: "17-210",
    city: "Narew",
  },
  {
    code: "17-220",
    city: "Narewka",
  },
  {
    code: "17-230",
    city: "Białowieża",
  },
  {
    code: "17-240",
    city: "Czeremcha",
  },
  {
    code: "17-250",
    city: "Kleszczele",
  },
  {
    code: "17-300",
    city: "Siemiatycze",
  },
  {
    code: "17-301",
    city: "Siematycze",
  },
  {
    code: "17-306",
    city: "Dziadkowice",
  },
  {
    code: "17-307",
    city: "Mielnik",
  },
  {
    code: "17-312",
    city: "Drohiczyn",
  },
  {
    code: "17-315",
    city: "Grodzisk",
  },
  {
    code: "17-322",
    city: "Perlejewo",
  },
  {
    code: "17-330",
    city: "Nurzec-Stacja",
  },
  {
    code: "17-332",
    city: "Milejczyce",
  },
  {
    code: "18-100",
    city: "Łapy",
  },
  {
    code: "18-101",
    city: "Łapy",
  },
  {
    code: "18-105",
    city: "Suraż",
  },
  {
    code: "18-106",
    city: "Turośń Kościelna",
  },
  {
    code: "18-112",
    city: "Poświętne",
  },
  {
    code: "18-200",
    city: "Wysokie Mazowieckie",
  },
  {
    code: "18-204",
    city: "Kobylin-Borzymy",
  },
  {
    code: "18-208",
    city: "Kulesze Kościelne",
  },
  {
    code: "18-210",
    city: "Szepietowo",
  },
  {
    code: "18-212",
    city: "Nowe Piekuty",
  },
  {
    code: "18-214",
    city: "Klukowo",
  },
  {
    code: "18-218",
    city: "Sokoły",
  },
  {
    code: "18-220",
    city: "Czyżew-Osada",
  },
  {
    code: "18-230",
    city: "Ciechanowiec",
  },
  {
    code: "18-300",
    city: "Zambrów",
  },
  {
    code: "18-301",
    city: "Zambrów",
  },
  {
    code: "18-305",
    city: "Szumowo",
  },
  {
    code: "18-312",
    city: "Rutki-Kossaki",
  },
  {
    code: "18-315",
    city: "Kołaki",
  },
  {
    code: "18-400",
    city: "Łomża",
  },
  {
    code: "18-401",
    city: "Łomża",
  },
  {
    code: "18-402",
    city: "Łomża",
  },
  {
    code: "18-403",
    city: "Łomża",
  },
  {
    code: "18-410",
    city: "Łomża",
  },
  {
    code: "18-411",
    city: "Śniadowo",
  },
  {
    code: "18-413",
    city: "Miastkowo",
  },
  {
    code: "18-414",
    city: "Nowogród",
  },
  {
    code: "18-416",
    city: "Zbójna",
  },
  {
    code: "18-420",
    city: "Jedwabne",
  },
  {
    code: "18-421",
    city: "Piątnica Poduchowna",
  },
  {
    code: "18-423",
    city: "Przytuły",
  },
  {
    code: "18-430",
    city: "Wizna",
  },
  {
    code: "18-500",
    city: "Kolno",
  },
  {
    code: "18-505",
    city: "Lachowo",
  },
  {
    code: "18-507",
    city: "Grabowo",
  },
  {
    code: "18-516",
    city: "Mały Płock",
  },
  {
    code: "18-520",
    city: "Stawiski",
  },
  {
    code: "18-525",
    city: "Turośl",
  },
  {
    code: "19-100",
    city: "Mońki",
  },
  {
    code: "19-101",
    city: "Mońki",
  },
  {
    code: "19-104",
    city: "Trzcianne",
  },
  {
    code: "19-110",
    city: "Goniądz",
  },
  {
    code: "19-111",
    city: "Krypno Kościelne",
  },
  {
    code: "19-120",
    city: "Knyszyn",
  },
  {
    code: "19-122",
    city: "Jasionówka",
  },
  {
    code: "19-124",
    city: "Jaświły",
  },
  {
    code: "19-200",
    city: "Grajewo",
  },
  {
    code: "19-203",
    city: "Grajewo",
  },
  {
    code: "19-206",
    city: "Rajgród",
  },
  {
    code: "19-212",
    city: "Białaszewo",
  },
  {
    code: "19-213",
    city: "Radziłów",
  },
  {
    code: "19-222",
    city: "Wąsosz",
  },
  {
    code: "19-230",
    city: "Szczuczyn",
  },
  {
    code: "19-300",
    city: "Ełk",
  },
  {
    code: "19-301",
    city: "Ełk",
  },
  {
    code: "19-302",
    city: "Ełk",
  },
  {
    code: "19-303",
    city: "Ełk",
  },
  {
    code: "19-304",
    city: "Ełk",
  },
  {
    code: "19-305",
    city: "Ełk",
  },
  {
    code: "19-314",
    city: "Kalinowo",
  },
  {
    code: "19-330",
    city: "Stare Juchy",
  },
  {
    code: "19-335",
    city: "Prostki",
  },
  {
    code: "19-400",
    city: "Olecko",
  },
  {
    code: "19-401",
    city: "Olecko",
  },
  {
    code: "19-402",
    city: "Olecko",
  },
  {
    code: "19-404",
    city: "Wieliczki",
  },
  {
    code: "19-411",
    city: "Świętajno",
  },
  {
    code: "19-420",
    city: "Kowale Oleckie",
  },
  {
    code: "19-500",
    city: "Gołdap",
  },
  {
    code: "19-501",
    city: "Gołdap",
  },
  {
    code: "19-504",
    city: "Dubeninki",
  },
  {
    code: "19-520",
    city: "Banie Mazurskie",
  },
  {
    code: "20-001",
    city: "Lublin",
  },
  {
    code: "20-002",
    city: "Lublin",
  },
  {
    code: "20-003",
    city: "Lublin",
  },
  {
    code: "20-004",
    city: "Lublin",
  },
  {
    code: "20-005",
    city: "Lublin",
  },
  {
    code: "20-006",
    city: "Lublin",
  },
  {
    code: "20-007",
    city: "Lublin",
  },
  {
    code: "20-008",
    city: "Lublin",
  },
  {
    code: "20-009",
    city: "Lublin",
  },
  {
    code: "20-010",
    city: "Lublin",
  },
  {
    code: "20-011",
    city: "Lublin",
  },
  {
    code: "20-012",
    city: "Lublin",
  },
  {
    code: "20-013",
    city: "Lublin",
  },
  {
    code: "20-014",
    city: "Lublin",
  },
  {
    code: "20-015",
    city: "Lublin",
  },
  {
    code: "20-016",
    city: "Lublin",
  },
  {
    code: "20-017",
    city: "Lublin",
  },
  {
    code: "20-018",
    city: "Lublin",
  },
  {
    code: "20-019",
    city: "Lublin",
  },
  {
    code: "20-020",
    city: "Lublin",
  },
  {
    code: "20-021",
    city: "Lublin",
  },
  {
    code: "20-022",
    city: "Lublin",
  },
  {
    code: "20-023",
    city: "Lublin",
  },
  {
    code: "20-024",
    city: "Lublin",
  },
  {
    code: "20-025",
    city: "Lublin",
  },
  {
    code: "20-026",
    city: "Lublin",
  },
  {
    code: "20-027",
    city: "Lublin",
  },
  {
    code: "20-028",
    city: "Lublin",
  },
  {
    code: "20-029",
    city: "Lublin",
  },
  {
    code: "20-030",
    city: "Lublin",
  },
  {
    code: "20-031",
    city: "Lublin",
  },
  {
    code: "20-032",
    city: "Lublin",
  },
  {
    code: "20-033",
    city: "Lublin",
  },
  {
    code: "20-034",
    city: "Lublin",
  },
  {
    code: "20-035",
    city: "Lublin",
  },
  {
    code: "20-036",
    city: "Lublin",
  },
  {
    code: "20-037",
    city: "Lublin",
  },
  {
    code: "20-038",
    city: "Lublin",
  },
  {
    code: "20-039",
    city: "Lublin",
  },
  {
    code: "20-040",
    city: "Lublin",
  },
  {
    code: "20-041",
    city: "Lublin",
  },
  {
    code: "20-042",
    city: "Lublin",
  },
  {
    code: "20-043",
    city: "Lublin",
  },
  {
    code: "20-044",
    city: "Lublin",
  },
  {
    code: "20-045",
    city: "Lublin",
  },
  {
    code: "20-046",
    city: "Lublin",
  },
  {
    code: "20-047",
    city: "Lublin",
  },
  {
    code: "20-048",
    city: "Lublin",
  },
  {
    code: "20-049",
    city: "Lublin",
  },
  {
    code: "20-050",
    city: "Lublin",
  },
  {
    code: "20-051",
    city: "Lublin",
  },
  {
    code: "20-052",
    city: "Lublin",
  },
  {
    code: "20-053",
    city: "Lublin",
  },
  {
    code: "20-054",
    city: "Lublin",
  },
  {
    code: "20-055",
    city: "Lublin",
  },
  {
    code: "20-056",
    city: "Lublin",
  },
  {
    code: "20-057",
    city: "Lublin",
  },
  {
    code: "20-058",
    city: "Lublin",
  },
  {
    code: "20-059",
    city: "Lublin",
  },
  {
    code: "20-060",
    city: "Lublin",
  },
  {
    code: "20-061",
    city: "Lublin",
  },
  {
    code: "20-064",
    city: "Lublin",
  },
  {
    code: "20-066",
    city: "Lublin",
  },
  {
    code: "20-067",
    city: "Lublin",
  },
  {
    code: "20-068",
    city: "Lublin",
  },
  {
    code: "20-069",
    city: "Lublin",
  },
  {
    code: "20-070",
    city: "Lublin",
  },
  {
    code: "20-071",
    city: "Lublin",
  },
  {
    code: "20-072",
    city: "Lublin",
  },
  {
    code: "20-073",
    city: "Lublin",
  },
  {
    code: "20-074",
    city: "Lublin",
  },
  {
    code: "20-075",
    city: "Lublin",
  },
  {
    code: "20-076",
    city: "Lublin",
  },
  {
    code: "20-077",
    city: "Lublin",
  },
  {
    code: "20-078",
    city: "Lublin",
  },
  {
    code: "20-079",
    city: "Lublin",
  },
  {
    code: "20-080",
    city: "Lublin",
  },
  {
    code: "20-081",
    city: "Lublin",
  },
  {
    code: "20-082",
    city: "Lublin",
  },
  {
    code: "20-083",
    city: "Lublin",
  },
  {
    code: "20-084",
    city: "Lublin",
  },
  {
    code: "20-085",
    city: "Lublin",
  },
  {
    code: "20-086",
    city: "Lublin",
  },
  {
    code: "20-087",
    city: "Lublin",
  },
  {
    code: "20-088",
    city: "Lublin",
  },
  {
    code: "20-089",
    city: "Lublin",
  },
  {
    code: "20-090",
    city: "Lublin",
  },
  {
    code: "20-092",
    city: "Lublin",
  },
  {
    code: "20-093",
    city: "Lublin",
  },
  {
    code: "20-094",
    city: "Lublin",
  },
  {
    code: "20-095",
    city: "Lublin",
  },
  {
    code: "20-097",
    city: "Lublin",
  },
  {
    code: "20-100",
    city: "Lublin",
  },
  {
    code: "20-101",
    city: "Lublin",
  },
  {
    code: "20-102",
    city: "Lublin",
  },
  {
    code: "20-103",
    city: "Lublin",
  },
  {
    code: "20-104",
    city: "Lublin",
  },
  {
    code: "20-105",
    city: "Lublin",
  },
  {
    code: "20-106",
    city: "Lublin",
  },
  {
    code: "20-107",
    city: "Lublin",
  },
  {
    code: "20-108",
    city: "Lublin",
  },
  {
    code: "20-109",
    city: "Lublin",
  },
  {
    code: "20-110",
    city: "Lublin",
  },
  {
    code: "20-111",
    city: "Lublin",
  },
  {
    code: "20-112",
    city: "Lublin",
  },
  {
    code: "20-113",
    city: "Lublin",
  },
  {
    code: "20-114",
    city: "Lublin",
  },
  {
    code: "20-115",
    city: "Lublin",
  },
  {
    code: "20-116",
    city: "Lublin",
  },
  {
    code: "20-117",
    city: "Lublin",
  },
  {
    code: "20-118",
    city: "Lublin",
  },
  {
    code: "20-119",
    city: "Lublin",
  },
  {
    code: "20-120",
    city: "Lublin",
  },
  {
    code: "20-121",
    city: "Lublin",
  },
  {
    code: "20-122",
    city: "Lublin",
  },
  {
    code: "20-123",
    city: "Lublin",
  },
  {
    code: "20-124",
    city: "Lublin",
  },
  {
    code: "20-125",
    city: "Lublin",
  },
  {
    code: "20-126",
    city: "Lublin",
  },
  {
    code: "20-127",
    city: "Lublin",
  },
  {
    code: "20-128",
    city: "Lublin",
  },
  {
    code: "20-129",
    city: "Lublin",
  },
  {
    code: "20-130",
    city: "Lublin",
  },
  {
    code: "20-132",
    city: "Lublin",
  },
  {
    code: "20-133",
    city: "Lublin",
  },
  {
    code: "20-134",
    city: "Lublin",
  },
  {
    code: "20-135",
    city: "Lublin",
  },
  {
    code: "20-136",
    city: "Lublin",
  },
  {
    code: "20-137",
    city: "Lublin",
  },
  {
    code: "20-138",
    city: "Lublin",
  },
  {
    code: "20-139",
    city: "Lublin",
  },
  {
    code: "20-140",
    city: "Lublin",
  },
  {
    code: "20-141",
    city: "Lublin",
  },
  {
    code: "20-142",
    city: "Lublin",
  },
  {
    code: "20-143",
    city: "Lublin",
  },
  {
    code: "20-144",
    city: "Lublin",
  },
  {
    code: "20-145",
    city: "Lublin",
  },
  {
    code: "20-146",
    city: "Lublin",
  },
  {
    code: "20-147",
    city: "Lublin",
  },
  {
    code: "20-148",
    city: "Lublin",
  },
  {
    code: "20-149",
    city: "Lublin",
  },
  {
    code: "20-150",
    city: "Lublin",
  },
  {
    code: "20-151",
    city: "Lublin",
  },
  {
    code: "20-152",
    city: "Lublin",
  },
  {
    code: "20-153",
    city: "Lublin",
  },
  {
    code: "20-154",
    city: "Lublin",
  },
  {
    code: "20-155",
    city: "Lublin",
  },
  {
    code: "20-160",
    city: "Lublin",
  },
  {
    code: "20-201",
    city: "Lublin",
  },
  {
    code: "20-202",
    city: "Lublin",
  },
  {
    code: "20-203",
    city: "Lublin",
  },
  {
    code: "20-204",
    city: "Lublin",
  },
  {
    code: "20-205",
    city: "Lublin",
  },
  {
    code: "20-207",
    city: "Lublin",
  },
  {
    code: "20-208",
    city: "Lublin",
  },
  {
    code: "20-209",
    city: "Lublin",
  },
  {
    code: "20-210",
    city: "Lublin",
  },
  {
    code: "20-211",
    city: "Lublin",
  },
  {
    code: "20-212",
    city: "Lublin",
  },
  {
    code: "20-213",
    city: "Lublin",
  },
  {
    code: "20-214",
    city: "Lublin",
  },
  {
    code: "20-215",
    city: "Lublin",
  },
  {
    code: "20-216",
    city: "Lublin",
  },
  {
    code: "20-217",
    city: "Lublin",
  },
  {
    code: "20-218",
    city: "Lublin",
  },
  {
    code: "20-219",
    city: "Lublin",
  },
  {
    code: "20-220",
    city: "Lublin",
  },
  {
    code: "20-221",
    city: "Lublin",
  },
  {
    code: "20-222",
    city: "Lublin",
  },
  {
    code: "20-223",
    city: "Lublin",
  },
  {
    code: "20-224",
    city: "Lublin",
  },
  {
    code: "20-225",
    city: "Lublin",
  },
  {
    code: "20-226",
    city: "Lublin",
  },
  {
    code: "20-227",
    city: "Lublin",
  },
  {
    code: "20-228",
    city: "Lublin",
  },
  {
    code: "20-229",
    city: "Lublin",
  },
  {
    code: "20-230",
    city: "Lublin",
  },
  {
    code: "20-231",
    city: "Lublin",
  },
  {
    code: "20-232",
    city: "Lublin",
  },
  {
    code: "20-233",
    city: "Lublin",
  },
  {
    code: "20-234",
    city: "Lublin",
  },
  {
    code: "20-235",
    city: "Lublin",
  },
  {
    code: "20-240",
    city: "Lublin",
  },
  {
    code: "20-241",
    city: "Lublin",
  },
  {
    code: "20-243",
    city: "Lublin",
  },
  {
    code: "20-244",
    city: "Lublin",
  },
  {
    code: "20-245",
    city: "Lublin",
  },
  {
    code: "20-246",
    city: "Lublin",
  },
  {
    code: "20-247",
    city: "Lublin",
  },
  {
    code: "20-248",
    city: "Lublin",
  },
  {
    code: "20-249",
    city: "Lublin",
  },
  {
    code: "20-250",
    city: "Lublin",
  },
  {
    code: "20-251",
    city: "Lublin",
  },
  {
    code: "20-252",
    city: "Lublin",
  },
  {
    code: "20-253",
    city: "Lublin",
  },
  {
    code: "20-254",
    city: "Lublin",
  },
  {
    code: "20-255",
    city: "Lublin",
  },
  {
    code: "20-256",
    city: "Lublin",
  },
  {
    code: "20-257",
    city: "Lublin",
  },
  {
    code: "20-258",
    city: "Lublin",
  },
  {
    code: "20-259",
    city: "Lublin",
  },
  {
    code: "20-260",
    city: "Lublin",
  },
  {
    code: "20-262",
    city: "Lublin",
  },
  {
    code: "20-270",
    city: "Lublin",
  },
  {
    code: "20-278",
    city: "Lublin",
  },
  {
    code: "20-279",
    city: "Lublin",
  },
  {
    code: "20-280",
    city: "Lublin",
  },
  {
    code: "20-281",
    city: "Lublin",
  },
  {
    code: "20-282",
    city: "Lublin",
  },
  {
    code: "20-283",
    city: "Lublin",
  },
  {
    code: "20-290",
    city: "Lublin",
  },
  {
    code: "20-301",
    city: "Lublin",
  },
  {
    code: "20-302",
    city: "Lublin",
  },
  {
    code: "20-303",
    city: "Lublin",
  },
  {
    code: "20-304",
    city: "Lublin",
  },
  {
    code: "20-305",
    city: "Lublin",
  },
  {
    code: "20-306",
    city: "Lublin",
  },
  {
    code: "20-307",
    city: "Lublin",
  },
  {
    code: "20-309",
    city: "Lublin",
  },
  {
    code: "20-310",
    city: "Lublin",
  },
  {
    code: "20-311",
    city: "Lublin",
  },
  {
    code: "20-313",
    city: "Lublin",
  },
  {
    code: "20-314",
    city: "Lublin",
  },
  {
    code: "20-315",
    city: "Lublin",
  },
  {
    code: "20-316",
    city: "Lublin",
  },
  {
    code: "20-317",
    city: "Lublin",
  },
  {
    code: "20-318",
    city: "Lublin",
  },
  {
    code: "20-319",
    city: "Lublin",
  },
  {
    code: "20-320",
    city: "Lublin",
  },
  {
    code: "20-321",
    city: "Lublin",
  },
  {
    code: "20-322",
    city: "Lublin",
  },
  {
    code: "20-323",
    city: "Lublin",
  },
  {
    code: "20-324",
    city: "Lublin",
  },
  {
    code: "20-325",
    city: "Lublin",
  },
  {
    code: "20-326",
    city: "Lublin",
  },
  {
    code: "20-327",
    city: "Lublin",
  },
  {
    code: "20-328",
    city: "Lublin",
  },
  {
    code: "20-329",
    city: "Lublin",
  },
  {
    code: "20-330",
    city: "Lublin",
  },
  {
    code: "20-331",
    city: "Lublin",
  },
  {
    code: "20-333",
    city: "Lublin",
  },
  {
    code: "20-334",
    city: "Lublin",
  },
  {
    code: "20-335",
    city: "Lublin",
  },
  {
    code: "20-336",
    city: "Lublin",
  },
  {
    code: "20-337",
    city: "Lublin",
  },
  {
    code: "20-338",
    city: "Lublin",
  },
  {
    code: "20-340",
    city: "Lublin",
  },
  {
    code: "20-341",
    city: "Lublin",
  },
  {
    code: "20-342",
    city: "Lublin",
  },
  {
    code: "20-343",
    city: "Lublin",
  },
  {
    code: "20-344",
    city: "Lublin",
  },
  {
    code: "20-346",
    city: "Lublin",
  },
  {
    code: "20-347",
    city: "Lublin",
  },
  {
    code: "20-348",
    city: "Lublin",
  },
  {
    code: "20-349",
    city: "Lublin",
  },
  {
    code: "20-350",
    city: "Lublin",
  },
  {
    code: "20-351",
    city: "Lublin",
  },
  {
    code: "20-352",
    city: "Lublin",
  },
  {
    code: "20-353",
    city: "Lublin",
  },
  {
    code: "20-354",
    city: "Lublin",
  },
  {
    code: "20-355",
    city: "Lublin",
  },
  {
    code: "20-356",
    city: "Lublin",
  },
  {
    code: "20-357",
    city: "Lublin",
  },
  {
    code: "20-358",
    city: "Lublin",
  },
  {
    code: "20-359",
    city: "Lublin",
  },
  {
    code: "20-360",
    city: "Lublin",
  },
  {
    code: "20-361",
    city: "Lublin",
  },
  {
    code: "20-362",
    city: "Lublin",
  },
  {
    code: "20-363",
    city: "Lublin",
  },
  {
    code: "20-364",
    city: "Lublin",
  },
  {
    code: "20-365",
    city: "Lublin",
  },
  {
    code: "20-366",
    city: "Lublin",
  },
  {
    code: "20-367",
    city: "Lublin",
  },
  {
    code: "20-368",
    city: "Lublin",
  },
  {
    code: "20-369",
    city: "Lublin",
  },
  {
    code: "20-370",
    city: "Lublin",
  },
  {
    code: "20-371",
    city: "Lublin",
  },
  {
    code: "20-372",
    city: "Lublin",
  },
  {
    code: "20-373",
    city: "Lublin",
  },
  {
    code: "20-374",
    city: "Lublin",
  },
  {
    code: "20-375",
    city: "Lublin",
  },
  {
    code: "20-376",
    city: "Lublin",
  },
  {
    code: "20-377",
    city: "Lublin",
  },
  {
    code: "20-378",
    city: "Lublin",
  },
  {
    code: "20-379",
    city: "Lublin",
  },
  {
    code: "20-380",
    city: "Lublin",
  },
  {
    code: "20-381",
    city: "Lublin",
  },
  {
    code: "20-382",
    city: "Lublin",
  },
  {
    code: "20-383",
    city: "Lublin",
  },
  {
    code: "20-384",
    city: "Lublin",
  },
  {
    code: "20-385",
    city: "Lublin",
  },
  {
    code: "20-386",
    city: "Lublin",
  },
  {
    code: "20-387",
    city: "Lublin",
  },
  {
    code: "20-388",
    city: "Lublin",
  },
  {
    code: "20-390",
    city: "Lublin",
  },
  {
    code: "20-391",
    city: "Lublin",
  },
  {
    code: "20-400",
    city: "Lublin",
  },
  {
    code: "20-401",
    city: "Lublin",
  },
  {
    code: "20-402",
    city: "Lublin",
  },
  {
    code: "20-403",
    city: "Lublin",
  },
  {
    code: "20-404",
    city: "Lublin",
  },
  {
    code: "20-405",
    city: "Lublin",
  },
  {
    code: "20-406",
    city: "Lublin",
  },
  {
    code: "20-407",
    city: "Lublin",
  },
  {
    code: "20-408",
    city: "Lublin",
  },
  {
    code: "20-409",
    city: "Lublin",
  },
  {
    code: "20-410",
    city: "Lublin",
  },
  {
    code: "20-411",
    city: "Lublin",
  },
  {
    code: "20-412",
    city: "Lublin",
  },
  {
    code: "20-413",
    city: "Lublin",
  },
  {
    code: "20-414",
    city: "Lublin",
  },
  {
    code: "20-415",
    city: "Lublin",
  },
  {
    code: "20-416",
    city: "Lublin",
  },
  {
    code: "20-417",
    city: "Lublin",
  },
  {
    code: "20-418",
    city: "Lublin",
  },
  {
    code: "20-420",
    city: "Lublin",
  },
  {
    code: "20-421",
    city: "Lublin",
  },
  {
    code: "20-422",
    city: "Lublin",
  },
  {
    code: "20-423",
    city: "Lublin",
  },
  {
    code: "20-424",
    city: "Lublin",
  },
  {
    code: "20-425",
    city: "Lublin",
  },
  {
    code: "20-426",
    city: "Lublin",
  },
  {
    code: "20-427",
    city: "Lublin",
  },
  {
    code: "20-429",
    city: "Lublin",
  },
  {
    code: "20-430",
    city: "Lublin",
  },
  {
    code: "20-431",
    city: "Lublin",
  },
  {
    code: "20-432",
    city: "Lublin",
  },
  {
    code: "20-433",
    city: "Lublin",
  },
  {
    code: "20-434",
    city: "Lublin",
  },
  {
    code: "20-435",
    city: "Lublin",
  },
  {
    code: "20-436",
    city: "Lublin",
  },
  {
    code: "20-437",
    city: "Lublin",
  },
  {
    code: "20-439",
    city: "Lublin",
  },
  {
    code: "20-440",
    city: "Lublin",
  },
  {
    code: "20-441",
    city: "Lublin",
  },
  {
    code: "20-442",
    city: "Lublin",
  },
  {
    code: "20-443",
    city: "Lublin",
  },
  {
    code: "20-444",
    city: "Lublin",
  },
  {
    code: "20-445",
    city: "Lublin",
  },
  {
    code: "20-446",
    city: "Lublin",
  },
  {
    code: "20-447",
    city: "Lublin",
  },
  {
    code: "20-448",
    city: "Lublin",
  },
  {
    code: "20-449",
    city: "Lublin",
  },
  {
    code: "20-450",
    city: "Lublin",
  },
  {
    code: "20-451",
    city: "Lublin",
  },
  {
    code: "20-452",
    city: "Lublin",
  },
  {
    code: "20-453",
    city: "Lublin",
  },
  {
    code: "20-454",
    city: "Lublin",
  },
  {
    code: "20-455",
    city: "Lublin",
  },
  {
    code: "20-456",
    city: "Lublin",
  },
  {
    code: "20-457",
    city: "Lublin",
  },
  {
    code: "20-458",
    city: "Lublin",
  },
  {
    code: "20-459",
    city: "Lublin",
  },
  {
    code: "20-460",
    city: "Lublin",
  },
  {
    code: "20-461",
    city: "Lublin",
  },
  {
    code: "20-462",
    city: "Lublin",
  },
  {
    code: "20-463",
    city: "Lublin",
  },
  {
    code: "20-464",
    city: "Lublin",
  },
  {
    code: "20-465",
    city: "Lublin",
  },
  {
    code: "20-466",
    city: "Lublin",
  },
  {
    code: "20-467",
    city: "Lublin",
  },
  {
    code: "20-468",
    city: "Lublin",
  },
  {
    code: "20-469",
    city: "Lublin",
  },
  {
    code: "20-470",
    city: "Lublin",
  },
  {
    code: "20-471",
    city: "Lublin",
  },
  {
    code: "20-472",
    city: "Lublin",
  },
  {
    code: "20-473",
    city: "Lublin",
  },
  {
    code: "20-474",
    city: "Lublin",
  },
  {
    code: "20-479",
    city: "Lublin",
  },
  {
    code: "20-481",
    city: "Lublin",
  },
  {
    code: "20-482",
    city: "Lublin",
  },
  {
    code: "20-483",
    city: "Lublin",
  },
  {
    code: "20-484",
    city: "Lublin",
  },
  {
    code: "20-485",
    city: "Lublin",
  },
  {
    code: "20-486",
    city: "Lublin",
  },
  {
    code: "20-487",
    city: "Lublin",
  },
  {
    code: "20-488",
    city: "Lublin",
  },
  {
    code: "20-489",
    city: "Lublin",
  },
  {
    code: "20-490",
    city: "Lublin",
  },
  {
    code: "20-491",
    city: "Lublin",
  },
  {
    code: "20-492",
    city: "Lublin",
  },
  {
    code: "20-500",
    city: "Lublin",
  },
  {
    code: "20-501",
    city: "Lublin",
  },
  {
    code: "20-502",
    city: "Lublin",
  },
  {
    code: "20-504",
    city: "Lublin",
  },
  {
    code: "20-506",
    city: "Lublin",
  },
  {
    code: "20-508",
    city: "Lublin",
  },
  {
    code: "20-509",
    city: "Lublin",
  },
  {
    code: "20-510",
    city: "Lublin",
  },
  {
    code: "20-515",
    city: "Lublin",
  },
  {
    code: "20-516",
    city: "Lublin",
  },
  {
    code: "20-517",
    city: "Lublin",
  },
  {
    code: "20-518",
    city: "Lublin",
  },
  {
    code: "20-520",
    city: "Lublin",
  },
  {
    code: "20-521",
    city: "Lublin",
  },
  {
    code: "20-522",
    city: "Lublin",
  },
  {
    code: "20-523",
    city: "Lublin",
  },
  {
    code: "20-524",
    city: "Lublin",
  },
  {
    code: "20-525",
    city: "Lublin",
  },
  {
    code: "20-530",
    city: "Lublin",
  },
  {
    code: "20-531",
    city: "Lublin",
  },
  {
    code: "20-532",
    city: "Lublin",
  },
  {
    code: "20-533",
    city: "Lublin",
  },
  {
    code: "20-534",
    city: "Lublin",
  },
  {
    code: "20-535",
    city: "Lublin",
  },
  {
    code: "20-536",
    city: "Lublin",
  },
  {
    code: "20-537",
    city: "Lublin",
  },
  {
    code: "20-538",
    city: "Lublin",
  },
  {
    code: "20-539",
    city: "Lublin",
  },
  {
    code: "20-540",
    city: "Lublin",
  },
  {
    code: "20-541",
    city: "Lublin",
  },
  {
    code: "20-542",
    city: "Lublin",
  },
  {
    code: "20-543",
    city: "Lublin",
  },
  {
    code: "20-550",
    city: "Lublin",
  },
  {
    code: "20-551",
    city: "Lublin",
  },
  {
    code: "20-552",
    city: "Lublin",
  },
  {
    code: "20-553",
    city: "Lublin",
  },
  {
    code: "20-554",
    city: "Lublin",
  },
  {
    code: "20-555",
    city: "Lublin",
  },
  {
    code: "20-560",
    city: "Lublin",
  },
  {
    code: "20-561",
    city: "Lublin",
  },
  {
    code: "20-562",
    city: "Lublin",
  },
  {
    code: "20-563",
    city: "Lublin",
  },
  {
    code: "20-564",
    city: "Lublin",
  },
  {
    code: "20-570",
    city: "Lublin",
  },
  {
    code: "20-571",
    city: "Lublin",
  },
  {
    code: "20-572",
    city: "Lublin",
  },
  {
    code: "20-573",
    city: "Lublin",
  },
  {
    code: "20-574",
    city: "Lublin",
  },
  {
    code: "20-575",
    city: "Lublin",
  },
  {
    code: "20-576",
    city: "Lublin",
  },
  {
    code: "20-577",
    city: "Lublin",
  },
  {
    code: "20-578",
    city: "Lublin",
  },
  {
    code: "20-579",
    city: "Lublin",
  },
  {
    code: "20-580",
    city: "Lublin",
  },
  {
    code: "20-581",
    city: "Lublin",
  },
  {
    code: "20-590",
    city: "Lublin",
  },
  {
    code: "20-601",
    city: "Lublin",
  },
  {
    code: "20-602",
    city: "Lublin",
  },
  {
    code: "20-603",
    city: "Lublin",
  },
  {
    code: "20-604",
    city: "Lublin",
  },
  {
    code: "20-605",
    city: "Lublin",
  },
  {
    code: "20-606",
    city: "Lublin",
  },
  {
    code: "20-607",
    city: "Lublin",
  },
  {
    code: "20-608",
    city: "Lublin",
  },
  {
    code: "20-609",
    city: "Lublin",
  },
  {
    code: "20-610",
    city: "Lublin",
  },
  {
    code: "20-611",
    city: "Lublin",
  },
  {
    code: "20-612",
    city: "Lublin",
  },
  {
    code: "20-613",
    city: "Lublin",
  },
  {
    code: "20-614",
    city: "Lublin",
  },
  {
    code: "20-615",
    city: "Lublin",
  },
  {
    code: "20-616",
    city: "Lublin",
  },
  {
    code: "20-617",
    city: "Lublin",
  },
  {
    code: "20-618",
    city: "Lublin",
  },
  {
    code: "20-619",
    city: "Lublin",
  },
  {
    code: "20-620",
    city: "Lublin",
  },
  {
    code: "20-621",
    city: "Lublin",
  },
  {
    code: "20-624",
    city: "Lublin",
  },
  {
    code: "20-625",
    city: "Lublin",
  },
  {
    code: "20-626",
    city: "Lublin",
  },
  {
    code: "20-627",
    city: "Lublin",
  },
  {
    code: "20-628",
    city: "Lublin",
  },
  {
    code: "20-629",
    city: "Lublin",
  },
  {
    code: "20-630",
    city: "Lublin",
  },
  {
    code: "20-631",
    city: "Lublin",
  },
  {
    code: "20-632",
    city: "Lublin",
  },
  {
    code: "20-633",
    city: "Lublin",
  },
  {
    code: "20-634",
    city: "Lublin",
  },
  {
    code: "20-635",
    city: "Lublin",
  },
  {
    code: "20-636",
    city: "Lublin",
  },
  {
    code: "20-637",
    city: "Lublin",
  },
  {
    code: "20-639",
    city: "Lublin",
  },
  {
    code: "20-640",
    city: "Lublin",
  },
  {
    code: "20-701",
    city: "Lublin",
  },
  {
    code: "20-703",
    city: "Lublin",
  },
  {
    code: "20-704",
    city: "Lublin",
  },
  {
    code: "20-705",
    city: "Lublin",
  },
  {
    code: "20-706",
    city: "Lublin",
  },
  {
    code: "20-707",
    city: "Lublin",
  },
  {
    code: "20-708",
    city: "Lublin",
  },
  {
    code: "20-709",
    city: "Lublin",
  },
  {
    code: "20-710",
    city: "Lublin",
  },
  {
    code: "20-711",
    city: "Lublin",
  },
  {
    code: "20-712",
    city: "Lublin",
  },
  {
    code: "20-713",
    city: "Lublin",
  },
  {
    code: "20-714",
    city: "Lublin",
  },
  {
    code: "20-715",
    city: "Lublin",
  },
  {
    code: "20-716",
    city: "Lublin",
  },
  {
    code: "20-717",
    city: "Lublin",
  },
  {
    code: "20-718",
    city: "Lublin",
  },
  {
    code: "20-719",
    city: "Lublin",
  },
  {
    code: "20-721",
    city: "Lublin",
  },
  {
    code: "20-722",
    city: "Lublin",
  },
  {
    code: "20-723",
    city: "Lublin",
  },
  {
    code: "20-724",
    city: "Lublin",
  },
  {
    code: "20-725",
    city: "Lublin",
  },
  {
    code: "20-726",
    city: "Lublin",
  },
  {
    code: "20-727",
    city: "Lublin",
  },
  {
    code: "20-728",
    city: "Lublin",
  },
  {
    code: "20-729",
    city: "Lublin",
  },
  {
    code: "20-730",
    city: "Lublin",
  },
  {
    code: "20-731",
    city: "Lublin",
  },
  {
    code: "20-732",
    city: "Lublin",
  },
  {
    code: "20-733",
    city: "Lublin",
  },
  {
    code: "20-734",
    city: "Lublin",
  },
  {
    code: "20-735",
    city: "Lublin",
  },
  {
    code: "20-736",
    city: "Lublin",
  },
  {
    code: "20-737",
    city: "Lublin",
  },
  {
    code: "20-738",
    city: "Lublin",
  },
  {
    code: "20-739",
    city: "Lublin",
  },
  {
    code: "20-750",
    city: "Lublin",
  },
  {
    code: "20-751",
    city: "Lublin",
  },
  {
    code: "20-780",
    city: "Lublin",
  },
  {
    code: "20-781",
    city: "Lublin",
  },
  {
    code: "20-782",
    city: "Lublin",
  },
  {
    code: "20-783",
    city: "Lublin",
  },
  {
    code: "20-784",
    city: "Lublin",
  },
  {
    code: "20-785",
    city: "Lublin",
  },
  {
    code: "20-786",
    city: "Lublin",
  },
  {
    code: "20-787",
    city: "Lublin",
  },
  {
    code: "20-788",
    city: "Lublin",
  },
  {
    code: "20-789",
    city: "Lublin",
  },
  {
    code: "20-801",
    city: "Lublin",
  },
  {
    code: "20-802",
    city: "Lublin",
  },
  {
    code: "20-803",
    city: "Lublin",
  },
  {
    code: "20-804",
    city: "Lublin",
  },
  {
    code: "20-805",
    city: "Lublin",
  },
  {
    code: "20-806",
    city: "Lublin",
  },
  {
    code: "20-807",
    city: "Lublin",
  },
  {
    code: "20-808",
    city: "Lublin",
  },
  {
    code: "20-809",
    city: "Lublin",
  },
  {
    code: "20-810",
    city: "Lublin",
  },
  {
    code: "20-811",
    city: "Lublin",
  },
  {
    code: "20-812",
    city: "Lublin",
  },
  {
    code: "20-813",
    city: "Lublin",
  },
  {
    code: "20-814",
    city: "Lublin",
  },
  {
    code: "20-815",
    city: "Lublin",
  },
  {
    code: "20-816",
    city: "Lublin",
  },
  {
    code: "20-817",
    city: "Lublin",
  },
  {
    code: "20-818",
    city: "Lublin",
  },
  {
    code: "20-819",
    city: "Lublin",
  },
  {
    code: "20-820",
    city: "Lublin",
  },
  {
    code: "20-822",
    city: "Lublin",
  },
  {
    code: "20-823",
    city: "Lublin",
  },
  {
    code: "20-824",
    city: "Lublin",
  },
  {
    code: "20-825",
    city: "Lublin",
  },
  {
    code: "20-826",
    city: "Lublin",
  },
  {
    code: "20-827",
    city: "Lublin",
  },
  {
    code: "20-828",
    city: "Lublin",
  },
  {
    code: "20-829",
    city: "Lublin",
  },
  {
    code: "20-830",
    city: "Lublin",
  },
  {
    code: "20-831",
    city: "Lublin",
  },
  {
    code: "20-832",
    city: "Lublin",
  },
  {
    code: "20-833",
    city: "Lublin",
  },
  {
    code: "20-834",
    city: "Lublin",
  },
  {
    code: "20-835",
    city: "Lublin",
  },
  {
    code: "20-836",
    city: "Lublin",
  },
  {
    code: "20-837",
    city: "Lublin",
  },
  {
    code: "20-838",
    city: "Lublin",
  },
  {
    code: "20-839",
    city: "Lublin",
  },
  {
    code: "20-840",
    city: "Lublin",
  },
  {
    code: "20-841",
    city: "Lublin",
  },
  {
    code: "20-843",
    city: "Lublin",
  },
  {
    code: "20-844",
    city: "Lublin",
  },
  {
    code: "20-845",
    city: "Lublin",
  },
  {
    code: "20-848",
    city: "Lublin",
  },
  {
    code: "20-849",
    city: "Lublin",
  },
  {
    code: "20-850",
    city: "Lublin",
  },
  {
    code: "20-851",
    city: "Lublin",
  },
  {
    code: "20-853",
    city: "Lublin",
  },
  {
    code: "20-854",
    city: "Lublin",
  },
  {
    code: "20-856",
    city: "Lublin",
  },
  {
    code: "20-857",
    city: "Lublin",
  },
  {
    code: "20-858",
    city: "Lublin",
  },
  {
    code: "20-859",
    city: "Lublin",
  },
  {
    code: "20-860",
    city: "Lublin",
  },
  {
    code: "20-861",
    city: "Lublin",
  },
  {
    code: "20-862",
    city: "Lublin",
  },
  {
    code: "20-863",
    city: "Lublin",
  },
  {
    code: "20-864",
    city: "Lublin",
  },
  {
    code: "20-865",
    city: "Lublin",
  },
  {
    code: "20-866",
    city: "Lublin",
  },
  {
    code: "20-867",
    city: "Lublin",
  },
  {
    code: "20-868",
    city: "Lublin",
  },
  {
    code: "20-869",
    city: "Lublin",
  },
  {
    code: "20-870",
    city: "Lublin",
  },
  {
    code: "20-871",
    city: "Lublin",
  },
  {
    code: "20-874",
    city: "Lublin",
  },
  {
    code: "20-875",
    city: "Lublin",
  },
  {
    code: "20-880",
    city: "Lublin",
  },
  {
    code: "20-881",
    city: "Lublin",
  },
  {
    code: "20-882",
    city: "Lublin",
  },
  {
    code: "20-883",
    city: "Lublin",
  },
  {
    code: "20-884",
    city: "Lublin",
  },
  {
    code: "20-900",
    city: "Lublin",
  },
  {
    code: "20-940",
    city: "Lublin",
  },
  {
    code: "20-950",
    city: "Lublin",
  },
  {
    code: "20-951",
    city: "Lublin",
  },
  {
    code: "20-952",
    city: "Lublin",
  },
  {
    code: "20-953",
    city: "Lublin",
  },
  {
    code: "20-954",
    city: "Lublin",
  },
  {
    code: "20-955",
    city: "Lublin",
  },
  {
    code: "20-956",
    city: "Lublin",
  },
  {
    code: "20-958",
    city: "Lublin",
  },
  {
    code: "20-960",
    city: "Lublin",
  },
  {
    code: "20-990",
    city: "Lublin",
  },
  {
    code: "21-002",
    city: "Jastków",
  },
  {
    code: "21-003",
    city: "Ciecierzyn",
  },
  {
    code: "21-007",
    city: "Mełgiew",
  },
  {
    code: "21-008",
    city: "Tomaszowice",
  },
  {
    code: "21-010",
    city: "Łęczna",
  },
  {
    code: "21-013",
    city: "Puchaczów",
  },
  {
    code: "21-017",
    city: "Łęczna",
  },
  {
    code: "21-020",
    city: "Milejów",
  },
  {
    code: "21-025",
    city: "Niemce",
  },
  {
    code: "21-030",
    city: "Motycz",
  },
  {
    code: "21-040",
    city: "Świdnik",
  },
  {
    code: "21-044",
    city: "Trawniki",
  },
  {
    code: "21-045",
    city: "Świdnik",
  },
  {
    code: "21-046",
    city: "Świdnik",
  },
  {
    code: "21-047",
    city: "Świdnik",
  },
  {
    code: "21-050",
    city: "Piaski",
  },
  {
    code: "21-060",
    city: "Fajsławice",
  },
  {
    code: "21-065",
    city: "Rybczewice",
  },
  {
    code: "21-070",
    city: "Cyców",
  },
  {
    code: "21-075",
    city: "Ludwin",
  },
  {
    code: "21-077",
    city: "Spiczyn",
  },
  {
    code: "21-080",
    city: "Garbów",
  },
  {
    code: "21-100",
    city: "Lubartów",
  },
  {
    code: "21-102",
    city: "Ostrówek",
  },
  {
    code: "21-104",
    city: "Niedźwiada",
  },
  {
    code: "21-107",
    city: "Serniki",
  },
  {
    code: "21-108",
    city: "Lubartów",
  },
  {
    code: "21-109",
    city: "Uścimów",
  },
  {
    code: "21-110",
    city: "Ostrów Lubelski",
  },
  {
    code: "21-132",
    city: "Kamionka",
  },
  {
    code: "21-136",
    city: "Firlej",
  },
  {
    code: "21-140",
    city: "Michów",
  },
  {
    code: "21-143",
    city: "Abramów",
  },
  {
    code: "21-146",
    city: "Jeziorzany",
  },
  {
    code: "21-150",
    city: "Kock",
  },
  {
    code: "21-200",
    city: "Parczew",
  },
  {
    code: "21-205",
    city: "Jabłoń",
  },
  {
    code: "21-210",
    city: "Milanów",
  },
  {
    code: "21-211",
    city: "Dębowa Kłoda",
  },
  {
    code: "21-213",
    city: "Kodeniec",
  },
  {
    code: "21-220",
    city: "Siemień",
  },
  {
    code: "21-222",
    city: "Podedwórze",
  },
  {
    code: "21-230",
    city: "Sosnowica",
  },
  {
    code: "21-300",
    city: "Radzyń Podlaski",
  },
  {
    code: "21-302",
    city: "Kąkolewnica Wschodnia",
  },
  {
    code: "21-305",
    city: "Suchowola",
  },
  {
    code: "21-306",
    city: "Czemierniki",
  },
  {
    code: "21-307",
    city: "Ulan-Majorat",
  },
  {
    code: "21-310",
    city: "Wohyń",
  },
  {
    code: "21-311",
    city: "Komarówka Podlaska",
  },
  {
    code: "21-315",
    city: "Radzyń Podlaski",
  },
  {
    code: "21-345",
    city: "Borki",
  },
  {
    code: "21-400",
    city: "Łuków",
  },
  {
    code: "21-404",
    city: "Trzebieszów",
  },
  {
    code: "21-405",
    city: "Zembry",
  },
  {
    code: "21-410",
    city: "Łuków",
  },
  {
    code: "21-411",
    city: "Wojcieszków",
  },
  {
    code: "21-412",
    city: "Adamów",
  },
  {
    code: "21-413",
    city: "Serokomla",
  },
  {
    code: "21-421",
    city: "Tuchowicz",
  },
  {
    code: "21-422",
    city: "Stanin",
  },
  {
    code: "21-425",
    city: "Huta-Dąbrowa",
  },
  {
    code: "21-426",
    city: "Wola Mysłowska",
  },
  {
    code: "21-450",
    city: "Stoczek Łukowski",
  },
  {
    code: "21-470",
    city: "Krzywda",
  },
  {
    code: "21-480",
    city: "Okrzeja",
  },
  {
    code: "21-481",
    city: "Wola Gułowska",
  },
  {
    code: "21-500",
    city: "Biała Podlaska",
  },
  {
    code: "21-501",
    city: "Biała Podlaska",
  },
  {
    code: "21-502",
    city: "Biała Podlaska",
  },
  {
    code: "21-504",
    city: "Rokitno",
  },
  {
    code: "21-505",
    city: "Janów Podlaski",
  },
  {
    code: "21-506",
    city: "Biała Podlaska",
  },
  {
    code: "21-509",
    city: "Kodeń",
  },
  {
    code: "21-512",
    city: "Zalesie",
  },
  {
    code: "21-515",
    city: "Sławatycze",
  },
  {
    code: "21-518",
    city: "Sosnówka",
  },
  {
    code: "21-523",
    city: "Tuczna",
  },
  {
    code: "21-526",
    city: "Jabłeczna",
  },
  {
    code: "21-527",
    city: "Biała Podlaska",
  },
  {
    code: "21-530",
    city: "Piszczac",
  },
  {
    code: "21-532",
    city: "Łomazy",
  },
  {
    code: "21-533",
    city: "Rossosz",
  },
  {
    code: "21-536",
    city: "Swory",
  },
  {
    code: "21-540",
    city: "Małaszewicze",
  },
  {
    code: "21-542",
    city: "Leśna Podlaska",
  },
  {
    code: "21-543",
    city: "Konstantynów",
  },
  {
    code: "21-550",
    city: "Terespol",
  },
  {
    code: "21-560",
    city: "Międzyrzec Podlaski",
  },
  {
    code: "21-561",
    city: "Międzyrzec Podlaski",
  },
  {
    code: "21-564",
    city: "Tłuściec",
  },
  {
    code: "21-570",
    city: "Drelów",
  },
  {
    code: "21-580",
    city: "Wisznice",
  },
  {
    code: "21-590",
    city: "Biała Podlaska",
  },
  {
    code: "22-100",
    city: "Chełm",
  },
  {
    code: "22-102",
    city: "Chełm",
  },
  {
    code: "22-103",
    city: "Chełm",
  },
  {
    code: "22-104",
    city: "Chełm",
  },
  {
    code: "22-105",
    city: "Okszów",
  },
  {
    code: "22-106",
    city: "Czułczyce",
  },
  {
    code: "22-107",
    city: "Sawin",
  },
  {
    code: "22-109",
    city: "Chełm",
  },
  {
    code: "22-110",
    city: "Ruda-Huta",
  },
  {
    code: "22-113",
    city: "Kamień",
  },
  {
    code: "22-114",
    city: "Żmudź",
  },
  {
    code: "22-115",
    city: "Chełm",
  },
  {
    code: "22-116",
    city: "Chełm",
  },
  {
    code: "22-117",
    city: "Chełm",
  },
  {
    code: "22-118",
    city: "Chełm",
  },
  {
    code: "22-120",
    city: "Wojsławice",
  },
  {
    code: "22-122",
    city: "Leśniowice",
  },
  {
    code: "22-130",
    city: "Siedliszcze",
  },
  {
    code: "22-133",
    city: "Nowe Chojno",
  },
  {
    code: "22-135",
    city: "Białopole",
  },
  {
    code: "22-145",
    city: "Dubienka",
  },
  {
    code: "22-150",
    city: "Wierzbica",
  },
  {
    code: "22-151",
    city: "Staw",
  },
  {
    code: "22-169",
    city: "Rejowiec Fabryczny",
  },
  {
    code: "22-170",
    city: "Rejowiec Fabryczny",
  },
  {
    code: "22-174",
    city: "Brzeźno",
  },
  {
    code: "22-175",
    city: "Dorohusk",
  },
  {
    code: "22-200",
    city: "Włodawa",
  },
  {
    code: "22-201",
    city: "Włodawa",
  },
  {
    code: "22-205",
    city: "Wyryki",
  },
  {
    code: "22-207",
    city: "Żuków",
  },
  {
    code: "22-211",
    city: "Różanka",
  },
  {
    code: "22-220",
    city: "Hanna",
  },
  {
    code: "22-230",
    city: "Wola Uhruska",
  },
  {
    code: "22-232",
    city: "Okuninka",
  },
  {
    code: "22-234",
    city: "Urszulin",
  },
  {
    code: "22-235",
    city: "Hańsk Pierwszy",
  },
  {
    code: "22-244",
    city: "Stary Brus",
  },
  {
    code: "22-300",
    city: "Krasnystaw",
  },
  {
    code: "22-302",
    city: "Siennica Nadolna",
  },
  {
    code: "22-304",
    city: "Siennica Różana",
  },
  {
    code: "22-310",
    city: "Kraśniczyn",
  },
  {
    code: "22-315",
    city: "Gorzków",
  },
  {
    code: "22-330",
    city: "Rudnik",
  },
  {
    code: "22-335",
    city: "Żółkiewka-Osada",
  },
  {
    code: "22-351",
    city: "Łopiennik Górny",
  },
  {
    code: "22-360",
    city: "Rejowiec",
  },
  {
    code: "22-363",
    city: "Zawadówka",
  },
  {
    code: "22-375",
    city: "Izbica",
  },
  {
    code: "22-376",
    city: "Orłów Murowany",
  },
  {
    code: "22-400",
    city: "Zamość",
  },
  {
    code: "22-401",
    city: "Zamość",
  },
  {
    code: "22-402",
    city: "Zamość",
  },
  {
    code: "22-403",
    city: "Zamość",
  },
  {
    code: "22-404",
    city: "Zamość",
  },
  {
    code: "22-405",
    city: "Zamość",
  },
  {
    code: "22-406",
    city: "Zamość",
  },
  {
    code: "22-407",
    city: "Zamość",
  },
  {
    code: "22-409",
    city: "Zamość",
  },
  {
    code: "22-410",
    city: "Zamość",
  },
  {
    code: "22-413",
    city: "Nielisz",
  },
  {
    code: "22-417",
    city: "Stary Zamość",
  },
  {
    code: "22-420",
    city: "Skierbieszów",
  },
  {
    code: "22-424",
    city: "Sitno",
  },
  {
    code: "22-425",
    city: "Grabowiec",
  },
  {
    code: "22-435",
    city: "Komarów-Osada",
  },
  {
    code: "22-437",
    city: "Łabunie",
  },
  {
    code: "22-440",
    city: "Krasnobród",
  },
  {
    code: "22-442",
    city: "Adamów",
  },
  {
    code: "22-448",
    city: "Sułów",
  },
  {
    code: "22-450",
    city: "Zawada",
  },
  {
    code: "22-455",
    city: "Miączyn",
  },
  {
    code: "22-457",
    city: "Horyszów",
  },
  {
    code: "22-460",
    city: "Szczebrzeszyn",
  },
  {
    code: "22-461",
    city: "Michalów",
  },
  {
    code: "22-463",
    city: "Radecznica",
  },
  {
    code: "22-470",
    city: "Zwierzyniec",
  },
  {
    code: "22-490",
    city: "Zamość",
  },
  {
    code: "22-500",
    city: "Hrubieszów",
  },
  {
    code: "22-501",
    city: "Hrubieszów",
  },
  {
    code: "22-510",
    city: "Uchanie",
  },
  {
    code: "22-523",
    city: "Horodło",
  },
  {
    code: "22-525",
    city: "Strzyżów",
  },
  {
    code: "22-530",
    city: "Mircze",
  },
  {
    code: "22-540",
    city: "Dołhobyczów",
  },
  {
    code: "22-546",
    city: "Turkowice",
  },
  {
    code: "22-550",
    city: "Werbkowice",
  },
  {
    code: "22-554",
    city: "Trzeszczany Pierwsze",
  },
  {
    code: "22-565",
    city: "Nieledew",
  },
  {
    code: "22-600",
    city: "Tomaszów Lubelski",
  },
  {
    code: "22-602",
    city: "Tomaszów Lubelski",
  },
  {
    code: "22-604",
    city: "Tarnawatka",
  },
  {
    code: "22-610",
    city: "Krynice",
  },
  {
    code: "22-630",
    city: "Tyszowce",
  },
  {
    code: "22-640",
    city: "Rachanie",
  },
  {
    code: "22-650",
    city: "Łaszczów",
  },
  {
    code: "22-652",
    city: "Telatyn",
  },
  {
    code: "22-664",
    city: "Jarczów",
  },
  {
    code: "22-670",
    city: "Bełżec",
  },
  {
    code: "22-671",
    city: "Majdan Sopocki",
  },
  {
    code: "22-672",
    city: "Susiec",
  },
  {
    code: "22-678",
    city: "Ulhówek",
  },
  {
    code: "22-680",
    city: "Lubycza Królewska",
  },
  {
    code: "22-681",
    city: "Hrebenne",
  },
  {
    code: "23-100",
    city: "Bychawa",
  },
  {
    code: "23-107",
    city: "Strzyżewice",
  },
  {
    code: "23-109",
    city: "Pszczela Wola",
  },
  {
    code: "23-110",
    city: "Krzczonów",
  },
  {
    code: "23-114",
    city: "Piotrków Pierwszy",
  },
  {
    code: "23-145",
    city: "Wysokie",
  },
  {
    code: "23-155",
    city: "Zakrzew",
  },
  {
    code: "23-156",
    city: "Dębina",
  },
  {
    code: "23-200",
    city: "Kraśnik",
  },
  {
    code: "23-202",
    city: "Kraśnik",
  },
  {
    code: "23-203",
    city: "Kraśnik",
  },
  {
    code: "23-204",
    city: "Kraśnik",
  },
  {
    code: "23-205",
    city: "Popkowice",
  },
  {
    code: "23-206",
    city: "Stróża",
  },
  {
    code: "23-210",
    city: "Kraśnik",
  },
  {
    code: "23-212",
    city: "Wilkołaz",
  },
  {
    code: "23-213",
    city: "Zakrzówek",
  },
  {
    code: "23-225",
    city: "Szastarka",
  },
  {
    code: "23-230",
    city: "Trzydnik Duży",
  },
  {
    code: "23-231",
    city: "Olbięcin",
  },
  {
    code: "23-235",
    city: "Annopol",
  },
  {
    code: "23-250",
    city: "Urzędów",
  },
  {
    code: "23-251",
    city: "Dzierzkowice",
  },
  {
    code: "23-275",
    city: "Gościeradów Ukazowy",
  },
  {
    code: "23-300",
    city: "Janów Lubelski",
  },
  {
    code: "23-302",
    city: "Godziszów",
  },
  {
    code: "23-304",
    city: "Dzwola",
  },
  {
    code: "23-305",
    city: "Chrzanów",
  },
  {
    code: "23-310",
    city: "Modliborzyce",
  },
  {
    code: "23-313",
    city: "Potok Wielki",
  },
  {
    code: "23-320",
    city: "Batorz",
  },
  {
    code: "23-400",
    city: "Biłgoraj",
  },
  {
    code: "23-401",
    city: "Biłgoraj",
  },
  {
    code: "23-407",
    city: "Tereszpol",
  },
  {
    code: "23-408",
    city: "Aleksandrów",
  },
  {
    code: "23-412",
    city: "Łukowa",
  },
  {
    code: "23-413",
    city: "Obsza",
  },
  {
    code: "23-414",
    city: "Stary Majdan",
  },
  {
    code: "23-415",
    city: "Księżpol",
  },
  {
    code: "23-420",
    city: "Tarnogród",
  },
  {
    code: "23-423",
    city: "Potok Górny",
  },
  {
    code: "23-425",
    city: "Biszcza",
  },
  {
    code: "23-440",
    city: "Frampol",
  },
  {
    code: "23-450",
    city: "Goraj",
  },
  {
    code: "23-460",
    city: "Józefów",
  },
  {
    code: "23-465",
    city: "Turobin",
  },
  {
    code: "24-100",
    city: "Puławy",
  },
  {
    code: "24-101",
    city: "Gołąb",
  },
  {
    code: "24-103",
    city: "Żyrzyn",
  },
  {
    code: "24-105",
    city: "Baranów",
  },
  {
    code: "24-110",
    city: "Puławy",
  },
  {
    code: "24-111",
    city: "Puławy",
  },
  {
    code: "24-112",
    city: "Puławy",
  },
  {
    code: "24-120",
    city: "Kazimierz Dolny",
  },
  {
    code: "24-123",
    city: "Janowiec",
  },
  {
    code: "24-130",
    city: "Końskowola",
  },
  {
    code: "24-140",
    city: "Nałęczów",
  },
  {
    code: "24-150",
    city: "Nałęczów",
  },
  {
    code: "24-160",
    city: "Wąwolnica",
  },
  {
    code: "24-170",
    city: "Kurów",
  },
  {
    code: "24-173",
    city: "Markuszów",
  },
  {
    code: "24-200",
    city: "Bełżyce",
  },
  {
    code: "24-204",
    city: "Wojciechów",
  },
  {
    code: "24-220",
    city: "Niedrzwica Duża",
  },
  {
    code: "24-224",
    city: "Borzechów",
  },
  {
    code: "24-300",
    city: "Opole Lubelskie",
  },
  {
    code: "24-310",
    city: "Karczmiska Pierwsze",
  },
  {
    code: "24-313",
    city: "Wilków",
  },
  {
    code: "24-320",
    city: "Poniatowa",
  },
  {
    code: "24-333",
    city: "Wrzelowiec",
  },
  {
    code: "24-335",
    city: "Łaziska",
  },
  {
    code: "24-340",
    city: "Józefów",
  },
  {
    code: "24-350",
    city: "Chodel",
  },
  {
    code: "25-001",
    city: "Kielce",
  },
  {
    code: "25-002",
    city: "Kielce",
  },
  {
    code: "25-003",
    city: "Kielce",
  },
  {
    code: "25-004",
    city: "Kielce",
  },
  {
    code: "25-005",
    city: "Kielce",
  },
  {
    code: "25-006",
    city: "Kielce",
  },
  {
    code: "25-007",
    city: "Kielce",
  },
  {
    code: "25-008",
    city: "Kielce",
  },
  {
    code: "25-009",
    city: "Kielce",
  },
  {
    code: "25-010",
    city: "Kielce",
  },
  {
    code: "25-011",
    city: "Kielce",
  },
  {
    code: "25-012",
    city: "Kielce",
  },
  {
    code: "25-013",
    city: "Kielce",
  },
  {
    code: "25-014",
    city: "Kielce",
  },
  {
    code: "25-015",
    city: "Kielce",
  },
  {
    code: "25-016",
    city: "Kielce",
  },
  {
    code: "25-017",
    city: "Kielce",
  },
  {
    code: "25-018",
    city: "Kielce",
  },
  {
    code: "25-019",
    city: "Kielce",
  },
  {
    code: "25-020",
    city: "Kielce",
  },
  {
    code: "25-021",
    city: "Kielce",
  },
  {
    code: "25-022",
    city: "Kielce",
  },
  {
    code: "25-023",
    city: "Kielce",
  },
  {
    code: "25-024",
    city: "Kielce",
  },
  {
    code: "25-025",
    city: "Kielce",
  },
  {
    code: "25-026",
    city: "Kielce",
  },
  {
    code: "25-027",
    city: "Kielce",
  },
  {
    code: "25-028",
    city: "Kielce",
  },
  {
    code: "25-029",
    city: "Kielce",
  },
  {
    code: "25-030",
    city: "Kielce",
  },
  {
    code: "25-031",
    city: "Kielce",
  },
  {
    code: "25-032",
    city: "Kielce",
  },
  {
    code: "25-033",
    city: "Kielce",
  },
  {
    code: "25-034",
    city: "Kielce",
  },
  {
    code: "25-035",
    city: "Kielce",
  },
  {
    code: "25-036",
    city: "Kielce",
  },
  {
    code: "25-037",
    city: "Kielce",
  },
  {
    code: "25-038",
    city: "Kielce",
  },
  {
    code: "25-039",
    city: "Kielce",
  },
  {
    code: "25-040",
    city: "Kielce",
  },
  {
    code: "25-041",
    city: "Kielce",
  },
  {
    code: "25-042",
    city: "Kielce",
  },
  {
    code: "25-043",
    city: "Kielce",
  },
  {
    code: "25-044",
    city: "Kielce",
  },
  {
    code: "25-045",
    city: "Kielce",
  },
  {
    code: "25-046",
    city: "Kielce",
  },
  {
    code: "25-047",
    city: "Kielce",
  },
  {
    code: "25-093",
    city: "Kielce",
  },
  {
    code: "25-101",
    city: "Kielce",
  },
  {
    code: "25-102",
    city: "Kielce",
  },
  {
    code: "25-103",
    city: "Kielce",
  },
  {
    code: "25-104",
    city: "Kielce",
  },
  {
    code: "25-105",
    city: "Kielce",
  },
  {
    code: "25-106",
    city: "Kielce",
  },
  {
    code: "25-107",
    city: "Kielce",
  },
  {
    code: "25-108",
    city: "Kielce",
  },
  {
    code: "25-109",
    city: "Kielce",
  },
  {
    code: "25-110",
    city: "Kielce",
  },
  {
    code: "25-111",
    city: "Kielce",
  },
  {
    code: "25-112",
    city: "Kielce",
  },
  {
    code: "25-113",
    city: "Kielce",
  },
  {
    code: "25-114",
    city: "Kielce",
  },
  {
    code: "25-115",
    city: "Kielce",
  },
  {
    code: "25-116",
    city: "Kielce",
  },
  {
    code: "25-117",
    city: "Kielce",
  },
  {
    code: "25-118",
    city: "Kielce",
  },
  {
    code: "25-119",
    city: "Kielce",
  },
  {
    code: "25-120",
    city: "Kielce",
  },
  {
    code: "25-121",
    city: "Kielce",
  },
  {
    code: "25-122",
    city: "Kielce",
  },
  {
    code: "25-123",
    city: "Kielce",
  },
  {
    code: "25-124",
    city: "Kielce",
  },
  {
    code: "25-125",
    city: "Kielce",
  },
  {
    code: "25-127",
    city: "Kielce",
  },
  {
    code: "25-128",
    city: "Kielce",
  },
  {
    code: "25-129",
    city: "Kielce",
  },
  {
    code: "25-130",
    city: "Kielce",
  },
  {
    code: "25-131",
    city: "Kielce",
  },
  {
    code: "25-132",
    city: "Kielce",
  },
  {
    code: "25-133",
    city: "Kielce",
  },
  {
    code: "25-134",
    city: "Kielce",
  },
  {
    code: "25-135",
    city: "Kielce",
  },
  {
    code: "25-136",
    city: "Kielce",
  },
  {
    code: "25-137",
    city: "Kielce",
  },
  {
    code: "25-138",
    city: "Kielce",
  },
  {
    code: "25-139",
    city: "Kielce",
  },
  {
    code: "25-140",
    city: "Kielce",
  },
  {
    code: "25-141",
    city: "Kielce",
  },
  {
    code: "25-142",
    city: "Kielce",
  },
  {
    code: "25-143",
    city: "Kielce",
  },
  {
    code: "25-144",
    city: "Kielce",
  },
  {
    code: "25-145",
    city: "Kielce",
  },
  {
    code: "25-146",
    city: "Kielce",
  },
  {
    code: "25-147",
    city: "Kielce",
  },
  {
    code: "25-148",
    city: "Kielce",
  },
  {
    code: "25-149",
    city: "Kielce",
  },
  {
    code: "25-150",
    city: "Kielce",
  },
  {
    code: "25-151",
    city: "Kielce",
  },
  {
    code: "25-152",
    city: "Kielce",
  },
  {
    code: "25-154",
    city: "Kielce",
  },
  {
    code: "25-155",
    city: "Kielce",
  },
  {
    code: "25-201",
    city: "Kielce",
  },
  {
    code: "25-202",
    city: "Kielce",
  },
  {
    code: "25-204",
    city: "Kielce",
  },
  {
    code: "25-205",
    city: "Kielce",
  },
  {
    code: "25-206",
    city: "Kielce",
  },
  {
    code: "25-208",
    city: "Kielce",
  },
  {
    code: "25-209",
    city: "Kielce",
  },
  {
    code: "25-210",
    city: "Kielce",
  },
  {
    code: "25-211",
    city: "Kielce",
  },
  {
    code: "25-212",
    city: "Kielce",
  },
  {
    code: "25-213",
    city: "Kielce",
  },
  {
    code: "25-214",
    city: "Kielce",
  },
  {
    code: "25-217",
    city: "Kielce",
  },
  {
    code: "25-218",
    city: "Kielce",
  },
  {
    code: "25-219",
    city: "Kielce",
  },
  {
    code: "25-220",
    city: "Kielce",
  },
  {
    code: "25-221",
    city: "Kielce",
  },
  {
    code: "25-222",
    city: "Kielce",
  },
  {
    code: "25-223",
    city: "Kielce",
  },
  {
    code: "25-224",
    city: "Kielce",
  },
  {
    code: "25-225",
    city: "Kielce",
  },
  {
    code: "25-226",
    city: "Kielce",
  },
  {
    code: "25-227",
    city: "Kielce",
  },
  {
    code: "25-228",
    city: "Kielce",
  },
  {
    code: "25-229",
    city: "Kielce",
  },
  {
    code: "25-230",
    city: "Kielce",
  },
  {
    code: "25-231",
    city: "Kielce",
  },
  {
    code: "25-232",
    city: "Kielce",
  },
  {
    code: "25-233",
    city: "Kielce",
  },
  {
    code: "25-234",
    city: "Kielce",
  },
  {
    code: "25-235",
    city: "Kielce",
  },
  {
    code: "25-236",
    city: "Kielce",
  },
  {
    code: "25-237",
    city: "Kielce",
  },
  {
    code: "25-252",
    city: "Kielce",
  },
  {
    code: "25-253",
    city: "Kielce",
  },
  {
    code: "25-254",
    city: "Kielce",
  },
  {
    code: "25-255",
    city: "Kielce",
  },
  {
    code: "25-257",
    city: "Kielce",
  },
  {
    code: "25-258",
    city: "Kielce",
  },
  {
    code: "25-259",
    city: "Kielce",
  },
  {
    code: "25-260",
    city: "Kielce",
  },
  {
    code: "25-301",
    city: "Kielce",
  },
  {
    code: "25-302",
    city: "Kielce",
  },
  {
    code: "25-303",
    city: "Kielce",
  },
  {
    code: "25-304",
    city: "Kielce",
  },
  {
    code: "25-305",
    city: "Kielce",
  },
  {
    code: "25-306",
    city: "Kielce",
  },
  {
    code: "25-307",
    city: "Kielce",
  },
  {
    code: "25-308",
    city: "Kielce",
  },
  {
    code: "25-309",
    city: "Kielce",
  },
  {
    code: "25-310",
    city: "Kielce",
  },
  {
    code: "25-311",
    city: "Kielce",
  },
  {
    code: "25-312",
    city: "Kielce",
  },
  {
    code: "25-313",
    city: "Kielce",
  },
  {
    code: "25-314",
    city: "Kielce",
  },
  {
    code: "25-315",
    city: "Kielce",
  },
  {
    code: "25-316",
    city: "Kielce",
  },
  {
    code: "25-317",
    city: "Kielce",
  },
  {
    code: "25-318",
    city: "Kielce",
  },
  {
    code: "25-319",
    city: "Kielce",
  },
  {
    code: "25-320",
    city: "Kielce",
  },
  {
    code: "25-321",
    city: "Kielce",
  },
  {
    code: "25-322",
    city: "Kielce",
  },
  {
    code: "25-323",
    city: "Kielce",
  },
  {
    code: "25-324",
    city: "Kielce",
  },
  {
    code: "25-325",
    city: "Kielce",
  },
  {
    code: "25-326",
    city: "Kielce",
  },
  {
    code: "25-327",
    city: "Kielce",
  },
  {
    code: "25-328",
    city: "Kielce",
  },
  {
    code: "25-329",
    city: "Kielce",
  },
  {
    code: "25-330",
    city: "Kielce",
  },
  {
    code: "25-331",
    city: "Kielce",
  },
  {
    code: "25-332",
    city: "Kielce",
  },
  {
    code: "25-333",
    city: "Kielce",
  },
  {
    code: "25-334",
    city: "Kielce",
  },
  {
    code: "25-335",
    city: "Kielce",
  },
  {
    code: "25-336",
    city: "Kielce",
  },
  {
    code: "25-337",
    city: "Kielce",
  },
  {
    code: "25-338",
    city: "Kielce",
  },
  {
    code: "25-339",
    city: "Kielce",
  },
  {
    code: "25-340",
    city: "Kielce",
  },
  {
    code: "25-341",
    city: "Kielce",
  },
  {
    code: "25-342",
    city: "Kielce",
  },
  {
    code: "25-343",
    city: "Kielce",
  },
  {
    code: "25-344",
    city: "Kielce",
  },
  {
    code: "25-345",
    city: "Kielce",
  },
  {
    code: "25-346",
    city: "Kielce",
  },
  {
    code: "25-347",
    city: "Kielce",
  },
  {
    code: "25-348",
    city: "Kielce",
  },
  {
    code: "25-349",
    city: "Kielce",
  },
  {
    code: "25-350",
    city: "Kielce",
  },
  {
    code: "25-351",
    city: "Kielce",
  },
  {
    code: "25-352",
    city: "Kielce",
  },
  {
    code: "25-353",
    city: "Kielce",
  },
  {
    code: "25-354",
    city: "Kielce",
  },
  {
    code: "25-355",
    city: "Kielce",
  },
  {
    code: "25-356",
    city: "Kielce",
  },
  {
    code: "25-357",
    city: "Kielce",
  },
  {
    code: "25-358",
    city: "Kielce",
  },
  {
    code: "25-359",
    city: "Kielce",
  },
  {
    code: "25-360",
    city: "Kielce",
  },
  {
    code: "25-361",
    city: "Kielce",
  },
  {
    code: "25-362",
    city: "Kielce",
  },
  {
    code: "25-363",
    city: "Kielce",
  },
  {
    code: "25-364",
    city: "Kielce",
  },
  {
    code: "25-365",
    city: "Kielce",
  },
  {
    code: "25-366",
    city: "Kielce",
  },
  {
    code: "25-367",
    city: "Kielce",
  },
  {
    code: "25-368",
    city: "Kielce",
  },
  {
    code: "25-369",
    city: "Kielce",
  },
  {
    code: "25-370",
    city: "Kielce",
  },
  {
    code: "25-371",
    city: "Kielce",
  },
  {
    code: "25-372",
    city: "Kielce",
  },
  {
    code: "25-373",
    city: "Kielce",
  },
  {
    code: "25-375",
    city: "Kielce",
  },
  {
    code: "25-376",
    city: "Kielce",
  },
  {
    code: "25-377",
    city: "Kielce",
  },
  {
    code: "25-378",
    city: "Kielce",
  },
  {
    code: "25-379",
    city: "Kielce",
  },
  {
    code: "25-380",
    city: "Kielce",
  },
  {
    code: "25-381",
    city: "Kielce",
  },
  {
    code: "25-382",
    city: "Kielce",
  },
  {
    code: "25-383",
    city: "Kielce",
  },
  {
    code: "25-384",
    city: "Kielce",
  },
  {
    code: "25-385",
    city: "Kielce",
  },
  {
    code: "25-386",
    city: "Kielce",
  },
  {
    code: "25-387",
    city: "Kielce",
  },
  {
    code: "25-389",
    city: "Kielce",
  },
  {
    code: "25-390",
    city: "Kielce",
  },
  {
    code: "25-391",
    city: "Kielce",
  },
  {
    code: "25-392",
    city: "Kielce",
  },
  {
    code: "25-394",
    city: "Kielce",
  },
  {
    code: "25-395",
    city: "Kielce",
  },
  {
    code: "25-401",
    city: "Kielce",
  },
  {
    code: "25-402",
    city: "Kielce",
  },
  {
    code: "25-403",
    city: "Kielce",
  },
  {
    code: "25-405",
    city: "Kielce",
  },
  {
    code: "25-406",
    city: "Kielce",
  },
  {
    code: "25-408",
    city: "Kielce",
  },
  {
    code: "25-409",
    city: "Kielce",
  },
  {
    code: "25-410",
    city: "Kielce",
  },
  {
    code: "25-411",
    city: "Kielce",
  },
  {
    code: "25-412",
    city: "Kielce",
  },
  {
    code: "25-413",
    city: "Kielce",
  },
  {
    code: "25-414",
    city: "Kielce",
  },
  {
    code: "25-415",
    city: "Kielce",
  },
  {
    code: "25-416",
    city: "Kielce",
  },
  {
    code: "25-417",
    city: "Kielce",
  },
  {
    code: "25-418",
    city: "Kielce",
  },
  {
    code: "25-419",
    city: "Kielce",
  },
  {
    code: "25-420",
    city: "Kielce",
  },
  {
    code: "25-421",
    city: "Kielce",
  },
  {
    code: "25-422",
    city: "Kielce",
  },
  {
    code: "25-424",
    city: "Kielce",
  },
  {
    code: "25-425",
    city: "Kielce",
  },
  {
    code: "25-426",
    city: "Kielce",
  },
  {
    code: "25-430",
    city: "Kielce",
  },
  {
    code: "25-431",
    city: "Kielce",
  },
  {
    code: "25-432",
    city: "Kielce",
  },
  {
    code: "25-433",
    city: "Kielce",
  },
  {
    code: "25-434",
    city: "Kielce",
  },
  {
    code: "25-435",
    city: "Kielce",
  },
  {
    code: "25-436",
    city: "Kielce",
  },
  {
    code: "25-437",
    city: "Kielce",
  },
  {
    code: "25-438",
    city: "Kielce",
  },
  {
    code: "25-439",
    city: "Kielce",
  },
  {
    code: "25-440",
    city: "Kielce",
  },
  {
    code: "25-441",
    city: "Kielce",
  },
  {
    code: "25-442",
    city: "Kielce",
  },
  {
    code: "25-443",
    city: "Kielce",
  },
  {
    code: "25-444",
    city: "Kielce",
  },
  {
    code: "25-445",
    city: "Kielce",
  },
  {
    code: "25-446",
    city: "Kielce",
  },
  {
    code: "25-447",
    city: "Kielce",
  },
  {
    code: "25-448",
    city: "Kielce",
  },
  {
    code: "25-449",
    city: "Kielce",
  },
  {
    code: "25-450",
    city: "Kielce",
  },
  {
    code: "25-451",
    city: "Kielce",
  },
  {
    code: "25-452",
    city: "Kielce",
  },
  {
    code: "25-453",
    city: "Kielce",
  },
  {
    code: "25-454",
    city: "Kielce",
  },
  {
    code: "25-455",
    city: "Kielce",
  },
  {
    code: "25-456",
    city: "Kielce",
  },
  {
    code: "25-457",
    city: "Kielce",
  },
  {
    code: "25-458",
    city: "Kielce",
  },
  {
    code: "25-459",
    city: "Kielce",
  },
  {
    code: "25-460",
    city: "Kielce",
  },
  {
    code: "25-470",
    city: "Kielce",
  },
  {
    code: "25-501",
    city: "Kielce",
  },
  {
    code: "25-502",
    city: "Kielce",
  },
  {
    code: "25-503",
    city: "Kielce",
  },
  {
    code: "25-504",
    city: "Kielce",
  },
  {
    code: "25-505",
    city: "Kielce",
  },
  {
    code: "25-506",
    city: "Kielce",
  },
  {
    code: "25-507",
    city: "Kielce",
  },
  {
    code: "25-508",
    city: "Kielce",
  },
  {
    code: "25-509",
    city: "Kielce",
  },
  {
    code: "25-510",
    city: "Kielce",
  },
  {
    code: "25-511",
    city: "Kielce",
  },
  {
    code: "25-512",
    city: "Kielce",
  },
  {
    code: "25-513",
    city: "Kielce",
  },
  {
    code: "25-514",
    city: "Kielce",
  },
  {
    code: "25-515",
    city: "Kielce",
  },
  {
    code: "25-516",
    city: "Kielce",
  },
  {
    code: "25-518",
    city: "Kielce",
  },
  {
    code: "25-519",
    city: "Kielce",
  },
  {
    code: "25-520",
    city: "Kielce",
  },
  {
    code: "25-521",
    city: "Kielce",
  },
  {
    code: "25-522",
    city: "Kielce",
  },
  {
    code: "25-523",
    city: "Kielce",
  },
  {
    code: "25-524",
    city: "Kielce",
  },
  {
    code: "25-525",
    city: "Kielce",
  },
  {
    code: "25-526",
    city: "Kielce",
  },
  {
    code: "25-527",
    city: "Kielce",
  },
  {
    code: "25-528",
    city: "Kielce",
  },
  {
    code: "25-529",
    city: "Kielce",
  },
  {
    code: "25-530",
    city: "Kielce",
  },
  {
    code: "25-531",
    city: "Kielce",
  },
  {
    code: "25-532",
    city: "Kielce",
  },
  {
    code: "25-533",
    city: "Kielce",
  },
  {
    code: "25-534",
    city: "Kielce",
  },
  {
    code: "25-535",
    city: "Kielce",
  },
  {
    code: "25-536",
    city: "Kielce",
  },
  {
    code: "25-537",
    city: "Kielce",
  },
  {
    code: "25-538",
    city: "Kielce",
  },
  {
    code: "25-539",
    city: "Kielce",
  },
  {
    code: "25-540",
    city: "Kielce",
  },
  {
    code: "25-541",
    city: "Kielce",
  },
  {
    code: "25-542",
    city: "Kielce",
  },
  {
    code: "25-543",
    city: "Kielce",
  },
  {
    code: "25-544",
    city: "Kielce",
  },
  {
    code: "25-545",
    city: "Kielce",
  },
  {
    code: "25-546",
    city: "Kielce",
  },
  {
    code: "25-547",
    city: "Kielce",
  },
  {
    code: "25-548",
    city: "Kielce",
  },
  {
    code: "25-549",
    city: "Kielce",
  },
  {
    code: "25-550",
    city: "Kielce",
  },
  {
    code: "25-551",
    city: "Kielce",
  },
  {
    code: "25-552",
    city: "Kielce",
  },
  {
    code: "25-553",
    city: "Kielce",
  },
  {
    code: "25-554",
    city: "Kielce",
  },
  {
    code: "25-555",
    city: "Kielce",
  },
  {
    code: "25-556",
    city: "Kielce",
  },
  {
    code: "25-557",
    city: "Kielce",
  },
  {
    code: "25-558",
    city: "Kielce",
  },
  {
    code: "25-559",
    city: "Kielce",
  },
  {
    code: "25-560",
    city: "Kielce",
  },
  {
    code: "25-561",
    city: "Kielce",
  },
  {
    code: "25-562",
    city: "Kielce",
  },
  {
    code: "25-563",
    city: "Kielce",
  },
  {
    code: "25-564",
    city: "Kielce",
  },
  {
    code: "25-565",
    city: "Kielce",
  },
  {
    code: "25-566",
    city: "Kielce",
  },
  {
    code: "25-567",
    city: "Kielce",
  },
  {
    code: "25-568",
    city: "Kielce",
  },
  {
    code: "25-601",
    city: "Kielce",
  },
  {
    code: "25-602",
    city: "Kielce",
  },
  {
    code: "25-603",
    city: "Kielce",
  },
  {
    code: "25-605",
    city: "Kielce",
  },
  {
    code: "25-606",
    city: "Kielce",
  },
  {
    code: "25-607",
    city: "Kielce",
  },
  {
    code: "25-608",
    city: "Kielce",
  },
  {
    code: "25-609",
    city: "Kielce",
  },
  {
    code: "25-610",
    city: "Kielce",
  },
  {
    code: "25-611",
    city: "Kielce",
  },
  {
    code: "25-612",
    city: "Kielce",
  },
  {
    code: "25-613",
    city: "Kielce",
  },
  {
    code: "25-614",
    city: "Kielce",
  },
  {
    code: "25-615",
    city: "Kielce",
  },
  {
    code: "25-616",
    city: "Kielce",
  },
  {
    code: "25-617",
    city: "Kielce",
  },
  {
    code: "25-618",
    city: "Kielce",
  },
  {
    code: "25-619",
    city: "Kielce",
  },
  {
    code: "25-620",
    city: "Kielce",
  },
  {
    code: "25-621",
    city: "Kielce",
  },
  {
    code: "25-622",
    city: "Kielce",
  },
  {
    code: "25-623",
    city: "Kielce",
  },
  {
    code: "25-624",
    city: "Kielce",
  },
  {
    code: "25-625",
    city: "Kielce",
  },
  {
    code: "25-626",
    city: "Kielce",
  },
  {
    code: "25-627",
    city: "Kielce",
  },
  {
    code: "25-628",
    city: "Kielce",
  },
  {
    code: "25-629",
    city: "Kielce",
  },
  {
    code: "25-630",
    city: "Kielce",
  },
  {
    code: "25-631",
    city: "Kielce",
  },
  {
    code: "25-632",
    city: "Kielce",
  },
  {
    code: "25-633",
    city: "Kielce",
  },
  {
    code: "25-634",
    city: "Kielce",
  },
  {
    code: "25-635",
    city: "Kielce",
  },
  {
    code: "25-636",
    city: "Kielce",
  },
  {
    code: "25-637",
    city: "Kielce",
  },
  {
    code: "25-638",
    city: "Kielce",
  },
  {
    code: "25-639",
    city: "Kielce",
  },
  {
    code: "25-640",
    city: "Kielce",
  },
  {
    code: "25-644",
    city: "Kielce",
  },
  {
    code: "25-645",
    city: "Kielce",
  },
  {
    code: "25-646",
    city: "Kielce",
  },
  {
    code: "25-647",
    city: "Kielce",
  },
  {
    code: "25-649",
    city: "Kielce",
  },
  {
    code: "25-650",
    city: "Kielce",
  },
  {
    code: "25-651",
    city: "Kielce",
  },
  {
    code: "25-652",
    city: "Kielce",
  },
  {
    code: "25-653",
    city: "Kielce",
  },
  {
    code: "25-654",
    city: "Kielce",
  },
  {
    code: "25-655",
    city: "Kielce",
  },
  {
    code: "25-656",
    city: "Kielce",
  },
  {
    code: "25-657",
    city: "Kielce",
  },
  {
    code: "25-658",
    city: "Kielce",
  },
  {
    code: "25-659",
    city: "Kielce",
  },
  {
    code: "25-660",
    city: "Kielce",
  },
  {
    code: "25-661",
    city: "Kielce",
  },
  {
    code: "25-662",
    city: "Kielce",
  },
  {
    code: "25-663",
    city: "Kielce",
  },
  {
    code: "25-664",
    city: "Kielce",
  },
  {
    code: "25-665",
    city: "Kielce",
  },
  {
    code: "25-666",
    city: "Kielce",
  },
  {
    code: "25-667",
    city: "Kielce",
  },
  {
    code: "25-668",
    city: "Kielce",
  },
  {
    code: "25-669",
    city: "Kielce",
  },
  {
    code: "25-670",
    city: "Kielce",
  },
  {
    code: "25-671",
    city: "Kielce",
  },
  {
    code: "25-672",
    city: "Kielce",
  },
  {
    code: "25-673",
    city: "Kielce",
  },
  {
    code: "25-675",
    city: "Kielce",
  },
  {
    code: "25-677",
    city: "Kielce",
  },
  {
    code: "25-678",
    city: "Kielce",
  },
  {
    code: "25-679",
    city: "Kielce",
  },
  {
    code: "25-680",
    city: "Kielce",
  },
  {
    code: "25-681",
    city: "Kielce",
  },
  {
    code: "25-682",
    city: "Kielce",
  },
  {
    code: "25-701",
    city: "Kielce",
  },
  {
    code: "25-702",
    city: "Kielce",
  },
  {
    code: "25-703",
    city: "Kielce",
  },
  {
    code: "25-704",
    city: "Kielce",
  },
  {
    code: "25-705",
    city: "Kielce",
  },
  {
    code: "25-706",
    city: "Kielce",
  },
  {
    code: "25-707",
    city: "Kielce",
  },
  {
    code: "25-708",
    city: "Kielce",
  },
  {
    code: "25-709",
    city: "Kielce",
  },
  {
    code: "25-710",
    city: "Kielce",
  },
  {
    code: "25-711",
    city: "Kielce",
  },
  {
    code: "25-712",
    city: "Kielce",
  },
  {
    code: "25-713",
    city: "Kielce",
  },
  {
    code: "25-714",
    city: "Kielce",
  },
  {
    code: "25-715",
    city: "Kielce",
  },
  {
    code: "25-716",
    city: "Kielce",
  },
  {
    code: "25-717",
    city: "Kielce",
  },
  {
    code: "25-718",
    city: "Kielce",
  },
  {
    code: "25-719",
    city: "Kielce",
  },
  {
    code: "25-720",
    city: "Kielce",
  },
  {
    code: "25-721",
    city: "Kielce",
  },
  {
    code: "25-722",
    city: "Kielce",
  },
  {
    code: "25-723",
    city: "Kielce",
  },
  {
    code: "25-724",
    city: "Kielce",
  },
  {
    code: "25-725",
    city: "Kielce",
  },
  {
    code: "25-726",
    city: "Kielce",
  },
  {
    code: "25-727",
    city: "Kielce",
  },
  {
    code: "25-728",
    city: "Kielce",
  },
  {
    code: "25-729",
    city: "Kielce",
  },
  {
    code: "25-730",
    city: "Kielce",
  },
  {
    code: "25-731",
    city: "Kielce",
  },
  {
    code: "25-732",
    city: "Kielce",
  },
  {
    code: "25-733",
    city: "Kielce",
  },
  {
    code: "25-734",
    city: "Kielce",
  },
  {
    code: "25-735",
    city: "Kielce",
  },
  {
    code: "25-736",
    city: "Kielce",
  },
  {
    code: "25-737",
    city: "Kielce",
  },
  {
    code: "25-738",
    city: "Kielce",
  },
  {
    code: "25-739",
    city: "Kielce",
  },
  {
    code: "25-744",
    city: "Kielce",
  },
  {
    code: "25-745",
    city: "Kielce",
  },
  {
    code: "25-746",
    city: "Kielce",
  },
  {
    code: "25-749",
    city: "Kielce",
  },
  {
    code: "25-750",
    city: "Kielce",
  },
  {
    code: "25-751",
    city: "Kielce",
  },
  {
    code: "25-752",
    city: "Kielce",
  },
  {
    code: "25-753",
    city: "Kielce",
  },
  {
    code: "25-754",
    city: "Kielce",
  },
  {
    code: "25-756",
    city: "Kielce",
  },
  {
    code: "25-757",
    city: "Kielce",
  },
  {
    code: "25-758",
    city: "Kielce",
  },
  {
    code: "25-759",
    city: "Kielce",
  },
  {
    code: "25-801",
    city: "Kielce",
  },
  {
    code: "25-802",
    city: "Kielce",
  },
  {
    code: "25-803",
    city: "Kielce",
  },
  {
    code: "25-804",
    city: "Kielce",
  },
  {
    code: "25-805",
    city: "Kielce",
  },
  {
    code: "25-806",
    city: "Kielce",
  },
  {
    code: "25-807",
    city: "Kielce",
  },
  {
    code: "25-808",
    city: "Kielce",
  },
  {
    code: "25-809",
    city: "Kielce",
  },
  {
    code: "25-810",
    city: "Kielce",
  },
  {
    code: "25-811",
    city: "Kielce",
  },
  {
    code: "25-812",
    city: "Kielce",
  },
  {
    code: "25-813",
    city: "Kielce",
  },
  {
    code: "25-814",
    city: "Kielce",
  },
  {
    code: "25-815",
    city: "Kielce",
  },
  {
    code: "25-816",
    city: "Kielce",
  },
  {
    code: "25-817",
    city: "Kielce",
  },
  {
    code: "25-818",
    city: "Kielce",
  },
  {
    code: "25-819",
    city: "Kielce",
  },
  {
    code: "25-820",
    city: "Kielce",
  },
  {
    code: "25-821",
    city: "Kielce",
  },
  {
    code: "25-822",
    city: "Kielce",
  },
  {
    code: "25-823",
    city: "Kielce",
  },
  {
    code: "25-824",
    city: "Kielce",
  },
  {
    code: "25-825",
    city: "Kielce",
  },
  {
    code: "25-826",
    city: "Kielce",
  },
  {
    code: "25-827",
    city: "Kielce",
  },
  {
    code: "25-828",
    city: "Kielce",
  },
  {
    code: "25-829",
    city: "Kielce",
  },
  {
    code: "25-851",
    city: "Kielce",
  },
  {
    code: "25-852",
    city: "Kielce",
  },
  {
    code: "25-900",
    city: "Kielce",
  },
  {
    code: "25-960",
    city: "Kielce",
  },
  {
    code: "26-001",
    city: "Masłów",
  },
  {
    code: "26-004",
    city: "Bieliny Kapitulne",
  },
  {
    code: "26-006",
    city: "Nowa Słupia",
  },
  {
    code: "26-008",
    city: "Górno",
  },
  {
    code: "26-010",
    city: "Bodzentyn",
  },
  {
    code: "26-015",
    city: "Pierzchnica",
  },
  {
    code: "26-020",
    city: "Chmielnik",
  },
  {
    code: "26-021",
    city: "Daleszyce",
  },
  {
    code: "26-025",
    city: "Łagów",
  },
  {
    code: "26-026",
    city: "Morawica",
  },
  {
    code: "26-035",
    city: "Raków",
  },
  {
    code: "26-050",
    city: "Zagnańsk",
  },
  {
    code: "26-052",
    city: "Sitkówka-Nowiny",
  },
  {
    code: "26-060",
    city: "Chęciny",
  },
  {
    code: "26-065",
    city: "Piekoszów",
  },
  {
    code: "26-067",
    city: "Strawczyn",
  },
  {
    code: "26-070",
    city: "Łopuszno",
  },
  {
    code: "26-080",
    city: "Mniów",
  },
  {
    code: "26-085",
    city: "Miedziana Góra",
  },
  {
    code: "26-100",
    city: "Skarżysko-Kamienna",
  },
  {
    code: "26-111",
    city: "Skarżysko-Kamienna",
  },
  {
    code: "26-112",
    city: "Skarżysko-Kamienna",
  },
  {
    code: "26-115",
    city: "Skarżysko Kościelne",
  },
  {
    code: "26-120",
    city: "Bliżyn",
  },
  {
    code: "26-130",
    city: "Suchedniów",
  },
  {
    code: "26-140",
    city: "Łączna",
  },
  {
    code: "26-200",
    city: "Końskie",
  },
  {
    code: "26-202",
    city: "Końskie",
  },
  {
    code: "26-212",
    city: "Smyków",
  },
  {
    code: "26-220",
    city: "Stąporków",
  },
  {
    code: "26-225",
    city: "Gowarczów",
  },
  {
    code: "26-230",
    city: "Radoszyce",
  },
  {
    code: "26-234",
    city: "Słupia",
  },
  {
    code: "26-242",
    city: "Ruda Maleniecka",
  },
  {
    code: "26-260",
    city: "Fałków",
  },
  {
    code: "26-300",
    city: "Opoczno",
  },
  {
    code: "26-301",
    city: "Opoczno",
  },
  {
    code: "26-307",
    city: "Białaczów",
  },
  {
    code: "26-315",
    city: "Poświętne",
  },
  {
    code: "26-330",
    city: "Żarnów",
  },
  {
    code: "26-332",
    city: "Sławno",
  },
  {
    code: "26-333",
    city: "Paradyż",
  },
  {
    code: "26-337",
    city: "Aleksandrów",
  },
  {
    code: "26-340",
    city: "Drzewica",
  },
  {
    code: "26-341",
    city: "Mniszków",
  },
  {
    code: "26-400",
    city: "Przysucha",
  },
  {
    code: "26-411",
    city: "Rusinów",
  },
  {
    code: "26-414",
    city: "Potworów",
  },
  {
    code: "26-415",
    city: "Klwów",
  },
  {
    code: "26-420",
    city: "Nowe Miasto nad Pilicą",
  },
  {
    code: "26-422",
    city: "Borkowice",
  },
  {
    code: "26-425",
    city: "Odrzywół",
  },
  {
    code: "26-432",
    city: "Wieniawa",
  },
  {
    code: "26-434",
    city: "Gielniów",
  },
  {
    code: "26-500",
    city: "Szydłowiec",
  },
  {
    code: "26-502",
    city: "Jastrząb",
  },
  {
    code: "26-503",
    city: "Mirów Stary",
  },
  {
    code: "26-505",
    city: "Orońsko",
  },
  {
    code: "26-510",
    city: "Chlewiska",
  },
  {
    code: "26-600",
    city: "Radom",
  },
  {
    code: "26-601",
    city: "Radom",
  },
  {
    code: "26-602",
    city: "Radom",
  },
  {
    code: "26-603",
    city: "Radom",
  },
  {
    code: "26-604",
    city: "Radom",
  },
  {
    code: "26-605",
    city: "Radom",
  },
  {
    code: "26-606",
    city: "Radom",
  },
  {
    code: "26-608",
    city: "Radom",
  },
  {
    code: "26-609",
    city: "Radom",
  },
  {
    code: "26-610",
    city: "Radom",
  },
  {
    code: "26-611",
    city: "Radom",
  },
  {
    code: "26-612",
    city: "Radom",
  },
  {
    code: "26-613",
    city: "Radom",
  },
  {
    code: "26-614",
    city: "Radom",
  },
  {
    code: "26-615",
    city: "Radom",
  },
  {
    code: "26-616",
    city: "Radom",
  },
  {
    code: "26-617",
    city: "Radom",
  },
  {
    code: "26-618",
    city: "Radom",
  },
  {
    code: "26-619",
    city: "Radom",
  },
  {
    code: "26-620",
    city: "Radom",
  },
  {
    code: "26-621",
    city: "Radom",
  },
  {
    code: "26-624",
    city: "Kowala",
  },
  {
    code: "26-625",
    city: "Wolanów",
  },
  {
    code: "26-630",
    city: "Jedlnia-Letnisko",
  },
  {
    code: "26-631",
    city: "Jastrzębia",
  },
  {
    code: "26-634",
    city: "Gózd",
  },
  {
    code: "26-640",
    city: "Skaryszew",
  },
  {
    code: "26-650",
    city: "Przytyk",
  },
  {
    code: "26-652",
    city: "Zakrzew",
  },
  {
    code: "26-660",
    city: "Jedlińsk",
  },
  {
    code: "26-670",
    city: "Pionki",
  },
  {
    code: "26-675",
    city: "Pionki",
  },
  {
    code: "26-680",
    city: "Wierzbica",
  },
  {
    code: "26-700",
    city: "Zwoleń",
  },
  {
    code: "26-704",
    city: "Przyłęk",
  },
  {
    code: "26-706",
    city: "Tczów",
  },
  {
    code: "26-713",
    city: "Kazanów",
  },
  {
    code: "26-720",
    city: "Policzna",
  },
  {
    code: "26-800",
    city: "Białobrzegi",
  },
  {
    code: "26-803",
    city: "Promna",
  },
  {
    code: "26-804",
    city: "Stromiec",
  },
  {
    code: "26-806",
    city: "Stara Błotnica",
  },
  {
    code: "26-807",
    city: "Radzanów",
  },
  {
    code: "26-811",
    city: "Wyśmierzyce",
  },
  {
    code: "26-900",
    city: "Kozienice",
  },
  {
    code: "26-901",
    city: "Kozienice",
  },
  {
    code: "26-902",
    city: "Grabów nad Pilicą",
  },
  {
    code: "26-903",
    city: "Głowaczów",
  },
  {
    code: "26-910",
    city: "Magnuszew",
  },
  {
    code: "26-920",
    city: "Gniewoszów",
  },
  {
    code: "26-922",
    city: "Sieciechów",
  },
  {
    code: "26-930",
    city: "Garbatka-Letnisko",
  },
  {
    code: "27-100",
    city: "Iłża",
  },
  {
    code: "27-200",
    city: "Starachowice",
  },
  {
    code: "27-201",
    city: "Starachowice",
  },
  {
    code: "27-202",
    city: "Starachowice",
  },
  {
    code: "27-203",
    city: "Starachowice",
  },
  {
    code: "27-205",
    city: "Starachowice",
  },
  {
    code: "27-206",
    city: "Starachowice",
  },
  {
    code: "27-215",
    city: "Wąchock",
  },
  {
    code: "27-220",
    city: "Mirzec",
  },
  {
    code: "27-225",
    city: "Pawłów",
  },
  {
    code: "27-230",
    city: "Brody",
  },
  {
    code: "27-300",
    city: "Lipsko",
  },
  {
    code: "27-310",
    city: "Ciepielów",
  },
  {
    code: "27-312",
    city: "Chotcza-Józefów",
  },
  {
    code: "27-320",
    city: "Solec nad Wisłą",
  },
  {
    code: "27-330",
    city: "Pawłowice",
  },
  {
    code: "27-350",
    city: "Sienno",
  },
  {
    code: "27-353",
    city: "Rzeczniów",
  },
  {
    code: "27-400",
    city: "Ostrowiec Świętokrzyski",
  },
  {
    code: "27-401",
    city: "Ostrowiec Świętokrzyski",
  },
  {
    code: "27-402",
    city: "Ostrowiec Świętokrzyski",
  },
  {
    code: "27-404",
    city: "Ostrowiec Świętokrzyski",
  },
  {
    code: "27-405",
    city: "Ostrowiec Świętokrzyski",
  },
  {
    code: "27-406",
    city: "Ostrowiec Świętokrzyski",
  },
  {
    code: "27-415",
    city: "Kunów",
  },
  {
    code: "27-420",
    city: "Bodzechów",
  },
  {
    code: "27-423",
    city: "Bałtów",
  },
  {
    code: "27-425",
    city: "Waśniów",
  },
  {
    code: "27-440",
    city: "Ćmielów",
  },
  {
    code: "27-500",
    city: "Opatów",
  },
  {
    code: "27-515",
    city: "Tarłów",
  },
  {
    code: "27-530",
    city: "Ożarów",
  },
  {
    code: "27-532",
    city: "Wojciechowice",
  },
  {
    code: "27-540",
    city: "Lipnik",
  },
  {
    code: "27-545",
    city: "Włostów",
  },
  {
    code: "27-552",
    city: "Baćkowice",
  },
  {
    code: "27-570",
    city: "Iwaniska",
  },
  {
    code: "27-580",
    city: "Sadowie",
  },
  {
    code: "27-600",
    city: "Sandomierz",
  },
  {
    code: "27-601",
    city: "Sandomierz",
  },
  {
    code: "27-602",
    city: "Sandomierz",
  },
  {
    code: "27-610",
    city: "Sandomierz",
  },
  {
    code: "27-612",
    city: "Wilczyce",
  },
  {
    code: "27-620",
    city: "Dwikozy",
  },
  {
    code: "27-630",
    city: "Zawichost",
  },
  {
    code: "27-640",
    city: "Klimontów",
  },
  {
    code: "27-641",
    city: "Obrazów",
  },
  {
    code: "27-650",
    city: "Samborzec",
  },
  {
    code: "27-660",
    city: "Koprzywnica",
  },
  {
    code: "27-670",
    city: "Łoniów",
  },
  {
    code: "28-101",
    city: "Busko-Zdrój",
  },
  {
    code: "28-102",
    city: "Busko-Zdrój",
  },
  {
    code: "28-114",
    city: "Gnojno",
  },
  {
    code: "28-130",
    city: "Stopnica",
  },
  {
    code: "28-131",
    city: "Solec-Zdrój",
  },
  {
    code: "28-133",
    city: "Pacanów",
  },
  {
    code: "28-136",
    city: "Nowy Korczyn",
  },
  {
    code: "28-142",
    city: "Tuczępy",
  },
  {
    code: "28-160",
    city: "Wiślica",
  },
  {
    code: "28-203",
    city: "Staszów",
  },
  {
    code: "28-210",
    city: "Bogoria",
  },
  {
    code: "28-220",
    city: "Oleśnica",
  },
  {
    code: "28-221",
    city: "Osiek",
  },
  {
    code: "28-225",
    city: "Szydłów",
  },
  {
    code: "28-230",
    city: "Połaniec",
  },
  {
    code: "28-232",
    city: "Łubnice",
  },
  {
    code: "28-236",
    city: "Rytwiany",
  },
  {
    code: "28-300",
    city: "Jędrzejów",
  },
  {
    code: "28-305",
    city: "Sobków",
  },
  {
    code: "28-310",
    city: "Jędrzejów",
  },
  {
    code: "28-313",
    city: "Imielno",
  },
  {
    code: "28-330",
    city: "Wodzisław",
  },
  {
    code: "28-340",
    city: "Sędziszów",
  },
  {
    code: "28-350",
    city: "Słupia",
  },
  {
    code: "28-362",
    city: "Nagłowice",
  },
  {
    code: "28-363",
    city: "Oksa",
  },
  {
    code: "28-366",
    city: "Małogoszcz",
  },
  {
    code: "28-400",
    city: "Pińczów",
  },
  {
    code: "28-404",
    city: "Kije",
  },
  {
    code: "28-411",
    city: "Michałów",
  },
  {
    code: "28-425",
    city: "Złota",
  },
  {
    code: "28-440",
    city: "Działoszyce",
  },
  {
    code: "28-500",
    city: "Kazimierza Wielka",
  },
  {
    code: "28-506",
    city: "Czarnocin",
  },
  {
    code: "28-512",
    city: "Bejsce",
  },
  {
    code: "28-520",
    city: "Opatowiec",
  },
  {
    code: "28-530",
    city: "Skalbmierz",
  },
  {
    code: "29-100",
    city: "Włoszczowa",
  },
  {
    code: "29-105",
    city: "Krasocin",
  },
  {
    code: "29-120",
    city: "Kluczewsko",
  },
  {
    code: "29-130",
    city: "Moskorzew",
  },
  {
    code: "29-135",
    city: "Radków",
  },
  {
    code: "29-145",
    city: "Secemin",
  },
  {
    code: "30-001",
    city: "Kraków",
  },
  {
    code: "30-002",
    city: "Kraków",
  },
  {
    code: "30-003",
    city: "Kraków",
  },
  {
    code: "30-004",
    city: "Kraków",
  },
  {
    code: "30-006",
    city: "Kraków",
  },
  {
    code: "30-007",
    city: "Kraków",
  },
  {
    code: "30-009",
    city: "Kraków",
  },
  {
    code: "30-010",
    city: "Kraków",
  },
  {
    code: "30-011",
    city: "Kraków",
  },
  {
    code: "30-012",
    city: "Kraków",
  },
  {
    code: "30-014",
    city: "Kraków",
  },
  {
    code: "30-015",
    city: "Kraków",
  },
  {
    code: "30-016",
    city: "Kraków",
  },
  {
    code: "30-017",
    city: "Kraków",
  },
  {
    code: "30-018",
    city: "Kraków",
  },
  {
    code: "30-019",
    city: "Kraków",
  },
  {
    code: "30-020",
    city: "Kraków",
  },
  {
    code: "30-021",
    city: "Kraków",
  },
  {
    code: "30-022",
    city: "Kraków",
  },
  {
    code: "30-023",
    city: "Kraków",
  },
  {
    code: "30-024",
    city: "Kraków",
  },
  {
    code: "30-031",
    city: "Kraków",
  },
  {
    code: "30-032",
    city: "Kraków",
  },
  {
    code: "30-033",
    city: "Kraków",
  },
  {
    code: "30-034",
    city: "Kraków",
  },
  {
    code: "30-035",
    city: "Kraków",
  },
  {
    code: "30-036",
    city: "Kraków",
  },
  {
    code: "30-037",
    city: "Kraków",
  },
  {
    code: "30-038",
    city: "Kraków",
  },
  {
    code: "30-039",
    city: "Kraków",
  },
  {
    code: "30-040",
    city: "Kraków",
  },
  {
    code: "30-041",
    city: "Kraków",
  },
  {
    code: "30-042",
    city: "Kraków",
  },
  {
    code: "30-043",
    city: "Kraków",
  },
  {
    code: "30-044",
    city: "Kraków",
  },
  {
    code: "30-045",
    city: "Kraków",
  },
  {
    code: "30-046",
    city: "Kraków",
  },
  {
    code: "30-047",
    city: "Kraków",
  },
  {
    code: "30-048",
    city: "Kraków",
  },
  {
    code: "30-049",
    city: "Kraków",
  },
  {
    code: "30-050",
    city: "Kraków",
  },
  {
    code: "30-051",
    city: "Kraków",
  },
  {
    code: "30-052",
    city: "Kraków",
  },
  {
    code: "30-053",
    city: "Kraków",
  },
  {
    code: "30-054",
    city: "Kraków",
  },
  {
    code: "30-055",
    city: "Kraków",
  },
  {
    code: "30-056",
    city: "Kraków",
  },
  {
    code: "30-057",
    city: "Kraków",
  },
  {
    code: "30-058",
    city: "Kraków",
  },
  {
    code: "30-059",
    city: "Kraków",
  },
  {
    code: "30-060",
    city: "Kraków",
  },
  {
    code: "30-061",
    city: "Kraków",
  },
  {
    code: "30-062",
    city: "Kraków",
  },
  {
    code: "30-063",
    city: "Kraków",
  },
  {
    code: "30-065",
    city: "Kraków",
  },
  {
    code: "30-066",
    city: "Kraków",
  },
  {
    code: "30-067",
    city: "Kraków",
  },
  {
    code: "30-068",
    city: "Kraków",
  },
  {
    code: "30-069",
    city: "Kraków",
  },
  {
    code: "30-070",
    city: "Kraków",
  },
  {
    code: "30-071",
    city: "Kraków",
  },
  {
    code: "30-072",
    city: "Kraków",
  },
  {
    code: "30-073",
    city: "Kraków",
  },
  {
    code: "30-074",
    city: "Kraków",
  },
  {
    code: "30-075",
    city: "Kraków",
  },
  {
    code: "30-076",
    city: "Kraków",
  },
  {
    code: "30-077",
    city: "Kraków",
  },
  {
    code: "30-078",
    city: "Kraków",
  },
  {
    code: "30-079",
    city: "Kraków",
  },
  {
    code: "30-081",
    city: "Kraków",
  },
  {
    code: "30-082",
    city: "Kraków",
  },
  {
    code: "30-084",
    city: "Kraków",
  },
  {
    code: "30-085",
    city: "Kraków",
  },
  {
    code: "30-086",
    city: "Kraków",
  },
  {
    code: "30-087",
    city: "Kraków",
  },
  {
    code: "30-091",
    city: "Kraków",
  },
  {
    code: "30-092",
    city: "Kraków",
  },
  {
    code: "30-093",
    city: "Kraków",
  },
  {
    code: "30-094",
    city: "Kraków",
  },
  {
    code: "30-095",
    city: "Kraków",
  },
  {
    code: "30-100",
    city: "Kraków",
  },
  {
    code: "30-101",
    city: "Kraków",
  },
  {
    code: "30-102",
    city: "Kraków",
  },
  {
    code: "30-103",
    city: "Kraków",
  },
  {
    code: "30-104",
    city: "Kraków",
  },
  {
    code: "30-105",
    city: "Kraków",
  },
  {
    code: "30-106",
    city: "Kraków",
  },
  {
    code: "30-107",
    city: "Kraków",
  },
  {
    code: "30-108",
    city: "Kraków",
  },
  {
    code: "30-109",
    city: "Kraków",
  },
  {
    code: "30-110",
    city: "Kraków",
  },
  {
    code: "30-111",
    city: "Kraków",
  },
  {
    code: "30-112",
    city: "Kraków",
  },
  {
    code: "30-114",
    city: "Kraków",
  },
  {
    code: "30-116",
    city: "Kraków",
  },
  {
    code: "30-117",
    city: "Kraków",
  },
  {
    code: "30-118",
    city: "Kraków",
  },
  {
    code: "30-119",
    city: "Kraków",
  },
  {
    code: "30-120",
    city: "Kraków",
  },
  {
    code: "30-121",
    city: "Kraków",
  },
  {
    code: "30-122",
    city: "Kraków",
  },
  {
    code: "30-123",
    city: "Kraków",
  },
  {
    code: "30-124",
    city: "Kraków",
  },
  {
    code: "30-126",
    city: "Kraków",
  },
  {
    code: "30-127",
    city: "Kraków",
  },
  {
    code: "30-128",
    city: "Kraków",
  },
  {
    code: "30-129",
    city: "Kraków",
  },
  {
    code: "30-130",
    city: "Kraków",
  },
  {
    code: "30-131",
    city: "Kraków",
  },
  {
    code: "30-132",
    city: "Kraków",
  },
  {
    code: "30-133",
    city: "Kraków",
  },
  {
    code: "30-134",
    city: "Kraków",
  },
  {
    code: "30-135",
    city: "Kraków",
  },
  {
    code: "30-136",
    city: "Kraków",
  },
  {
    code: "30-137",
    city: "Kraków",
  },
  {
    code: "30-138",
    city: "Kraków",
  },
  {
    code: "30-139",
    city: "Kraków",
  },
  {
    code: "30-142",
    city: "Kraków",
  },
  {
    code: "30-143",
    city: "Kraków",
  },
  {
    code: "30-144",
    city: "Kraków",
  },
  {
    code: "30-145",
    city: "Kraków",
  },
  {
    code: "30-146",
    city: "Kraków",
  },
  {
    code: "30-147",
    city: "Kraków",
  },
  {
    code: "30-148",
    city: "Kraków",
  },
  {
    code: "30-149",
    city: "Kraków",
  },
  {
    code: "30-150",
    city: "Kraków",
  },
  {
    code: "30-198",
    city: "Kraków",
  },
  {
    code: "30-199",
    city: "Kraków",
  },
  {
    code: "30-201",
    city: "Kraków",
  },
  {
    code: "30-202",
    city: "Kraków",
  },
  {
    code: "30-203",
    city: "Kraków",
  },
  {
    code: "30-204",
    city: "Kraków",
  },
  {
    code: "30-205",
    city: "Kraków",
  },
  {
    code: "30-206",
    city: "Kraków",
  },
  {
    code: "30-207",
    city: "Kraków",
  },
  {
    code: "30-209",
    city: "Kraków",
  },
  {
    code: "30-210",
    city: "Kraków",
  },
  {
    code: "30-211",
    city: "Kraków",
  },
  {
    code: "30-212",
    city: "Kraków",
  },
  {
    code: "30-213",
    city: "Kraków",
  },
  {
    code: "30-214",
    city: "Kraków",
  },
  {
    code: "30-215",
    city: "Kraków",
  },
  {
    code: "30-216",
    city: "Kraków",
  },
  {
    code: "30-217",
    city: "Kraków",
  },
  {
    code: "30-218",
    city: "Kraków",
  },
  {
    code: "30-219",
    city: "Kraków",
  },
  {
    code: "30-220",
    city: "Kraków",
  },
  {
    code: "30-221",
    city: "Kraków",
  },
  {
    code: "30-222",
    city: "Kraków",
  },
  {
    code: "30-223",
    city: "Kraków",
  },
  {
    code: "30-224",
    city: "Kraków",
  },
  {
    code: "30-225",
    city: "Kraków",
  },
  {
    code: "30-227",
    city: "Kraków",
  },
  {
    code: "30-228",
    city: "Kraków",
  },
  {
    code: "30-229",
    city: "Kraków",
  },
  {
    code: "30-230",
    city: "Kraków",
  },
  {
    code: "30-231",
    city: "Kraków",
  },
  {
    code: "30-232",
    city: "Kraków",
  },
  {
    code: "30-233",
    city: "Kraków",
  },
  {
    code: "30-234",
    city: "Kraków",
  },
  {
    code: "30-235",
    city: "Kraków",
  },
  {
    code: "30-236",
    city: "Kraków",
  },
  {
    code: "30-237",
    city: "Kraków",
  },
  {
    code: "30-238",
    city: "Kraków",
  },
  {
    code: "30-239",
    city: "Kraków",
  },
  {
    code: "30-240",
    city: "Kraków",
  },
  {
    code: "30-241",
    city: "Kraków",
  },
  {
    code: "30-243",
    city: "Kraków",
  },
  {
    code: "30-244",
    city: "Kraków",
  },
  {
    code: "30-245",
    city: "Kraków",
  },
  {
    code: "30-246",
    city: "Kraków",
  },
  {
    code: "30-247",
    city: "Kraków",
  },
  {
    code: "30-248",
    city: "Kraków",
  },
  {
    code: "30-249",
    city: "Kraków",
  },
  {
    code: "30-250",
    city: "Kraków",
  },
  {
    code: "30-251",
    city: "Kraków",
  },
  {
    code: "30-252",
    city: "Kraków",
  },
  {
    code: "30-253",
    city: "Kraków",
  },
  {
    code: "30-254",
    city: "Kraków",
  },
  {
    code: "30-255",
    city: "Kraków",
  },
  {
    code: "30-298",
    city: "Kraków",
  },
  {
    code: "30-300",
    city: "Kraków",
  },
  {
    code: "30-301",
    city: "Kraków",
  },
  {
    code: "30-302",
    city: "Kraków",
  },
  {
    code: "30-303",
    city: "Kraków",
  },
  {
    code: "30-305",
    city: "Kraków",
  },
  {
    code: "30-306",
    city: "Kraków",
  },
  {
    code: "30-307",
    city: "Kraków",
  },
  {
    code: "30-308",
    city: "Kraków",
  },
  {
    code: "30-309",
    city: "Kraków",
  },
  {
    code: "30-311",
    city: "Kraków",
  },
  {
    code: "30-313",
    city: "Kraków",
  },
  {
    code: "30-314",
    city: "Kraków",
  },
  {
    code: "30-315",
    city: "Kraków",
  },
  {
    code: "30-316",
    city: "Kraków",
  },
  {
    code: "30-317",
    city: "Kraków",
  },
  {
    code: "30-318",
    city: "Kraków",
  },
  {
    code: "30-319",
    city: "Kraków",
  },
  {
    code: "30-320",
    city: "Kraków",
  },
  {
    code: "30-321",
    city: "Kraków",
  },
  {
    code: "30-322",
    city: "Kraków",
  },
  {
    code: "30-324",
    city: "Kraków",
  },
  {
    code: "30-326",
    city: "Kraków",
  },
  {
    code: "30-327",
    city: "Kraków",
  },
  {
    code: "30-328",
    city: "Kraków",
  },
  {
    code: "30-329",
    city: "Kraków",
  },
  {
    code: "30-331",
    city: "Kraków",
  },
  {
    code: "30-332",
    city: "Kraków",
  },
  {
    code: "30-333",
    city: "Kraków",
  },
  {
    code: "30-334",
    city: "Kraków",
  },
  {
    code: "30-335",
    city: "Kraków",
  },
  {
    code: "30-336",
    city: "Kraków",
  },
  {
    code: "30-337",
    city: "Kraków",
  },
  {
    code: "30-346",
    city: "Kraków",
  },
  {
    code: "30-347",
    city: "Kraków",
  },
  {
    code: "30-348",
    city: "Kraków",
  },
  {
    code: "30-349",
    city: "Kraków",
  },
  {
    code: "30-358",
    city: "Kraków",
  },
  {
    code: "30-361",
    city: "Kraków",
  },
  {
    code: "30-362",
    city: "Kraków",
  },
  {
    code: "30-363",
    city: "Kraków",
  },
  {
    code: "30-364",
    city: "Kraków",
  },
  {
    code: "30-374",
    city: "Kraków",
  },
  {
    code: "30-375",
    city: "Kraków",
  },
  {
    code: "30-376",
    city: "Kraków",
  },
  {
    code: "30-377",
    city: "Kraków",
  },
  {
    code: "30-379",
    city: "Kraków",
  },
  {
    code: "30-380",
    city: "Kraków",
  },
  {
    code: "30-381",
    city: "Kraków",
  },
  {
    code: "30-382",
    city: "Kraków",
  },
  {
    code: "30-383",
    city: "Kraków",
  },
  {
    code: "30-384",
    city: "Kraków",
  },
  {
    code: "30-385",
    city: "Kraków",
  },
  {
    code: "30-386",
    city: "Kraków",
  },
  {
    code: "30-387",
    city: "Kraków",
  },
  {
    code: "30-388",
    city: "Kraków",
  },
  {
    code: "30-389",
    city: "Kraków",
  },
  {
    code: "30-390",
    city: "Kraków",
  },
  {
    code: "30-391",
    city: "Kraków",
  },
  {
    code: "30-392",
    city: "Kraków",
  },
  {
    code: "30-393",
    city: "Kraków",
  },
  {
    code: "30-394",
    city: "Kraków",
  },
  {
    code: "30-395",
    city: "Kraków",
  },
  {
    code: "30-396",
    city: "Kraków",
  },
  {
    code: "30-397",
    city: "Kraków",
  },
  {
    code: "30-398",
    city: "Kraków",
  },
  {
    code: "30-399",
    city: "Kraków",
  },
  {
    code: "30-404",
    city: "Kraków",
  },
  {
    code: "30-405",
    city: "Kraków",
  },
  {
    code: "30-406",
    city: "Kraków",
  },
  {
    code: "30-407",
    city: "Kraków",
  },
  {
    code: "30-408",
    city: "Kraków",
  },
  {
    code: "30-409",
    city: "Kraków",
  },
  {
    code: "30-410",
    city: "Kraków",
  },
  {
    code: "30-411",
    city: "Kraków",
  },
  {
    code: "30-412",
    city: "Kraków",
  },
  {
    code: "30-413",
    city: "Kraków",
  },
  {
    code: "30-414",
    city: "Kraków",
  },
  {
    code: "30-415",
    city: "Kraków",
  },
  {
    code: "30-416",
    city: "Kraków",
  },
  {
    code: "30-417",
    city: "Kraków",
  },
  {
    code: "30-418",
    city: "Kraków",
  },
  {
    code: "30-419",
    city: "Kraków",
  },
  {
    code: "30-420",
    city: "Kraków",
  },
  {
    code: "30-421",
    city: "Kraków",
  },
  {
    code: "30-422",
    city: "Kraków",
  },
  {
    code: "30-423",
    city: "Kraków",
  },
  {
    code: "30-424",
    city: "Kraków",
  },
  {
    code: "30-425",
    city: "Kraków",
  },
  {
    code: "30-426",
    city: "Kraków",
  },
  {
    code: "30-427",
    city: "Kraków",
  },
  {
    code: "30-428",
    city: "Kraków",
  },
  {
    code: "30-429",
    city: "Kraków",
  },
  {
    code: "30-430",
    city: "Kraków",
  },
  {
    code: "30-431",
    city: "Kraków",
  },
  {
    code: "30-432",
    city: "Kraków",
  },
  {
    code: "30-433",
    city: "Kraków",
  },
  {
    code: "30-434",
    city: "Kraków",
  },
  {
    code: "30-435",
    city: "Kraków",
  },
  {
    code: "30-436",
    city: "Kraków",
  },
  {
    code: "30-437",
    city: "Kraków",
  },
  {
    code: "30-438",
    city: "Kraków",
  },
  {
    code: "30-439",
    city: "Kraków",
  },
  {
    code: "30-440",
    city: "Kraków",
  },
  {
    code: "30-441",
    city: "Kraków",
  },
  {
    code: "30-442",
    city: "Kraków",
  },
  {
    code: "30-443",
    city: "Kraków",
  },
  {
    code: "30-444",
    city: "Kraków",
  },
  {
    code: "30-445",
    city: "Kraków",
  },
  {
    code: "30-446",
    city: "Kraków",
  },
  {
    code: "30-447",
    city: "Kraków",
  },
  {
    code: "30-450",
    city: "Kraków",
  },
  {
    code: "30-498",
    city: "Kraków",
  },
  {
    code: "30-499",
    city: "Kraków",
  },
  {
    code: "30-500",
    city: "Kraków",
  },
  {
    code: "30-501",
    city: "Kraków",
  },
  {
    code: "30-502",
    city: "Kraków",
  },
  {
    code: "30-503",
    city: "Kraków",
  },
  {
    code: "30-504",
    city: "Kraków",
  },
  {
    code: "30-505",
    city: "Kraków",
  },
  {
    code: "30-506",
    city: "Kraków",
  },
  {
    code: "30-507",
    city: "Kraków",
  },
  {
    code: "30-508",
    city: "Kraków",
  },
  {
    code: "30-509",
    city: "Kraków",
  },
  {
    code: "30-510",
    city: "Kraków",
  },
  {
    code: "30-512",
    city: "Kraków",
  },
  {
    code: "30-513",
    city: "Kraków",
  },
  {
    code: "30-515",
    city: "Kraków",
  },
  {
    code: "30-516",
    city: "Kraków",
  },
  {
    code: "30-518",
    city: "Kraków",
  },
  {
    code: "30-519",
    city: "Kraków",
  },
  {
    code: "30-520",
    city: "Kraków",
  },
  {
    code: "30-521",
    city: "Kraków",
  },
  {
    code: "30-522",
    city: "Kraków",
  },
  {
    code: "30-523",
    city: "Kraków",
  },
  {
    code: "30-524",
    city: "Kraków",
  },
  {
    code: "30-525",
    city: "Kraków",
  },
  {
    code: "30-526",
    city: "Kraków",
  },
  {
    code: "30-527",
    city: "Kraków",
  },
  {
    code: "30-528",
    city: "Kraków",
  },
  {
    code: "30-529",
    city: "Kraków",
  },
  {
    code: "30-530",
    city: "Kraków",
  },
  {
    code: "30-531",
    city: "Kraków",
  },
  {
    code: "30-532",
    city: "Kraków",
  },
  {
    code: "30-533",
    city: "Kraków",
  },
  {
    code: "30-534",
    city: "Kraków",
  },
  {
    code: "30-535",
    city: "Kraków",
  },
  {
    code: "30-536",
    city: "Kraków",
  },
  {
    code: "30-537",
    city: "Kraków",
  },
  {
    code: "30-538",
    city: "Kraków",
  },
  {
    code: "30-539",
    city: "Kraków",
  },
  {
    code: "30-540",
    city: "Kraków",
  },
  {
    code: "30-542",
    city: "Kraków",
  },
  {
    code: "30-543",
    city: "Kraków",
  },
  {
    code: "30-544",
    city: "Kraków",
  },
  {
    code: "30-545",
    city: "Kraków",
  },
  {
    code: "30-546",
    city: "Kraków",
  },
  {
    code: "30-547",
    city: "Kraków",
  },
  {
    code: "30-548",
    city: "Kraków",
  },
  {
    code: "30-549",
    city: "Kraków",
  },
  {
    code: "30-550",
    city: "Kraków",
  },
  {
    code: "30-551",
    city: "Kraków",
  },
  {
    code: "30-552",
    city: "Kraków",
  },
  {
    code: "30-553",
    city: "Kraków",
  },
  {
    code: "30-554",
    city: "Kraków",
  },
  {
    code: "30-555",
    city: "Kraków",
  },
  {
    code: "30-556",
    city: "Kraków",
  },
  {
    code: "30-557",
    city: "Kraków",
  },
  {
    code: "30-559",
    city: "Kraków",
  },
  {
    code: "30-560",
    city: "Kraków",
  },
  {
    code: "30-563",
    city: "Kraków",
  },
  {
    code: "30-564",
    city: "Kraków",
  },
  {
    code: "30-565",
    city: "Kraków",
  },
  {
    code: "30-566",
    city: "Kraków",
  },
  {
    code: "30-568",
    city: "Kraków",
  },
  {
    code: "30-570",
    city: "Kraków",
  },
  {
    code: "30-571",
    city: "Kraków",
  },
  {
    code: "30-572",
    city: "Kraków",
  },
  {
    code: "30-601",
    city: "Kraków",
  },
  {
    code: "30-602",
    city: "Kraków",
  },
  {
    code: "30-603",
    city: "Kraków",
  },
  {
    code: "30-604",
    city: "Kraków",
  },
  {
    code: "30-605",
    city: "Kraków",
  },
  {
    code: "30-606",
    city: "Kraków",
  },
  {
    code: "30-607",
    city: "Kraków",
  },
  {
    code: "30-608",
    city: "Kraków",
  },
  {
    code: "30-609",
    city: "Kraków",
  },
  {
    code: "30-610",
    city: "Kraków",
  },
  {
    code: "30-611",
    city: "Kraków",
  },
  {
    code: "30-612",
    city: "Kraków",
  },
  {
    code: "30-613",
    city: "Kraków",
  },
  {
    code: "30-614",
    city: "Kraków",
  },
  {
    code: "30-616",
    city: "Kraków",
  },
  {
    code: "30-617",
    city: "Kraków",
  },
  {
    code: "30-619",
    city: "Kraków",
  },
  {
    code: "30-620",
    city: "Kraków",
  },
  {
    code: "30-621",
    city: "Kraków",
  },
  {
    code: "30-622",
    city: "Kraków",
  },
  {
    code: "30-623",
    city: "Kraków",
  },
  {
    code: "30-624",
    city: "Kraków",
  },
  {
    code: "30-626",
    city: "Kraków",
  },
  {
    code: "30-627",
    city: "Kraków",
  },
  {
    code: "30-628",
    city: "Kraków",
  },
  {
    code: "30-629",
    city: "Kraków",
  },
  {
    code: "30-630",
    city: "Kraków",
  },
  {
    code: "30-631",
    city: "Kraków",
  },
  {
    code: "30-632",
    city: "Kraków",
  },
  {
    code: "30-638",
    city: "Kraków",
  },
  {
    code: "30-639",
    city: "Kraków",
  },
  {
    code: "30-641",
    city: "Kraków",
  },
  {
    code: "30-643",
    city: "Kraków",
  },
  {
    code: "30-645",
    city: "Kraków",
  },
  {
    code: "30-646",
    city: "Kraków",
  },
  {
    code: "30-647",
    city: "Kraków",
  },
  {
    code: "30-649",
    city: "Kraków",
  },
  {
    code: "30-650",
    city: "Kraków",
  },
  {
    code: "30-651",
    city: "Kraków",
  },
  {
    code: "30-652",
    city: "Kraków",
  },
  {
    code: "30-653",
    city: "Kraków",
  },
  {
    code: "30-654",
    city: "Kraków",
  },
  {
    code: "30-655",
    city: "Kraków",
  },
  {
    code: "30-656",
    city: "Kraków",
  },
  {
    code: "30-657",
    city: "Kraków",
  },
  {
    code: "30-658",
    city: "Kraków",
  },
  {
    code: "30-659",
    city: "Kraków",
  },
  {
    code: "30-660",
    city: "Kraków",
  },
  {
    code: "30-662",
    city: "Kraków",
  },
  {
    code: "30-663",
    city: "Kraków",
  },
  {
    code: "30-664",
    city: "Kraków",
  },
  {
    code: "30-665",
    city: "Kraków",
  },
  {
    code: "30-667",
    city: "Kraków",
  },
  {
    code: "30-668",
    city: "Kraków",
  },
  {
    code: "30-669",
    city: "Kraków",
  },
  {
    code: "30-670",
    city: "Kraków",
  },
  {
    code: "30-681",
    city: "Kraków",
  },
  {
    code: "30-683",
    city: "Kraków",
  },
  {
    code: "30-684",
    city: "Kraków",
  },
  {
    code: "30-685",
    city: "Kraków",
  },
  {
    code: "30-686",
    city: "Kraków",
  },
  {
    code: "30-688",
    city: "Kraków",
  },
  {
    code: "30-689",
    city: "Kraków",
  },
  {
    code: "30-690",
    city: "Kraków",
  },
  {
    code: "30-692",
    city: "Kraków",
  },
  {
    code: "30-693",
    city: "Kraków",
  },
  {
    code: "30-694",
    city: "Kraków",
  },
  {
    code: "30-695",
    city: "Kraków",
  },
  {
    code: "30-697",
    city: "Kraków",
  },
  {
    code: "30-698",
    city: "Kraków",
  },
  {
    code: "30-699",
    city: "Kraków",
  },
  {
    code: "30-701",
    city: "Kraków",
  },
  {
    code: "30-702",
    city: "Kraków",
  },
  {
    code: "30-703",
    city: "Kraków",
  },
  {
    code: "30-704",
    city: "Kraków",
  },
  {
    code: "30-705",
    city: "Kraków",
  },
  {
    code: "30-706",
    city: "Kraków",
  },
  {
    code: "30-707",
    city: "Kraków",
  },
  {
    code: "30-709",
    city: "Kraków",
  },
  {
    code: "30-710",
    city: "Kraków",
  },
  {
    code: "30-711",
    city: "Kraków",
  },
  {
    code: "30-712",
    city: "Kraków",
  },
  {
    code: "30-713",
    city: "Kraków",
  },
  {
    code: "30-714",
    city: "Kraków",
  },
  {
    code: "30-715",
    city: "Kraków",
  },
  {
    code: "30-716",
    city: "Kraków",
  },
  {
    code: "30-717",
    city: "Kraków",
  },
  {
    code: "30-718",
    city: "Kraków",
  },
  {
    code: "30-719",
    city: "Kraków",
  },
  {
    code: "30-720",
    city: "Kraków",
  },
  {
    code: "30-721",
    city: "Kraków",
  },
  {
    code: "30-722",
    city: "Kraków",
  },
  {
    code: "30-723",
    city: "Kraków",
  },
  {
    code: "30-724",
    city: "Kraków",
  },
  {
    code: "30-725",
    city: "Kraków",
  },
  {
    code: "30-726",
    city: "Kraków",
  },
  {
    code: "30-727",
    city: "Kraków",
  },
  {
    code: "30-728",
    city: "Kraków",
  },
  {
    code: "30-729",
    city: "Kraków",
  },
  {
    code: "30-730",
    city: "Kraków",
  },
  {
    code: "30-731",
    city: "Kraków",
  },
  {
    code: "30-732",
    city: "Kraków",
  },
  {
    code: "30-733",
    city: "Kraków",
  },
  {
    code: "30-734",
    city: "Kraków",
  },
  {
    code: "30-735",
    city: "Kraków",
  },
  {
    code: "30-736",
    city: "Kraków",
  },
  {
    code: "30-737",
    city: "Kraków",
  },
  {
    code: "30-738",
    city: "Kraków",
  },
  {
    code: "30-739",
    city: "Kraków",
  },
  {
    code: "30-740",
    city: "Kraków",
  },
  {
    code: "30-741",
    city: "Kraków",
  },
  {
    code: "30-758",
    city: "Kraków",
  },
  {
    code: "30-798",
    city: "Kraków",
  },
  {
    code: "30-799",
    city: "Kraków",
  },
  {
    code: "30-800",
    city: "Kraków",
  },
  {
    code: "30-802",
    city: "Kraków",
  },
  {
    code: "30-803",
    city: "Kraków",
  },
  {
    code: "30-804",
    city: "Kraków",
  },
  {
    code: "30-805",
    city: "Kraków",
  },
  {
    code: "30-806",
    city: "Kraków",
  },
  {
    code: "30-807",
    city: "Kraków",
  },
  {
    code: "30-808",
    city: "Kraków",
  },
  {
    code: "30-809",
    city: "Kraków",
  },
  {
    code: "30-810",
    city: "Kraków",
  },
  {
    code: "30-811",
    city: "Kraków",
  },
  {
    code: "30-812",
    city: "Kraków",
  },
  {
    code: "30-813",
    city: "Kraków",
  },
  {
    code: "30-814",
    city: "Kraków",
  },
  {
    code: "30-815",
    city: "Kraków",
  },
  {
    code: "30-816",
    city: "Kraków",
  },
  {
    code: "30-817",
    city: "Kraków",
  },
  {
    code: "30-818",
    city: "Kraków",
  },
  {
    code: "30-819",
    city: "Kraków",
  },
  {
    code: "30-820",
    city: "Kraków",
  },
  {
    code: "30-821",
    city: "Kraków",
  },
  {
    code: "30-822",
    city: "Kraków",
  },
  {
    code: "30-823",
    city: "Kraków",
  },
  {
    code: "30-824",
    city: "Kraków",
  },
  {
    code: "30-825",
    city: "Kraków",
  },
  {
    code: "30-826",
    city: "Kraków",
  },
  {
    code: "30-827",
    city: "Kraków",
  },
  {
    code: "30-828",
    city: "Kraków",
  },
  {
    code: "30-829",
    city: "Kraków",
  },
  {
    code: "30-830",
    city: "Kraków",
  },
  {
    code: "30-833",
    city: "Kraków",
  },
  {
    code: "30-834",
    city: "Kraków",
  },
  {
    code: "30-835",
    city: "Kraków",
  },
  {
    code: "30-836",
    city: "Kraków",
  },
  {
    code: "30-837",
    city: "Kraków",
  },
  {
    code: "30-838",
    city: "Kraków",
  },
  {
    code: "30-851",
    city: "Kraków",
  },
  {
    code: "30-852",
    city: "Kraków",
  },
  {
    code: "30-853",
    city: "Kraków",
  },
  {
    code: "30-854",
    city: "Kraków",
  },
  {
    code: "30-855",
    city: "Kraków",
  },
  {
    code: "30-856",
    city: "Kraków",
  },
  {
    code: "30-857",
    city: "Kraków",
  },
  {
    code: "30-858",
    city: "Kraków",
  },
  {
    code: "30-860",
    city: "Kraków",
  },
  {
    code: "30-863",
    city: "Kraków",
  },
  {
    code: "30-864",
    city: "Kraków",
  },
  {
    code: "30-865",
    city: "Kraków",
  },
  {
    code: "30-867",
    city: "Kraków",
  },
  {
    code: "30-868",
    city: "Kraków",
  },
  {
    code: "30-870",
    city: "Kraków",
  },
  {
    code: "30-898",
    city: "Kraków",
  },
  {
    code: "30-899",
    city: "Kraków",
  },
  {
    code: "30-900",
    city: "Kraków",
  },
  {
    code: "30-901",
    city: "Kraków",
  },
  {
    code: "30-902",
    city: "Kraków",
  },
  {
    code: "30-940",
    city: "Kraków",
  },
  {
    code: "30-942",
    city: "Kraków",
  },
  {
    code: "30-950",
    city: "Kraków",
  },
  {
    code: "30-951",
    city: "Kraków",
  },
  {
    code: "30-952",
    city: "Kraków",
  },
  {
    code: "30-953",
    city: "Kraków",
  },
  {
    code: "30-954",
    city: "Kraków",
  },
  {
    code: "30-955",
    city: "Kraków",
  },
  {
    code: "30-956",
    city: "Kraków",
  },
  {
    code: "30-960",
    city: "Kraków",
  },
  {
    code: "30-961",
    city: "Kraków",
  },
  {
    code: "30-962",
    city: "Kraków",
  },
  {
    code: "31-000",
    city: "Kraków",
  },
  {
    code: "31-001",
    city: "Kraków",
  },
  {
    code: "31-002",
    city: "Kraków",
  },
  {
    code: "31-003",
    city: "Kraków",
  },
  {
    code: "31-004",
    city: "Kraków",
  },
  {
    code: "31-005",
    city: "Kraków",
  },
  {
    code: "31-006",
    city: "Kraków",
  },
  {
    code: "31-007",
    city: "Kraków",
  },
  {
    code: "31-008",
    city: "Kraków",
  },
  {
    code: "31-009",
    city: "Kraków",
  },
  {
    code: "31-010",
    city: "Kraków",
  },
  {
    code: "31-011",
    city: "Kraków",
  },
  {
    code: "31-012",
    city: "Kraków",
  },
  {
    code: "31-013",
    city: "Kraków",
  },
  {
    code: "31-014",
    city: "Kraków",
  },
  {
    code: "31-015",
    city: "Kraków",
  },
  {
    code: "31-016",
    city: "Kraków",
  },
  {
    code: "31-017",
    city: "Kraków",
  },
  {
    code: "31-018",
    city: "Kraków",
  },
  {
    code: "31-019",
    city: "Kraków",
  },
  {
    code: "31-020",
    city: "Kraków",
  },
  {
    code: "31-021",
    city: "Kraków",
  },
  {
    code: "31-022",
    city: "Kraków",
  },
  {
    code: "31-023",
    city: "Kraków",
  },
  {
    code: "31-024",
    city: "Kraków",
  },
  {
    code: "31-025",
    city: "Kraków",
  },
  {
    code: "31-026",
    city: "Kraków",
  },
  {
    code: "31-027",
    city: "Kraków",
  },
  {
    code: "31-028",
    city: "Kraków",
  },
  {
    code: "31-029",
    city: "Kraków",
  },
  {
    code: "31-030",
    city: "Kraków",
  },
  {
    code: "31-031",
    city: "Kraków",
  },
  {
    code: "31-032",
    city: "Kraków",
  },
  {
    code: "31-033",
    city: "Kraków",
  },
  {
    code: "31-034",
    city: "Kraków",
  },
  {
    code: "31-035",
    city: "Kraków",
  },
  {
    code: "31-036",
    city: "Kraków",
  },
  {
    code: "31-037",
    city: "Kraków",
  },
  {
    code: "31-038",
    city: "Kraków",
  },
  {
    code: "31-039",
    city: "Kraków",
  },
  {
    code: "31-041",
    city: "Kraków",
  },
  {
    code: "31-042",
    city: "Kraków",
  },
  {
    code: "31-043",
    city: "Kraków",
  },
  {
    code: "31-044",
    city: "Kraków",
  },
  {
    code: "31-045",
    city: "Kraków",
  },
  {
    code: "31-046",
    city: "Kraków",
  },
  {
    code: "31-047",
    city: "Kraków",
  },
  {
    code: "31-048",
    city: "Kraków",
  },
  {
    code: "31-049",
    city: "Kraków",
  },
  {
    code: "31-050",
    city: "Kraków",
  },
  {
    code: "31-051",
    city: "Kraków",
  },
  {
    code: "31-052",
    city: "Kraków",
  },
  {
    code: "31-053",
    city: "Kraków",
  },
  {
    code: "31-054",
    city: "Kraków",
  },
  {
    code: "31-055",
    city: "Kraków",
  },
  {
    code: "31-056",
    city: "Kraków",
  },
  {
    code: "31-057",
    city: "Kraków",
  },
  {
    code: "31-058",
    city: "Kraków",
  },
  {
    code: "31-059",
    city: "Kraków",
  },
  {
    code: "31-060",
    city: "Kraków",
  },
  {
    code: "31-061",
    city: "Kraków",
  },
  {
    code: "31-062",
    city: "Kraków",
  },
  {
    code: "31-063",
    city: "Kraków",
  },
  {
    code: "31-064",
    city: "Kraków",
  },
  {
    code: "31-065",
    city: "Kraków",
  },
  {
    code: "31-066",
    city: "Kraków",
  },
  {
    code: "31-067",
    city: "Kraków",
  },
  {
    code: "31-068",
    city: "Kraków",
  },
  {
    code: "31-069",
    city: "Kraków",
  },
  {
    code: "31-070",
    city: "Kraków",
  },
  {
    code: "31-071",
    city: "Kraków",
  },
  {
    code: "31-072",
    city: "Kraków",
  },
  {
    code: "31-073",
    city: "Kraków",
  },
  {
    code: "31-075",
    city: "Kraków",
  },
  {
    code: "31-080",
    city: "Kraków",
  },
  {
    code: "31-100",
    city: "Kraków",
  },
  {
    code: "31-101",
    city: "Kraków",
  },
  {
    code: "31-102",
    city: "Kraków",
  },
  {
    code: "31-103",
    city: "Kraków",
  },
  {
    code: "31-104",
    city: "Kraków",
  },
  {
    code: "31-105",
    city: "Kraków",
  },
  {
    code: "31-106",
    city: "Kraków",
  },
  {
    code: "31-107",
    city: "Kraków",
  },
  {
    code: "31-108",
    city: "Kraków",
  },
  {
    code: "31-109",
    city: "Kraków",
  },
  {
    code: "31-110",
    city: "Kraków",
  },
  {
    code: "31-111",
    city: "Kraków",
  },
  {
    code: "31-112",
    city: "Kraków",
  },
  {
    code: "31-113",
    city: "Kraków",
  },
  {
    code: "31-114",
    city: "Kraków",
  },
  {
    code: "31-115",
    city: "Kraków",
  },
  {
    code: "31-116",
    city: "Kraków",
  },
  {
    code: "31-117",
    city: "Kraków",
  },
  {
    code: "31-118",
    city: "Kraków",
  },
  {
    code: "31-120",
    city: "Kraków",
  },
  {
    code: "31-121",
    city: "Kraków",
  },
  {
    code: "31-123",
    city: "Kraków",
  },
  {
    code: "31-124",
    city: "Kraków",
  },
  {
    code: "31-126",
    city: "Kraków",
  },
  {
    code: "31-127",
    city: "Kraków",
  },
  {
    code: "31-128",
    city: "Kraków",
  },
  {
    code: "31-130",
    city: "Kraków",
  },
  {
    code: "31-131",
    city: "Kraków",
  },
  {
    code: "31-132",
    city: "Kraków",
  },
  {
    code: "31-133",
    city: "Kraków",
  },
  {
    code: "31-134",
    city: "Kraków",
  },
  {
    code: "31-135",
    city: "Kraków",
  },
  {
    code: "31-136",
    city: "Kraków",
  },
  {
    code: "31-137",
    city: "Kraków",
  },
  {
    code: "31-138",
    city: "Kraków",
  },
  {
    code: "31-139",
    city: "Kraków",
  },
  {
    code: "31-140",
    city: "Kraków",
  },
  {
    code: "31-141",
    city: "Kraków",
  },
  {
    code: "31-142",
    city: "Kraków",
  },
  {
    code: "31-143",
    city: "Kraków",
  },
  {
    code: "31-144",
    city: "Kraków",
  },
  {
    code: "31-145",
    city: "Kraków",
  },
  {
    code: "31-146",
    city: "Kraków",
  },
  {
    code: "31-147",
    city: "Kraków",
  },
  {
    code: "31-148",
    city: "Kraków",
  },
  {
    code: "31-149",
    city: "Kraków",
  },
  {
    code: "31-150",
    city: "Kraków",
  },
  {
    code: "31-151",
    city: "Kraków",
  },
  {
    code: "31-152",
    city: "Kraków",
  },
  {
    code: "31-153",
    city: "Kraków",
  },
  {
    code: "31-154",
    city: "Kraków",
  },
  {
    code: "31-155",
    city: "Kraków",
  },
  {
    code: "31-156",
    city: "Kraków",
  },
  {
    code: "31-157",
    city: "Kraków",
  },
  {
    code: "31-158",
    city: "Kraków",
  },
  {
    code: "31-159",
    city: "Kraków",
  },
  {
    code: "31-160",
    city: "Kraków",
  },
  {
    code: "31-161",
    city: "Kraków",
  },
  {
    code: "31-162",
    city: "Kraków",
  },
  {
    code: "31-200",
    city: "Kraków",
  },
  {
    code: "31-201",
    city: "Kraków",
  },
  {
    code: "31-202",
    city: "Kraków",
  },
  {
    code: "31-203",
    city: "Kraków",
  },
  {
    code: "31-207",
    city: "Kraków",
  },
  {
    code: "31-209",
    city: "Kraków",
  },
  {
    code: "31-210",
    city: "Kraków",
  },
  {
    code: "31-212",
    city: "Kraków",
  },
  {
    code: "31-213",
    city: "Kraków",
  },
  {
    code: "31-214",
    city: "Kraków",
  },
  {
    code: "31-215",
    city: "Kraków",
  },
  {
    code: "31-216",
    city: "Kraków",
  },
  {
    code: "31-217",
    city: "Kraków",
  },
  {
    code: "31-218",
    city: "Kraków",
  },
  {
    code: "31-220",
    city: "Kraków",
  },
  {
    code: "31-221",
    city: "Kraków",
  },
  {
    code: "31-222",
    city: "Kraków",
  },
  {
    code: "31-223",
    city: "Kraków",
  },
  {
    code: "31-224",
    city: "Kraków",
  },
  {
    code: "31-225",
    city: "Kraków",
  },
  {
    code: "31-226",
    city: "Kraków",
  },
  {
    code: "31-227",
    city: "Kraków",
  },
  {
    code: "31-228",
    city: "Kraków",
  },
  {
    code: "31-229",
    city: "Kraków",
  },
  {
    code: "31-230",
    city: "Kraków",
  },
  {
    code: "31-231",
    city: "Kraków",
  },
  {
    code: "31-232",
    city: "Kraków",
  },
  {
    code: "31-233",
    city: "Kraków",
  },
  {
    code: "31-234",
    city: "Kraków",
  },
  {
    code: "31-235",
    city: "Kraków",
  },
  {
    code: "31-236",
    city: "Kraków",
  },
  {
    code: "31-241",
    city: "Kraków",
  },
  {
    code: "31-242",
    city: "Kraków",
  },
  {
    code: "31-261",
    city: "Kraków",
  },
  {
    code: "31-262",
    city: "Kraków",
  },
  {
    code: "31-263",
    city: "Kraków",
  },
  {
    code: "31-264",
    city: "Kraków",
  },
  {
    code: "31-265",
    city: "Kraków",
  },
  {
    code: "31-266",
    city: "Kraków",
  },
  {
    code: "31-267",
    city: "Kraków",
  },
  {
    code: "31-268",
    city: "Kraków",
  },
  {
    code: "31-269",
    city: "Kraków",
  },
  {
    code: "31-270",
    city: "Kraków",
  },
  {
    code: "31-271",
    city: "Kraków",
  },
  {
    code: "31-272",
    city: "Kraków",
  },
  {
    code: "31-273",
    city: "Kraków",
  },
  {
    code: "31-274",
    city: "Kraków",
  },
  {
    code: "31-275",
    city: "Kraków",
  },
  {
    code: "31-276",
    city: "Kraków",
  },
  {
    code: "31-277",
    city: "Kraków",
  },
  {
    code: "31-278",
    city: "Kraków",
  },
  {
    code: "31-279",
    city: "Kraków",
  },
  {
    code: "31-280",
    city: "Kraków",
  },
  {
    code: "31-300",
    city: "Kraków",
  },
  {
    code: "31-301",
    city: "Kraków",
  },
  {
    code: "31-302",
    city: "Kraków",
  },
  {
    code: "31-303",
    city: "Kraków",
  },
  {
    code: "31-305",
    city: "Kraków",
  },
  {
    code: "31-306",
    city: "Kraków",
  },
  {
    code: "31-307",
    city: "Kraków",
  },
  {
    code: "31-308",
    city: "Kraków",
  },
  {
    code: "31-309",
    city: "Kraków",
  },
  {
    code: "31-310",
    city: "Kraków",
  },
  {
    code: "31-311",
    city: "Kraków",
  },
  {
    code: "31-312",
    city: "Kraków",
  },
  {
    code: "31-313",
    city: "Kraków",
  },
  {
    code: "31-314",
    city: "Kraków",
  },
  {
    code: "31-315",
    city: "Kraków",
  },
  {
    code: "31-316",
    city: "Kraków",
  },
  {
    code: "31-317",
    city: "Kraków",
  },
  {
    code: "31-318",
    city: "Kraków",
  },
  {
    code: "31-319",
    city: "Kraków",
  },
  {
    code: "31-320",
    city: "Kraków",
  },
  {
    code: "31-321",
    city: "Kraków",
  },
  {
    code: "31-322",
    city: "Kraków",
  },
  {
    code: "31-323",
    city: "Kraków",
  },
  {
    code: "31-324",
    city: "Kraków",
  },
  {
    code: "31-325",
    city: "Kraków",
  },
  {
    code: "31-326",
    city: "Kraków",
  },
  {
    code: "31-327",
    city: "Kraków",
  },
  {
    code: "31-328",
    city: "Kraków",
  },
  {
    code: "31-329",
    city: "Kraków",
  },
  {
    code: "31-330",
    city: "Kraków",
  },
  {
    code: "31-331",
    city: "Kraków",
  },
  {
    code: "31-332",
    city: "Kraków",
  },
  {
    code: "31-333",
    city: "Kraków",
  },
  {
    code: "31-334",
    city: "Kraków",
  },
  {
    code: "31-335",
    city: "Kraków",
  },
  {
    code: "31-336",
    city: "Kraków",
  },
  {
    code: "31-337",
    city: "Kraków",
  },
  {
    code: "31-338",
    city: "Kraków",
  },
  {
    code: "31-339",
    city: "Kraków",
  },
  {
    code: "31-340",
    city: "Kraków",
  },
  {
    code: "31-341",
    city: "Kraków",
  },
  {
    code: "31-342",
    city: "Kraków",
  },
  {
    code: "31-343",
    city: "Kraków",
  },
  {
    code: "31-344",
    city: "Kraków",
  },
  {
    code: "31-345",
    city: "Kraków",
  },
  {
    code: "31-346",
    city: "Kraków",
  },
  {
    code: "31-347",
    city: "Kraków",
  },
  {
    code: "31-348",
    city: "Kraków",
  },
  {
    code: "31-349",
    city: "Kraków",
  },
  {
    code: "31-350",
    city: "Kraków",
  },
  {
    code: "31-351",
    city: "Kraków",
  },
  {
    code: "31-352",
    city: "Kraków",
  },
  {
    code: "31-353",
    city: "Kraków",
  },
  {
    code: "31-354",
    city: "Kraków",
  },
  {
    code: "31-355",
    city: "Kraków",
  },
  {
    code: "31-357",
    city: "Kraków",
  },
  {
    code: "31-358",
    city: "Kraków",
  },
  {
    code: "31-398",
    city: "Kraków",
  },
  {
    code: "31-401",
    city: "Kraków",
  },
  {
    code: "31-402",
    city: "Kraków",
  },
  {
    code: "31-403",
    city: "Kraków",
  },
  {
    code: "31-404",
    city: "Kraków",
  },
  {
    code: "31-406",
    city: "Kraków",
  },
  {
    code: "31-408",
    city: "Kraków",
  },
  {
    code: "31-409",
    city: "Kraków",
  },
  {
    code: "31-410",
    city: "Kraków",
  },
  {
    code: "31-411",
    city: "Kraków",
  },
  {
    code: "31-413",
    city: "Kraków",
  },
  {
    code: "31-414",
    city: "Kraków",
  },
  {
    code: "31-416",
    city: "Kraków",
  },
  {
    code: "31-417",
    city: "Kraków",
  },
  {
    code: "31-418",
    city: "Kraków",
  },
  {
    code: "31-419",
    city: "Kraków",
  },
  {
    code: "31-420",
    city: "Kraków",
  },
  {
    code: "31-421",
    city: "Kraków",
  },
  {
    code: "31-422",
    city: "Kraków",
  },
  {
    code: "31-423",
    city: "Kraków",
  },
  {
    code: "31-424",
    city: "Kraków",
  },
  {
    code: "31-425",
    city: "Kraków",
  },
  {
    code: "31-426",
    city: "Kraków",
  },
  {
    code: "31-428",
    city: "Kraków",
  },
  {
    code: "31-429",
    city: "Kraków",
  },
  {
    code: "31-431",
    city: "Kraków",
  },
  {
    code: "31-432",
    city: "Kraków",
  },
  {
    code: "31-435",
    city: "Kraków",
  },
  {
    code: "31-436",
    city: "Kraków",
  },
  {
    code: "31-443",
    city: "Kraków",
  },
  {
    code: "31-444",
    city: "Kraków",
  },
  {
    code: "31-445",
    city: "Kraków",
  },
  {
    code: "31-446",
    city: "Kraków",
  },
  {
    code: "31-450",
    city: "Kraków",
  },
  {
    code: "31-452",
    city: "Kraków",
  },
  {
    code: "31-455",
    city: "Kraków",
  },
  {
    code: "31-456",
    city: "Kraków",
  },
  {
    code: "31-457",
    city: "Kraków",
  },
  {
    code: "31-460",
    city: "Kraków",
  },
  {
    code: "31-461",
    city: "Kraków",
  },
  {
    code: "31-462",
    city: "Kraków",
  },
  {
    code: "31-463",
    city: "Kraków",
  },
  {
    code: "31-464",
    city: "Kraków",
  },
  {
    code: "31-465",
    city: "Kraków",
  },
  {
    code: "31-466",
    city: "Kraków",
  },
  {
    code: "31-467",
    city: "Kraków",
  },
  {
    code: "31-469",
    city: "Kraków",
  },
  {
    code: "31-470",
    city: "Kraków",
  },
  {
    code: "31-471",
    city: "Kraków",
  },
  {
    code: "31-474",
    city: "Kraków",
  },
  {
    code: "31-475",
    city: "Kraków",
  },
  {
    code: "31-476",
    city: "Kraków",
  },
  {
    code: "31-477",
    city: "Kraków",
  },
  {
    code: "31-478",
    city: "Kraków",
  },
  {
    code: "31-479",
    city: "Kraków",
  },
  {
    code: "31-480",
    city: "Kraków",
  },
  {
    code: "31-481",
    city: "Kraków",
  },
  {
    code: "31-482",
    city: "Kraków",
  },
  {
    code: "31-500",
    city: "Kraków",
  },
  {
    code: "31-501",
    city: "Kraków",
  },
  {
    code: "31-502",
    city: "Kraków",
  },
  {
    code: "31-503",
    city: "Kraków",
  },
  {
    code: "31-504",
    city: "Kraków",
  },
  {
    code: "31-505",
    city: "Kraków",
  },
  {
    code: "31-506",
    city: "Kraków",
  },
  {
    code: "31-507",
    city: "Kraków",
  },
  {
    code: "31-508",
    city: "Kraków",
  },
  {
    code: "31-509",
    city: "Kraków",
  },
  {
    code: "31-510",
    city: "Kraków",
  },
  {
    code: "31-511",
    city: "Kraków",
  },
  {
    code: "31-512",
    city: "Kraków",
  },
  {
    code: "31-513",
    city: "Kraków",
  },
  {
    code: "31-514",
    city: "Kraków",
  },
  {
    code: "31-515",
    city: "Kraków",
  },
  {
    code: "31-516",
    city: "Kraków",
  },
  {
    code: "31-517",
    city: "Kraków",
  },
  {
    code: "31-518",
    city: "Kraków",
  },
  {
    code: "31-519",
    city: "Kraków",
  },
  {
    code: "31-520",
    city: "Kraków",
  },
  {
    code: "31-521",
    city: "Kraków",
  },
  {
    code: "31-523",
    city: "Kraków",
  },
  {
    code: "31-524",
    city: "Kraków",
  },
  {
    code: "31-525",
    city: "Kraków",
  },
  {
    code: "31-526",
    city: "Kraków",
  },
  {
    code: "31-527",
    city: "Kraków",
  },
  {
    code: "31-529",
    city: "Kraków",
  },
  {
    code: "31-530",
    city: "Kraków",
  },
  {
    code: "31-531",
    city: "Kraków",
  },
  {
    code: "31-532",
    city: "Kraków",
  },
  {
    code: "31-534",
    city: "Kraków",
  },
  {
    code: "31-535",
    city: "Kraków",
  },
  {
    code: "31-536",
    city: "Kraków",
  },
  {
    code: "31-537",
    city: "Kraków",
  },
  {
    code: "31-538",
    city: "Kraków",
  },
  {
    code: "31-539",
    city: "Kraków",
  },
  {
    code: "31-540",
    city: "Kraków",
  },
  {
    code: "31-541",
    city: "Kraków",
  },
  {
    code: "31-542",
    city: "Kraków",
  },
  {
    code: "31-543",
    city: "Kraków",
  },
  {
    code: "31-545",
    city: "Kraków",
  },
  {
    code: "31-546",
    city: "Kraków",
  },
  {
    code: "31-547",
    city: "Kraków",
  },
  {
    code: "31-548",
    city: "Kraków",
  },
  {
    code: "31-550",
    city: "Kraków",
  },
  {
    code: "31-552",
    city: "Kraków",
  },
  {
    code: "31-553",
    city: "Kraków",
  },
  {
    code: "31-557",
    city: "Kraków",
  },
  {
    code: "31-559",
    city: "Kraków",
  },
  {
    code: "31-560",
    city: "Kraków",
  },
  {
    code: "31-563",
    city: "Kraków",
  },
  {
    code: "31-564",
    city: "Kraków",
  },
  {
    code: "31-566",
    city: "Kraków",
  },
  {
    code: "31-567",
    city: "Kraków",
  },
  {
    code: "31-571",
    city: "Kraków",
  },
  {
    code: "31-572",
    city: "Kraków",
  },
  {
    code: "31-573",
    city: "Kraków",
  },
  {
    code: "31-574",
    city: "Kraków",
  },
  {
    code: "31-579",
    city: "Kraków",
  },
  {
    code: "31-580",
    city: "Kraków",
  },
  {
    code: "31-581",
    city: "Kraków",
  },
  {
    code: "31-586",
    city: "Kraków",
  },
  {
    code: "31-587",
    city: "Kraków",
  },
  {
    code: "31-588",
    city: "Kraków",
  },
  {
    code: "31-589",
    city: "Kraków",
  },
  {
    code: "31-603",
    city: "Kraków",
  },
  {
    code: "31-604",
    city: "Kraków",
  },
  {
    code: "31-605",
    city: "Kraków",
  },
  {
    code: "31-606",
    city: "Kraków",
  },
  {
    code: "31-607",
    city: "Kraków",
  },
  {
    code: "31-608",
    city: "Kraków",
  },
  {
    code: "31-609",
    city: "Kraków",
  },
  {
    code: "31-610",
    city: "Kraków",
  },
  {
    code: "31-611",
    city: "Kraków",
  },
  {
    code: "31-612",
    city: "Kraków",
  },
  {
    code: "31-615",
    city: "Kraków",
  },
  {
    code: "31-616",
    city: "Kraków",
  },
  {
    code: "31-617",
    city: "Kraków",
  },
  {
    code: "31-618",
    city: "Kraków",
  },
  {
    code: "31-619",
    city: "Kraków",
  },
  {
    code: "31-620",
    city: "Kraków",
  },
  {
    code: "31-621",
    city: "Kraków",
  },
  {
    code: "31-622",
    city: "Kraków",
  },
  {
    code: "31-623",
    city: "Kraków",
  },
  {
    code: "31-624",
    city: "Kraków",
  },
  {
    code: "31-625",
    city: "Kraków",
  },
  {
    code: "31-626",
    city: "Kraków",
  },
  {
    code: "31-628",
    city: "Kraków",
  },
  {
    code: "31-630",
    city: "Kraków",
  },
  {
    code: "31-634",
    city: "Kraków",
  },
  {
    code: "31-635",
    city: "Kraków",
  },
  {
    code: "31-636",
    city: "Kraków",
  },
  {
    code: "31-637",
    city: "Kraków",
  },
  {
    code: "31-638",
    city: "Kraków",
  },
  {
    code: "31-640",
    city: "Kraków",
  },
  {
    code: "31-643",
    city: "Kraków",
  },
  {
    code: "31-644",
    city: "Kraków",
  },
  {
    code: "31-651",
    city: "Kraków",
  },
  {
    code: "31-670",
    city: "Kraków",
  },
  {
    code: "31-701",
    city: "Kraków",
  },
  {
    code: "31-702",
    city: "Kraków",
  },
  {
    code: "31-703",
    city: "Kraków",
  },
  {
    code: "31-704",
    city: "Kraków",
  },
  {
    code: "31-705",
    city: "Kraków",
  },
  {
    code: "31-706",
    city: "Kraków",
  },
  {
    code: "31-707",
    city: "Kraków",
  },
  {
    code: "31-708",
    city: "Kraków",
  },
  {
    code: "31-709",
    city: "Kraków",
  },
  {
    code: "31-710",
    city: "Kraków",
  },
  {
    code: "31-711",
    city: "Kraków",
  },
  {
    code: "31-712",
    city: "Kraków",
  },
  {
    code: "31-721",
    city: "Kraków",
  },
  {
    code: "31-722",
    city: "Kraków",
  },
  {
    code: "31-723",
    city: "Kraków",
  },
  {
    code: "31-724",
    city: "Kraków",
  },
  {
    code: "31-725",
    city: "Kraków",
  },
  {
    code: "31-726",
    city: "Kraków",
  },
  {
    code: "31-727",
    city: "Kraków",
  },
  {
    code: "31-750",
    city: "Kraków",
  },
  {
    code: "31-751",
    city: "Kraków",
  },
  {
    code: "31-752",
    city: "Kraków",
  },
  {
    code: "31-753",
    city: "Kraków",
  },
  {
    code: "31-754",
    city: "Kraków",
  },
  {
    code: "31-761",
    city: "Kraków",
  },
  {
    code: "31-762",
    city: "Kraków",
  },
  {
    code: "31-763",
    city: "Kraków",
  },
  {
    code: "31-764",
    city: "Kraków",
  },
  {
    code: "31-765",
    city: "Kraków",
  },
  {
    code: "31-766",
    city: "Kraków",
  },
  {
    code: "31-767",
    city: "Kraków",
  },
  {
    code: "31-768",
    city: "Kraków",
  },
  {
    code: "31-800",
    city: "Kraków",
  },
  {
    code: "31-801",
    city: "Kraków",
  },
  {
    code: "31-802",
    city: "Kraków",
  },
  {
    code: "31-803",
    city: "Kraków",
  },
  {
    code: "31-804",
    city: "Kraków",
  },
  {
    code: "31-807",
    city: "Kraków",
  },
  {
    code: "31-808",
    city: "Kraków",
  },
  {
    code: "31-809",
    city: "Kraków",
  },
  {
    code: "31-810",
    city: "Kraków",
  },
  {
    code: "31-812",
    city: "Kraków",
  },
  {
    code: "31-813",
    city: "Kraków",
  },
  {
    code: "31-814",
    city: "Kraków",
  },
  {
    code: "31-815",
    city: "Kraków",
  },
  {
    code: "31-816",
    city: "Kraków",
  },
  {
    code: "31-818",
    city: "Kraków",
  },
  {
    code: "31-819",
    city: "Kraków",
  },
  {
    code: "31-820",
    city: "Kraków",
  },
  {
    code: "31-825",
    city: "Kraków",
  },
  {
    code: "31-826",
    city: "Kraków",
  },
  {
    code: "31-827",
    city: "Kraków",
  },
  {
    code: "31-828",
    city: "Kraków",
  },
  {
    code: "31-829",
    city: "Kraków",
  },
  {
    code: "31-831",
    city: "Kraków",
  },
  {
    code: "31-832",
    city: "Kraków",
  },
  {
    code: "31-833",
    city: "Kraków",
  },
  {
    code: "31-834",
    city: "Kraków",
  },
  {
    code: "31-835",
    city: "Kraków",
  },
  {
    code: "31-836",
    city: "Kraków",
  },
  {
    code: "31-837",
    city: "Kraków",
  },
  {
    code: "31-839",
    city: "Kraków",
  },
  {
    code: "31-840",
    city: "Kraków",
  },
  {
    code: "31-841",
    city: "Kraków",
  },
  {
    code: "31-842",
    city: "Kraków",
  },
  {
    code: "31-843",
    city: "Kraków",
  },
  {
    code: "31-844",
    city: "Kraków",
  },
  {
    code: "31-845",
    city: "Kraków",
  },
  {
    code: "31-850",
    city: "Kraków",
  },
  {
    code: "31-851",
    city: "Kraków",
  },
  {
    code: "31-852",
    city: "Kraków",
  },
  {
    code: "31-853",
    city: "Kraków",
  },
  {
    code: "31-854",
    city: "Kraków",
  },
  {
    code: "31-855",
    city: "Kraków",
  },
  {
    code: "31-858",
    city: "Kraków",
  },
  {
    code: "31-859",
    city: "Kraków",
  },
  {
    code: "31-860",
    city: "Kraków",
  },
  {
    code: "31-861",
    city: "Kraków",
  },
  {
    code: "31-862",
    city: "Kraków",
  },
  {
    code: "31-863",
    city: "Kraków",
  },
  {
    code: "31-864",
    city: "Kraków",
  },
  {
    code: "31-865",
    city: "Kraków",
  },
  {
    code: "31-866",
    city: "Kraków",
  },
  {
    code: "31-867",
    city: "Kraków",
  },
  {
    code: "31-868",
    city: "Kraków",
  },
  {
    code: "31-869",
    city: "Kraków",
  },
  {
    code: "31-870",
    city: "Kraków",
  },
  {
    code: "31-871",
    city: "Kraków",
  },
  {
    code: "31-872",
    city: "Kraków",
  },
  {
    code: "31-873",
    city: "Kraków",
  },
  {
    code: "31-874",
    city: "Kraków",
  },
  {
    code: "31-875",
    city: "Kraków",
  },
  {
    code: "31-880",
    city: "Kraków",
  },
  {
    code: "31-881",
    city: "Kraków",
  },
  {
    code: "31-901",
    city: "Kraków",
  },
  {
    code: "31-902",
    city: "Kraków",
  },
  {
    code: "31-903",
    city: "Kraków",
  },
  {
    code: "31-905",
    city: "Kraków",
  },
  {
    code: "31-906",
    city: "Kraków",
  },
  {
    code: "31-907",
    city: "Kraków",
  },
  {
    code: "31-908",
    city: "Kraków",
  },
  {
    code: "31-909",
    city: "Kraków",
  },
  {
    code: "31-910",
    city: "Kraków",
  },
  {
    code: "31-911",
    city: "Kraków",
  },
  {
    code: "31-912",
    city: "Kraków",
  },
  {
    code: "31-913",
    city: "Kraków",
  },
  {
    code: "31-914",
    city: "Kraków",
  },
  {
    code: "31-915",
    city: "Kraków",
  },
  {
    code: "31-916",
    city: "Kraków",
  },
  {
    code: "31-917",
    city: "Kraków",
  },
  {
    code: "31-918",
    city: "Kraków",
  },
  {
    code: "31-919",
    city: "Kraków",
  },
  {
    code: "31-920",
    city: "Kraków",
  },
  {
    code: "31-921",
    city: "Kraków",
  },
  {
    code: "31-922",
    city: "Kraków",
  },
  {
    code: "31-923",
    city: "Kraków",
  },
  {
    code: "31-924",
    city: "Kraków",
  },
  {
    code: "31-925",
    city: "Kraków",
  },
  {
    code: "31-926",
    city: "Kraków",
  },
  {
    code: "31-927",
    city: "Kraków",
  },
  {
    code: "31-928",
    city: "Kraków",
  },
  {
    code: "31-929",
    city: "Kraków",
  },
  {
    code: "31-930",
    city: "Kraków",
  },
  {
    code: "31-931",
    city: "Kraków",
  },
  {
    code: "31-932",
    city: "Kraków",
  },
  {
    code: "31-933",
    city: "Kraków",
  },
  {
    code: "31-934",
    city: "Kraków",
  },
  {
    code: "31-935",
    city: "Kraków",
  },
  {
    code: "31-936",
    city: "Kraków",
  },
  {
    code: "31-937",
    city: "Kraków",
  },
  {
    code: "31-938",
    city: "Kraków",
  },
  {
    code: "31-939",
    city: "Kraków",
  },
  {
    code: "31-940",
    city: "Kraków",
  },
  {
    code: "31-941",
    city: "Kraków",
  },
  {
    code: "31-942",
    city: "Kraków",
  },
  {
    code: "31-943",
    city: "Kraków",
  },
  {
    code: "31-944",
    city: "Kraków",
  },
  {
    code: "31-945",
    city: "Kraków",
  },
  {
    code: "31-946",
    city: "Kraków",
  },
  {
    code: "31-947",
    city: "Kraków",
  },
  {
    code: "31-948",
    city: "Kraków",
  },
  {
    code: "31-949",
    city: "Kraków",
  },
  {
    code: "31-950",
    city: "Kraków",
  },
  {
    code: "31-951",
    city: "Kraków",
  },
  {
    code: "31-952",
    city: "Kraków",
  },
  {
    code: "31-953",
    city: "Kraków",
  },
  {
    code: "31-954",
    city: "Kraków",
  },
  {
    code: "31-955",
    city: "Kraków",
  },
  {
    code: "31-956",
    city: "Kraków",
  },
  {
    code: "31-957",
    city: "Kraków",
  },
  {
    code: "31-958",
    city: "Kraków",
  },
  {
    code: "31-959",
    city: "Kraków",
  },
  {
    code: "31-960",
    city: "Kraków",
  },
  {
    code: "31-961",
    city: "Kraków",
  },
  {
    code: "31-962",
    city: "Kraków",
  },
  {
    code: "31-963",
    city: "Kraków",
  },
  {
    code: "31-964",
    city: "Kraków",
  },
  {
    code: "31-965",
    city: "Kraków",
  },
  {
    code: "31-966",
    city: "Kraków",
  },
  {
    code: "31-967",
    city: "Kraków",
  },
  {
    code: "31-968",
    city: "Kraków",
  },
  {
    code: "31-969",
    city: "Kraków",
  },
  {
    code: "31-970",
    city: "Kraków",
  },
  {
    code: "31-971",
    city: "Kraków",
  },
  {
    code: "31-972",
    city: "Kraków",
  },
  {
    code: "31-974",
    city: "Kraków",
  },
  {
    code: "31-975",
    city: "Kraków",
  },
  {
    code: "31-976",
    city: "Kraków",
  },
  {
    code: "31-977",
    city: "Kraków",
  },
  {
    code: "31-978",
    city: "Kraków",
  },
  {
    code: "31-979",
    city: "Kraków",
  },
  {
    code: "31-980",
    city: "Kraków",
  },
  {
    code: "31-982",
    city: "Kraków",
  },
  {
    code: "31-983",
    city: "Kraków",
  },
  {
    code: "31-985",
    city: "Kraków",
  },
  {
    code: "31-987",
    city: "Kraków",
  },
  {
    code: "31-988",
    city: "Kraków",
  },
  {
    code: "31-989",
    city: "Kraków",
  },
  {
    code: "31-990",
    city: "Kraków",
  },
  {
    code: "31-992",
    city: "Kraków",
  },
  {
    code: "31-997",
    city: "Kraków",
  },
  {
    code: "31-998",
    city: "Kraków",
  },
  {
    code: "31-999",
    city: "Kraków",
  },
  {
    code: "32-002",
    city: "Węgrzce Wielkie",
  },
  {
    code: "32-003",
    city: "Podłęże",
  },
  {
    code: "32-005",
    city: "Niepołomice",
  },
  {
    code: "32-007",
    city: "Zabierzów Bocheński",
  },
  {
    code: "32-010",
    city: "Luborzyca",
  },
  {
    code: "32-013",
    city: "Niegowić",
  },
  {
    code: "32-014",
    city: "Brzezie",
  },
  {
    code: "32-015",
    city: "Kłaj",
  },
  {
    code: "32-020",
    city: "Wieliczka",
  },
  {
    code: "32-031",
    city: "Mogilany",
  },
  {
    code: "32-040",
    city: "Świątniki Górne",
  },
  {
    code: "32-043",
    city: "Skała",
  },
  {
    code: "32-045",
    city: "Sułoszowa",
  },
  {
    code: "32-046",
    city: "Minoga",
  },
  {
    code: "32-047",
    city: "Ojców",
  },
  {
    code: "32-048",
    city: "Jerzmanowice",
  },
  {
    code: "32-049",
    city: "Przeginia",
  },
  {
    code: "32-050",
    city: "Skawina",
  },
  {
    code: "32-051",
    city: "Wielkie Drogi",
  },
  {
    code: "32-052",
    city: "Radziszów",
  },
  {
    code: "32-053",
    city: "Wola Radziszowska",
  },
  {
    code: "32-060",
    city: "Liszki",
  },
  {
    code: "32-061",
    city: "Rybna",
  },
  {
    code: "32-064",
    city: "Rudawa",
  },
  {
    code: "32-065",
    city: "Krzeszowice",
  },
  {
    code: "32-067",
    city: "Tenczynek",
  },
  {
    code: "32-070",
    city: "Czernichów",
  },
  {
    code: "32-071",
    city: "Kamień",
  },
  {
    code: "32-075",
    city: "Gołcza",
  },
  {
    code: "32-077",
    city: "Smardzowice",
  },
  {
    code: "32-080",
    city: "Zabierzów",
  },
  {
    code: "32-082",
    city: "Bolechowice",
  },
  {
    code: "32-083",
    city: "Balice",
  },
  {
    code: "32-084",
    city: "Morawica",
  },
  {
    code: "32-085",
    city: "Modlnica",
  },
  {
    code: "32-086",
    city: "Węgrzce",
  },
  {
    code: "32-087",
    city: "Zielonki",
  },
  {
    code: "32-088",
    city: "Przybysławice",
  },
  {
    code: "32-089",
    city: "Wielka Wieś",
  },
  {
    code: "32-090",
    city: "Słomniki",
  },
  {
    code: "32-091",
    city: "Michałowice-Osiedle",
  },
  {
    code: "32-095",
    city: "Iwanowice Włościańskie",
  },
  {
    code: "32-100",
    city: "Proszowice",
  },
  {
    code: "32-104",
    city: "Koniusza",
  },
  {
    code: "32-107",
    city: "Radziemice",
  },
  {
    code: "32-109",
    city: "Pałecznica",
  },
  {
    code: "32-112",
    city: "Klimontów",
  },
  {
    code: "32-120",
    city: "Nowe Brzesko",
  },
  {
    code: "32-125",
    city: "Wawrzeńczyce",
  },
  {
    code: "32-126",
    city: "Igołomia",
  },
  {
    code: "32-130",
    city: "Koszyce",
  },
  {
    code: "32-200",
    city: "Miechów",
  },
  {
    code: "32-210",
    city: "Książ Wielki",
  },
  {
    code: "32-218",
    city: "Słaboszów",
  },
  {
    code: "32-222",
    city: "Racławice",
  },
  {
    code: "32-241",
    city: "Kozłów",
  },
  {
    code: "32-250",
    city: "Charsznica",
  },
  {
    code: "32-300",
    city: "Olkusz",
  },
  {
    code: "32-305",
    city: "Olkusz",
  },
  {
    code: "32-310",
    city: "Klucze",
  },
  {
    code: "32-312",
    city: "Jaroszowiec",
  },
  {
    code: "32-327",
    city: "Gorenice",
  },
  {
    code: "32-329",
    city: "Bolesław",
  },
  {
    code: "32-332",
    city: "Bukowno",
  },
  {
    code: "32-340",
    city: "Wolbrom",
  },
  {
    code: "32-353",
    city: "Trzyciąż",
  },
  {
    code: "32-400",
    city: "Myślenice",
  },
  {
    code: "32-406",
    city: "Zakliczyn",
  },
  {
    code: "32-410",
    city: "Dobczyce",
  },
  {
    code: "32-412",
    city: "Wiśniowa",
  },
  {
    code: "32-413",
    city: "Zegartowice",
  },
  {
    code: "32-414",
    city: "Gruszów",
  },
  {
    code: "32-415",
    city: "Raciechowice",
  },
  {
    code: "32-420",
    city: "Gdów",
  },
  {
    code: "32-422",
    city: "Stadniki",
  },
  {
    code: "32-425",
    city: "Trzemeśnia",
  },
  {
    code: "32-431",
    city: "Stróża",
  },
  {
    code: "32-432",
    city: "Pcim",
  },
  {
    code: "32-433",
    city: "Lubień",
  },
  {
    code: "32-434",
    city: "Skomielna Biała",
  },
  {
    code: "32-435",
    city: "Krzczonów",
  },
  {
    code: "32-436",
    city: "Tokarnia",
  },
  {
    code: "32-437",
    city: "Skomielna Czarna",
  },
  {
    code: "32-438",
    city: "Trzebunia",
  },
  {
    code: "32-440",
    city: "Sułkowice",
  },
  {
    code: "32-442",
    city: "Krzywaczka",
  },
  {
    code: "32-444",
    city: "Głogoczów",
  },
  {
    code: "32-445",
    city: "Krzyszkowice",
  },
  {
    code: "32-447",
    city: "Siepraw",
  },
  {
    code: "32-500",
    city: "Chrzanów",
  },
  {
    code: "32-501",
    city: "Chrzanów",
  },
  {
    code: "32-502",
    city: "Chrzanów",
  },
  {
    code: "32-503",
    city: "Chrzanów",
  },
  {
    code: "32-530",
    city: "Trzebinia",
  },
  {
    code: "32-540",
    city: "Trzebinia",
  },
  {
    code: "32-541",
    city: "Trzebinia",
  },
  {
    code: "32-543",
    city: "Myślachowice",
  },
  {
    code: "32-545",
    city: "Karniowice",
  },
  {
    code: "32-546",
    city: "Młoszowa",
  },
  {
    code: "32-551",
    city: "Babice",
  },
  {
    code: "32-552",
    city: "Płaza",
  },
  {
    code: "32-566",
    city: "Alwernia",
  },
  {
    code: "32-590",
    city: "Libiąż",
  },
  {
    code: "32-593",
    city: "Libiąż",
  },
  {
    code: "32-600",
    city: "Oświęcim",
  },
  {
    code: "32-601",
    city: "Oświęcim",
  },
  {
    code: "32-602",
    city: "Oświęcim",
  },
  {
    code: "32-603",
    city: "Oświęcim",
  },
  {
    code: "32-606",
    city: "Oświęcim",
  },
  {
    code: "32-607",
    city: "Polanka Wielka",
  },
  {
    code: "32-608",
    city: "Osiek",
  },
  {
    code: "32-610",
    city: "Oświęcim",
  },
  {
    code: "32-615",
    city: "Grojec",
  },
  {
    code: "32-620",
    city: "Brzeszcze",
  },
  {
    code: "32-621",
    city: "Brzeszcze",
  },
  {
    code: "32-622",
    city: "Brzeszcze",
  },
  {
    code: "32-625",
    city: "Przecieszyn",
  },
  {
    code: "32-626",
    city: "Jawiszowice",
  },
  {
    code: "32-640",
    city: "Zator",
  },
  {
    code: "32-641",
    city: "Przeciszów",
  },
  {
    code: "32-642",
    city: "Włosienica",
  },
  {
    code: "32-650",
    city: "Kęty",
  },
  {
    code: "32-651",
    city: "Nowa Wieś",
  },
  {
    code: "32-652",
    city: "Bulowice",
  },
  {
    code: "32-653",
    city: "Kęty",
  },
  {
    code: "32-660",
    city: "Chełmek",
  },
  {
    code: "32-661",
    city: "Bobrek",
  },
  {
    code: "32-700",
    city: "Bochnia",
  },
  {
    code: "32-701",
    city: "Bochnia",
  },
  {
    code: "32-708",
    city: "Dziewin",
  },
  {
    code: "32-709",
    city: "Drwinia",
  },
  {
    code: "32-711",
    city: "Bogucice",
  },
  {
    code: "32-712",
    city: "Bratucice",
  },
  {
    code: "32-720",
    city: "Nowy Wiśnicz",
  },
  {
    code: "32-722",
    city: "Królówka",
  },
  {
    code: "32-724",
    city: "Lipnica Murowana",
  },
  {
    code: "32-725",
    city: "Rajbrot",
  },
  {
    code: "32-731",
    city: "Żegocina",
  },
  {
    code: "32-732",
    city: "Kamionna",
  },
  {
    code: "32-733",
    city: "Trzciana",
  },
  {
    code: "32-740",
    city: "Łapanów",
  },
  {
    code: "32-741",
    city: "Tarnawa",
  },
  {
    code: "32-742",
    city: "Sobolów",
  },
  {
    code: "32-744",
    city: "Łapczyca",
  },
  {
    code: "32-765",
    city: "Rzezawa",
  },
  {
    code: "32-800",
    city: "Brzesko",
  },
  {
    code: "32-810",
    city: "Brzesko",
  },
  {
    code: "32-813",
    city: "Uście Solne",
  },
  {
    code: "32-820",
    city: "Szczurowa",
  },
  {
    code: "32-821",
    city: "Zaborów",
  },
  {
    code: "32-822",
    city: "Strzelce Wielkie",
  },
  {
    code: "32-823",
    city: "Szczepanów",
  },
  {
    code: "32-824",
    city: "Bielcza",
  },
  {
    code: "32-825",
    city: "Borzęcin",
  },
  {
    code: "32-828",
    city: "Biadoliny Szlacheckie",
  },
  {
    code: "32-830",
    city: "Wojnicz",
  },
  {
    code: "32-831",
    city: "Olszyny",
  },
  {
    code: "32-840",
    city: "Zakliczyn",
  },
  {
    code: "32-842",
    city: "Paleśnica",
  },
  {
    code: "32-851",
    city: "Jadowniki",
  },
  {
    code: "32-852",
    city: "Dębno",
  },
  {
    code: "32-853",
    city: "Łysa Góra",
  },
  {
    code: "32-854",
    city: "Porąbka Uszewska",
  },
  {
    code: "32-859",
    city: "Złota",
  },
  {
    code: "32-860",
    city: "Czchów",
  },
  {
    code: "32-861",
    city: "Iwkowa",
  },
  {
    code: "32-862",
    city: "Porąbka Iwkowska",
  },
  {
    code: "32-863",
    city: "Tymowa",
  },
  {
    code: "32-864",
    city: "Gnojnik",
  },
  {
    code: "32-865",
    city: "Uszew",
  },
  {
    code: "33-100",
    city: "Tarnów",
  },
  {
    code: "33-101",
    city: "Tarnów",
  },
  {
    code: "33-102",
    city: "Tarnów",
  },
  {
    code: "33-103",
    city: "Tarnów",
  },
  {
    code: "33-104",
    city: "Tarnów",
  },
  {
    code: "33-105",
    city: "Tarnów",
  },
  {
    code: "33-106",
    city: "Tarnów",
  },
  {
    code: "33-110",
    city: "Tarnów",
  },
  {
    code: "33-111",
    city: "Koszyce Wielkie",
  },
  {
    code: "33-112",
    city: "Tarnowiec",
  },
  {
    code: "33-113",
    city: "Zgłobice",
  },
  {
    code: "33-114",
    city: "Rzuchowa",
  },
  {
    code: "33-115",
    city: "Janowice",
  },
  {
    code: "33-121",
    city: "Bogumiłowice",
  },
  {
    code: "33-122",
    city: "Wierzchosławice",
  },
  {
    code: "33-130",
    city: "Radłów",
  },
  {
    code: "33-131",
    city: "Łęg Tarnowski",
  },
  {
    code: "33-132",
    city: "Niedomice",
  },
  {
    code: "33-133",
    city: "Wał-Ruda",
  },
  {
    code: "33-140",
    city: "Lisia Góra",
  },
  {
    code: "33-150",
    city: "Wola Rzędzińska",
  },
  {
    code: "33-151",
    city: "Nowa Jastrząbka",
  },
  {
    code: "33-152",
    city: "Pogórska Wola",
  },
  {
    code: "33-156",
    city: "Skrzyszów",
  },
  {
    code: "33-158",
    city: "Szynwałd",
  },
  {
    code: "33-159",
    city: "Zalasowa",
  },
  {
    code: "33-160",
    city: "Ryglice",
  },
  {
    code: "33-161",
    city: "Kowalowa",
  },
  {
    code: "33-162",
    city: "Lubcza",
  },
  {
    code: "33-163",
    city: "Rzepiennik Strzyżewski",
  },
  {
    code: "33-164",
    city: "Olszyny",
  },
  {
    code: "33-167",
    city: "Turza",
  },
  {
    code: "33-170",
    city: "Tuchów",
  },
  {
    code: "33-171",
    city: "Pleśna",
  },
  {
    code: "33-172",
    city: "Siedliska",
  },
  {
    code: "33-173",
    city: "Jodłówka Tuchowska",
  },
  {
    code: "33-180",
    city: "Gromnik",
  },
  {
    code: "33-181",
    city: "Siemiechów",
  },
  {
    code: "33-182",
    city: "Brzozowa",
  },
  {
    code: "33-190",
    city: "Ciężkowice",
  },
  {
    code: "33-191",
    city: "Jastrzębia",
  },
  {
    code: "33-192",
    city: "Bruśnik",
  },
  {
    code: "33-200",
    city: "Dąbrowa Tarnowska",
  },
  {
    code: "33-202",
    city: "Smęgorzów",
  },
  {
    code: "33-203",
    city: "Borki",
  },
  {
    code: "33-205",
    city: "Nieczajna Dolna",
  },
  {
    code: "33-206",
    city: "Luszowice",
  },
  {
    code: "33-207",
    city: "Radgoszcz",
  },
  {
    code: "33-210",
    city: "Olesno",
  },
  {
    code: "33-220",
    city: "Bolesław",
  },
  {
    code: "33-221",
    city: "Mędrzechów",
  },
  {
    code: "33-230",
    city: "Szczucin",
  },
  {
    code: "33-240",
    city: "Żabno",
  },
  {
    code: "33-250",
    city: "Otfinów",
  },
  {
    code: "33-260",
    city: "Gręboszów",
  },
  {
    code: "33-263",
    city: "Zalipie",
  },
  {
    code: "33-264",
    city: "Ćwików",
  },
  {
    code: "33-270",
    city: "Wietrzychowice",
  },
  {
    code: "33-271",
    city: "Jadowniki Mokre",
  },
  {
    code: "33-273",
    city: "Marcinkowice",
  },
  {
    code: "33-300",
    city: "Nowy Sącz",
  },
  {
    code: "33-302",
    city: "Nowy Sącz",
  },
  {
    code: "33-303",
    city: "Nowy Sącz",
  },
  {
    code: "33-304",
    city: "Nowy Sącz",
  },
  {
    code: "33-305",
    city: "Nowy Sącz",
  },
  {
    code: "33-306",
    city: "Nowy Sącz",
  },
  {
    code: "33-310",
    city: "Nowy Sącz",
  },
  {
    code: "33-311",
    city: "Wielogłowy",
  },
  {
    code: "33-312",
    city: "Tęgoborze",
  },
  {
    code: "33-314",
    city: "Łososina Dolna",
  },
  {
    code: "33-316",
    city: "Rożnów",
  },
  {
    code: "33-318",
    city: "Gródek nad Dunajcem",
  },
  {
    code: "33-320",
    city: "Nowy Sącz",
  },
  {
    code: "33-321",
    city: "Siedlce",
  },
  {
    code: "33-322",
    city: "Korzenna",
  },
  {
    code: "33-323",
    city: "Lipnica Wielka",
  },
  {
    code: "33-325",
    city: "Krużlowa Wyżna",
  },
  {
    code: "33-326",
    city: "Mogilno",
  },
  {
    code: "33-330",
    city: "Grybów",
  },
  {
    code: "33-331",
    city: "Stróże",
  },
  {
    code: "33-332",
    city: "Florynka",
  },
  {
    code: "33-333",
    city: "Ptaszkowa",
  },
  {
    code: "33-334",
    city: "Kamionka Wielka",
  },
  {
    code: "33-335",
    city: "Nawojowa",
  },
  {
    code: "33-336",
    city: "Łabowa",
  },
  {
    code: "33-340",
    city: "Stary Sącz",
  },
  {
    code: "33-342",
    city: "Barcice Górne",
  },
  {
    code: "33-343",
    city: "Rytro",
  },
  {
    code: "33-350",
    city: "Piwniczna-Zdrój",
  },
  {
    code: "33-351",
    city: "Łomnica-Zdrój",
  },
  {
    code: "33-360",
    city: "Żegiestów",
  },
  {
    code: "33-370",
    city: "Muszyna",
  },
  {
    code: "33-380",
    city: "Krynica-Zdrój",
  },
  {
    code: "33-383",
    city: "Tylicz",
  },
  {
    code: "33-386",
    city: "Podegrodzie",
  },
  {
    code: "33-388",
    city: "Gołkowice Dolne",
  },
  {
    code: "33-389",
    city: "Jazowsko",
  },
  {
    code: "33-390",
    city: "Łącko",
  },
  {
    code: "33-393",
    city: "Marcinkowice",
  },
  {
    code: "33-394",
    city: "Klęczany",
  },
  {
    code: "33-395",
    city: "Chełmiec",
  },
  {
    code: "34-100",
    city: "Wadowice",
  },
  {
    code: "34-103",
    city: "Witanowice",
  },
  {
    code: "34-104",
    city: "Wadowice",
  },
  {
    code: "34-105",
    city: "Wysoka",
  },
  {
    code: "34-106",
    city: "Mucharz",
  },
  {
    code: "34-108",
    city: "Frydrychowice",
  },
  {
    code: "34-113",
    city: "Paszkówka",
  },
  {
    code: "34-114",
    city: "Brzeźnica",
  },
  {
    code: "34-115",
    city: "Ryczów",
  },
  {
    code: "34-116",
    city: "Spytkowice",
  },
  {
    code: "34-120",
    city: "Andrychów",
  },
  {
    code: "34-122",
    city: "Wieprz",
  },
  {
    code: "34-123",
    city: "Chocznia",
  },
  {
    code: "34-124",
    city: "Klecza Górna",
  },
  {
    code: "34-125",
    city: "Sułkowice",
  },
  {
    code: "34-130",
    city: "Kalwaria Zebrzydowska",
  },
  {
    code: "34-141",
    city: "Przytkowice",
  },
  {
    code: "34-142",
    city: "Leńcze",
  },
  {
    code: "34-143",
    city: "Lanckorona",
  },
  {
    code: "34-144",
    city: "Izdebnik",
  },
  {
    code: "34-145",
    city: "Stronie",
  },
  {
    code: "34-146",
    city: "Stryszów",
  },
  {
    code: "34-200",
    city: "Sucha Beskidzka",
  },
  {
    code: "34-205",
    city: "Stryszawa",
  },
  {
    code: "34-206",
    city: "Krzeszów",
  },
  {
    code: "34-210",
    city: "Zembrzyce",
  },
  {
    code: "34-211",
    city: "Budzów",
  },
  {
    code: "34-212",
    city: "Bieńkówka",
  },
  {
    code: "34-220",
    city: "Maków Podhalański",
  },
  {
    code: "34-221",
    city: "Skawica",
  },
  {
    code: "34-222",
    city: "Zawoja",
  },
  {
    code: "34-231",
    city: "Juszczyn",
  },
  {
    code: "34-232",
    city: "Lachowice",
  },
  {
    code: "34-233",
    city: "Hucisko",
  },
  {
    code: "34-234",
    city: "Osielec",
  },
  {
    code: "34-235",
    city: "Bystra",
  },
  {
    code: "34-236",
    city: "Sidzina",
  },
  {
    code: "34-240",
    city: "Jordanów",
  },
  {
    code: "34-242",
    city: "Łętownia",
  },
  {
    code: "34-300",
    city: "Żywiec",
  },
  {
    code: "34-310",
    city: "Żywiec",
  },
  {
    code: "34-311",
    city: "Czernichów",
  },
  {
    code: "34-312",
    city: "Międzybrodzie Bialskie",
  },
  {
    code: "34-321",
    city: "Łękawica",
  },
  {
    code: "34-322",
    city: "Gilowice",
  },
  {
    code: "34-323",
    city: "Ślemień",
  },
  {
    code: "34-324",
    city: "Lipowa",
  },
  {
    code: "34-325",
    city: "Łodygowice",
  },
  {
    code: "34-326",
    city: "Pietrzykowice",
  },
  {
    code: "34-330",
    city: "Żywiec",
  },
  {
    code: "34-331",
    city: "Świnna",
  },
  {
    code: "34-332",
    city: "Koszarawa",
  },
  {
    code: "34-335",
    city: "Krzyżowa",
  },
  {
    code: "34-340",
    city: "Jeleśnia",
  },
  {
    code: "34-350",
    city: "Węgierska Górka",
  },
  {
    code: "34-360",
    city: "Milówka",
  },
  {
    code: "34-370",
    city: "Rajcza",
  },
  {
    code: "34-371",
    city: "Ujsoły",
  },
  {
    code: "34-373",
    city: "Zwardoń",
  },
  {
    code: "34-381",
    city: "Radziechowy",
  },
  {
    code: "34-382",
    city: "Bystra",
  },
  {
    code: "34-383",
    city: "Kamesznica",
  },
  {
    code: "34-400",
    city: "Nowy Targ",
  },
  {
    code: "34-401",
    city: "Nowy Targ",
  },
  {
    code: "34-402",
    city: "Nowy Targ",
  },
  {
    code: "34-403",
    city: "Nowy Targ",
  },
  {
    code: "34-404",
    city: "Klikuszowa",
  },
  {
    code: "34-405",
    city: "Białka Tatrzańska",
  },
  {
    code: "34-406",
    city: "Leśnica",
  },
  {
    code: "34-407",
    city: "Ciche",
  },
  {
    code: "34-408",
    city: "Odrowąż",
  },
  {
    code: "34-424",
    city: "Szaflary",
  },
  {
    code: "34-425",
    city: "Biały Dunajec",
  },
  {
    code: "34-431",
    city: "Waksmund",
  },
  {
    code: "34-432",
    city: "Łopuszna",
  },
  {
    code: "34-433",
    city: "Nowa Biała",
  },
  {
    code: "34-434",
    city: "Dębno",
  },
  {
    code: "34-435",
    city: "Frydman",
  },
  {
    code: "34-436",
    city: "Maniowy",
  },
  {
    code: "34-440",
    city: "Kluszkowce",
  },
  {
    code: "34-441",
    city: "Niedzica",
  },
  {
    code: "34-442",
    city: "Łapsze Niżne",
  },
  {
    code: "34-443",
    city: "Sromowce Wyżne",
  },
  {
    code: "34-450",
    city: "Krościenko nad Dunajcem",
  },
  {
    code: "34-451",
    city: "Tylmanowa",
  },
  {
    code: "34-452",
    city: "Ochotnica Dolna",
  },
  {
    code: "34-453",
    city: "Ochotnica Górna",
  },
  {
    code: "34-460",
    city: "Szczawnica",
  },
  {
    code: "34-470",
    city: "Czarny Dunajec",
  },
  {
    code: "34-471",
    city: "Ludźmierz",
  },
  {
    code: "34-472",
    city: "Piekielnik",
  },
  {
    code: "34-480",
    city: "Jabłonka",
  },
  {
    code: "34-481",
    city: "Chyżne",
  },
  {
    code: "34-482",
    city: "Lipnica Mała",
  },
  {
    code: "34-483",
    city: "Lipnica Wielka",
  },
  {
    code: "34-484",
    city: "Zubrzyca Górna",
  },
  {
    code: "34-500",
    city: "Zakopane",
  },
  {
    code: "34-501",
    city: "Zakopane",
  },
  {
    code: "34-502",
    city: "Zakopane",
  },
  {
    code: "34-503",
    city: "Zakopane",
  },
  {
    code: "34-505",
    city: "Zakopane",
  },
  {
    code: "34-511",
    city: "Kościelisko",
  },
  {
    code: "34-512",
    city: "Witów",
  },
  {
    code: "34-513",
    city: "Chochołów",
  },
  {
    code: "34-514",
    city: "Dzianisz",
  },
  {
    code: "34-520",
    city: "Poronin",
  },
  {
    code: "34-521",
    city: "Ząb",
  },
  {
    code: "34-530",
    city: "Bukowina Tatrzańska",
  },
  {
    code: "34-531",
    city: "Murzasichle",
  },
  {
    code: "34-532",
    city: "Jurgów",
  },
  {
    code: "34-600",
    city: "Limanowa",
  },
  {
    code: "34-601",
    city: "Limanowa",
  },
  {
    code: "34-602",
    city: "Laskowa",
  },
  {
    code: "34-603",
    city: "Ujanowice",
  },
  {
    code: "34-604",
    city: "Przyszowa",
  },
  {
    code: "34-606",
    city: "Łukowica",
  },
  {
    code: "34-607",
    city: "Szczawa",
  },
  {
    code: "34-608",
    city: "Kamienica",
  },
  {
    code: "34-615",
    city: "Słopnice",
  },
  {
    code: "34-617",
    city: "Wilkowisko",
  },
  {
    code: "34-620",
    city: "Jodłownik",
  },
  {
    code: "34-623",
    city: "Szczyrzyc",
  },
  {
    code: "34-625",
    city: "Skrzydlna",
  },
  {
    code: "34-642",
    city: "Dobra",
  },
  {
    code: "34-643",
    city: "Jurków",
  },
  {
    code: "34-650",
    city: "Tymbark",
  },
  {
    code: "34-651",
    city: "Limanowa",
  },
  {
    code: "34-652",
    city: "Nowe Rybie",
  },
  {
    code: "34-654",
    city: "Męcina",
  },
  {
    code: "34-700",
    city: "Rabka-Zdrój",
  },
  {
    code: "34-713",
    city: "Skawa",
  },
  {
    code: "34-720",
    city: "Chabówka",
  },
  {
    code: "34-721",
    city: "Raba Wyżna",
  },
  {
    code: "34-722",
    city: "Podwilk",
  },
  {
    code: "34-723",
    city: "Sieniawa",
  },
  {
    code: "34-730",
    city: "Mszana Dolna",
  },
  {
    code: "34-732",
    city: "Olszówka",
  },
  {
    code: "34-733",
    city: "Mszana Górna",
  },
  {
    code: "34-734",
    city: "Kasinka Mała",
  },
  {
    code: "34-735",
    city: "Niedźwiedź",
  },
  {
    code: "34-736",
    city: "Lubomierz",
  },
  {
    code: "34-741",
    city: "Kasina Wielka",
  },
  {
    code: "34-745",
    city: "Spytkowice",
  },
  {
    code: "35-001",
    city: "Rzeszów",
  },
  {
    code: "35-002",
    city: "Rzeszów",
  },
  {
    code: "35-005",
    city: "Rzeszów",
  },
  {
    code: "35-006",
    city: "Rzeszów",
  },
  {
    code: "35-010",
    city: "Rzeszów",
  },
  {
    code: "35-011",
    city: "Rzeszów",
  },
  {
    code: "35-015",
    city: "Rzeszów",
  },
  {
    code: "35-016",
    city: "Rzeszów",
  },
  {
    code: "35-017",
    city: "Rzeszów",
  },
  {
    code: "35-020",
    city: "Rzeszów",
  },
  {
    code: "35-021",
    city: "Rzeszów",
  },
  {
    code: "35-025",
    city: "Rzeszów",
  },
  {
    code: "35-026",
    city: "Rzeszów",
  },
  {
    code: "35-030",
    city: "Rzeszów",
  },
  {
    code: "35-031",
    city: "Rzeszów",
  },
  {
    code: "35-032",
    city: "Rzeszów",
  },
  {
    code: "35-033",
    city: "Rzeszów",
  },
  {
    code: "35-036",
    city: "Rzeszów",
  },
  {
    code: "35-037",
    city: "Rzeszów",
  },
  {
    code: "35-038",
    city: "Rzeszów",
  },
  {
    code: "35-040",
    city: "Rzeszów",
  },
  {
    code: "35-042",
    city: "Rzeszów",
  },
  {
    code: "35-045",
    city: "Rzeszów",
  },
  {
    code: "35-046",
    city: "Rzeszów",
  },
  {
    code: "35-047",
    city: "Rzeszów",
  },
  {
    code: "35-050",
    city: "Rzeszów",
  },
  {
    code: "35-051",
    city: "Rzeszów",
  },
  {
    code: "35-055",
    city: "Rzeszów",
  },
  {
    code: "35-056",
    city: "Rzeszów",
  },
  {
    code: "35-060",
    city: "Rzeszów",
  },
  {
    code: "35-061",
    city: "Rzeszów",
  },
  {
    code: "35-064",
    city: "Rzeszów",
  },
  {
    code: "35-065",
    city: "Rzeszów",
  },
  {
    code: "35-068",
    city: "Rzeszów",
  },
  {
    code: "35-069",
    city: "Rzeszów",
  },
  {
    code: "35-070",
    city: "Rzeszów",
  },
  {
    code: "35-073",
    city: "Rzeszów",
  },
  {
    code: "35-074",
    city: "Rzeszów",
  },
  {
    code: "35-075",
    city: "Rzeszów",
  },
  {
    code: "35-077",
    city: "Rzeszów",
  },
  {
    code: "35-078",
    city: "Rzeszów",
  },
  {
    code: "35-079",
    city: "Rzeszów",
  },
  {
    code: "35-080",
    city: "Rzeszów",
  },
  {
    code: "35-082",
    city: "Rzeszów",
  },
  {
    code: "35-083",
    city: "Rzeszów",
  },
  {
    code: "35-084",
    city: "Rzeszów",
  },
  {
    code: "35-086",
    city: "Rzeszów",
  },
  {
    code: "35-100",
    city: "Rzeszów",
  },
  {
    code: "35-101",
    city: "Rzeszów",
  },
  {
    code: "35-102",
    city: "Rzeszów",
  },
  {
    code: "35-103",
    city: "Rzeszów",
  },
  {
    code: "35-104",
    city: "Rzeszów",
  },
  {
    code: "35-105",
    city: "Rzeszów",
  },
  {
    code: "35-107",
    city: "Rzeszów",
  },
  {
    code: "35-111",
    city: "Rzeszów",
  },
  {
    code: "35-112",
    city: "Rzeszów",
  },
  {
    code: "35-113",
    city: "Rzeszów",
  },
  {
    code: "35-114",
    city: "Rzeszów",
  },
  {
    code: "35-115",
    city: "Rzeszów",
  },
  {
    code: "35-116",
    city: "Rzeszów",
  },
  {
    code: "35-117",
    city: "Rzeszów",
  },
  {
    code: "35-118",
    city: "Rzeszów",
  },
  {
    code: "35-119",
    city: "Rzeszów",
  },
  {
    code: "35-120",
    city: "Rzeszów",
  },
  {
    code: "35-122",
    city: "Rzeszów",
  },
  {
    code: "35-123",
    city: "Rzeszów",
  },
  {
    code: "35-124",
    city: "Rzeszów",
  },
  {
    code: "35-125",
    city: "Rzeszów",
  },
  {
    code: "35-201",
    city: "Rzeszów",
  },
  {
    code: "35-202",
    city: "Rzeszów",
  },
  {
    code: "35-203",
    city: "Rzeszów",
  },
  {
    code: "35-205",
    city: "Rzeszów",
  },
  {
    code: "35-206",
    city: "Rzeszów",
  },
  {
    code: "35-207",
    city: "Rzeszów",
  },
  {
    code: "35-208",
    city: "Rzeszów",
  },
  {
    code: "35-209",
    city: "Rzeszów",
  },
  {
    code: "35-210",
    city: "Rzeszów",
  },
  {
    code: "35-211",
    city: "Rzeszów",
  },
  {
    code: "35-213",
    city: "Rzeszów",
  },
  {
    code: "35-215",
    city: "Rzeszów",
  },
  {
    code: "35-216",
    city: "Rzeszów",
  },
  {
    code: "35-222",
    city: "Rzeszów",
  },
  {
    code: "35-223",
    city: "Rzeszów",
  },
  {
    code: "35-224",
    city: "Rzeszów",
  },
  {
    code: "35-225",
    city: "Rzeszów",
  },
  {
    code: "35-230",
    city: "Rzeszów",
  },
  {
    code: "35-231",
    city: "Rzeszów",
  },
  {
    code: "35-232",
    city: "Rzeszów",
  },
  {
    code: "35-233",
    city: "Rzeszów",
  },
  {
    code: "35-234",
    city: "Rzeszów",
  },
  {
    code: "35-235",
    city: "Rzeszów",
  },
  {
    code: "35-241",
    city: "Rzeszów",
  },
  {
    code: "35-242",
    city: "Rzeszów",
  },
  {
    code: "35-300",
    city: "Rzeszów",
  },
  {
    code: "35-301",
    city: "Rzeszów",
  },
  {
    code: "35-302",
    city: "Rzeszów",
  },
  {
    code: "35-303",
    city: "Rzeszów",
  },
  {
    code: "35-304",
    city: "Rzeszów",
  },
  {
    code: "35-305",
    city: "Rzeszów",
  },
  {
    code: "35-306",
    city: "Rzeszów",
  },
  {
    code: "35-307",
    city: "Rzeszów",
  },
  {
    code: "35-308",
    city: "Rzeszów",
  },
  {
    code: "35-309",
    city: "Rzeszów",
  },
  {
    code: "35-310",
    city: "Rzeszów",
  },
  {
    code: "35-311",
    city: "Rzeszów",
  },
  {
    code: "35-312",
    city: "Rzeszów",
  },
  {
    code: "35-313",
    city: "Rzeszów",
  },
  {
    code: "35-314",
    city: "Rzeszów",
  },
  {
    code: "35-315",
    city: "Rzeszów",
  },
  {
    code: "35-316",
    city: "Rzeszów",
  },
  {
    code: "35-320",
    city: "Rzeszów",
  },
  {
    code: "35-321",
    city: "Rzeszów",
  },
  {
    code: "35-322",
    city: "Rzeszów",
  },
  {
    code: "35-323",
    city: "Rzeszów",
  },
  {
    code: "35-324",
    city: "Rzeszów",
  },
  {
    code: "35-326",
    city: "Rzeszów",
  },
  {
    code: "35-327",
    city: "Rzeszów",
  },
  {
    code: "35-328",
    city: "Rzeszów",
  },
  {
    code: "35-329",
    city: "Rzeszów",
  },
  {
    code: "35-330",
    city: "Rzeszów",
  },
  {
    code: "35-332",
    city: "Rzeszów",
  },
  {
    code: "35-333",
    city: "Rzeszów",
  },
  {
    code: "35-404",
    city: "Rzeszów",
  },
  {
    code: "35-410",
    city: "Rzeszów",
  },
  {
    code: "35-501",
    city: "Rzeszów",
  },
  {
    code: "35-502",
    city: "Rzeszów",
  },
  {
    code: "35-503",
    city: "Rzeszów",
  },
  {
    code: "35-504",
    city: "Rzeszów",
  },
  {
    code: "35-505",
    city: "Rzeszów",
  },
  {
    code: "35-506",
    city: "Rzeszów",
  },
  {
    code: "35-507",
    city: "Rzeszów",
  },
  {
    code: "35-508",
    city: "Rzeszów",
  },
  {
    code: "35-509",
    city: "Rzeszów",
  },
  {
    code: "35-510",
    city: "Rzeszów",
  },
  {
    code: "35-511",
    city: "Rzeszów",
  },
  {
    code: "35-512",
    city: "Rzeszów",
  },
  {
    code: "35-513",
    city: "Rzeszów",
  },
  {
    code: "35-515",
    city: "Rzeszów",
  },
  {
    code: "35-601",
    city: "Rzeszów",
  },
  {
    code: "35-602",
    city: "Rzeszów",
  },
  {
    code: "35-603",
    city: "Rzeszów",
  },
  {
    code: "35-604",
    city: "Rzeszów",
  },
  {
    code: "35-605",
    city: "Rzeszów",
  },
  {
    code: "35-606",
    city: "Rzeszów",
  },
  {
    code: "35-607",
    city: "Rzeszów",
  },
  {
    code: "35-608",
    city: "Rzeszów",
  },
  {
    code: "35-609",
    city: "Rzeszów",
  },
  {
    code: "35-610",
    city: "Rzeszów",
  },
  {
    code: "35-611",
    city: "Rzeszów",
  },
  {
    code: "35-612",
    city: "Rzeszów",
  },
  {
    code: "35-614",
    city: "Rzeszów",
  },
  {
    code: "35-615",
    city: "Rzeszów",
  },
  {
    code: "35-616",
    city: "Rzeszów",
  },
  {
    code: "35-617",
    city: "Rzeszów",
  },
  {
    code: "35-620",
    city: "Rzeszów",
  },
  {
    code: "35-622",
    city: "Rzeszów",
  },
  {
    code: "35-623",
    city: "Rzeszów",
  },
  {
    code: "35-624",
    city: "Rzeszów",
  },
  {
    code: "35-625",
    city: "Rzeszów",
  },
  {
    code: "35-626",
    city: "Rzeszów",
  },
  {
    code: "35-627",
    city: "Rzeszów",
  },
  {
    code: "35-628",
    city: "Rzeszów",
  },
  {
    code: "35-629",
    city: "Rzeszów",
  },
  {
    code: "35-630",
    city: "Rzeszów",
  },
  {
    code: "35-749",
    city: "Rzeszów",
  },
  {
    code: "35-900",
    city: "Rzeszów",
  },
  {
    code: "35-959",
    city: "Rzeszów",
  },
  {
    code: "36-001",
    city: "Trzebownisko",
  },
  {
    code: "36-002",
    city: "Jasionka",
  },
  {
    code: "36-003",
    city: "Przewrotne",
  },
  {
    code: "36-004",
    city: "Łąka",
  },
  {
    code: "36-007",
    city: "Krasne",
  },
  {
    code: "36-016",
    city: "Chmielnik",
  },
  {
    code: "36-017",
    city: "Błędowa Tyczyńska",
  },
  {
    code: "36-020",
    city: "Tyczyn",
  },
  {
    code: "36-021",
    city: "Budziwój",
  },
  {
    code: "36-024",
    city: "Hyżne",
  },
  {
    code: "36-025",
    city: "Dylągówka",
  },
  {
    code: "36-030",
    city: "Błażowa",
  },
  {
    code: "36-032",
    city: "Kąkolówka",
  },
  {
    code: "36-034",
    city: "Futoma",
  },
  {
    code: "36-040",
    city: "Boguchwała",
  },
  {
    code: "36-041",
    city: "Zarzecze",
  },
  {
    code: "36-042",
    city: "Lubenia",
  },
  {
    code: "36-043",
    city: "Straszydle",
  },
  {
    code: "36-046",
    city: "Zgłobień",
  },
  {
    code: "36-047",
    city: "Niechobrz",
  },
  {
    code: "36-050",
    city: "Sokołów Małopolski",
  },
  {
    code: "36-051",
    city: "Górno",
  },
  {
    code: "36-052",
    city: "Nienadówka",
  },
  {
    code: "36-053",
    city: "Kamień",
  },
  {
    code: "36-054",
    city: "Mrowla",
  },
  {
    code: "36-055",
    city: "Bratkowice",
  },
  {
    code: "36-060",
    city: "Głogów Małopolski",
  },
  {
    code: "36-061",
    city: "Harta",
  },
  {
    code: "36-062",
    city: "Zaczernie",
  },
  {
    code: "36-065",
    city: "Dynów",
  },
  {
    code: "36-067",
    city: "Harta",
  },
  {
    code: "36-068",
    city: "Bachórz",
  },
  {
    code: "36-069",
    city: "Dylągowa",
  },
  {
    code: "36-071",
    city: "Trzciana",
  },
  {
    code: "36-072",
    city: "Świlcza",
  },
  {
    code: "36-073",
    city: "Strażów",
  },
  {
    code: "36-100",
    city: "Kolbuszowa",
  },
  {
    code: "36-105",
    city: "Cmolas",
  },
  {
    code: "36-106",
    city: "Trzęsówka",
  },
  {
    code: "36-107",
    city: "Przyłęk",
  },
  {
    code: "36-110",
    city: "Majdan Królewski",
  },
  {
    code: "36-121",
    city: "Wilcza Wola",
  },
  {
    code: "36-122",
    city: "Dzikowiec",
  },
  {
    code: "36-123",
    city: "Lipnica",
  },
  {
    code: "36-125",
    city: "Wola Raniżowska",
  },
  {
    code: "36-130",
    city: "Raniżów",
  },
  {
    code: "36-145",
    city: "Widełka",
  },
  {
    code: "36-147",
    city: "Niwiska",
  },
  {
    code: "36-200",
    city: "Brzozów",
  },
  {
    code: "36-203",
    city: "Izdebki",
  },
  {
    code: "36-204",
    city: "Dydnia",
  },
  {
    code: "36-205",
    city: "Witryłów",
  },
  {
    code: "36-206",
    city: "Humniska",
  },
  {
    code: "36-207",
    city: "Grabownica Starzeńska",
  },
  {
    code: "36-211",
    city: "Jasionów",
  },
  {
    code: "36-212",
    city: "Trześniów",
  },
  {
    code: "36-213",
    city: "Haczów",
  },
  {
    code: "36-220",
    city: "Jasienica Rosielna",
  },
  {
    code: "36-221",
    city: "Blizne",
  },
  {
    code: "36-230",
    city: "Domaradz",
  },
  {
    code: "36-231",
    city: "Golcowa",
  },
  {
    code: "36-233",
    city: "Wesoła",
  },
  {
    code: "36-244",
    city: "Siedliska",
  },
  {
    code: "36-245",
    city: "Nozdrzec",
  },
  {
    code: "37-100",
    city: "Łańcut",
  },
  {
    code: "37-110",
    city: "Żołynia",
  },
  {
    code: "37-111",
    city: "Rakszawa",
  },
  {
    code: "37-112",
    city: "Kosina",
  },
  {
    code: "37-114",
    city: "Białobrzegi",
  },
  {
    code: "37-120",
    city: "Markowa",
  },
  {
    code: "37-121",
    city: "Husów",
  },
  {
    code: "37-122",
    city: "Albigowa",
  },
  {
    code: "37-123",
    city: "Handzlówka",
  },
  {
    code: "37-124",
    city: "Kraczkowa",
  },
  {
    code: "37-125",
    city: "Czarna",
  },
  {
    code: "37-126",
    city: "Medynia Głogowska",
  },
  {
    code: "37-127",
    city: "Krzemienica",
  },
  {
    code: "37-200",
    city: "Przeworsk",
  },
  {
    code: "37-203",
    city: "Gniewczyna Łańcucka",
  },
  {
    code: "37-204",
    city: "Tryńcza",
  },
  {
    code: "37-205",
    city: "Zarzecze",
  },
  {
    code: "37-206",
    city: "Sietesz",
  },
  {
    code: "37-207",
    city: "Gać",
  },
  {
    code: "37-210",
    city: "Przeworsk",
  },
  {
    code: "37-220",
    city: "Kańczuga",
  },
  {
    code: "37-222",
    city: "Łopuszka Wielka",
  },
  {
    code: "37-224",
    city: "Pantalowice",
  },
  {
    code: "37-230",
    city: "Manasterz",
  },
  {
    code: "37-232",
    city: "Jawornik Polski",
  },
  {
    code: "37-240",
    city: "Przeworsk",
  },
  {
    code: "37-300",
    city: "Leżajsk",
  },
  {
    code: "37-303",
    city: "Kuryłówka",
  },
  {
    code: "37-304",
    city: "Brzyska Wola",
  },
  {
    code: "37-305",
    city: "Dębno",
  },
  {
    code: "37-306",
    city: "Grodzisko Dolne",
  },
  {
    code: "37-307",
    city: "Brzóza Królewska",
  },
  {
    code: "37-310",
    city: "Nowa Sarzyna",
  },
  {
    code: "37-311",
    city: "Wola Żarczycka",
  },
  {
    code: "37-312",
    city: "Łętownia",
  },
  {
    code: "37-400",
    city: "Nisko",
  },
  {
    code: "37-403",
    city: "Pysznica",
  },
  {
    code: "37-405",
    city: "Jarocin",
  },
  {
    code: "37-410",
    city: "Ulanów",
  },
  {
    code: "37-413",
    city: "Harasiuki",
  },
  {
    code: "37-414",
    city: "Huta Krzeszowska",
  },
  {
    code: "37-415",
    city: "Zaleszany",
  },
  {
    code: "37-416",
    city: "Zbydniów",
  },
  {
    code: "37-418",
    city: "Krzeszów",
  },
  {
    code: "37-420",
    city: "Rudnik nad Sanem",
  },
  {
    code: "37-430",
    city: "Jeżowe",
  },
  {
    code: "37-433",
    city: "Bojanów",
  },
  {
    code: "37-450",
    city: "Stalowa Wola",
  },
  {
    code: "37-455",
    city: "Radomyśl nad Sanem",
  },
  {
    code: "37-462",
    city: "Stalowa Wola",
  },
  {
    code: "37-463",
    city: "Stalowa Wola",
  },
  {
    code: "37-464",
    city: "Stalowa Wola",
  },
  {
    code: "37-465",
    city: "Stalowa Wola",
  },
  {
    code: "37-467",
    city: "Stalowa Wola",
  },
  {
    code: "37-470",
    city: "Zaklików",
  },
  {
    code: "37-500",
    city: "Jarosław",
  },
  {
    code: "37-501",
    city: "Jarosław",
  },
  {
    code: "37-504",
    city: "Jarosław",
  },
  {
    code: "37-505",
    city: "Jarosław",
  },
  {
    code: "37-511",
    city: "Wólka Pełkińska",
  },
  {
    code: "37-514",
    city: "Munina",
  },
  {
    code: "37-522",
    city: "Wiązownica",
  },
  {
    code: "37-523",
    city: "Radawa",
  },
  {
    code: "37-530",
    city: "Sieniawa",
  },
  {
    code: "37-534",
    city: "Adamówka",
  },
  {
    code: "37-543",
    city: "Laszki",
  },
  {
    code: "37-544",
    city: "Zapałów",
  },
  {
    code: "37-550",
    city: "Radymno",
  },
  {
    code: "37-552",
    city: "Młyny",
  },
  {
    code: "37-554",
    city: "Łowce",
  },
  {
    code: "37-555",
    city: "Sośnica",
  },
  {
    code: "37-560",
    city: "Pruchnik",
  },
  {
    code: "37-561",
    city: "Chłopice",
  },
  {
    code: "37-562",
    city: "Rokietnica",
  },
  {
    code: "37-565",
    city: "Roźwienica",
  },
  {
    code: "37-600",
    city: "Lubaczów",
  },
  {
    code: "37-610",
    city: "Narol",
  },
  {
    code: "37-611",
    city: "Cieszanów",
  },
  {
    code: "37-612",
    city: "Stary Lubliniec",
  },
  {
    code: "37-613",
    city: "Ruda Różaniecka",
  },
  {
    code: "37-614",
    city: "Płazów",
  },
  {
    code: "37-620",
    city: "Horyniec-Zdrój",
  },
  {
    code: "37-621",
    city: "Basznia Dolna",
  },
  {
    code: "37-625",
    city: "Krowica Sama",
  },
  {
    code: "37-626",
    city: "Łukawiec",
  },
  {
    code: "37-627",
    city: "Wielkie Oczy",
  },
  {
    code: "37-630",
    city: "Oleszyce",
  },
  {
    code: "37-631",
    city: "Nowa Grobla",
  },
  {
    code: "37-632",
    city: "Stary Dzików",
  },
  {
    code: "37-700",
    city: "Przemyśl",
  },
  {
    code: "37-701",
    city: "Przemyśl",
  },
  {
    code: "37-702",
    city: "Przemyśl",
  },
  {
    code: "37-703",
    city: "Przemyśl",
  },
  {
    code: "37-704",
    city: "Przemyśl",
  },
  {
    code: "37-705",
    city: "Przemyśl",
  },
  {
    code: "37-706",
    city: "Przemyśl",
  },
  {
    code: "37-710",
    city: "Żurawica",
  },
  {
    code: "37-712",
    city: "Orzechowce",
  },
  {
    code: "37-713",
    city: "Maćkowice",
  },
  {
    code: "37-716",
    city: "Orły",
  },
  {
    code: "37-717",
    city: "Kaszyce",
  },
  {
    code: "37-720",
    city: "Przemyśl",
  },
  {
    code: "37-722",
    city: "Wyszatyce",
  },
  {
    code: "37-723",
    city: "Stubno",
  },
  {
    code: "37-724",
    city: "Kalników",
  },
  {
    code: "37-732",
    city: "Medyka",
  },
  {
    code: "37-733",
    city: "Pikulice",
  },
  {
    code: "37-734",
    city: "Fredropol",
  },
  {
    code: "37-740",
    city: "Bircza",
  },
  {
    code: "37-741",
    city: "Krasiczyn",
  },
  {
    code: "37-742",
    city: "Rybotycze",
  },
  {
    code: "37-743",
    city: "Nowosiółki Dydyńskie",
  },
  {
    code: "37-749",
    city: "Przemyśl",
  },
  {
    code: "37-750",
    city: "Dubiecko",
  },
  {
    code: "37-751",
    city: "Żohatyn",
  },
  {
    code: "37-752",
    city: "Bachórzec",
  },
  {
    code: "37-754",
    city: "Babice",
  },
  {
    code: "37-755",
    city: "Krzywcza",
  },
  {
    code: "38-100",
    city: "Strzyżów",
  },
  {
    code: "38-102",
    city: "Grodzisko",
  },
  {
    code: "38-111",
    city: "Żyznów",
  },
  {
    code: "38-112",
    city: "Lutcza",
  },
  {
    code: "38-114",
    city: "Niebylec",
  },
  {
    code: "38-115",
    city: "Połomia",
  },
  {
    code: "38-116",
    city: "Gwoźnica Górna",
  },
  {
    code: "38-120",
    city: "Czudec",
  },
  {
    code: "38-121",
    city: "Pstrągowa",
  },
  {
    code: "38-123",
    city: "Wysoka Strzyżowska",
  },
  {
    code: "38-124",
    city: "Wiśniowa",
  },
  {
    code: "38-125",
    city: "Stępina",
  },
  {
    code: "38-126",
    city: "Markuszowa",
  },
  {
    code: "38-130",
    city: "Frysztak",
  },
  {
    code: "38-131",
    city: "Gogołów",
  },
  {
    code: "38-200",
    city: "Jasło",
  },
  {
    code: "38-201",
    city: "Jasło",
  },
  {
    code: "38-203",
    city: "Szebnie",
  },
  {
    code: "38-204",
    city: "Tarnowiec",
  },
  {
    code: "38-207",
    city: "Przysieki",
  },
  {
    code: "38-211",
    city: "Jasło",
  },
  {
    code: "38-212",
    city: "Brzyska",
  },
  {
    code: "38-213",
    city: "Kołaczyce",
  },
  {
    code: "38-214",
    city: "Bieździedza",
  },
  {
    code: "38-220",
    city: "Dębowiec",
  },
  {
    code: "38-222",
    city: "Cieklin",
  },
  {
    code: "38-223",
    city: "Osiek Jasielski",
  },
  {
    code: "38-230",
    city: "Nowy Żmigród",
  },
  {
    code: "38-232",
    city: "Krempna",
  },
  {
    code: "38-241",
    city: "Osobnica",
  },
  {
    code: "38-242",
    city: "Skołyszyn",
  },
  {
    code: "38-243",
    city: "Harklowa",
  },
  {
    code: "38-244",
    city: "Święcany",
  },
  {
    code: "38-245",
    city: "Czermna",
  },
  {
    code: "38-246",
    city: "Szerzyny",
  },
  {
    code: "38-247",
    city: "Ołpiny",
  },
  {
    code: "38-300",
    city: "Gorlice",
  },
  {
    code: "38-302",
    city: "Gorlice",
  },
  {
    code: "38-303",
    city: "Kobylanka",
  },
  {
    code: "38-304",
    city: "Kryg",
  },
  {
    code: "38-305",
    city: "Lipinki",
  },
  {
    code: "38-306",
    city: "Libusza",
  },
  {
    code: "38-307",
    city: "Sękowa",
  },
  {
    code: "38-311",
    city: "Szymbark",
  },
  {
    code: "38-312",
    city: "Ropa",
  },
  {
    code: "38-313",
    city: "Śnietnica",
  },
  {
    code: "38-314",
    city: "Łosie",
  },
  {
    code: "38-315",
    city: "Uście Gorlickie",
  },
  {
    code: "38-316",
    city: "Wysowa",
  },
  {
    code: "38-320",
    city: "Gorlice",
  },
  {
    code: "38-321",
    city: "Moszczenica",
  },
  {
    code: "38-322",
    city: "Łużna",
  },
  {
    code: "38-323",
    city: "Rożnowice",
  },
  {
    code: "38-324",
    city: "Siedliska",
  },
  {
    code: "38-331",
    city: "Szalowa",
  },
  {
    code: "38-333",
    city: "Zagórzany",
  },
  {
    code: "38-340",
    city: "Biecz",
  },
  {
    code: "38-350",
    city: "Bobowa",
  },
  {
    code: "38-400",
    city: "Krosno",
  },
  {
    code: "38-401",
    city: "Krosno",
  },
  {
    code: "38-402",
    city: "Krosno",
  },
  {
    code: "38-404",
    city: "Krosno",
  },
  {
    code: "38-406",
    city: "Odrzykoń",
  },
  {
    code: "38-407",
    city: "Bratkówka",
  },
  {
    code: "38-408",
    city: "Węglówka",
  },
  {
    code: "38-409",
    city: "Krosno",
  },
  {
    code: "38-410",
    city: "Krosno",
  },
  {
    code: "38-411",
    city: "Krosno",
  },
  {
    code: "38-420",
    city: "Korczyna",
  },
  {
    code: "38-421",
    city: "Kombornia",
  },
  {
    code: "38-422",
    city: "Krościenko Wyżne",
  },
  {
    code: "38-430",
    city: "Miejsce Piastowe",
  },
  {
    code: "38-440",
    city: "Iwonicz-Zdrój",
  },
  {
    code: "38-441",
    city: "Lubatowa",
  },
  {
    code: "38-450",
    city: "Dukla",
  },
  {
    code: "38-455",
    city: "Głowienka",
  },
  {
    code: "38-456",
    city: "Łęki Dukielskie",
  },
  {
    code: "38-457",
    city: "Zręcin",
  },
  {
    code: "38-458",
    city: "Chorkówka",
  },
  {
    code: "38-459",
    city: "Kopytowa",
  },
  {
    code: "38-460",
    city: "Jedlicze",
  },
  {
    code: "38-462",
    city: "Kobylany",
  },
  {
    code: "38-471",
    city: "Wojaszówka",
  },
  {
    code: "38-472",
    city: "Łączki Jagiellońskie",
  },
  {
    code: "38-473",
    city: "Łęki Strzyżowskie",
  },
  {
    code: "38-480",
    city: "Rymanów",
  },
  {
    code: "38-481",
    city: "Rymanów-Zdrój",
  },
  {
    code: "38-482",
    city: "Klimkówka",
  },
  {
    code: "38-483",
    city: "Wróblik Szlachecki",
  },
  {
    code: "38-485",
    city: "Jaśliska",
  },
  {
    code: "38-500",
    city: "Sanok",
  },
  {
    code: "38-501",
    city: "Sanok",
  },
  {
    code: "38-503",
    city: "Mrzygłód",
  },
  {
    code: "38-504",
    city: "Niebieszczany",
  },
  {
    code: "38-505",
    city: "Bukowsko",
  },
  {
    code: "38-506",
    city: "Nowotaniec",
  },
  {
    code: "38-507",
    city: "Jurowce",
  },
  {
    code: "38-512",
    city: "Sanok",
  },
  {
    code: "38-516",
    city: "Tarnawa Dolna",
  },
  {
    code: "38-524",
    city: "Besko",
  },
  {
    code: "38-530",
    city: "Zarszyn",
  },
  {
    code: "38-533",
    city: "Nowosielce",
  },
  {
    code: "38-535",
    city: "Tyrawa Wołoska",
  },
  {
    code: "38-540",
    city: "Zagórz",
  },
  {
    code: "38-542",
    city: "Rzepedź",
  },
  {
    code: "38-543",
    city: "Komańcza",
  },
  {
    code: "38-600",
    city: "Lesko",
  },
  {
    code: "38-604",
    city: "Hoczew",
  },
  {
    code: "38-606",
    city: "Baligród",
  },
  {
    code: "38-607",
    city: "Cisna",
  },
  {
    code: "38-608",
    city: "Wetlina",
  },
  {
    code: "38-610",
    city: "Polańczyk",
  },
  {
    code: "38-700",
    city: "Ustrzyki Dolne",
  },
  {
    code: "38-709",
    city: "Polana",
  },
  {
    code: "38-710",
    city: "Czarna Góra",
  },
  {
    code: "38-711",
    city: "Ropienka",
  },
  {
    code: "38-712",
    city: "Wojtkowa",
  },
  {
    code: "38-713",
    city: "Lutowiska",
  },
  {
    code: "38-714",
    city: "Ustrzyki Górne",
  },
  {
    code: "38-715",
    city: "Dwernik",
  },
  {
    code: "38-722",
    city: "Olszanica",
  },
  {
    code: "38-749",
    city: "Krosno",
  },
  {
    code: "39-100",
    city: "Ropczyce",
  },
  {
    code: "39-102",
    city: "Lubzina",
  },
  {
    code: "39-103",
    city: "Ostrów",
  },
  {
    code: "39-104",
    city: "Ocieka",
  },
  {
    code: "39-105",
    city: "Gnojnica",
  },
  {
    code: "39-106",
    city: "Łączki Kucharskie",
  },
  {
    code: "39-107",
    city: "Niedźwiada",
  },
  {
    code: "39-110",
    city: "Wielopole Skrzyńskie",
  },
  {
    code: "39-111",
    city: "Brzeziny",
  },
  {
    code: "39-120",
    city: "Sędziszów Małopolski",
  },
  {
    code: "39-122",
    city: "Kamionka",
  },
  {
    code: "39-123",
    city: "Borek Wielki",
  },
  {
    code: "39-124",
    city: "Iwierzyce",
  },
  {
    code: "39-126",
    city: "Zagorzyce",
  },
  {
    code: "39-127",
    city: "Będziemyśl",
  },
  {
    code: "39-200",
    city: "Dębica",
  },
  {
    code: "39-201",
    city: "Dębica",
  },
  {
    code: "39-203",
    city: "Nagoszyn",
  },
  {
    code: "39-204",
    city: "Żyraków",
  },
  {
    code: "39-205",
    city: "Pustków",
  },
  {
    code: "39-206",
    city: "Pustków",
  },
  {
    code: "39-207",
    city: "Brzeźnica",
  },
  {
    code: "39-209",
    city: "Zasów",
  },
  {
    code: "39-210",
    city: "Dębica",
  },
  {
    code: "39-215",
    city: "Czarna",
  },
  {
    code: "39-216",
    city: "Stara Jastrząbka",
  },
  {
    code: "39-217",
    city: "Grabiny",
  },
  {
    code: "39-218",
    city: "Straszęcin",
  },
  {
    code: "39-220",
    city: "Pilzno",
  },
  {
    code: "39-221",
    city: "Łęki Górne",
  },
  {
    code: "39-223",
    city: "Strzegocice",
  },
  {
    code: "39-225",
    city: "Jodłowa",
  },
  {
    code: "39-230",
    city: "Brzostek",
  },
  {
    code: "39-231",
    city: "Siedliska-Bogusz",
  },
  {
    code: "39-232",
    city: "Grudna Dolna",
  },
  {
    code: "39-300",
    city: "Mielec",
  },
  {
    code: "39-301",
    city: "Mielec",
  },
  {
    code: "39-302",
    city: "Mielec",
  },
  {
    code: "39-303",
    city: "Mielec",
  },
  {
    code: "39-304",
    city: "Czermin",
  },
  {
    code: "39-305",
    city: "Borowa",
  },
  {
    code: "39-306",
    city: "Górki",
  },
  {
    code: "39-307",
    city: "Gawłuszowice",
  },
  {
    code: "39-308",
    city: "Wadowice Górne",
  },
  {
    code: "39-310",
    city: "Radomyśl Wielki",
  },
  {
    code: "39-311",
    city: "Zdziarzec",
  },
  {
    code: "39-312",
    city: "Żarówka",
  },
  {
    code: "39-315",
    city: "Ruda",
  },
  {
    code: "39-320",
    city: "Przecław",
  },
  {
    code: "39-321",
    city: "Tuszyma",
  },
  {
    code: "39-322",
    city: "Rzemień",
  },
  {
    code: "39-323",
    city: "Mielec",
  },
  {
    code: "39-331",
    city: "Chorzelów",
  },
  {
    code: "39-332",
    city: "Tuszów Narodowy",
  },
  {
    code: "39-333",
    city: "Sarnów",
  },
  {
    code: "39-340",
    city: "Padew Narodowa",
  },
  {
    code: "39-400",
    city: "Tarnobrzeg",
  },
  {
    code: "39-401",
    city: "Tarnobrzeg",
  },
  {
    code: "39-402",
    city: "Tarnobrzeg",
  },
  {
    code: "39-403",
    city: "Tarnobrzeg",
  },
  {
    code: "39-405",
    city: "Tarnobrzeg",
  },
  {
    code: "39-407",
    city: "Tarnobrzeg",
  },
  {
    code: "39-410",
    city: "Grębów",
  },
  {
    code: "39-432",
    city: "Gorzyce",
  },
  {
    code: "39-434",
    city: "Trześń",
  },
  {
    code: "39-441",
    city: "Tarnobrzeg",
  },
  {
    code: "39-442",
    city: "Chmielów",
  },
  {
    code: "39-450",
    city: "Baranów Sandomierski",
  },
  {
    code: "39-451",
    city: "Skopanie",
  },
  {
    code: "39-460",
    city: "Nowa Dęba",
  },
  {
    code: "40-001",
    city: "Katowice",
  },
  {
    code: "40-002",
    city: "Katowice",
  },
  {
    code: "40-003",
    city: "Katowice",
  },
  {
    code: "40-004",
    city: "Katowice",
  },
  {
    code: "40-005",
    city: "Katowice",
  },
  {
    code: "40-006",
    city: "Katowice",
  },
  {
    code: "40-007",
    city: "Katowice",
  },
  {
    code: "40-008",
    city: "Katowice",
  },
  {
    code: "40-009",
    city: "Katowice",
  },
  {
    code: "40-010",
    city: "Katowice",
  },
  {
    code: "40-011",
    city: "Katowice",
  },
  {
    code: "40-012",
    city: "Katowice",
  },
  {
    code: "40-013",
    city: "Katowice",
  },
  {
    code: "40-014",
    city: "Katowice",
  },
  {
    code: "40-015",
    city: "Katowice",
  },
  {
    code: "40-016",
    city: "Katowice",
  },
  {
    code: "40-017",
    city: "Katowice",
  },
  {
    code: "40-018",
    city: "Katowice",
  },
  {
    code: "40-019",
    city: "Katowice",
  },
  {
    code: "40-020",
    city: "Katowice",
  },
  {
    code: "40-021",
    city: "Katowice",
  },
  {
    code: "40-022",
    city: "Katowice",
  },
  {
    code: "40-024",
    city: "Katowice",
  },
  {
    code: "40-025",
    city: "Katowice",
  },
  {
    code: "40-026",
    city: "Katowice",
  },
  {
    code: "40-027",
    city: "Katowice",
  },
  {
    code: "40-028",
    city: "Katowice",
  },
  {
    code: "40-029",
    city: "Katowice",
  },
  {
    code: "40-030",
    city: "Katowice",
  },
  {
    code: "40-031",
    city: "Katowice",
  },
  {
    code: "40-032",
    city: "Katowice",
  },
  {
    code: "40-034",
    city: "Katowice",
  },
  {
    code: "40-035",
    city: "Katowice",
  },
  {
    code: "40-036",
    city: "Katowice",
  },
  {
    code: "40-037",
    city: "Katowice",
  },
  {
    code: "40-038",
    city: "Katowice",
  },
  {
    code: "40-039",
    city: "Katowice",
  },
  {
    code: "40-040",
    city: "Katowice",
  },
  {
    code: "40-041",
    city: "Katowice",
  },
  {
    code: "40-042",
    city: "Katowice",
  },
  {
    code: "40-043",
    city: "Katowice",
  },
  {
    code: "40-044",
    city: "Katowice",
  },
  {
    code: "40-045",
    city: "Katowice",
  },
  {
    code: "40-046",
    city: "Katowice",
  },
  {
    code: "40-047",
    city: "Katowice",
  },
  {
    code: "40-048",
    city: "Katowice",
  },
  {
    code: "40-049",
    city: "Katowice",
  },
  {
    code: "40-050",
    city: "Katowice",
  },
  {
    code: "40-052",
    city: "Katowice",
  },
  {
    code: "40-053",
    city: "Katowice",
  },
  {
    code: "40-054",
    city: "Katowice",
  },
  {
    code: "40-055",
    city: "Katowice",
  },
  {
    code: "40-056",
    city: "Katowice",
  },
  {
    code: "40-057",
    city: "Katowice",
  },
  {
    code: "40-058",
    city: "Katowice",
  },
  {
    code: "40-059",
    city: "Katowice",
  },
  {
    code: "40-060",
    city: "Katowice",
  },
  {
    code: "40-061",
    city: "Katowice",
  },
  {
    code: "40-062",
    city: "Katowice",
  },
  {
    code: "40-063",
    city: "Katowice",
  },
  {
    code: "40-064",
    city: "Katowice",
  },
  {
    code: "40-065",
    city: "Katowice",
  },
  {
    code: "40-066",
    city: "Katowice",
  },
  {
    code: "40-067",
    city: "Katowice",
  },
  {
    code: "40-068",
    city: "Katowice",
  },
  {
    code: "40-069",
    city: "Katowice",
  },
  {
    code: "40-070",
    city: "Katowice",
  },
  {
    code: "40-071",
    city: "Katowice",
  },
  {
    code: "40-072",
    city: "Katowice",
  },
  {
    code: "40-073",
    city: "Katowice",
  },
  {
    code: "40-074",
    city: "Katowice",
  },
  {
    code: "40-076",
    city: "Katowice",
  },
  {
    code: "40-077",
    city: "Katowice",
  },
  {
    code: "40-078",
    city: "Katowice",
  },
  {
    code: "40-079",
    city: "Katowice",
  },
  {
    code: "40-081",
    city: "Katowice",
  },
  {
    code: "40-082",
    city: "Katowice",
  },
  {
    code: "40-083",
    city: "Katowice",
  },
  {
    code: "40-084",
    city: "Katowice",
  },
  {
    code: "40-085",
    city: "Katowice",
  },
  {
    code: "40-086",
    city: "Katowice",
  },
  {
    code: "40-087",
    city: "Katowice",
  },
  {
    code: "40-091",
    city: "Katowice",
  },
  {
    code: "40-092",
    city: "Katowice",
  },
  {
    code: "40-093",
    city: "Katowice",
  },
  {
    code: "40-094",
    city: "Katowice",
  },
  {
    code: "40-095",
    city: "Katowice",
  },
  {
    code: "40-096",
    city: "Katowice",
  },
  {
    code: "40-097",
    city: "Katowice",
  },
  {
    code: "40-098",
    city: "Katowice",
  },
  {
    code: "40-100",
    city: "Katowice",
  },
  {
    code: "40-101",
    city: "Katowice",
  },
  {
    code: "40-102",
    city: "Katowice",
  },
  {
    code: "40-103",
    city: "Katowice",
  },
  {
    code: "40-104",
    city: "Katowice",
  },
  {
    code: "40-105",
    city: "Katowice",
  },
  {
    code: "40-106",
    city: "Katowice",
  },
  {
    code: "40-107",
    city: "Katowice",
  },
  {
    code: "40-108",
    city: "Katowice",
  },
  {
    code: "40-109",
    city: "Katowice",
  },
  {
    code: "40-110",
    city: "Katowice",
  },
  {
    code: "40-111",
    city: "Katowice",
  },
  {
    code: "40-112",
    city: "Katowice",
  },
  {
    code: "40-113",
    city: "Katowice",
  },
  {
    code: "40-114",
    city: "Katowice",
  },
  {
    code: "40-116",
    city: "Katowice",
  },
  {
    code: "40-117",
    city: "Katowice",
  },
  {
    code: "40-118",
    city: "Katowice",
  },
  {
    code: "40-119",
    city: "Katowice",
  },
  {
    code: "40-121",
    city: "Katowice",
  },
  {
    code: "40-123",
    city: "Katowice",
  },
  {
    code: "40-124",
    city: "Katowice",
  },
  {
    code: "40-125",
    city: "Katowice",
  },
  {
    code: "40-126",
    city: "Katowice",
  },
  {
    code: "40-127",
    city: "Katowice",
  },
  {
    code: "40-129",
    city: "Katowice",
  },
  {
    code: "40-131",
    city: "Katowice",
  },
  {
    code: "40-132",
    city: "Katowice",
  },
  {
    code: "40-133",
    city: "Katowice",
  },
  {
    code: "40-134",
    city: "Katowice",
  },
  {
    code: "40-135",
    city: "Katowice",
  },
  {
    code: "40-136",
    city: "Katowice",
  },
  {
    code: "40-137",
    city: "Katowice",
  },
  {
    code: "40-139",
    city: "Katowice",
  },
  {
    code: "40-140",
    city: "Katowice",
  },
  {
    code: "40-141",
    city: "Katowice",
  },
  {
    code: "40-142",
    city: "Katowice",
  },
  {
    code: "40-143",
    city: "Katowice",
  },
  {
    code: "40-144",
    city: "Katowice",
  },
  {
    code: "40-145",
    city: "Katowice",
  },
  {
    code: "40-146",
    city: "Katowice",
  },
  {
    code: "40-147",
    city: "Katowice",
  },
  {
    code: "40-148",
    city: "Katowice",
  },
  {
    code: "40-149",
    city: "Katowice",
  },
  {
    code: "40-150",
    city: "Katowice",
  },
  {
    code: "40-151",
    city: "Katowice",
  },
  {
    code: "40-152",
    city: "Katowice",
  },
  {
    code: "40-153",
    city: "Katowice",
  },
  {
    code: "40-154",
    city: "Katowice",
  },
  {
    code: "40-155",
    city: "Katowice",
  },
  {
    code: "40-156",
    city: "Katowice",
  },
  {
    code: "40-157",
    city: "Katowice",
  },
  {
    code: "40-158",
    city: "Katowice",
  },
  {
    code: "40-159",
    city: "Katowice",
  },
  {
    code: "40-160",
    city: "Katowice",
  },
  {
    code: "40-161",
    city: "Katowice",
  },
  {
    code: "40-162",
    city: "Katowice",
  },
  {
    code: "40-163",
    city: "Katowice",
  },
  {
    code: "40-164",
    city: "Katowice",
  },
  {
    code: "40-165",
    city: "Katowice",
  },
  {
    code: "40-166",
    city: "Katowice",
  },
  {
    code: "40-167",
    city: "Katowice",
  },
  {
    code: "40-168",
    city: "Katowice",
  },
  {
    code: "40-169",
    city: "Katowice",
  },
  {
    code: "40-170",
    city: "Katowice",
  },
  {
    code: "40-171",
    city: "Katowice",
  },
  {
    code: "40-172",
    city: "Katowice",
  },
  {
    code: "40-173",
    city: "Katowice",
  },
  {
    code: "40-174",
    city: "Katowice",
  },
  {
    code: "40-175",
    city: "Katowice",
  },
  {
    code: "40-176",
    city: "Katowice",
  },
  {
    code: "40-177",
    city: "Katowice",
  },
  {
    code: "40-179",
    city: "Katowice",
  },
  {
    code: "40-181",
    city: "Katowice",
  },
  {
    code: "40-186",
    city: "Katowice",
  },
  {
    code: "40-188",
    city: "Katowice",
  },
  {
    code: "40-189",
    city: "Katowice",
  },
  {
    code: "40-200",
    city: "Katowice",
  },
  {
    code: "40-201",
    city: "Katowice",
  },
  {
    code: "40-202",
    city: "Katowice",
  },
  {
    code: "40-203",
    city: "Katowice",
  },
  {
    code: "40-205",
    city: "Katowice",
  },
  {
    code: "40-206",
    city: "Katowice",
  },
  {
    code: "40-208",
    city: "Katowice",
  },
  {
    code: "40-209",
    city: "Katowice",
  },
  {
    code: "40-210",
    city: "Katowice",
  },
  {
    code: "40-211",
    city: "Katowice",
  },
  {
    code: "40-212",
    city: "Katowice",
  },
  {
    code: "40-213",
    city: "Katowice",
  },
  {
    code: "40-214",
    city: "Katowice",
  },
  {
    code: "40-215",
    city: "Katowice",
  },
  {
    code: "40-216",
    city: "Katowice",
  },
  {
    code: "40-217",
    city: "Katowice",
  },
  {
    code: "40-218",
    city: "Katowice",
  },
  {
    code: "40-219",
    city: "Katowice",
  },
  {
    code: "40-224",
    city: "Katowice",
  },
  {
    code: "40-225",
    city: "Katowice",
  },
  {
    code: "40-226",
    city: "Katowice",
  },
  {
    code: "40-227",
    city: "Katowice",
  },
  {
    code: "40-228",
    city: "Katowice",
  },
  {
    code: "40-229",
    city: "Katowice",
  },
  {
    code: "40-230",
    city: "Katowice",
  },
  {
    code: "40-231",
    city: "Katowice",
  },
  {
    code: "40-232",
    city: "Katowice",
  },
  {
    code: "40-233",
    city: "Katowice",
  },
  {
    code: "40-234",
    city: "Katowice",
  },
  {
    code: "40-235",
    city: "Katowice",
  },
  {
    code: "40-236",
    city: "Katowice",
  },
  {
    code: "40-237",
    city: "Katowice",
  },
  {
    code: "40-238",
    city: "Katowice",
  },
  {
    code: "40-239",
    city: "Katowice",
  },
  {
    code: "40-240",
    city: "Katowice",
  },
  {
    code: "40-241",
    city: "Katowice",
  },
  {
    code: "40-242",
    city: "Katowice",
  },
  {
    code: "40-246",
    city: "Katowice",
  },
  {
    code: "40-256",
    city: "Katowice",
  },
  {
    code: "40-265",
    city: "Katowice",
  },
  {
    code: "40-266",
    city: "Katowice",
  },
  {
    code: "40-271",
    city: "Katowice",
  },
  {
    code: "40-272",
    city: "Katowice",
  },
  {
    code: "40-273",
    city: "Katowice",
  },
  {
    code: "40-276",
    city: "Katowice",
  },
  {
    code: "40-277",
    city: "Katowice",
  },
  {
    code: "40-281",
    city: "Katowice",
  },
  {
    code: "40-282",
    city: "Katowice",
  },
  {
    code: "40-283",
    city: "Katowice",
  },
  {
    code: "40-284",
    city: "Katowice",
  },
  {
    code: "40-285",
    city: "Katowice",
  },
  {
    code: "40-286",
    city: "Katowice",
  },
  {
    code: "40-287",
    city: "Katowice",
  },
  {
    code: "40-288",
    city: "Katowice",
  },
  {
    code: "40-290",
    city: "Katowice",
  },
  {
    code: "40-291",
    city: "Katowice",
  },
  {
    code: "40-300",
    city: "Katowice",
  },
  {
    code: "40-301",
    city: "Katowice",
  },
  {
    code: "40-302",
    city: "Katowice",
  },
  {
    code: "40-303",
    city: "Katowice",
  },
  {
    code: "40-304",
    city: "Katowice",
  },
  {
    code: "40-305",
    city: "Katowice",
  },
  {
    code: "40-306",
    city: "Katowice",
  },
  {
    code: "40-307",
    city: "Katowice",
  },
  {
    code: "40-308",
    city: "Katowice",
  },
  {
    code: "40-309",
    city: "Katowice",
  },
  {
    code: "40-310",
    city: "Katowice",
  },
  {
    code: "40-311",
    city: "Katowice",
  },
  {
    code: "40-312",
    city: "Katowice",
  },
  {
    code: "40-313",
    city: "Katowice",
  },
  {
    code: "40-314",
    city: "Mikołów",
  },
  {
    code: "40-315",
    city: "Katowice",
  },
  {
    code: "40-316",
    city: "Katowice",
  },
  {
    code: "40-317",
    city: "Katowice",
  },
  {
    code: "40-318",
    city: "Katowice",
  },
  {
    code: "40-319",
    city: "Katowice",
  },
  {
    code: "40-320",
    city: "Katowice",
  },
  {
    code: "40-321",
    city: "Katowice",
  },
  {
    code: "40-322",
    city: "Katowice",
  },
  {
    code: "40-325",
    city: "Katowice",
  },
  {
    code: "40-326",
    city: "Katowice",
  },
  {
    code: "40-334",
    city: "Katowice",
  },
  {
    code: "40-335",
    city: "Katowice",
  },
  {
    code: "40-336",
    city: "Katowice",
  },
  {
    code: "40-337",
    city: "Katowice",
  },
  {
    code: "40-338",
    city: "Katowice",
  },
  {
    code: "40-339",
    city: "Katowice",
  },
  {
    code: "40-340",
    city: "Katowice",
  },
  {
    code: "40-341",
    city: "Katowice",
  },
  {
    code: "40-342",
    city: "Katowice",
  },
  {
    code: "40-348",
    city: "Katowice",
  },
  {
    code: "40-351",
    city: "Katowice",
  },
  {
    code: "40-353",
    city: "Katowice",
  },
  {
    code: "40-356",
    city: "Katowice",
  },
  {
    code: "40-357",
    city: "Katowice",
  },
  {
    code: "40-358",
    city: "Katowice",
  },
  {
    code: "40-360",
    city: "Katowice",
  },
  {
    code: "40-367",
    city: "Katowice",
  },
  {
    code: "40-368",
    city: "Katowice",
  },
  {
    code: "40-370",
    city: "Katowice",
  },
  {
    code: "40-373",
    city: "Katowice",
  },
  {
    code: "40-374",
    city: "Katowice",
  },
  {
    code: "40-375",
    city: "Katowice",
  },
  {
    code: "40-376",
    city: "Katowice",
  },
  {
    code: "40-377",
    city: "Katowice",
  },
  {
    code: "40-378",
    city: "Katowice",
  },
  {
    code: "40-379",
    city: "Katowice",
  },
  {
    code: "40-381",
    city: "Katowice",
  },
  {
    code: "40-382",
    city: "Katowice",
  },
  {
    code: "40-383",
    city: "Katowice",
  },
  {
    code: "40-384",
    city: "Katowice",
  },
  {
    code: "40-386",
    city: "Katowice",
  },
  {
    code: "40-387",
    city: "Katowice",
  },
  {
    code: "40-388",
    city: "Katowice",
  },
  {
    code: "40-389",
    city: "Katowice",
  },
  {
    code: "40-391",
    city: "Katowice",
  },
  {
    code: "40-393",
    city: "Katowice",
  },
  {
    code: "40-394",
    city: "Katowice",
  },
  {
    code: "40-401",
    city: "Katowice",
  },
  {
    code: "40-402",
    city: "Katowice",
  },
  {
    code: "40-403",
    city: "Katowice",
  },
  {
    code: "40-404",
    city: "Katowice",
  },
  {
    code: "40-405",
    city: "Katowice",
  },
  {
    code: "40-406",
    city: "Katowice",
  },
  {
    code: "40-407",
    city: "Katowice",
  },
  {
    code: "40-410",
    city: "Katowice",
  },
  {
    code: "40-411",
    city: "Katowice",
  },
  {
    code: "40-412",
    city: "Katowice",
  },
  {
    code: "40-413",
    city: "Katowice",
  },
  {
    code: "40-414",
    city: "Katowice",
  },
  {
    code: "40-421",
    city: "Katowice",
  },
  {
    code: "40-422",
    city: "Katowice",
  },
  {
    code: "40-423",
    city: "Katowice",
  },
  {
    code: "40-424",
    city: "Katowice",
  },
  {
    code: "40-425",
    city: "Katowice",
  },
  {
    code: "40-431",
    city: "Katowice",
  },
  {
    code: "40-432",
    city: "Katowice",
  },
  {
    code: "40-434",
    city: "Katowice",
  },
  {
    code: "40-435",
    city: "Katowice",
  },
  {
    code: "40-452",
    city: "Katowice",
  },
  {
    code: "40-453",
    city: "Katowice",
  },
  {
    code: "40-457",
    city: "Katowice",
  },
  {
    code: "40-458",
    city: "Katowice",
  },
  {
    code: "40-459",
    city: "Katowice",
  },
  {
    code: "40-460",
    city: "Katowice",
  },
  {
    code: "40-461",
    city: "Katowice",
  },
  {
    code: "40-462",
    city: "Katowice",
  },
  {
    code: "40-463",
    city: "Katowice",
  },
  {
    code: "40-464",
    city: "Katowice",
  },
  {
    code: "40-465",
    city: "Katowice",
  },
  {
    code: "40-466",
    city: "Katowice",
  },
  {
    code: "40-467",
    city: "Katowice",
  },
  {
    code: "40-468",
    city: "Katowice",
  },
  {
    code: "40-469",
    city: "Katowice",
  },
  {
    code: "40-470",
    city: "Katowice",
  },
  {
    code: "40-471",
    city: "Katowice",
  },
  {
    code: "40-472",
    city: "Katowice",
  },
  {
    code: "40-473",
    city: "Katowice",
  },
  {
    code: "40-474",
    city: "Katowice",
  },
  {
    code: "40-476",
    city: "Katowice",
  },
  {
    code: "40-477",
    city: "Katowice",
  },
  {
    code: "40-478",
    city: "Katowice",
  },
  {
    code: "40-479",
    city: "Katowice",
  },
  {
    code: "40-483",
    city: "Katowice",
  },
  {
    code: "40-484",
    city: "Katowice",
  },
  {
    code: "40-485",
    city: "Katowice",
  },
  {
    code: "40-486",
    city: "Katowice",
  },
  {
    code: "40-487",
    city: "Katowice",
  },
  {
    code: "40-488",
    city: "Katowice",
  },
  {
    code: "40-489",
    city: "Katowice",
  },
  {
    code: "40-494",
    city: "Katowice",
  },
  {
    code: "40-496",
    city: "Katowice",
  },
  {
    code: "40-499",
    city: "Katowice",
  },
  {
    code: "40-500",
    city: "Katowice",
  },
  {
    code: "40-502",
    city: "Katowice",
  },
  {
    code: "40-503",
    city: "Katowice",
  },
  {
    code: "40-504",
    city: "Katowice",
  },
  {
    code: "40-505",
    city: "Katowice",
  },
  {
    code: "40-506",
    city: "Katowice",
  },
  {
    code: "40-507",
    city: "Katowice",
  },
  {
    code: "40-508",
    city: "Katowice",
  },
  {
    code: "40-510",
    city: "Katowice",
  },
  {
    code: "40-511",
    city: "Katowice",
  },
  {
    code: "40-513",
    city: "Katowice",
  },
  {
    code: "40-514",
    city: "Katowice",
  },
  {
    code: "40-517",
    city: "Katowice",
  },
  {
    code: "40-518",
    city: "Katowice",
  },
  {
    code: "40-519",
    city: "Katowice",
  },
  {
    code: "40-520",
    city: "Katowice",
  },
  {
    code: "40-521",
    city: "Katowice",
  },
  {
    code: "40-522",
    city: "Katowice",
  },
  {
    code: "40-523",
    city: "Katowice",
  },
  {
    code: "40-524",
    city: "Katowice",
  },
  {
    code: "40-525",
    city: "Katowice",
  },
  {
    code: "40-526",
    city: "Katowice",
  },
  {
    code: "40-527",
    city: "Katowice",
  },
  {
    code: "40-528",
    city: "Katowice",
  },
  {
    code: "40-529",
    city: "Katowice",
  },
  {
    code: "40-530",
    city: "Katowice",
  },
  {
    code: "40-531",
    city: "Katowice",
  },
  {
    code: "40-532",
    city: "Katowice",
  },
  {
    code: "40-533",
    city: "Katowice",
  },
  {
    code: "40-534",
    city: "Katowice",
  },
  {
    code: "40-535",
    city: "Katowice",
  },
  {
    code: "40-536",
    city: "Katowice",
  },
  {
    code: "40-537",
    city: "Katowice",
  },
  {
    code: "40-538",
    city: "Katowice",
  },
  {
    code: "40-539",
    city: "Katowice",
  },
  {
    code: "40-540",
    city: "Katowice",
  },
  {
    code: "40-541",
    city: "Katowice",
  },
  {
    code: "40-542",
    city: "Katowice",
  },
  {
    code: "40-543",
    city: "Katowice",
  },
  {
    code: "40-544",
    city: "Katowice",
  },
  {
    code: "40-545",
    city: "Katowice",
  },
  {
    code: "40-546",
    city: "Katowice",
  },
  {
    code: "40-547",
    city: "Katowice",
  },
  {
    code: "40-551",
    city: "Katowice",
  },
  {
    code: "40-553",
    city: "Katowice",
  },
  {
    code: "40-555",
    city: "Katowice",
  },
  {
    code: "40-558",
    city: "Katowice",
  },
  {
    code: "40-559",
    city: "Katowice",
  },
  {
    code: "40-560",
    city: "Katowice",
  },
  {
    code: "40-561",
    city: "Katowice",
  },
  {
    code: "40-562",
    city: "Katowice",
  },
  {
    code: "40-563",
    city: "Katowice",
  },
  {
    code: "40-564",
    city: "Katowice",
  },
  {
    code: "40-565",
    city: "Katowice",
  },
  {
    code: "40-566",
    city: "Katowice",
  },
  {
    code: "40-567",
    city: "Katowice",
  },
  {
    code: "40-568",
    city: "Katowice",
  },
  {
    code: "40-569",
    city: "Katowice",
  },
  {
    code: "40-570",
    city: "Katowice",
  },
  {
    code: "40-571",
    city: "Katowice",
  },
  {
    code: "40-572",
    city: "Katowice",
  },
  {
    code: "40-573",
    city: "Katowice",
  },
  {
    code: "40-574",
    city: "Katowice",
  },
  {
    code: "40-575",
    city: "Katowice",
  },
  {
    code: "40-576",
    city: "Katowice",
  },
  {
    code: "40-578",
    city: "Katowice",
  },
  {
    code: "40-579",
    city: "Katowice",
  },
  {
    code: "40-580",
    city: "Katowice",
  },
  {
    code: "40-581",
    city: "Katowice",
  },
  {
    code: "40-582",
    city: "Katowice",
  },
  {
    code: "40-583",
    city: "Katowice",
  },
  {
    code: "40-584",
    city: "Katowice",
  },
  {
    code: "40-585",
    city: "Katowice",
  },
  {
    code: "40-586",
    city: "Katowice",
  },
  {
    code: "40-587",
    city: "Katowice",
  },
  {
    code: "40-588",
    city: "Katowice",
  },
  {
    code: "40-589",
    city: "Katowice",
  },
  {
    code: "40-590",
    city: "Katowice",
  },
  {
    code: "40-591",
    city: "Katowice",
  },
  {
    code: "40-592",
    city: "Katowice",
  },
  {
    code: "40-593",
    city: "Katowice",
  },
  {
    code: "40-594",
    city: "Katowice",
  },
  {
    code: "40-595",
    city: "Katowice",
  },
  {
    code: "40-596",
    city: "Katowice",
  },
  {
    code: "40-597",
    city: "Katowice",
  },
  {
    code: "40-598",
    city: "Katowice",
  },
  {
    code: "40-599",
    city: "Katowice",
  },
  {
    code: "40-600",
    city: "Katowice",
  },
  {
    code: "40-601",
    city: "Katowice",
  },
  {
    code: "40-602",
    city: "Katowice",
  },
  {
    code: "40-605",
    city: "Katowice",
  },
  {
    code: "40-606",
    city: "Katowice",
  },
  {
    code: "40-607",
    city: "Katowice",
  },
  {
    code: "40-608",
    city: "Katowice",
  },
  {
    code: "40-609",
    city: "Katowice",
  },
  {
    code: "40-610",
    city: "Katowice",
  },
  {
    code: "40-611",
    city: "Katowice",
  },
  {
    code: "40-612",
    city: "Katowice",
  },
  {
    code: "40-613",
    city: "Katowice",
  },
  {
    code: "40-615",
    city: "Katowice",
  },
  {
    code: "40-616",
    city: "Katowice",
  },
  {
    code: "40-617",
    city: "Katowice",
  },
  {
    code: "40-618",
    city: "Katowice",
  },
  {
    code: "40-619",
    city: "Katowice",
  },
  {
    code: "40-620",
    city: "Katowice",
  },
  {
    code: "40-621",
    city: "Katowice",
  },
  {
    code: "40-622",
    city: "Katowice",
  },
  {
    code: "40-623",
    city: "Katowice",
  },
  {
    code: "40-624",
    city: "Katowice",
  },
  {
    code: "40-625",
    city: "Katowice",
  },
  {
    code: "40-626",
    city: "Katowice",
  },
  {
    code: "40-627",
    city: "Katowice",
  },
  {
    code: "40-628",
    city: "Katowice",
  },
  {
    code: "40-629",
    city: "Katowice",
  },
  {
    code: "40-630",
    city: "Katowice",
  },
  {
    code: "40-631",
    city: "Katowice",
  },
  {
    code: "40-632",
    city: "Katowice",
  },
  {
    code: "40-633",
    city: "Katowice",
  },
  {
    code: "40-634",
    city: "Katowice",
  },
  {
    code: "40-635",
    city: "Katowice",
  },
  {
    code: "40-636",
    city: "Katowice",
  },
  {
    code: "40-637",
    city: "Katowice",
  },
  {
    code: "40-638",
    city: "Katowice",
  },
  {
    code: "40-639",
    city: "Katowice",
  },
  {
    code: "40-640",
    city: "Katowice",
  },
  {
    code: "40-641",
    city: "Katowice",
  },
  {
    code: "40-642",
    city: "Katowice",
  },
  {
    code: "40-643",
    city: "Katowice",
  },
  {
    code: "40-644",
    city: "Katowice",
  },
  {
    code: "40-645",
    city: "Katowice",
  },
  {
    code: "40-646",
    city: "Katowice",
  },
  {
    code: "40-647",
    city: "Katowice",
  },
  {
    code: "40-648",
    city: "Katowice",
  },
  {
    code: "40-649",
    city: "Katowice",
  },
  {
    code: "40-650",
    city: "Katowice",
  },
  {
    code: "40-651",
    city: "Katowice",
  },
  {
    code: "40-652",
    city: "Katowice",
  },
  {
    code: "40-653",
    city: "Katowice",
  },
  {
    code: "40-654",
    city: "Katowice",
  },
  {
    code: "40-655",
    city: "Katowice",
  },
  {
    code: "40-656",
    city: "Katowice",
  },
  {
    code: "40-657",
    city: "Katowice",
  },
  {
    code: "40-658",
    city: "Katowice",
  },
  {
    code: "40-659",
    city: "Katowice",
  },
  {
    code: "40-660",
    city: "Katowice",
  },
  {
    code: "40-661",
    city: "Katowice",
  },
  {
    code: "40-662",
    city: "Katowice",
  },
  {
    code: "40-663",
    city: "Katowice",
  },
  {
    code: "40-664",
    city: "Katowice",
  },
  {
    code: "40-665",
    city: "Katowice",
  },
  {
    code: "40-666",
    city: "Katowice",
  },
  {
    code: "40-667",
    city: "Katowice",
  },
  {
    code: "40-668",
    city: "Katowice",
  },
  {
    code: "40-669",
    city: "Katowice",
  },
  {
    code: "40-670",
    city: "Katowice",
  },
  {
    code: "40-671",
    city: "Katowice",
  },
  {
    code: "40-672",
    city: "Katowice",
  },
  {
    code: "40-673",
    city: "Katowice",
  },
  {
    code: "40-674",
    city: "Katowice",
  },
  {
    code: "40-675",
    city: "Katowice",
  },
  {
    code: "40-676",
    city: "Katowice",
  },
  {
    code: "40-677",
    city: "Katowice",
  },
  {
    code: "40-678",
    city: "Katowice",
  },
  {
    code: "40-679",
    city: "Katowice",
  },
  {
    code: "40-680",
    city: "Katowice",
  },
  {
    code: "40-681",
    city: "Katowice",
  },
  {
    code: "40-682",
    city: "Katowice",
  },
  {
    code: "40-683",
    city: "Katowice",
  },
  {
    code: "40-684",
    city: "Katowice",
  },
  {
    code: "40-685",
    city: "Katowice",
  },
  {
    code: "40-686",
    city: "Katowice",
  },
  {
    code: "40-687",
    city: "Katowice",
  },
  {
    code: "40-688",
    city: "Katowice",
  },
  {
    code: "40-689",
    city: "Katowice",
  },
  {
    code: "40-690",
    city: "Katowice",
  },
  {
    code: "40-691",
    city: "Katowice",
  },
  {
    code: "40-692",
    city: "Katowice",
  },
  {
    code: "40-693",
    city: "Katowice",
  },
  {
    code: "40-694",
    city: "Katowice",
  },
  {
    code: "40-695",
    city: "Katowice",
  },
  {
    code: "40-696",
    city: "Katowice",
  },
  {
    code: "40-697",
    city: "Katowice",
  },
  {
    code: "40-698",
    city: "Katowice",
  },
  {
    code: "40-701",
    city: "Katowice",
  },
  {
    code: "40-702",
    city: "Katowice",
  },
  {
    code: "40-703",
    city: "Katowice",
  },
  {
    code: "40-704",
    city: "Katowice",
  },
  {
    code: "40-705",
    city: "Katowice",
  },
  {
    code: "40-706",
    city: "Katowice",
  },
  {
    code: "40-707",
    city: "Katowice",
  },
  {
    code: "40-708",
    city: "Katowice",
  },
  {
    code: "40-709",
    city: "Katowice",
  },
  {
    code: "40-712",
    city: "Katowice",
  },
  {
    code: "40-713",
    city: "Katowice",
  },
  {
    code: "40-714",
    city: "Katowice",
  },
  {
    code: "40-715",
    city: "Katowice",
  },
  {
    code: "40-716",
    city: "Katowice",
  },
  {
    code: "40-717",
    city: "Katowice",
  },
  {
    code: "40-718",
    city: "Katowice",
  },
  {
    code: "40-719",
    city: "Katowice",
  },
  {
    code: "40-720",
    city: "Katowice",
  },
  {
    code: "40-721",
    city: "Katowice",
  },
  {
    code: "40-722",
    city: "Katowice",
  },
  {
    code: "40-723",
    city: "Katowice",
  },
  {
    code: "40-724",
    city: "Katowice",
  },
  {
    code: "40-725",
    city: "Katowice",
  },
  {
    code: "40-728",
    city: "Katowice",
  },
  {
    code: "40-729",
    city: "Katowice",
  },
  {
    code: "40-730",
    city: "Katowice",
  },
  {
    code: "40-731",
    city: "Katowice",
  },
  {
    code: "40-732",
    city: "Katowice",
  },
  {
    code: "40-733",
    city: "Katowice",
  },
  {
    code: "40-736",
    city: "Katowice",
  },
  {
    code: "40-737",
    city: "Katowice",
  },
  {
    code: "40-738",
    city: "Katowice",
  },
  {
    code: "40-739",
    city: "Katowice",
  },
  {
    code: "40-748",
    city: "Katowice",
  },
  {
    code: "40-749",
    city: "Katowice",
  },
  {
    code: "40-750",
    city: "Katowice",
  },
  {
    code: "40-751",
    city: "Katowice",
  },
  {
    code: "40-752",
    city: "Katowice",
  },
  {
    code: "40-753",
    city: "Katowice",
  },
  {
    code: "40-754",
    city: "Katowice",
  },
  {
    code: "40-755",
    city: "Katowice",
  },
  {
    code: "40-756",
    city: "Katowice",
  },
  {
    code: "40-757",
    city: "Katowice",
  },
  {
    code: "40-758",
    city: "Katowice",
  },
  {
    code: "40-759",
    city: "Katowice",
  },
  {
    code: "40-760",
    city: "Katowice",
  },
  {
    code: "40-761",
    city: "Katowice",
  },
  {
    code: "40-762",
    city: "Katowice",
  },
  {
    code: "40-763",
    city: "Katowice",
  },
  {
    code: "40-764",
    city: "Katowice",
  },
  {
    code: "40-765",
    city: "Katowice",
  },
  {
    code: "40-766",
    city: "Katowice",
  },
  {
    code: "40-768",
    city: "Katowice",
  },
  {
    code: "40-769",
    city: "Katowice",
  },
  {
    code: "40-770",
    city: "Katowice",
  },
  {
    code: "40-771",
    city: "Katowice",
  },
  {
    code: "40-772",
    city: "Katowice",
  },
  {
    code: "40-773",
    city: "Katowice",
  },
  {
    code: "40-774",
    city: "Katowice",
  },
  {
    code: "40-775",
    city: "Katowice",
  },
  {
    code: "40-777",
    city: "Katowice",
  },
  {
    code: "40-778",
    city: "Katowice",
  },
  {
    code: "40-779",
    city: "Katowice",
  },
  {
    code: "40-780",
    city: "Katowice",
  },
  {
    code: "40-781",
    city: "Katowice",
  },
  {
    code: "40-783",
    city: "Katowice",
  },
  {
    code: "40-801",
    city: "Katowice",
  },
  {
    code: "40-802",
    city: "Katowice",
  },
  {
    code: "40-803",
    city: "Katowice",
  },
  {
    code: "40-804",
    city: "Katowice",
  },
  {
    code: "40-805",
    city: "Katowice",
  },
  {
    code: "40-806",
    city: "Katowice",
  },
  {
    code: "40-807",
    city: "Katowice",
  },
  {
    code: "40-808",
    city: "Katowice",
  },
  {
    code: "40-809",
    city: "Katowice",
  },
  {
    code: "40-810",
    city: "Katowice",
  },
  {
    code: "40-812",
    city: "Katowice",
  },
  {
    code: "40-813",
    city: "Katowice",
  },
  {
    code: "40-815",
    city: "Katowice",
  },
  {
    code: "40-816",
    city: "Katowice",
  },
  {
    code: "40-817",
    city: "Katowice",
  },
  {
    code: "40-818",
    city: "Katowice",
  },
  {
    code: "40-819",
    city: "Katowice",
  },
  {
    code: "40-820",
    city: "Katowice",
  },
  {
    code: "40-821",
    city: "Katowice",
  },
  {
    code: "40-823",
    city: "Katowice",
  },
  {
    code: "40-824",
    city: "Katowice",
  },
  {
    code: "40-826",
    city: "Katowice",
  },
  {
    code: "40-831",
    city: "Katowice",
  },
  {
    code: "40-832",
    city: "Katowice",
  },
  {
    code: "40-833",
    city: "Katowice",
  },
  {
    code: "40-834",
    city: "Katowice",
  },
  {
    code: "40-836",
    city: "Katowice",
  },
  {
    code: "40-837",
    city: "Katowice",
  },
  {
    code: "40-841",
    city: "Katowice",
  },
  {
    code: "40-842",
    city: "Katowice",
  },
  {
    code: "40-843",
    city: "Katowice",
  },
  {
    code: "40-844",
    city: "Katowice",
  },
  {
    code: "40-845",
    city: "Katowice",
  },
  {
    code: "40-846",
    city: "Katowice",
  },
  {
    code: "40-847",
    city: "Katowice",
  },
  {
    code: "40-848",
    city: "Katowice",
  },
  {
    code: "40-850",
    city: "Katowice",
  },
  {
    code: "40-851",
    city: "Katowice",
  },
  {
    code: "40-852",
    city: "Katowice",
  },
  {
    code: "40-853",
    city: "Katowice",
  },
  {
    code: "40-854",
    city: "Katowice",
  },
  {
    code: "40-855",
    city: "Katowice",
  },
  {
    code: "40-856",
    city: "Katowice",
  },
  {
    code: "40-857",
    city: "Katowice",
  },
  {
    code: "40-858",
    city: "Katowice",
  },
  {
    code: "40-859",
    city: "Katowice",
  },
  {
    code: "40-860",
    city: "Katowice",
  },
  {
    code: "40-861",
    city: "Katowice",
  },
  {
    code: "40-862",
    city: "Katowice",
  },
  {
    code: "40-863",
    city: "Katowice",
  },
  {
    code: "40-865",
    city: "Katowice",
  },
  {
    code: "40-866",
    city: "Katowice",
  },
  {
    code: "40-867",
    city: "Katowice",
  },
  {
    code: "40-868",
    city: "Katowice",
  },
  {
    code: "40-869",
    city: "Katowice",
  },
  {
    code: "40-870",
    city: "Katowice",
  },
  {
    code: "40-871",
    city: "Katowice",
  },
  {
    code: "40-872",
    city: "Katowice",
  },
  {
    code: "40-873",
    city: "Katowice",
  },
  {
    code: "40-874",
    city: "Katowice",
  },
  {
    code: "40-875",
    city: "Katowice",
  },
  {
    code: "40-876",
    city: "Katowice",
  },
  {
    code: "40-877",
    city: "Katowice",
  },
  {
    code: "40-878",
    city: "Katowice",
  },
  {
    code: "40-881",
    city: "Katowice",
  },
  {
    code: "40-887",
    city: "Katowice",
  },
  {
    code: "40-892",
    city: "Katowice",
  },
  {
    code: "40-900",
    city: "Katowice",
  },
  {
    code: "40-923",
    city: "Katowice",
  },
  {
    code: "40-925",
    city: "Katowice",
  },
  {
    code: "40-927",
    city: "Katowice",
  },
  {
    code: "40-929",
    city: "Katowice",
  },
  {
    code: "40-930",
    city: "Katowice",
  },
  {
    code: "40-940",
    city: "Katowice",
  },
  {
    code: "40-950",
    city: "Katowice",
  },
  {
    code: "40-959",
    city: "Katowice",
  },
  {
    code: "41-100",
    city: "Siemianowice Śląskie",
  },
  {
    code: "41-103",
    city: "Siemianowice Śląskie",
  },
  {
    code: "41-106",
    city: "Siemianowice Śląskie",
  },
  {
    code: "41-200",
    city: "Sosnowiec",
  },
  {
    code: "41-203",
    city: "Sosnowiec",
  },
  {
    code: "41-205",
    city: "Sosnowiec",
  },
  {
    code: "41-206",
    city: "Sosnowiec",
  },
  {
    code: "41-207",
    city: "Sosnowiec",
  },
  {
    code: "41-208",
    city: "Sosnowiec",
  },
  {
    code: "41-209",
    city: "Sosnowiec",
  },
  {
    code: "41-210",
    city: "Sosnowiec",
  },
  {
    code: "41-211",
    city: "Sosnowiec",
  },
  {
    code: "41-213",
    city: "Sosnowiec",
  },
  {
    code: "41-214",
    city: "Sosnowiec",
  },
  {
    code: "41-215",
    city: "Sosnowiec",
  },
  {
    code: "41-216",
    city: "Sosnowiec",
  },
  {
    code: "41-217",
    city: "Sosnowiec",
  },
  {
    code: "41-218",
    city: "Sosnowiec",
  },
  {
    code: "41-219",
    city: "Sosnowiec",
  },
  {
    code: "41-220",
    city: "Sosnowiec",
  },
  {
    code: "41-221",
    city: "Sosnowiec",
  },
  {
    code: "41-250",
    city: "Czeladź",
  },
  {
    code: "41-253",
    city: "Czeladź",
  },
  {
    code: "41-254",
    city: "Czeladź",
  },
  {
    code: "41-260",
    city: "Sławków",
  },
  {
    code: "41-300",
    city: "Dąbrowa Górnicza",
  },
  {
    code: "41-303",
    city: "Dąbrowa Górnicza",
  },
  {
    code: "41-304",
    city: "Dąbrowa Górnicza",
  },
  {
    code: "41-306",
    city: "Dąbrowa Górnicza",
  },
  {
    code: "41-308",
    city: "Dąbrowa Górnicza",
  },
  {
    code: "41-310",
    city: "Dąbrowa Górnicza",
  },
  {
    code: "41-400",
    city: "Mysłowice",
  },
  {
    code: "41-403",
    city: "Chełm Śląski",
  },
  {
    code: "41-404",
    city: "Mysłowice",
  },
  {
    code: "41-406",
    city: "Mysłowice",
  },
  {
    code: "41-407",
    city: "Imielin",
  },
  {
    code: "41-408",
    city: "Mysłowice",
  },
  {
    code: "41-409",
    city: "Mysłowice",
  },
  {
    code: "41-412",
    city: "Mysłowice",
  },
  {
    code: "41-500",
    city: "Chorzów",
  },
  {
    code: "41-503",
    city: "Chorzów",
  },
  {
    code: "41-506",
    city: "Chorzów",
  },
  {
    code: "41-507",
    city: "Chorzów",
  },
  {
    code: "41-512",
    city: "Chorzów",
  },
  {
    code: "41-513",
    city: "Chorzów",
  },
  {
    code: "41-515",
    city: "Chorzów",
  },
  {
    code: "41-516",
    city: "Chorzów",
  },
  {
    code: "41-530",
    city: "Chorzów",
  },
  {
    code: "41-600",
    city: "Świętochłowice",
  },
  {
    code: "41-603",
    city: "Świętochłowice",
  },
  {
    code: "41-605",
    city: "Świętochłowice",
  },
  {
    code: "41-608",
    city: "Świętochłowice",
  },
  {
    code: "41-700",
    city: "Ruda Śląska",
  },
  {
    code: "41-705",
    city: "Ruda Śląska",
  },
  {
    code: "41-706",
    city: "Ruda Śląska",
  },
  {
    code: "41-707",
    city: "Ruda Śląska",
  },
  {
    code: "41-709",
    city: "Ruda Śląska",
  },
  {
    code: "41-710",
    city: "Ruda Śląska",
  },
  {
    code: "41-711",
    city: "Ruda Śląska",
  },
  {
    code: "41-712",
    city: "Ruda Śląska",
  },
  {
    code: "41-713",
    city: "Ruda Śląska",
  },
  {
    code: "41-714",
    city: "Ruda Śląska",
  },
  {
    code: "41-717",
    city: "Ruda Śląska",
  },
  {
    code: "41-800",
    city: "Zabrze",
  },
  {
    code: "41-803",
    city: "Zabrze",
  },
  {
    code: "41-805",
    city: "Zabrze",
  },
  {
    code: "41-806",
    city: "Zabrze",
  },
  {
    code: "41-807",
    city: "Zabrze",
  },
  {
    code: "41-808",
    city: "Zabrze",
  },
  {
    code: "41-809",
    city: "Zabrze",
  },
  {
    code: "41-810",
    city: "Zabrze",
  },
  {
    code: "41-811",
    city: "Zabrze",
  },
  {
    code: "41-813",
    city: "Zabrze",
  },
  {
    code: "41-814",
    city: "Zabrze",
  },
  {
    code: "41-815",
    city: "Zabrze",
  },
  {
    code: "41-818",
    city: "Zabrze",
  },
  {
    code: "41-819",
    city: "Zabrze",
  },
  {
    code: "41-820",
    city: "Zabrze",
  },
  {
    code: "41-840",
    city: "Zabrze",
  },
  {
    code: "41-900",
    city: "Bytom",
  },
  {
    code: "41-902",
    city: "Bytom",
  },
  {
    code: "41-905",
    city: "Bytom",
  },
  {
    code: "41-906",
    city: "Bytom",
  },
  {
    code: "41-907",
    city: "Bytom",
  },
  {
    code: "41-908",
    city: "Bytom",
  },
  {
    code: "41-909",
    city: "Bytom",
  },
  {
    code: "41-910",
    city: "Bytom",
  },
  {
    code: "41-914",
    city: "Bytom",
  },
  {
    code: "41-915",
    city: "Bytom",
  },
  {
    code: "41-916",
    city: "Bytom",
  },
  {
    code: "41-922",
    city: "Radzionków",
  },
  {
    code: "41-923",
    city: "Bytom",
  },
  {
    code: "41-925",
    city: "Bytom",
  },
  {
    code: "41-926",
    city: "Bytom",
  },
  {
    code: "41-927",
    city: "Bytom",
  },
  {
    code: "41-933",
    city: "Bytom",
  },
  {
    code: "41-935",
    city: "Bytom",
  },
  {
    code: "41-936",
    city: "Bytom",
  },
  {
    code: "41-940",
    city: "Piekary Śląskie",
  },
  {
    code: "41-943",
    city: "Piekary Śląskie",
  },
  {
    code: "41-949",
    city: "Piekary Śląskie",
  },
  {
    code: "42-100",
    city: "Kłobuck",
  },
  {
    code: "42-110",
    city: "Popów",
  },
  {
    code: "42-120",
    city: "Miedźno",
  },
  {
    code: "42-122",
    city: "Ostrowy nad Okszą",
  },
  {
    code: "42-125",
    city: "Kamyk",
  },
  {
    code: "42-130",
    city: "Wręczyca",
  },
  {
    code: "42-133",
    city: "Węglowice",
  },
  {
    code: "42-134",
    city: "Truskolasy",
  },
  {
    code: "42-140",
    city: "Panki",
  },
  {
    code: "42-141",
    city: "Przystajń",
  },
  {
    code: "42-142",
    city: "Ługi-Radły",
  },
  {
    code: "42-151",
    city: "Waleńczów",
  },
  {
    code: "42-152",
    city: "Opatów",
  },
  {
    code: "42-160",
    city: "Krzepice",
  },
  {
    code: "42-161",
    city: "Starokrzepice",
  },
  {
    code: "42-164",
    city: "Parzymiechy",
  },
  {
    code: "42-165",
    city: "Lipie",
  },
  {
    code: "42-166",
    city: "Stanisławów",
  },
  {
    code: "42-200",
    city: "Częstochowa",
  },
  {
    code: "42-201",
    city: "Częstochowa",
  },
  {
    code: "42-202",
    city: "Częstochowa",
  },
  {
    code: "42-203",
    city: "Częstochowa",
  },
  {
    code: "42-205",
    city: "Częstochowa",
  },
  {
    code: "42-207",
    city: "Częstochowa",
  },
  {
    code: "42-208",
    city: "Częstochowa",
  },
  {
    code: "42-209",
    city: "Częstochowa",
  },
  {
    code: "42-210",
    city: "Częstochowa",
  },
  {
    code: "42-211",
    city: "Częstochowa",
  },
  {
    code: "42-213",
    city: "Częstochowa",
  },
  {
    code: "42-214",
    city: "Częstochowa",
  },
  {
    code: "42-215",
    city: "Częstochowa",
  },
  {
    code: "42-216",
    city: "Częstochowa",
  },
  {
    code: "42-217",
    city: "Częstochowa",
  },
  {
    code: "42-218",
    city: "Częstochowa",
  },
  {
    code: "42-219",
    city: "Częstochowa",
  },
  {
    code: "42-221",
    city: "Częstochowa",
  },
  {
    code: "42-224",
    city: "Częstochowa",
  },
  {
    code: "42-225",
    city: "Częstochowa",
  },
  {
    code: "42-226",
    city: "Częstochowa",
  },
  {
    code: "42-227",
    city: "Częstochowa",
  },
  {
    code: "42-228",
    city: "Częstochowa",
  },
  {
    code: "42-229",
    city: "Częstochowa",
  },
  {
    code: "42-230",
    city: "Koniecpol",
  },
  {
    code: "42-231",
    city: "Cykarzew Północny",
  },
  {
    code: "42-233",
    city: "Mykanów",
  },
  {
    code: "42-235",
    city: "Lelów",
  },
  {
    code: "42-240",
    city: "Rudniki",
  },
  {
    code: "42-242",
    city: "Rędziny",
  },
  {
    code: "42-244",
    city: "Mstów",
  },
  {
    code: "42-248",
    city: "Przyrów",
  },
  {
    code: "42-250",
    city: "Julianka",
  },
  {
    code: "42-253",
    city: "Janów",
  },
  {
    code: "42-256",
    city: "Olsztyn",
  },
  {
    code: "42-260",
    city: "Kamienica Polska",
  },
  {
    code: "42-261",
    city: "Starcza",
  },
  {
    code: "42-262",
    city: "Poczesna",
  },
  {
    code: "42-263",
    city: "Wrzosowa",
  },
  {
    code: "42-265",
    city: "Dąbrowa Zielona",
  },
  {
    code: "42-270",
    city: "Kłomnice",
  },
  {
    code: "42-271",
    city: "Częstochowa",
  },
  {
    code: "42-274",
    city: "Konopiska",
  },
  {
    code: "42-280",
    city: "Częstochowa",
  },
  {
    code: "42-282",
    city: "Kruszyna",
  },
  {
    code: "42-283",
    city: "Boronów",
  },
  {
    code: "42-284",
    city: "Herby",
  },
  {
    code: "42-286",
    city: "Koszęcin",
  },
  {
    code: "42-287",
    city: "Lubsza",
  },
  {
    code: "42-288",
    city: "Strzebiń",
  },
  {
    code: "42-289",
    city: "Woźniki",
  },
  {
    code: "42-290",
    city: "Blachownia",
  },
  {
    code: "42-293",
    city: "Blachownia",
  },
  {
    code: "42-294",
    city: "Częstochowa",
  },
  {
    code: "42-300",
    city: "Myszków",
  },
  {
    code: "42-310",
    city: "Żarki",
  },
  {
    code: "42-311",
    city: "Żarki-Letnisko",
  },
  {
    code: "42-320",
    city: "Niegowa",
  },
  {
    code: "42-330",
    city: "Myszków",
  },
  {
    code: "42-350",
    city: "Koziegłowy",
  },
  {
    code: "42-360",
    city: "Poraj",
  },
  {
    code: "42-400",
    city: "Zawiercie",
  },
  {
    code: "42-403",
    city: "Zawiercie",
  },
  {
    code: "42-404",
    city: "Zawiercie",
  },
  {
    code: "42-421",
    city: "Włodowice",
  },
  {
    code: "42-425",
    city: "Kroczyce",
  },
  {
    code: "42-427",
    city: "Pradła",
  },
  {
    code: "42-431",
    city: "Zawiercie",
  },
  {
    code: "42-436",
    city: "Pilica",
  },
  {
    code: "42-439",
    city: "Żarnowiec",
  },
  {
    code: "42-440",
    city: "Ogrodzieniec",
  },
  {
    code: "42-445",
    city: "Szczekociny",
  },
  {
    code: "42-446",
    city: "Irządze",
  },
  {
    code: "42-450",
    city: "Łazy",
  },
  {
    code: "42-453",
    city: "Łazy",
  },
  {
    code: "42-454",
    city: "Niegowonice",
  },
  {
    code: "42-460",
    city: "Mierzęcice",
  },
  {
    code: "42-470",
    city: "Siewierz",
  },
  {
    code: "42-480",
    city: "Poręba",
  },
  {
    code: "42-500",
    city: "Będzin",
  },
  {
    code: "42-504",
    city: "Będzin",
  },
  {
    code: "42-505",
    city: "Będzin",
  },
  {
    code: "42-506",
    city: "Będzin",
  },
  {
    code: "42-510",
    city: "Wojkowice Kościelne",
  },
  {
    code: "42-512",
    city: "Psary",
  },
  {
    code: "42-519",
    city: "Będzin",
  },
  {
    code: "42-520",
    city: "Dąbrowa Górnicza",
  },
  {
    code: "42-522",
    city: "Dąbrowa Górnicza",
  },
  {
    code: "42-523",
    city: "Dąbrowa Górnicza",
  },
  {
    code: "42-524",
    city: "Dąbrowa Górnicza",
  },
  {
    code: "42-530",
    city: "Dąbrowa Górnicza",
  },
  {
    code: "42-575",
    city: "Strzyżowice",
  },
  {
    code: "42-580",
    city: "Wojkowice",
  },
  {
    code: "42-583",
    city: "Bobrowniki",
  },
  {
    code: "42-595",
    city: "Sączów",
  },
  {
    code: "42-600",
    city: "Tarnowskie Góry",
  },
  {
    code: "42-603",
    city: "Tarnowskie Góry",
  },
  {
    code: "42-605",
    city: "Tarnowskie Góry",
  },
  {
    code: "42-606",
    city: "Tarnowskie Góry",
  },
  {
    code: "42-609",
    city: "Tarnowskie Góry",
  },
  {
    code: "42-610",
    city: "Miasteczko Śląskie",
  },
  {
    code: "42-612",
    city: "Tarnowskie Góry",
  },
  {
    code: "42-620",
    city: "Nakło",
  },
  {
    code: "42-622",
    city: "Świerklaniec",
  },
  {
    code: "42-624",
    city: "Tąpkowice",
  },
  {
    code: "42-625",
    city: "Ożarowice",
  },
  {
    code: "42-660",
    city: "Kalety",
  },
  {
    code: "42-672",
    city: "Wieszowa",
  },
  {
    code: "42-674",
    city: "Zbrosławice",
  },
  {
    code: "42-675",
    city: "Ziemięcice",
  },
  {
    code: "42-677",
    city: "Czekanów",
  },
  {
    code: "42-680",
    city: "Tarnowskie Góry",
  },
  {
    code: "42-690",
    city: "Tworóg",
  },
  {
    code: "42-693",
    city: "Krupski Młyn",
  },
  {
    code: "42-700",
    city: "Lubliniec",
  },
  {
    code: "42-703",
    city: "Lubliniec",
  },
  {
    code: "42-713",
    city: "Kochanowice",
  },
  {
    code: "42-714",
    city: "Lisów",
  },
  {
    code: "42-772",
    city: "Pawonków",
  },
  {
    code: "42-790",
    city: "Sieraków Śląski",
  },
  {
    code: "42-793",
    city: "Ciasna",
  },
  {
    code: "43-100",
    city: "Tychy",
  },
  {
    code: "43-105",
    city: "Tychy",
  },
  {
    code: "43-108",
    city: "Tychy",
  },
  {
    code: "43-109",
    city: "Tychy",
  },
  {
    code: "43-140",
    city: "Lędziny",
  },
  {
    code: "43-143",
    city: "Lędziny",
  },
  {
    code: "43-150",
    city: "Bieruń",
  },
  {
    code: "43-155",
    city: "Bieruń",
  },
  {
    code: "43-170",
    city: "Łaziska Górne",
  },
  {
    code: "43-173",
    city: "Łaziska Górne",
  },
  {
    code: "43-175",
    city: "Wyry",
  },
  {
    code: "43-176",
    city: "Gostyń",
  },
  {
    code: "43-178",
    city: "Ornontowice",
  },
  {
    code: "43-180",
    city: "Orzesze",
  },
  {
    code: "43-186",
    city: "Orzesze",
  },
  {
    code: "43-187",
    city: "Orzesze",
  },
  {
    code: "43-188",
    city: "Orzesze",
  },
  {
    code: "43-190",
    city: "Mikołów",
  },
  {
    code: "43-193",
    city: "Mikołów",
  },
  {
    code: "43-195",
    city: "Mikołów",
  },
  {
    code: "43-196",
    city: "Mikołów",
  },
  {
    code: "43-200",
    city: "Pszczyna",
  },
  {
    code: "43-210",
    city: "Kobiór",
  },
  {
    code: "43-211",
    city: "Piasek",
  },
  {
    code: "43-215",
    city: "Jankowice",
  },
  {
    code: "43-220",
    city: "Bojszowy",
  },
  {
    code: "43-225",
    city: "Wola",
  },
  {
    code: "43-227",
    city: "Miedźna",
  },
  {
    code: "43-229",
    city: "Ćwiklice",
  },
  {
    code: "43-230",
    city: "Goczałkowice-Zdrój",
  },
  {
    code: "43-241",
    city: "Łąka",
  },
  {
    code: "43-243",
    city: "Wisła Wielka",
  },
  {
    code: "43-245",
    city: "Studzionka",
  },
  {
    code: "43-246",
    city: "Strumień",
  },
  {
    code: "43-250",
    city: "Pawłowice",
  },
  {
    code: "43-251",
    city: "Pawłowice",
  },
  {
    code: "43-252",
    city: "Golasowice",
  },
  {
    code: "43-254",
    city: "Warszowice",
  },
  {
    code: "43-265",
    city: "Mizerów",
  },
  {
    code: "43-267",
    city: "Suszec",
  },
  {
    code: "43-300",
    city: "Bielsko-Biała",
  },
  {
    code: "43-301",
    city: "Bielsko-Biała",
  },
  {
    code: "43-302",
    city: "Bielsko-Biała",
  },
  {
    code: "43-303",
    city: "Bielsko-Biała",
  },
  {
    code: "43-304",
    city: "Bielsko-Biała",
  },
  {
    code: "43-305",
    city: "Bielsko-Biała",
  },
  {
    code: "43-306",
    city: "Bielsko-Biała",
  },
  {
    code: "43-307",
    city: "Bielsko-Biała",
  },
  {
    code: "43-308",
    city: "Bielsko-Biała",
  },
  {
    code: "43-309",
    city: "Bielsko-Biała",
  },
  {
    code: "43-310",
    city: "Bielsko-Biała",
  },
  {
    code: "43-311",
    city: "Bielsko-Biała",
  },
  {
    code: "43-316",
    city: "Bielsko-Biała",
  },
  {
    code: "43-317",
    city: "Bielsko-Biała",
  },
  {
    code: "43-318",
    city: "Bielsko-Biała",
  },
  {
    code: "43-319",
    city: "Bielsko-Biała",
  },
  {
    code: "43-330",
    city: "Wilamowice",
  },
  {
    code: "43-331",
    city: "Dankowice",
  },
  {
    code: "43-332",
    city: "Pisarzowice",
  },
  {
    code: "43-340",
    city: "Kozy",
  },
  {
    code: "43-344",
    city: "Bielsko-Biała",
  },
  {
    code: "43-346",
    city: "Bielsko-Biała",
  },
  {
    code: "43-350",
    city: "Bielsko-Biała",
  },
  {
    code: "43-353",
    city: "Porąbka",
  },
  {
    code: "43-354",
    city: "Czaniec",
  },
  {
    code: "43-356",
    city: "Kobiernice",
  },
  {
    code: "43-360",
    city: "Bystra Śląska",
  },
  {
    code: "43-365",
    city: "Wilkowice",
  },
  {
    code: "43-370",
    city: "Szczyrk",
  },
  {
    code: "43-374",
    city: "Buczkowice",
  },
  {
    code: "43-376",
    city: "Godziszka",
  },
  {
    code: "43-378",
    city: "Rybarzowice",
  },
  {
    code: "43-382",
    city: "Bielsko-Biała",
  },
  {
    code: "43-384",
    city: "Jaworze",
  },
  {
    code: "43-385",
    city: "Jasienica",
  },
  {
    code: "43-386",
    city: "Świętoszówka",
  },
  {
    code: "43-391",
    city: "Mazańcowice",
  },
  {
    code: "43-392",
    city: "Międzyrzecze",
  },
  {
    code: "43-394",
    city: "Rudzica",
  },
  {
    code: "43-400",
    city: "Cieszyn",
  },
  {
    code: "43-410",
    city: "Zebrzydowice",
  },
  {
    code: "43-417",
    city: "Kaczyce",
  },
  {
    code: "43-418",
    city: "Pogwizdów",
  },
  {
    code: "43-419",
    city: "Hażlach",
  },
  {
    code: "43-424",
    city: "Drogomyśl",
  },
  {
    code: "43-426",
    city: "Dębowiec",
  },
  {
    code: "43-430",
    city: "Skoczów",
  },
  {
    code: "43-436",
    city: "Górki Wielkie",
  },
  {
    code: "43-438",
    city: "Brenna",
  },
  {
    code: "43-440",
    city: "Goleszów",
  },
  {
    code: "43-445",
    city: "Dzięgielów",
  },
  {
    code: "43-450",
    city: "Ustroń",
  },
  {
    code: "43-460",
    city: "Wisła",
  },
  {
    code: "43-470",
    city: "Istebna",
  },
  {
    code: "43-474",
    city: "Koniaków",
  },
  {
    code: "43-476",
    city: "Jaworzynka",
  },
  {
    code: "43-500",
    city: "Czechowice-Dziedzice",
  },
  {
    code: "43-502",
    city: "Czechowice-Dziedzice",
  },
  {
    code: "43-503",
    city: "Czechowice-Dziedzice",
  },
  {
    code: "43-512",
    city: "Bestwina",
  },
  {
    code: "43-516",
    city: "Zabrzeg",
  },
  {
    code: "43-518",
    city: "Ligota",
  },
  {
    code: "43-520",
    city: "Chybie",
  },
  {
    code: "43-523",
    city: "Pruchna",
  },
  {
    code: "43-600",
    city: "Jaworzno",
  },
  {
    code: "43-602",
    city: "Jaworzno",
  },
  {
    code: "43-603",
    city: "Jaworzno",
  },
  {
    code: "43-605",
    city: "Jaworzno",
  },
  {
    code: "43-607",
    city: "Jaworzno",
  },
  {
    code: "43-608",
    city: "Jaworzno",
  },
  {
    code: "43-609",
    city: "Jaworzno",
  },
  {
    code: "44-100",
    city: "Gliwice",
  },
  {
    code: "44-102",
    city: "Gliwice",
  },
  {
    code: "44-103",
    city: "Gliwice",
  },
  {
    code: "44-105",
    city: "Gliwice",
  },
  {
    code: "44-106",
    city: "Gliwice",
  },
  {
    code: "44-107",
    city: "Gliwice",
  },
  {
    code: "44-109",
    city: "Gliwice",
  },
  {
    code: "44-113",
    city: "Gliwice",
  },
  {
    code: "44-114",
    city: "Gliwice",
  },
  {
    code: "44-117",
    city: "Gliwice",
  },
  {
    code: "44-119",
    city: "Gliwice",
  },
  {
    code: "44-120",
    city: "Pyskowice",
  },
  {
    code: "44-121",
    city: "Gliwice",
  },
  {
    code: "44-122",
    city: "Gliwice",
  },
  {
    code: "44-141",
    city: "Gliwice",
  },
  {
    code: "44-144",
    city: "Żernica",
  },
  {
    code: "44-145",
    city: "Pilchowice",
  },
  {
    code: "44-151",
    city: "Gliwice",
  },
  {
    code: "44-152",
    city: "Gliwice",
  },
  {
    code: "44-153",
    city: "Sośnicowice",
  },
  {
    code: "44-156",
    city: "Sierakowice",
  },
  {
    code: "44-160",
    city: "Rudziniec",
  },
  {
    code: "44-164",
    city: "Gliwice",
  },
  {
    code: "44-171",
    city: "Pławniowice",
  },
  {
    code: "44-172",
    city: "Poniszowice",
  },
  {
    code: "44-177",
    city: "Paniówki",
  },
  {
    code: "44-178",
    city: "Przyszowice",
  },
  {
    code: "44-180",
    city: "Toszek",
  },
  {
    code: "44-186",
    city: "Gierałtowice",
  },
  {
    code: "44-187",
    city: "Wielowieś",
  },
  {
    code: "44-189",
    city: "Wilcza",
  },
  {
    code: "44-190",
    city: "Knurów",
  },
  {
    code: "44-193",
    city: "Knurów",
  },
  {
    code: "44-194",
    city: "Knurów",
  },
  {
    code: "44-196",
    city: "Knurów",
  },
  {
    code: "44-200",
    city: "Rybnik",
  },
  {
    code: "44-201",
    city: "Rybnik",
  },
  {
    code: "44-203",
    city: "Rybnik",
  },
  {
    code: "44-206",
    city: "Rybnik",
  },
  {
    code: "44-207",
    city: "Rybnik",
  },
  {
    code: "44-210",
    city: "Rybnik",
  },
  {
    code: "44-213",
    city: "Rybnik",
  },
  {
    code: "44-217",
    city: "Rybnik",
  },
  {
    code: "44-218",
    city: "Rybnik",
  },
  {
    code: "44-230",
    city: "Czerwionka-Leszczyny",
  },
  {
    code: "44-238",
    city: "Czerwionka-Leszczyny",
  },
  {
    code: "44-240",
    city: "Żory",
  },
  {
    code: "44-244",
    city: "Żory",
  },
  {
    code: "44-246",
    city: "Palowice",
  },
  {
    code: "44-250",
    city: "Rybnik",
  },
  {
    code: "44-251",
    city: "Rybnik",
  },
  {
    code: "44-253",
    city: "Rybnik",
  },
  {
    code: "44-264",
    city: "Jankowice Rybnickie",
  },
  {
    code: "44-266",
    city: "Świerklany Górne",
  },
  {
    code: "44-268",
    city: "Jastrzębie-Zdrój",
  },
  {
    code: "44-270",
    city: "Rybnik",
  },
  {
    code: "44-274",
    city: "Rybnik",
  },
  {
    code: "44-280",
    city: "Rydułtowy",
  },
  {
    code: "44-282",
    city: "Czernica",
  },
  {
    code: "44-284",
    city: "Pstrążna",
  },
  {
    code: "44-285",
    city: "Kornowac",
  },
  {
    code: "44-286",
    city: "Wodzisław Śląski",
  },
  {
    code: "44-290",
    city: "Jejkowice",
  },
  {
    code: "44-293",
    city: "Gaszowice",
  },
  {
    code: "44-295",
    city: "Lyski",
  },
  {
    code: "44-300",
    city: "Wodzisław Śląski",
  },
  {
    code: "44-304",
    city: "Wodzisław Śląski",
  },
  {
    code: "44-307",
    city: "Wodzisław Śląski",
  },
  {
    code: "44-310",
    city: "Radlin",
  },
  {
    code: "44-313",
    city: "Wodzisław Śląski",
  },
  {
    code: "44-314",
    city: "Radlin",
  },
  {
    code: "44-321",
    city: "Marklowice",
  },
  {
    code: "44-323",
    city: "Połomia",
  },
  {
    code: "44-325",
    city: "Mszana",
  },
  {
    code: "44-330",
    city: "Jastrzębie-Zdrój",
  },
  {
    code: "44-335",
    city: "Jastrzębie-Zdrój",
  },
  {
    code: "44-336",
    city: "Jastrzębie-Zdrój",
  },
  {
    code: "44-337",
    city: "Jastrzębie-Zdrój",
  },
  {
    code: "44-338",
    city: "Jastrzębie-Zdrój",
  },
  {
    code: "44-340",
    city: "Godów",
  },
  {
    code: "44-341",
    city: "Gołkowice",
  },
  {
    code: "44-348",
    city: "Skrzyszów",
  },
  {
    code: "44-350",
    city: "Gorzyce",
  },
  {
    code: "44-351",
    city: "Turza Śląska",
  },
  {
    code: "44-352",
    city: "Czyżowice",
  },
  {
    code: "44-360",
    city: "Lubomia",
  },
  {
    code: "44-362",
    city: "Rogów",
  },
  {
    code: "44-370",
    city: "Pszów",
  },
  {
    code: "44-373",
    city: "Wodzisław Śląski",
  },
  {
    code: "44-401",
    city: "Gliwice",
  },
  {
    code: "45-001",
    city: "Opole",
  },
  {
    code: "45-002",
    city: "Opole",
  },
  {
    code: "45-003",
    city: "Opole",
  },
  {
    code: "45-004",
    city: "Opole",
  },
  {
    code: "45-005",
    city: "Opole",
  },
  {
    code: "45-006",
    city: "Opole",
  },
  {
    code: "45-007",
    city: "Opole",
  },
  {
    code: "45-009",
    city: "Opole",
  },
  {
    code: "45-010",
    city: "Opole",
  },
  {
    code: "45-011",
    city: "Opole",
  },
  {
    code: "45-012",
    city: "Opole",
  },
  {
    code: "45-013",
    city: "Opole",
  },
  {
    code: "45-015",
    city: "Opole",
  },
  {
    code: "45-016",
    city: "Opole",
  },
  {
    code: "45-017",
    city: "Opole",
  },
  {
    code: "45-018",
    city: "Opole",
  },
  {
    code: "45-019",
    city: "Opole",
  },
  {
    code: "45-020",
    city: "Opole",
  },
  {
    code: "45-021",
    city: "Opole",
  },
  {
    code: "45-022",
    city: "Opole",
  },
  {
    code: "45-023",
    city: "Opole",
  },
  {
    code: "45-024",
    city: "Opole",
  },
  {
    code: "45-025",
    city: "Opole",
  },
  {
    code: "45-026",
    city: "Opole",
  },
  {
    code: "45-027",
    city: "Opole",
  },
  {
    code: "45-030",
    city: "Opole",
  },
  {
    code: "45-031",
    city: "Opole",
  },
  {
    code: "45-032",
    city: "Opole",
  },
  {
    code: "45-033",
    city: "Opole",
  },
  {
    code: "45-034",
    city: "Opole",
  },
  {
    code: "45-035",
    city: "Opole",
  },
  {
    code: "45-036",
    city: "Opole",
  },
  {
    code: "45-037",
    city: "Opole",
  },
  {
    code: "45-038",
    city: "Opole",
  },
  {
    code: "45-039",
    city: "Opole",
  },
  {
    code: "45-040",
    city: "Opole",
  },
  {
    code: "45-044",
    city: "Opole",
  },
  {
    code: "45-045",
    city: "Opole",
  },
  {
    code: "45-046",
    city: "Opole",
  },
  {
    code: "45-047",
    city: "Opole",
  },
  {
    code: "45-048",
    city: "Opole",
  },
  {
    code: "45-049",
    city: "Opole",
  },
  {
    code: "45-050",
    city: "Opole",
  },
  {
    code: "45-051",
    city: "Opole",
  },
  {
    code: "45-052",
    city: "Opole",
  },
  {
    code: "45-053",
    city: "Opole",
  },
  {
    code: "45-054",
    city: "Opole",
  },
  {
    code: "45-055",
    city: "Opole",
  },
  {
    code: "45-056",
    city: "Opole",
  },
  {
    code: "45-057",
    city: "Opole",
  },
  {
    code: "45-058",
    city: "Opole",
  },
  {
    code: "45-059",
    city: "Opole",
  },
  {
    code: "45-061",
    city: "Opole",
  },
  {
    code: "45-062",
    city: "Opole",
  },
  {
    code: "45-064",
    city: "Opole",
  },
  {
    code: "45-065",
    city: "Opole",
  },
  {
    code: "45-066",
    city: "Opole",
  },
  {
    code: "45-067",
    city: "Opole",
  },
  {
    code: "45-068",
    city: "Opole",
  },
  {
    code: "45-069",
    city: "Opole",
  },
  {
    code: "45-070",
    city: "Opole",
  },
  {
    code: "45-071",
    city: "Opole",
  },
  {
    code: "45-072",
    city: "Opole",
  },
  {
    code: "45-073",
    city: "Opole",
  },
  {
    code: "45-075",
    city: "Opole",
  },
  {
    code: "45-076",
    city: "Opole",
  },
  {
    code: "45-077",
    city: "Opole",
  },
  {
    code: "45-078",
    city: "Opole",
  },
  {
    code: "45-079",
    city: "Opole",
  },
  {
    code: "45-080",
    city: "Opole",
  },
  {
    code: "45-081",
    city: "Opole",
  },
  {
    code: "45-083",
    city: "Opole",
  },
  {
    code: "45-084",
    city: "Opole",
  },
  {
    code: "45-085",
    city: "Opole",
  },
  {
    code: "45-086",
    city: "Opole",
  },
  {
    code: "45-087",
    city: "Opole",
  },
  {
    code: "45-088",
    city: "Opole",
  },
  {
    code: "45-089",
    city: "Opole",
  },
  {
    code: "45-090",
    city: "Opole",
  },
  {
    code: "45-091",
    city: "Opole",
  },
  {
    code: "45-092",
    city: "Opole",
  },
  {
    code: "45-094",
    city: "Opole",
  },
  {
    code: "45-108",
    city: "Opole",
  },
  {
    code: "45-109",
    city: "Opole",
  },
  {
    code: "45-110",
    city: "Opole",
  },
  {
    code: "45-111",
    city: "Opole",
  },
  {
    code: "45-112",
    city: "Opole",
  },
  {
    code: "45-113",
    city: "Opole",
  },
  {
    code: "45-114",
    city: "Opole",
  },
  {
    code: "45-115",
    city: "Opole",
  },
  {
    code: "45-116",
    city: "Opole",
  },
  {
    code: "45-117",
    city: "Opole",
  },
  {
    code: "45-118",
    city: "Opole",
  },
  {
    code: "45-119",
    city: "Opole",
  },
  {
    code: "45-121",
    city: "Opole",
  },
  {
    code: "45-123",
    city: "Opole",
  },
  {
    code: "45-125",
    city: "Opole",
  },
  {
    code: "45-126",
    city: "Opole",
  },
  {
    code: "45-127",
    city: "Opole",
  },
  {
    code: "45-128",
    city: "Opole",
  },
  {
    code: "45-129",
    city: "Opole",
  },
  {
    code: "45-131",
    city: "Opole",
  },
  {
    code: "45-132",
    city: "Opole",
  },
  {
    code: "45-133",
    city: "Opole",
  },
  {
    code: "45-134",
    city: "Opole",
  },
  {
    code: "45-135",
    city: "Opole",
  },
  {
    code: "45-136",
    city: "Opole",
  },
  {
    code: "45-137",
    city: "Opole",
  },
  {
    code: "45-138",
    city: "Opole",
  },
  {
    code: "45-139",
    city: "Opole",
  },
  {
    code: "45-141",
    city: "Opole",
  },
  {
    code: "45-142",
    city: "Opole",
  },
  {
    code: "45-143",
    city: "Opole",
  },
  {
    code: "45-144",
    city: "Opole",
  },
  {
    code: "45-145",
    city: "Opole",
  },
  {
    code: "45-215",
    city: "Opole",
  },
  {
    code: "45-217",
    city: "Opole",
  },
  {
    code: "45-218",
    city: "Opole",
  },
  {
    code: "45-219",
    city: "Opole",
  },
  {
    code: "45-220",
    city: "Opole",
  },
  {
    code: "45-221",
    city: "Opole",
  },
  {
    code: "45-222",
    city: "Opole",
  },
  {
    code: "45-223",
    city: "Opole",
  },
  {
    code: "45-224",
    city: "Opole",
  },
  {
    code: "45-225",
    city: "Opole",
  },
  {
    code: "45-226",
    city: "Opole",
  },
  {
    code: "45-227",
    city: "Opole",
  },
  {
    code: "45-228",
    city: "Opole",
  },
  {
    code: "45-229",
    city: "Opole",
  },
  {
    code: "45-230",
    city: "Opole",
  },
  {
    code: "45-231",
    city: "Opole",
  },
  {
    code: "45-232",
    city: "Opole",
  },
  {
    code: "45-233",
    city: "Opole",
  },
  {
    code: "45-234",
    city: "Opole",
  },
  {
    code: "45-235",
    city: "Opole",
  },
  {
    code: "45-236",
    city: "Opole",
  },
  {
    code: "45-237",
    city: "Opole",
  },
  {
    code: "45-238",
    city: "Opole",
  },
  {
    code: "45-239",
    city: "Opole",
  },
  {
    code: "45-240",
    city: "Opole",
  },
  {
    code: "45-241",
    city: "Opole",
  },
  {
    code: "45-265",
    city: "Opole",
  },
  {
    code: "45-266",
    city: "Opole",
  },
  {
    code: "45-267",
    city: "Opole",
  },
  {
    code: "45-268",
    city: "Opole",
  },
  {
    code: "45-269",
    city: "Opole",
  },
  {
    code: "45-271",
    city: "Opole",
  },
  {
    code: "45-272",
    city: "Opole",
  },
  {
    code: "45-273",
    city: "Opole",
  },
  {
    code: "45-282",
    city: "Opole",
  },
  {
    code: "45-283",
    city: "Opole",
  },
  {
    code: "45-284",
    city: "Opole",
  },
  {
    code: "45-285",
    city: "Opole",
  },
  {
    code: "45-286",
    city: "Opole",
  },
  {
    code: "45-287",
    city: "Opole",
  },
  {
    code: "45-288",
    city: "Opole",
  },
  {
    code: "45-290",
    city: "Opole",
  },
  {
    code: "45-291",
    city: "Opole",
  },
  {
    code: "45-301",
    city: "Opole",
  },
  {
    code: "45-302",
    city: "Opole",
  },
  {
    code: "45-303",
    city: "Opole",
  },
  {
    code: "45-304",
    city: "Opole",
  },
  {
    code: "45-305",
    city: "Opole",
  },
  {
    code: "45-306",
    city: "Opole",
  },
  {
    code: "45-307",
    city: "Opole",
  },
  {
    code: "45-308",
    city: "Opole",
  },
  {
    code: "45-309",
    city: "Opole",
  },
  {
    code: "45-310",
    city: "Opole",
  },
  {
    code: "45-311",
    city: "Opole",
  },
  {
    code: "45-312",
    city: "Opole",
  },
  {
    code: "45-313",
    city: "Opole",
  },
  {
    code: "45-314",
    city: "Opole",
  },
  {
    code: "45-315",
    city: "Opole",
  },
  {
    code: "45-316",
    city: "Opole",
  },
  {
    code: "45-317",
    city: "Opole",
  },
  {
    code: "45-318",
    city: "Opole",
  },
  {
    code: "45-319",
    city: "Opole",
  },
  {
    code: "45-320",
    city: "Opole",
  },
  {
    code: "45-321",
    city: "Opole",
  },
  {
    code: "45-323",
    city: "Opole",
  },
  {
    code: "45-324",
    city: "Opole",
  },
  {
    code: "45-325",
    city: "Opole",
  },
  {
    code: "45-326",
    city: "Opole",
  },
  {
    code: "45-331",
    city: "Opole",
  },
  {
    code: "45-332",
    city: "Opole",
  },
  {
    code: "45-339",
    city: "Opole",
  },
  {
    code: "45-340",
    city: "Opole",
  },
  {
    code: "45-342",
    city: "Opole",
  },
  {
    code: "45-344",
    city: "Opole",
  },
  {
    code: "45-346",
    city: "Opole",
  },
  {
    code: "45-347",
    city: "Opole",
  },
  {
    code: "45-348",
    city: "Opole",
  },
  {
    code: "45-349",
    city: "Opole",
  },
  {
    code: "45-351",
    city: "Opole",
  },
  {
    code: "45-352",
    city: "Opole",
  },
  {
    code: "45-353",
    city: "Opole",
  },
  {
    code: "45-354",
    city: "Opole",
  },
  {
    code: "45-355",
    city: "Opole",
  },
  {
    code: "45-356",
    city: "Opole",
  },
  {
    code: "45-357",
    city: "Opole",
  },
  {
    code: "45-358",
    city: "Opole",
  },
  {
    code: "45-359",
    city: "Opole",
  },
  {
    code: "45-360",
    city: "Opole",
  },
  {
    code: "45-361",
    city: "Opole",
  },
  {
    code: "45-362",
    city: "Opole",
  },
  {
    code: "45-363",
    city: "Opole",
  },
  {
    code: "45-364",
    city: "Opole",
  },
  {
    code: "45-365",
    city: "Opole",
  },
  {
    code: "45-367",
    city: "Opole",
  },
  {
    code: "45-368",
    city: "Opole",
  },
  {
    code: "45-370",
    city: "Opole",
  },
  {
    code: "45-371",
    city: "Opole",
  },
  {
    code: "45-372",
    city: "Opole",
  },
  {
    code: "45-373",
    city: "Opole",
  },
  {
    code: "45-401",
    city: "Opole",
  },
  {
    code: "45-402",
    city: "Opole",
  },
  {
    code: "45-403",
    city: "Opole",
  },
  {
    code: "45-404",
    city: "Opole",
  },
  {
    code: "45-405",
    city: "Opole",
  },
  {
    code: "45-406",
    city: "Opole",
  },
  {
    code: "45-407",
    city: "Opole",
  },
  {
    code: "45-408",
    city: "Opole",
  },
  {
    code: "45-409",
    city: "Opole",
  },
  {
    code: "45-410",
    city: "Opole",
  },
  {
    code: "45-411",
    city: "Opole",
  },
  {
    code: "45-413",
    city: "Opole",
  },
  {
    code: "45-414",
    city: "Opole",
  },
  {
    code: "45-415",
    city: "Opole",
  },
  {
    code: "45-416",
    city: "Opole",
  },
  {
    code: "45-417",
    city: "Opole",
  },
  {
    code: "45-418",
    city: "Opole",
  },
  {
    code: "45-419",
    city: "Opole",
  },
  {
    code: "45-420",
    city: "Opole",
  },
  {
    code: "45-424",
    city: "Opole",
  },
  {
    code: "45-425",
    city: "Opole",
  },
  {
    code: "45-427",
    city: "Opole",
  },
  {
    code: "45-428",
    city: "Opole",
  },
  {
    code: "45-429",
    city: "Opole",
  },
  {
    code: "45-430",
    city: "Opole",
  },
  {
    code: "45-431",
    city: "Opole",
  },
  {
    code: "45-432",
    city: "Opole",
  },
  {
    code: "45-433",
    city: "Opole",
  },
  {
    code: "45-434",
    city: "Opole",
  },
  {
    code: "45-435",
    city: "Opole",
  },
  {
    code: "45-436",
    city: "Opole",
  },
  {
    code: "45-437",
    city: "Opole",
  },
  {
    code: "45-438",
    city: "Opole",
  },
  {
    code: "45-439",
    city: "Opole",
  },
  {
    code: "45-440",
    city: "Opole",
  },
  {
    code: "45-441",
    city: "Opole",
  },
  {
    code: "45-442",
    city: "Opole",
  },
  {
    code: "45-443",
    city: "Opole",
  },
  {
    code: "45-446",
    city: "Opole",
  },
  {
    code: "45-449",
    city: "Opole",
  },
  {
    code: "45-459",
    city: "Opole",
  },
  {
    code: "45-460",
    city: "Opole",
  },
  {
    code: "45-461",
    city: "Opole",
  },
  {
    code: "45-462",
    city: "Opole",
  },
  {
    code: "45-463",
    city: "Opole",
  },
  {
    code: "45-464",
    city: "Opole",
  },
  {
    code: "45-465",
    city: "Opole",
  },
  {
    code: "45-466",
    city: "Opole",
  },
  {
    code: "45-467",
    city: "Opole",
  },
  {
    code: "45-468",
    city: "Opole",
  },
  {
    code: "45-469",
    city: "Opole",
  },
  {
    code: "45-470",
    city: "Opole",
  },
  {
    code: "45-471",
    city: "Opole",
  },
  {
    code: "45-472",
    city: "Opole",
  },
  {
    code: "45-473",
    city: "Opole",
  },
  {
    code: "45-474",
    city: "Opole",
  },
  {
    code: "45-475",
    city: "Opole",
  },
  {
    code: "45-476",
    city: "Opole",
  },
  {
    code: "45-477",
    city: "Opole",
  },
  {
    code: "45-478",
    city: "Opole",
  },
  {
    code: "45-512",
    city: "Opole",
  },
  {
    code: "45-513",
    city: "Opole",
  },
  {
    code: "45-515",
    city: "Opole",
  },
  {
    code: "45-516",
    city: "Opole",
  },
  {
    code: "45-517",
    city: "Opole",
  },
  {
    code: "45-518",
    city: "Opole",
  },
  {
    code: "45-519",
    city: "Opole",
  },
  {
    code: "45-520",
    city: "Opole",
  },
  {
    code: "45-521",
    city: "Opole",
  },
  {
    code: "45-522",
    city: "Opole",
  },
  {
    code: "45-523",
    city: "Opole",
  },
  {
    code: "45-524",
    city: "Opole",
  },
  {
    code: "45-525",
    city: "Opole",
  },
  {
    code: "45-526",
    city: "Opole",
  },
  {
    code: "45-527",
    city: "Opole",
  },
  {
    code: "45-528",
    city: "Opole",
  },
  {
    code: "45-529",
    city: "Opole",
  },
  {
    code: "45-530",
    city: "Opole",
  },
  {
    code: "45-531",
    city: "Opole",
  },
  {
    code: "45-532",
    city: "Opole",
  },
  {
    code: "45-533",
    city: "Opole",
  },
  {
    code: "45-534",
    city: "Opole",
  },
  {
    code: "45-535",
    city: "Opole",
  },
  {
    code: "45-536",
    city: "Opole",
  },
  {
    code: "45-542",
    city: "Opole",
  },
  {
    code: "45-543",
    city: "Opole",
  },
  {
    code: "45-550",
    city: "Opole",
  },
  {
    code: "45-551",
    city: "Opole",
  },
  {
    code: "45-552",
    city: "Opole",
  },
  {
    code: "45-553",
    city: "Opole",
  },
  {
    code: "45-554",
    city: "Opole",
  },
  {
    code: "45-555",
    city: "Opole",
  },
  {
    code: "45-556",
    city: "Opole",
  },
  {
    code: "45-557",
    city: "Opole",
  },
  {
    code: "45-558",
    city: "Opole",
  },
  {
    code: "45-559",
    city: "Opole",
  },
  {
    code: "45-560",
    city: "Opole",
  },
  {
    code: "45-561",
    city: "Opole",
  },
  {
    code: "45-562",
    city: "Opole",
  },
  {
    code: "45-563",
    city: "Opole",
  },
  {
    code: "45-564",
    city: "Opole",
  },
  {
    code: "45-565",
    city: "Opole",
  },
  {
    code: "45-568",
    city: "Opole",
  },
  {
    code: "45-569",
    city: "Opole",
  },
  {
    code: "45-570",
    city: "Opole",
  },
  {
    code: "45-571",
    city: "Opole",
  },
  {
    code: "45-572",
    city: "Opole",
  },
  {
    code: "45-573",
    city: "Opole",
  },
  {
    code: "45-574",
    city: "Opole",
  },
  {
    code: "45-575",
    city: "Opole",
  },
  {
    code: "45-577",
    city: "Opole",
  },
  {
    code: "45-578",
    city: "Opole",
  },
  {
    code: "45-580",
    city: "Opole",
  },
  {
    code: "45-586",
    city: "Opole",
  },
  {
    code: "45-587",
    city: "Opole",
  },
  {
    code: "45-588",
    city: "Opole",
  },
  {
    code: "45-590",
    city: "Opole",
  },
  {
    code: "45-591",
    city: "Opole",
  },
  {
    code: "45-592",
    city: "Opole",
  },
  {
    code: "45-593",
    city: "Opole",
  },
  {
    code: "45-594",
    city: "Opole",
  },
  {
    code: "45-601",
    city: "Opole",
  },
  {
    code: "45-612",
    city: "Opole",
  },
  {
    code: "45-618",
    city: "Opole",
  },
  {
    code: "45-622",
    city: "Opole",
  },
  {
    code: "45-623",
    city: "Opole",
  },
  {
    code: "45-624",
    city: "Opole",
  },
  {
    code: "45-625",
    city: "Opole",
  },
  {
    code: "45-626",
    city: "Opole",
  },
  {
    code: "45-627",
    city: "Opole",
  },
  {
    code: "45-628",
    city: "Opole",
  },
  {
    code: "45-630",
    city: "Opole",
  },
  {
    code: "45-631",
    city: "Opole",
  },
  {
    code: "45-632",
    city: "Opole",
  },
  {
    code: "45-633",
    city: "Opole",
  },
  {
    code: "45-634",
    city: "Opole",
  },
  {
    code: "45-635",
    city: "Opole",
  },
  {
    code: "45-636",
    city: "Opole",
  },
  {
    code: "45-638",
    city: "Opole",
  },
  {
    code: "45-639",
    city: "Opole",
  },
  {
    code: "45-640",
    city: "Opole",
  },
  {
    code: "45-641",
    city: "Opole",
  },
  {
    code: "45-642",
    city: "Opole",
  },
  {
    code: "45-644",
    city: "Opole",
  },
  {
    code: "45-645",
    city: "Opole",
  },
  {
    code: "45-646",
    city: "Opole",
  },
  {
    code: "45-647",
    city: "Opole",
  },
  {
    code: "45-648",
    city: "Opole",
  },
  {
    code: "45-649",
    city: "Opole",
  },
  {
    code: "45-650",
    city: "Opole",
  },
  {
    code: "45-651",
    city: "Opole",
  },
  {
    code: "45-652",
    city: "Opole",
  },
  {
    code: "45-653",
    city: "Opole",
  },
  {
    code: "45-654",
    city: "Opole",
  },
  {
    code: "45-655",
    city: "Opole",
  },
  {
    code: "45-656",
    city: "Opole",
  },
  {
    code: "45-660",
    city: "Opole",
  },
  {
    code: "45-661",
    city: "Opole",
  },
  {
    code: "45-662",
    city: "Opole",
  },
  {
    code: "45-663",
    city: "Opole",
  },
  {
    code: "45-665",
    city: "Opole",
  },
  {
    code: "45-667",
    city: "Opole",
  },
  {
    code: "45-668",
    city: "Opole",
  },
  {
    code: "45-669",
    city: "Opole",
  },
  {
    code: "45-670",
    city: "Opole",
  },
  {
    code: "45-671",
    city: "Opole",
  },
  {
    code: "45-675",
    city: "Opole",
  },
  {
    code: "45-676",
    city: "Opole",
  },
  {
    code: "45-677",
    city: "Opole",
  },
  {
    code: "45-678",
    city: "Opole",
  },
  {
    code: "45-679",
    city: "Opole",
  },
  {
    code: "45-680",
    city: "Opole",
  },
  {
    code: "45-681",
    city: "Opole",
  },
  {
    code: "45-682",
    city: "Opole",
  },
  {
    code: "45-683",
    city: "Opole",
  },
  {
    code: "45-684",
    city: "Opole",
  },
  {
    code: "45-685",
    city: "Opole",
  },
  {
    code: "45-686",
    city: "Opole",
  },
  {
    code: "45-687",
    city: "Opole",
  },
  {
    code: "45-688",
    city: "Opole",
  },
  {
    code: "45-701",
    city: "Opole",
  },
  {
    code: "45-702",
    city: "Opole",
  },
  {
    code: "45-703",
    city: "Opole",
  },
  {
    code: "45-704",
    city: "Opole",
  },
  {
    code: "45-705",
    city: "Opole",
  },
  {
    code: "45-706",
    city: "Opole",
  },
  {
    code: "45-707",
    city: "Opole",
  },
  {
    code: "45-708",
    city: "Opole",
  },
  {
    code: "45-709",
    city: "Opole",
  },
  {
    code: "45-710",
    city: "Opole",
  },
  {
    code: "45-711",
    city: "Opole",
  },
  {
    code: "45-712",
    city: "Opole",
  },
  {
    code: "45-713",
    city: "Opole",
  },
  {
    code: "45-714",
    city: "Opole",
  },
  {
    code: "45-715",
    city: "Opole",
  },
  {
    code: "45-716",
    city: "Opole",
  },
  {
    code: "45-717",
    city: "Opole",
  },
  {
    code: "45-720",
    city: "Opole",
  },
  {
    code: "45-721",
    city: "Opole",
  },
  {
    code: "45-722",
    city: "Opole",
  },
  {
    code: "45-723",
    city: "Opole",
  },
  {
    code: "45-724",
    city: "Opole",
  },
  {
    code: "45-725",
    city: "Opole",
  },
  {
    code: "45-726",
    city: "Opole",
  },
  {
    code: "45-751",
    city: "Opole",
  },
  {
    code: "45-752",
    city: "Opole",
  },
  {
    code: "45-753",
    city: "Opole",
  },
  {
    code: "45-754",
    city: "Opole",
  },
  {
    code: "45-755",
    city: "Opole",
  },
  {
    code: "45-756",
    city: "Opole",
  },
  {
    code: "45-757",
    city: "Opole",
  },
  {
    code: "45-758",
    city: "Opole",
  },
  {
    code: "45-759",
    city: "Opole",
  },
  {
    code: "45-760",
    city: "Opole",
  },
  {
    code: "45-761",
    city: "Opole",
  },
  {
    code: "45-762",
    city: "Opole",
  },
  {
    code: "45-763",
    city: "Opole",
  },
  {
    code: "45-765",
    city: "Opole",
  },
  {
    code: "45-766",
    city: "Opole",
  },
  {
    code: "45-767",
    city: "Opole",
  },
  {
    code: "45-771",
    city: "Opole",
  },
  {
    code: "45-772",
    city: "Opole",
  },
  {
    code: "45-773",
    city: "Opole",
  },
  {
    code: "45-774",
    city: "Opole",
  },
  {
    code: "45-776",
    city: "Opole",
  },
  {
    code: "45-801",
    city: "Opole",
  },
  {
    code: "45-802",
    city: "Opole",
  },
  {
    code: "45-803",
    city: "Opole",
  },
  {
    code: "45-804",
    city: "Opole",
  },
  {
    code: "45-805",
    city: "Opole",
  },
  {
    code: "45-809",
    city: "Opole",
  },
  {
    code: "45-811",
    city: "Opole",
  },
  {
    code: "45-814",
    city: "Opole",
  },
  {
    code: "45-815",
    city: "Opole",
  },
  {
    code: "45-819",
    city: "Opole",
  },
  {
    code: "45-820",
    city: "Opole",
  },
  {
    code: "45-821",
    city: "Opole",
  },
  {
    code: "45-822",
    city: "Opole",
  },
  {
    code: "45-823",
    city: "Opole",
  },
  {
    code: "45-824",
    city: "Opole",
  },
  {
    code: "45-825",
    city: "Opole",
  },
  {
    code: "45-826",
    city: "Opole",
  },
  {
    code: "45-827",
    city: "Opole",
  },
  {
    code: "45-828",
    city: "Opole",
  },
  {
    code: "45-829",
    city: "Opole",
  },
  {
    code: "45-830",
    city: "Opole",
  },
  {
    code: "45-831",
    city: "Opole",
  },
  {
    code: "45-832",
    city: "Opole",
  },
  {
    code: "45-833",
    city: "Opole",
  },
  {
    code: "45-834",
    city: "Opole",
  },
  {
    code: "45-835",
    city: "Opole",
  },
  {
    code: "45-837",
    city: "Opole",
  },
  {
    code: "45-838",
    city: "Opole",
  },
  {
    code: "45-839",
    city: "Opole",
  },
  {
    code: "45-840",
    city: "Opole",
  },
  {
    code: "45-841",
    city: "Opole",
  },
  {
    code: "45-842",
    city: "Opole",
  },
  {
    code: "45-843",
    city: "Opole",
  },
  {
    code: "45-844",
    city: "Opole",
  },
  {
    code: "45-850",
    city: "Opole",
  },
  {
    code: "45-852",
    city: "Opole",
  },
  {
    code: "45-853",
    city: "Opole",
  },
  {
    code: "45-854",
    city: "Opole",
  },
  {
    code: "45-855",
    city: "Opole",
  },
  {
    code: "45-856",
    city: "Opole",
  },
  {
    code: "45-857",
    city: "Opole",
  },
  {
    code: "45-858",
    city: "Opole",
  },
  {
    code: "45-859",
    city: "Opole",
  },
  {
    code: "45-860",
    city: "Opole",
  },
  {
    code: "45-861",
    city: "Opole",
  },
  {
    code: "45-862",
    city: "Opole",
  },
  {
    code: "45-863",
    city: "Opole",
  },
  {
    code: "45-864",
    city: "Opole",
  },
  {
    code: "45-865",
    city: "Opole",
  },
  {
    code: "45-867",
    city: "Opole",
  },
  {
    code: "45-899",
    city: "Opole",
  },
  {
    code: "45-910",
    city: "Opole",
  },
  {
    code: "46-020",
    city: "Opole",
  },
  {
    code: "46-021",
    city: "Brzezie",
  },
  {
    code: "46-022",
    city: "Luboszyce",
  },
  {
    code: "46-023",
    city: "Osowiec Śląski",
  },
  {
    code: "46-024",
    city: "Łubniany",
  },
  {
    code: "46-030",
    city: "Murów",
  },
  {
    code: "46-034",
    city: "Pokój",
  },
  {
    code: "46-037",
    city: "Karłowice",
  },
  {
    code: "46-040",
    city: "Ozimek",
  },
  {
    code: "46-042",
    city: "Szczedrzyk",
  },
  {
    code: "46-043",
    city: "Dylaki",
  },
  {
    code: "46-045",
    city: "Turawa",
  },
  {
    code: "46-046",
    city: "Ligota Turawska",
  },
  {
    code: "46-047",
    city: "Radawie",
  },
  {
    code: "46-048",
    city: "Zębowice",
  },
  {
    code: "46-050",
    city: "Tarnów Opolski",
  },
  {
    code: "46-053",
    city: "Chrząstowice",
  },
  {
    code: "46-060",
    city: "Prószków",
  },
  {
    code: "46-061",
    city: "Źlinice",
  },
  {
    code: "46-070",
    city: "Komprachcice",
  },
  {
    code: "46-073",
    city: "Chróścina",
  },
  {
    code: "46-080",
    city: "Chróścice",
  },
  {
    code: "46-081",
    city: "Dobrzeń Wielki",
  },
  {
    code: "46-082",
    city: "Kup",
  },
  {
    code: "46-083",
    city: "Stare Siołkowice",
  },
  {
    code: "46-090",
    city: "Popielów",
  },
  {
    code: "46-100",
    city: "Namysłów",
  },
  {
    code: "46-112",
    city: "Świerczów",
  },
  {
    code: "46-113",
    city: "Wilków",
  },
  {
    code: "46-115",
    city: "Bukowie",
  },
  {
    code: "46-125",
    city: "Idzikowice",
  },
  {
    code: "46-134",
    city: "Głuszyna",
  },
  {
    code: "46-142",
    city: "Bukowa Śląska",
  },
  {
    code: "46-146",
    city: "Domaszowice",
  },
  {
    code: "46-166",
    city: "Ligota Książęca",
  },
  {
    code: "46-200",
    city: "Kluczbork",
  },
  {
    code: "46-203",
    city: "Kluczbork",
  },
  {
    code: "46-211",
    city: "Kujakowice Górne",
  },
  {
    code: "46-220",
    city: "Byczyna",
  },
  {
    code: "46-233",
    city: "Bąków",
  },
  {
    code: "46-243",
    city: "Bogacica",
  },
  {
    code: "46-250",
    city: "Wołczyn",
  },
  {
    code: "46-255",
    city: "Wierzbica Górna",
  },
  {
    code: "46-262",
    city: "Skałągi",
  },
  {
    code: "46-264",
    city: "Krzywiczyny",
  },
  {
    code: "46-275",
    city: "Chudoba",
  },
  {
    code: "46-280",
    city: "Lasowice Małe",
  },
  {
    code: "46-282",
    city: "Lasowice Wielkie",
  },
  {
    code: "46-300",
    city: "Olesno",
  },
  {
    code: "46-310",
    city: "Gorzów Śląski",
  },
  {
    code: "46-312",
    city: "Bodzanowice",
  },
  {
    code: "46-320",
    city: "Praszka",
  },
  {
    code: "46-321",
    city: "Dalachów",
  },
  {
    code: "46-324",
    city: "Kościeliska",
  },
  {
    code: "46-325",
    city: "Rudniki",
  },
  {
    code: "46-331",
    city: "Radłów",
  },
  {
    code: "46-333",
    city: "Sternalice",
  },
  {
    code: "46-375",
    city: "Pludry",
  },
  {
    code: "46-380",
    city: "Dobrodzień",
  },
  {
    code: "47-100",
    city: "Strzelce Opolskie",
  },
  {
    code: "47-110",
    city: "Kolonowskie",
  },
  {
    code: "47-113",
    city: "Kolonowskie",
  },
  {
    code: "47-120",
    city: "Zawadzkie",
  },
  {
    code: "47-126",
    city: "Kielcza",
  },
  {
    code: "47-133",
    city: "Jemielnica",
  },
  {
    code: "47-134",
    city: "Błotnica Strzelecka",
  },
  {
    code: "47-143",
    city: "Ujazd",
  },
  {
    code: "47-150",
    city: "Leśnica",
  },
  {
    code: "47-154",
    city: "Góra Świętej Anny",
  },
  {
    code: "47-161",
    city: "Szymiszów",
  },
  {
    code: "47-171",
    city: "Rozmierz",
  },
  {
    code: "47-175",
    city: "Kadłub",
  },
  {
    code: "47-180",
    city: "Izbicko",
  },
  {
    code: "47-200",
    city: "Kędzierzyn-Koźle",
  },
  {
    code: "47-205",
    city: "Kędzierzyn-Koźle",
  },
  {
    code: "47-206",
    city: "Kędzierzyn-Koźle",
  },
  {
    code: "47-208",
    city: "Reńska Wieś",
  },
  {
    code: "47-214",
    city: "Poborszów",
  },
  {
    code: "47-220",
    city: "Kędzierzyn-Koźle",
  },
  {
    code: "47-222",
    city: "Kędzierzyn-Koźle",
  },
  {
    code: "47-223",
    city: "Kędzierzyn-Koźle",
  },
  {
    code: "47-224",
    city: "Kędzierzyn-Koźle",
  },
  {
    code: "47-225",
    city: "Kędzierzyn-Koźle",
  },
  {
    code: "47-230",
    city: "Kędzierzyn-Koźle",
  },
  {
    code: "47-232",
    city: "Kędzierzyn-Koźle",
  },
  {
    code: "47-240",
    city: "Bierawa",
  },
  {
    code: "47-244",
    city: "Dziergowice",
  },
  {
    code: "47-246",
    city: "Kotlarnia",
  },
  {
    code: "47-253",
    city: "Cisek",
  },
  {
    code: "47-260",
    city: "Polska Cerekiew",
  },
  {
    code: "47-263",
    city: "Zakrzów",
  },
  {
    code: "47-270",
    city: "Gościęcin",
  },
  {
    code: "47-280",
    city: "Pawłowiczki",
  },
  {
    code: "47-300",
    city: "Krapkowice",
  },
  {
    code: "47-303",
    city: "Krapkowice",
  },
  {
    code: "47-316",
    city: "Górażdże",
  },
  {
    code: "47-320",
    city: "Gogolin",
  },
  {
    code: "47-325",
    city: "Kamień Śląski",
  },
  {
    code: "47-330",
    city: "Zdzieszowice",
  },
  {
    code: "47-340",
    city: "Twardawa",
  },
  {
    code: "47-344",
    city: "Walce",
  },
  {
    code: "47-364",
    city: "Strzeleczki",
  },
  {
    code: "47-370",
    city: "Zielina",
  },
  {
    code: "47-400",
    city: "Racibórz",
  },
  {
    code: "47-403",
    city: "Racibórz",
  },
  {
    code: "47-404",
    city: "Racibórz",
  },
  {
    code: "47-406",
    city: "Racibórz",
  },
  {
    code: "47-411",
    city: "Rudnik",
  },
  {
    code: "47-420",
    city: "Kuźnia Raciborska",
  },
  {
    code: "47-430",
    city: "Rudy",
  },
  {
    code: "47-435",
    city: "Raszczyce",
  },
  {
    code: "47-440",
    city: "Nędza",
  },
  {
    code: "47-445",
    city: "Racibórz",
  },
  {
    code: "47-450",
    city: "Krzyżanowice",
  },
  {
    code: "47-451",
    city: "Tworków",
  },
  {
    code: "47-460",
    city: "Chałupki",
  },
  {
    code: "47-470",
    city: "Krzanowice",
  },
  {
    code: "47-480",
    city: "Pietrowice Wielkie",
  },
  {
    code: "48-100",
    city: "Głubczyce",
  },
  {
    code: "48-118",
    city: "Lisięcice",
  },
  {
    code: "48-120",
    city: "Baborów",
  },
  {
    code: "48-130",
    city: "Kietrz",
  },
  {
    code: "48-133",
    city: "Nowa Cerekwia",
  },
  {
    code: "48-140",
    city: "Branice",
  },
  {
    code: "48-145",
    city: "Zubrzyce",
  },
  {
    code: "48-200",
    city: "Prudnik",
  },
  {
    code: "48-210",
    city: "Biała",
  },
  {
    code: "48-217",
    city: "Gostomia",
  },
  {
    code: "48-220",
    city: "Łącznik",
  },
  {
    code: "48-231",
    city: "Lubrza",
  },
  {
    code: "48-250",
    city: "Głogówek",
  },
  {
    code: "48-267",
    city: "Jarnołtówek",
  },
  {
    code: "48-300",
    city: "Nysa",
  },
  {
    code: "48-303",
    city: "Nysa",
  },
  {
    code: "48-304",
    city: "Nysa",
  },
  {
    code: "48-314",
    city: "Pakosławice",
  },
  {
    code: "48-315",
    city: "Jasienica Dolna",
  },
  {
    code: "48-316",
    city: "Łambinowice",
  },
  {
    code: "48-317",
    city: "Korfantów",
  },
  {
    code: "48-319",
    city: "Chróścina",
  },
  {
    code: "48-320",
    city: "Skoroszyce",
  },
  {
    code: "48-321",
    city: "Niwnica",
  },
  {
    code: "48-324",
    city: "Przechód",
  },
  {
    code: "48-325",
    city: "Ścinawa Mała",
  },
  {
    code: "48-330",
    city: "Nowy Świętów",
  },
  {
    code: "48-340",
    city: "Głuchołazy",
  },
  {
    code: "48-351",
    city: "Biała Nyska",
  },
  {
    code: "48-355",
    city: "Burgrabice",
  },
  {
    code: "48-364",
    city: "Kałków",
  },
  {
    code: "48-370",
    city: "Paczków",
  },
  {
    code: "48-381",
    city: "Goświnowice",
  },
  {
    code: "48-385",
    city: "Otmuchów",
  },
  {
    code: "48-387",
    city: "Karłowice Wielkie",
  },
  {
    code: "48-388",
    city: "Kamiennik",
  },
  {
    code: "49-100",
    city: "Niemodlin",
  },
  {
    code: "49-120",
    city: "Dąbrowa",
  },
  {
    code: "49-130",
    city: "Tułowice",
  },
  {
    code: "49-156",
    city: "Gracze",
  },
  {
    code: "49-200",
    city: "Grodków",
  },
  {
    code: "49-300",
    city: "Brzeg",
  },
  {
    code: "49-302",
    city: "Brzeg",
  },
  {
    code: "49-304",
    city: "Brzeg",
  },
  {
    code: "49-305",
    city: "Brzeg",
  },
  {
    code: "49-306",
    city: "Brzeg",
  },
  {
    code: "49-312",
    city: "Szydłowice",
  },
  {
    code: "49-313",
    city: "Lubsza",
  },
  {
    code: "49-314",
    city: "Pisarzowice",
  },
  {
    code: "49-315",
    city: "Mąkoszyce",
  },
  {
    code: "49-318",
    city: "Skarbimierz",
  },
  {
    code: "49-330",
    city: "Łosiów",
  },
  {
    code: "49-332",
    city: "Olszanka",
  },
  {
    code: "49-340",
    city: "Lewin Brzeski",
  },
  {
    code: "49-345",
    city: "Skorogoszcz",
  },
  {
    code: "49-351",
    city: "Przylesie",
  },
  {
    code: "50-001",
    city: "Wrocław",
  },
  {
    code: "50-002",
    city: "Wrocław",
  },
  {
    code: "50-003",
    city: "Wrocław",
  },
  {
    code: "50-004",
    city: "Wrocław",
  },
  {
    code: "50-005",
    city: "Wrocław",
  },
  {
    code: "50-006",
    city: "Wrocław",
  },
  {
    code: "50-007",
    city: "Wrocław",
  },
  {
    code: "50-008",
    city: "Wrocław",
  },
  {
    code: "50-009",
    city: "Wrocław",
  },
  {
    code: "50-010",
    city: "Wrocław",
  },
  {
    code: "50-011",
    city: "Wrocław",
  },
  {
    code: "50-012",
    city: "Wrocław",
  },
  {
    code: "50-013",
    city: "Wrocław",
  },
  {
    code: "50-014",
    city: "Wrocław",
  },
  {
    code: "50-015",
    city: "Wrocław",
  },
  {
    code: "50-016",
    city: "Wrocław",
  },
  {
    code: "50-017",
    city: "Wrocław",
  },
  {
    code: "50-018",
    city: "Wrocław",
  },
  {
    code: "50-019",
    city: "Wrocław",
  },
  {
    code: "50-020",
    city: "Wrocław",
  },
  {
    code: "50-021",
    city: "Wrocław",
  },
  {
    code: "50-022",
    city: "Wrocław",
  },
  {
    code: "50-023",
    city: "Wrocław",
  },
  {
    code: "50-024",
    city: "Wrocław",
  },
  {
    code: "50-026",
    city: "Wrocław",
  },
  {
    code: "50-027",
    city: "Wrocław",
  },
  {
    code: "50-028",
    city: "Wrocław",
  },
  {
    code: "50-029",
    city: "Wrocław",
  },
  {
    code: "50-030",
    city: "Wrocław",
  },
  {
    code: "50-031",
    city: "Wrocław",
  },
  {
    code: "50-032",
    city: "Wrocław",
  },
  {
    code: "50-033",
    city: "Wrocław",
  },
  {
    code: "50-034",
    city: "Wrocław",
  },
  {
    code: "50-035",
    city: "Wrocław",
  },
  {
    code: "50-036",
    city: "Wrocław",
  },
  {
    code: "50-037",
    city: "Wrocław",
  },
  {
    code: "50-038",
    city: "Wrocław",
  },
  {
    code: "50-039",
    city: "Wrocław",
  },
  {
    code: "50-040",
    city: "Wrocław",
  },
  {
    code: "50-042",
    city: "Wrocław",
  },
  {
    code: "50-043",
    city: "Wrocław",
  },
  {
    code: "50-044",
    city: "Wrocław",
  },
  {
    code: "50-045",
    city: "Wrocław",
  },
  {
    code: "50-046",
    city: "Wrocław",
  },
  {
    code: "50-047",
    city: "Wrocław",
  },
  {
    code: "50-048",
    city: "Wrocław",
  },
  {
    code: "50-049",
    city: "Wrocław",
  },
  {
    code: "50-050",
    city: "Wrocław",
  },
  {
    code: "50-051",
    city: "Wrocław",
  },
  {
    code: "50-052",
    city: "Wrocław",
  },
  {
    code: "50-053",
    city: "Wrocław",
  },
  {
    code: "50-054",
    city: "Wrocław",
  },
  {
    code: "50-055",
    city: "Wrocław",
  },
  {
    code: "50-056",
    city: "Wrocław",
  },
  {
    code: "50-057",
    city: "Wrocław",
  },
  {
    code: "50-059",
    city: "Wrocław",
  },
  {
    code: "50-060",
    city: "Wrocław",
  },
  {
    code: "50-061",
    city: "Wrocław",
  },
  {
    code: "50-062",
    city: "Wrocław",
  },
  {
    code: "50-063",
    city: "Wrocław",
  },
  {
    code: "50-064",
    city: "Wrocław",
  },
  {
    code: "50-065",
    city: "Wrocław",
  },
  {
    code: "50-066",
    city: "Wrocław",
  },
  {
    code: "50-067",
    city: "Wrocław",
  },
  {
    code: "50-068",
    city: "Wrocław",
  },
  {
    code: "50-069",
    city: "Wrocław",
  },
  {
    code: "50-070",
    city: "Wrocław",
  },
  {
    code: "50-071",
    city: "Wrocław",
  },
  {
    code: "50-072",
    city: "Wrocław",
  },
  {
    code: "50-073",
    city: "Wrocław",
  },
  {
    code: "50-074",
    city: "Wrocław",
  },
  {
    code: "50-075",
    city: "Wrocław",
  },
  {
    code: "50-076",
    city: "Wrocław",
  },
  {
    code: "50-077",
    city: "Wrocław",
  },
  {
    code: "50-078",
    city: "Wrocław",
  },
  {
    code: "50-079",
    city: "Wrocław",
  },
  {
    code: "50-080",
    city: "Wrocław",
  },
  {
    code: "50-082",
    city: "Wrocław",
  },
  {
    code: "50-083",
    city: "Wrocław",
  },
  {
    code: "50-084",
    city: "Wrocław",
  },
  {
    code: "50-085",
    city: "Wrocław",
  },
  {
    code: "50-086",
    city: "Wrocław",
  },
  {
    code: "50-087",
    city: "Wrocław",
  },
  {
    code: "50-088",
    city: "Wrocław",
  },
  {
    code: "50-089",
    city: "Wrocław",
  },
  {
    code: "50-090",
    city: "Wrocław",
  },
  {
    code: "50-101",
    city: "Wrocław",
  },
  {
    code: "50-102",
    city: "Wrocław",
  },
  {
    code: "50-103",
    city: "Wrocław",
  },
  {
    code: "50-104",
    city: "Wrocław",
  },
  {
    code: "50-105",
    city: "Wrocław",
  },
  {
    code: "50-106",
    city: "Wrocław",
  },
  {
    code: "50-107",
    city: "Wrocław",
  },
  {
    code: "50-108",
    city: "Wrocław",
  },
  {
    code: "50-109",
    city: "Wrocław",
  },
  {
    code: "50-110",
    city: "Wrocław",
  },
  {
    code: "50-111",
    city: "Wrocław",
  },
  {
    code: "50-112",
    city: "Wrocław",
  },
  {
    code: "50-113",
    city: "Wrocław",
  },
  {
    code: "50-114",
    city: "Wrocław",
  },
  {
    code: "50-115",
    city: "Wrocław",
  },
  {
    code: "50-116",
    city: "Wrocław",
  },
  {
    code: "50-117",
    city: "Wrocław",
  },
  {
    code: "50-118",
    city: "Wrocław",
  },
  {
    code: "50-119",
    city: "Wrocław",
  },
  {
    code: "50-120",
    city: "Wrocław",
  },
  {
    code: "50-121",
    city: "Wrocław",
  },
  {
    code: "50-122",
    city: "Wrocław",
  },
  {
    code: "50-123",
    city: "Wrocław",
  },
  {
    code: "50-124",
    city: "Wrocław",
  },
  {
    code: "50-125",
    city: "Wrocław",
  },
  {
    code: "50-126",
    city: "Wrocław",
  },
  {
    code: "50-127",
    city: "Wrocław",
  },
  {
    code: "50-128",
    city: "Wrocław",
  },
  {
    code: "50-129",
    city: "Wrocław",
  },
  {
    code: "50-130",
    city: "Wrocław",
  },
  {
    code: "50-131",
    city: "Wrocław",
  },
  {
    code: "50-132",
    city: "Wrocław",
  },
  {
    code: "50-133",
    city: "Wrocław",
  },
  {
    code: "50-134",
    city: "Wrocław",
  },
  {
    code: "50-135",
    city: "Wrocław",
  },
  {
    code: "50-136",
    city: "Wrocław",
  },
  {
    code: "50-137",
    city: "Wrocław",
  },
  {
    code: "50-138",
    city: "Wrocław",
  },
  {
    code: "50-139",
    city: "Wrocław",
  },
  {
    code: "50-140",
    city: "Wrocław",
  },
  {
    code: "50-141",
    city: "Wrocław",
  },
  {
    code: "50-142",
    city: "Wrocław",
  },
  {
    code: "50-143",
    city: "Wrocław",
  },
  {
    code: "50-144",
    city: "Wrocław",
  },
  {
    code: "50-145",
    city: "Wrocław",
  },
  {
    code: "50-146",
    city: "Wrocław",
  },
  {
    code: "50-147",
    city: "Wrocław",
  },
  {
    code: "50-148",
    city: "Wrocław",
  },
  {
    code: "50-149",
    city: "Wrocław",
  },
  {
    code: "50-150",
    city: "Wrocław",
  },
  {
    code: "50-151",
    city: "Wrocław",
  },
  {
    code: "50-152",
    city: "Wrocław",
  },
  {
    code: "50-153",
    city: "Wrocław",
  },
  {
    code: "50-155",
    city: "Wrocław",
  },
  {
    code: "50-156",
    city: "Wrocław",
  },
  {
    code: "50-157",
    city: "Wrocław",
  },
  {
    code: "50-158",
    city: "Wrocław",
  },
  {
    code: "50-159",
    city: "Wrocław",
  },
  {
    code: "50-165",
    city: "Wrocław",
  },
  {
    code: "50-201",
    city: "Wrocław",
  },
  {
    code: "50-202",
    city: "Wrocław",
  },
  {
    code: "50-203",
    city: "Wrocław",
  },
  {
    code: "50-204",
    city: "Wrocław",
  },
  {
    code: "50-205",
    city: "Wrocław",
  },
  {
    code: "50-206",
    city: "Wrocław",
  },
  {
    code: "50-207",
    city: "Wrocław",
  },
  {
    code: "50-208",
    city: "Wrocław",
  },
  {
    code: "50-209",
    city: "Wrocław",
  },
  {
    code: "50-210",
    city: "Wrocław",
  },
  {
    code: "50-211",
    city: "Wrocław",
  },
  {
    code: "50-212",
    city: "Wrocław",
  },
  {
    code: "50-213",
    city: "Wrocław",
  },
  {
    code: "50-214",
    city: "Wrocław",
  },
  {
    code: "50-215",
    city: "Wrocław",
  },
  {
    code: "50-216",
    city: "Wrocław",
  },
  {
    code: "50-217",
    city: "Wrocław",
  },
  {
    code: "50-218",
    city: "Wrocław",
  },
  {
    code: "50-219",
    city: "Wrocław",
  },
  {
    code: "50-220",
    city: "Wrocław",
  },
  {
    code: "50-221",
    city: "Wrocław",
  },
  {
    code: "50-222",
    city: "Wrocław",
  },
  {
    code: "50-223",
    city: "Wrocław",
  },
  {
    code: "50-224",
    city: "Wrocław",
  },
  {
    code: "50-225",
    city: "Wrocław",
  },
  {
    code: "50-226",
    city: "Wrocław",
  },
  {
    code: "50-227",
    city: "Wrocław",
  },
  {
    code: "50-228",
    city: "Wrocław",
  },
  {
    code: "50-229",
    city: "Wrocław",
  },
  {
    code: "50-230",
    city: "Wrocław",
  },
  {
    code: "50-231",
    city: "Wrocław",
  },
  {
    code: "50-232",
    city: "Wrocław",
  },
  {
    code: "50-233",
    city: "Wrocław",
  },
  {
    code: "50-234",
    city: "Wrocław",
  },
  {
    code: "50-235",
    city: "Wrocław",
  },
  {
    code: "50-236",
    city: "Wrocław",
  },
  {
    code: "50-237",
    city: "Wrocław",
  },
  {
    code: "50-238",
    city: "Wrocław",
  },
  {
    code: "50-239",
    city: "Wrocław",
  },
  {
    code: "50-240",
    city: "Wrocław",
  },
  {
    code: "50-241",
    city: "Wrocław",
  },
  {
    code: "50-242",
    city: "Wrocław",
  },
  {
    code: "50-243",
    city: "Wrocław",
  },
  {
    code: "50-244",
    city: "Wrocław",
  },
  {
    code: "50-245",
    city: "Wrocław",
  },
  {
    code: "50-246",
    city: "Wrocław",
  },
  {
    code: "50-247",
    city: "Wrocław",
  },
  {
    code: "50-248",
    city: "Wrocław",
  },
  {
    code: "50-249",
    city: "Wrocław",
  },
  {
    code: "50-250",
    city: "Wrocław",
  },
  {
    code: "50-251",
    city: "Wrocław",
  },
  {
    code: "50-252",
    city: "Wrocław",
  },
  {
    code: "50-253",
    city: "Wrocław",
  },
  {
    code: "50-254",
    city: "Wrocław",
  },
  {
    code: "50-255",
    city: "Wrocław",
  },
  {
    code: "50-256",
    city: "Wrocław",
  },
  {
    code: "50-257",
    city: "Wrocław",
  },
  {
    code: "50-258",
    city: "Wrocław",
  },
  {
    code: "50-259",
    city: "Wrocław",
  },
  {
    code: "50-260",
    city: "Wrocław",
  },
  {
    code: "50-261",
    city: "Wrocław",
  },
  {
    code: "50-262",
    city: "Wrocław",
  },
  {
    code: "50-263",
    city: "Wrocław",
  },
  {
    code: "50-264",
    city: "Wrocław",
  },
  {
    code: "50-265",
    city: "Wrocław",
  },
  {
    code: "50-266",
    city: "Wrocław",
  },
  {
    code: "50-267",
    city: "Wrocław",
  },
  {
    code: "50-300",
    city: "Wrocław",
  },
  {
    code: "50-301",
    city: "Wrocław",
  },
  {
    code: "50-302",
    city: "Wrocław",
  },
  {
    code: "50-303",
    city: "Wrocław",
  },
  {
    code: "50-304",
    city: "Wrocław",
  },
  {
    code: "50-305",
    city: "Wrocław",
  },
  {
    code: "50-306",
    city: "Wrocław",
  },
  {
    code: "50-307",
    city: "Wrocław",
  },
  {
    code: "50-308",
    city: "Wrocław",
  },
  {
    code: "50-309",
    city: "Wrocław",
  },
  {
    code: "50-310",
    city: "Wrocław",
  },
  {
    code: "50-311",
    city: "Wrocław",
  },
  {
    code: "50-312",
    city: "Wrocław",
  },
  {
    code: "50-313",
    city: "Wrocław",
  },
  {
    code: "50-314",
    city: "Wrocław",
  },
  {
    code: "50-315",
    city: "Wrocław",
  },
  {
    code: "50-316",
    city: "Wrocław",
  },
  {
    code: "50-317",
    city: "Wrocław",
  },
  {
    code: "50-318",
    city: "Wrocław",
  },
  {
    code: "50-319",
    city: "Wrocław",
  },
  {
    code: "50-320",
    city: "Wrocław",
  },
  {
    code: "50-321",
    city: "Wrocław",
  },
  {
    code: "50-322",
    city: "Wrocław",
  },
  {
    code: "50-323",
    city: "Wrocław",
  },
  {
    code: "50-324",
    city: "Wrocław",
  },
  {
    code: "50-325",
    city: "Wrocław",
  },
  {
    code: "50-326",
    city: "Wrocław",
  },
  {
    code: "50-327",
    city: "Wrocław",
  },
  {
    code: "50-328",
    city: "Wrocław",
  },
  {
    code: "50-329",
    city: "Wrocław",
  },
  {
    code: "50-330",
    city: "Wrocław",
  },
  {
    code: "50-331",
    city: "Wrocław",
  },
  {
    code: "50-332",
    city: "Wrocław",
  },
  {
    code: "50-333",
    city: "Wrocław",
  },
  {
    code: "50-334",
    city: "Wrocław",
  },
  {
    code: "50-335",
    city: "Wrocław",
  },
  {
    code: "50-336",
    city: "Wrocław",
  },
  {
    code: "50-337",
    city: "Wrocław",
  },
  {
    code: "50-338",
    city: "Wrocław",
  },
  {
    code: "50-339",
    city: "Wrocław",
  },
  {
    code: "50-340",
    city: "Wrocław",
  },
  {
    code: "50-341",
    city: "Wrocław",
  },
  {
    code: "50-342",
    city: "Wrocław",
  },
  {
    code: "50-343",
    city: "Wrocław",
  },
  {
    code: "50-344",
    city: "Wrocław",
  },
  {
    code: "50-345",
    city: "Wrocław",
  },
  {
    code: "50-346",
    city: "Wrocław",
  },
  {
    code: "50-347",
    city: "Wrocław",
  },
  {
    code: "50-348",
    city: "Wrocław",
  },
  {
    code: "50-349",
    city: "Wrocław",
  },
  {
    code: "50-350",
    city: "Wrocław",
  },
  {
    code: "50-351",
    city: "Wrocław",
  },
  {
    code: "50-352",
    city: "Wrocław",
  },
  {
    code: "50-353",
    city: "Wrocław",
  },
  {
    code: "50-354",
    city: "Wrocław",
  },
  {
    code: "50-355",
    city: "Wrocław",
  },
  {
    code: "50-356",
    city: "Wrocław",
  },
  {
    code: "50-357",
    city: "Wrocław",
  },
  {
    code: "50-359",
    city: "Wrocław",
  },
  {
    code: "50-360",
    city: "Wrocław",
  },
  {
    code: "50-361",
    city: "Wrocław",
  },
  {
    code: "50-362",
    city: "Wrocław",
  },
  {
    code: "50-363",
    city: "Wrocław",
  },
  {
    code: "50-364",
    city: "Wrocław",
  },
  {
    code: "50-365",
    city: "Wrocław",
  },
  {
    code: "50-366",
    city: "Wrocław",
  },
  {
    code: "50-367",
    city: "Wrocław",
  },
  {
    code: "50-368",
    city: "Wrocław",
  },
  {
    code: "50-369",
    city: "Wrocław",
  },
  {
    code: "50-370",
    city: "Wrocław",
  },
  {
    code: "50-371",
    city: "Wrocław",
  },
  {
    code: "50-372",
    city: "Wrocław",
  },
  {
    code: "50-373",
    city: "Wrocław",
  },
  {
    code: "50-374",
    city: "Wrocław",
  },
  {
    code: "50-375",
    city: "Wrocław",
  },
  {
    code: "50-376",
    city: "Wrocław",
  },
  {
    code: "50-377",
    city: "Wrocław",
  },
  {
    code: "50-378",
    city: "Wrocław",
  },
  {
    code: "50-379",
    city: "Wrocław",
  },
  {
    code: "50-380",
    city: "Wrocław",
  },
  {
    code: "50-381",
    city: "Wrocław",
  },
  {
    code: "50-382",
    city: "Wrocław",
  },
  {
    code: "50-383",
    city: "Wrocław",
  },
  {
    code: "50-384",
    city: "Wrocław",
  },
  {
    code: "50-385",
    city: "Wrocław",
  },
  {
    code: "50-386",
    city: "Wrocław",
  },
  {
    code: "50-388",
    city: "Wrocław",
  },
  {
    code: "50-399",
    city: "Wrocław",
  },
  {
    code: "50-401",
    city: "Wrocław",
  },
  {
    code: "50-402",
    city: "Wrocław",
  },
  {
    code: "50-403",
    city: "Wrocław",
  },
  {
    code: "50-406",
    city: "Wrocław",
  },
  {
    code: "50-407",
    city: "Wrocław",
  },
  {
    code: "50-408",
    city: "Wrocław",
  },
  {
    code: "50-411",
    city: "Wrocław",
  },
  {
    code: "50-412",
    city: "Wrocław",
  },
  {
    code: "50-413",
    city: "Wrocław",
  },
  {
    code: "50-414",
    city: "Wrocław",
  },
  {
    code: "50-415",
    city: "Wrocław",
  },
  {
    code: "50-416",
    city: "Wrocław",
  },
  {
    code: "50-417",
    city: "Wrocław",
  },
  {
    code: "50-418",
    city: "Wrocław",
  },
  {
    code: "50-419",
    city: "Wrocław",
  },
  {
    code: "50-420",
    city: "Wrocław",
  },
  {
    code: "50-421",
    city: "Wrocław",
  },
  {
    code: "50-422",
    city: "Wrocław",
  },
  {
    code: "50-424",
    city: "Wrocław",
  },
  {
    code: "50-425",
    city: "Wrocław",
  },
  {
    code: "50-426",
    city: "Wrocław",
  },
  {
    code: "50-427",
    city: "Wrocław",
  },
  {
    code: "50-428",
    city: "Wrocław",
  },
  {
    code: "50-429",
    city: "Wrocław",
  },
  {
    code: "50-430",
    city: "Wrocław",
  },
  {
    code: "50-431",
    city: "Wrocław",
  },
  {
    code: "50-432",
    city: "Wrocław",
  },
  {
    code: "50-433",
    city: "Wrocław",
  },
  {
    code: "50-434",
    city: "Wrocław",
  },
  {
    code: "50-435",
    city: "Wrocław",
  },
  {
    code: "50-436",
    city: "Wrocław",
  },
  {
    code: "50-437",
    city: "Wrocław",
  },
  {
    code: "50-438",
    city: "Wrocław",
  },
  {
    code: "50-439",
    city: "Wrocław",
  },
  {
    code: "50-440",
    city: "Wrocław",
  },
  {
    code: "50-441",
    city: "Wrocław",
  },
  {
    code: "50-442",
    city: "Wrocław",
  },
  {
    code: "50-443",
    city: "Wrocław",
  },
  {
    code: "50-444",
    city: "Wrocław",
  },
  {
    code: "50-445",
    city: "Wrocław",
  },
  {
    code: "50-446",
    city: "Wrocław",
  },
  {
    code: "50-447",
    city: "Wrocław",
  },
  {
    code: "50-448",
    city: "Wrocław",
  },
  {
    code: "50-449",
    city: "Wrocław",
  },
  {
    code: "50-450",
    city: "Wrocław",
  },
  {
    code: "50-451",
    city: "Wrocław",
  },
  {
    code: "50-452",
    city: "Wrocław",
  },
  {
    code: "50-453",
    city: "Wrocław",
  },
  {
    code: "50-454",
    city: "Wrocław",
  },
  {
    code: "50-455",
    city: "Wrocław",
  },
  {
    code: "50-456",
    city: "Wrocław",
  },
  {
    code: "50-457",
    city: "Wrocław",
  },
  {
    code: "50-458",
    city: "Wrocław",
  },
  {
    code: "50-501",
    city: "Wrocław",
  },
  {
    code: "50-502",
    city: "Wrocław",
  },
  {
    code: "50-503",
    city: "Wrocław",
  },
  {
    code: "50-504",
    city: "Wrocław",
  },
  {
    code: "50-505",
    city: "Wrocław",
  },
  {
    code: "50-506",
    city: "Wrocław",
  },
  {
    code: "50-507",
    city: "Wrocław",
  },
  {
    code: "50-508",
    city: "Wrocław",
  },
  {
    code: "50-509",
    city: "Wrocław",
  },
  {
    code: "50-510",
    city: "Wrocław",
  },
  {
    code: "50-511",
    city: "Wrocław",
  },
  {
    code: "50-512",
    city: "Wrocław",
  },
  {
    code: "50-513",
    city: "Wrocław",
  },
  {
    code: "50-514",
    city: "Wrocław",
  },
  {
    code: "50-515",
    city: "Wrocław",
  },
  {
    code: "50-516",
    city: "Wrocław",
  },
  {
    code: "50-517",
    city: "Wrocław",
  },
  {
    code: "50-518",
    city: "Wrocław",
  },
  {
    code: "50-519",
    city: "Wrocław",
  },
  {
    code: "50-520",
    city: "Wrocław",
  },
  {
    code: "50-521",
    city: "Wrocław",
  },
  {
    code: "50-522",
    city: "Wrocław",
  },
  {
    code: "50-523",
    city: "Wrocław",
  },
  {
    code: "50-524",
    city: "Wrocław",
  },
  {
    code: "50-525",
    city: "Wrocław",
  },
  {
    code: "50-526",
    city: "Wrocław",
  },
  {
    code: "50-527",
    city: "Wrocław",
  },
  {
    code: "50-528",
    city: "Wrocław",
  },
  {
    code: "50-529",
    city: "Wrocław",
  },
  {
    code: "50-530",
    city: "Wrocław",
  },
  {
    code: "50-531",
    city: "Wrocław",
  },
  {
    code: "50-532",
    city: "Wrocław",
  },
  {
    code: "50-533",
    city: "Wrocław",
  },
  {
    code: "50-534",
    city: "Wrocław",
  },
  {
    code: "50-535",
    city: "Wrocław",
  },
  {
    code: "50-536",
    city: "Wrocław",
  },
  {
    code: "50-537",
    city: "Wrocław",
  },
  {
    code: "50-538",
    city: "Wrocław",
  },
  {
    code: "50-539",
    city: "Wrocław",
  },
  {
    code: "50-540",
    city: "Wrocław",
  },
  {
    code: "50-541",
    city: "Wrocław",
  },
  {
    code: "50-542",
    city: "Wrocław",
  },
  {
    code: "50-543",
    city: "Wrocław",
  },
  {
    code: "50-544",
    city: "Wrocław",
  },
  {
    code: "50-545",
    city: "Wrocław",
  },
  {
    code: "50-546",
    city: "Wrocław",
  },
  {
    code: "50-547",
    city: "Wrocław",
  },
  {
    code: "50-548",
    city: "Wrocław",
  },
  {
    code: "50-549",
    city: "Wrocław",
  },
  {
    code: "50-550",
    city: "Wrocław",
  },
  {
    code: "50-551",
    city: "Wrocław",
  },
  {
    code: "50-552",
    city: "Wrocław",
  },
  {
    code: "50-553",
    city: "Wrocław",
  },
  {
    code: "50-554",
    city: "Wrocław",
  },
  {
    code: "50-555",
    city: "Wrocław",
  },
  {
    code: "50-556",
    city: "Wrocław",
  },
  {
    code: "50-557",
    city: "Wrocław",
  },
  {
    code: "50-558",
    city: "Wrocław",
  },
  {
    code: "50-559",
    city: "Wrocław",
  },
  {
    code: "50-560",
    city: "Wrocław",
  },
  {
    code: "50-561",
    city: "Wrocław",
  },
  {
    code: "50-562",
    city: "Wrocław",
  },
  {
    code: "50-563",
    city: "Wrocław",
  },
  {
    code: "50-564",
    city: "Wrocław",
  },
  {
    code: "50-565",
    city: "Wrocław",
  },
  {
    code: "50-566",
    city: "Wrocław",
  },
  {
    code: "50-567",
    city: "Wrocław",
  },
  {
    code: "50-568",
    city: "Wrocław",
  },
  {
    code: "50-569",
    city: "Wrocław",
  },
  {
    code: "50-570",
    city: "Wrocław",
  },
  {
    code: "50-571",
    city: "Wrocław",
  },
  {
    code: "50-572",
    city: "Wrocław",
  },
  {
    code: "50-573",
    city: "Wrocław",
  },
  {
    code: "50-574",
    city: "Wrocław",
  },
  {
    code: "50-576",
    city: "Wrocław",
  },
  {
    code: "50-580",
    city: "Wrocław",
  },
  {
    code: "50-900",
    city: "Wrocław",
  },
  {
    code: "50-901",
    city: "Wrocław",
  },
  {
    code: "50-930",
    city: "Wrocław",
  },
  {
    code: "50-936",
    city: "Wrocław",
  },
  {
    code: "50-940",
    city: "Wrocław",
  },
  {
    code: "50-950",
    city: "Wrocław",
  },
  {
    code: "50-951",
    city: "Wrocław",
  },
  {
    code: "50-952",
    city: "Wrocław",
  },
  {
    code: "50-953",
    city: "Wrocław",
  },
  {
    code: "50-954",
    city: "Wrocław",
  },
  {
    code: "50-955",
    city: "Wrocław",
  },
  {
    code: "50-956",
    city: "Wrocław",
  },
  {
    code: "50-961",
    city: "Wrocław",
  },
  {
    code: "50-962",
    city: "Wrocław",
  },
  {
    code: "50-963",
    city: "Wrocław",
  },
  {
    code: "50-964",
    city: "Wrocław",
  },
  {
    code: "50-965",
    city: "Wrocław",
  },
  {
    code: "50-966",
    city: "Wrocław",
  },
  {
    code: "50-970",
    city: "Wrocław",
  },
  {
    code: "50-971",
    city: "Wrocław",
  },
  {
    code: "50-972",
    city: "Wrocław",
  },
  {
    code: "50-973",
    city: "Wrocław",
  },
  {
    code: "50-974",
    city: "Wrocław",
  },
  {
    code: "50-981",
    city: "Wrocław",
  },
  {
    code: "50-982",
    city: "Wrocław",
  },
  {
    code: "50-983",
    city: "Wrocław",
  },
  {
    code: "50-984",
    city: "Wrocław",
  },
  {
    code: "50-985",
    city: "Wrocław",
  },
  {
    code: "50-986",
    city: "Wrocław",
  },
  {
    code: "50-989",
    city: "Wrocław",
  },
  {
    code: "50-990",
    city: "Wrocław",
  },
  {
    code: "50-991",
    city: "Wrocław",
  },
  {
    code: "50-994",
    city: "Wrocław",
  },
  {
    code: "50-995",
    city: "Wrocław",
  },
  {
    code: "50-996",
    city: "Wrocław",
  },
  {
    code: "51-001",
    city: "Wrocław",
  },
  {
    code: "51-002",
    city: "Wrocław",
  },
  {
    code: "51-003",
    city: "Wrocław",
  },
  {
    code: "51-004",
    city: "Wrocław",
  },
  {
    code: "51-005",
    city: "Wrocław",
  },
  {
    code: "51-006",
    city: "Wrocław",
  },
  {
    code: "51-007",
    city: "Wrocław",
  },
  {
    code: "51-008",
    city: "Wrocław",
  },
  {
    code: "51-009",
    city: "Wrocław",
  },
  {
    code: "51-010",
    city: "Wrocław",
  },
  {
    code: "51-011",
    city: "Wrocław",
  },
  {
    code: "51-050",
    city: "Wrocław",
  },
  {
    code: "51-051",
    city: "Wrocław",
  },
  {
    code: "51-052",
    city: "Wrocław",
  },
  {
    code: "51-107",
    city: "Wrocław",
  },
  {
    code: "51-108",
    city: "Wrocław",
  },
  {
    code: "51-109",
    city: "Wrocław",
  },
  {
    code: "51-110",
    city: "Wrocław",
  },
  {
    code: "51-111",
    city: "Wrocław",
  },
  {
    code: "51-112",
    city: "Wrocław",
  },
  {
    code: "51-113",
    city: "Wrocław",
  },
  {
    code: "51-114",
    city: "Wrocław",
  },
  {
    code: "51-115",
    city: "Wrocław",
  },
  {
    code: "51-116",
    city: "Wrocław",
  },
  {
    code: "51-117",
    city: "Wrocław",
  },
  {
    code: "51-118",
    city: "Wrocław",
  },
  {
    code: "51-119",
    city: "Wrocław",
  },
  {
    code: "51-120",
    city: "Wrocław",
  },
  {
    code: "51-121",
    city: "Wrocław",
  },
  {
    code: "51-122",
    city: "Wrocław",
  },
  {
    code: "51-123",
    city: "Wrocław",
  },
  {
    code: "51-124",
    city: "Wrocław",
  },
  {
    code: "51-125",
    city: "Wrocław",
  },
  {
    code: "51-126",
    city: "Wrocław",
  },
  {
    code: "51-127",
    city: "Wrocław",
  },
  {
    code: "51-128",
    city: "Wrocław",
  },
  {
    code: "51-129",
    city: "Wrocław",
  },
  {
    code: "51-130",
    city: "Wrocław",
  },
  {
    code: "51-131",
    city: "Wrocław",
  },
  {
    code: "51-132",
    city: "Wrocław",
  },
  {
    code: "51-134",
    city: "Wrocław",
  },
  {
    code: "51-136",
    city: "Wrocław",
  },
  {
    code: "51-137",
    city: "Wrocław",
  },
  {
    code: "51-138",
    city: "Wrocław",
  },
  {
    code: "51-139",
    city: "Wrocław",
  },
  {
    code: "51-140",
    city: "Wrocław",
  },
  {
    code: "51-141",
    city: "Wrocław",
  },
  {
    code: "51-142",
    city: "Wrocław",
  },
  {
    code: "51-143",
    city: "Wrocław",
  },
  {
    code: "51-144",
    city: "Wrocław",
  },
  {
    code: "51-145",
    city: "Wrocław",
  },
  {
    code: "51-146",
    city: "Wrocław",
  },
  {
    code: "51-147",
    city: "Wrocław",
  },
  {
    code: "51-148",
    city: "Wrocław",
  },
  {
    code: "51-149",
    city: "Wrocław",
  },
  {
    code: "51-151",
    city: "Wrocław",
  },
  {
    code: "51-152",
    city: "Wrocław",
  },
  {
    code: "51-153",
    city: "Wrocław",
  },
  {
    code: "51-160",
    city: "Wrocław",
  },
  {
    code: "51-161",
    city: "Wrocław",
  },
  {
    code: "51-162",
    city: "Wrocław",
  },
  {
    code: "51-163",
    city: "Wrocław",
  },
  {
    code: "51-164",
    city: "Wrocław",
  },
  {
    code: "51-165",
    city: "Wrocław",
  },
  {
    code: "51-166",
    city: "Wrocław",
  },
  {
    code: "51-167",
    city: "Wrocław",
  },
  {
    code: "51-168",
    city: "Wrocław",
  },
  {
    code: "51-169",
    city: "Wrocław",
  },
  {
    code: "51-170",
    city: "Wrocław",
  },
  {
    code: "51-171",
    city: "Wrocław",
  },
  {
    code: "51-173",
    city: "Wrocław",
  },
  {
    code: "51-179",
    city: "Wrocław",
  },
  {
    code: "51-180",
    city: "Wrocław",
  },
  {
    code: "51-188",
    city: "Wrocław",
  },
  {
    code: "51-200",
    city: "Wrocław",
  },
  {
    code: "51-203",
    city: "Wrocław",
  },
  {
    code: "51-204",
    city: "Wrocław",
  },
  {
    code: "51-205",
    city: "Wrocław",
  },
  {
    code: "51-206",
    city: "Wrocław",
  },
  {
    code: "51-207",
    city: "Wrocław",
  },
  {
    code: "51-208",
    city: "Wrocław",
  },
  {
    code: "51-209",
    city: "Wrocław",
  },
  {
    code: "51-210",
    city: "Wrocław",
  },
  {
    code: "51-211",
    city: "Wrocław",
  },
  {
    code: "51-212",
    city: "Wrocław",
  },
  {
    code: "51-213",
    city: "Wrocław",
  },
  {
    code: "51-214",
    city: "Wrocław",
  },
  {
    code: "51-215",
    city: "Wrocław",
  },
  {
    code: "51-216",
    city: "Wrocław",
  },
  {
    code: "51-217",
    city: "Wrocław",
  },
  {
    code: "51-218",
    city: "Wrocław",
  },
  {
    code: "51-219",
    city: "Wrocław",
  },
  {
    code: "51-220",
    city: "Wrocław",
  },
  {
    code: "51-222",
    city: "Wrocław",
  },
  {
    code: "51-230",
    city: "Wrocław",
  },
  {
    code: "51-231",
    city: "Wrocław",
  },
  {
    code: "51-250",
    city: "Wrocław",
  },
  {
    code: "51-251",
    city: "Wrocław",
  },
  {
    code: "51-252",
    city: "Wrocław",
  },
  {
    code: "51-253",
    city: "Wrocław",
  },
  {
    code: "51-259",
    city: "Wrocław",
  },
  {
    code: "51-310",
    city: "Wrocław",
  },
  {
    code: "51-311",
    city: "Wrocław",
  },
  {
    code: "51-312",
    city: "Wrocław",
  },
  {
    code: "51-313",
    city: "Wrocław",
  },
  {
    code: "51-314",
    city: "Wrocław",
  },
  {
    code: "51-315",
    city: "Wrocław",
  },
  {
    code: "51-316",
    city: "Wrocław",
  },
  {
    code: "51-317",
    city: "Wrocław",
  },
  {
    code: "51-318",
    city: "Wrocław",
  },
  {
    code: "51-319",
    city: "Wrocław",
  },
  {
    code: "51-321",
    city: "Wrocław",
  },
  {
    code: "51-347",
    city: "Wrocław",
  },
  {
    code: "51-348",
    city: "Wrocław",
  },
  {
    code: "51-349",
    city: "Wrocław",
  },
  {
    code: "51-350",
    city: "Wrocław",
  },
  {
    code: "51-351",
    city: "Wrocław",
  },
  {
    code: "51-352",
    city: "Wrocław",
  },
  {
    code: "51-354",
    city: "Wrocław",
  },
  {
    code: "51-355",
    city: "Wrocław",
  },
  {
    code: "51-356",
    city: "Wrocław",
  },
  {
    code: "51-376",
    city: "Wrocław",
  },
  {
    code: "51-378",
    city: "Wrocław",
  },
  {
    code: "51-410",
    city: "Wrocław",
  },
  {
    code: "51-411",
    city: "Wrocław",
  },
  {
    code: "51-412",
    city: "Wrocław",
  },
  {
    code: "51-413",
    city: "Wrocław",
  },
  {
    code: "51-414",
    city: "Wrocław",
  },
  {
    code: "51-415",
    city: "Wrocław",
  },
  {
    code: "51-416",
    city: "Wrocław",
  },
  {
    code: "51-417",
    city: "Wrocław",
  },
  {
    code: "51-418",
    city: "Wrocław",
  },
  {
    code: "51-419",
    city: "Wrocław",
  },
  {
    code: "51-420",
    city: "Wrocław",
  },
  {
    code: "51-421",
    city: "Wrocław",
  },
  {
    code: "51-422",
    city: "Wrocław",
  },
  {
    code: "51-423",
    city: "Wrocław",
  },
  {
    code: "51-424",
    city: "Wrocław",
  },
  {
    code: "51-425",
    city: "Wrocław",
  },
  {
    code: "51-426",
    city: "Wrocław",
  },
  {
    code: "51-427",
    city: "Wrocław",
  },
  {
    code: "51-428",
    city: "Wrocław",
  },
  {
    code: "51-429",
    city: "Wrocław",
  },
  {
    code: "51-430",
    city: "Wrocław",
  },
  {
    code: "51-501",
    city: "Wrocław",
  },
  {
    code: "51-502",
    city: "Wrocław",
  },
  {
    code: "51-503",
    city: "Wrocław",
  },
  {
    code: "51-504",
    city: "Wrocław",
  },
  {
    code: "51-505",
    city: "Wrocław",
  },
  {
    code: "51-506",
    city: "Wrocław",
  },
  {
    code: "51-507",
    city: "Wrocław",
  },
  {
    code: "51-508",
    city: "Wrocław",
  },
  {
    code: "51-511",
    city: "Wrocław",
  },
  {
    code: "51-512",
    city: "Wrocław",
  },
  {
    code: "51-513",
    city: "Wrocław",
  },
  {
    code: "51-514",
    city: "Wrocław",
  },
  {
    code: "51-515",
    city: "Wrocław",
  },
  {
    code: "51-516",
    city: "Wrocław",
  },
  {
    code: "51-517",
    city: "Wrocław",
  },
  {
    code: "51-518",
    city: "Wrocław",
  },
  {
    code: "51-519",
    city: "Wrocław",
  },
  {
    code: "51-520",
    city: "Wrocław",
  },
  {
    code: "51-521",
    city: "Wrocław",
  },
  {
    code: "51-522",
    city: "Wrocław",
  },
  {
    code: "51-523",
    city: "Wrocław",
  },
  {
    code: "51-524",
    city: "Wrocław",
  },
  {
    code: "51-531",
    city: "Wrocław",
  },
  {
    code: "51-537",
    city: "Wrocław",
  },
  {
    code: "51-601",
    city: "Wrocław",
  },
  {
    code: "51-602",
    city: "Wrocław",
  },
  {
    code: "51-603",
    city: "Wrocław",
  },
  {
    code: "51-604",
    city: "Wrocław",
  },
  {
    code: "51-605",
    city: "Wrocław",
  },
  {
    code: "51-606",
    city: "Wrocław",
  },
  {
    code: "51-607",
    city: "Wrocław",
  },
  {
    code: "51-608",
    city: "Wrocław",
  },
  {
    code: "51-609",
    city: "Wrocław",
  },
  {
    code: "51-610",
    city: "Wrocław",
  },
  {
    code: "51-611",
    city: "Wrocław",
  },
  {
    code: "51-612",
    city: "Wrocław",
  },
  {
    code: "51-613",
    city: "Wrocław",
  },
  {
    code: "51-616",
    city: "Wrocław",
  },
  {
    code: "51-617",
    city: "Wrocław",
  },
  {
    code: "51-618",
    city: "Wrocław",
  },
  {
    code: "51-619",
    city: "Wrocław",
  },
  {
    code: "51-620",
    city: "Wrocław",
  },
  {
    code: "51-621",
    city: "Wrocław",
  },
  {
    code: "51-622",
    city: "Wrocław",
  },
  {
    code: "51-627",
    city: "Wrocław",
  },
  {
    code: "51-628",
    city: "Wrocław",
  },
  {
    code: "51-629",
    city: "Wrocław",
  },
  {
    code: "51-630",
    city: "Wrocław",
  },
  {
    code: "51-631",
    city: "Wrocław",
  },
  {
    code: "51-636",
    city: "Wrocław",
  },
  {
    code: "51-637",
    city: "Wrocław",
  },
  {
    code: "51-638",
    city: "Wrocław",
  },
  {
    code: "51-639",
    city: "Wrocław",
  },
  {
    code: "51-640",
    city: "Wrocław",
  },
  {
    code: "51-641",
    city: "Wrocław",
  },
  {
    code: "51-642",
    city: "Wrocław",
  },
  {
    code: "51-643",
    city: "Wrocław",
  },
  {
    code: "51-644",
    city: "Wrocław",
  },
  {
    code: "51-645",
    city: "Wrocław",
  },
  {
    code: "51-646",
    city: "Wrocław",
  },
  {
    code: "51-647",
    city: "Wrocław",
  },
  {
    code: "51-648",
    city: "Wrocław",
  },
  {
    code: "51-649",
    city: "Wrocław",
  },
  {
    code: "51-650",
    city: "Wrocław",
  },
  {
    code: "51-651",
    city: "Wrocław",
  },
  {
    code: "51-657",
    city: "Wrocław",
  },
  {
    code: "51-658",
    city: "Wrocław",
  },
  {
    code: "51-659",
    city: "Wrocław",
  },
  {
    code: "51-660",
    city: "Wrocław",
  },
  {
    code: "51-661",
    city: "Wrocław",
  },
  {
    code: "51-662",
    city: "Wrocław",
  },
  {
    code: "51-663",
    city: "Wrocław",
  },
  {
    code: "51-664",
    city: "Wrocław",
  },
  {
    code: "51-665",
    city: "Wrocław",
  },
  {
    code: "51-668",
    city: "Wrocław",
  },
  {
    code: "51-669",
    city: "Wrocław",
  },
  {
    code: "51-670",
    city: "Wrocław",
  },
  {
    code: "51-671",
    city: "Wrocław",
  },
  {
    code: "51-672",
    city: "Wrocław",
  },
  {
    code: "51-673",
    city: "Wrocław",
  },
  {
    code: "51-674",
    city: "Wrocław",
  },
  {
    code: "51-675",
    city: "Wrocław",
  },
  {
    code: "51-676",
    city: "Wrocław",
  },
  {
    code: "51-677",
    city: "Wrocław",
  },
  {
    code: "51-678",
    city: "Wrocław",
  },
  {
    code: "51-679",
    city: "Wrocław",
  },
  {
    code: "51-680",
    city: "Wrocław",
  },
  {
    code: "51-681",
    city: "Wrocław",
  },
  {
    code: "51-682",
    city: "Wrocław",
  },
  {
    code: "51-683",
    city: "Wrocław",
  },
  {
    code: "51-684",
    city: "Wrocław",
  },
  {
    code: "51-685",
    city: "Wrocław",
  },
  {
    code: "51-686",
    city: "Wrocław",
  },
  {
    code: "51-687",
    city: "Wrocław",
  },
  {
    code: "51-688",
    city: "Wrocław",
  },
  {
    code: "51-689",
    city: "Wrocław",
  },
  {
    code: "51-690",
    city: "Wrocław",
  },
  {
    code: "51-691",
    city: "Wrocław",
  },
  {
    code: "51-692",
    city: "Wrocław",
  },
  {
    code: "52-007",
    city: "Wrocław",
  },
  {
    code: "52-008",
    city: "Wrocław",
  },
  {
    code: "52-010",
    city: "Wrocław",
  },
  {
    code: "52-011",
    city: "Wrocław",
  },
  {
    code: "52-012",
    city: "Wrocław",
  },
  {
    code: "52-013",
    city: "Wrocław",
  },
  {
    code: "52-014",
    city: "Wrocław",
  },
  {
    code: "52-015",
    city: "Wrocław",
  },
  {
    code: "52-016",
    city: "Wrocław",
  },
  {
    code: "52-017",
    city: "Wrocław",
  },
  {
    code: "52-018",
    city: "Wrocław",
  },
  {
    code: "52-019",
    city: "Wrocław",
  },
  {
    code: "52-020",
    city: "Wrocław",
  },
  {
    code: "52-021",
    city: "Wrocław",
  },
  {
    code: "52-022",
    city: "Wrocław",
  },
  {
    code: "52-023",
    city: "Wrocław",
  },
  {
    code: "52-024",
    city: "Wrocław",
  },
  {
    code: "52-025",
    city: "Wrocław",
  },
  {
    code: "52-026",
    city: "Wrocław",
  },
  {
    code: "52-027",
    city: "Wrocław",
  },
  {
    code: "52-028",
    city: "Wrocław",
  },
  {
    code: "52-029",
    city: "Wrocław",
  },
  {
    code: "52-051",
    city: "Wrocław",
  },
  {
    code: "52-110",
    city: "Wrocław",
  },
  {
    code: "52-111",
    city: "Wrocław",
  },
  {
    code: "52-112",
    city: "Wrocław",
  },
  {
    code: "52-113",
    city: "Wrocław",
  },
  {
    code: "52-114",
    city: "Wrocław",
  },
  {
    code: "52-115",
    city: "Wrocław",
  },
  {
    code: "52-116",
    city: "Wrocław",
  },
  {
    code: "52-117",
    city: "Wrocław",
  },
  {
    code: "52-118",
    city: "Wrocław",
  },
  {
    code: "52-119",
    city: "Wrocław",
  },
  {
    code: "52-120",
    city: "Wrocław",
  },
  {
    code: "52-121",
    city: "Wrocław",
  },
  {
    code: "52-122",
    city: "Wrocław",
  },
  {
    code: "52-123",
    city: "Wrocław",
  },
  {
    code: "52-124",
    city: "Wrocław",
  },
  {
    code: "52-126",
    city: "Wrocław",
  },
  {
    code: "52-127",
    city: "Wrocław",
  },
  {
    code: "52-128",
    city: "Wrocław",
  },
  {
    code: "52-129",
    city: "Wrocław",
  },
  {
    code: "52-130",
    city: "Wrocław",
  },
  {
    code: "52-131",
    city: "Wrocław",
  },
  {
    code: "52-132",
    city: "Wrocław",
  },
  {
    code: "52-133",
    city: "Wrocław",
  },
  {
    code: "52-135",
    city: "Wrocław",
  },
  {
    code: "52-141",
    city: "Wrocław",
  },
  {
    code: "52-200",
    city: "Wrocław",
  },
  {
    code: "52-201",
    city: "Wrocław",
  },
  {
    code: "52-203",
    city: "Wrocław",
  },
  {
    code: "52-204",
    city: "Wrocław",
  },
  {
    code: "52-205",
    city: "Wrocław",
  },
  {
    code: "52-206",
    city: "Wrocław",
  },
  {
    code: "52-207",
    city: "Wrocław",
  },
  {
    code: "52-208",
    city: "Wrocław",
  },
  {
    code: "52-209",
    city: "Wrocław",
  },
  {
    code: "52-210",
    city: "Wrocław",
  },
  {
    code: "52-211",
    city: "Wrocław",
  },
  {
    code: "52-212",
    city: "Wrocław",
  },
  {
    code: "52-213",
    city: "Wrocław",
  },
  {
    code: "52-214",
    city: "Wrocław",
  },
  {
    code: "52-215",
    city: "Wrocław",
  },
  {
    code: "52-216",
    city: "Wrocław",
  },
  {
    code: "52-218",
    city: "Wrocław",
  },
  {
    code: "52-219",
    city: "Wrocław",
  },
  {
    code: "52-220",
    city: "Wrocław",
  },
  {
    code: "52-221",
    city: "Wrocław",
  },
  {
    code: "52-222",
    city: "Wrocław",
  },
  {
    code: "52-223",
    city: "Wrocław",
  },
  {
    code: "52-224",
    city: "Wrocław",
  },
  {
    code: "52-225",
    city: "Wrocław",
  },
  {
    code: "52-226",
    city: "Wrocław",
  },
  {
    code: "52-227",
    city: "Wrocław",
  },
  {
    code: "52-228",
    city: "Wrocław",
  },
  {
    code: "52-229",
    city: "Wrocław",
  },
  {
    code: "52-230",
    city: "Wrocław",
  },
  {
    code: "52-231",
    city: "Wrocław",
  },
  {
    code: "52-232",
    city: "Wrocław",
  },
  {
    code: "52-233",
    city: "Wrocław",
  },
  {
    code: "52-234",
    city: "Wrocław",
  },
  {
    code: "52-235",
    city: "Wrocław",
  },
  {
    code: "52-239",
    city: "Wrocław",
  },
  {
    code: "52-241",
    city: "Wrocław",
  },
  {
    code: "52-242",
    city: "Wrocław",
  },
  {
    code: "52-244",
    city: "Wrocław",
  },
  {
    code: "52-245",
    city: "Wrocław",
  },
  {
    code: "52-258",
    city: "Wrocław",
  },
  {
    code: "52-311",
    city: "Wrocław",
  },
  {
    code: "52-314",
    city: "Wrocław",
  },
  {
    code: "52-315",
    city: "Wrocław",
  },
  {
    code: "52-316",
    city: "Wrocław",
  },
  {
    code: "52-317",
    city: "Wrocław",
  },
  {
    code: "52-319",
    city: "Wrocław",
  },
  {
    code: "52-320",
    city: "Wrocław",
  },
  {
    code: "52-326",
    city: "Wrocław",
  },
  {
    code: "52-327",
    city: "Wrocław",
  },
  {
    code: "52-331",
    city: "Wrocław",
  },
  {
    code: "52-332",
    city: "Wrocław",
  },
  {
    code: "52-333",
    city: "Wrocław",
  },
  {
    code: "52-334",
    city: "Wrocław",
  },
  {
    code: "52-335",
    city: "Wrocław",
  },
  {
    code: "52-336",
    city: "Wrocław",
  },
  {
    code: "52-339",
    city: "Wrocław",
  },
  {
    code: "52-340",
    city: "Wrocław",
  },
  {
    code: "52-401",
    city: "Wrocław",
  },
  {
    code: "52-402",
    city: "Wrocław",
  },
  {
    code: "52-403",
    city: "Wrocław",
  },
  {
    code: "52-404",
    city: "Wrocław",
  },
  {
    code: "52-405",
    city: "Wrocław",
  },
  {
    code: "52-407",
    city: "Wrocław",
  },
  {
    code: "52-408",
    city: "Wrocław",
  },
  {
    code: "52-409",
    city: "Wrocław",
  },
  {
    code: "52-411",
    city: "Wrocław",
  },
  {
    code: "52-412",
    city: "Wrocław",
  },
  {
    code: "52-413",
    city: "Wrocław",
  },
  {
    code: "52-414",
    city: "Wrocław",
  },
  {
    code: "52-415",
    city: "Wrocław",
  },
  {
    code: "52-416",
    city: "Wrocław",
  },
  {
    code: "52-417",
    city: "Wrocław",
  },
  {
    code: "52-418",
    city: "Wrocław",
  },
  {
    code: "52-419",
    city: "Wrocław",
  },
  {
    code: "52-420",
    city: "Wrocław",
  },
  {
    code: "52-421",
    city: "Wrocław",
  },
  {
    code: "52-422",
    city: "Wrocław",
  },
  {
    code: "52-423",
    city: "Wrocław",
  },
  {
    code: "52-424",
    city: "Wrocław",
  },
  {
    code: "52-425",
    city: "Wrocław",
  },
  {
    code: "52-427",
    city: "Wrocław",
  },
  {
    code: "52-428",
    city: "Wrocław",
  },
  {
    code: "52-429",
    city: "Wrocław",
  },
  {
    code: "52-430",
    city: "Wrocław",
  },
  {
    code: "52-431",
    city: "Wrocław",
  },
  {
    code: "52-432",
    city: "Wrocław",
  },
  {
    code: "52-433",
    city: "Wrocław",
  },
  {
    code: "52-434",
    city: "Wrocław",
  },
  {
    code: "52-435",
    city: "Wrocław",
  },
  {
    code: "52-436",
    city: "Wrocław",
  },
  {
    code: "52-437",
    city: "Wrocław",
  },
  {
    code: "52-438",
    city: "Wrocław",
  },
  {
    code: "52-443",
    city: "Wrocław",
  },
  {
    code: "53-004",
    city: "Wrocław",
  },
  {
    code: "53-006",
    city: "Wrocław",
  },
  {
    code: "53-007",
    city: "Wrocław",
  },
  {
    code: "53-008",
    city: "Wrocław",
  },
  {
    code: "53-009",
    city: "Wrocław",
  },
  {
    code: "53-010",
    city: "Wrocław",
  },
  {
    code: "53-011",
    city: "Wrocław",
  },
  {
    code: "53-012",
    city: "Wrocław",
  },
  {
    code: "53-013",
    city: "Wrocław",
  },
  {
    code: "53-014",
    city: "Wrocław",
  },
  {
    code: "53-015",
    city: "Wrocław",
  },
  {
    code: "53-017",
    city: "Wrocław",
  },
  {
    code: "53-018",
    city: "Wrocław",
  },
  {
    code: "53-019",
    city: "Wrocław",
  },
  {
    code: "53-020",
    city: "Wrocław",
  },
  {
    code: "53-021",
    city: "Wrocław",
  },
  {
    code: "53-022",
    city: "Wrocław",
  },
  {
    code: "53-023",
    city: "Wrocław",
  },
  {
    code: "53-024",
    city: "Wrocław",
  },
  {
    code: "53-025",
    city: "Wrocław",
  },
  {
    code: "53-026",
    city: "Wrocław",
  },
  {
    code: "53-027",
    city: "Wrocław",
  },
  {
    code: "53-028",
    city: "Wrocław",
  },
  {
    code: "53-029",
    city: "Wrocław",
  },
  {
    code: "53-030",
    city: "Wrocław",
  },
  {
    code: "53-031",
    city: "Wrocław",
  },
  {
    code: "53-032",
    city: "Wrocław",
  },
  {
    code: "53-033",
    city: "Wrocław",
  },
  {
    code: "53-034",
    city: "Wrocław",
  },
  {
    code: "53-035",
    city: "Wrocław",
  },
  {
    code: "53-110",
    city: "Wrocław",
  },
  {
    code: "53-111",
    city: "Wrocław",
  },
  {
    code: "53-112",
    city: "Wrocław",
  },
  {
    code: "53-113",
    city: "Wrocław",
  },
  {
    code: "53-114",
    city: "Wrocław",
  },
  {
    code: "53-115",
    city: "Wrocław",
  },
  {
    code: "53-116",
    city: "Wrocław",
  },
  {
    code: "53-117",
    city: "Wrocław",
  },
  {
    code: "53-118",
    city: "Wrocław",
  },
  {
    code: "53-119",
    city: "Wrocław",
  },
  {
    code: "53-120",
    city: "Wrocław",
  },
  {
    code: "53-121",
    city: "Wrocław",
  },
  {
    code: "53-122",
    city: "Wrocław",
  },
  {
    code: "53-123",
    city: "Wrocław",
  },
  {
    code: "53-124",
    city: "Wrocław",
  },
  {
    code: "53-125",
    city: "Wrocław",
  },
  {
    code: "53-126",
    city: "Wrocław",
  },
  {
    code: "53-127",
    city: "Wrocław",
  },
  {
    code: "53-128",
    city: "Wrocław",
  },
  {
    code: "53-129",
    city: "Wrocław",
  },
  {
    code: "53-133",
    city: "Wrocław",
  },
  {
    code: "53-134",
    city: "Wrocław",
  },
  {
    code: "53-135",
    city: "Wrocław",
  },
  {
    code: "53-136",
    city: "Wrocław",
  },
  {
    code: "53-137",
    city: "Wrocław",
  },
  {
    code: "53-138",
    city: "Wrocław",
  },
  {
    code: "53-139",
    city: "Wrocław",
  },
  {
    code: "53-140",
    city: "Wrocław",
  },
  {
    code: "53-141",
    city: "Wrocław",
  },
  {
    code: "53-142",
    city: "Wrocław",
  },
  {
    code: "53-143",
    city: "Wrocław",
  },
  {
    code: "53-144",
    city: "Wrocław",
  },
  {
    code: "53-145",
    city: "Wrocław",
  },
  {
    code: "53-146",
    city: "Wrocław",
  },
  {
    code: "53-147",
    city: "Wrocław",
  },
  {
    code: "53-148",
    city: "Wrocław",
  },
  {
    code: "53-149",
    city: "Wrocław",
  },
  {
    code: "53-150",
    city: "Wrocław",
  },
  {
    code: "53-151",
    city: "Wrocław",
  },
  {
    code: "53-152",
    city: "Wrocław",
  },
  {
    code: "53-153",
    city: "Wrocław",
  },
  {
    code: "53-201",
    city: "Wrocław",
  },
  {
    code: "53-202",
    city: "Wrocław",
  },
  {
    code: "53-203",
    city: "Wrocław",
  },
  {
    code: "53-204",
    city: "Wrocław",
  },
  {
    code: "53-205",
    city: "Wrocław",
  },
  {
    code: "53-206",
    city: "Wrocław",
  },
  {
    code: "53-207",
    city: "Wrocław",
  },
  {
    code: "53-208",
    city: "Wrocław",
  },
  {
    code: "53-209",
    city: "Wrocław",
  },
  {
    code: "53-210",
    city: "Wrocław",
  },
  {
    code: "53-211",
    city: "Wrocław",
  },
  {
    code: "53-212",
    city: "Wrocław",
  },
  {
    code: "53-213",
    city: "Wrocław",
  },
  {
    code: "53-214",
    city: "Wrocław",
  },
  {
    code: "53-224",
    city: "Wrocław",
  },
  {
    code: "53-225",
    city: "Wrocław",
  },
  {
    code: "53-226",
    city: "Wrocław",
  },
  {
    code: "53-227",
    city: "Wrocław",
  },
  {
    code: "53-228",
    city: "Wrocław",
  },
  {
    code: "53-229",
    city: "Wrocław",
  },
  {
    code: "53-230",
    city: "Wrocław",
  },
  {
    code: "53-231",
    city: "Wrocław",
  },
  {
    code: "53-232",
    city: "Wrocław",
  },
  {
    code: "53-233",
    city: "Wrocław",
  },
  {
    code: "53-234",
    city: "Wrocław",
  },
  {
    code: "53-235",
    city: "Wrocław",
  },
  {
    code: "53-236",
    city: "Wrocław",
  },
  {
    code: "53-237",
    city: "Wrocław",
  },
  {
    code: "53-238",
    city: "Wrocław",
  },
  {
    code: "53-239",
    city: "Wrocław",
  },
  {
    code: "53-240",
    city: "Wrocław",
  },
  {
    code: "53-241",
    city: "Wrocław",
  },
  {
    code: "53-245",
    city: "Wrocław",
  },
  {
    code: "53-301",
    city: "Wrocław",
  },
  {
    code: "53-302",
    city: "Wrocław",
  },
  {
    code: "53-303",
    city: "Wrocław",
  },
  {
    code: "53-304",
    city: "Wrocław",
  },
  {
    code: "53-305",
    city: "Wrocław",
  },
  {
    code: "53-306",
    city: "Wrocław",
  },
  {
    code: "53-307",
    city: "Wrocław",
  },
  {
    code: "53-308",
    city: "Wrocław",
  },
  {
    code: "53-310",
    city: "Wrocław",
  },
  {
    code: "53-311",
    city: "Wrocław",
  },
  {
    code: "53-312",
    city: "Wrocław",
  },
  {
    code: "53-313",
    city: "Wrocław",
  },
  {
    code: "53-314",
    city: "Wrocław",
  },
  {
    code: "53-315",
    city: "Wrocław",
  },
  {
    code: "53-316",
    city: "Wrocław",
  },
  {
    code: "53-317",
    city: "Wrocław",
  },
  {
    code: "53-318",
    city: "Wrocław",
  },
  {
    code: "53-319",
    city: "Wrocław",
  },
  {
    code: "53-320",
    city: "Wrocław",
  },
  {
    code: "53-321",
    city: "Wrocław",
  },
  {
    code: "53-322",
    city: "Wrocław",
  },
  {
    code: "53-323",
    city: "Wrocław",
  },
  {
    code: "53-324",
    city: "Wrocław",
  },
  {
    code: "53-325",
    city: "Wrocław",
  },
  {
    code: "53-326",
    city: "Wrocław",
  },
  {
    code: "53-327",
    city: "Wrocław",
  },
  {
    code: "53-328",
    city: "Wrocław",
  },
  {
    code: "53-329",
    city: "Wrocław",
  },
  {
    code: "53-330",
    city: "Wrocław",
  },
  {
    code: "53-331",
    city: "Wrocław",
  },
  {
    code: "53-332",
    city: "Wrocław",
  },
  {
    code: "53-333",
    city: "Wrocław",
  },
  {
    code: "53-334",
    city: "Wrocław",
  },
  {
    code: "53-335",
    city: "Wrocław",
  },
  {
    code: "53-336",
    city: "Wrocław",
  },
  {
    code: "53-337",
    city: "Wrocław",
  },
  {
    code: "53-338",
    city: "Wrocław",
  },
  {
    code: "53-339",
    city: "Wrocław",
  },
  {
    code: "53-340",
    city: "Wrocław",
  },
  {
    code: "53-341",
    city: "Wrocław",
  },
  {
    code: "53-342",
    city: "Wrocław",
  },
  {
    code: "53-343",
    city: "Wrocław",
  },
  {
    code: "53-344",
    city: "Wrocław",
  },
  {
    code: "53-345",
    city: "Wrocław",
  },
  {
    code: "53-350",
    city: "Wrocław",
  },
  {
    code: "53-401",
    city: "Wrocław",
  },
  {
    code: "53-402",
    city: "Wrocław",
  },
  {
    code: "53-403",
    city: "Wrocław",
  },
  {
    code: "53-404",
    city: "Wrocław",
  },
  {
    code: "53-405",
    city: "Wrocław",
  },
  {
    code: "53-406",
    city: "Wrocław",
  },
  {
    code: "53-407",
    city: "Wrocław",
  },
  {
    code: "53-408",
    city: "Wrocław",
  },
  {
    code: "53-409",
    city: "Wrocław",
  },
  {
    code: "53-410",
    city: "Wrocław",
  },
  {
    code: "53-411",
    city: "Wrocław",
  },
  {
    code: "53-412",
    city: "Wrocław",
  },
  {
    code: "53-413",
    city: "Wrocław",
  },
  {
    code: "53-414",
    city: "Wrocław",
  },
  {
    code: "53-415",
    city: "Wrocław",
  },
  {
    code: "53-416",
    city: "Wrocław",
  },
  {
    code: "53-417",
    city: "Wrocław",
  },
  {
    code: "53-418",
    city: "Wrocław",
  },
  {
    code: "53-419",
    city: "Wrocław",
  },
  {
    code: "53-421",
    city: "Wrocław",
  },
  {
    code: "53-422",
    city: "Wrocław",
  },
  {
    code: "53-423",
    city: "Wrocław",
  },
  {
    code: "53-424",
    city: "Wrocław",
  },
  {
    code: "53-425",
    city: "Wrocław",
  },
  {
    code: "53-426",
    city: "Wrocław",
  },
  {
    code: "53-427",
    city: "Wrocław",
  },
  {
    code: "53-428",
    city: "Wrocław",
  },
  {
    code: "53-429",
    city: "Wrocław",
  },
  {
    code: "53-430",
    city: "Wrocław",
  },
  {
    code: "53-431",
    city: "Wrocław",
  },
  {
    code: "53-432",
    city: "Wrocław",
  },
  {
    code: "53-433",
    city: "Wrocław",
  },
  {
    code: "53-434",
    city: "Wrocław",
  },
  {
    code: "53-435",
    city: "Wrocław",
  },
  {
    code: "53-436",
    city: "Wrocław",
  },
  {
    code: "53-437",
    city: "Wrocław",
  },
  {
    code: "53-438",
    city: "Wrocław",
  },
  {
    code: "53-439",
    city: "Wrocław",
  },
  {
    code: "53-440",
    city: "Wrocław",
  },
  {
    code: "53-441",
    city: "Wrocław",
  },
  {
    code: "53-442",
    city: "Wrocław",
  },
  {
    code: "53-443",
    city: "Wrocław",
  },
  {
    code: "53-444",
    city: "Wrocław",
  },
  {
    code: "53-445",
    city: "Wrocław",
  },
  {
    code: "53-446",
    city: "Wrocław",
  },
  {
    code: "53-447",
    city: "Wrocław",
  },
  {
    code: "53-501",
    city: "Wrocław",
  },
  {
    code: "53-502",
    city: "Wrocław",
  },
  {
    code: "53-503",
    city: "Wrocław",
  },
  {
    code: "53-504",
    city: "Wrocław",
  },
  {
    code: "53-505",
    city: "Wrocław",
  },
  {
    code: "53-506",
    city: "Wrocław",
  },
  {
    code: "53-507",
    city: "Wrocław",
  },
  {
    code: "53-508",
    city: "Wrocław",
  },
  {
    code: "53-509",
    city: "Wrocław",
  },
  {
    code: "53-510",
    city: "Wrocław",
  },
  {
    code: "53-511",
    city: "Wrocław",
  },
  {
    code: "53-512",
    city: "Wrocław",
  },
  {
    code: "53-513",
    city: "Wrocław",
  },
  {
    code: "53-514",
    city: "Wrocław",
  },
  {
    code: "53-515",
    city: "Wrocław",
  },
  {
    code: "53-516",
    city: "Wrocław",
  },
  {
    code: "53-517",
    city: "Wrocław",
  },
  {
    code: "53-518",
    city: "Wrocław",
  },
  {
    code: "53-519",
    city: "Wrocław",
  },
  {
    code: "53-520",
    city: "Wrocław",
  },
  {
    code: "53-521",
    city: "Wrocław",
  },
  {
    code: "53-522",
    city: "Wrocław",
  },
  {
    code: "53-523",
    city: "Wrocław",
  },
  {
    code: "53-525",
    city: "Wrocław",
  },
  {
    code: "53-526",
    city: "Wrocław",
  },
  {
    code: "53-527",
    city: "Wrocław",
  },
  {
    code: "53-528",
    city: "Wrocław",
  },
  {
    code: "53-529",
    city: "Wrocław",
  },
  {
    code: "53-530",
    city: "Wrocław",
  },
  {
    code: "53-531",
    city: "Wrocław",
  },
  {
    code: "53-532",
    city: "Wrocław",
  },
  {
    code: "53-533",
    city: "Wrocław",
  },
  {
    code: "53-534",
    city: "Wrocław",
  },
  {
    code: "53-535",
    city: "Wrocław",
  },
  {
    code: "53-601",
    city: "Wrocław",
  },
  {
    code: "53-602",
    city: "Wrocław",
  },
  {
    code: "53-603",
    city: "Wrocław",
  },
  {
    code: "53-604",
    city: "Wrocław",
  },
  {
    code: "53-605",
    city: "Wrocław",
  },
  {
    code: "53-607",
    city: "Wrocław",
  },
  {
    code: "53-608",
    city: "Wrocław",
  },
  {
    code: "53-609",
    city: "Wrocław",
  },
  {
    code: "53-610",
    city: "Wrocław",
  },
  {
    code: "53-611",
    city: "Wrocław",
  },
  {
    code: "53-612",
    city: "Wrocław",
  },
  {
    code: "53-613",
    city: "Wrocław",
  },
  {
    code: "53-614",
    city: "Wrocław",
  },
  {
    code: "53-615",
    city: "Wrocław",
  },
  {
    code: "53-616",
    city: "Wrocław",
  },
  {
    code: "53-617",
    city: "Wrocław",
  },
  {
    code: "53-621",
    city: "Wrocław",
  },
  {
    code: "53-622",
    city: "Wrocław",
  },
  {
    code: "53-623",
    city: "Wrocław",
  },
  {
    code: "53-624",
    city: "Wrocław",
  },
  {
    code: "53-625",
    city: "Wrocław",
  },
  {
    code: "53-626",
    city: "Wrocław",
  },
  {
    code: "53-627",
    city: "Wrocław",
  },
  {
    code: "53-628",
    city: "Wrocław",
  },
  {
    code: "53-629",
    city: "Wrocław",
  },
  {
    code: "53-630",
    city: "Wrocław",
  },
  {
    code: "53-631",
    city: "Wrocław",
  },
  {
    code: "53-632",
    city: "Wrocław",
  },
  {
    code: "53-633",
    city: "Wrocław",
  },
  {
    code: "53-638",
    city: "Wrocław",
  },
  {
    code: "53-641",
    city: "Wrocław",
  },
  {
    code: "53-642",
    city: "Wrocław",
  },
  {
    code: "53-643",
    city: "Wrocław",
  },
  {
    code: "53-644",
    city: "Wrocław",
  },
  {
    code: "53-645",
    city: "Wrocław",
  },
  {
    code: "53-646",
    city: "Wrocław",
  },
  {
    code: "53-647",
    city: "Wrocław",
  },
  {
    code: "53-648",
    city: "Wrocław",
  },
  {
    code: "53-649",
    city: "Wrocław",
  },
  {
    code: "53-650",
    city: "Wrocław",
  },
  {
    code: "53-651",
    city: "Wrocław",
  },
  {
    code: "53-652",
    city: "Wrocław",
  },
  {
    code: "53-653",
    city: "Wrocław",
  },
  {
    code: "53-654",
    city: "Wrocław",
  },
  {
    code: "53-655",
    city: "Wrocław",
  },
  {
    code: "53-656",
    city: "Wrocław",
  },
  {
    code: "53-657",
    city: "Wrocław",
  },
  {
    code: "53-658",
    city: "Wrocław",
  },
  {
    code: "53-659",
    city: "Wrocław",
  },
  {
    code: "53-660",
    city: "Wrocław",
  },
  {
    code: "53-661",
    city: "Wrocław",
  },
  {
    code: "53-662",
    city: "Wrocław",
  },
  {
    code: "53-663",
    city: "Wrocław",
  },
  {
    code: "53-671",
    city: "Wrocław",
  },
  {
    code: "53-672",
    city: "Wrocław",
  },
  {
    code: "53-673",
    city: "Wrocław",
  },
  {
    code: "53-674",
    city: "Wrocław",
  },
  {
    code: "53-675",
    city: "Wrocław",
  },
  {
    code: "53-676",
    city: "Wrocław",
  },
  {
    code: "53-677",
    city: "Wrocław",
  },
  {
    code: "53-678",
    city: "Wrocław",
  },
  {
    code: "53-679",
    city: "Wrocław",
  },
  {
    code: "53-680",
    city: "Wrocław",
  },
  {
    code: "53-681",
    city: "Wrocław",
  },
  {
    code: "54-001",
    city: "Wrocław",
  },
  {
    code: "54-002",
    city: "Wrocław",
  },
  {
    code: "54-003",
    city: "Wrocław",
  },
  {
    code: "54-004",
    city: "Wrocław",
  },
  {
    code: "54-005",
    city: "Wrocław",
  },
  {
    code: "54-006",
    city: "Wrocław",
  },
  {
    code: "54-007",
    city: "Wrocław",
  },
  {
    code: "54-008",
    city: "Wrocław",
  },
  {
    code: "54-009",
    city: "Wrocław",
  },
  {
    code: "54-010",
    city: "Wrocław",
  },
  {
    code: "54-011",
    city: "Wrocław",
  },
  {
    code: "54-014",
    city: "Wrocław",
  },
  {
    code: "54-015",
    city: "Wrocław",
  },
  {
    code: "54-016",
    city: "Wrocław",
  },
  {
    code: "54-017",
    city: "Wrocław",
  },
  {
    code: "54-018",
    city: "Wrocław",
  },
  {
    code: "54-019",
    city: "Wrocław",
  },
  {
    code: "54-020",
    city: "Wrocław",
  },
  {
    code: "54-025",
    city: "Wrocław",
  },
  {
    code: "54-026",
    city: "Wrocław",
  },
  {
    code: "54-027",
    city: "Wrocław",
  },
  {
    code: "54-028",
    city: "Wrocław",
  },
  {
    code: "54-029",
    city: "Wrocław",
  },
  {
    code: "54-030",
    city: "Wrocław",
  },
  {
    code: "54-031",
    city: "Wrocław",
  },
  {
    code: "54-032",
    city: "Wrocław",
  },
  {
    code: "54-033",
    city: "Wrocław",
  },
  {
    code: "54-034",
    city: "Wrocław",
  },
  {
    code: "54-035",
    city: "Wrocław",
  },
  {
    code: "54-041",
    city: "Wrocław",
  },
  {
    code: "54-042",
    city: "Wrocław",
  },
  {
    code: "54-043",
    city: "Wrocław",
  },
  {
    code: "54-044",
    city: "Wrocław",
  },
  {
    code: "54-045",
    city: "Wrocław",
  },
  {
    code: "54-046",
    city: "Wrocław",
  },
  {
    code: "54-047",
    city: "Wrocław",
  },
  {
    code: "54-048",
    city: "Wrocław",
  },
  {
    code: "54-049",
    city: "Wrocław",
  },
  {
    code: "54-054",
    city: "Wrocław",
  },
  {
    code: "54-055",
    city: "Wrocław",
  },
  {
    code: "54-056",
    city: "Wrocław",
  },
  {
    code: "54-057",
    city: "Wrocław",
  },
  {
    code: "54-058",
    city: "Wrocław",
  },
  {
    code: "54-059",
    city: "Wrocław",
  },
  {
    code: "54-060",
    city: "Wrocław",
  },
  {
    code: "54-061",
    city: "Wrocław",
  },
  {
    code: "54-062",
    city: "Wrocław",
  },
  {
    code: "54-063",
    city: "Wrocław",
  },
  {
    code: "54-064",
    city: "Wrocław",
  },
  {
    code: "54-066",
    city: "Wrocław",
  },
  {
    code: "54-067",
    city: "Wrocław",
  },
  {
    code: "54-071",
    city: "Wrocław",
  },
  {
    code: "54-072",
    city: "Wrocław",
  },
  {
    code: "54-074",
    city: "Wrocław",
  },
  {
    code: "54-076",
    city: "Wrocław",
  },
  {
    code: "54-078",
    city: "Wrocław",
  },
  {
    code: "54-079",
    city: "Wrocław",
  },
  {
    code: "54-081",
    city: "Wrocław",
  },
  {
    code: "54-101",
    city: "Wrocław",
  },
  {
    code: "54-102",
    city: "Wrocław",
  },
  {
    code: "54-103",
    city: "Wrocław",
  },
  {
    code: "54-104",
    city: "Wrocław",
  },
  {
    code: "54-105",
    city: "Wrocław",
  },
  {
    code: "54-106",
    city: "Wrocław",
  },
  {
    code: "54-107",
    city: "Wrocław",
  },
  {
    code: "54-108",
    city: "Wrocław",
  },
  {
    code: "54-109",
    city: "Wrocław",
  },
  {
    code: "54-110",
    city: "Wrocław",
  },
  {
    code: "54-111",
    city: "Wrocław",
  },
  {
    code: "54-112",
    city: "Wrocław",
  },
  {
    code: "54-113",
    city: "Wrocław",
  },
  {
    code: "54-114",
    city: "Wrocław",
  },
  {
    code: "54-115",
    city: "Wrocław",
  },
  {
    code: "54-116",
    city: "Wrocław",
  },
  {
    code: "54-117",
    city: "Wrocław",
  },
  {
    code: "54-126",
    city: "Wrocław",
  },
  {
    code: "54-127",
    city: "Wrocław",
  },
  {
    code: "54-128",
    city: "Wrocław",
  },
  {
    code: "54-129",
    city: "Wrocław",
  },
  {
    code: "54-130",
    city: "Wrocław",
  },
  {
    code: "54-131",
    city: "Wrocław",
  },
  {
    code: "54-132",
    city: "Wrocław",
  },
  {
    code: "54-133",
    city: "Wrocław",
  },
  {
    code: "54-134",
    city: "Wrocław",
  },
  {
    code: "54-135",
    city: "Wrocław",
  },
  {
    code: "54-136",
    city: "Wrocław",
  },
  {
    code: "54-137",
    city: "Wrocław",
  },
  {
    code: "54-138",
    city: "Wrocław",
  },
  {
    code: "54-139",
    city: "Wrocław",
  },
  {
    code: "54-142",
    city: "Wrocław",
  },
  {
    code: "54-143",
    city: "Wrocław",
  },
  {
    code: "54-144",
    city: "Wrocław",
  },
  {
    code: "54-145",
    city: "Wrocław",
  },
  {
    code: "54-149",
    city: "Wrocław",
  },
  {
    code: "54-150",
    city: "Wrocław",
  },
  {
    code: "54-151",
    city: "Wrocław",
  },
  {
    code: "54-152",
    city: "Wrocław",
  },
  {
    code: "54-153",
    city: "Wrocław",
  },
  {
    code: "54-154",
    city: "Wrocław",
  },
  {
    code: "54-155",
    city: "Wrocław",
  },
  {
    code: "54-156",
    city: "Wrocław",
  },
  {
    code: "54-160",
    city: "Wrocław",
  },
  {
    code: "54-201",
    city: "Wrocław",
  },
  {
    code: "54-202",
    city: "Wrocław",
  },
  {
    code: "54-203",
    city: "Wrocław",
  },
  {
    code: "54-204",
    city: "Wrocław",
  },
  {
    code: "54-205",
    city: "Wrocław",
  },
  {
    code: "54-206",
    city: "Wrocław",
  },
  {
    code: "54-207",
    city: "Wrocław",
  },
  {
    code: "54-210",
    city: "Wrocław",
  },
  {
    code: "54-211",
    city: "Wrocław",
  },
  {
    code: "54-212",
    city: "Wrocław",
  },
  {
    code: "54-213",
    city: "Wrocław",
  },
  {
    code: "54-214",
    city: "Wrocław",
  },
  {
    code: "54-215",
    city: "Wrocław",
  },
  {
    code: "54-216",
    city: "Wrocław",
  },
  {
    code: "54-217",
    city: "Wrocław",
  },
  {
    code: "54-218",
    city: "Wrocław",
  },
  {
    code: "54-220",
    city: "Wrocław",
  },
  {
    code: "54-222",
    city: "Wrocław",
  },
  {
    code: "54-229",
    city: "Wrocław",
  },
  {
    code: "54-230",
    city: "Wrocław",
  },
  {
    code: "54-231",
    city: "Wrocław",
  },
  {
    code: "54-232",
    city: "Wrocław",
  },
  {
    code: "54-233",
    city: "Wrocław",
  },
  {
    code: "54-234",
    city: "Wrocław",
  },
  {
    code: "54-235",
    city: "Wrocław",
  },
  {
    code: "54-236",
    city: "Wrocław",
  },
  {
    code: "54-237",
    city: "Wrocław",
  },
  {
    code: "54-238",
    city: "Wrocław",
  },
  {
    code: "54-239",
    city: "Wrocław",
  },
  {
    code: "54-240",
    city: "Wrocław",
  },
  {
    code: "54-241",
    city: "Wrocław",
  },
  {
    code: "54-242",
    city: "Wrocław",
  },
  {
    code: "54-310",
    city: "Wrocław",
  },
  {
    code: "54-311",
    city: "Wrocław",
  },
  {
    code: "54-312",
    city: "Wrocław",
  },
  {
    code: "54-313",
    city: "Wrocław",
  },
  {
    code: "54-314",
    city: "Wrocław",
  },
  {
    code: "54-315",
    city: "Wrocław",
  },
  {
    code: "54-316",
    city: "Wrocław",
  },
  {
    code: "54-317",
    city: "Wrocław",
  },
  {
    code: "54-318",
    city: "Wrocław",
  },
  {
    code: "54-320",
    city: "Wrocław",
  },
  {
    code: "54-330",
    city: "Wrocław",
  },
  {
    code: "54-401",
    city: "Wrocław",
  },
  {
    code: "54-402",
    city: "Wrocław",
  },
  {
    code: "54-403",
    city: "Wrocław",
  },
  {
    code: "54-404",
    city: "Wrocław",
  },
  {
    code: "54-405",
    city: "Wrocław",
  },
  {
    code: "54-406",
    city: "Wrocław",
  },
  {
    code: "54-409",
    city: "Wrocław",
  },
  {
    code: "54-411",
    city: "Wrocław",
  },
  {
    code: "54-412",
    city: "Wrocław",
  },
  {
    code: "54-413",
    city: "Wrocław",
  },
  {
    code: "54-414",
    city: "Wrocław",
  },
  {
    code: "54-424",
    city: "Wrocław",
  },
  {
    code: "54-425",
    city: "Wrocław",
  },
  {
    code: "54-426",
    city: "Wrocław",
  },
  {
    code: "54-427",
    city: "Wrocław",
  },
  {
    code: "54-428",
    city: "Wrocław",
  },
  {
    code: "54-429",
    city: "Wrocław",
  },
  {
    code: "54-430",
    city: "Wrocław",
  },
  {
    code: "54-431",
    city: "Wrocław",
  },
  {
    code: "54-432",
    city: "Wrocław",
  },
  {
    code: "54-433",
    city: "Wrocław",
  },
  {
    code: "54-434",
    city: "Wrocław",
  },
  {
    code: "54-435",
    city: "Wrocław",
  },
  {
    code: "54-436",
    city: "Wrocław",
  },
  {
    code: "54-438",
    city: "Wrocław",
  },
  {
    code: "54-440",
    city: "Wrocław",
  },
  {
    code: "54-510",
    city: "Wrocław",
  },
  {
    code: "54-511",
    city: "Wrocław",
  },
  {
    code: "54-512",
    city: "Wrocław",
  },
  {
    code: "54-513",
    city: "Wrocław",
  },
  {
    code: "54-514",
    city: "Wrocław",
  },
  {
    code: "54-515",
    city: "Wrocław",
  },
  {
    code: "54-516",
    city: "Wrocław",
  },
  {
    code: "54-517",
    city: "Wrocław",
  },
  {
    code: "54-518",
    city: "Wrocław",
  },
  {
    code: "54-519",
    city: "Wrocław",
  },
  {
    code: "54-520",
    city: "Wrocław",
  },
  {
    code: "54-530",
    city: "Wrocław",
  },
  {
    code: "54-607",
    city: "Wrocław",
  },
  {
    code: "54-608",
    city: "Wrocław",
  },
  {
    code: "54-609",
    city: "Wrocław",
  },
  {
    code: "54-610",
    city: "Wrocław",
  },
  {
    code: "54-611",
    city: "Wrocław",
  },
  {
    code: "54-612",
    city: "Wrocław",
  },
  {
    code: "54-613",
    city: "Wrocław",
  },
  {
    code: "54-614",
    city: "Wrocław",
  },
  {
    code: "54-615",
    city: "Wrocław",
  },
  {
    code: "54-616",
    city: "Wrocław",
  },
  {
    code: "54-617",
    city: "Wrocław",
  },
  {
    code: "54-618",
    city: "Wrocław",
  },
  {
    code: "54-619",
    city: "Wrocław",
  },
  {
    code: "54-620",
    city: "Wrocław",
  },
  {
    code: "54-621",
    city: "Wrocław",
  },
  {
    code: "54-622",
    city: "Wrocław",
  },
  {
    code: "54-701",
    city: "Wrocław",
  },
  {
    code: "54-702",
    city: "Wrocław",
  },
  {
    code: "54-703",
    city: "Wrocław",
  },
  {
    code: "54-704",
    city: "Wrocław",
  },
  {
    code: "54-705",
    city: "Wrocław",
  },
  {
    code: "55-002",
    city: "Kamieniec Wrocławski",
  },
  {
    code: "55-003",
    city: "Czernica",
  },
  {
    code: "55-010",
    city: "Święta Katarzyna",
  },
  {
    code: "55-011",
    city: "Siechnice",
  },
  {
    code: "55-015",
    city: "Radwanice",
  },
  {
    code: "55-020",
    city: "Żórawina",
  },
  {
    code: "55-040",
    city: "Kobierzyce",
  },
  {
    code: "55-041",
    city: "Tyniec Mały",
  },
  {
    code: "55-042",
    city: "Gniechowice",
  },
  {
    code: "55-045",
    city: "Rogów Sobócki",
  },
  {
    code: "55-050",
    city: "Sobótka",
  },
  {
    code: "55-051",
    city: "Sobótka",
  },
  {
    code: "55-065",
    city: "Jordanów Śląski",
  },
  {
    code: "55-070",
    city: "Smolec",
  },
  {
    code: "55-075",
    city: "Bielany Wrocławskie",
  },
  {
    code: "55-076",
    city: "Bielany Wrocławskie",
  },
  {
    code: "55-077",
    city: "Bielany Wrocławskie",
  },
  {
    code: "55-080",
    city: "Kąty Wrocławskie",
  },
  {
    code: "55-081",
    city: "Mietków",
  },
  {
    code: "55-090",
    city: "Długołęka",
  },
  {
    code: "55-091",
    city: "Borowa",
  },
  {
    code: "55-093",
    city: "Kiełczów",
  },
  {
    code: "55-094",
    city: "Łozina",
  },
  {
    code: "55-095",
    city: "Mirków",
  },
  {
    code: "55-100",
    city: "Trzebnica",
  },
  {
    code: "55-106",
    city: "Zawonia",
  },
  {
    code: "55-110",
    city: "Prusice",
  },
  {
    code: "55-114",
    city: "Wisznia Mała",
  },
  {
    code: "55-120",
    city: "Oborniki Śląskie",
  },
  {
    code: "55-124",
    city: "Pęgów",
  },
  {
    code: "55-130",
    city: "Skokowa",
  },
  {
    code: "55-140",
    city: "Żmigród",
  },
  {
    code: "55-200",
    city: "Oława",
  },
  {
    code: "55-201",
    city: "Oława",
  },
  {
    code: "55-202",
    city: "Oława",
  },
  {
    code: "55-203",
    city: "Oława",
  },
  {
    code: "55-206",
    city: "Minkowice Oławskie",
  },
  {
    code: "55-216",
    city: "Domaniów",
  },
  {
    code: "55-220",
    city: "Jelcz-Laskowice",
  },
  {
    code: "55-221",
    city: "Jelcz-Laskowice",
  },
  {
    code: "55-230",
    city: "Jelcz-Laskowice",
  },
  {
    code: "55-231",
    city: "Jelcz-Laskowice",
  },
  {
    code: "55-300",
    city: "Środa Śląska",
  },
  {
    code: "55-311",
    city: "Kostomłoty",
  },
  {
    code: "55-318",
    city: "Szczepanów",
  },
  {
    code: "55-320",
    city: "Malczyce",
  },
  {
    code: "55-330",
    city: "Miękinia",
  },
  {
    code: "55-333",
    city: "Lutynia",
  },
  {
    code: "55-334",
    city: "Mrozów",
  },
  {
    code: "55-340",
    city: "Udanin",
  },
  {
    code: "55-341",
    city: "Ujazd Górny",
  },
  {
    code: "56-100",
    city: "Wołów",
  },
  {
    code: "56-110",
    city: "Lubiąż",
  },
  {
    code: "56-120",
    city: "Brzeg Dolny",
  },
  {
    code: "56-121",
    city: "Brzeg Dolny",
  },
  {
    code: "56-122",
    city: "Brzeg Dolny",
  },
  {
    code: "56-150",
    city: "Krzelów",
  },
  {
    code: "56-160",
    city: "Wińsko",
  },
  {
    code: "56-200",
    city: "Góra",
  },
  {
    code: "56-209",
    city: "Jemielno",
  },
  {
    code: "56-210",
    city: "Wąsosz",
  },
  {
    code: "56-215",
    city: "Niechlów",
  },
  {
    code: "56-300",
    city: "Milicz",
  },
  {
    code: "56-305",
    city: "Kuźnica Czeszycka",
  },
  {
    code: "56-306",
    city: "Sułów",
  },
  {
    code: "56-320",
    city: "Krośnice",
  },
  {
    code: "56-330",
    city: "Cieszków",
  },
  {
    code: "56-400",
    city: "Oleśnica",
  },
  {
    code: "56-401",
    city: "Oleśnica",
  },
  {
    code: "56-404",
    city: "Wabienice",
  },
  {
    code: "56-409",
    city: "Oleśnica",
  },
  {
    code: "56-410",
    city: "Dobroszyce",
  },
  {
    code: "56-416",
    city: "Twardogóra",
  },
  {
    code: "56-417",
    city: "Goszcz",
  },
  {
    code: "56-420",
    city: "Bierutów",
  },
  {
    code: "56-500",
    city: "Syców",
  },
  {
    code: "56-504",
    city: "Dziadowa Kłoda",
  },
  {
    code: "56-513",
    city: "Międzybórz",
  },
  {
    code: "57-100",
    city: "Strzelin",
  },
  {
    code: "57-110",
    city: "Borek Strzeliński",
  },
  {
    code: "57-120",
    city: "Wiązów",
  },
  {
    code: "57-130",
    city: "Przeworno",
  },
  {
    code: "57-150",
    city: "Prusy",
  },
  {
    code: "57-160",
    city: "Borów",
  },
  {
    code: "57-200",
    city: "Ząbkowice Śląskie",
  },
  {
    code: "57-201",
    city: "Ząbkowice Śląskie",
  },
  {
    code: "57-210",
    city: "Henryków",
  },
  {
    code: "57-211",
    city: "Ciepłowody",
  },
  {
    code: "57-215",
    city: "Srebrna Góra",
  },
  {
    code: "57-220",
    city: "Ziębice",
  },
  {
    code: "57-230",
    city: "Kamieniec Ząbkowicki",
  },
  {
    code: "57-250",
    city: "Złoty Stok",
  },
  {
    code: "57-251",
    city: "Laski",
  },
  {
    code: "57-256",
    city: "Bardo",
  },
  {
    code: "57-300",
    city: "Kłodzko",
  },
  {
    code: "57-303",
    city: "Kłodzko",
  },
  {
    code: "57-304",
    city: "Kłodzko",
  },
  {
    code: "57-320",
    city: "Polanica-Zdrój",
  },
  {
    code: "57-330",
    city: "Szczytna",
  },
  {
    code: "57-340",
    city: "Duszniki-Zdrój",
  },
  {
    code: "57-343",
    city: "Lewin Kłodzki",
  },
  {
    code: "57-350",
    city: "Kudowa Zdrój",
  },
  {
    code: "57-351",
    city: "Kudowa Zdrój",
  },
  {
    code: "57-360",
    city: "Ołdrzychowice Kłodzkie",
  },
  {
    code: "57-362",
    city: "Krosnowice",
  },
  {
    code: "57-400",
    city: "Nowa Ruda",
  },
  {
    code: "57-401",
    city: "Nowa Ruda",
  },
  {
    code: "57-402",
    city: "Nowa Ruda",
  },
  {
    code: "57-403",
    city: "Nowa Ruda",
  },
  {
    code: "57-408",
    city: "Tłumaczów",
  },
  {
    code: "57-410",
    city: "Ścinawka Średnia",
  },
  {
    code: "57-420",
    city: "Radków",
  },
  {
    code: "57-431",
    city: "Wolibórz",
  },
  {
    code: "57-450",
    city: "Ludwikowice Kłodzkie",
  },
  {
    code: "57-500",
    city: "Bystrzyca Kłodzka",
  },
  {
    code: "57-501",
    city: "Bystrzyca Kłodzka",
  },
  {
    code: "57-520",
    city: "Długopole-Zdrój",
  },
  {
    code: "57-521",
    city: "Gorzanów",
  },
  {
    code: "57-522",
    city: "Domaszków",
  },
  {
    code: "57-530",
    city: "Międzylesie",
  },
  {
    code: "57-540",
    city: "Lądek-Zdrój",
  },
  {
    code: "57-550",
    city: "Stronie Śląskie",
  },
  {
    code: "58-100",
    city: "Świdnica",
  },
  {
    code: "58-101",
    city: "Świdnica",
  },
  {
    code: "58-102",
    city: "Świdnica",
  },
  {
    code: "58-103",
    city: "Świdnica",
  },
  {
    code: "58-105",
    city: "Świdnica",
  },
  {
    code: "58-106",
    city: "Świdnica",
  },
  {
    code: "58-111",
    city: "Wiry",
  },
  {
    code: "58-124",
    city: "Marcinowice",
  },
  {
    code: "58-130",
    city: "Żarów",
  },
  {
    code: "58-140",
    city: "Jaworzyna Śląska",
  },
  {
    code: "58-150",
    city: "Strzegom",
  },
  {
    code: "58-160",
    city: "Świebodzice",
  },
  {
    code: "58-163",
    city: "Świebodzice",
  },
  {
    code: "58-170",
    city: "Dobromierz",
  },
  {
    code: "58-173",
    city: "Roztoka",
  },
  {
    code: "58-200",
    city: "Dzierżoniów",
  },
  {
    code: "58-202",
    city: "Dzierżoniów",
  },
  {
    code: "58-203",
    city: "Dzierżoniów",
  },
  {
    code: "58-210",
    city: "Łagiewniki",
  },
  {
    code: "58-230",
    city: "Niemcza",
  },
  {
    code: "58-240",
    city: "Piława Górna",
  },
  {
    code: "58-250",
    city: "Pieszyce",
  },
  {
    code: "58-260",
    city: "Bielawa",
  },
  {
    code: "58-261",
    city: "Bielawa",
  },
  {
    code: "58-262",
    city: "Ostroszowice",
  },
  {
    code: "58-263",
    city: "Bielawa",
  },
  {
    code: "58-300",
    city: "Wałbrzych",
  },
  {
    code: "58-301",
    city: "Wałbrzych",
  },
  {
    code: "58-302",
    city: "Wałbrzych",
  },
  {
    code: "58-303",
    city: "Wałbrzych",
  },
  {
    code: "58-304",
    city: "Wałbrzych",
  },
  {
    code: "58-305",
    city: "Wałbrzych",
  },
  {
    code: "58-306",
    city: "Wałbrzych",
  },
  {
    code: "58-307",
    city: "Wałbrzych",
  },
  {
    code: "58-309",
    city: "Wałbrzych",
  },
  {
    code: "58-310",
    city: "Szczawno-Zdrój",
  },
  {
    code: "58-312",
    city: "Stare Bogaczowice",
  },
  {
    code: "58-316",
    city: "Wałbrzych",
  },
  {
    code: "58-320",
    city: "Walim",
  },
  {
    code: "58-330",
    city: "Jedlina-Zdrój",
  },
  {
    code: "58-340",
    city: "Głuszyca",
  },
  {
    code: "58-350",
    city: "Mieroszów",
  },
  {
    code: "58-370",
    city: "Boguszów-Gorce",
  },
  {
    code: "58-371",
    city: "Boguszów-Gorce",
  },
  {
    code: "58-379",
    city: "Czarny Bór",
  },
  {
    code: "58-390",
    city: "Wałbrzych",
  },
  {
    code: "58-400",
    city: "Kamienna Góra",
  },
  {
    code: "58-402",
    city: "Kamienna Góra",
  },
  {
    code: "58-405",
    city: "Krzeszów",
  },
  {
    code: "58-407",
    city: "Chełmsko Śląskie",
  },
  {
    code: "58-410",
    city: "Marciszów",
  },
  {
    code: "58-420",
    city: "Lubawka",
  },
  {
    code: "58-425",
    city: "Leszczyniec",
  },
  {
    code: "58-500",
    city: "Jelenia Góra",
  },
  {
    code: "58-501",
    city: "Jelenia Góra",
  },
  {
    code: "58-503",
    city: "Jelenia Góra",
  },
  {
    code: "58-505",
    city: "Jelenia Góra",
  },
  {
    code: "58-506",
    city: "Jelenia Góra",
  },
  {
    code: "58-507",
    city: "Jelenia Góra",
  },
  {
    code: "58-508",
    city: "Jelenia Góra",
  },
  {
    code: "58-512",
    city: "Stara Kamienica",
  },
  {
    code: "58-520",
    city: "Janowice Wielkie",
  },
  {
    code: "58-521",
    city: "Jeżów Sudecki",
  },
  {
    code: "58-530",
    city: "Kowary",
  },
  {
    code: "58-533",
    city: "Mysłakowice",
  },
  {
    code: "58-535",
    city: "Miłków",
  },
  {
    code: "58-540",
    city: "Karpacz",
  },
  {
    code: "58-550",
    city: "Karpacz",
  },
  {
    code: "58-560",
    city: "Jelenia Góra",
  },
  {
    code: "58-562",
    city: "Podgórzyn",
  },
  {
    code: "58-563",
    city: "Przesieka",
  },
  {
    code: "58-564",
    city: "Sosnówka",
  },
  {
    code: "58-570",
    city: "Jelenia Góra",
  },
  {
    code: "58-573",
    city: "Piechowice",
  },
  {
    code: "58-580",
    city: "Szklarska Poręba",
  },
  {
    code: "58-588",
    city: "Jelenia Góra",
  },
  {
    code: "59-100",
    city: "Polkowice",
  },
  {
    code: "59-101",
    city: "Polkowice",
  },
  {
    code: "59-140",
    city: "Chocianów",
  },
  {
    code: "59-141",
    city: "Chocianów",
  },
  {
    code: "59-150",
    city: "Grębocice",
  },
  {
    code: "59-160",
    city: "Radwanice",
  },
  {
    code: "59-170",
    city: "Przemków",
  },
  {
    code: "59-171",
    city: "Przemków",
  },
  {
    code: "59-180",
    city: "Gaworzyce",
  },
  {
    code: "59-200",
    city: "Legnica",
  },
  {
    code: "59-202",
    city: "Legnica",
  },
  {
    code: "59-203",
    city: "Legnica",
  },
  {
    code: "59-204",
    city: "Legnica",
  },
  {
    code: "59-205",
    city: "Legnica",
  },
  {
    code: "59-206",
    city: "Legnica",
  },
  {
    code: "59-207",
    city: "Legnica",
  },
  {
    code: "59-208",
    city: "Legnica",
  },
  {
    code: "59-209",
    city: "Legnica",
  },
  {
    code: "59-210",
    city: "Legnica",
  },
  {
    code: "59-211",
    city: "Legnica",
  },
  {
    code: "59-212",
    city: "Legnica",
  },
  {
    code: "59-213",
    city: "Legnica",
  },
  {
    code: "59-214",
    city: "Legnica",
  },
  {
    code: "59-216",
    city: "Kunice",
  },
  {
    code: "59-217",
    city: "Legnica",
  },
  {
    code: "59-220",
    city: "Legnica",
  },
  {
    code: "59-222",
    city: "Miłkowice",
  },
  {
    code: "59-223",
    city: "Krotoszyce",
  },
  {
    code: "59-224",
    city: "Chojnów",
  },
  {
    code: "59-225",
    city: "Chojnów",
  },
  {
    code: "59-230",
    city: "Prochowice",
  },
  {
    code: "59-241",
    city: "Legnickie Pole",
  },
  {
    code: "59-243",
    city: "Ruja",
  },
  {
    code: "59-290",
    city: "Legnica",
  },
  {
    code: "59-300",
    city: "Lubin",
  },
  {
    code: "59-301",
    city: "Lubin",
  },
  {
    code: "59-302",
    city: "Lubin",
  },
  {
    code: "59-303",
    city: "Lubin",
  },
  {
    code: "59-304",
    city: "Lubin",
  },
  {
    code: "59-305",
    city: "Rudna",
  },
  {
    code: "59-307",
    city: "Raszówka",
  },
  {
    code: "59-311",
    city: "Lubin",
  },
  {
    code: "59-323",
    city: "Miłoradzice",
  },
  {
    code: "59-330",
    city: "Ścinawa",
  },
  {
    code: "59-334",
    city: "Lubin",
  },
  {
    code: "59-335",
    city: "Lubin",
  },
  {
    code: "59-336",
    city: "Lubin",
  },
  {
    code: "59-337",
    city: "Lubin",
  },
  {
    code: "59-338",
    city: "Lubin",
  },
  {
    code: "59-339",
    city: "Lubin",
  },
  {
    code: "59-400",
    city: "Jawor",
  },
  {
    code: "59-401",
    city: "Jawor",
  },
  {
    code: "59-402",
    city: "Jawor",
  },
  {
    code: "59-407",
    city: "Mściwojów",
  },
  {
    code: "59-411",
    city: "Paszowice",
  },
  {
    code: "59-420",
    city: "Bolków",
  },
  {
    code: "59-423",
    city: "Pomocne",
  },
  {
    code: "59-424",
    city: "Męcinka",
  },
  {
    code: "59-430",
    city: "Wądroże Wielkie",
  },
  {
    code: "59-500",
    city: "Złotoryja",
  },
  {
    code: "59-501",
    city: "Złotoryja",
  },
  {
    code: "59-516",
    city: "Zagrodno",
  },
  {
    code: "59-524",
    city: "Pielgrzymka",
  },
  {
    code: "59-540",
    city: "Świerzawa",
  },
  {
    code: "59-550",
    city: "Wojcieszów",
  },
  {
    code: "59-600",
    city: "Lwówek Śląski",
  },
  {
    code: "59-601",
    city: "Lwówek Śląski",
  },
  {
    code: "59-610",
    city: "Wleń",
  },
  {
    code: "59-620",
    city: "Gryfów Śląski",
  },
  {
    code: "59-623",
    city: "Lubomierz",
  },
  {
    code: "59-630",
    city: "Mirsk",
  },
  {
    code: "59-700",
    city: "Bolesławiec",
  },
  {
    code: "59-701",
    city: "Bolesławiec",
  },
  {
    code: "59-702",
    city: "Bolesławiec",
  },
  {
    code: "59-703",
    city: "Bolesławiec",
  },
  {
    code: "59-706",
    city: "Gromadka",
  },
  {
    code: "59-708",
    city: "Tomaszów Bolesławiecki",
  },
  {
    code: "59-720",
    city: "Raciborowice Górne",
  },
  {
    code: "59-721",
    city: "Iwiny",
  },
  {
    code: "59-722",
    city: "Warta Bolesławiecka",
  },
  {
    code: "59-724",
    city: "Osiecznica",
  },
  {
    code: "59-726",
    city: "Świętoszów",
  },
  {
    code: "59-730",
    city: "Nowogrodziec",
  },
  {
    code: "59-731",
    city: "Zebrzydowa",
  },
  {
    code: "59-733",
    city: "Wykroty",
  },
  {
    code: "59-800",
    city: "Lubań",
  },
  {
    code: "59-801",
    city: "Lubań",
  },
  {
    code: "59-816",
    city: "Platerówka",
  },
  {
    code: "59-817",
    city: "Zaręba Górna",
  },
  {
    code: "59-818",
    city: "Siekierczyn",
  },
  {
    code: "59-820",
    city: "Leśna",
  },
  {
    code: "59-830",
    city: "Olszyna",
  },
  {
    code: "59-850",
    city: "Świeradów-Zdrój",
  },
  {
    code: "59-851",
    city: "Świeradów-Zdrój",
  },
  {
    code: "59-852",
    city: "Świeradów-Zdrój",
  },
  {
    code: "59-900",
    city: "Zgorzelec",
  },
  {
    code: "59-901",
    city: "Zgorzelec",
  },
  {
    code: "59-902",
    city: "Zgorzelec",
  },
  {
    code: "59-903",
    city: "Zgorzelec",
  },
  {
    code: "59-916",
    city: "Bogatynia",
  },
  {
    code: "59-920",
    city: "Bogatynia",
  },
  {
    code: "59-921",
    city: "Sieniawka",
  },
  {
    code: "59-930",
    city: "Pieńsk",
  },
  {
    code: "59-940",
    city: "Węgliniec",
  },
  {
    code: "59-950",
    city: "Ruszów",
  },
  {
    code: "59-970",
    city: "Zawidów",
  },
  {
    code: "59-975",
    city: "Sulików",
  },
  {
    code: "60-001",
    city: "Poznań",
  },
  {
    code: "60-002",
    city: "Poznań",
  },
  {
    code: "60-003",
    city: "Poznań",
  },
  {
    code: "60-004",
    city: "Poznań",
  },
  {
    code: "60-005",
    city: "Poznań",
  },
  {
    code: "60-008",
    city: "Poznań",
  },
  {
    code: "60-009",
    city: "Poznań",
  },
  {
    code: "60-012",
    city: "Poznań",
  },
  {
    code: "60-013",
    city: "Poznań",
  },
  {
    code: "60-101",
    city: "Poznań",
  },
  {
    code: "60-102",
    city: "Poznań",
  },
  {
    code: "60-103",
    city: "Poznań",
  },
  {
    code: "60-104",
    city: "Poznań",
  },
  {
    code: "60-105",
    city: "Poznań",
  },
  {
    code: "60-106",
    city: "Poznań",
  },
  {
    code: "60-107",
    city: "Poznań",
  },
  {
    code: "60-108",
    city: "Poznań",
  },
  {
    code: "60-111",
    city: "Poznań",
  },
  {
    code: "60-112",
    city: "Poznań",
  },
  {
    code: "60-113",
    city: "Poznań",
  },
  {
    code: "60-114",
    city: "Poznań",
  },
  {
    code: "60-115",
    city: "Poznań",
  },
  {
    code: "60-116",
    city: "Poznań",
  },
  {
    code: "60-118",
    city: "Poznań",
  },
  {
    code: "60-119",
    city: "Poznań",
  },
  {
    code: "60-120",
    city: "Poznań",
  },
  {
    code: "60-121",
    city: "Poznań",
  },
  {
    code: "60-122",
    city: "Poznań",
  },
  {
    code: "60-123",
    city: "Poznań",
  },
  {
    code: "60-124",
    city: "Poznań",
  },
  {
    code: "60-125",
    city: "Poznań",
  },
  {
    code: "60-126",
    city: "Poznań",
  },
  {
    code: "60-128",
    city: "Poznań",
  },
  {
    code: "60-129",
    city: "Poznań",
  },
  {
    code: "60-130",
    city: "Poznań",
  },
  {
    code: "60-131",
    city: "Poznań",
  },
  {
    code: "60-132",
    city: "Poznań",
  },
  {
    code: "60-133",
    city: "Poznań",
  },
  {
    code: "60-134",
    city: "Poznań",
  },
  {
    code: "60-136",
    city: "Poznań",
  },
  {
    code: "60-137",
    city: "Poznań",
  },
  {
    code: "60-139",
    city: "Poznań",
  },
  {
    code: "60-141",
    city: "Poznań",
  },
  {
    code: "60-142",
    city: "Poznań",
  },
  {
    code: "60-143",
    city: "Poznań",
  },
  {
    code: "60-144",
    city: "Poznań",
  },
  {
    code: "60-149",
    city: "Poznań",
  },
  {
    code: "60-151",
    city: "Poznań",
  },
  {
    code: "60-152",
    city: "Poznań",
  },
  {
    code: "60-153",
    city: "Poznań",
  },
  {
    code: "60-157",
    city: "Poznań",
  },
  {
    code: "60-158",
    city: "Poznań",
  },
  {
    code: "60-159",
    city: "Poznań",
  },
  {
    code: "60-160",
    city: "Poznań",
  },
  {
    code: "60-161",
    city: "Poznań",
  },
  {
    code: "60-162",
    city: "Poznań",
  },
  {
    code: "60-163",
    city: "Poznań",
  },
  {
    code: "60-164",
    city: "Poznań",
  },
  {
    code: "60-166",
    city: "Poznań",
  },
  {
    code: "60-167",
    city: "Poznań",
  },
  {
    code: "60-168",
    city: "Poznań",
  },
  {
    code: "60-169",
    city: "Poznań",
  },
  {
    code: "60-171",
    city: "Poznań",
  },
  {
    code: "60-173",
    city: "Poznań",
  },
  {
    code: "60-174",
    city: "Poznań",
  },
  {
    code: "60-175",
    city: "Poznań",
  },
  {
    code: "60-176",
    city: "Poznań",
  },
  {
    code: "60-177",
    city: "Poznań",
  },
  {
    code: "60-178",
    city: "Poznań",
  },
  {
    code: "60-179",
    city: "Poznań",
  },
  {
    code: "60-182",
    city: "Poznań",
  },
  {
    code: "60-183",
    city: "Poznań",
  },
  {
    code: "60-184",
    city: "Poznań",
  },
  {
    code: "60-185",
    city: "Skórzewo",
  },
  {
    code: "60-186",
    city: "Poznań",
  },
  {
    code: "60-187",
    city: "Poznań",
  },
  {
    code: "60-188",
    city: "Poznań",
  },
  {
    code: "60-189",
    city: "Poznań",
  },
  {
    code: "60-190",
    city: "Poznań",
  },
  {
    code: "60-192",
    city: "Poznań",
  },
  {
    code: "60-193",
    city: "Poznań",
  },
  {
    code: "60-194",
    city: "Poznań",
  },
  {
    code: "60-195",
    city: "Poznań",
  },
  {
    code: "60-196",
    city: "Poznań",
  },
  {
    code: "60-197",
    city: "Poznań",
  },
  {
    code: "60-198",
    city: "Poznań",
  },
  {
    code: "60-201",
    city: "Poznań",
  },
  {
    code: "60-202",
    city: "Poznań",
  },
  {
    code: "60-203",
    city: "Poznań",
  },
  {
    code: "60-204",
    city: "Poznań",
  },
  {
    code: "60-205",
    city: "Poznań",
  },
  {
    code: "60-206",
    city: "Poznań",
  },
  {
    code: "60-208",
    city: "Poznań",
  },
  {
    code: "60-209",
    city: "Poznań",
  },
  {
    code: "60-211",
    city: "Poznań",
  },
  {
    code: "60-212",
    city: "Poznań",
  },
  {
    code: "60-213",
    city: "Poznań",
  },
  {
    code: "60-214",
    city: "Poznań",
  },
  {
    code: "60-215",
    city: "Poznań",
  },
  {
    code: "60-216",
    city: "Poznań",
  },
  {
    code: "60-218",
    city: "Poznań",
  },
  {
    code: "60-219",
    city: "Poznań",
  },
  {
    code: "60-220",
    city: "Poznań",
  },
  {
    code: "60-221",
    city: "Poznań",
  },
  {
    code: "60-222",
    city: "Poznań",
  },
  {
    code: "60-223",
    city: "Poznań",
  },
  {
    code: "60-224",
    city: "Poznań",
  },
  {
    code: "60-225",
    city: "Poznań",
  },
  {
    code: "60-226",
    city: "Poznań",
  },
  {
    code: "60-227",
    city: "Poznań",
  },
  {
    code: "60-228",
    city: "Poznań",
  },
  {
    code: "60-229",
    city: "Poznań",
  },
  {
    code: "60-231",
    city: "Poznań",
  },
  {
    code: "60-232",
    city: "Poznań",
  },
  {
    code: "60-233",
    city: "Poznań",
  },
  {
    code: "60-234",
    city: "Poznań",
  },
  {
    code: "60-235",
    city: "Poznań",
  },
  {
    code: "60-236",
    city: "Poznań",
  },
  {
    code: "60-237",
    city: "Poznań",
  },
  {
    code: "60-238",
    city: "Poznań",
  },
  {
    code: "60-239",
    city: "Poznań",
  },
  {
    code: "60-240",
    city: "Poznań",
  },
  {
    code: "60-241",
    city: "Poznań",
  },
  {
    code: "60-242",
    city: "Poznań",
  },
  {
    code: "60-243",
    city: "Poznań",
  },
  {
    code: "60-244",
    city: "Poznań",
  },
  {
    code: "60-245",
    city: "Poznań",
  },
  {
    code: "60-246",
    city: "Poznań",
  },
  {
    code: "60-247",
    city: "Poznań",
  },
  {
    code: "60-248",
    city: "Poznań",
  },
  {
    code: "60-251",
    city: "Poznań",
  },
  {
    code: "60-252",
    city: "Poznań",
  },
  {
    code: "60-253",
    city: "Poznań",
  },
  {
    code: "60-254",
    city: "Poznań",
  },
  {
    code: "60-255",
    city: "Poznań",
  },
  {
    code: "60-256",
    city: "Poznań",
  },
  {
    code: "60-257",
    city: "Poznań",
  },
  {
    code: "60-258",
    city: "Poznań",
  },
  {
    code: "60-259",
    city: "Poznań",
  },
  {
    code: "60-260",
    city: "Poznań",
  },
  {
    code: "60-261",
    city: "Poznań",
  },
  {
    code: "60-262",
    city: "Poznań",
  },
  {
    code: "60-263",
    city: "Poznań",
  },
  {
    code: "60-264",
    city: "Poznań",
  },
  {
    code: "60-265",
    city: "Poznań",
  },
  {
    code: "60-266",
    city: "Poznań",
  },
  {
    code: "60-267",
    city: "Poznań",
  },
  {
    code: "60-268",
    city: "Poznań",
  },
  {
    code: "60-269",
    city: "Poznań",
  },
  {
    code: "60-271",
    city: "Poznań",
  },
  {
    code: "60-272",
    city: "Poznań",
  },
  {
    code: "60-273",
    city: "Poznań",
  },
  {
    code: "60-274",
    city: "Poznań",
  },
  {
    code: "60-275",
    city: "Poznań",
  },
  {
    code: "60-276",
    city: "Poznań",
  },
  {
    code: "60-277",
    city: "Poznań",
  },
  {
    code: "60-278",
    city: "Poznań",
  },
  {
    code: "60-279",
    city: "Poznań",
  },
  {
    code: "60-281",
    city: "Poznań",
  },
  {
    code: "60-282",
    city: "Poznań",
  },
  {
    code: "60-283",
    city: "Poznań",
  },
  {
    code: "60-284",
    city: "Poznań",
  },
  {
    code: "60-286",
    city: "Poznań",
  },
  {
    code: "60-287",
    city: "Poznań",
  },
  {
    code: "60-288",
    city: "Poznań",
  },
  {
    code: "60-289",
    city: "Poznań",
  },
  {
    code: "60-301",
    city: "Poznań",
  },
  {
    code: "60-302",
    city: "Poznań",
  },
  {
    code: "60-303",
    city: "Poznań",
  },
  {
    code: "60-304",
    city: "Poznań",
  },
  {
    code: "60-306",
    city: "Poznań",
  },
  {
    code: "60-307",
    city: "Poznań",
  },
  {
    code: "60-308",
    city: "Poznań",
  },
  {
    code: "60-309",
    city: "Poznań",
  },
  {
    code: "60-311",
    city: "Poznań",
  },
  {
    code: "60-312",
    city: "Poznań",
  },
  {
    code: "60-313",
    city: "Poznań",
  },
  {
    code: "60-315",
    city: "Poznań",
  },
  {
    code: "60-316",
    city: "Poznań",
  },
  {
    code: "60-317",
    city: "Poznań",
  },
  {
    code: "60-318",
    city: "Poznań",
  },
  {
    code: "60-319",
    city: "Poznań",
  },
  {
    code: "60-320",
    city: "Poznań",
  },
  {
    code: "60-321",
    city: "Poznań",
  },
  {
    code: "60-322",
    city: "Poznań",
  },
  {
    code: "60-323",
    city: "Poznań",
  },
  {
    code: "60-324",
    city: "Poznań",
  },
  {
    code: "60-325",
    city: "Poznań",
  },
  {
    code: "60-326",
    city: "Poznań",
  },
  {
    code: "60-327",
    city: "Poznań",
  },
  {
    code: "60-328",
    city: "Poznań",
  },
  {
    code: "60-329",
    city: "Poznań",
  },
  {
    code: "60-330",
    city: "Poznań",
  },
  {
    code: "60-331",
    city: "Poznań",
  },
  {
    code: "60-332",
    city: "Poznań",
  },
  {
    code: "60-334",
    city: "Poznań",
  },
  {
    code: "60-335",
    city: "Poznań",
  },
  {
    code: "60-336",
    city: "Poznań",
  },
  {
    code: "60-337",
    city: "Poznań",
  },
  {
    code: "60-338",
    city: "Poznań",
  },
  {
    code: "60-339",
    city: "Poznań",
  },
  {
    code: "60-341",
    city: "Poznań",
  },
  {
    code: "60-343",
    city: "Poznań",
  },
  {
    code: "60-344",
    city: "Poznań",
  },
  {
    code: "60-345",
    city: "Poznań",
  },
  {
    code: "60-346",
    city: "Poznań",
  },
  {
    code: "60-347",
    city: "Poznań",
  },
  {
    code: "60-348",
    city: "Poznań",
  },
  {
    code: "60-349",
    city: "Poznań",
  },
  {
    code: "60-350",
    city: "Poznań",
  },
  {
    code: "60-351",
    city: "Poznań",
  },
  {
    code: "60-352",
    city: "Poznań",
  },
  {
    code: "60-354",
    city: "Poznań",
  },
  {
    code: "60-355",
    city: "Poznań",
  },
  {
    code: "60-356",
    city: "Poznań",
  },
  {
    code: "60-357",
    city: "Poznań",
  },
  {
    code: "60-358",
    city: "Poznań",
  },
  {
    code: "60-359",
    city: "Poznań",
  },
  {
    code: "60-361",
    city: "Poznań",
  },
  {
    code: "60-362",
    city: "Poznań",
  },
  {
    code: "60-363",
    city: "Poznań",
  },
  {
    code: "60-365",
    city: "Poznań",
  },
  {
    code: "60-366",
    city: "Poznań",
  },
  {
    code: "60-367",
    city: "Poznań",
  },
  {
    code: "60-368",
    city: "Poznań",
  },
  {
    code: "60-369",
    city: "Poznań",
  },
  {
    code: "60-371",
    city: "Poznań",
  },
  {
    code: "60-373",
    city: "Poznań",
  },
  {
    code: "60-374",
    city: "Poznań",
  },
  {
    code: "60-375",
    city: "Poznań",
  },
  {
    code: "60-376",
    city: "Poznań",
  },
  {
    code: "60-378",
    city: "Poznań",
  },
  {
    code: "60-379",
    city: "Poznań",
  },
  {
    code: "60-381",
    city: "Poznań",
  },
  {
    code: "60-382",
    city: "Poznań",
  },
  {
    code: "60-383",
    city: "Poznań",
  },
  {
    code: "60-384",
    city: "Poznań",
  },
  {
    code: "60-385",
    city: "Poznań",
  },
  {
    code: "60-386",
    city: "Poznań",
  },
  {
    code: "60-387",
    city: "Poznań",
  },
  {
    code: "60-388",
    city: "Poznań",
  },
  {
    code: "60-389",
    city: "Poznań",
  },
  {
    code: "60-391",
    city: "Poznań",
  },
  {
    code: "60-392",
    city: "Poznań",
  },
  {
    code: "60-393",
    city: "Poznań",
  },
  {
    code: "60-394",
    city: "Poznań",
  },
  {
    code: "60-395",
    city: "Poznań",
  },
  {
    code: "60-396",
    city: "Poznań",
  },
  {
    code: "60-397",
    city: "Poznań",
  },
  {
    code: "60-398",
    city: "Poznań",
  },
  {
    code: "60-401",
    city: "Poznań",
  },
  {
    code: "60-406",
    city: "Poznań",
  },
  {
    code: "60-407",
    city: "Poznań",
  },
  {
    code: "60-408",
    city: "Poznań",
  },
  {
    code: "60-409",
    city: "Poznań",
  },
  {
    code: "60-411",
    city: "Poznań",
  },
  {
    code: "60-412",
    city: "Poznań",
  },
  {
    code: "60-413",
    city: "Poznań",
  },
  {
    code: "60-415",
    city: "Poznań",
  },
  {
    code: "60-416",
    city: "Poznań",
  },
  {
    code: "60-418",
    city: "Poznań",
  },
  {
    code: "60-419",
    city: "Poznań",
  },
  {
    code: "60-421",
    city: "Poznań",
  },
  {
    code: "60-425",
    city: "Poznań",
  },
  {
    code: "60-427",
    city: "Poznań",
  },
  {
    code: "60-431",
    city: "Poznań",
  },
  {
    code: "60-432",
    city: "Poznań",
  },
  {
    code: "60-433",
    city: "Poznań",
  },
  {
    code: "60-434",
    city: "Poznań",
  },
  {
    code: "60-438",
    city: "Poznań",
  },
  {
    code: "60-439",
    city: "Poznań",
  },
  {
    code: "60-441",
    city: "Poznań",
  },
  {
    code: "60-442",
    city: "Poznań",
  },
  {
    code: "60-443",
    city: "Poznań",
  },
  {
    code: "60-446",
    city: "Poznań",
  },
  {
    code: "60-447",
    city: "Poznań",
  },
  {
    code: "60-451",
    city: "Poznań",
  },
  {
    code: "60-452",
    city: "Poznań",
  },
  {
    code: "60-453",
    city: "Poznań",
  },
  {
    code: "60-454",
    city: "Poznań",
  },
  {
    code: "60-456",
    city: "Poznań",
  },
  {
    code: "60-457",
    city: "Poznań",
  },
  {
    code: "60-458",
    city: "Poznań",
  },
  {
    code: "60-460",
    city: "Poznań",
  },
  {
    code: "60-461",
    city: "Poznań",
  },
  {
    code: "60-462",
    city: "Poznań",
  },
  {
    code: "60-463",
    city: "Poznań",
  },
  {
    code: "60-464",
    city: "Poznań",
  },
  {
    code: "60-465",
    city: "Poznań",
  },
  {
    code: "60-468",
    city: "Poznań",
  },
  {
    code: "60-469",
    city: "Poznań",
  },
  {
    code: "60-470",
    city: "Poznań",
  },
  {
    code: "60-471",
    city: "Poznań",
  },
  {
    code: "60-472",
    city: "Poznań",
  },
  {
    code: "60-473",
    city: "Poznań",
  },
  {
    code: "60-474",
    city: "Poznań",
  },
  {
    code: "60-475",
    city: "Poznań",
  },
  {
    code: "60-476",
    city: "Poznań",
  },
  {
    code: "60-478",
    city: "Poznań",
  },
  {
    code: "60-479",
    city: "Poznań",
  },
  {
    code: "60-480",
    city: "Poznań",
  },
  {
    code: "60-501",
    city: "Poznań",
  },
  {
    code: "60-502",
    city: "Poznań",
  },
  {
    code: "60-503",
    city: "Poznań",
  },
  {
    code: "60-504",
    city: "Poznań",
  },
  {
    code: "60-505",
    city: "Poznań",
  },
  {
    code: "60-506",
    city: "Poznań",
  },
  {
    code: "60-507",
    city: "Poznań",
  },
  {
    code: "60-508",
    city: "Poznań",
  },
  {
    code: "60-509",
    city: "Poznań",
  },
  {
    code: "60-511",
    city: "Poznań",
  },
  {
    code: "60-512",
    city: "Poznań",
  },
  {
    code: "60-513",
    city: "Poznań",
  },
  {
    code: "60-514",
    city: "Poznań",
  },
  {
    code: "60-516",
    city: "Poznań",
  },
  {
    code: "60-517",
    city: "Poznań",
  },
  {
    code: "60-518",
    city: "Poznań",
  },
  {
    code: "60-519",
    city: "Poznań",
  },
  {
    code: "60-521",
    city: "Poznań",
  },
  {
    code: "60-522",
    city: "Poznań",
  },
  {
    code: "60-523",
    city: "Poznań",
  },
  {
    code: "60-524",
    city: "Poznań",
  },
  {
    code: "60-525",
    city: "Poznań",
  },
  {
    code: "60-526",
    city: "Poznań",
  },
  {
    code: "60-527",
    city: "Poznań",
  },
  {
    code: "60-528",
    city: "Poznań",
  },
  {
    code: "60-529",
    city: "Poznań",
  },
  {
    code: "60-531",
    city: "Poznań",
  },
  {
    code: "60-532",
    city: "Poznań",
  },
  {
    code: "60-533",
    city: "Poznań",
  },
  {
    code: "60-534",
    city: "Poznań",
  },
  {
    code: "60-535",
    city: "Poznań",
  },
  {
    code: "60-536",
    city: "Poznań",
  },
  {
    code: "60-537",
    city: "Poznań",
  },
  {
    code: "60-538",
    city: "Poznań",
  },
  {
    code: "60-539",
    city: "Poznań",
  },
  {
    code: "60-541",
    city: "Poznań",
  },
  {
    code: "60-542",
    city: "Poznań",
  },
  {
    code: "60-543",
    city: "Poznań",
  },
  {
    code: "60-544",
    city: "Poznań",
  },
  {
    code: "60-545",
    city: "Poznań",
  },
  {
    code: "60-546",
    city: "Poznań",
  },
  {
    code: "60-547",
    city: "Poznań",
  },
  {
    code: "60-548",
    city: "Poznań",
  },
  {
    code: "60-549",
    city: "Poznań",
  },
  {
    code: "60-551",
    city: "Poznań",
  },
  {
    code: "60-552",
    city: "Poznań",
  },
  {
    code: "60-553",
    city: "Poznań",
  },
  {
    code: "60-554",
    city: "Poznań",
  },
  {
    code: "60-555",
    city: "Poznań",
  },
  {
    code: "60-556",
    city: "Poznań",
  },
  {
    code: "60-557",
    city: "Poznań",
  },
  {
    code: "60-558",
    city: "Poznań",
  },
  {
    code: "60-559",
    city: "Poznań",
  },
  {
    code: "60-560",
    city: "Poznań",
  },
  {
    code: "60-561",
    city: "Poznań",
  },
  {
    code: "60-562",
    city: "Poznań",
  },
  {
    code: "60-563",
    city: "Poznań",
  },
  {
    code: "60-564",
    city: "Poznań",
  },
  {
    code: "60-566",
    city: "Poznań",
  },
  {
    code: "60-567",
    city: "Poznań",
  },
  {
    code: "60-568",
    city: "Poznań",
  },
  {
    code: "60-569",
    city: "Poznań",
  },
  {
    code: "60-571",
    city: "Poznań",
  },
  {
    code: "60-572",
    city: "Poznań",
  },
  {
    code: "60-573",
    city: "Poznań",
  },
  {
    code: "60-574",
    city: "Poznań",
  },
  {
    code: "60-575",
    city: "Poznań",
  },
  {
    code: "60-576",
    city: "Poznań",
  },
  {
    code: "60-577",
    city: "Poznań",
  },
  {
    code: "60-578",
    city: "Poznań",
  },
  {
    code: "60-579",
    city: "Poznań",
  },
  {
    code: "60-580",
    city: "Poznań",
  },
  {
    code: "60-581",
    city: "Poznań",
  },
  {
    code: "60-582",
    city: "Poznań",
  },
  {
    code: "60-583",
    city: "Poznań",
  },
  {
    code: "60-584",
    city: "Poznań",
  },
  {
    code: "60-586",
    city: "Poznań",
  },
  {
    code: "60-587",
    city: "Poznań",
  },
  {
    code: "60-588",
    city: "Poznań",
  },
  {
    code: "60-589",
    city: "Poznań",
  },
  {
    code: "60-591",
    city: "Poznań",
  },
  {
    code: "60-592",
    city: "Poznań",
  },
  {
    code: "60-593",
    city: "Poznań",
  },
  {
    code: "60-594",
    city: "Poznań",
  },
  {
    code: "60-595",
    city: "Poznań",
  },
  {
    code: "60-598",
    city: "Poznań",
  },
  {
    code: "60-601",
    city: "Poznań",
  },
  {
    code: "60-602",
    city: "Poznań",
  },
  {
    code: "60-603",
    city: "Poznań",
  },
  {
    code: "60-604",
    city: "Poznań",
  },
  {
    code: "60-605",
    city: "Poznań",
  },
  {
    code: "60-607",
    city: "Poznań",
  },
  {
    code: "60-608",
    city: "Poznań",
  },
  {
    code: "60-611",
    city: "Poznań",
  },
  {
    code: "60-612",
    city: "Poznań",
  },
  {
    code: "60-613",
    city: "Poznań",
  },
  {
    code: "60-614",
    city: "Poznań",
  },
  {
    code: "60-615",
    city: "Poznań",
  },
  {
    code: "60-616",
    city: "Poznań",
  },
  {
    code: "60-617",
    city: "Poznań",
  },
  {
    code: "60-618",
    city: "Poznań",
  },
  {
    code: "60-619",
    city: "Poznań",
  },
  {
    code: "60-621",
    city: "Poznań",
  },
  {
    code: "60-622",
    city: "Poznań",
  },
  {
    code: "60-623",
    city: "Poznań",
  },
  {
    code: "60-624",
    city: "Poznań",
  },
  {
    code: "60-625",
    city: "Poznań",
  },
  {
    code: "60-626",
    city: "Poznań",
  },
  {
    code: "60-627",
    city: "Poznań",
  },
  {
    code: "60-628",
    city: "Poznań",
  },
  {
    code: "60-631",
    city: "Poznań",
  },
  {
    code: "60-632",
    city: "Poznań",
  },
  {
    code: "60-633",
    city: "Poznań",
  },
  {
    code: "60-637",
    city: "Poznań",
  },
  {
    code: "60-638",
    city: "Poznań",
  },
  {
    code: "60-639",
    city: "Poznań",
  },
  {
    code: "60-641",
    city: "Poznań",
  },
  {
    code: "60-642",
    city: "Poznań",
  },
  {
    code: "60-643",
    city: "Poznań",
  },
  {
    code: "60-644",
    city: "Poznań",
  },
  {
    code: "60-645",
    city: "Poznań",
  },
  {
    code: "60-646",
    city: "Poznań",
  },
  {
    code: "60-647",
    city: "Poznań",
  },
  {
    code: "60-648",
    city: "Poznań",
  },
  {
    code: "60-649",
    city: "Poznań",
  },
  {
    code: "60-650",
    city: "Poznań",
  },
  {
    code: "60-651",
    city: "Poznań",
  },
  {
    code: "60-652",
    city: "Poznań",
  },
  {
    code: "60-653",
    city: "Poznań",
  },
  {
    code: "60-654",
    city: "Poznań",
  },
  {
    code: "60-655",
    city: "Poznań",
  },
  {
    code: "60-656",
    city: "Poznań",
  },
  {
    code: "60-658",
    city: "Poznań",
  },
  {
    code: "60-660",
    city: "Poznań",
  },
  {
    code: "60-661",
    city: "Poznań",
  },
  {
    code: "60-663",
    city: "Poznań",
  },
  {
    code: "60-665",
    city: "Poznań",
  },
  {
    code: "60-666",
    city: "Poznań",
  },
  {
    code: "60-667",
    city: "Poznań",
  },
  {
    code: "60-668",
    city: "Poznań",
  },
  {
    code: "60-669",
    city: "Poznań",
  },
  {
    code: "60-670",
    city: "Poznań",
  },
  {
    code: "60-680",
    city: "Poznań",
  },
  {
    code: "60-681",
    city: "Poznań",
  },
  {
    code: "60-682",
    city: "Poznań",
  },
  {
    code: "60-683",
    city: "Poznań",
  },
  {
    code: "60-684",
    city: "Poznań",
  },
  {
    code: "60-685",
    city: "Poznań",
  },
  {
    code: "60-686",
    city: "Poznań",
  },
  {
    code: "60-687",
    city: "Poznań",
  },
  {
    code: "60-688",
    city: "Poznań",
  },
  {
    code: "60-689",
    city: "Poznań",
  },
  {
    code: "60-691",
    city: "Poznań",
  },
  {
    code: "60-692",
    city: "Poznań",
  },
  {
    code: "60-693",
    city: "Poznań",
  },
  {
    code: "60-694",
    city: "Poznań",
  },
  {
    code: "60-700",
    city: "Poznań",
  },
  {
    code: "60-701",
    city: "Poznań",
  },
  {
    code: "60-702",
    city: "Poznań",
  },
  {
    code: "60-703",
    city: "Poznań",
  },
  {
    code: "60-704",
    city: "Poznań",
  },
  {
    code: "60-705",
    city: "Poznań",
  },
  {
    code: "60-706",
    city: "Poznań",
  },
  {
    code: "60-707",
    city: "Poznań",
  },
  {
    code: "60-708",
    city: "Poznań",
  },
  {
    code: "60-709",
    city: "Poznań",
  },
  {
    code: "60-710",
    city: "Poznań",
  },
  {
    code: "60-711",
    city: "Poznań",
  },
  {
    code: "60-712",
    city: "Poznań",
  },
  {
    code: "60-713",
    city: "Poznań",
  },
  {
    code: "60-715",
    city: "Poznań",
  },
  {
    code: "60-716",
    city: "Poznań",
  },
  {
    code: "60-717",
    city: "Poznań",
  },
  {
    code: "60-718",
    city: "Poznań",
  },
  {
    code: "60-719",
    city: "Poznań",
  },
  {
    code: "60-720",
    city: "Poznań",
  },
  {
    code: "60-722",
    city: "Poznań",
  },
  {
    code: "60-723",
    city: "Poznań",
  },
  {
    code: "60-724",
    city: "Poznań",
  },
  {
    code: "60-725",
    city: "Poznań",
  },
  {
    code: "60-726",
    city: "Poznań",
  },
  {
    code: "60-727",
    city: "Poznań",
  },
  {
    code: "60-728",
    city: "Poznań",
  },
  {
    code: "60-729",
    city: "Poznań",
  },
  {
    code: "60-731",
    city: "Poznań",
  },
  {
    code: "60-732",
    city: "Poznań",
  },
  {
    code: "60-733",
    city: "Poznań",
  },
  {
    code: "60-734",
    city: "Poznań",
  },
  {
    code: "60-736",
    city: "Poznań",
  },
  {
    code: "60-737",
    city: "Poznań",
  },
  {
    code: "60-738",
    city: "Poznań",
  },
  {
    code: "60-739",
    city: "Poznań",
  },
  {
    code: "60-740",
    city: "Poznań",
  },
  {
    code: "60-741",
    city: "Poznań",
  },
  {
    code: "60-743",
    city: "Poznań",
  },
  {
    code: "60-744",
    city: "Poznań",
  },
  {
    code: "60-745",
    city: "Poznań",
  },
  {
    code: "60-746",
    city: "Poznań",
  },
  {
    code: "60-747",
    city: "Poznań",
  },
  {
    code: "60-748",
    city: "Poznań",
  },
  {
    code: "60-749",
    city: "Poznań",
  },
  {
    code: "60-750",
    city: "Poznań",
  },
  {
    code: "60-751",
    city: "Poznań",
  },
  {
    code: "60-753",
    city: "Poznań",
  },
  {
    code: "60-754",
    city: "Poznań",
  },
  {
    code: "60-755",
    city: "Poznań",
  },
  {
    code: "60-756",
    city: "Poznań",
  },
  {
    code: "60-757",
    city: "Poznań",
  },
  {
    code: "60-758",
    city: "Poznań",
  },
  {
    code: "60-759",
    city: "Poznań",
  },
  {
    code: "60-760",
    city: "Poznań",
  },
  {
    code: "60-761",
    city: "Poznań",
  },
  {
    code: "60-762",
    city: "Poznań",
  },
  {
    code: "60-763",
    city: "Poznań",
  },
  {
    code: "60-764",
    city: "Poznań",
  },
  {
    code: "60-765",
    city: "Poznań",
  },
  {
    code: "60-766",
    city: "Poznań",
  },
  {
    code: "60-767",
    city: "Poznań",
  },
  {
    code: "60-768",
    city: "Poznań",
  },
  {
    code: "60-769",
    city: "Poznań",
  },
  {
    code: "60-770",
    city: "Poznań",
  },
  {
    code: "60-771",
    city: "Poznań",
  },
  {
    code: "60-772",
    city: "Poznań",
  },
  {
    code: "60-773",
    city: "Poznań",
  },
  {
    code: "60-774",
    city: "Poznań",
  },
  {
    code: "60-775",
    city: "Poznań",
  },
  {
    code: "60-778",
    city: "Poznań",
  },
  {
    code: "60-779",
    city: "Poznań",
  },
  {
    code: "60-780",
    city: "Poznań",
  },
  {
    code: "60-781",
    city: "Poznań",
  },
  {
    code: "60-782",
    city: "Poznań",
  },
  {
    code: "60-783",
    city: "Poznań",
  },
  {
    code: "60-784",
    city: "Poznań",
  },
  {
    code: "60-785",
    city: "Poznań",
  },
  {
    code: "60-786",
    city: "Poznań",
  },
  {
    code: "60-787",
    city: "Poznań",
  },
  {
    code: "60-788",
    city: "Poznań",
  },
  {
    code: "60-789",
    city: "Poznań",
  },
  {
    code: "60-790",
    city: "Poznań",
  },
  {
    code: "60-791",
    city: "Poznań",
  },
  {
    code: "60-792",
    city: "Poznań",
  },
  {
    code: "60-801",
    city: "Poznań",
  },
  {
    code: "60-802",
    city: "Poznań",
  },
  {
    code: "60-803",
    city: "Poznań",
  },
  {
    code: "60-804",
    city: "Poznań",
  },
  {
    code: "60-805",
    city: "Poznań",
  },
  {
    code: "60-806",
    city: "Poznań",
  },
  {
    code: "60-808",
    city: "Poznań",
  },
  {
    code: "60-809",
    city: "Poznań",
  },
  {
    code: "60-810",
    city: "Poznań",
  },
  {
    code: "60-811",
    city: "Poznań",
  },
  {
    code: "60-812",
    city: "Poznań",
  },
  {
    code: "60-813",
    city: "Poznań",
  },
  {
    code: "60-814",
    city: "Poznań",
  },
  {
    code: "60-815",
    city: "Poznań",
  },
  {
    code: "60-816",
    city: "Poznań",
  },
  {
    code: "60-817",
    city: "Poznań",
  },
  {
    code: "60-818",
    city: "Poznań",
  },
  {
    code: "60-819",
    city: "Poznań",
  },
  {
    code: "60-820",
    city: "Poznań",
  },
  {
    code: "60-821",
    city: "Poznań",
  },
  {
    code: "60-822",
    city: "Poznań",
  },
  {
    code: "60-823",
    city: "Poznań",
  },
  {
    code: "60-824",
    city: "Poznań",
  },
  {
    code: "60-825",
    city: "Poznań",
  },
  {
    code: "60-826",
    city: "Poznań",
  },
  {
    code: "60-829",
    city: "Poznań",
  },
  {
    code: "60-830",
    city: "Poznań",
  },
  {
    code: "60-831",
    city: "Poznań",
  },
  {
    code: "60-832",
    city: "Poznań",
  },
  {
    code: "60-833",
    city: "Poznań",
  },
  {
    code: "60-834",
    city: "Poznań",
  },
  {
    code: "60-835",
    city: "Poznań",
  },
  {
    code: "60-836",
    city: "Poznań",
  },
  {
    code: "60-837",
    city: "Poznań",
  },
  {
    code: "60-838",
    city: "Poznań",
  },
  {
    code: "60-839",
    city: "Poznań",
  },
  {
    code: "60-840",
    city: "Poznań",
  },
  {
    code: "60-841",
    city: "Poznań",
  },
  {
    code: "60-842",
    city: "Poznań",
  },
  {
    code: "60-843",
    city: "Poznań",
  },
  {
    code: "60-844",
    city: "Poznań",
  },
  {
    code: "60-845",
    city: "Poznań",
  },
  {
    code: "60-846",
    city: "Poznań",
  },
  {
    code: "60-847",
    city: "Poznań",
  },
  {
    code: "60-848",
    city: "Poznań",
  },
  {
    code: "60-849",
    city: "Poznań",
  },
  {
    code: "60-850",
    city: "Poznań",
  },
  {
    code: "60-851",
    city: "Poznań",
  },
  {
    code: "60-852",
    city: "Poznań",
  },
  {
    code: "60-853",
    city: "Poznań",
  },
  {
    code: "60-854",
    city: "Poznań",
  },
  {
    code: "60-855",
    city: "Poznań",
  },
  {
    code: "60-856",
    city: "Poznań",
  },
  {
    code: "60-857",
    city: "Poznań",
  },
  {
    code: "60-858",
    city: "Poznań",
  },
  {
    code: "60-859",
    city: "Poznań",
  },
  {
    code: "60-860",
    city: "Poznań",
  },
  {
    code: "60-861",
    city: "Poznań",
  },
  {
    code: "60-862",
    city: "Poznań",
  },
  {
    code: "60-863",
    city: "Poznań",
  },
  {
    code: "60-864",
    city: "Poznań",
  },
  {
    code: "60-865",
    city: "Poznań",
  },
  {
    code: "60-866",
    city: "Poznań",
  },
  {
    code: "60-867",
    city: "Poznań",
  },
  {
    code: "60-870",
    city: "Poznań",
  },
  {
    code: "60-880",
    city: "Poznań",
  },
  {
    code: "60-900",
    city: "Poznań",
  },
  {
    code: "60-901",
    city: "Poznań",
  },
  {
    code: "60-902",
    city: "Poznań",
  },
  {
    code: "60-903",
    city: "Poznań",
  },
  {
    code: "60-904",
    city: "Poznań",
  },
  {
    code: "60-907",
    city: "Poznań",
  },
  {
    code: "60-908",
    city: "Poznań",
  },
  {
    code: "60-909",
    city: "Poznań",
  },
  {
    code: "60-911",
    city: "Poznań",
  },
  {
    code: "60-912",
    city: "Poznań",
  },
  {
    code: "60-914",
    city: "Poznań",
  },
  {
    code: "60-915",
    city: "Poznań",
  },
  {
    code: "60-916",
    city: "Poznań",
  },
  {
    code: "60-917",
    city: "Poznań",
  },
  {
    code: "60-918",
    city: "Poznań",
  },
  {
    code: "60-919",
    city: "Poznań",
  },
  {
    code: "60-920",
    city: "Poznań",
  },
  {
    code: "60-921",
    city: "Poznań",
  },
  {
    code: "60-923",
    city: "Poznań",
  },
  {
    code: "60-924",
    city: "Poznań",
  },
  {
    code: "60-925",
    city: "Poznań",
  },
  {
    code: "60-929",
    city: "Poznań",
  },
  {
    code: "60-930",
    city: "Poznań",
  },
  {
    code: "60-931",
    city: "Poznań",
  },
  {
    code: "60-932",
    city: "Poznań",
  },
  {
    code: "60-938",
    city: "Poznań",
  },
  {
    code: "60-939",
    city: "Poznań",
  },
  {
    code: "60-940",
    city: "Poznań",
  },
  {
    code: "60-941",
    city: "Poznań",
  },
  {
    code: "60-942",
    city: "Poznań",
  },
  {
    code: "60-943",
    city: "Poznań",
  },
  {
    code: "60-944",
    city: "Poznań",
  },
  {
    code: "60-945",
    city: "Poznań",
  },
  {
    code: "60-946",
    city: "Poznań",
  },
  {
    code: "60-947",
    city: "Poznań",
  },
  {
    code: "60-948",
    city: "Poznań",
  },
  {
    code: "60-950",
    city: "Poznań",
  },
  {
    code: "60-951",
    city: "Poznań",
  },
  {
    code: "60-952",
    city: "Poznań",
  },
  {
    code: "60-953",
    city: "Poznań",
  },
  {
    code: "60-955",
    city: "Poznań",
  },
  {
    code: "60-956",
    city: "Poznań",
  },
  {
    code: "60-957",
    city: "Poznań",
  },
  {
    code: "60-958",
    city: "Poznań",
  },
  {
    code: "60-959",
    city: "Poznań",
  },
  {
    code: "60-960",
    city: "Poznań",
  },
  {
    code: "60-961",
    city: "Poznań",
  },
  {
    code: "60-962",
    city: "Poznań",
  },
  {
    code: "60-963",
    city: "Poznań",
  },
  {
    code: "60-964",
    city: "Poznań",
  },
  {
    code: "60-965",
    city: "Poznań",
  },
  {
    code: "60-966",
    city: "Poznań",
  },
  {
    code: "60-967",
    city: "Poznań",
  },
  {
    code: "60-968",
    city: "Poznań",
  },
  {
    code: "60-969",
    city: "Poznań",
  },
  {
    code: "60-970",
    city: "Poznań",
  },
  {
    code: "60-971",
    city: "Poznań",
  },
  {
    code: "60-972",
    city: "Poznań",
  },
  {
    code: "60-973",
    city: "Poznań",
  },
  {
    code: "60-974",
    city: "Poznań",
  },
  {
    code: "60-975",
    city: "Poznań",
  },
  {
    code: "60-976",
    city: "Poznań",
  },
  {
    code: "60-977",
    city: "Poznań",
  },
  {
    code: "60-978",
    city: "Poznań",
  },
  {
    code: "60-979",
    city: "Poznań",
  },
  {
    code: "60-980",
    city: "Poznań",
  },
  {
    code: "60-982",
    city: "Poznań",
  },
  {
    code: "60-983",
    city: "Poznań",
  },
  {
    code: "60-985",
    city: "Poznań",
  },
  {
    code: "60-987",
    city: "Poznań",
  },
  {
    code: "60-988",
    city: "Poznań",
  },
  {
    code: "60-989",
    city: "Poznań",
  },
  {
    code: "60-990",
    city: "Poznań",
  },
  {
    code: "60-991",
    city: "Poznań",
  },
  {
    code: "60-992",
    city: "Poznań",
  },
  {
    code: "60-993",
    city: "Poznań",
  },
  {
    code: "60-994",
    city: "Poznań",
  },
  {
    code: "60-995",
    city: "Poznań",
  },
  {
    code: "60-999",
    city: "Komorniki",
  },
  {
    code: "61-001",
    city: "Poznań",
  },
  {
    code: "61-002",
    city: "Poznań",
  },
  {
    code: "61-003",
    city: "Poznań",
  },
  {
    code: "61-005",
    city: "Poznań",
  },
  {
    code: "61-006",
    city: "Poznań",
  },
  {
    code: "61-007",
    city: "Poznań",
  },
  {
    code: "61-008",
    city: "Poznań",
  },
  {
    code: "61-010",
    city: "Poznań",
  },
  {
    code: "61-011",
    city: "Poznań",
  },
  {
    code: "61-012",
    city: "Poznań",
  },
  {
    code: "61-013",
    city: "Poznań",
  },
  {
    code: "61-014",
    city: "Poznań",
  },
  {
    code: "61-015",
    city: "Poznań",
  },
  {
    code: "61-016",
    city: "Poznań",
  },
  {
    code: "61-017",
    city: "Poznań",
  },
  {
    code: "61-019",
    city: "Poznań",
  },
  {
    code: "61-021",
    city: "Poznań",
  },
  {
    code: "61-022",
    city: "Poznań",
  },
  {
    code: "61-023",
    city: "Poznań",
  },
  {
    code: "61-024",
    city: "Poznań",
  },
  {
    code: "61-028",
    city: "Poznań",
  },
  {
    code: "61-029",
    city: "Poznań",
  },
  {
    code: "61-031",
    city: "Poznań",
  },
  {
    code: "61-033",
    city: "Poznań",
  },
  {
    code: "61-035",
    city: "Poznań",
  },
  {
    code: "61-036",
    city: "Poznań",
  },
  {
    code: "61-037",
    city: "Poznań",
  },
  {
    code: "61-038",
    city: "Poznań",
  },
  {
    code: "61-039",
    city: "Poznań",
  },
  {
    code: "61-040",
    city: "Poznań",
  },
  {
    code: "61-041",
    city: "Poznań",
  },
  {
    code: "61-042",
    city: "Poznań",
  },
  {
    code: "61-043",
    city: "Poznań",
  },
  {
    code: "61-044",
    city: "Poznań",
  },
  {
    code: "61-045",
    city: "Poznań",
  },
  {
    code: "61-046",
    city: "Poznań",
  },
  {
    code: "61-047",
    city: "Poznań",
  },
  {
    code: "61-048",
    city: "Poznań",
  },
  {
    code: "61-049",
    city: "Poznań",
  },
  {
    code: "61-051",
    city: "Poznań",
  },
  {
    code: "61-052",
    city: "Poznań",
  },
  {
    code: "61-053",
    city: "Poznań",
  },
  {
    code: "61-054",
    city: "Poznań",
  },
  {
    code: "61-055",
    city: "Poznań",
  },
  {
    code: "61-056",
    city: "Poznań",
  },
  {
    code: "61-057",
    city: "Poznań",
  },
  {
    code: "61-058",
    city: "Poznań",
  },
  {
    code: "61-059",
    city: "Poznań",
  },
  {
    code: "61-062",
    city: "Poznań",
  },
  {
    code: "61-063",
    city: "Poznań",
  },
  {
    code: "61-064",
    city: "Poznań",
  },
  {
    code: "61-065",
    city: "Poznań",
  },
  {
    code: "61-066",
    city: "Poznań",
  },
  {
    code: "61-070",
    city: "Poznań",
  },
  {
    code: "61-101",
    city: "Poznań",
  },
  {
    code: "61-102",
    city: "Poznań",
  },
  {
    code: "61-103",
    city: "Poznań",
  },
  {
    code: "61-104",
    city: "Poznań",
  },
  {
    code: "61-105",
    city: "Poznań",
  },
  {
    code: "61-108",
    city: "Poznań",
  },
  {
    code: "61-109",
    city: "Poznań",
  },
  {
    code: "61-111",
    city: "Poznań",
  },
  {
    code: "61-112",
    city: "Poznań",
  },
  {
    code: "61-113",
    city: "Poznań",
  },
  {
    code: "61-114",
    city: "Poznań",
  },
  {
    code: "61-115",
    city: "Poznań",
  },
  {
    code: "61-116",
    city: "Poznań",
  },
  {
    code: "61-117",
    city: "Poznań",
  },
  {
    code: "61-118",
    city: "Poznań",
  },
  {
    code: "61-119",
    city: "Poznań",
  },
  {
    code: "61-120",
    city: "Poznań",
  },
  {
    code: "61-121",
    city: "Poznań",
  },
  {
    code: "61-122",
    city: "Poznań",
  },
  {
    code: "61-123",
    city: "Poznań",
  },
  {
    code: "61-124",
    city: "Poznań",
  },
  {
    code: "61-125",
    city: "Poznań",
  },
  {
    code: "61-126",
    city: "Poznań",
  },
  {
    code: "61-127",
    city: "Poznań",
  },
  {
    code: "61-128",
    city: "Poznań",
  },
  {
    code: "61-129",
    city: "Poznań",
  },
  {
    code: "61-131",
    city: "Poznań",
  },
  {
    code: "61-132",
    city: "Poznań",
  },
  {
    code: "61-136",
    city: "Poznań",
  },
  {
    code: "61-138",
    city: "Poznań",
  },
  {
    code: "61-139",
    city: "Poznań",
  },
  {
    code: "61-140",
    city: "Poznań",
  },
  {
    code: "61-141",
    city: "Poznań",
  },
  {
    code: "61-142",
    city: "Poznań",
  },
  {
    code: "61-144",
    city: "Poznań",
  },
  {
    code: "61-145",
    city: "Poznań",
  },
  {
    code: "61-146",
    city: "Poznań",
  },
  {
    code: "61-147",
    city: "Poznań",
  },
  {
    code: "61-148",
    city: "Poznań",
  },
  {
    code: "61-149",
    city: "Poznań",
  },
  {
    code: "61-151",
    city: "Poznań",
  },
  {
    code: "61-152",
    city: "Poznań",
  },
  {
    code: "61-153",
    city: "Poznań",
  },
  {
    code: "61-154",
    city: "Poznań",
  },
  {
    code: "61-155",
    city: "Poznań",
  },
  {
    code: "61-156",
    city: "Poznań",
  },
  {
    code: "61-157",
    city: "Poznań",
  },
  {
    code: "61-158",
    city: "Poznań",
  },
  {
    code: "61-159",
    city: "Poznań",
  },
  {
    code: "61-161",
    city: "Poznań",
  },
  {
    code: "61-162",
    city: "Poznań",
  },
  {
    code: "61-163",
    city: "Poznań",
  },
  {
    code: "61-164",
    city: "Poznań",
  },
  {
    code: "61-165",
    city: "Poznań",
  },
  {
    code: "61-166",
    city: "Poznań",
  },
  {
    code: "61-167",
    city: "Poznań",
  },
  {
    code: "61-168",
    city: "Poznań",
  },
  {
    code: "61-203",
    city: "Poznań",
  },
  {
    code: "61-204",
    city: "Poznań",
  },
  {
    code: "61-205",
    city: "Poznań",
  },
  {
    code: "61-206",
    city: "Poznań",
  },
  {
    code: "61-207",
    city: "Poznań",
  },
  {
    code: "61-208",
    city: "Poznań",
  },
  {
    code: "61-209",
    city: "Poznań",
  },
  {
    code: "61-211",
    city: "Poznań",
  },
  {
    code: "61-212",
    city: "Poznań",
  },
  {
    code: "61-213",
    city: "Poznań",
  },
  {
    code: "61-214",
    city: "Poznań",
  },
  {
    code: "61-215",
    city: "Poznań",
  },
  {
    code: "61-216",
    city: "Poznań",
  },
  {
    code: "61-217",
    city: "Poznań",
  },
  {
    code: "61-218",
    city: "Poznań",
  },
  {
    code: "61-219",
    city: "Poznań",
  },
  {
    code: "61-220",
    city: "Poznań",
  },
  {
    code: "61-221",
    city: "Poznań",
  },
  {
    code: "61-222",
    city: "Poznań",
  },
  {
    code: "61-223",
    city: "Poznań",
  },
  {
    code: "61-224",
    city: "Poznań",
  },
  {
    code: "61-225",
    city: "Poznań",
  },
  {
    code: "61-226",
    city: "Poznań",
  },
  {
    code: "61-227",
    city: "Poznań",
  },
  {
    code: "61-228",
    city: "Poznań",
  },
  {
    code: "61-229",
    city: "Poznań",
  },
  {
    code: "61-231",
    city: "Poznań",
  },
  {
    code: "61-232",
    city: "Poznań",
  },
  {
    code: "61-233",
    city: "Poznań",
  },
  {
    code: "61-234",
    city: "Poznań",
  },
  {
    code: "61-235",
    city: "Poznań",
  },
  {
    code: "61-236",
    city: "Poznań",
  },
  {
    code: "61-237",
    city: "Poznań",
  },
  {
    code: "61-238",
    city: "Poznań",
  },
  {
    code: "61-239",
    city: "Poznań",
  },
  {
    code: "61-240",
    city: "Poznań",
  },
  {
    code: "61-241",
    city: "Poznań",
  },
  {
    code: "61-242",
    city: "Poznań",
  },
  {
    code: "61-243",
    city: "Poznań",
  },
  {
    code: "61-244",
    city: "Poznań",
  },
  {
    code: "61-245",
    city: "Poznań",
  },
  {
    code: "61-246",
    city: "Poznań",
  },
  {
    code: "61-248",
    city: "Poznań",
  },
  {
    code: "61-249",
    city: "Poznań",
  },
  {
    code: "61-250",
    city: "Poznań",
  },
  {
    code: "61-251",
    city: "Poznań",
  },
  {
    code: "61-252",
    city: "Poznań",
  },
  {
    code: "61-253",
    city: "Poznań",
  },
  {
    code: "61-255",
    city: "Poznań",
  },
  {
    code: "61-280",
    city: "Poznań",
  },
  {
    code: "61-285",
    city: "Poznań",
  },
  {
    code: "61-286",
    city: "Poznań",
  },
  {
    code: "61-287",
    city: "Poznań",
  },
  {
    code: "61-288",
    city: "Poznań",
  },
  {
    code: "61-289",
    city: "Poznań",
  },
  {
    code: "61-290",
    city: "Poznań",
  },
  {
    code: "61-291",
    city: "Poznań",
  },
  {
    code: "61-292",
    city: "Poznań",
  },
  {
    code: "61-293",
    city: "Poznań",
  },
  {
    code: "61-294",
    city: "Poznań",
  },
  {
    code: "61-295",
    city: "Poznań",
  },
  {
    code: "61-296",
    city: "Poznań",
  },
  {
    code: "61-297",
    city: "Poznań",
  },
  {
    code: "61-298",
    city: "Poznań",
  },
  {
    code: "61-299",
    city: "Poznań",
  },
  {
    code: "61-302",
    city: "Poznań",
  },
  {
    code: "61-303",
    city: "Poznań",
  },
  {
    code: "61-304",
    city: "Poznań",
  },
  {
    code: "61-306",
    city: "Poznań",
  },
  {
    code: "61-307",
    city: "Poznań",
  },
  {
    code: "61-308",
    city: "Poznań",
  },
  {
    code: "61-309",
    city: "Poznań",
  },
  {
    code: "61-310",
    city: "Poznań",
  },
  {
    code: "61-311",
    city: "Poznań",
  },
  {
    code: "61-312",
    city: "Poznań",
  },
  {
    code: "61-313",
    city: "Poznań",
  },
  {
    code: "61-314",
    city: "Poznań",
  },
  {
    code: "61-315",
    city: "Poznań",
  },
  {
    code: "61-316",
    city: "Poznań",
  },
  {
    code: "61-317",
    city: "Poznań",
  },
  {
    code: "61-318",
    city: "Poznań",
  },
  {
    code: "61-321",
    city: "Poznań",
  },
  {
    code: "61-323",
    city: "Poznań",
  },
  {
    code: "61-324",
    city: "Poznań",
  },
  {
    code: "61-327",
    city: "Poznań",
  },
  {
    code: "61-328",
    city: "Poznań",
  },
  {
    code: "61-329",
    city: "Poznań",
  },
  {
    code: "61-332",
    city: "Poznań",
  },
  {
    code: "61-333",
    city: "Poznań",
  },
  {
    code: "61-334",
    city: "Poznań",
  },
  {
    code: "61-335",
    city: "Poznań",
  },
  {
    code: "61-337",
    city: "Poznań",
  },
  {
    code: "61-339",
    city: "Poznań",
  },
  {
    code: "61-341",
    city: "Poznań",
  },
  {
    code: "61-343",
    city: "Poznań",
  },
  {
    code: "61-344",
    city: "Poznań",
  },
  {
    code: "61-345",
    city: "Poznań",
  },
  {
    code: "61-347",
    city: "Poznań",
  },
  {
    code: "61-348",
    city: "Poznań",
  },
  {
    code: "61-351",
    city: "Poznań",
  },
  {
    code: "61-353",
    city: "Poznań",
  },
  {
    code: "61-354",
    city: "Poznań",
  },
  {
    code: "61-355",
    city: "Poznań",
  },
  {
    code: "61-357",
    city: "Poznań",
  },
  {
    code: "61-359",
    city: "Poznań",
  },
  {
    code: "61-360",
    city: "Poznań",
  },
  {
    code: "61-361",
    city: "Poznań",
  },
  {
    code: "61-362",
    city: "Poznań",
  },
  {
    code: "61-366",
    city: "Poznań",
  },
  {
    code: "61-367",
    city: "Poznań",
  },
  {
    code: "61-368",
    city: "Poznań",
  },
  {
    code: "61-369",
    city: "Poznań",
  },
  {
    code: "61-370",
    city: "Poznań",
  },
  {
    code: "61-371",
    city: "Poznań",
  },
  {
    code: "61-372",
    city: "Poznań",
  },
  {
    code: "61-373",
    city: "Poznań",
  },
  {
    code: "61-374",
    city: "Poznań",
  },
  {
    code: "61-375",
    city: "Poznań",
  },
  {
    code: "61-376",
    city: "Poznań",
  },
  {
    code: "61-377",
    city: "Poznań",
  },
  {
    code: "61-378",
    city: "Poznań",
  },
  {
    code: "61-379",
    city: "Poznań",
  },
  {
    code: "61-381",
    city: "Poznań",
  },
  {
    code: "61-382",
    city: "Poznań",
  },
  {
    code: "61-383",
    city: "Poznań",
  },
  {
    code: "61-384",
    city: "Poznań",
  },
  {
    code: "61-385",
    city: "Poznań",
  },
  {
    code: "61-386",
    city: "Poznań",
  },
  {
    code: "61-387",
    city: "Poznań",
  },
  {
    code: "61-388",
    city: "Poznań",
  },
  {
    code: "61-389",
    city: "Poznań",
  },
  {
    code: "61-391",
    city: "Poznań",
  },
  {
    code: "61-392",
    city: "Poznań",
  },
  {
    code: "61-393",
    city: "Poznań",
  },
  {
    code: "61-394",
    city: "Poznań",
  },
  {
    code: "61-395",
    city: "Poznań",
  },
  {
    code: "61-396",
    city: "Poznań",
  },
  {
    code: "61-397",
    city: "Poznań",
  },
  {
    code: "61-401",
    city: "Poznań",
  },
  {
    code: "61-402",
    city: "Poznań",
  },
  {
    code: "61-403",
    city: "Poznań",
  },
  {
    code: "61-404",
    city: "Poznań",
  },
  {
    code: "61-405",
    city: "Poznań",
  },
  {
    code: "61-406",
    city: "Poznań",
  },
  {
    code: "61-407",
    city: "Poznań",
  },
  {
    code: "61-408",
    city: "Poznań",
  },
  {
    code: "61-409",
    city: "Poznań",
  },
  {
    code: "61-410",
    city: "Poznań",
  },
  {
    code: "61-411",
    city: "Poznań",
  },
  {
    code: "61-412",
    city: "Poznań",
  },
  {
    code: "61-413",
    city: "Poznań",
  },
  {
    code: "61-414",
    city: "Poznań",
  },
  {
    code: "61-415",
    city: "Poznań",
  },
  {
    code: "61-417",
    city: "Poznań",
  },
  {
    code: "61-418",
    city: "Poznań",
  },
  {
    code: "61-419",
    city: "Poznań",
  },
  {
    code: "61-421",
    city: "Poznań",
  },
  {
    code: "61-422",
    city: "Poznań",
  },
  {
    code: "61-423",
    city: "Poznań",
  },
  {
    code: "61-424",
    city: "Poznań",
  },
  {
    code: "61-425",
    city: "Poznań",
  },
  {
    code: "61-426",
    city: "Poznań",
  },
  {
    code: "61-427",
    city: "Poznań",
  },
  {
    code: "61-428",
    city: "Poznań",
  },
  {
    code: "61-429",
    city: "Poznań",
  },
  {
    code: "61-431",
    city: "Poznań",
  },
  {
    code: "61-432",
    city: "Poznań",
  },
  {
    code: "61-433",
    city: "Poznań",
  },
  {
    code: "61-434",
    city: "Poznań",
  },
  {
    code: "61-435",
    city: "Poznań",
  },
  {
    code: "61-436",
    city: "Poznań",
  },
  {
    code: "61-437",
    city: "Poznań",
  },
  {
    code: "61-440",
    city: "Poznań",
  },
  {
    code: "61-441",
    city: "Poznań",
  },
  {
    code: "61-442",
    city: "Poznań",
  },
  {
    code: "61-443",
    city: "Poznań",
  },
  {
    code: "61-444",
    city: "Poznań",
  },
  {
    code: "61-445",
    city: "Poznań",
  },
  {
    code: "61-446",
    city: "Poznań",
  },
  {
    code: "61-447",
    city: "Poznań",
  },
  {
    code: "61-448",
    city: "Poznań",
  },
  {
    code: "61-449",
    city: "Poznań",
  },
  {
    code: "61-450",
    city: "Poznań",
  },
  {
    code: "61-451",
    city: "Poznań",
  },
  {
    code: "61-453",
    city: "Poznań",
  },
  {
    code: "61-454",
    city: "Poznań",
  },
  {
    code: "61-455",
    city: "Poznań",
  },
  {
    code: "61-456",
    city: "Poznań",
  },
  {
    code: "61-457",
    city: "Poznań",
  },
  {
    code: "61-458",
    city: "Poznań",
  },
  {
    code: "61-459",
    city: "Poznań",
  },
  {
    code: "61-461",
    city: "Poznań",
  },
  {
    code: "61-462",
    city: "Poznań",
  },
  {
    code: "61-463",
    city: "Poznań",
  },
  {
    code: "61-464",
    city: "Poznań",
  },
  {
    code: "61-465",
    city: "Poznań",
  },
  {
    code: "61-466",
    city: "Poznań",
  },
  {
    code: "61-467",
    city: "Poznań",
  },
  {
    code: "61-468",
    city: "Poznań",
  },
  {
    code: "61-469",
    city: "Poznań",
  },
  {
    code: "61-471",
    city: "Poznań",
  },
  {
    code: "61-472",
    city: "Poznań",
  },
  {
    code: "61-473",
    city: "Poznań",
  },
  {
    code: "61-474",
    city: "Poznań",
  },
  {
    code: "61-475",
    city: "Poznań",
  },
  {
    code: "61-476",
    city: "Poznań",
  },
  {
    code: "61-477",
    city: "Poznań",
  },
  {
    code: "61-478",
    city: "Poznań",
  },
  {
    code: "61-479",
    city: "Poznań",
  },
  {
    code: "61-481",
    city: "Poznań",
  },
  {
    code: "61-482",
    city: "Poznań",
  },
  {
    code: "61-483",
    city: "Poznań",
  },
  {
    code: "61-485",
    city: "Poznań",
  },
  {
    code: "61-486",
    city: "Poznań",
  },
  {
    code: "61-487",
    city: "Poznań",
  },
  {
    code: "61-488",
    city: "Poznań",
  },
  {
    code: "61-489",
    city: "Poznań",
  },
  {
    code: "61-491",
    city: "Poznań",
  },
  {
    code: "61-492",
    city: "Poznań",
  },
  {
    code: "61-493",
    city: "Poznań",
  },
  {
    code: "61-494",
    city: "Poznań",
  },
  {
    code: "61-495",
    city: "Poznań",
  },
  {
    code: "61-496",
    city: "Poznań",
  },
  {
    code: "61-501",
    city: "Poznań",
  },
  {
    code: "61-502",
    city: "Poznań",
  },
  {
    code: "61-503",
    city: "Poznań",
  },
  {
    code: "61-504",
    city: "Poznań",
  },
  {
    code: "61-505",
    city: "Poznań",
  },
  {
    code: "61-507",
    city: "Poznań",
  },
  {
    code: "61-508",
    city: "Poznań",
  },
  {
    code: "61-509",
    city: "Poznań",
  },
  {
    code: "61-511",
    city: "Poznań",
  },
  {
    code: "61-512",
    city: "Poznań",
  },
  {
    code: "61-513",
    city: "Poznań",
  },
  {
    code: "61-514",
    city: "Poznań",
  },
  {
    code: "61-515",
    city: "Poznań",
  },
  {
    code: "61-517",
    city: "Poznań",
  },
  {
    code: "61-518",
    city: "Poznań",
  },
  {
    code: "61-519",
    city: "Poznań",
  },
  {
    code: "61-521",
    city: "Poznań",
  },
  {
    code: "61-522",
    city: "Poznań",
  },
  {
    code: "61-523",
    city: "Poznań",
  },
  {
    code: "61-524",
    city: "Poznań",
  },
  {
    code: "61-525",
    city: "Poznań",
  },
  {
    code: "61-526",
    city: "Poznań",
  },
  {
    code: "61-527",
    city: "Poznań",
  },
  {
    code: "61-528",
    city: "Poznań",
  },
  {
    code: "61-529",
    city: "Poznań",
  },
  {
    code: "61-530",
    city: "Poznań",
  },
  {
    code: "61-531",
    city: "Poznań",
  },
  {
    code: "61-532",
    city: "Poznań",
  },
  {
    code: "61-534",
    city: "Poznań",
  },
  {
    code: "61-535",
    city: "Poznań",
  },
  {
    code: "61-536",
    city: "Poznań",
  },
  {
    code: "61-537",
    city: "Poznań",
  },
  {
    code: "61-538",
    city: "Poznań",
  },
  {
    code: "61-540",
    city: "Poznań",
  },
  {
    code: "61-541",
    city: "Poznań",
  },
  {
    code: "61-542",
    city: "Poznań",
  },
  {
    code: "61-543",
    city: "Poznań",
  },
  {
    code: "61-544",
    city: "Poznań",
  },
  {
    code: "61-545",
    city: "Poznań",
  },
  {
    code: "61-546",
    city: "Poznań",
  },
  {
    code: "61-547",
    city: "Poznań",
  },
  {
    code: "61-548",
    city: "Poznań",
  },
  {
    code: "61-551",
    city: "Poznań",
  },
  {
    code: "61-552",
    city: "Poznań",
  },
  {
    code: "61-553",
    city: "Poznań",
  },
  {
    code: "61-555",
    city: "Poznań",
  },
  {
    code: "61-556",
    city: "Poznań",
  },
  {
    code: "61-558",
    city: "Poznań",
  },
  {
    code: "61-559",
    city: "Poznań",
  },
  {
    code: "61-561",
    city: "Poznań",
  },
  {
    code: "61-562",
    city: "Poznań",
  },
  {
    code: "61-563",
    city: "Poznań",
  },
  {
    code: "61-564",
    city: "Poznań",
  },
  {
    code: "61-565",
    city: "Poznań",
  },
  {
    code: "61-567",
    city: "Poznań",
  },
  {
    code: "61-568",
    city: "Poznań",
  },
  {
    code: "61-569",
    city: "Poznań",
  },
  {
    code: "61-571",
    city: "Poznań",
  },
  {
    code: "61-572",
    city: "Poznań",
  },
  {
    code: "61-573",
    city: "Poznań",
  },
  {
    code: "61-574",
    city: "Poznań",
  },
  {
    code: "61-575",
    city: "Poznań",
  },
  {
    code: "61-576",
    city: "Poznań",
  },
  {
    code: "61-577",
    city: "Poznań",
  },
  {
    code: "61-578",
    city: "Poznań",
  },
  {
    code: "61-579",
    city: "Poznań",
  },
  {
    code: "61-581",
    city: "Poznań",
  },
  {
    code: "61-582",
    city: "Poznań",
  },
  {
    code: "61-583",
    city: "Poznań",
  },
  {
    code: "61-584",
    city: "Poznań",
  },
  {
    code: "61-585",
    city: "Poznań",
  },
  {
    code: "61-586",
    city: "Poznań",
  },
  {
    code: "61-588",
    city: "Poznań",
  },
  {
    code: "61-601",
    city: "Poznań",
  },
  {
    code: "61-602",
    city: "Poznań",
  },
  {
    code: "61-603",
    city: "Poznań",
  },
  {
    code: "61-605",
    city: "Poznań",
  },
  {
    code: "61-606",
    city: "Poznań",
  },
  {
    code: "61-607",
    city: "Poznań",
  },
  {
    code: "61-608",
    city: "Poznań",
  },
  {
    code: "61-609",
    city: "Poznań",
  },
  {
    code: "61-610",
    city: "Poznań",
  },
  {
    code: "61-611",
    city: "Poznań",
  },
  {
    code: "61-612",
    city: "Poznań",
  },
  {
    code: "61-614",
    city: "Poznań",
  },
  {
    code: "61-615",
    city: "Poznań",
  },
  {
    code: "61-616",
    city: "Poznań",
  },
  {
    code: "61-619",
    city: "Poznań",
  },
  {
    code: "61-621",
    city: "Poznań",
  },
  {
    code: "61-622",
    city: "Poznań",
  },
  {
    code: "61-623",
    city: "Poznań",
  },
  {
    code: "61-624",
    city: "Poznań",
  },
  {
    code: "61-625",
    city: "Poznań",
  },
  {
    code: "61-627",
    city: "Poznań",
  },
  {
    code: "61-628",
    city: "Poznań",
  },
  {
    code: "61-629",
    city: "Poznań",
  },
  {
    code: "61-631",
    city: "Poznań",
  },
  {
    code: "61-632",
    city: "Poznań",
  },
  {
    code: "61-633",
    city: "Poznań",
  },
  {
    code: "61-634",
    city: "Poznań",
  },
  {
    code: "61-635",
    city: "Poznań",
  },
  {
    code: "61-636",
    city: "Poznań",
  },
  {
    code: "61-637",
    city: "Poznań",
  },
  {
    code: "61-638",
    city: "Poznań",
  },
  {
    code: "61-639",
    city: "Poznań",
  },
  {
    code: "61-640",
    city: "Poznań",
  },
  {
    code: "61-641",
    city: "Poznań",
  },
  {
    code: "61-642",
    city: "Poznań",
  },
  {
    code: "61-643",
    city: "Poznań",
  },
  {
    code: "61-644",
    city: "Poznań",
  },
  {
    code: "61-645",
    city: "Poznań",
  },
  {
    code: "61-646",
    city: "Poznań",
  },
  {
    code: "61-647",
    city: "Poznań",
  },
  {
    code: "61-648",
    city: "Poznań",
  },
  {
    code: "61-649",
    city: "Poznań",
  },
  {
    code: "61-650",
    city: "Poznań",
  },
  {
    code: "61-651",
    city: "Poznań",
  },
  {
    code: "61-652",
    city: "Poznań",
  },
  {
    code: "61-653",
    city: "Poznań",
  },
  {
    code: "61-654",
    city: "Poznań",
  },
  {
    code: "61-655",
    city: "Poznań",
  },
  {
    code: "61-656",
    city: "Poznań",
  },
  {
    code: "61-657",
    city: "Poznań",
  },
  {
    code: "61-658",
    city: "Poznań",
  },
  {
    code: "61-659",
    city: "Poznań",
  },
  {
    code: "61-660",
    city: "Poznań",
  },
  {
    code: "61-661",
    city: "Poznań",
  },
  {
    code: "61-662",
    city: "Poznań",
  },
  {
    code: "61-663",
    city: "Poznań",
  },
  {
    code: "61-664",
    city: "Poznań",
  },
  {
    code: "61-666",
    city: "Poznań",
  },
  {
    code: "61-667",
    city: "Poznań",
  },
  {
    code: "61-668",
    city: "Poznań",
  },
  {
    code: "61-670",
    city: "Poznań",
  },
  {
    code: "61-671",
    city: "Poznań",
  },
  {
    code: "61-672",
    city: "Poznań",
  },
  {
    code: "61-673",
    city: "Poznań",
  },
  {
    code: "61-674",
    city: "Poznań",
  },
  {
    code: "61-675",
    city: "Poznań",
  },
  {
    code: "61-676",
    city: "Poznań",
  },
  {
    code: "61-677",
    city: "Poznań",
  },
  {
    code: "61-678",
    city: "Poznań",
  },
  {
    code: "61-679",
    city: "Poznań",
  },
  {
    code: "61-680",
    city: "Poznań",
  },
  {
    code: "61-681",
    city: "Poznań",
  },
  {
    code: "61-682",
    city: "Poznań",
  },
  {
    code: "61-683",
    city: "Poznań",
  },
  {
    code: "61-684",
    city: "Poznań",
  },
  {
    code: "61-685",
    city: "Poznań",
  },
  {
    code: "61-686",
    city: "Poznań",
  },
  {
    code: "61-687",
    city: "Poznań",
  },
  {
    code: "61-688",
    city: "Poznań",
  },
  {
    code: "61-689",
    city: "Poznań",
  },
  {
    code: "61-691",
    city: "Poznań",
  },
  {
    code: "61-692",
    city: "Poznań",
  },
  {
    code: "61-693",
    city: "Poznań",
  },
  {
    code: "61-695",
    city: "Poznań",
  },
  {
    code: "61-697",
    city: "Poznań",
  },
  {
    code: "61-698",
    city: "Poznań",
  },
  {
    code: "61-699",
    city: "Poznań",
  },
  {
    code: "61-701",
    city: "Poznań",
  },
  {
    code: "61-702",
    city: "Poznań",
  },
  {
    code: "61-703",
    city: "Poznań",
  },
  {
    code: "61-704",
    city: "Poznań",
  },
  {
    code: "61-705",
    city: "Poznań",
  },
  {
    code: "61-706",
    city: "Poznań",
  },
  {
    code: "61-707",
    city: "Poznań",
  },
  {
    code: "61-708",
    city: "Poznań",
  },
  {
    code: "61-709",
    city: "Poznań",
  },
  {
    code: "61-710",
    city: "Poznań",
  },
  {
    code: "61-711",
    city: "Poznań",
  },
  {
    code: "61-712",
    city: "Poznań",
  },
  {
    code: "61-713",
    city: "Poznań",
  },
  {
    code: "61-714",
    city: "Poznań",
  },
  {
    code: "61-715",
    city: "Poznań",
  },
  {
    code: "61-716",
    city: "Poznań",
  },
  {
    code: "61-717",
    city: "Poznań",
  },
  {
    code: "61-718",
    city: "Poznań",
  },
  {
    code: "61-719",
    city: "Poznań",
  },
  {
    code: "61-720",
    city: "Poznań",
  },
  {
    code: "61-721",
    city: "Poznań",
  },
  {
    code: "61-722",
    city: "Poznań",
  },
  {
    code: "61-725",
    city: "Poznań",
  },
  {
    code: "61-726",
    city: "Poznań",
  },
  {
    code: "61-727",
    city: "Poznań",
  },
  {
    code: "61-728",
    city: "Poznań",
  },
  {
    code: "61-729",
    city: "Poznań",
  },
  {
    code: "61-730",
    city: "Poznań",
  },
  {
    code: "61-731",
    city: "Poznań",
  },
  {
    code: "61-732",
    city: "Poznań",
  },
  {
    code: "61-733",
    city: "Poznań",
  },
  {
    code: "61-734",
    city: "Poznań",
  },
  {
    code: "61-735",
    city: "Poznań",
  },
  {
    code: "61-736",
    city: "Poznań",
  },
  {
    code: "61-737",
    city: "Poznań",
  },
  {
    code: "61-738",
    city: "Poznań",
  },
  {
    code: "61-739",
    city: "Poznań",
  },
  {
    code: "61-740",
    city: "Poznań",
  },
  {
    code: "61-741",
    city: "Poznań",
  },
  {
    code: "61-742",
    city: "Poznań",
  },
  {
    code: "61-743",
    city: "Poznań",
  },
  {
    code: "61-744",
    city: "Poznań",
  },
  {
    code: "61-745",
    city: "Poznań",
  },
  {
    code: "61-746",
    city: "Poznań",
  },
  {
    code: "61-747",
    city: "Poznań",
  },
  {
    code: "61-748",
    city: "Poznań",
  },
  {
    code: "61-749",
    city: "Poznań",
  },
  {
    code: "61-751",
    city: "Poznań",
  },
  {
    code: "61-752",
    city: "Poznań",
  },
  {
    code: "61-753",
    city: "Poznań",
  },
  {
    code: "61-754",
    city: "Poznań",
  },
  {
    code: "61-755",
    city: "Poznań",
  },
  {
    code: "61-756",
    city: "Poznań",
  },
  {
    code: "61-757",
    city: "Poznań",
  },
  {
    code: "61-758",
    city: "Poznań",
  },
  {
    code: "61-759",
    city: "Poznań",
  },
  {
    code: "61-760",
    city: "Poznań",
  },
  {
    code: "61-761",
    city: "Poznań",
  },
  {
    code: "61-762",
    city: "Poznań",
  },
  {
    code: "61-763",
    city: "Poznań",
  },
  {
    code: "61-764",
    city: "Poznań",
  },
  {
    code: "61-765",
    city: "Poznań",
  },
  {
    code: "61-766",
    city: "Poznań",
  },
  {
    code: "61-767",
    city: "Poznań",
  },
  {
    code: "61-768",
    city: "Poznań",
  },
  {
    code: "61-770",
    city: "Poznań",
  },
  {
    code: "61-771",
    city: "Poznań",
  },
  {
    code: "61-772",
    city: "Poznań",
  },
  {
    code: "61-773",
    city: "Poznań",
  },
  {
    code: "61-774",
    city: "Poznań",
  },
  {
    code: "61-775",
    city: "Poznań",
  },
  {
    code: "61-776",
    city: "Poznań",
  },
  {
    code: "61-777",
    city: "Poznań",
  },
  {
    code: "61-778",
    city: "Poznań",
  },
  {
    code: "61-779",
    city: "Poznań",
  },
  {
    code: "61-780",
    city: "Poznań",
  },
  {
    code: "61-781",
    city: "Poznań",
  },
  {
    code: "61-782",
    city: "Poznań",
  },
  {
    code: "61-800",
    city: "Poznań",
  },
  {
    code: "61-801",
    city: "Poznań",
  },
  {
    code: "61-802",
    city: "Poznań",
  },
  {
    code: "61-803",
    city: "Poznań",
  },
  {
    code: "61-804",
    city: "Poznań",
  },
  {
    code: "61-805",
    city: "Poznań",
  },
  {
    code: "61-806",
    city: "Poznań",
  },
  {
    code: "61-807",
    city: "Poznań",
  },
  {
    code: "61-808",
    city: "Poznań",
  },
  {
    code: "61-809",
    city: "Poznań",
  },
  {
    code: "61-810",
    city: "Poznań",
  },
  {
    code: "61-812",
    city: "Poznań",
  },
  {
    code: "61-813",
    city: "Poznań",
  },
  {
    code: "61-814",
    city: "Poznań",
  },
  {
    code: "61-815",
    city: "Poznań",
  },
  {
    code: "61-816",
    city: "Poznań",
  },
  {
    code: "61-817",
    city: "Poznań",
  },
  {
    code: "61-818",
    city: "Poznań",
  },
  {
    code: "61-819",
    city: "Poznań",
  },
  {
    code: "61-820",
    city: "Poznań",
  },
  {
    code: "61-821",
    city: "Poznań",
  },
  {
    code: "61-823",
    city: "Poznań",
  },
  {
    code: "61-825",
    city: "Poznań",
  },
  {
    code: "61-826",
    city: "Poznań",
  },
  {
    code: "61-827",
    city: "Poznań",
  },
  {
    code: "61-828",
    city: "Poznań",
  },
  {
    code: "61-829",
    city: "Poznań",
  },
  {
    code: "61-831",
    city: "Poznań",
  },
  {
    code: "61-832",
    city: "Poznań",
  },
  {
    code: "61-833",
    city: "Poznań",
  },
  {
    code: "61-834",
    city: "Poznań",
  },
  {
    code: "61-835",
    city: "Poznań",
  },
  {
    code: "61-836",
    city: "Poznań",
  },
  {
    code: "61-837",
    city: "Poznań",
  },
  {
    code: "61-838",
    city: "Poznań",
  },
  {
    code: "61-840",
    city: "Poznań",
  },
  {
    code: "61-841",
    city: "Poznań",
  },
  {
    code: "61-842",
    city: "Poznań",
  },
  {
    code: "61-843",
    city: "Poznań",
  },
  {
    code: "61-844",
    city: "Poznań",
  },
  {
    code: "61-845",
    city: "Poznań",
  },
  {
    code: "61-846",
    city: "Poznań",
  },
  {
    code: "61-847",
    city: "Poznań",
  },
  {
    code: "61-848",
    city: "Poznań",
  },
  {
    code: "61-849",
    city: "Poznań",
  },
  {
    code: "61-850",
    city: "Poznań",
  },
  {
    code: "61-851",
    city: "Poznań",
  },
  {
    code: "61-852",
    city: "Poznań",
  },
  {
    code: "61-853",
    city: "Poznań",
  },
  {
    code: "61-854",
    city: "Poznań",
  },
  {
    code: "61-856",
    city: "Poznań",
  },
  {
    code: "61-857",
    city: "Poznań",
  },
  {
    code: "61-858",
    city: "Poznań",
  },
  {
    code: "61-859",
    city: "Poznań",
  },
  {
    code: "61-860",
    city: "Poznań",
  },
  {
    code: "61-861",
    city: "Poznań",
  },
  {
    code: "61-862",
    city: "Poznań",
  },
  {
    code: "61-863",
    city: "Poznań",
  },
  {
    code: "61-866",
    city: "Poznań",
  },
  {
    code: "61-867",
    city: "Poznań",
  },
  {
    code: "61-868",
    city: "Poznań",
  },
  {
    code: "61-869",
    city: "Poznań",
  },
  {
    code: "61-870",
    city: "Poznań",
  },
  {
    code: "61-871",
    city: "Poznań",
  },
  {
    code: "61-872",
    city: "Poznań",
  },
  {
    code: "61-873",
    city: "Poznań",
  },
  {
    code: "61-874",
    city: "Poznań",
  },
  {
    code: "61-875",
    city: "Poznań",
  },
  {
    code: "61-876",
    city: "Poznań",
  },
  {
    code: "61-877",
    city: "Poznań",
  },
  {
    code: "61-878",
    city: "Poznań",
  },
  {
    code: "61-879",
    city: "Poznań",
  },
  {
    code: "61-880",
    city: "Poznań",
  },
  {
    code: "61-881",
    city: "Poznań",
  },
  {
    code: "61-882",
    city: "Poznań",
  },
  {
    code: "61-883",
    city: "Poznań",
  },
  {
    code: "61-884",
    city: "Poznań",
  },
  {
    code: "61-885",
    city: "Poznań",
  },
  {
    code: "61-886",
    city: "Poznań",
  },
  {
    code: "61-887",
    city: "Poznań",
  },
  {
    code: "61-888",
    city: "Poznań",
  },
  {
    code: "61-889",
    city: "Poznań",
  },
  {
    code: "61-890",
    city: "Poznań",
  },
  {
    code: "61-891",
    city: "Poznań",
  },
  {
    code: "61-892",
    city: "Poznań",
  },
  {
    code: "61-893",
    city: "Poznań",
  },
  {
    code: "61-894",
    city: "Poznań",
  },
  {
    code: "61-895",
    city: "Poznań",
  },
  {
    code: "61-896",
    city: "Poznań",
  },
  {
    code: "61-897",
    city: "Poznań",
  },
  {
    code: "62-001",
    city: "Chludowo",
  },
  {
    code: "62-002",
    city: "Suchy Las",
  },
  {
    code: "62-004",
    city: "Czerwonak",
  },
  {
    code: "62-005",
    city: "Owińska",
  },
  {
    code: "62-006",
    city: "Kobylnica",
  },
  {
    code: "62-010",
    city: "Pobiedziska",
  },
  {
    code: "62-017",
    city: "Swarzędz",
  },
  {
    code: "62-018",
    city: "Swarzędz",
  },
  {
    code: "62-019",
    city: "Swarzędz",
  },
  {
    code: "62-020",
    city: "Swarzędz",
  },
  {
    code: "62-023",
    city: "Gądki",
  },
  {
    code: "62-025",
    city: "Kostrzyn",
  },
  {
    code: "62-028",
    city: "Koziegłowy",
  },
  {
    code: "62-030",
    city: "Luboń",
  },
  {
    code: "62-035",
    city: "Kórnik",
  },
  {
    code: "62-040",
    city: "Puszczykowo",
  },
  {
    code: "62-045",
    city: "Pniewy",
  },
  {
    code: "62-050",
    city: "Mosina",
  },
  {
    code: "62-052",
    city: "Komorniki",
  },
  {
    code: "62-056",
    city: "Komorniki",
  },
  {
    code: "62-060",
    city: "Stęszew",
  },
  {
    code: "62-065",
    city: "Grodzisk Wielkopolski",
  },
  {
    code: "62-066",
    city: "Granowo",
  },
  {
    code: "62-067",
    city: "Rakoniewice",
  },
  {
    code: "62-070",
    city: "Dopiewo",
  },
  {
    code: "62-079",
    city: "Tarnowo Podgórne",
  },
  {
    code: "62-080",
    city: "Tarnowo Podgórne",
  },
  {
    code: "62-081",
    city: "Przeźmierowo",
  },
  {
    code: "62-085",
    city: "Skoki",
  },
  {
    code: "62-090",
    city: "Rokietnica",
  },
  {
    code: "62-095",
    city: "Murowana Goślina",
  },
  {
    code: "62-096",
    city: "Murowana Goślina",
  },
  {
    code: "62-100",
    city: "Wągrowiec",
  },
  {
    code: "62-105",
    city: "Łekno",
  },
  {
    code: "62-110",
    city: "Damasławek",
  },
  {
    code: "62-120",
    city: "Wapno",
  },
  {
    code: "62-130",
    city: "Gołańcz",
  },
  {
    code: "62-200",
    city: "Gniezno",
  },
  {
    code: "62-204",
    city: "Gniezno",
  },
  {
    code: "62-206",
    city: "Gniezno",
  },
  {
    code: "62-210",
    city: "Gniezno",
  },
  {
    code: "62-212",
    city: "Mieleszyn",
  },
  {
    code: "62-215",
    city: "Skorzęcin",
  },
  {
    code: "62-220",
    city: "Niechanowo",
  },
  {
    code: "62-230",
    city: "Witkowo",
  },
  {
    code: "62-240",
    city: "Trzemeszno",
  },
  {
    code: "62-241",
    city: "Żydowo",
  },
  {
    code: "62-250",
    city: "Czerniejewo",
  },
  {
    code: "62-260",
    city: "Łubowo",
  },
  {
    code: "62-262",
    city: "Fałkowo",
  },
  {
    code: "62-270",
    city: "Kłecko",
  },
  {
    code: "62-280",
    city: "Kiszkowo",
  },
  {
    code: "62-285",
    city: "Popowo Kościelne",
  },
  {
    code: "62-290",
    city: "Mieścisko",
  },
  {
    code: "62-300",
    city: "Września",
  },
  {
    code: "62-306",
    city: "Kołaczkowo",
  },
  {
    code: "62-310",
    city: "Pyzdry",
  },
  {
    code: "62-313",
    city: "Września",
  },
  {
    code: "62-314",
    city: "Września",
  },
  {
    code: "62-320",
    city: "Miłosław",
  },
  {
    code: "62-322",
    city: "Orzechowo",
  },
  {
    code: "62-330",
    city: "Nekla",
  },
  {
    code: "62-400",
    city: "Słupca",
  },
  {
    code: "62-401",
    city: "Słupca",
  },
  {
    code: "62-402",
    city: "Ostrowite",
  },
  {
    code: "62-406",
    city: "Lądek",
  },
  {
    code: "62-410",
    city: "Zagórów",
  },
  {
    code: "62-420",
    city: "Strzałkowo",
  },
  {
    code: "62-430",
    city: "Powidz",
  },
  {
    code: "62-436",
    city: "Orchowo",
  },
  {
    code: "62-500",
    city: "Konin",
  },
  {
    code: "62-501",
    city: "Konin",
  },
  {
    code: "62-502",
    city: "Konin",
  },
  {
    code: "62-503",
    city: "Konin",
  },
  {
    code: "62-504",
    city: "Konin",
  },
  {
    code: "62-505",
    city: "Konin",
  },
  {
    code: "62-506",
    city: "Konin",
  },
  {
    code: "62-507",
    city: "Konin",
  },
  {
    code: "62-508",
    city: "Konin",
  },
  {
    code: "62-510",
    city: "Konin",
  },
  {
    code: "62-511",
    city: "Kramsk",
  },
  {
    code: "62-513",
    city: "Krzymów",
  },
  {
    code: "62-530",
    city: "Kazimierz Biskupi",
  },
  {
    code: "62-540",
    city: "Kleczew",
  },
  {
    code: "62-541",
    city: "Budzisław Kościelny",
  },
  {
    code: "62-550",
    city: "Wilczyn",
  },
  {
    code: "62-560",
    city: "Skulsk",
  },
  {
    code: "62-561",
    city: "Ślesin",
  },
  {
    code: "62-563",
    city: "Stary Licheń",
  },
  {
    code: "62-570",
    city: "Rychwał",
  },
  {
    code: "62-571",
    city: "Stare Miasto",
  },
  {
    code: "62-580",
    city: "Grodziec",
  },
  {
    code: "62-586",
    city: "Rzgów",
  },
  {
    code: "62-590",
    city: "Golina",
  },
  {
    code: "62-600",
    city: "Koło",
  },
  {
    code: "62-601",
    city: "Koło",
  },
  {
    code: "62-602",
    city: "Koło",
  },
  {
    code: "62-604",
    city: "Kościelec",
  },
  {
    code: "62-610",
    city: "Sompolno",
  },
  {
    code: "62-613",
    city: "Osiek Mały",
  },
  {
    code: "62-619",
    city: "Sadlno",
  },
  {
    code: "62-620",
    city: "Babiak",
  },
  {
    code: "62-635",
    city: "Przedecz",
  },
  {
    code: "62-640",
    city: "Grzegorzew",
  },
  {
    code: "62-641",
    city: "Olszówka",
  },
  {
    code: "62-650",
    city: "Kłodawa",
  },
  {
    code: "62-652",
    city: "Chodów",
  },
  {
    code: "62-660",
    city: "Dąbie",
  },
  {
    code: "62-700",
    city: "Turek",
  },
  {
    code: "62-701",
    city: "Turek",
  },
  {
    code: "62-704",
    city: "Kawęczyn",
  },
  {
    code: "62-709",
    city: "Malanów",
  },
  {
    code: "62-710",
    city: "Władysławów",
  },
  {
    code: "62-720",
    city: "Brudzew",
  },
  {
    code: "62-730",
    city: "Dobra",
  },
  {
    code: "62-731",
    city: "Przykona",
  },
  {
    code: "62-740",
    city: "Tuliszków",
  },
  {
    code: "62-800",
    city: "Kalisz",
  },
  {
    code: "62-801",
    city: "Kalisz",
  },
  {
    code: "62-802",
    city: "Kalisz",
  },
  {
    code: "62-803",
    city: "Kalisz",
  },
  {
    code: "62-804",
    city: "Kalisz",
  },
  {
    code: "62-805",
    city: "Kalisz",
  },
  {
    code: "62-806",
    city: "Kalisz",
  },
  {
    code: "62-809",
    city: "Kalisz",
  },
  {
    code: "62-814",
    city: "Blizanów",
  },
  {
    code: "62-817",
    city: "Żelazków",
  },
  {
    code: "62-819",
    city: "Kalisz",
  },
  {
    code: "62-820",
    city: "Stawiszyn",
  },
  {
    code: "62-821",
    city: "Kalisz",
  },
  {
    code: "62-830",
    city: "Zbiersk",
  },
  {
    code: "62-831",
    city: "Korzeniew",
  },
  {
    code: "62-834",
    city: "Ceków",
  },
  {
    code: "62-840",
    city: "Koźminek",
  },
  {
    code: "62-850",
    city: "Lisków",
  },
  {
    code: "62-860",
    city: "Opatówek",
  },
  {
    code: "62-865",
    city: "Szczytniki",
  },
  {
    code: "62-872",
    city: "Godziesze Małe",
  },
  {
    code: "62-874",
    city: "Brzeziny",
  },
  {
    code: "63-000",
    city: "Środa Wielkopolska",
  },
  {
    code: "63-001",
    city: "Środa Wielkopolska",
  },
  {
    code: "63-004",
    city: "Tulce",
  },
  {
    code: "63-005",
    city: "Kleszczewo",
  },
  {
    code: "63-014",
    city: "Murzynowo Kościelne",
  },
  {
    code: "63-020",
    city: "Zaniemyśl",
  },
  {
    code: "63-024",
    city: "Krzykosy",
  },
  {
    code: "63-040",
    city: "Nowe Miasto nad Wartą",
  },
  {
    code: "63-100",
    city: "Śrem",
  },
  {
    code: "63-101",
    city: "Śrem",
  },
  {
    code: "63-102",
    city: "Śrem",
  },
  {
    code: "63-112",
    city: "Brodnica",
  },
  {
    code: "63-130",
    city: "Książ Wielkopolski",
  },
  {
    code: "63-140",
    city: "Dolsk",
  },
  {
    code: "63-200",
    city: "Jarocin",
  },
  {
    code: "63-201",
    city: "Jarocin",
  },
  {
    code: "63-202",
    city: "Jarocin",
  },
  {
    code: "63-210",
    city: "Żerków",
  },
  {
    code: "63-220",
    city: "Kotlin",
  },
  {
    code: "63-230",
    city: "Witaszyce",
  },
  {
    code: "63-233",
    city: "Jaraczewo",
  },
  {
    code: "63-300",
    city: "Pleszew",
  },
  {
    code: "63-301",
    city: "Pleszew",
  },
  {
    code: "63-304",
    city: "Czermin",
  },
  {
    code: "63-308",
    city: "Gizałki",
  },
  {
    code: "63-313",
    city: "Chocz",
  },
  {
    code: "63-322",
    city: "Gołuchów",
  },
  {
    code: "63-330",
    city: "Dobrzyca",
  },
  {
    code: "63-400",
    city: "Ostrów Wielkopolski",
  },
  {
    code: "63-401",
    city: "Ostrów Wielkopolski",
  },
  {
    code: "63-402",
    city: "Ostrów Wielkopolski",
  },
  {
    code: "63-403",
    city: "Ostrów Wielkopolski",
  },
  {
    code: "63-404",
    city: "Ostrów Wielkopolski",
  },
  {
    code: "63-405",
    city: "Sieroszewice",
  },
  {
    code: "63-409",
    city: "Ostrów Wielkopolski",
  },
  {
    code: "63-410",
    city: "Ostrów Wielkopolski",
  },
  {
    code: "63-417",
    city: "Ostrów Wielkopolski",
  },
  {
    code: "63-421",
    city: "Przygodzice",
  },
  {
    code: "63-430",
    city: "Odolanów",
  },
  {
    code: "63-435",
    city: "Sośnie",
  },
  {
    code: "63-440",
    city: "Raszków",
  },
  {
    code: "63-450",
    city: "Sobótka",
  },
  {
    code: "63-460",
    city: "Nowe Skalmierzyce",
  },
  {
    code: "63-500",
    city: "Ostrzeszów",
  },
  {
    code: "63-505",
    city: "Doruchów",
  },
  {
    code: "63-507",
    city: "Kobyla Góra",
  },
  {
    code: "63-510",
    city: "Mikstat",
  },
  {
    code: "63-520",
    city: "Grabów nad Prosną",
  },
  {
    code: "63-522",
    city: "Kraszewice",
  },
  {
    code: "63-524",
    city: "Czajków",
  },
  {
    code: "63-600",
    city: "Kępno",
  },
  {
    code: "63-604",
    city: "Baranów",
  },
  {
    code: "63-620",
    city: "Trzcinica",
  },
  {
    code: "63-630",
    city: "Rychtal",
  },
  {
    code: "63-640",
    city: "Bralin",
  },
  {
    code: "63-642",
    city: "Perzów",
  },
  {
    code: "63-645",
    city: "Łęka Opatowska",
  },
  {
    code: "63-700",
    city: "Krotoszyn",
  },
  {
    code: "63-701",
    city: "Krotoszyn",
  },
  {
    code: "63-702",
    city: "Krotoszyn",
  },
  {
    code: "63-708",
    city: "Rozdrażew",
  },
  {
    code: "63-714",
    city: "Kobierno",
  },
  {
    code: "63-720",
    city: "Koźmin Wielkopolski",
  },
  {
    code: "63-740",
    city: "Kobylin",
  },
  {
    code: "63-750",
    city: "Sulmierzyce",
  },
  {
    code: "63-760",
    city: "Zduny",
  },
  {
    code: "63-800",
    city: "Gostyń",
  },
  {
    code: "63-810",
    city: "Borek Wielkopolski",
  },
  {
    code: "63-814",
    city: "Gostyń",
  },
  {
    code: "63-815",
    city: "Gostyń",
  },
  {
    code: "63-816",
    city: "Gostyń",
  },
  {
    code: "63-820",
    city: "Piaski",
  },
  {
    code: "63-830",
    city: "Pępowo",
  },
  {
    code: "63-840",
    city: "Krobia",
  },
  {
    code: "63-842",
    city: "Pudliszki",
  },
  {
    code: "63-860",
    city: "Pogorzela",
  },
  {
    code: "63-900",
    city: "Rawicz",
  },
  {
    code: "63-901",
    city: "Rawicz",
  },
  {
    code: "63-910",
    city: "Miejska Górka",
  },
  {
    code: "63-911",
    city: "Rawicz",
  },
  {
    code: "63-920",
    city: "Pakosław",
  },
  {
    code: "63-930",
    city: "Jutrosin",
  },
  {
    code: "63-940",
    city: "Bojanowo",
  },
  {
    code: "64-000",
    city: "Kościan",
  },
  {
    code: "64-001",
    city: "Kościan",
  },
  {
    code: "64-004",
    city: "Kościan",
  },
  {
    code: "64-009",
    city: "Kościan",
  },
  {
    code: "64-010",
    city: "Krzywiń",
  },
  {
    code: "64-020",
    city: "Czempiń",
  },
  {
    code: "64-030",
    city: "Śmigiel",
  },
  {
    code: "64-050",
    city: "Wielichowo",
  },
  {
    code: "64-061",
    city: "Kamieniec",
  },
  {
    code: "64-100",
    city: "Leszno",
  },
  {
    code: "64-101",
    city: "Leszno",
  },
  {
    code: "64-102",
    city: "Leszno",
  },
  {
    code: "64-103",
    city: "Leszno",
  },
  {
    code: "64-104",
    city: "Leszno",
  },
  {
    code: "64-105",
    city: "Leszno",
  },
  {
    code: "64-106",
    city: "Leszno",
  },
  {
    code: "64-110",
    city: "Leszno",
  },
  {
    code: "64-111",
    city: "Lipno",
  },
  {
    code: "64-113",
    city: "Osieczna",
  },
  {
    code: "64-115",
    city: "Święciechowa",
  },
  {
    code: "64-120",
    city: "Krzemieniewo",
  },
  {
    code: "64-125",
    city: "Poniec",
  },
  {
    code: "64-130",
    city: "Rydzyna",
  },
  {
    code: "64-140",
    city: "Włoszakowice",
  },
  {
    code: "64-150",
    city: "Wijewo",
  },
  {
    code: "64-200",
    city: "Wolsztyn",
  },
  {
    code: "64-212",
    city: "Siedlec",
  },
  {
    code: "64-234",
    city: "Przemęt",
  },
  {
    code: "64-300",
    city: "Nowy Tomyśl",
  },
  {
    code: "64-305",
    city: "Bolewice",
  },
  {
    code: "64-310",
    city: "Lwówek",
  },
  {
    code: "64-316",
    city: "Kuślin",
  },
  {
    code: "64-320",
    city: "Buk",
  },
  {
    code: "64-330",
    city: "Opalenica",
  },
  {
    code: "64-360",
    city: "Zbąszyń",
  },
  {
    code: "64-361",
    city: "Miedzichowo",
  },
  {
    code: "64-400",
    city: "Międzychód",
  },
  {
    code: "64-410",
    city: "Sieraków",
  },
  {
    code: "64-412",
    city: "Chrzypsko Wielkie",
  },
  {
    code: "64-420",
    city: "Kwilcz",
  },
  {
    code: "64-500",
    city: "Szamotuły",
  },
  {
    code: "64-510",
    city: "Wronki",
  },
  {
    code: "64-520",
    city: "Obrzycko",
  },
  {
    code: "64-530",
    city: "Kaźmierz",
  },
  {
    code: "64-550",
    city: "Duszniki",
  },
  {
    code: "64-600",
    city: "Oborniki",
  },
  {
    code: "64-601",
    city: "Oborniki",
  },
  {
    code: "64-610",
    city: "Rogoźno",
  },
  {
    code: "64-630",
    city: "Ryczywół",
  },
  {
    code: "64-700",
    city: "Czarnków",
  },
  {
    code: "64-710",
    city: "Połajewo",
  },
  {
    code: "64-720",
    city: "Lubasz",
  },
  {
    code: "64-730",
    city: "Wieleń",
  },
  {
    code: "64-733",
    city: "Drawsko",
  },
  {
    code: "64-734",
    city: "Chełst",
  },
  {
    code: "64-761",
    city: "Krzyż Wielkopolski",
  },
  {
    code: "64-800",
    city: "Chodzież",
  },
  {
    code: "64-810",
    city: "Kaczory",
  },
  {
    code: "64-820",
    city: "Szamocin",
  },
  {
    code: "64-830",
    city: "Margonin",
  },
  {
    code: "64-840",
    city: "Budzyń",
  },
  {
    code: "64-850",
    city: "Ujście",
  },
  {
    code: "64-900",
    city: "Piła",
  },
  {
    code: "64-915",
    city: "Jastrowie",
  },
  {
    code: "64-918",
    city: "Lotyń",
  },
  {
    code: "64-920",
    city: "Piła",
  },
  {
    code: "64-930",
    city: "Szydłowo",
  },
  {
    code: "64-931",
    city: "Piła",
  },
  {
    code: "64-934",
    city: "Piła",
  },
  {
    code: "64-935",
    city: "Piła",
  },
  {
    code: "64-965",
    city: "Okonek",
  },
  {
    code: "64-970",
    city: "Piła",
  },
  {
    code: "64-980",
    city: "Trzcianka",
  },
  {
    code: "65-001",
    city: "Zielona Góra",
  },
  {
    code: "65-002",
    city: "Zielona Góra",
  },
  {
    code: "65-003",
    city: "Zielona Góra",
  },
  {
    code: "65-004",
    city: "Zielona Góra",
  },
  {
    code: "65-007",
    city: "Zielona Góra",
  },
  {
    code: "65-010",
    city: "Zielona Góra",
  },
  {
    code: "65-012",
    city: "Zielona Góra",
  },
  {
    code: "65-014",
    city: "Zielona Góra",
  },
  {
    code: "65-015",
    city: "Zielona Góra",
  },
  {
    code: "65-017",
    city: "Zielona Góra",
  },
  {
    code: "65-018",
    city: "Zielona Góra",
  },
  {
    code: "65-019",
    city: "Zielona Góra",
  },
  {
    code: "65-020",
    city: "Zielona Góra",
  },
  {
    code: "65-021",
    city: "Zielona Góra",
  },
  {
    code: "65-022",
    city: "Zielona Góra",
  },
  {
    code: "65-023",
    city: "Zielona Góra",
  },
  {
    code: "65-025",
    city: "Zielona Góra",
  },
  {
    code: "65-027",
    city: "Zielona Góra",
  },
  {
    code: "65-028",
    city: "Zielona Góra",
  },
  {
    code: "65-029",
    city: "Zielona Góra",
  },
  {
    code: "65-031",
    city: "Zielona Góra",
  },
  {
    code: "65-032",
    city: "Zielona Góra",
  },
  {
    code: "65-033",
    city: "Zielona Góra",
  },
  {
    code: "65-034",
    city: "Zielona Góra",
  },
  {
    code: "65-035",
    city: "Zielona Góra",
  },
  {
    code: "65-036",
    city: "Zielona Góra",
  },
  {
    code: "65-037",
    city: "Zielona Góra",
  },
  {
    code: "65-038",
    city: "Zielona Góra",
  },
  {
    code: "65-039",
    city: "Zielona Góra",
  },
  {
    code: "65-040",
    city: "Zielona Góra",
  },
  {
    code: "65-041",
    city: "Zielona Góra",
  },
  {
    code: "65-042",
    city: "Zielona Góra",
  },
  {
    code: "65-043",
    city: "Zielona Góra",
  },
  {
    code: "65-044",
    city: "Zielona Góra",
  },
  {
    code: "65-045",
    city: "Zielona Góra",
  },
  {
    code: "65-046",
    city: "Zielona Góra",
  },
  {
    code: "65-047",
    city: "Zielona Góra",
  },
  {
    code: "65-048",
    city: "Zielona Góra",
  },
  {
    code: "65-049",
    city: "Zielona Góra",
  },
  {
    code: "65-050",
    city: "Zielona Góra",
  },
  {
    code: "65-052",
    city: "Zielona Góra",
  },
  {
    code: "65-053",
    city: "Zielona Góra",
  },
  {
    code: "65-054",
    city: "Zielona Góra",
  },
  {
    code: "65-055",
    city: "Zielona Góra",
  },
  {
    code: "65-056",
    city: "Zielona Góra",
  },
  {
    code: "65-057",
    city: "Zielona Góra",
  },
  {
    code: "65-058",
    city: "Zielona Góra",
  },
  {
    code: "65-059",
    city: "Zielona Góra",
  },
  {
    code: "65-060",
    city: "Zielona Góra",
  },
  {
    code: "65-061",
    city: "Zielona Góra",
  },
  {
    code: "65-063",
    city: "Zielona Góra",
  },
  {
    code: "65-064",
    city: "Zielona Góra",
  },
  {
    code: "65-065",
    city: "Zielona Góra",
  },
  {
    code: "65-066",
    city: "Zielona Góra",
  },
  {
    code: "65-067",
    city: "Zielona Góra",
  },
  {
    code: "65-068",
    city: "Zielona Góra",
  },
  {
    code: "65-069",
    city: "Zielona Góra",
  },
  {
    code: "65-071",
    city: "Zielona Góra",
  },
  {
    code: "65-072",
    city: "Zielona Góra",
  },
  {
    code: "65-073",
    city: "Zielona Góra",
  },
  {
    code: "65-074",
    city: "Zielona Góra",
  },
  {
    code: "65-075",
    city: "Zielona Góra",
  },
  {
    code: "65-076",
    city: "Zielona Góra",
  },
  {
    code: "65-077",
    city: "Zielona Góra",
  },
  {
    code: "65-078",
    city: "Zielona Góra",
  },
  {
    code: "65-081",
    city: "Zielona Góra",
  },
  {
    code: "65-082",
    city: "Zielona Góra",
  },
  {
    code: "65-083",
    city: "Zielona Góra",
  },
  {
    code: "65-084",
    city: "Zielona Góra",
  },
  {
    code: "65-085",
    city: "Zielona Góra",
  },
  {
    code: "65-086",
    city: "Zielona Góra",
  },
  {
    code: "65-087",
    city: "Zielona Góra",
  },
  {
    code: "65-088",
    city: "Zielona Góra",
  },
  {
    code: "65-089",
    city: "Zielona Góra",
  },
  {
    code: "65-090",
    city: "Zielona Góra",
  },
  {
    code: "65-093",
    city: "Zielona Góra",
  },
  {
    code: "65-094",
    city: "Zielona Góra",
  },
  {
    code: "65-095",
    city: "Zielona Góra",
  },
  {
    code: "65-096",
    city: "Zielona Góra",
  },
  {
    code: "65-097",
    city: "Zielona Góra",
  },
  {
    code: "65-101",
    city: "Zielona Góra",
  },
  {
    code: "65-104",
    city: "Zielona Góra",
  },
  {
    code: "65-106",
    city: "Zielona Góra",
  },
  {
    code: "65-107",
    city: "Zielona Góra",
  },
  {
    code: "65-109",
    city: "Zielona Góra",
  },
  {
    code: "65-110",
    city: "Zielona Góra",
  },
  {
    code: "65-112",
    city: "Zielona Góra",
  },
  {
    code: "65-114",
    city: "Zielona Góra",
  },
  {
    code: "65-115",
    city: "Zielona Góra",
  },
  {
    code: "65-119",
    city: "Zielona Góra",
  },
  {
    code: "65-120",
    city: "Zielona Góra",
  },
  {
    code: "65-121",
    city: "Zielona Góra",
  },
  {
    code: "65-122",
    city: "Zielona Góra",
  },
  {
    code: "65-123",
    city: "Zielona Góra",
  },
  {
    code: "65-124",
    city: "Zielona Góra",
  },
  {
    code: "65-125",
    city: "Zielona Góra",
  },
  {
    code: "65-126",
    city: "Zielona Góra",
  },
  {
    code: "65-127",
    city: "Zielona Góra",
  },
  {
    code: "65-128",
    city: "Zielona Góra",
  },
  {
    code: "65-129",
    city: "Zielona Góra",
  },
  {
    code: "65-130",
    city: "Zielona Góra",
  },
  {
    code: "65-131",
    city: "Zielona Góra",
  },
  {
    code: "65-132",
    city: "Zielona Góra",
  },
  {
    code: "65-133",
    city: "Zielona Góra",
  },
  {
    code: "65-135",
    city: "Zielona Góra",
  },
  {
    code: "65-137",
    city: "Zielona Góra",
  },
  {
    code: "65-138",
    city: "Zielona Góra",
  },
  {
    code: "65-140",
    city: "Zielona Góra",
  },
  {
    code: "65-142",
    city: "Zielona Góra",
  },
  {
    code: "65-147",
    city: "Zielona Góra",
  },
  {
    code: "65-152",
    city: "Zielona Góra",
  },
  {
    code: "65-153",
    city: "Zielona Góra",
  },
  {
    code: "65-154",
    city: "Zielona Góra",
  },
  {
    code: "65-155",
    city: "Zielona Góra",
  },
  {
    code: "65-158",
    city: "Zielona Góra",
  },
  {
    code: "65-160",
    city: "Zielona Góra",
  },
  {
    code: "65-167",
    city: "Zielona Góra",
  },
  {
    code: "65-169",
    city: "Zielona Góra",
  },
  {
    code: "65-170",
    city: "Zielona Góra",
  },
  {
    code: "65-175",
    city: "Zielona Góra",
  },
  {
    code: "65-176",
    city: "Zielona Góra",
  },
  {
    code: "65-177",
    city: "Zielona Góra",
  },
  {
    code: "65-178",
    city: "Zielona Góra",
  },
  {
    code: "65-179",
    city: "Zielona Góra",
  },
  {
    code: "65-180",
    city: "Zielona Góra",
  },
  {
    code: "65-181",
    city: "Zielona Góra",
  },
  {
    code: "65-182",
    city: "Zielona Góra",
  },
  {
    code: "65-183",
    city: "Zielona Góra",
  },
  {
    code: "65-184",
    city: "Zielona Góra",
  },
  {
    code: "65-186",
    city: "Zielona Góra",
  },
  {
    code: "65-187",
    city: "Zielona Góra",
  },
  {
    code: "65-190",
    city: "Zielona Góra",
  },
  {
    code: "65-191",
    city: "Zielona Góra",
  },
  {
    code: "65-201",
    city: "Zielona Góra",
  },
  {
    code: "65-204",
    city: "Zielona Góra",
  },
  {
    code: "65-209",
    city: "Zielona Góra",
  },
  {
    code: "65-211",
    city: "Zielona Góra",
  },
  {
    code: "65-212",
    city: "Zielona Góra",
  },
  {
    code: "65-213",
    city: "Zielona Góra",
  },
  {
    code: "65-215",
    city: "Zielona Góra",
  },
  {
    code: "65-218",
    city: "Zielona Góra",
  },
  {
    code: "65-220",
    city: "Zielona Góra",
  },
  {
    code: "65-221",
    city: "Zielona Góra",
  },
  {
    code: "65-222",
    city: "Zielona Góra",
  },
  {
    code: "65-223",
    city: "Zielona Góra",
  },
  {
    code: "65-224",
    city: "Zielona Góra",
  },
  {
    code: "65-225",
    city: "Zielona Góra",
  },
  {
    code: "65-229",
    city: "Zielona Góra",
  },
  {
    code: "65-231",
    city: "Zielona Góra",
  },
  {
    code: "65-238",
    city: "Zielona Góra",
  },
  {
    code: "65-240",
    city: "Zielona Góra",
  },
  {
    code: "65-245",
    city: "Zielona Góra",
  },
  {
    code: "65-246",
    city: "Zielona Góra",
  },
  {
    code: "65-247",
    city: "Zielona Góra",
  },
  {
    code: "65-249",
    city: "Zielona Góra",
  },
  {
    code: "65-253",
    city: "Zielona Góra",
  },
  {
    code: "65-254",
    city: "Zielona Góra",
  },
  {
    code: "65-255",
    city: "Zielona Góra",
  },
  {
    code: "65-256",
    city: "Zielona Góra",
  },
  {
    code: "65-261",
    city: "Zielona Góra",
  },
  {
    code: "65-264",
    city: "Zielona Góra",
  },
  {
    code: "65-265",
    city: "Zielona Góra",
  },
  {
    code: "65-266",
    city: "Zielona Góra",
  },
  {
    code: "65-267",
    city: "Zielona Góra",
  },
  {
    code: "65-268",
    city: "Zielona Góra",
  },
  {
    code: "65-269",
    city: "Zielona Góra",
  },
  {
    code: "65-270",
    city: "Zielona Góra",
  },
  {
    code: "65-272",
    city: "Zielona Góra",
  },
  {
    code: "65-273",
    city: "Zielona Góra",
  },
  {
    code: "65-301",
    city: "Zielona Góra",
  },
  {
    code: "65-303",
    city: "Zielona Góra",
  },
  {
    code: "65-304",
    city: "Zielona Góra",
  },
  {
    code: "65-305",
    city: "Zielona Góra",
  },
  {
    code: "65-306",
    city: "Zielona Góra",
  },
  {
    code: "65-307",
    city: "Zielona Góra",
  },
  {
    code: "65-308",
    city: "Zielona Góra",
  },
  {
    code: "65-309",
    city: "Zielona Góra",
  },
  {
    code: "65-310",
    city: "Zielona Góra",
  },
  {
    code: "65-311",
    city: "Zielona Góra",
  },
  {
    code: "65-312",
    city: "Zielona Góra",
  },
  {
    code: "65-315",
    city: "Zielona Góra",
  },
  {
    code: "65-318",
    city: "Zielona Góra",
  },
  {
    code: "65-322",
    city: "Zielona Góra",
  },
  {
    code: "65-323",
    city: "Zielona Góra",
  },
  {
    code: "65-324",
    city: "Zielona Góra",
  },
  {
    code: "65-325",
    city: "Zielona Góra",
  },
  {
    code: "65-326",
    city: "Zielona Góra",
  },
  {
    code: "65-327",
    city: "Zielona Góra",
  },
  {
    code: "65-328",
    city: "Zielona Góra",
  },
  {
    code: "65-329",
    city: "Zielona Góra",
  },
  {
    code: "65-331",
    city: "Zielona Góra",
  },
  {
    code: "65-332",
    city: "Zielona Góra",
  },
  {
    code: "65-334",
    city: "Zielona Góra",
  },
  {
    code: "65-335",
    city: "Zielona Góra",
  },
  {
    code: "65-336",
    city: "Zielona Góra",
  },
  {
    code: "65-337",
    city: "Zielona Góra",
  },
  {
    code: "65-338",
    city: "Zielona Góra",
  },
  {
    code: "65-339",
    city: "Zielona Góra",
  },
  {
    code: "65-340",
    city: "Zielona Góra",
  },
  {
    code: "65-341",
    city: "Zielona Góra",
  },
  {
    code: "65-342",
    city: "Zielona Góra",
  },
  {
    code: "65-343",
    city: "Zielona Góra",
  },
  {
    code: "65-344",
    city: "Zielona Góra",
  },
  {
    code: "65-345",
    city: "Zielona Góra",
  },
  {
    code: "65-358",
    city: "Zielona Góra",
  },
  {
    code: "65-364",
    city: "Zielona Góra",
  },
  {
    code: "65-366",
    city: "Zielona Góra",
  },
  {
    code: "65-368",
    city: "Zielona Góra",
  },
  {
    code: "65-371",
    city: "Zielona Góra",
  },
  {
    code: "65-372",
    city: "Zielona Góra",
  },
  {
    code: "65-373",
    city: "Zielona Góra",
  },
  {
    code: "65-374",
    city: "Zielona Góra",
  },
  {
    code: "65-375",
    city: "Zielona Góra",
  },
  {
    code: "65-376",
    city: "Zielona Góra",
  },
  {
    code: "65-377",
    city: "Zielona Góra",
  },
  {
    code: "65-378",
    city: "Zielona Góra",
  },
  {
    code: "65-380",
    city: "Zielona Góra",
  },
  {
    code: "65-381",
    city: "Zielona Góra",
  },
  {
    code: "65-382",
    city: "Zielona Góra",
  },
  {
    code: "65-383",
    city: "Zielona Góra",
  },
  {
    code: "65-384",
    city: "Zielona Góra",
  },
  {
    code: "65-385",
    city: "Zielona Góra",
  },
  {
    code: "65-386",
    city: "Zielona Góra",
  },
  {
    code: "65-387",
    city: "Zielona Góra",
  },
  {
    code: "65-388",
    city: "Zielona Góra",
  },
  {
    code: "65-389",
    city: "Zielona Góra",
  },
  {
    code: "65-390",
    city: "Zielona Góra",
  },
  {
    code: "65-391",
    city: "Zielona Góra",
  },
  {
    code: "65-392",
    city: "Zielona Góra",
  },
  {
    code: "65-395",
    city: "Zielona Góra",
  },
  {
    code: "65-401",
    city: "Zielona Góra",
  },
  {
    code: "65-404",
    city: "Zielona Góra",
  },
  {
    code: "65-405",
    city: "Zielona Góra",
  },
  {
    code: "65-406",
    city: "Zielona Góra",
  },
  {
    code: "65-407",
    city: "Zielona Góra",
  },
  {
    code: "65-409",
    city: "Zielona Góra",
  },
  {
    code: "65-410",
    city: "Zielona Góra",
  },
  {
    code: "65-411",
    city: "Zielona Góra",
  },
  {
    code: "65-412",
    city: "Zielona Góra",
  },
  {
    code: "65-413",
    city: "Zielona Góra",
  },
  {
    code: "65-414",
    city: "Zielona Góra",
  },
  {
    code: "65-415",
    city: "Zielona Góra",
  },
  {
    code: "65-416",
    city: "Zielona Góra",
  },
  {
    code: "65-417",
    city: "Zielona Góra",
  },
  {
    code: "65-418",
    city: "Zielona Góra",
  },
  {
    code: "65-419",
    city: "Zielona Góra",
  },
  {
    code: "65-421",
    city: "Zielona Góra",
  },
  {
    code: "65-423",
    city: "Zielona Góra",
  },
  {
    code: "65-424",
    city: "Zielona Góra",
  },
  {
    code: "65-426",
    city: "Zielona Góra",
  },
  {
    code: "65-427",
    city: "Zielona Góra",
  },
  {
    code: "65-431",
    city: "Zielona Góra",
  },
  {
    code: "65-432",
    city: "Zielona Góra",
  },
  {
    code: "65-433",
    city: "Zielona Góra",
  },
  {
    code: "65-434",
    city: "Zielona Góra",
  },
  {
    code: "65-436",
    city: "Zielona Góra",
  },
  {
    code: "65-437",
    city: "Zielona Góra",
  },
  {
    code: "65-441",
    city: "Zielona Góra",
  },
  {
    code: "65-442",
    city: "Zielona Góra",
  },
  {
    code: "65-443",
    city: "Zielona Góra",
  },
  {
    code: "65-448",
    city: "Zielona Góra",
  },
  {
    code: "65-449",
    city: "Zielona Góra",
  },
  {
    code: "65-450",
    city: "Zielona Góra",
  },
  {
    code: "65-452",
    city: "Zielona Góra",
  },
  {
    code: "65-453",
    city: "Zielona Góra",
  },
  {
    code: "65-454",
    city: "Zielona Góra",
  },
  {
    code: "65-461",
    city: "Zielona Góra",
  },
  {
    code: "65-462",
    city: "Zielona Góra",
  },
  {
    code: "65-463",
    city: "Zielona Góra",
  },
  {
    code: "65-465",
    city: "Zielona Góra",
  },
  {
    code: "65-470",
    city: "Zielona Góra",
  },
  {
    code: "65-472",
    city: "Zielona Góra",
  },
  {
    code: "65-501",
    city: "Zielona Góra",
  },
  {
    code: "65-502",
    city: "Zielona Góra",
  },
  {
    code: "65-503",
    city: "Zielona Góra",
  },
  {
    code: "65-505",
    city: "Zielona Góra",
  },
  {
    code: "65-506",
    city: "Zielona Góra",
  },
  {
    code: "65-507",
    city: "Zielona Góra",
  },
  {
    code: "65-508",
    city: "Zielona Góra",
  },
  {
    code: "65-509",
    city: "Zielona Góra",
  },
  {
    code: "65-510",
    city: "Zielona Góra",
  },
  {
    code: "65-511",
    city: "Zielona Góra",
  },
  {
    code: "65-512",
    city: "Zielona Góra",
  },
  {
    code: "65-514",
    city: "Zielona Góra",
  },
  {
    code: "65-515",
    city: "Zielona Góra",
  },
  {
    code: "65-516",
    city: "Zielona Góra",
  },
  {
    code: "65-517",
    city: "Zielona Góra",
  },
  {
    code: "65-518",
    city: "Zielona Góra",
  },
  {
    code: "65-519",
    city: "Zielona Góra",
  },
  {
    code: "65-520",
    city: "Zielona Góra",
  },
  {
    code: "65-525",
    city: "Zielona Góra",
  },
  {
    code: "65-528",
    city: "Zielona Góra",
  },
  {
    code: "65-530",
    city: "Zielona Góra",
  },
  {
    code: "65-533",
    city: "Zielona Góra",
  },
  {
    code: "65-534",
    city: "Zielona Góra",
  },
  {
    code: "65-536",
    city: "Zielona Góra",
  },
  {
    code: "65-540",
    city: "Zielona Góra",
  },
  {
    code: "65-544",
    city: "Zielona Góra",
  },
  {
    code: "65-546",
    city: "Zielona Góra",
  },
  {
    code: "65-547",
    city: "Zielona Góra",
  },
  {
    code: "65-548",
    city: "Zielona Góra",
  },
  {
    code: "65-552",
    city: "Zielona Góra",
  },
  {
    code: "65-556",
    city: "Zielona Góra",
  },
  {
    code: "65-557",
    city: "Zielona Góra",
  },
  {
    code: "65-559",
    city: "Zielona Góra",
  },
  {
    code: "65-561",
    city: "Zielona Góra",
  },
  {
    code: "65-562",
    city: "Zielona Góra",
  },
  {
    code: "65-601",
    city: "Zielona Góra",
  },
  {
    code: "65-602",
    city: "Zielona Góra",
  },
  {
    code: "65-609",
    city: "Zielona Góra",
  },
  {
    code: "65-610",
    city: "Zielona Góra",
  },
  {
    code: "65-613",
    city: "Zielona Góra",
  },
  {
    code: "65-622",
    city: "Zielona Góra",
  },
  {
    code: "65-625",
    city: "Zielona Góra",
  },
  {
    code: "65-634",
    city: "Zielona Góra",
  },
  {
    code: "65-636",
    city: "Zielona Góra",
  },
  {
    code: "65-638",
    city: "Zielona Góra",
  },
  {
    code: "65-649",
    city: "Zielona Góra",
  },
  {
    code: "65-654",
    city: "Zielona Góra",
  },
  {
    code: "65-664",
    city: "Zielona Góra",
  },
  {
    code: "65-705",
    city: "Zielona Góra",
  },
  {
    code: "65-707",
    city: "Zielona Góra",
  },
  {
    code: "65-713",
    city: "Zielona Góra",
  },
  {
    code: "65-714",
    city: "Zielona Góra",
  },
  {
    code: "65-729",
    city: "Zielona Góra",
  },
  {
    code: "65-730",
    city: "Zielona Góra",
  },
  {
    code: "65-733",
    city: "Zielona Góra",
  },
  {
    code: "65-734",
    city: "Zielona Góra",
  },
  {
    code: "65-735",
    city: "Zielona Góra",
  },
  {
    code: "65-736",
    city: "Zielona Góra",
  },
  {
    code: "65-739",
    city: "Zielona Góra",
  },
  {
    code: "65-740",
    city: "Zielona Góra",
  },
  {
    code: "65-742",
    city: "Zielona Góra",
  },
  {
    code: "65-744",
    city: "Zielona Góra",
  },
  {
    code: "65-747",
    city: "Zielona Góra",
  },
  {
    code: "65-751",
    city: "Zielona Góra",
  },
  {
    code: "65-752",
    city: "Zielona Góra",
  },
  {
    code: "65-755",
    city: "Zielona Góra",
  },
  {
    code: "65-760",
    city: "Zielona Góra",
  },
  {
    code: "65-761",
    city: "Zielona Góra",
  },
  {
    code: "65-762",
    city: "Zielona Góra",
  },
  {
    code: "65-763",
    city: "Zielona Góra",
  },
  {
    code: "65-764",
    city: "Zielona Góra",
  },
  {
    code: "65-766",
    city: "Zielona Góra",
  },
  {
    code: "65-767",
    city: "Zielona Góra",
  },
  {
    code: "65-770",
    city: "Zielona Góra",
  },
  {
    code: "65-775",
    city: "Zielona Góra",
  },
  {
    code: "65-778",
    city: "Zielona Góra",
  },
  {
    code: "65-779",
    city: "Zielona Góra",
  },
  {
    code: "65-780",
    city: "Zielona Góra",
  },
  {
    code: "65-783",
    city: "Zielona Góra",
  },
  {
    code: "65-784",
    city: "Zielona Góra",
  },
  {
    code: "65-785",
    city: "Zielona Góra",
  },
  {
    code: "65-786",
    city: "Zielona Góra",
  },
  {
    code: "65-788",
    city: "Zielona Góra",
  },
  {
    code: "65-790",
    city: "Zielona Góra",
  },
  {
    code: "65-792",
    city: "Zielona Góra",
  },
  {
    code: "65-794",
    city: "Zielona Góra",
  },
  {
    code: "65-803",
    city: "Zielona Góra",
  },
  {
    code: "65-805",
    city: "Zielona Góra",
  },
  {
    code: "65-807",
    city: "Zielona Góra",
  },
  {
    code: "65-823",
    city: "Zielona Góra",
  },
  {
    code: "65-831",
    city: "Zielona Góra",
  },
  {
    code: "65-849",
    city: "Zielona Góra",
  },
  {
    code: "65-850",
    city: "Zielona Góra",
  },
  {
    code: "65-900",
    city: "Zielona Góra",
  },
  {
    code: "65-901",
    city: "Zielona Góra",
  },
  {
    code: "65-903",
    city: "Zielona Góra",
  },
  {
    code: "65-904",
    city: "Zielona Góra",
  },
  {
    code: "65-905",
    city: "Zielona Góra",
  },
  {
    code: "65-906",
    city: "Zielona Góra",
  },
  {
    code: "65-908",
    city: "Zielona Góra",
  },
  {
    code: "65-909",
    city: "Zielona Góra",
  },
  {
    code: "65-912",
    city: "Zielona Góra",
  },
  {
    code: "65-913",
    city: "Zielona Góra",
  },
  {
    code: "65-936",
    city: "Zielona Góra",
  },
  {
    code: "65-939",
    city: "Zielona Góra",
  },
  {
    code: "65-941",
    city: "Zielona Góra",
  },
  {
    code: "65-943",
    city: "Zielona Góra",
  },
  {
    code: "65-945",
    city: "Zielona Góra",
  },
  {
    code: "65-954",
    city: "Zielona Góra",
  },
  {
    code: "65-960",
    city: "Zielona Góra",
  },
  {
    code: "65-980",
    city: "Zielona Góra",
  },
  {
    code: "66-001",
    city: "Zawada",
  },
  {
    code: "66-002",
    city: "Stary Kisielin",
  },
  {
    code: "66-003",
    city: "Zabór",
  },
  {
    code: "66-004",
    city: "Racula",
  },
  {
    code: "66-008",
    city: "Świdnica",
  },
  {
    code: "66-010",
    city: "Nowogród Bobrzański",
  },
  {
    code: "66-015",
    city: "Przylep",
  },
  {
    code: "66-016",
    city: "Czerwieńsk",
  },
  {
    code: "66-100",
    city: "Sulechów",
  },
  {
    code: "66-101",
    city: "Sulechów",
  },
  {
    code: "66-110",
    city: "Babimost",
  },
  {
    code: "66-112",
    city: "Nietkowice",
  },
  {
    code: "66-120",
    city: "Kargowa",
  },
  {
    code: "66-130",
    city: "Bojadła",
  },
  {
    code: "66-132",
    city: "Trzebiechów",
  },
  {
    code: "66-200",
    city: "Świebodzin",
  },
  {
    code: "66-210",
    city: "Zbąszynek",
  },
  {
    code: "66-213",
    city: "Skąpe",
  },
  {
    code: "66-218",
    city: "Lubrza",
  },
  {
    code: "66-220",
    city: "Łagów",
  },
  {
    code: "66-225",
    city: "Szczaniec",
  },
  {
    code: "66-235",
    city: "Torzym",
  },
  {
    code: "66-300",
    city: "Międzyrzecz",
  },
  {
    code: "66-301",
    city: "Międzyrzecz",
  },
  {
    code: "66-302",
    city: "Międzyrzecz",
  },
  {
    code: "66-304",
    city: "Brójce",
  },
  {
    code: "66-307",
    city: "Templewo",
  },
  {
    code: "66-320",
    city: "Trzciel",
  },
  {
    code: "66-330",
    city: "Pszczew",
  },
  {
    code: "66-340",
    city: "Przytoczna",
  },
  {
    code: "66-342",
    city: "Goraj",
  },
  {
    code: "66-350",
    city: "Bledzew",
  },
  {
    code: "66-400",
    city: "Gorzów Wielkopolski",
  },
  {
    code: "66-401",
    city: "Gorzów Wielkopolski",
  },
  {
    code: "66-403",
    city: "Gorzów Wielkopolski",
  },
  {
    code: "66-404",
    city: "Gorzów Wielkopolski",
  },
  {
    code: "66-405",
    city: "Gorzów Wielkopolski",
  },
  {
    code: "66-406",
    city: "Gorzów Wielkopolski",
  },
  {
    code: "66-407",
    city: "Gorzów Wielkopolski",
  },
  {
    code: "66-408",
    city: "Gorzów Wielkopolski",
  },
  {
    code: "66-410",
    city: "Gorzów Wielkopolski",
  },
  {
    code: "66-412",
    city: "Gorzów Wielkopolski",
  },
  {
    code: "66-413",
    city: "Gorzów Wielkopolski",
  },
  {
    code: "66-414",
    city: "Gorzów Wielkopolski",
  },
  {
    code: "66-415",
    city: "Kłodawa",
  },
  {
    code: "66-418",
    city: "Gorzów Wielkopolski",
  },
  {
    code: "66-431",
    city: "Santok",
  },
  {
    code: "66-433",
    city: "Lubiszyn",
  },
  {
    code: "66-435",
    city: "Krzeszyce",
  },
  {
    code: "66-436",
    city: "Słońsk",
  },
  {
    code: "66-440",
    city: "Skwierzyna",
  },
  {
    code: "66-446",
    city: "Deszczno",
  },
  {
    code: "66-450",
    city: "Bogdaniec",
  },
  {
    code: "66-460",
    city: "Witnica",
  },
  {
    code: "66-470",
    city: "Kostrzyn nad Odrą",
  },
  {
    code: "66-500",
    city: "Strzelce Krajeńskie",
  },
  {
    code: "66-520",
    city: "Dobiegniew",
  },
  {
    code: "66-530",
    city: "Drezdenko",
  },
  {
    code: "66-540",
    city: "Stare Kurowo",
  },
  {
    code: "66-542",
    city: "Zwierzyn",
  },
  {
    code: "66-600",
    city: "Krosno Odrzańskie",
  },
  {
    code: "66-601",
    city: "Krosno Odrzańskie",
  },
  {
    code: "66-602",
    city: "Krosno Odrzańskie",
  },
  {
    code: "66-614",
    city: "Maszewo",
  },
  {
    code: "66-620",
    city: "Gubin",
  },
  {
    code: "66-627",
    city: "Bobrowice",
  },
  {
    code: "66-630",
    city: "Bytnica",
  },
  {
    code: "66-635",
    city: "Gubin",
  },
  {
    code: "67-100",
    city: "Nowa Sól",
  },
  {
    code: "67-101",
    city: "Nowa Sól",
  },
  {
    code: "67-115",
    city: "Bytom Odrzański",
  },
  {
    code: "67-120",
    city: "Kożuchów",
  },
  {
    code: "67-124",
    city: "Nowe Miasteczko",
  },
  {
    code: "67-200",
    city: "Głogów",
  },
  {
    code: "67-202",
    city: "Głogów",
  },
  {
    code: "67-203",
    city: "Głogów",
  },
  {
    code: "67-204",
    city: "Głogów",
  },
  {
    code: "67-205",
    city: "Głogów",
  },
  {
    code: "67-206",
    city: "Głogów",
  },
  {
    code: "67-210",
    city: "Głogów",
  },
  {
    code: "67-221",
    city: "Białołęka",
  },
  {
    code: "67-222",
    city: "Jerzmanowa",
  },
  {
    code: "67-231",
    city: "Żukowice",
  },
  {
    code: "67-240",
    city: "Kotla",
  },
  {
    code: "67-300",
    city: "Szprotawa",
  },
  {
    code: "67-312",
    city: "Niegosławice",
  },
  {
    code: "67-320",
    city: "Małomice",
  },
  {
    code: "67-400",
    city: "Wschowa",
  },
  {
    code: "67-407",
    city: "Szlichtyngowa",
  },
  {
    code: "67-410",
    city: "Sława",
  },
  {
    code: "67-415",
    city: "Kolsko",
  },
  {
    code: "68-100",
    city: "Żagań",
  },
  {
    code: "68-101",
    city: "Żagań",
  },
  {
    code: "68-103",
    city: "Żagań",
  },
  {
    code: "68-113",
    city: "Brzeźnica",
  },
  {
    code: "68-120",
    city: "Iłowa",
  },
  {
    code: "68-130",
    city: "Gozdnica",
  },
  {
    code: "68-131",
    city: "Wymiarki",
  },
  {
    code: "68-132",
    city: "Przewóz",
  },
  {
    code: "68-200",
    city: "Żary",
  },
  {
    code: "68-203",
    city: "Żary",
  },
  {
    code: "68-208",
    city: "Łęknica",
  },
  {
    code: "68-212",
    city: "Trzebiel",
  },
  {
    code: "68-213",
    city: "Lipinki Łużyckie",
  },
  {
    code: "68-219",
    city: "Tuplice",
  },
  {
    code: "68-300",
    city: "Lubsko",
  },
  {
    code: "68-301",
    city: "Lubsko",
  },
  {
    code: "68-320",
    city: "Jasień",
  },
  {
    code: "68-343",
    city: "Brody",
  },
  {
    code: "69-100",
    city: "Słubice",
  },
  {
    code: "69-101",
    city: "Słubice",
  },
  {
    code: "69-105",
    city: "Świecko",
  },
  {
    code: "69-108",
    city: "Cybinka",
  },
  {
    code: "69-110",
    city: "Rzepin",
  },
  {
    code: "69-113",
    city: "Górzyca",
  },
  {
    code: "69-200",
    city: "Sulęcin",
  },
  {
    code: "69-210",
    city: "Lubniewice",
  },
  {
    code: "69-211",
    city: "Wędrzyn",
  },
  {
    code: "69-220",
    city: "Ośno Lubuskie",
  },
  {
    code: "70-001",
    city: "Szczecin",
  },
  {
    code: "70-002",
    city: "Szczecin",
  },
  {
    code: "70-003",
    city: "Szczecin",
  },
  {
    code: "70-004",
    city: "Szczecin",
  },
  {
    code: "70-005",
    city: "Szczecin",
  },
  {
    code: "70-006",
    city: "Szczecin",
  },
  {
    code: "70-007",
    city: "Szczecin",
  },
  {
    code: "70-008",
    city: "Szczecin",
  },
  {
    code: "70-009",
    city: "Szczecin",
  },
  {
    code: "70-010",
    city: "Szczecin",
  },
  {
    code: "70-011",
    city: "Szczecin",
  },
  {
    code: "70-012",
    city: "Szczecin",
  },
  {
    code: "70-013",
    city: "Szczecin",
  },
  {
    code: "70-014",
    city: "Szczecin",
  },
  {
    code: "70-015",
    city: "Szczecin",
  },
  {
    code: "70-016",
    city: "Szczecin",
  },
  {
    code: "70-017",
    city: "Szczecin",
  },
  {
    code: "70-018",
    city: "Szczecin",
  },
  {
    code: "70-020",
    city: "Szczecin",
  },
  {
    code: "70-021",
    city: "Szczecin",
  },
  {
    code: "70-022",
    city: "Szczecin",
  },
  {
    code: "70-023",
    city: "Szczecin",
  },
  {
    code: "70-024",
    city: "Szczecin",
  },
  {
    code: "70-025",
    city: "Szczecin",
  },
  {
    code: "70-026",
    city: "Szczecin",
  },
  {
    code: "70-027",
    city: "Szczecin",
  },
  {
    code: "70-028",
    city: "Szczecin",
  },
  {
    code: "70-030",
    city: "Szczecin",
  },
  {
    code: "70-031",
    city: "Szczecin",
  },
  {
    code: "70-032",
    city: "Szczecin",
  },
  {
    code: "70-033",
    city: "Szczecin",
  },
  {
    code: "70-034",
    city: "Szczecin",
  },
  {
    code: "70-035",
    city: "Szczecin",
  },
  {
    code: "70-037",
    city: "Szczecin",
  },
  {
    code: "70-100",
    city: "Szczecin",
  },
  {
    code: "70-101",
    city: "Szczecin",
  },
  {
    code: "70-102",
    city: "Szczecin",
  },
  {
    code: "70-103",
    city: "Szczecin",
  },
  {
    code: "70-104",
    city: "Szczecin",
  },
  {
    code: "70-105",
    city: "Szczecin",
  },
  {
    code: "70-106",
    city: "Szczecin",
  },
  {
    code: "70-107",
    city: "Szczecin",
  },
  {
    code: "70-110",
    city: "Szczecin",
  },
  {
    code: "70-111",
    city: "Szczecin",
  },
  {
    code: "70-112",
    city: "Szczecin",
  },
  {
    code: "70-113",
    city: "Szczecin",
  },
  {
    code: "70-114",
    city: "Szczecin",
  },
  {
    code: "70-115",
    city: "Szczecin",
  },
  {
    code: "70-116",
    city: "Szczecin",
  },
  {
    code: "70-117",
    city: "Szczecin",
  },
  {
    code: "70-120",
    city: "Szczecin",
  },
  {
    code: "70-121",
    city: "Szczecin",
  },
  {
    code: "70-123",
    city: "Szczecin",
  },
  {
    code: "70-128",
    city: "Szczecin",
  },
  {
    code: "70-130",
    city: "Szczecin",
  },
  {
    code: "70-131",
    city: "Szczecin",
  },
  {
    code: "70-132",
    city: "Szczecin",
  },
  {
    code: "70-133",
    city: "Szczecin",
  },
  {
    code: "70-134",
    city: "Szczecin",
  },
  {
    code: "70-136",
    city: "Szczecin",
  },
  {
    code: "70-137",
    city: "Szczecin",
  },
  {
    code: "70-200",
    city: "Szczecin",
  },
  {
    code: "70-201",
    city: "Szczecin",
  },
  {
    code: "70-202",
    city: "Szczecin",
  },
  {
    code: "70-203",
    city: "Szczecin",
  },
  {
    code: "70-204",
    city: "Szczecin",
  },
  {
    code: "70-205",
    city: "Szczecin",
  },
  {
    code: "70-206",
    city: "Szczecin",
  },
  {
    code: "70-207",
    city: "Szczecin",
  },
  {
    code: "70-209",
    city: "Szczecin",
  },
  {
    code: "70-210",
    city: "Szczecin",
  },
  {
    code: "70-211",
    city: "Szczecin",
  },
  {
    code: "70-212",
    city: "Szczecin",
  },
  {
    code: "70-213",
    city: "Szczecin",
  },
  {
    code: "70-214",
    city: "Szczecin",
  },
  {
    code: "70-215",
    city: "Szczecin",
  },
  {
    code: "70-216",
    city: "Szczecin",
  },
  {
    code: "70-217",
    city: "Szczecin",
  },
  {
    code: "70-220",
    city: "Szczecin",
  },
  {
    code: "70-221",
    city: "Szczecin",
  },
  {
    code: "70-222",
    city: "Szczecin",
  },
  {
    code: "70-223",
    city: "Szczecin",
  },
  {
    code: "70-224",
    city: "Szczecin",
  },
  {
    code: "70-225",
    city: "Szczecin",
  },
  {
    code: "70-226",
    city: "Szczecin",
  },
  {
    code: "70-227",
    city: "Szczecin",
  },
  {
    code: "70-230",
    city: "Szczecin",
  },
  {
    code: "70-231",
    city: "Szczecin",
  },
  {
    code: "70-232",
    city: "Szczecin",
  },
  {
    code: "70-233",
    city: "Szczecin",
  },
  {
    code: "70-234",
    city: "Szczecin",
  },
  {
    code: "70-236",
    city: "Szczecin",
  },
  {
    code: "70-237",
    city: "Szczecin",
  },
  {
    code: "70-238",
    city: "Szczecin",
  },
  {
    code: "70-240",
    city: "Szczecin",
  },
  {
    code: "70-241",
    city: "Szczecin",
  },
  {
    code: "70-242",
    city: "Szczecin",
  },
  {
    code: "70-243",
    city: "Szczecin",
  },
  {
    code: "70-244",
    city: "Szczecin",
  },
  {
    code: "70-245",
    city: "Szczecin",
  },
  {
    code: "70-246",
    city: "Szczecin",
  },
  {
    code: "70-250",
    city: "Szczecin",
  },
  {
    code: "70-251",
    city: "Szczecin",
  },
  {
    code: "70-252",
    city: "Szczecin",
  },
  {
    code: "70-253",
    city: "Szczecin",
  },
  {
    code: "70-254",
    city: "Szczecin",
  },
  {
    code: "70-255",
    city: "Szczecin",
  },
  {
    code: "70-256",
    city: "Szczecin",
  },
  {
    code: "70-257",
    city: "Szczecin",
  },
  {
    code: "70-260",
    city: "Szczecin",
  },
  {
    code: "70-261",
    city: "Szczecin",
  },
  {
    code: "70-262",
    city: "Szczecin",
  },
  {
    code: "70-263",
    city: "Szczecin",
  },
  {
    code: "70-300",
    city: "Szczecin",
  },
  {
    code: "70-301",
    city: "Szczecin",
  },
  {
    code: "70-302",
    city: "Szczecin",
  },
  {
    code: "70-303",
    city: "Szczecin",
  },
  {
    code: "70-304",
    city: "Szczecin",
  },
  {
    code: "70-305",
    city: "Szczecin",
  },
  {
    code: "70-306",
    city: "Szczecin",
  },
  {
    code: "70-307",
    city: "Szczecin",
  },
  {
    code: "70-310",
    city: "Szczecin",
  },
  {
    code: "70-311",
    city: "Szczecin",
  },
  {
    code: "70-312",
    city: "Szczecin",
  },
  {
    code: "70-313",
    city: "Szczecin",
  },
  {
    code: "70-314",
    city: "Szczecin",
  },
  {
    code: "70-315",
    city: "Szczecin",
  },
  {
    code: "70-316",
    city: "Szczecin",
  },
  {
    code: "70-317",
    city: "Szczecin",
  },
  {
    code: "70-320",
    city: "Szczecin",
  },
  {
    code: "70-321",
    city: "Szczecin",
  },
  {
    code: "70-322",
    city: "Szczecin",
  },
  {
    code: "70-323",
    city: "Szczecin",
  },
  {
    code: "70-325",
    city: "Szczecin",
  },
  {
    code: "70-326",
    city: "Szczecin",
  },
  {
    code: "70-327",
    city: "Szczecin",
  },
  {
    code: "70-330",
    city: "Szczecin",
  },
  {
    code: "70-331",
    city: "Szczecin",
  },
  {
    code: "70-332",
    city: "Szczecin",
  },
  {
    code: "70-333",
    city: "Szczecin",
  },
  {
    code: "70-334",
    city: "Szczecin",
  },
  {
    code: "70-335",
    city: "Szczecin",
  },
  {
    code: "70-337",
    city: "Szczecin",
  },
  {
    code: "70-340",
    city: "Szczecin",
  },
  {
    code: "70-341",
    city: "Szczecin",
  },
  {
    code: "70-342",
    city: "Szczecin",
  },
  {
    code: "70-343",
    city: "Szczecin",
  },
  {
    code: "70-344",
    city: "Szczecin",
  },
  {
    code: "70-345",
    city: "Szczecin",
  },
  {
    code: "70-346",
    city: "Szczecin",
  },
  {
    code: "70-347",
    city: "Szczecin",
  },
  {
    code: "70-348",
    city: "Szczecin",
  },
  {
    code: "70-349",
    city: "Szczecin",
  },
  {
    code: "70-350",
    city: "Szczecin",
  },
  {
    code: "70-351",
    city: "Szczecin",
  },
  {
    code: "70-352",
    city: "Szczecin",
  },
  {
    code: "70-353",
    city: "Szczecin",
  },
  {
    code: "70-354",
    city: "Szczecin",
  },
  {
    code: "70-355",
    city: "Szczecin",
  },
  {
    code: "70-356",
    city: "Szczecin",
  },
  {
    code: "70-357",
    city: "Szczecin",
  },
  {
    code: "70-358",
    city: "Szczecin",
  },
  {
    code: "70-360",
    city: "Szczecin",
  },
  {
    code: "70-361",
    city: "Szczecin",
  },
  {
    code: "70-362",
    city: "Szczecin",
  },
  {
    code: "70-363",
    city: "Szczecin",
  },
  {
    code: "70-364",
    city: "Szczecin",
  },
  {
    code: "70-365",
    city: "Szczecin",
  },
  {
    code: "70-366",
    city: "Szczecin",
  },
  {
    code: "70-367",
    city: "Szczecin",
  },
  {
    code: "70-370",
    city: "Szczecin",
  },
  {
    code: "70-371",
    city: "Szczecin",
  },
  {
    code: "70-372",
    city: "Szczecin",
  },
  {
    code: "70-373",
    city: "Szczecin",
  },
  {
    code: "70-374",
    city: "Szczecin",
  },
  {
    code: "70-375",
    city: "Szczecin",
  },
  {
    code: "70-376",
    city: "Szczecin",
  },
  {
    code: "70-377",
    city: "Szczecin",
  },
  {
    code: "70-380",
    city: "Szczecin",
  },
  {
    code: "70-381",
    city: "Szczecin",
  },
  {
    code: "70-382",
    city: "Szczecin",
  },
  {
    code: "70-383",
    city: "Szczecin",
  },
  {
    code: "70-384",
    city: "Szczecin",
  },
  {
    code: "70-385",
    city: "Szczecin",
  },
  {
    code: "70-386",
    city: "Szczecin",
  },
  {
    code: "70-387",
    city: "Szczecin",
  },
  {
    code: "70-390",
    city: "Szczecin",
  },
  {
    code: "70-391",
    city: "Szczecin",
  },
  {
    code: "70-392",
    city: "Szczecin",
  },
  {
    code: "70-393",
    city: "Szczecin",
  },
  {
    code: "70-394",
    city: "Szczecin",
  },
  {
    code: "70-395",
    city: "Szczecin",
  },
  {
    code: "70-396",
    city: "Szczecin",
  },
  {
    code: "70-400",
    city: "Szczecin",
  },
  {
    code: "70-402",
    city: "Szczecin",
  },
  {
    code: "70-403",
    city: "Szczecin",
  },
  {
    code: "70-404",
    city: "Szczecin",
  },
  {
    code: "70-405",
    city: "Szczecin",
  },
  {
    code: "70-406",
    city: "Szczecin",
  },
  {
    code: "70-407",
    city: "Szczecin",
  },
  {
    code: "70-410",
    city: "Szczecin",
  },
  {
    code: "70-411",
    city: "Szczecin",
  },
  {
    code: "70-412",
    city: "Szczecin",
  },
  {
    code: "70-413",
    city: "Szczecin",
  },
  {
    code: "70-414",
    city: "Szczecin",
  },
  {
    code: "70-415",
    city: "Szczecin",
  },
  {
    code: "70-416",
    city: "Szczecin",
  },
  {
    code: "70-419",
    city: "Szczecin",
  },
  {
    code: "70-420",
    city: "Szczecin",
  },
  {
    code: "70-421",
    city: "Szczecin",
  },
  {
    code: "70-422",
    city: "Szczecin",
  },
  {
    code: "70-423",
    city: "Szczecin",
  },
  {
    code: "70-424",
    city: "Szczecin",
  },
  {
    code: "70-425",
    city: "Szczecin",
  },
  {
    code: "70-426",
    city: "Szczecin",
  },
  {
    code: "70-427",
    city: "Szczecin",
  },
  {
    code: "70-428",
    city: "Szczecin",
  },
  {
    code: "70-430",
    city: "Szczecin",
  },
  {
    code: "70-431",
    city: "Szczecin",
  },
  {
    code: "70-432",
    city: "Szczecin",
  },
  {
    code: "70-433",
    city: "Szczecin",
  },
  {
    code: "70-434",
    city: "Szczecin",
  },
  {
    code: "70-435",
    city: "Szczecin",
  },
  {
    code: "70-436",
    city: "Szczecin",
  },
  {
    code: "70-437",
    city: "Szczecin",
  },
  {
    code: "70-440",
    city: "Szczecin",
  },
  {
    code: "70-441",
    city: "Szczecin",
  },
  {
    code: "70-442",
    city: "Szczecin",
  },
  {
    code: "70-443",
    city: "Szczecin",
  },
  {
    code: "70-444",
    city: "Szczecin",
  },
  {
    code: "70-445",
    city: "Szczecin",
  },
  {
    code: "70-446",
    city: "Szczecin",
  },
  {
    code: "70-450",
    city: "Szczecin",
  },
  {
    code: "70-451",
    city: "Szczecin",
  },
  {
    code: "70-452",
    city: "Szczecin",
  },
  {
    code: "70-453",
    city: "Szczecin",
  },
  {
    code: "70-454",
    city: "Szczecin",
  },
  {
    code: "70-455",
    city: "Szczecin",
  },
  {
    code: "70-456",
    city: "Szczecin",
  },
  {
    code: "70-460",
    city: "Szczecin",
  },
  {
    code: "70-461",
    city: "Szczecin",
  },
  {
    code: "70-462",
    city: "Szczecin",
  },
  {
    code: "70-463",
    city: "Szczecin",
  },
  {
    code: "70-464",
    city: "Szczecin",
  },
  {
    code: "70-465",
    city: "Szczecin",
  },
  {
    code: "70-466",
    city: "Szczecin",
  },
  {
    code: "70-467",
    city: "Szczecin",
  },
  {
    code: "70-470",
    city: "Szczecin",
  },
  {
    code: "70-471",
    city: "Szczecin",
  },
  {
    code: "70-472",
    city: "Szczecin",
  },
  {
    code: "70-473",
    city: "Szczecin",
  },
  {
    code: "70-474",
    city: "Szczecin",
  },
  {
    code: "70-475",
    city: "Szczecin",
  },
  {
    code: "70-476",
    city: "Szczecin",
  },
  {
    code: "70-477",
    city: "Szczecin",
  },
  {
    code: "70-478",
    city: "Szczecin",
  },
  {
    code: "70-479",
    city: "Szczecin",
  },
  {
    code: "70-480",
    city: "Szczecin",
  },
  {
    code: "70-481",
    city: "Szczecin",
  },
  {
    code: "70-482",
    city: "Szczecin",
  },
  {
    code: "70-483",
    city: "Szczecin",
  },
  {
    code: "70-484",
    city: "Szczecin",
  },
  {
    code: "70-485",
    city: "Szczecin",
  },
  {
    code: "70-486",
    city: "Szczecin",
  },
  {
    code: "70-487",
    city: "Szczecin",
  },
  {
    code: "70-488",
    city: "Szczecin",
  },
  {
    code: "70-490",
    city: "Szczecin",
  },
  {
    code: "70-491",
    city: "Szczecin",
  },
  {
    code: "70-492",
    city: "Szczecin",
  },
  {
    code: "70-493",
    city: "Szczecin",
  },
  {
    code: "70-494",
    city: "Szczecin",
  },
  {
    code: "70-495",
    city: "Szczecin",
  },
  {
    code: "70-496",
    city: "Szczecin",
  },
  {
    code: "70-497",
    city: "Szczecin",
  },
  {
    code: "70-500",
    city: "Szczecin",
  },
  {
    code: "70-501",
    city: "Szczecin",
  },
  {
    code: "70-502",
    city: "Szczecin",
  },
  {
    code: "70-503",
    city: "Szczecin",
  },
  {
    code: "70-504",
    city: "Szczecin",
  },
  {
    code: "70-505",
    city: "Szczecin",
  },
  {
    code: "70-506",
    city: "Szczecin",
  },
  {
    code: "70-507",
    city: "Szczecin",
  },
  {
    code: "70-508",
    city: "Szczecin",
  },
  {
    code: "70-509",
    city: "Szczecin",
  },
  {
    code: "70-510",
    city: "Szczecin",
  },
  {
    code: "70-511",
    city: "Szczecin",
  },
  {
    code: "70-512",
    city: "Szczecin",
  },
  {
    code: "70-513",
    city: "Szczecin",
  },
  {
    code: "70-514",
    city: "Szczecin",
  },
  {
    code: "70-515",
    city: "Szczecin",
  },
  {
    code: "70-520",
    city: "Szczecin",
  },
  {
    code: "70-521",
    city: "Szczecin",
  },
  {
    code: "70-522",
    city: "Szczecin",
  },
  {
    code: "70-524",
    city: "Szczecin",
  },
  {
    code: "70-525",
    city: "Szczecin",
  },
  {
    code: "70-526",
    city: "Szczecin",
  },
  {
    code: "70-527",
    city: "Szczecin",
  },
  {
    code: "70-529",
    city: "Szczecin",
  },
  {
    code: "70-530",
    city: "Szczecin",
  },
  {
    code: "70-531",
    city: "Szczecin",
  },
  {
    code: "70-532",
    city: "Szczecin",
  },
  {
    code: "70-533",
    city: "Szczecin",
  },
  {
    code: "70-534",
    city: "Szczecin",
  },
  {
    code: "70-535",
    city: "Szczecin",
  },
  {
    code: "70-536",
    city: "Szczecin",
  },
  {
    code: "70-537",
    city: "Szczecin",
  },
  {
    code: "70-538",
    city: "Szczecin",
  },
  {
    code: "70-540",
    city: "Szczecin",
  },
  {
    code: "70-541",
    city: "Szczecin",
  },
  {
    code: "70-542",
    city: "Szczecin",
  },
  {
    code: "70-543",
    city: "Szczecin",
  },
  {
    code: "70-545",
    city: "Szczecin",
  },
  {
    code: "70-546",
    city: "Szczecin",
  },
  {
    code: "70-547",
    city: "Szczecin",
  },
  {
    code: "70-549",
    city: "Szczecin",
  },
  {
    code: "70-550",
    city: "Szczecin",
  },
  {
    code: "70-551",
    city: "Szczecin",
  },
  {
    code: "70-552",
    city: "Szczecin",
  },
  {
    code: "70-553",
    city: "Szczecin",
  },
  {
    code: "70-554",
    city: "Szczecin",
  },
  {
    code: "70-555",
    city: "Szczecin",
  },
  {
    code: "70-556",
    city: "Szczecin",
  },
  {
    code: "70-557",
    city: "Szczecin",
  },
  {
    code: "70-560",
    city: "Szczecin",
  },
  {
    code: "70-561",
    city: "Szczecin",
  },
  {
    code: "70-562",
    city: "Szczecin",
  },
  {
    code: "70-563",
    city: "Szczecin",
  },
  {
    code: "70-564",
    city: "Szczecin",
  },
  {
    code: "70-565",
    city: "Szczecin",
  },
  {
    code: "70-566",
    city: "Szczecin",
  },
  {
    code: "70-567",
    city: "Szczecin",
  },
  {
    code: "70-568",
    city: "Szczecin",
  },
  {
    code: "70-569",
    city: "Szczecin",
  },
  {
    code: "70-570",
    city: "Szczecin",
  },
  {
    code: "70-600",
    city: "Szczecin",
  },
  {
    code: "70-601",
    city: "Szczecin",
  },
  {
    code: "70-602",
    city: "Szczecin",
  },
  {
    code: "70-603",
    city: "Szczecin",
  },
  {
    code: "70-604",
    city: "Szczecin",
  },
  {
    code: "70-605",
    city: "Szczecin",
  },
  {
    code: "70-606",
    city: "Szczecin",
  },
  {
    code: "70-607",
    city: "Szczecin",
  },
  {
    code: "70-610",
    city: "Szczecin",
  },
  {
    code: "70-611",
    city: "Szczecin",
  },
  {
    code: "70-612",
    city: "Szczecin",
  },
  {
    code: "70-613",
    city: "Szczecin",
  },
  {
    code: "70-614",
    city: "Szczecin",
  },
  {
    code: "70-615",
    city: "Szczecin",
  },
  {
    code: "70-616",
    city: "Szczecin",
  },
  {
    code: "70-617",
    city: "Szczecin",
  },
  {
    code: "70-620",
    city: "Szczecin",
  },
  {
    code: "70-621",
    city: "Szczecin",
  },
  {
    code: "70-622",
    city: "Szczecin",
  },
  {
    code: "70-623",
    city: "Szczecin",
  },
  {
    code: "70-630",
    city: "Szczecin",
  },
  {
    code: "70-631",
    city: "Szczecin",
  },
  {
    code: "70-632",
    city: "Szczecin",
  },
  {
    code: "70-633",
    city: "Szczecin",
  },
  {
    code: "70-634",
    city: "Szczecin",
  },
  {
    code: "70-635",
    city: "Szczecin",
  },
  {
    code: "70-636",
    city: "Szczecin",
  },
  {
    code: "70-640",
    city: "Szczecin",
  },
  {
    code: "70-641",
    city: "Szczecin",
  },
  {
    code: "70-642",
    city: "Szczecin",
  },
  {
    code: "70-644",
    city: "Szczecin",
  },
  {
    code: "70-646",
    city: "Szczecin",
  },
  {
    code: "70-651",
    city: "Szczecin",
  },
  {
    code: "70-652",
    city: "Szczecin",
  },
  {
    code: "70-653",
    city: "Szczecin",
  },
  {
    code: "70-655",
    city: "Szczecin",
  },
  {
    code: "70-656",
    city: "Szczecin",
  },
  {
    code: "70-660",
    city: "Szczecin",
  },
  {
    code: "70-661",
    city: "Szczecin",
  },
  {
    code: "70-662",
    city: "Szczecin",
  },
  {
    code: "70-663",
    city: "Szczecin",
  },
  {
    code: "70-664",
    city: "Szczecin",
  },
  {
    code: "70-665",
    city: "Szczecin",
  },
  {
    code: "70-666",
    city: "Szczecin",
  },
  {
    code: "70-667",
    city: "Szczecin",
  },
  {
    code: "70-668",
    city: "Szczecin",
  },
  {
    code: "70-671",
    city: "Szczecin",
  },
  {
    code: "70-672",
    city: "Szczecin",
  },
  {
    code: "70-673",
    city: "Szczecin",
  },
  {
    code: "70-674",
    city: "Szczecin",
  },
  {
    code: "70-675",
    city: "Szczecin",
  },
  {
    code: "70-676",
    city: "Szczecin",
  },
  {
    code: "70-700",
    city: "Szczecin",
  },
  {
    code: "70-701",
    city: "Szczecin",
  },
  {
    code: "70-702",
    city: "Szczecin",
  },
  {
    code: "70-703",
    city: "Szczecin",
  },
  {
    code: "70-704",
    city: "Szczecin",
  },
  {
    code: "70-705",
    city: "Szczecin",
  },
  {
    code: "70-706",
    city: "Szczecin",
  },
  {
    code: "70-707",
    city: "Szczecin",
  },
  {
    code: "70-708",
    city: "Szczecin",
  },
  {
    code: "70-710",
    city: "Szczecin",
  },
  {
    code: "70-711",
    city: "Szczecin",
  },
  {
    code: "70-712",
    city: "Szczecin",
  },
  {
    code: "70-713",
    city: "Szczecin",
  },
  {
    code: "70-714",
    city: "Szczecin",
  },
  {
    code: "70-715",
    city: "Szczecin",
  },
  {
    code: "70-716",
    city: "Szczecin",
  },
  {
    code: "70-717",
    city: "Szczecin",
  },
  {
    code: "70-720",
    city: "Szczecin",
  },
  {
    code: "70-721",
    city: "Szczecin",
  },
  {
    code: "70-722",
    city: "Szczecin",
  },
  {
    code: "70-723",
    city: "Szczecin",
  },
  {
    code: "70-724",
    city: "Szczecin",
  },
  {
    code: "70-725",
    city: "Szczecin",
  },
  {
    code: "70-726",
    city: "Szczecin",
  },
  {
    code: "70-727",
    city: "Szczecin",
  },
  {
    code: "70-730",
    city: "Szczecin",
  },
  {
    code: "70-731",
    city: "Szczecin",
  },
  {
    code: "70-732",
    city: "Szczecin",
  },
  {
    code: "70-733",
    city: "Szczecin",
  },
  {
    code: "70-734",
    city: "Szczecin",
  },
  {
    code: "70-735",
    city: "Szczecin",
  },
  {
    code: "70-736",
    city: "Szczecin",
  },
  {
    code: "70-737",
    city: "Szczecin",
  },
  {
    code: "70-740",
    city: "Szczecin",
  },
  {
    code: "70-741",
    city: "Szczecin",
  },
  {
    code: "70-742",
    city: "Szczecin",
  },
  {
    code: "70-743",
    city: "Szczecin",
  },
  {
    code: "70-744",
    city: "Szczecin",
  },
  {
    code: "70-745",
    city: "Szczecin",
  },
  {
    code: "70-746",
    city: "Szczecin",
  },
  {
    code: "70-747",
    city: "Szczecin",
  },
  {
    code: "70-748",
    city: "Szczecin",
  },
  {
    code: "70-750",
    city: "Szczecin",
  },
  {
    code: "70-751",
    city: "Szczecin",
  },
  {
    code: "70-752",
    city: "Szczecin",
  },
  {
    code: "70-753",
    city: "Szczecin",
  },
  {
    code: "70-754",
    city: "Szczecin",
  },
  {
    code: "70-760",
    city: "Szczecin",
  },
  {
    code: "70-761",
    city: "Szczecin",
  },
  {
    code: "70-762",
    city: "Szczecin",
  },
  {
    code: "70-763",
    city: "Szczecin",
  },
  {
    code: "70-764",
    city: "Szczecin",
  },
  {
    code: "70-765",
    city: "Szczecin",
  },
  {
    code: "70-766",
    city: "Szczecin",
  },
  {
    code: "70-767",
    city: "Szczecin",
  },
  {
    code: "70-770",
    city: "Szczecin",
  },
  {
    code: "70-771",
    city: "Szczecin",
  },
  {
    code: "70-772",
    city: "Szczecin",
  },
  {
    code: "70-773",
    city: "Szczecin",
  },
  {
    code: "70-774",
    city: "Szczecin",
  },
  {
    code: "70-775",
    city: "Szczecin",
  },
  {
    code: "70-776",
    city: "Szczecin",
  },
  {
    code: "70-777",
    city: "Szczecin",
  },
  {
    code: "70-778",
    city: "Szczecin",
  },
  {
    code: "70-779",
    city: "Szczecin",
  },
  {
    code: "70-780",
    city: "Szczecin",
  },
  {
    code: "70-781",
    city: "Szczecin",
  },
  {
    code: "70-782",
    city: "Szczecin",
  },
  {
    code: "70-783",
    city: "Szczecin",
  },
  {
    code: "70-784",
    city: "Szczecin",
  },
  {
    code: "70-785",
    city: "Szczecin",
  },
  {
    code: "70-786",
    city: "Szczecin",
  },
  {
    code: "70-787",
    city: "Szczecin",
  },
  {
    code: "70-788",
    city: "Szczecin",
  },
  {
    code: "70-789",
    city: "Szczecin",
  },
  {
    code: "70-790",
    city: "Szczecin",
  },
  {
    code: "70-791",
    city: "Szczecin",
  },
  {
    code: "70-792",
    city: "Szczecin",
  },
  {
    code: "70-793",
    city: "Szczecin",
  },
  {
    code: "70-794",
    city: "Szczecin",
  },
  {
    code: "70-795",
    city: "Szczecin",
  },
  {
    code: "70-796",
    city: "Szczecin",
  },
  {
    code: "70-797",
    city: "Szczecin",
  },
  {
    code: "70-798",
    city: "Szczecin",
  },
  {
    code: "70-799",
    city: "Szczecin",
  },
  {
    code: "70-800",
    city: "Szczecin",
  },
  {
    code: "70-801",
    city: "Szczecin",
  },
  {
    code: "70-802",
    city: "Szczecin",
  },
  {
    code: "70-803",
    city: "Szczecin",
  },
  {
    code: "70-804",
    city: "Szczecin",
  },
  {
    code: "70-805",
    city: "Szczecin",
  },
  {
    code: "70-806",
    city: "Szczecin",
  },
  {
    code: "70-807",
    city: "Szczecin",
  },
  {
    code: "70-809",
    city: "Szczecin",
  },
  {
    code: "70-810",
    city: "Szczecin",
  },
  {
    code: "70-811",
    city: "Szczecin",
  },
  {
    code: "70-812",
    city: "Szczecin",
  },
  {
    code: "70-813",
    city: "Szczecin",
  },
  {
    code: "70-814",
    city: "Szczecin",
  },
  {
    code: "70-815",
    city: "Szczecin",
  },
  {
    code: "70-819",
    city: "Szczecin",
  },
  {
    code: "70-820",
    city: "Szczecin",
  },
  {
    code: "70-821",
    city: "Szczecin",
  },
  {
    code: "70-822",
    city: "Szczecin",
  },
  {
    code: "70-823",
    city: "Szczecin",
  },
  {
    code: "70-824",
    city: "Szczecin",
  },
  {
    code: "70-825",
    city: "Szczecin",
  },
  {
    code: "70-826",
    city: "Szczecin",
  },
  {
    code: "70-827",
    city: "Szczecin",
  },
  {
    code: "70-830",
    city: "Szczecin",
  },
  {
    code: "70-831",
    city: "Szczecin",
  },
  {
    code: "70-832",
    city: "Szczecin",
  },
  {
    code: "70-833",
    city: "Szczecin",
  },
  {
    code: "70-834",
    city: "Szczecin",
  },
  {
    code: "70-835",
    city: "Szczecin",
  },
  {
    code: "70-836",
    city: "Szczecin",
  },
  {
    code: "70-837",
    city: "Szczecin",
  },
  {
    code: "70-839",
    city: "Szczecin",
  },
  {
    code: "70-840",
    city: "Szczecin",
  },
  {
    code: "70-841",
    city: "Szczecin",
  },
  {
    code: "70-842",
    city: "Szczecin",
  },
  {
    code: "70-843",
    city: "Szczecin",
  },
  {
    code: "70-844",
    city: "Szczecin",
  },
  {
    code: "70-845",
    city: "Szczecin",
  },
  {
    code: "70-846",
    city: "Szczecin",
  },
  {
    code: "70-847",
    city: "Szczecin",
  },
  {
    code: "70-848",
    city: "Szczecin",
  },
  {
    code: "70-850",
    city: "Szczecin",
  },
  {
    code: "70-851",
    city: "Szczecin",
  },
  {
    code: "70-852",
    city: "Szczecin",
  },
  {
    code: "70-853",
    city: "Szczecin",
  },
  {
    code: "70-854",
    city: "Szczecin",
  },
  {
    code: "70-855",
    city: "Szczecin",
  },
  {
    code: "70-856",
    city: "Szczecin",
  },
  {
    code: "70-857",
    city: "Szczecin",
  },
  {
    code: "70-862",
    city: "Szczecin",
  },
  {
    code: "70-864",
    city: "Szczecin",
  },
  {
    code: "70-870",
    city: "Szczecin",
  },
  {
    code: "70-871",
    city: "Szczecin",
  },
  {
    code: "70-872",
    city: "Szczecin",
  },
  {
    code: "70-873",
    city: "Szczecin",
  },
  {
    code: "70-874",
    city: "Szczecin",
  },
  {
    code: "70-875",
    city: "Szczecin",
  },
  {
    code: "70-876",
    city: "Szczecin",
  },
  {
    code: "70-877",
    city: "Szczecin",
  },
  {
    code: "70-878",
    city: "Szczecin",
  },
  {
    code: "70-879",
    city: "Szczecin",
  },
  {
    code: "70-880",
    city: "Szczecin",
  },
  {
    code: "70-881",
    city: "Szczecin",
  },
  {
    code: "70-882",
    city: "Szczecin",
  },
  {
    code: "70-883",
    city: "Szczecin",
  },
  {
    code: "70-884",
    city: "Szczecin",
  },
  {
    code: "70-885",
    city: "Szczecin",
  },
  {
    code: "70-886",
    city: "Szczecin",
  },
  {
    code: "70-887",
    city: "Szczecin",
  },
  {
    code: "70-888",
    city: "Szczecin",
  },
  {
    code: "70-889",
    city: "Szczecin",
  },
  {
    code: "70-890",
    city: "Szczecin",
  },
  {
    code: "70-891",
    city: "Szczecin",
  },
  {
    code: "70-892",
    city: "Szczecin",
  },
  {
    code: "70-893",
    city: "Szczecin",
  },
  {
    code: "70-894",
    city: "Szczecin",
  },
  {
    code: "70-895",
    city: "Szczecin",
  },
  {
    code: "70-896",
    city: "Szczecin",
  },
  {
    code: "70-904",
    city: "Szczecin",
  },
  {
    code: "70-907",
    city: "Szczecin",
  },
  {
    code: "70-940",
    city: "Szczecin",
  },
  {
    code: "70-950",
    city: "Szczecin",
  },
  {
    code: "70-953",
    city: "Szczecin",
  },
  {
    code: "71-001",
    city: "Szczecin",
  },
  {
    code: "71-002",
    city: "Szczecin",
  },
  {
    code: "71-003",
    city: "Szczecin",
  },
  {
    code: "71-004",
    city: "Szczecin",
  },
  {
    code: "71-005",
    city: "Szczecin",
  },
  {
    code: "71-006",
    city: "Szczecin",
  },
  {
    code: "71-007",
    city: "Szczecin",
  },
  {
    code: "71-008",
    city: "Szczecin",
  },
  {
    code: "71-009",
    city: "Szczecin",
  },
  {
    code: "71-010",
    city: "Szczecin",
  },
  {
    code: "71-011",
    city: "Szczecin",
  },
  {
    code: "71-012",
    city: "Szczecin",
  },
  {
    code: "71-013",
    city: "Szczecin",
  },
  {
    code: "71-014",
    city: "Szczecin",
  },
  {
    code: "71-015",
    city: "Szczecin",
  },
  {
    code: "71-016",
    city: "Szczecin",
  },
  {
    code: "71-017",
    city: "Szczecin",
  },
  {
    code: "71-018",
    city: "Szczecin",
  },
  {
    code: "71-019",
    city: "Szczecin",
  },
  {
    code: "71-020",
    city: "Szczecin",
  },
  {
    code: "71-021",
    city: "Szczecin",
  },
  {
    code: "71-022",
    city: "Szczecin",
  },
  {
    code: "71-023",
    city: "Szczecin",
  },
  {
    code: "71-024",
    city: "Szczecin",
  },
  {
    code: "71-025",
    city: "Szczecin",
  },
  {
    code: "71-026",
    city: "Szczecin",
  },
  {
    code: "71-027",
    city: "Szczecin",
  },
  {
    code: "71-030",
    city: "Szczecin",
  },
  {
    code: "71-031",
    city: "Szczecin",
  },
  {
    code: "71-032",
    city: "Szczecin",
  },
  {
    code: "71-033",
    city: "Szczecin",
  },
  {
    code: "71-034",
    city: "Szczecin",
  },
  {
    code: "71-035",
    city: "Szczecin",
  },
  {
    code: "71-036",
    city: "Szczecin",
  },
  {
    code: "71-037",
    city: "Szczecin",
  },
  {
    code: "71-040",
    city: "Szczecin",
  },
  {
    code: "71-041",
    city: "Szczecin",
  },
  {
    code: "71-042",
    city: "Szczecin",
  },
  {
    code: "71-043",
    city: "Szczecin",
  },
  {
    code: "71-044",
    city: "Szczecin",
  },
  {
    code: "71-045",
    city: "Szczecin",
  },
  {
    code: "71-046",
    city: "Szczecin",
  },
  {
    code: "71-047",
    city: "Szczecin",
  },
  {
    code: "71-050",
    city: "Szczecin",
  },
  {
    code: "71-051",
    city: "Szczecin",
  },
  {
    code: "71-052",
    city: "Szczecin",
  },
  {
    code: "71-060",
    city: "Szczecin",
  },
  {
    code: "71-061",
    city: "Szczecin",
  },
  {
    code: "71-062",
    city: "Szczecin",
  },
  {
    code: "71-063",
    city: "Szczecin",
  },
  {
    code: "71-064",
    city: "Szczecin",
  },
  {
    code: "71-065",
    city: "Szczecin",
  },
  {
    code: "71-066",
    city: "Szczecin",
  },
  {
    code: "71-069",
    city: "Szczecin",
  },
  {
    code: "71-070",
    city: "Szczecin",
  },
  {
    code: "71-071",
    city: "Szczecin",
  },
  {
    code: "71-072",
    city: "Szczecin",
  },
  {
    code: "71-073",
    city: "Szczecin",
  },
  {
    code: "71-075",
    city: "Szczecin",
  },
  {
    code: "71-076",
    city: "Szczecin",
  },
  {
    code: "71-078",
    city: "Szczecin",
  },
  {
    code: "71-080",
    city: "Szczecin",
  },
  {
    code: "71-081",
    city: "Szczecin",
  },
  {
    code: "71-082",
    city: "Szczecin",
  },
  {
    code: "71-083",
    city: "Szczecin",
  },
  {
    code: "71-084",
    city: "Szczecin",
  },
  {
    code: "71-085",
    city: "Szczecin",
  },
  {
    code: "71-086",
    city: "Szczecin",
  },
  {
    code: "71-100",
    city: "Szczecin",
  },
  {
    code: "71-101",
    city: "Szczecin",
  },
  {
    code: "71-102",
    city: "Szczecin",
  },
  {
    code: "71-103",
    city: "Szczecin",
  },
  {
    code: "71-104",
    city: "Szczecin",
  },
  {
    code: "71-105",
    city: "Szczecin",
  },
  {
    code: "71-106",
    city: "Szczecin",
  },
  {
    code: "71-107",
    city: "Szczecin",
  },
  {
    code: "71-110",
    city: "Szczecin",
  },
  {
    code: "71-111",
    city: "Szczecin",
  },
  {
    code: "71-112",
    city: "Szczecin",
  },
  {
    code: "71-113",
    city: "Szczecin",
  },
  {
    code: "71-114",
    city: "Szczecin",
  },
  {
    code: "71-115",
    city: "Szczecin",
  },
  {
    code: "71-116",
    city: "Szczecin",
  },
  {
    code: "71-117",
    city: "Szczecin",
  },
  {
    code: "71-118",
    city: "Szczecin",
  },
  {
    code: "71-119",
    city: "Szczecin",
  },
  {
    code: "71-120",
    city: "Szczecin",
  },
  {
    code: "71-121",
    city: "Szczecin",
  },
  {
    code: "71-122",
    city: "Szczecin",
  },
  {
    code: "71-123",
    city: "Szczecin",
  },
  {
    code: "71-124",
    city: "Szczecin",
  },
  {
    code: "71-125",
    city: "Szczecin",
  },
  {
    code: "71-126",
    city: "Szczecin",
  },
  {
    code: "71-129",
    city: "Szczecin",
  },
  {
    code: "71-130",
    city: "Szczecin",
  },
  {
    code: "71-131",
    city: "Szczecin",
  },
  {
    code: "71-132",
    city: "Szczecin",
  },
  {
    code: "71-133",
    city: "Szczecin",
  },
  {
    code: "71-134",
    city: "Szczecin",
  },
  {
    code: "71-135",
    city: "Szczecin",
  },
  {
    code: "71-136",
    city: "Szczecin",
  },
  {
    code: "71-137",
    city: "Szczecin",
  },
  {
    code: "71-138",
    city: "Szczecin",
  },
  {
    code: "71-140",
    city: "Szczecin",
  },
  {
    code: "71-141",
    city: "Szczecin",
  },
  {
    code: "71-142",
    city: "Szczecin",
  },
  {
    code: "71-143",
    city: "Szczecin",
  },
  {
    code: "71-144",
    city: "Szczecin",
  },
  {
    code: "71-145",
    city: "Szczecin",
  },
  {
    code: "71-146",
    city: "Szczecin",
  },
  {
    code: "71-147",
    city: "Szczecin",
  },
  {
    code: "71-148",
    city: "Szczecin",
  },
  {
    code: "71-149",
    city: "Szczecin",
  },
  {
    code: "71-150",
    city: "Szczecin",
  },
  {
    code: "71-151",
    city: "Szczecin",
  },
  {
    code: "71-152",
    city: "Szczecin",
  },
  {
    code: "71-153",
    city: "Szczecin",
  },
  {
    code: "71-154",
    city: "Szczecin",
  },
  {
    code: "71-155",
    city: "Szczecin",
  },
  {
    code: "71-156",
    city: "Szczecin",
  },
  {
    code: "71-157",
    city: "Szczecin",
  },
  {
    code: "71-160",
    city: "Szczecin",
  },
  {
    code: "71-161",
    city: "Szczecin",
  },
  {
    code: "71-162",
    city: "Szczecin",
  },
  {
    code: "71-163",
    city: "Szczecin",
  },
  {
    code: "71-165",
    city: "Szczecin",
  },
  {
    code: "71-170",
    city: "Szczecin",
  },
  {
    code: "71-171",
    city: "Szczecin",
  },
  {
    code: "71-172",
    city: "Szczecin",
  },
  {
    code: "71-173",
    city: "Szczecin",
  },
  {
    code: "71-174",
    city: "Szczecin",
  },
  {
    code: "71-175",
    city: "Szczecin",
  },
  {
    code: "71-176",
    city: "Szczecin",
  },
  {
    code: "71-177",
    city: "Szczecin",
  },
  {
    code: "71-179",
    city: "Szczecin",
  },
  {
    code: "71-180",
    city: "Szczecin",
  },
  {
    code: "71-181",
    city: "Szczecin",
  },
  {
    code: "71-200",
    city: "Szczecin",
  },
  {
    code: "71-201",
    city: "Szczecin",
  },
  {
    code: "71-202",
    city: "Szczecin",
  },
  {
    code: "71-203",
    city: "Szczecin",
  },
  {
    code: "71-204",
    city: "Szczecin",
  },
  {
    code: "71-205",
    city: "Szczecin",
  },
  {
    code: "71-206",
    city: "Szczecin",
  },
  {
    code: "71-207",
    city: "Szczecin",
  },
  {
    code: "71-210",
    city: "Szczecin",
  },
  {
    code: "71-211",
    city: "Szczecin",
  },
  {
    code: "71-212",
    city: "Szczecin",
  },
  {
    code: "71-213",
    city: "Szczecin",
  },
  {
    code: "71-214",
    city: "Szczecin",
  },
  {
    code: "71-215",
    city: "Szczecin",
  },
  {
    code: "71-216",
    city: "Szczecin",
  },
  {
    code: "71-217",
    city: "Szczecin",
  },
  {
    code: "71-218",
    city: "Szczecin",
  },
  {
    code: "71-219",
    city: "Szczecin",
  },
  {
    code: "71-220",
    city: "Szczecin",
  },
  {
    code: "71-221",
    city: "Szczecin",
  },
  {
    code: "71-222",
    city: "Szczecin",
  },
  {
    code: "71-223",
    city: "Szczecin",
  },
  {
    code: "71-224",
    city: "Szczecin",
  },
  {
    code: "71-225",
    city: "Szczecin",
  },
  {
    code: "71-226",
    city: "Szczecin",
  },
  {
    code: "71-227",
    city: "Szczecin",
  },
  {
    code: "71-228",
    city: "Szczecin",
  },
  {
    code: "71-229",
    city: "Szczecin",
  },
  {
    code: "71-230",
    city: "Szczecin",
  },
  {
    code: "71-231",
    city: "Szczecin",
  },
  {
    code: "71-232",
    city: "Szczecin",
  },
  {
    code: "71-233",
    city: "Szczecin",
  },
  {
    code: "71-234",
    city: "Szczecin",
  },
  {
    code: "71-235",
    city: "Szczecin",
  },
  {
    code: "71-236",
    city: "Szczecin",
  },
  {
    code: "71-237",
    city: "Szczecin",
  },
  {
    code: "71-238",
    city: "Szczecin",
  },
  {
    code: "71-240",
    city: "Szczecin",
  },
  {
    code: "71-241",
    city: "Szczecin",
  },
  {
    code: "71-242",
    city: "Szczecin",
  },
  {
    code: "71-244",
    city: "Szczecin",
  },
  {
    code: "71-245",
    city: "Szczecin",
  },
  {
    code: "71-246",
    city: "Szczecin",
  },
  {
    code: "71-247",
    city: "Szczecin",
  },
  {
    code: "71-248",
    city: "Szczecin",
  },
  {
    code: "71-249",
    city: "Szczecin",
  },
  {
    code: "71-250",
    city: "Szczecin",
  },
  {
    code: "71-251",
    city: "Szczecin",
  },
  {
    code: "71-252",
    city: "Szczecin",
  },
  {
    code: "71-253",
    city: "Szczecin",
  },
  {
    code: "71-254",
    city: "Szczecin",
  },
  {
    code: "71-255",
    city: "Szczecin",
  },
  {
    code: "71-256",
    city: "Szczecin",
  },
  {
    code: "71-260",
    city: "Szczecin",
  },
  {
    code: "71-261",
    city: "Szczecin",
  },
  {
    code: "71-262",
    city: "Szczecin",
  },
  {
    code: "71-263",
    city: "Szczecin",
  },
  {
    code: "71-264",
    city: "Szczecin",
  },
  {
    code: "71-265",
    city: "Szczecin",
  },
  {
    code: "71-266",
    city: "Szczecin",
  },
  {
    code: "71-270",
    city: "Szczecin",
  },
  {
    code: "71-271",
    city: "Szczecin",
  },
  {
    code: "71-272",
    city: "Szczecin",
  },
  {
    code: "71-273",
    city: "Szczecin",
  },
  {
    code: "71-274",
    city: "Szczecin",
  },
  {
    code: "71-275",
    city: "Szczecin",
  },
  {
    code: "71-276",
    city: "Szczecin",
  },
  {
    code: "71-277",
    city: "Szczecin",
  },
  {
    code: "71-278",
    city: "Szczecin",
  },
  {
    code: "71-279",
    city: "Szczecin",
  },
  {
    code: "71-280",
    city: "Szczecin",
  },
  {
    code: "71-281",
    city: "Szczecin",
  },
  {
    code: "71-294",
    city: "Szczecin",
  },
  {
    code: "71-295",
    city: "Szczecin",
  },
  {
    code: "71-296",
    city: "Szczecin",
  },
  {
    code: "71-297",
    city: "Szczecin",
  },
  {
    code: "71-298",
    city: "Szczecin",
  },
  {
    code: "71-299",
    city: "Szczecin",
  },
  {
    code: "71-300",
    city: "Szczecin",
  },
  {
    code: "71-301",
    city: "Szczecin",
  },
  {
    code: "71-302",
    city: "Szczecin",
  },
  {
    code: "71-303",
    city: "Szczecin",
  },
  {
    code: "71-304",
    city: "Szczecin",
  },
  {
    code: "71-305",
    city: "Szczecin",
  },
  {
    code: "71-306",
    city: "Szczecin",
  },
  {
    code: "71-307",
    city: "Szczecin",
  },
  {
    code: "71-310",
    city: "Szczecin",
  },
  {
    code: "71-311",
    city: "Szczecin",
  },
  {
    code: "71-312",
    city: "Szczecin",
  },
  {
    code: "71-313",
    city: "Szczecin",
  },
  {
    code: "71-314",
    city: "Szczecin",
  },
  {
    code: "71-315",
    city: "Szczecin",
  },
  {
    code: "71-316",
    city: "Szczecin",
  },
  {
    code: "71-317",
    city: "Szczecin",
  },
  {
    code: "71-320",
    city: "Szczecin",
  },
  {
    code: "71-321",
    city: "Szczecin",
  },
  {
    code: "71-322",
    city: "Szczecin",
  },
  {
    code: "71-323",
    city: "Szczecin",
  },
  {
    code: "71-324",
    city: "Szczecin",
  },
  {
    code: "71-325",
    city: "Szczecin",
  },
  {
    code: "71-326",
    city: "Szczecin",
  },
  {
    code: "71-327",
    city: "Szczecin",
  },
  {
    code: "71-330",
    city: "Szczecin",
  },
  {
    code: "71-331",
    city: "Szczecin",
  },
  {
    code: "71-332",
    city: "Szczecin",
  },
  {
    code: "71-333",
    city: "Szczecin",
  },
  {
    code: "71-334",
    city: "Szczecin",
  },
  {
    code: "71-335",
    city: "Szczecin",
  },
  {
    code: "71-336",
    city: "Szczecin",
  },
  {
    code: "71-337",
    city: "Szczecin",
  },
  {
    code: "71-340",
    city: "Szczecin",
  },
  {
    code: "71-341",
    city: "Szczecin",
  },
  {
    code: "71-342",
    city: "Szczecin",
  },
  {
    code: "71-343",
    city: "Szczecin",
  },
  {
    code: "71-344",
    city: "Szczecin",
  },
  {
    code: "71-345",
    city: "Szczecin",
  },
  {
    code: "71-346",
    city: "Szczecin",
  },
  {
    code: "71-370",
    city: "Szczecin",
  },
  {
    code: "71-371",
    city: "Szczecin",
  },
  {
    code: "71-372",
    city: "Szczecin",
  },
  {
    code: "71-373",
    city: "Szczecin",
  },
  {
    code: "71-374",
    city: "Szczecin",
  },
  {
    code: "71-375",
    city: "Szczecin",
  },
  {
    code: "71-376",
    city: "Szczecin",
  },
  {
    code: "71-377",
    city: "Szczecin",
  },
  {
    code: "71-378",
    city: "Szczecin",
  },
  {
    code: "71-380",
    city: "Szczecin",
  },
  {
    code: "71-381",
    city: "Szczecin",
  },
  {
    code: "71-382",
    city: "Szczecin",
  },
  {
    code: "71-386",
    city: "Szczecin",
  },
  {
    code: "71-387",
    city: "Szczecin",
  },
  {
    code: "71-390",
    city: "Szczecin",
  },
  {
    code: "71-391",
    city: "Szczecin",
  },
  {
    code: "71-392",
    city: "Szczecin",
  },
  {
    code: "71-393",
    city: "Szczecin",
  },
  {
    code: "71-400",
    city: "Szczecin",
  },
  {
    code: "71-401",
    city: "Szczecin",
  },
  {
    code: "71-402",
    city: "Szczecin",
  },
  {
    code: "71-403",
    city: "Szczecin",
  },
  {
    code: "71-404",
    city: "Szczecin",
  },
  {
    code: "71-405",
    city: "Szczecin",
  },
  {
    code: "71-407",
    city: "Szczecin",
  },
  {
    code: "71-410",
    city: "Szczecin",
  },
  {
    code: "71-411",
    city: "Szczecin",
  },
  {
    code: "71-412",
    city: "Szczecin",
  },
  {
    code: "71-413",
    city: "Szczecin",
  },
  {
    code: "71-414",
    city: "Szczecin",
  },
  {
    code: "71-415",
    city: "Szczecin",
  },
  {
    code: "71-416",
    city: "Szczecin",
  },
  {
    code: "71-417",
    city: "Szczecin",
  },
  {
    code: "71-420",
    city: "Szczecin",
  },
  {
    code: "71-421",
    city: "Szczecin",
  },
  {
    code: "71-422",
    city: "Szczecin",
  },
  {
    code: "71-423",
    city: "Szczecin",
  },
  {
    code: "71-424",
    city: "Szczecin",
  },
  {
    code: "71-425",
    city: "Szczecin",
  },
  {
    code: "71-426",
    city: "Szczecin",
  },
  {
    code: "71-427",
    city: "Szczecin",
  },
  {
    code: "71-430",
    city: "Szczecin",
  },
  {
    code: "71-431",
    city: "Szczecin",
  },
  {
    code: "71-432",
    city: "Szczecin",
  },
  {
    code: "71-433",
    city: "Szczecin",
  },
  {
    code: "71-434",
    city: "Szczecin",
  },
  {
    code: "71-435",
    city: "Szczecin",
  },
  {
    code: "71-436",
    city: "Szczecin",
  },
  {
    code: "71-437",
    city: "Szczecin",
  },
  {
    code: "71-438",
    city: "Szczecin",
  },
  {
    code: "71-440",
    city: "Szczecin",
  },
  {
    code: "71-441",
    city: "Szczecin",
  },
  {
    code: "71-443",
    city: "Szczecin",
  },
  {
    code: "71-444",
    city: "Szczecin",
  },
  {
    code: "71-445",
    city: "Szczecin",
  },
  {
    code: "71-446",
    city: "Szczecin",
  },
  {
    code: "71-447",
    city: "Szczecin",
  },
  {
    code: "71-449",
    city: "Szczecin",
  },
  {
    code: "71-450",
    city: "Szczecin",
  },
  {
    code: "71-451",
    city: "Szczecin",
  },
  {
    code: "71-452",
    city: "Szczecin",
  },
  {
    code: "71-453",
    city: "Szczecin",
  },
  {
    code: "71-454",
    city: "Szczecin",
  },
  {
    code: "71-455",
    city: "Szczecin",
  },
  {
    code: "71-457",
    city: "Szczecin",
  },
  {
    code: "71-459",
    city: "Szczecin",
  },
  {
    code: "71-460",
    city: "Szczecin",
  },
  {
    code: "71-461",
    city: "Szczecin",
  },
  {
    code: "71-462",
    city: "Szczecin",
  },
  {
    code: "71-463",
    city: "Szczecin",
  },
  {
    code: "71-464",
    city: "Szczecin",
  },
  {
    code: "71-465",
    city: "Szczecin",
  },
  {
    code: "71-466",
    city: "Szczecin",
  },
  {
    code: "71-467",
    city: "Szczecin",
  },
  {
    code: "71-468",
    city: "Szczecin",
  },
  {
    code: "71-470",
    city: "Szczecin",
  },
  {
    code: "71-471",
    city: "Szczecin",
  },
  {
    code: "71-472",
    city: "Szczecin",
  },
  {
    code: "71-474",
    city: "Szczecin",
  },
  {
    code: "71-475",
    city: "Szczecin",
  },
  {
    code: "71-476",
    city: "Szczecin",
  },
  {
    code: "71-477",
    city: "Szczecin",
  },
  {
    code: "71-478",
    city: "Szczecin",
  },
  {
    code: "71-480",
    city: "Szczecin",
  },
  {
    code: "71-481",
    city: "Szczecin",
  },
  {
    code: "71-482",
    city: "Szczecin",
  },
  {
    code: "71-483",
    city: "Szczecin",
  },
  {
    code: "71-484",
    city: "Szczecin",
  },
  {
    code: "71-486",
    city: "Szczecin",
  },
  {
    code: "71-487",
    city: "Szczecin",
  },
  {
    code: "71-490",
    city: "Szczecin",
  },
  {
    code: "71-491",
    city: "Szczecin",
  },
  {
    code: "71-492",
    city: "Szczecin",
  },
  {
    code: "71-493",
    city: "Szczecin",
  },
  {
    code: "71-494",
    city: "Szczecin",
  },
  {
    code: "71-495",
    city: "Szczecin",
  },
  {
    code: "71-496",
    city: "Szczecin",
  },
  {
    code: "71-497",
    city: "Szczecin",
  },
  {
    code: "71-498",
    city: "Szczecin",
  },
  {
    code: "71-499",
    city: "Szczecin",
  },
  {
    code: "71-500",
    city: "Szczecin",
  },
  {
    code: "71-501",
    city: "Szczecin",
  },
  {
    code: "71-502",
    city: "Szczecin",
  },
  {
    code: "71-503",
    city: "Szczecin",
  },
  {
    code: "71-504",
    city: "Szczecin",
  },
  {
    code: "71-505",
    city: "Szczecin",
  },
  {
    code: "71-506",
    city: "Szczecin",
  },
  {
    code: "71-507",
    city: "Szczecin",
  },
  {
    code: "71-515",
    city: "Szczecin",
  },
  {
    code: "71-516",
    city: "Szczecin",
  },
  {
    code: "71-520",
    city: "Szczecin",
  },
  {
    code: "71-521",
    city: "Szczecin",
  },
  {
    code: "71-522",
    city: "Szczecin",
  },
  {
    code: "71-524",
    city: "Szczecin",
  },
  {
    code: "71-525",
    city: "Szczecin",
  },
  {
    code: "71-526",
    city: "Szczecin",
  },
  {
    code: "71-527",
    city: "Szczecin",
  },
  {
    code: "71-528",
    city: "Szczecin",
  },
  {
    code: "71-530",
    city: "Szczecin",
  },
  {
    code: "71-531",
    city: "Szczecin",
  },
  {
    code: "71-532",
    city: "Szczecin",
  },
  {
    code: "71-533",
    city: "Szczecin",
  },
  {
    code: "71-534",
    city: "Szczecin",
  },
  {
    code: "71-535",
    city: "Szczecin",
  },
  {
    code: "71-537",
    city: "Szczecin",
  },
  {
    code: "71-540",
    city: "Szczecin",
  },
  {
    code: "71-541",
    city: "Szczecin",
  },
  {
    code: "71-543",
    city: "Szczecin",
  },
  {
    code: "71-544",
    city: "Szczecin",
  },
  {
    code: "71-545",
    city: "Szczecin",
  },
  {
    code: "71-547",
    city: "Szczecin",
  },
  {
    code: "71-550",
    city: "Szczecin",
  },
  {
    code: "71-551",
    city: "Szczecin",
  },
  {
    code: "71-552",
    city: "Szczecin",
  },
  {
    code: "71-553",
    city: "Szczecin",
  },
  {
    code: "71-554",
    city: "Szczecin",
  },
  {
    code: "71-555",
    city: "Szczecin",
  },
  {
    code: "71-556",
    city: "Szczecin",
  },
  {
    code: "71-557",
    city: "Szczecin",
  },
  {
    code: "71-560",
    city: "Szczecin",
  },
  {
    code: "71-561",
    city: "Szczecin",
  },
  {
    code: "71-562",
    city: "Szczecin",
  },
  {
    code: "71-563",
    city: "Szczecin",
  },
  {
    code: "71-564",
    city: "Szczecin",
  },
  {
    code: "71-565",
    city: "Szczecin",
  },
  {
    code: "71-600",
    city: "Szczecin",
  },
  {
    code: "71-601",
    city: "Szczecin",
  },
  {
    code: "71-602",
    city: "Szczecin",
  },
  {
    code: "71-603",
    city: "Szczecin",
  },
  {
    code: "71-604",
    city: "Szczecin",
  },
  {
    code: "71-605",
    city: "Szczecin",
  },
  {
    code: "71-606",
    city: "Szczecin",
  },
  {
    code: "71-607",
    city: "Szczecin",
  },
  {
    code: "71-610",
    city: "Szczecin",
  },
  {
    code: "71-611",
    city: "Szczecin",
  },
  {
    code: "71-612",
    city: "Szczecin",
  },
  {
    code: "71-614",
    city: "Szczecin",
  },
  {
    code: "71-615",
    city: "Szczecin",
  },
  {
    code: "71-616",
    city: "Szczecin",
  },
  {
    code: "71-617",
    city: "Szczecin",
  },
  {
    code: "71-620",
    city: "Szczecin",
  },
  {
    code: "71-621",
    city: "Szczecin",
  },
  {
    code: "71-622",
    city: "Szczecin",
  },
  {
    code: "71-623",
    city: "Szczecin",
  },
  {
    code: "71-625",
    city: "Szczecin",
  },
  {
    code: "71-626",
    city: "Szczecin",
  },
  {
    code: "71-627",
    city: "Szczecin",
  },
  {
    code: "71-629",
    city: "Szczecin",
  },
  {
    code: "71-630",
    city: "Szczecin",
  },
  {
    code: "71-631",
    city: "Szczecin",
  },
  {
    code: "71-632",
    city: "Szczecin",
  },
  {
    code: "71-634",
    city: "Szczecin",
  },
  {
    code: "71-635",
    city: "Szczecin",
  },
  {
    code: "71-636",
    city: "Szczecin",
  },
  {
    code: "71-637",
    city: "Szczecin",
  },
  {
    code: "71-641",
    city: "Szczecin",
  },
  {
    code: "71-642",
    city: "Szczecin",
  },
  {
    code: "71-643",
    city: "Szczecin",
  },
  {
    code: "71-644",
    city: "Szczecin",
  },
  {
    code: "71-645",
    city: "Szczecin",
  },
  {
    code: "71-646",
    city: "Szczecin",
  },
  {
    code: "71-647",
    city: "Szczecin",
  },
  {
    code: "71-650",
    city: "Szczecin",
  },
  {
    code: "71-652",
    city: "Szczecin",
  },
  {
    code: "71-653",
    city: "Szczecin",
  },
  {
    code: "71-656",
    city: "Szczecin",
  },
  {
    code: "71-657",
    city: "Szczecin",
  },
  {
    code: "71-660",
    city: "Szczecin",
  },
  {
    code: "71-661",
    city: "Szczecin",
  },
  {
    code: "71-662",
    city: "Szczecin",
  },
  {
    code: "71-663",
    city: "Szczecin",
  },
  {
    code: "71-664",
    city: "Szczecin",
  },
  {
    code: "71-665",
    city: "Szczecin",
  },
  {
    code: "71-666",
    city: "Szczecin",
  },
  {
    code: "71-667",
    city: "Szczecin",
  },
  {
    code: "71-668",
    city: "Szczecin",
  },
  {
    code: "71-669",
    city: "Szczecin",
  },
  {
    code: "71-670",
    city: "Szczecin",
  },
  {
    code: "71-671",
    city: "Szczecin",
  },
  {
    code: "71-672",
    city: "Szczecin",
  },
  {
    code: "71-673",
    city: "Szczecin",
  },
  {
    code: "71-674",
    city: "Szczecin",
  },
  {
    code: "71-675",
    city: "Szczecin",
  },
  {
    code: "71-676",
    city: "Szczecin",
  },
  {
    code: "71-677",
    city: "Szczecin",
  },
  {
    code: "71-680",
    city: "Szczecin",
  },
  {
    code: "71-681",
    city: "Szczecin",
  },
  {
    code: "71-682",
    city: "Szczecin",
  },
  {
    code: "71-683",
    city: "Szczecin",
  },
  {
    code: "71-684",
    city: "Szczecin",
  },
  {
    code: "71-685",
    city: "Szczecin",
  },
  {
    code: "71-687",
    city: "Szczecin",
  },
  {
    code: "71-688",
    city: "Szczecin",
  },
  {
    code: "71-690",
    city: "Szczecin",
  },
  {
    code: "71-691",
    city: "Szczecin",
  },
  {
    code: "71-692",
    city: "Szczecin",
  },
  {
    code: "71-693",
    city: "Szczecin",
  },
  {
    code: "71-694",
    city: "Szczecin",
  },
  {
    code: "71-695",
    city: "Szczecin",
  },
  {
    code: "71-696",
    city: "Szczecin",
  },
  {
    code: "71-697",
    city: "Szczecin",
  },
  {
    code: "71-698",
    city: "Szczecin",
  },
  {
    code: "71-699",
    city: "Szczecin",
  },
  {
    code: "71-700",
    city: "Szczecin",
  },
  {
    code: "71-702",
    city: "Szczecin",
  },
  {
    code: "71-703",
    city: "Szczecin",
  },
  {
    code: "71-704",
    city: "Szczecin",
  },
  {
    code: "71-705",
    city: "Szczecin",
  },
  {
    code: "71-706",
    city: "Szczecin",
  },
  {
    code: "71-707",
    city: "Szczecin",
  },
  {
    code: "71-710",
    city: "Szczecin",
  },
  {
    code: "71-711",
    city: "Szczecin",
  },
  {
    code: "71-712",
    city: "Szczecin",
  },
  {
    code: "71-713",
    city: "Szczecin",
  },
  {
    code: "71-714",
    city: "Szczecin",
  },
  {
    code: "71-715",
    city: "Szczecin",
  },
  {
    code: "71-716",
    city: "Szczecin",
  },
  {
    code: "71-717",
    city: "Szczecin",
  },
  {
    code: "71-718",
    city: "Szczecin",
  },
  {
    code: "71-720",
    city: "Szczecin",
  },
  {
    code: "71-721",
    city: "Szczecin",
  },
  {
    code: "71-722",
    city: "Szczecin",
  },
  {
    code: "71-723",
    city: "Szczecin",
  },
  {
    code: "71-724",
    city: "Szczecin",
  },
  {
    code: "71-725",
    city: "Szczecin",
  },
  {
    code: "71-726",
    city: "Szczecin",
  },
  {
    code: "71-727",
    city: "Szczecin",
  },
  {
    code: "71-728",
    city: "Szczecin",
  },
  {
    code: "71-730",
    city: "Szczecin",
  },
  {
    code: "71-731",
    city: "Szczecin",
  },
  {
    code: "71-732",
    city: "Szczecin",
  },
  {
    code: "71-733",
    city: "Szczecin",
  },
  {
    code: "71-734",
    city: "Szczecin",
  },
  {
    code: "71-735",
    city: "Szczecin",
  },
  {
    code: "71-736",
    city: "Szczecin",
  },
  {
    code: "71-737",
    city: "Szczecin",
  },
  {
    code: "71-738",
    city: "Szczecin",
  },
  {
    code: "71-739",
    city: "Szczecin",
  },
  {
    code: "71-740",
    city: "Szczecin",
  },
  {
    code: "71-741",
    city: "Szczecin",
  },
  {
    code: "71-742",
    city: "Szczecin",
  },
  {
    code: "71-743",
    city: "Szczecin",
  },
  {
    code: "71-744",
    city: "Szczecin",
  },
  {
    code: "71-745",
    city: "Szczecin",
  },
  {
    code: "71-746",
    city: "Szczecin",
  },
  {
    code: "71-747",
    city: "Szczecin",
  },
  {
    code: "71-748",
    city: "Szczecin",
  },
  {
    code: "71-750",
    city: "Szczecin",
  },
  {
    code: "71-751",
    city: "Szczecin",
  },
  {
    code: "71-752",
    city: "Szczecin",
  },
  {
    code: "71-753",
    city: "Szczecin",
  },
  {
    code: "71-754",
    city: "Szczecin",
  },
  {
    code: "71-755",
    city: "Szczecin",
  },
  {
    code: "71-756",
    city: "Szczecin",
  },
  {
    code: "71-757",
    city: "Szczecin",
  },
  {
    code: "71-758",
    city: "Szczecin",
  },
  {
    code: "71-767",
    city: "Szczecin",
  },
  {
    code: "71-768",
    city: "Szczecin",
  },
  {
    code: "71-769",
    city: "Szczecin",
  },
  {
    code: "71-770",
    city: "Szczecin",
  },
  {
    code: "71-771",
    city: "Szczecin",
  },
  {
    code: "71-772",
    city: "Szczecin",
  },
  {
    code: "71-773",
    city: "Szczecin",
  },
  {
    code: "71-774",
    city: "Szczecin",
  },
  {
    code: "71-775",
    city: "Szczecin",
  },
  {
    code: "71-776",
    city: "Szczecin",
  },
  {
    code: "71-777",
    city: "Szczecin",
  },
  {
    code: "71-778",
    city: "Szczecin",
  },
  {
    code: "71-779",
    city: "Szczecin",
  },
  {
    code: "71-780",
    city: "Szczecin",
  },
  {
    code: "71-781",
    city: "Szczecin",
  },
  {
    code: "71-782",
    city: "Szczecin",
  },
  {
    code: "71-783",
    city: "Szczecin",
  },
  {
    code: "71-784",
    city: "Szczecin",
  },
  {
    code: "71-785",
    city: "Szczecin",
  },
  {
    code: "71-786",
    city: "Szczecin",
  },
  {
    code: "71-787",
    city: "Szczecin",
  },
  {
    code: "71-788",
    city: "Szczecin",
  },
  {
    code: "71-789",
    city: "Szczecin",
  },
  {
    code: "71-790",
    city: "Szczecin",
  },
  {
    code: "71-791",
    city: "Szczecin",
  },
  {
    code: "71-792",
    city: "Szczecin",
  },
  {
    code: "71-793",
    city: "Szczecin",
  },
  {
    code: "71-794",
    city: "Szczecin",
  },
  {
    code: "71-795",
    city: "Szczecin",
  },
  {
    code: "71-796",
    city: "Szczecin",
  },
  {
    code: "71-797",
    city: "Szczecin",
  },
  {
    code: "71-798",
    city: "Szczecin",
  },
  {
    code: "71-799",
    city: "Szczecin",
  },
  {
    code: "71-800",
    city: "Szczecin",
  },
  {
    code: "71-801",
    city: "Szczecin",
  },
  {
    code: "71-802",
    city: "Szczecin",
  },
  {
    code: "71-803",
    city: "Szczecin",
  },
  {
    code: "71-804",
    city: "Szczecin",
  },
  {
    code: "71-805",
    city: "Szczecin",
  },
  {
    code: "71-806",
    city: "Szczecin",
  },
  {
    code: "71-807",
    city: "Szczecin",
  },
  {
    code: "71-808",
    city: "Szczecin",
  },
  {
    code: "71-809",
    city: "Szczecin",
  },
  {
    code: "71-810",
    city: "Szczecin",
  },
  {
    code: "71-811",
    city: "Szczecin",
  },
  {
    code: "71-812",
    city: "Szczecin",
  },
  {
    code: "71-813",
    city: "Szczecin",
  },
  {
    code: "71-814",
    city: "Szczecin",
  },
  {
    code: "71-815",
    city: "Szczecin",
  },
  {
    code: "71-816",
    city: "Szczecin",
  },
  {
    code: "71-817",
    city: "Szczecin",
  },
  {
    code: "71-818",
    city: "Szczecin",
  },
  {
    code: "71-820",
    city: "Szczecin",
  },
  {
    code: "71-821",
    city: "Szczecin",
  },
  {
    code: "71-822",
    city: "Szczecin",
  },
  {
    code: "71-823",
    city: "Szczecin",
  },
  {
    code: "71-824",
    city: "Szczecin",
  },
  {
    code: "71-825",
    city: "Szczecin",
  },
  {
    code: "71-826",
    city: "Szczecin",
  },
  {
    code: "71-827",
    city: "Szczecin",
  },
  {
    code: "71-828",
    city: "Szczecin",
  },
  {
    code: "71-829",
    city: "Szczecin",
  },
  {
    code: "71-830",
    city: "Szczecin",
  },
  {
    code: "71-831",
    city: "Szczecin",
  },
  {
    code: "71-832",
    city: "Szczecin",
  },
  {
    code: "71-833",
    city: "Szczecin",
  },
  {
    code: "71-834",
    city: "Szczecin",
  },
  {
    code: "71-835",
    city: "Szczecin",
  },
  {
    code: "71-836",
    city: "Szczecin",
  },
  {
    code: "71-837",
    city: "Szczecin",
  },
  {
    code: "71-838",
    city: "Szczecin",
  },
  {
    code: "71-840",
    city: "Szczecin",
  },
  {
    code: "71-841",
    city: "Szczecin",
  },
  {
    code: "71-842",
    city: "Szczecin",
  },
  {
    code: "71-843",
    city: "Szczecin",
  },
  {
    code: "71-844",
    city: "Szczecin",
  },
  {
    code: "71-845",
    city: "Szczecin",
  },
  {
    code: "71-867",
    city: "Szczecin",
  },
  {
    code: "71-868",
    city: "Szczecin",
  },
  {
    code: "71-869",
    city: "Szczecin",
  },
  {
    code: "71-870",
    city: "Szczecin",
  },
  {
    code: "71-871",
    city: "Szczecin",
  },
  {
    code: "71-872",
    city: "Szczecin",
  },
  {
    code: "71-873",
    city: "Szczecin",
  },
  {
    code: "71-874",
    city: "Szczecin",
  },
  {
    code: "71-875",
    city: "Szczecin",
  },
  {
    code: "71-876",
    city: "Szczecin",
  },
  {
    code: "71-877",
    city: "Szczecin",
  },
  {
    code: "71-878",
    city: "Szczecin",
  },
  {
    code: "71-880",
    city: "Szczecin",
  },
  {
    code: "71-881",
    city: "Szczecin",
  },
  {
    code: "71-882",
    city: "Szczecin",
  },
  {
    code: "71-883",
    city: "Szczecin",
  },
  {
    code: "71-884",
    city: "Szczecin",
  },
  {
    code: "71-885",
    city: "Szczecin",
  },
  {
    code: "71-886",
    city: "Szczecin",
  },
  {
    code: "71-887",
    city: "Szczecin",
  },
  {
    code: "71-888",
    city: "Szczecin",
  },
  {
    code: "71-889",
    city: "Szczecin",
  },
  {
    code: "71-890",
    city: "Szczecin",
  },
  {
    code: "71-891",
    city: "Szczecin",
  },
  {
    code: "71-892",
    city: "Szczecin",
  },
  {
    code: "71-893",
    city: "Szczecin",
  },
  {
    code: "71-894",
    city: "Szczecin",
  },
  {
    code: "71-895",
    city: "Szczecin",
  },
  {
    code: "71-896",
    city: "Szczecin",
  },
  {
    code: "71-897",
    city: "Szczecin",
  },
  {
    code: "71-898",
    city: "Szczecin",
  },
  {
    code: "71-899",
    city: "Szczecin",
  },
  {
    code: "72-001",
    city: "Kołbaskowo",
  },
  {
    code: "72-002",
    city: "Dołuje",
  },
  {
    code: "72-003",
    city: "Dobra",
  },
  {
    code: "72-004",
    city: "Tanowo",
  },
  {
    code: "72-005",
    city: "Przecław",
  },
  {
    code: "72-006",
    city: "Mierzyn",
  },
  {
    code: "72-009",
    city: "Police",
  },
  {
    code: "72-010",
    city: "Police",
  },
  {
    code: "72-011",
    city: "Police",
  },
  {
    code: "72-015",
    city: "Police",
  },
  {
    code: "72-020",
    city: "Trzebież",
  },
  {
    code: "72-022",
    city: "Nowe Warpno",
  },
  {
    code: "72-100",
    city: "Goleniów",
  },
  {
    code: "72-101",
    city: "Goleniów",
  },
  {
    code: "72-102",
    city: "Goleniów",
  },
  {
    code: "72-105",
    city: "Lubczyna",
  },
  {
    code: "72-110",
    city: "Przybiernów",
  },
  {
    code: "72-111",
    city: "Żarnowo",
  },
  {
    code: "72-112",
    city: "Stepnica",
  },
  {
    code: "72-121",
    city: "Czarnogłowy",
  },
  {
    code: "72-122",
    city: "Łożnica",
  },
  {
    code: "72-123",
    city: "Kliniska Wielkie",
  },
  {
    code: "72-130",
    city: "Maszewo",
  },
  {
    code: "72-132",
    city: "Mosty",
  },
  {
    code: "72-200",
    city: "Nowogard",
  },
  {
    code: "72-203",
    city: "Nowogard",
  },
  {
    code: "72-210",
    city: "Dobra",
  },
  {
    code: "72-221",
    city: "Osina",
  },
  {
    code: "72-300",
    city: "Gryfice",
  },
  {
    code: "72-301",
    city: "Gryfice",
  },
  {
    code: "72-302",
    city: "Gryfice",
  },
  {
    code: "72-304",
    city: "Brojce",
  },
  {
    code: "72-310",
    city: "Płoty",
  },
  {
    code: "72-314",
    city: "Radowo Małe",
  },
  {
    code: "72-315",
    city: "Resko",
  },
  {
    code: "72-320",
    city: "Trzebiatów",
  },
  {
    code: "72-321",
    city: "Trzebiatów",
  },
  {
    code: "72-330",
    city: "Mrzeżyno",
  },
  {
    code: "72-342",
    city: "Cerkwica",
  },
  {
    code: "72-343",
    city: "Karnice",
  },
  {
    code: "72-344",
    city: "Rewal",
  },
  {
    code: "72-345",
    city: "Pustkowo",
  },
  {
    code: "72-346",
    city: "Pobierowo",
  },
  {
    code: "72-350",
    city: "Niechorze",
  },
  {
    code: "72-351",
    city: "Pogorzelica",
  },
  {
    code: "72-400",
    city: "Kamień Pomorski",
  },
  {
    code: "72-401",
    city: "Łukęcin",
  },
  {
    code: "72-405",
    city: "Świerzno",
  },
  {
    code: "72-410",
    city: "Golczewo",
  },
  {
    code: "72-415",
    city: "Międzywodzie",
  },
  {
    code: "72-418",
    city: "Dziwnów",
  },
  {
    code: "72-420",
    city: "Dziwnów",
  },
  {
    code: "72-500",
    city: "Międzyzdroje",
  },
  {
    code: "72-510",
    city: "Wolin",
  },
  {
    code: "72-511",
    city: "Troszyn",
  },
  {
    code: "72-513",
    city: "Wisełka",
  },
  {
    code: "72-514",
    city: "Kołczewo",
  },
  {
    code: "72-518",
    city: "Ładzin",
  },
  {
    code: "72-600",
    city: "Świnoujście",
  },
  {
    code: "72-601",
    city: "Świnoujście",
  },
  {
    code: "72-602",
    city: "Świnoujście",
  },
  {
    code: "72-604",
    city: "Świnoujście",
  },
  {
    code: "72-605",
    city: "Świnoujście",
  },
  {
    code: "72-606",
    city: "Świnoujście",
  },
  {
    code: "72-610",
    city: "Świnoujście",
  },
  {
    code: "72-611",
    city: "Świnoujście",
  },
  {
    code: "73-100",
    city: "Stargard Szczeciński",
  },
  {
    code: "73-101",
    city: "Stargard Szczeciński",
  },
  {
    code: "73-102",
    city: "Stargard Szczeciński",
  },
  {
    code: "73-103",
    city: "Stargard Szczeciński",
  },
  {
    code: "73-104",
    city: "Stargard Szczeciński",
  },
  {
    code: "73-105",
    city: "Stargard Szczeciński",
  },
  {
    code: "73-106",
    city: "Stargard Szczeciński",
  },
  {
    code: "73-107",
    city: "Stargard Szczeciński",
  },
  {
    code: "73-108",
    city: "Kobylanka",
  },
  {
    code: "73-110",
    city: "Stargard Szczeciński",
  },
  {
    code: "73-112",
    city: "Stara Dąbrowa",
  },
  {
    code: "73-115",
    city: "Dolice",
  },
  {
    code: "73-120",
    city: "Chociwel",
  },
  {
    code: "73-121",
    city: "Marianowo",
  },
  {
    code: "73-130",
    city: "Dobrzany",
  },
  {
    code: "73-131",
    city: "Pęzino",
  },
  {
    code: "73-132",
    city: "Suchań",
  },
  {
    code: "73-140",
    city: "Ińsko",
  },
  {
    code: "73-150",
    city: "Łobez",
  },
  {
    code: "73-155",
    city: "Węgorzyno",
  },
  {
    code: "73-200",
    city: "Choszczno",
  },
  {
    code: "73-201",
    city: "Choszczno",
  },
  {
    code: "73-210",
    city: "Recz",
  },
  {
    code: "73-220",
    city: "Drawno",
  },
  {
    code: "73-222",
    city: "Suliszewo",
  },
  {
    code: "73-231",
    city: "Krzęcin",
  },
  {
    code: "73-236",
    city: "Płotno",
  },
  {
    code: "73-240",
    city: "Bierzwnik",
  },
  {
    code: "73-260",
    city: "Pełczyce",
  },
  {
    code: "74-100",
    city: "Gryfino",
  },
  {
    code: "74-101",
    city: "Gryfino",
  },
  {
    code: "74-105",
    city: "Nowe Czarnowo",
  },
  {
    code: "74-106",
    city: "Stare Czarnowo",
  },
  {
    code: "74-107",
    city: "Daleszewo",
  },
  {
    code: "74-110",
    city: "Banie",
  },
  {
    code: "74-111",
    city: "Lubanowo",
  },
  {
    code: "74-120",
    city: "Widuchowa",
  },
  {
    code: "74-200",
    city: "Pyrzyce",
  },
  {
    code: "74-201",
    city: "Warnice",
  },
  {
    code: "74-202",
    city: "Bielice",
  },
  {
    code: "74-204",
    city: "Kozielice",
  },
  {
    code: "74-205",
    city: "Tetyń",
  },
  {
    code: "74-210",
    city: "Przelewice",
  },
  {
    code: "74-211",
    city: "Brzesko",
  },
  {
    code: "74-230",
    city: "Mielęcin",
  },
  {
    code: "74-240",
    city: "Lipiany",
  },
  {
    code: "74-300",
    city: "Myślibórz",
  },
  {
    code: "74-304",
    city: "Nowogródek Pomorski",
  },
  {
    code: "74-305",
    city: "Karsko",
  },
  {
    code: "74-312",
    city: "Golenice",
  },
  {
    code: "74-320",
    city: "Barlinek",
  },
  {
    code: "74-322",
    city: "Mostkowo",
  },
  {
    code: "74-400",
    city: "Dębno",
  },
  {
    code: "74-404",
    city: "Cychry",
  },
  {
    code: "74-406",
    city: "Namyślin",
  },
  {
    code: "74-407",
    city: "Boleszkowice",
  },
  {
    code: "74-500",
    city: "Chojna",
  },
  {
    code: "74-503",
    city: "Moryń",
  },
  {
    code: "74-505",
    city: "Mieszkowice",
  },
  {
    code: "74-510",
    city: "Trzcińsko-Zdrój",
  },
  {
    code: "74-520",
    city: "Cedynia",
  },
  {
    code: "75-001",
    city: "Koszalin",
  },
  {
    code: "75-002",
    city: "Koszalin",
  },
  {
    code: "75-003",
    city: "Koszalin",
  },
  {
    code: "75-004",
    city: "Koszalin",
  },
  {
    code: "75-005",
    city: "Koszalin",
  },
  {
    code: "75-006",
    city: "Koszalin",
  },
  {
    code: "75-007",
    city: "Koszalin",
  },
  {
    code: "75-008",
    city: "Koszalin",
  },
  {
    code: "75-009",
    city: "Koszalin",
  },
  {
    code: "75-011",
    city: "Koszalin",
  },
  {
    code: "75-012",
    city: "Koszalin",
  },
  {
    code: "75-013",
    city: "Koszalin",
  },
  {
    code: "75-014",
    city: "Koszalin",
  },
  {
    code: "75-015",
    city: "Koszalin",
  },
  {
    code: "75-016",
    city: "Koszalin",
  },
  {
    code: "75-017",
    city: "Koszalin",
  },
  {
    code: "75-020",
    city: "Koszalin",
  },
  {
    code: "75-021",
    city: "Koszalin",
  },
  {
    code: "75-022",
    city: "Koszalin",
  },
  {
    code: "75-023",
    city: "Koszalin",
  },
  {
    code: "75-025",
    city: "Koszalin",
  },
  {
    code: "75-027",
    city: "Koszalin",
  },
  {
    code: "75-028",
    city: "Koszalin",
  },
  {
    code: "75-029",
    city: "Koszalin",
  },
  {
    code: "75-031",
    city: "Koszalin",
  },
  {
    code: "75-032",
    city: "Koszalin",
  },
  {
    code: "75-033",
    city: "Koszalin",
  },
  {
    code: "75-034",
    city: "Koszalin",
  },
  {
    code: "75-035",
    city: "Koszalin",
  },
  {
    code: "75-036",
    city: "Koszalin",
  },
  {
    code: "75-037",
    city: "Koszalin",
  },
  {
    code: "75-038",
    city: "Koszalin",
  },
  {
    code: "75-039",
    city: "Koszalin",
  },
  {
    code: "75-041",
    city: "Koszalin",
  },
  {
    code: "75-042",
    city: "Koszalin",
  },
  {
    code: "75-050",
    city: "Koszalin",
  },
  {
    code: "75-051",
    city: "Koszalin",
  },
  {
    code: "75-052",
    city: "Koszalin",
  },
  {
    code: "75-053",
    city: "Koszalin",
  },
  {
    code: "75-054",
    city: "Koszalin",
  },
  {
    code: "75-055",
    city: "Koszalin",
  },
  {
    code: "75-056",
    city: "Koszalin",
  },
  {
    code: "75-057",
    city: "Koszalin",
  },
  {
    code: "75-058",
    city: "Koszalin",
  },
  {
    code: "75-059",
    city: "Koszalin",
  },
  {
    code: "75-061",
    city: "Koszalin",
  },
  {
    code: "75-062",
    city: "Koszalin",
  },
  {
    code: "75-063",
    city: "Koszalin",
  },
  {
    code: "75-064",
    city: "Koszalin",
  },
  {
    code: "75-065",
    city: "Koszalin",
  },
  {
    code: "75-070",
    city: "Koszalin",
  },
  {
    code: "75-072",
    city: "Koszalin",
  },
  {
    code: "75-073",
    city: "Koszalin",
  },
  {
    code: "75-074",
    city: "Koszalin",
  },
  {
    code: "75-075",
    city: "Koszalin",
  },
  {
    code: "75-076",
    city: "Koszalin",
  },
  {
    code: "75-077",
    city: "Koszalin",
  },
  {
    code: "75-078",
    city: "Koszalin",
  },
  {
    code: "75-079",
    city: "Koszalin",
  },
  {
    code: "75-081",
    city: "Koszalin",
  },
  {
    code: "75-100",
    city: "Koszalin",
  },
  {
    code: "75-102",
    city: "Koszalin",
  },
  {
    code: "75-103",
    city: "Koszalin",
  },
  {
    code: "75-104",
    city: "Koszalin",
  },
  {
    code: "75-105",
    city: "Koszalin",
  },
  {
    code: "75-106",
    city: "Koszalin",
  },
  {
    code: "75-107",
    city: "Koszalin",
  },
  {
    code: "75-108",
    city: "Koszalin",
  },
  {
    code: "75-109",
    city: "Koszalin",
  },
  {
    code: "75-111",
    city: "Koszalin",
  },
  {
    code: "75-112",
    city: "Koszalin",
  },
  {
    code: "75-113",
    city: "Koszalin",
  },
  {
    code: "75-120",
    city: "Koszalin",
  },
  {
    code: "75-121",
    city: "Koszalin",
  },
  {
    code: "75-122",
    city: "Koszalin",
  },
  {
    code: "75-123",
    city: "Koszalin",
  },
  {
    code: "75-124",
    city: "Koszalin",
  },
  {
    code: "75-125",
    city: "Koszalin",
  },
  {
    code: "75-126",
    city: "Koszalin",
  },
  {
    code: "75-127",
    city: "Koszalin",
  },
  {
    code: "75-128",
    city: "Koszalin",
  },
  {
    code: "75-129",
    city: "Koszalin",
  },
  {
    code: "75-130",
    city: "Koszalin",
  },
  {
    code: "75-131",
    city: "Koszalin",
  },
  {
    code: "75-132",
    city: "Koszalin",
  },
  {
    code: "75-134",
    city: "Koszalin",
  },
  {
    code: "75-135",
    city: "Koszalin",
  },
  {
    code: "75-136",
    city: "Koszalin",
  },
  {
    code: "75-137",
    city: "Koszalin",
  },
  {
    code: "75-200",
    city: "Koszalin",
  },
  {
    code: "75-201",
    city: "Koszalin",
  },
  {
    code: "75-202",
    city: "Koszalin",
  },
  {
    code: "75-203",
    city: "Koszalin",
  },
  {
    code: "75-204",
    city: "Koszalin",
  },
  {
    code: "75-205",
    city: "Koszalin",
  },
  {
    code: "75-206",
    city: "Koszalin",
  },
  {
    code: "75-207",
    city: "Koszalin",
  },
  {
    code: "75-208",
    city: "Koszalin",
  },
  {
    code: "75-209",
    city: "Koszalin",
  },
  {
    code: "75-210",
    city: "Koszalin",
  },
  {
    code: "75-211",
    city: "Koszalin",
  },
  {
    code: "75-212",
    city: "Koszalin",
  },
  {
    code: "75-213",
    city: "Koszalin",
  },
  {
    code: "75-215",
    city: "Koszalin",
  },
  {
    code: "75-216",
    city: "Koszalin",
  },
  {
    code: "75-217",
    city: "Koszalin",
  },
  {
    code: "75-218",
    city: "Koszalin",
  },
  {
    code: "75-219",
    city: "Koszalin",
  },
  {
    code: "75-220",
    city: "Koszalin",
  },
  {
    code: "75-221",
    city: "Koszalin",
  },
  {
    code: "75-222",
    city: "Koszalin",
  },
  {
    code: "75-223",
    city: "Koszalin",
  },
  {
    code: "75-224",
    city: "Koszalin",
  },
  {
    code: "75-225",
    city: "Koszalin",
  },
  {
    code: "75-226",
    city: "Koszalin",
  },
  {
    code: "75-227",
    city: "Koszalin",
  },
  {
    code: "75-228",
    city: "Koszalin",
  },
  {
    code: "75-229",
    city: "Koszalin",
  },
  {
    code: "75-230",
    city: "Koszalin",
  },
  {
    code: "75-232",
    city: "Koszalin",
  },
  {
    code: "75-233",
    city: "Koszalin",
  },
  {
    code: "75-234",
    city: "Koszalin",
  },
  {
    code: "75-235",
    city: "Koszalin",
  },
  {
    code: "75-236",
    city: "Koszalin",
  },
  {
    code: "75-237",
    city: "Koszalin",
  },
  {
    code: "75-238",
    city: "Koszalin",
  },
  {
    code: "75-239",
    city: "Koszalin",
  },
  {
    code: "75-240",
    city: "Koszalin",
  },
  {
    code: "75-241",
    city: "Koszalin",
  },
  {
    code: "75-242",
    city: "Koszalin",
  },
  {
    code: "75-243",
    city: "Koszalin",
  },
  {
    code: "75-244",
    city: "Koszalin",
  },
  {
    code: "75-245",
    city: "Koszalin",
  },
  {
    code: "75-246",
    city: "Koszalin",
  },
  {
    code: "75-247",
    city: "Koszalin",
  },
  {
    code: "75-249",
    city: "Koszalin",
  },
  {
    code: "75-250",
    city: "Koszalin",
  },
  {
    code: "75-251",
    city: "Koszalin",
  },
  {
    code: "75-252",
    city: "Koszalin",
  },
  {
    code: "75-253",
    city: "Koszalin",
  },
  {
    code: "75-254",
    city: "Koszalin",
  },
  {
    code: "75-255",
    city: "Koszalin",
  },
  {
    code: "75-256",
    city: "Koszalin",
  },
  {
    code: "75-257",
    city: "Koszalin",
  },
  {
    code: "75-300",
    city: "Koszalin",
  },
  {
    code: "75-301",
    city: "Koszalin",
  },
  {
    code: "75-302",
    city: "Koszalin",
  },
  {
    code: "75-303",
    city: "Koszalin",
  },
  {
    code: "75-304",
    city: "Koszalin",
  },
  {
    code: "75-305",
    city: "Koszalin",
  },
  {
    code: "75-306",
    city: "Koszalin",
  },
  {
    code: "75-307",
    city: "Koszalin",
  },
  {
    code: "75-308",
    city: "Koszalin",
  },
  {
    code: "75-309",
    city: "Koszalin",
  },
  {
    code: "75-310",
    city: "Koszalin",
  },
  {
    code: "75-311",
    city: "Koszalin",
  },
  {
    code: "75-312",
    city: "Koszalin",
  },
  {
    code: "75-313",
    city: "Koszalin",
  },
  {
    code: "75-319",
    city: "Koszalin",
  },
  {
    code: "75-320",
    city: "Koszalin",
  },
  {
    code: "75-321",
    city: "Koszalin",
  },
  {
    code: "75-322",
    city: "Koszalin",
  },
  {
    code: "75-323",
    city: "Koszalin",
  },
  {
    code: "75-324",
    city: "Koszalin",
  },
  {
    code: "75-325",
    city: "Koszalin",
  },
  {
    code: "75-326",
    city: "Koszalin",
  },
  {
    code: "75-327",
    city: "Koszalin",
  },
  {
    code: "75-328",
    city: "Koszalin",
  },
  {
    code: "75-329",
    city: "Koszalin",
  },
  {
    code: "75-330",
    city: "Koszalin",
  },
  {
    code: "75-331",
    city: "Koszalin",
  },
  {
    code: "75-332",
    city: "Koszalin",
  },
  {
    code: "75-333",
    city: "Koszalin",
  },
  {
    code: "75-334",
    city: "Koszalin",
  },
  {
    code: "75-335",
    city: "Koszalin",
  },
  {
    code: "75-336",
    city: "Koszalin",
  },
  {
    code: "75-337",
    city: "Koszalin",
  },
  {
    code: "75-338",
    city: "Koszalin",
  },
  {
    code: "75-339",
    city: "Koszalin",
  },
  {
    code: "75-340",
    city: "Koszalin",
  },
  {
    code: "75-341",
    city: "Koszalin",
  },
  {
    code: "75-342",
    city: "Koszalin",
  },
  {
    code: "75-343",
    city: "Koszalin",
  },
  {
    code: "75-344",
    city: "Koszalin",
  },
  {
    code: "75-345",
    city: "Koszalin",
  },
  {
    code: "75-346",
    city: "Koszalin",
  },
  {
    code: "75-347",
    city: "Koszalin",
  },
  {
    code: "75-348",
    city: "Koszalin",
  },
  {
    code: "75-349",
    city: "Koszalin",
  },
  {
    code: "75-350",
    city: "Koszalin",
  },
  {
    code: "75-351",
    city: "Koszalin",
  },
  {
    code: "75-352",
    city: "Koszalin",
  },
  {
    code: "75-353",
    city: "Koszalin",
  },
  {
    code: "75-354",
    city: "Koszalin",
  },
  {
    code: "75-355",
    city: "Koszalin",
  },
  {
    code: "75-356",
    city: "Koszalin",
  },
  {
    code: "75-357",
    city: "Koszalin",
  },
  {
    code: "75-358",
    city: "Koszalin",
  },
  {
    code: "75-359",
    city: "Koszalin",
  },
  {
    code: "75-360",
    city: "Koszalin",
  },
  {
    code: "75-361",
    city: "Koszalin",
  },
  {
    code: "75-362",
    city: "Koszalin",
  },
  {
    code: "75-363",
    city: "Koszalin",
  },
  {
    code: "75-364",
    city: "Koszalin",
  },
  {
    code: "75-365",
    city: "Koszalin",
  },
  {
    code: "75-366",
    city: "Koszalin",
  },
  {
    code: "75-367",
    city: "Koszalin",
  },
  {
    code: "75-368",
    city: "Koszalin",
  },
  {
    code: "75-369",
    city: "Koszalin",
  },
  {
    code: "75-370",
    city: "Koszalin",
  },
  {
    code: "75-371",
    city: "Koszalin",
  },
  {
    code: "75-372",
    city: "Koszalin",
  },
  {
    code: "75-373",
    city: "Koszalin",
  },
  {
    code: "75-374",
    city: "Koszalin",
  },
  {
    code: "75-375",
    city: "Koszalin",
  },
  {
    code: "75-376",
    city: "Koszalin",
  },
  {
    code: "75-377",
    city: "Koszalin",
  },
  {
    code: "75-378",
    city: "Koszalin",
  },
  {
    code: "75-379",
    city: "Koszalin",
  },
  {
    code: "75-380",
    city: "Koszalin",
  },
  {
    code: "75-381",
    city: "Koszalin",
  },
  {
    code: "75-382",
    city: "Koszalin",
  },
  {
    code: "75-383",
    city: "Koszalin",
  },
  {
    code: "75-384",
    city: "Koszalin",
  },
  {
    code: "75-385",
    city: "Koszalin",
  },
  {
    code: "75-386",
    city: "Koszalin",
  },
  {
    code: "75-388",
    city: "Koszalin",
  },
  {
    code: "75-389",
    city: "Koszalin",
  },
  {
    code: "75-390",
    city: "Koszalin",
  },
  {
    code: "75-391",
    city: "Koszalin",
  },
  {
    code: "75-392",
    city: "Koszalin",
  },
  {
    code: "75-393",
    city: "Koszalin",
  },
  {
    code: "75-394",
    city: "Koszalin",
  },
  {
    code: "75-395",
    city: "Koszalin",
  },
  {
    code: "75-396",
    city: "Koszalin",
  },
  {
    code: "75-397",
    city: "Koszalin",
  },
  {
    code: "75-398",
    city: "Koszalin",
  },
  {
    code: "75-399",
    city: "Koszalin",
  },
  {
    code: "75-400",
    city: "Koszalin",
  },
  {
    code: "75-401",
    city: "Koszalin",
  },
  {
    code: "75-402",
    city: "Koszalin",
  },
  {
    code: "75-403",
    city: "Koszalin",
  },
  {
    code: "75-404",
    city: "Koszalin",
  },
  {
    code: "75-405",
    city: "Koszalin",
  },
  {
    code: "75-406",
    city: "Koszalin",
  },
  {
    code: "75-407",
    city: "Koszalin",
  },
  {
    code: "75-408",
    city: "Koszalin",
  },
  {
    code: "75-409",
    city: "Koszalin",
  },
  {
    code: "75-410",
    city: "Koszalin",
  },
  {
    code: "75-411",
    city: "Koszalin",
  },
  {
    code: "75-412",
    city: "Koszalin",
  },
  {
    code: "75-413",
    city: "Koszalin",
  },
  {
    code: "75-414",
    city: "Koszalin",
  },
  {
    code: "75-415",
    city: "Koszalin",
  },
  {
    code: "75-420",
    city: "Koszalin",
  },
  {
    code: "75-421",
    city: "Koszalin",
  },
  {
    code: "75-422",
    city: "Koszalin",
  },
  {
    code: "75-423",
    city: "Koszalin",
  },
  {
    code: "75-424",
    city: "Koszalin",
  },
  {
    code: "75-425",
    city: "Koszalin",
  },
  {
    code: "75-426",
    city: "Koszalin",
  },
  {
    code: "75-427",
    city: "Koszalin",
  },
  {
    code: "75-428",
    city: "Koszalin",
  },
  {
    code: "75-429",
    city: "Koszalin",
  },
  {
    code: "75-430",
    city: "Koszalin",
  },
  {
    code: "75-431",
    city: "Koszalin",
  },
  {
    code: "75-432",
    city: "Koszalin",
  },
  {
    code: "75-433",
    city: "Koszalin",
  },
  {
    code: "75-434",
    city: "Koszalin",
  },
  {
    code: "75-435",
    city: "Koszalin",
  },
  {
    code: "75-436",
    city: "Koszalin",
  },
  {
    code: "75-437",
    city: "Koszalin",
  },
  {
    code: "75-438",
    city: "Koszalin",
  },
  {
    code: "75-440",
    city: "Koszalin",
  },
  {
    code: "75-441",
    city: "Koszalin",
  },
  {
    code: "75-442",
    city: "Koszalin",
  },
  {
    code: "75-443",
    city: "Koszalin",
  },
  {
    code: "75-444",
    city: "Koszalin",
  },
  {
    code: "75-445",
    city: "Koszalin",
  },
  {
    code: "75-446",
    city: "Koszalin",
  },
  {
    code: "75-447",
    city: "Koszalin",
  },
  {
    code: "75-448",
    city: "Koszalin",
  },
  {
    code: "75-449",
    city: "Koszalin",
  },
  {
    code: "75-450",
    city: "Koszalin",
  },
  {
    code: "75-451",
    city: "Koszalin",
  },
  {
    code: "75-452",
    city: "Koszalin",
  },
  {
    code: "75-453",
    city: "Koszalin",
  },
  {
    code: "75-454",
    city: "Koszalin",
  },
  {
    code: "75-455",
    city: "Koszalin",
  },
  {
    code: "75-500",
    city: "Koszalin",
  },
  {
    code: "75-501",
    city: "Koszalin",
  },
  {
    code: "75-502",
    city: "Koszalin",
  },
  {
    code: "75-503",
    city: "Koszalin",
  },
  {
    code: "75-504",
    city: "Koszalin",
  },
  {
    code: "75-505",
    city: "Koszalin",
  },
  {
    code: "75-506",
    city: "Koszalin",
  },
  {
    code: "75-507",
    city: "Koszalin",
  },
  {
    code: "75-508",
    city: "Koszalin",
  },
  {
    code: "75-509",
    city: "Koszalin",
  },
  {
    code: "75-511",
    city: "Koszalin",
  },
  {
    code: "75-512",
    city: "Koszalin",
  },
  {
    code: "75-519",
    city: "Koszalin",
  },
  {
    code: "75-520",
    city: "Koszalin",
  },
  {
    code: "75-521",
    city: "Koszalin",
  },
  {
    code: "75-522",
    city: "Koszalin",
  },
  {
    code: "75-523",
    city: "Koszalin",
  },
  {
    code: "75-524",
    city: "Koszalin",
  },
  {
    code: "75-525",
    city: "Koszalin",
  },
  {
    code: "75-526",
    city: "Koszalin",
  },
  {
    code: "75-527",
    city: "Koszalin",
  },
  {
    code: "75-528",
    city: "Koszalin",
  },
  {
    code: "75-529",
    city: "Koszalin",
  },
  {
    code: "75-531",
    city: "Koszalin",
  },
  {
    code: "75-540",
    city: "Koszalin",
  },
  {
    code: "75-541",
    city: "Koszalin",
  },
  {
    code: "75-542",
    city: "Koszalin",
  },
  {
    code: "75-543",
    city: "Koszalin",
  },
  {
    code: "75-544",
    city: "Koszalin",
  },
  {
    code: "75-545",
    city: "Koszalin",
  },
  {
    code: "75-546",
    city: "Koszalin",
  },
  {
    code: "75-547",
    city: "Koszalin",
  },
  {
    code: "75-548",
    city: "Koszalin",
  },
  {
    code: "75-549",
    city: "Koszalin",
  },
  {
    code: "75-551",
    city: "Koszalin",
  },
  {
    code: "75-552",
    city: "Koszalin",
  },
  {
    code: "75-553",
    city: "Koszalin",
  },
  {
    code: "75-554",
    city: "Koszalin",
  },
  {
    code: "75-555",
    city: "Koszalin",
  },
  {
    code: "75-556",
    city: "Koszalin",
  },
  {
    code: "75-557",
    city: "Koszalin",
  },
  {
    code: "75-558",
    city: "Koszalin",
  },
  {
    code: "75-560",
    city: "Koszalin",
  },
  {
    code: "75-561",
    city: "Koszalin",
  },
  {
    code: "75-562",
    city: "Koszalin",
  },
  {
    code: "75-563",
    city: "Koszalin",
  },
  {
    code: "75-564",
    city: "Koszalin",
  },
  {
    code: "75-565",
    city: "Koszalin",
  },
  {
    code: "75-566",
    city: "Koszalin",
  },
  {
    code: "75-567",
    city: "Koszalin",
  },
  {
    code: "75-568",
    city: "Koszalin",
  },
  {
    code: "75-569",
    city: "Koszalin",
  },
  {
    code: "75-571",
    city: "Koszalin",
  },
  {
    code: "75-572",
    city: "Koszalin",
  },
  {
    code: "75-573",
    city: "Koszalin",
  },
  {
    code: "75-574",
    city: "Koszalin",
  },
  {
    code: "75-575",
    city: "Koszalin",
  },
  {
    code: "75-576",
    city: "Koszalin",
  },
  {
    code: "75-577",
    city: "Koszalin",
  },
  {
    code: "75-578",
    city: "Koszalin",
  },
  {
    code: "75-579",
    city: "Koszalin",
  },
  {
    code: "75-580",
    city: "Koszalin",
  },
  {
    code: "75-581",
    city: "Koszalin",
  },
  {
    code: "75-582",
    city: "Koszalin",
  },
  {
    code: "75-583",
    city: "Koszalin",
  },
  {
    code: "75-584",
    city: "Koszalin",
  },
  {
    code: "75-585",
    city: "Koszalin",
  },
  {
    code: "75-586",
    city: "Koszalin",
  },
  {
    code: "75-587",
    city: "Koszalin",
  },
  {
    code: "75-588",
    city: "Koszalin",
  },
  {
    code: "75-589",
    city: "Koszalin",
  },
  {
    code: "75-590",
    city: "Koszalin",
  },
  {
    code: "75-600",
    city: "Koszalin",
  },
  {
    code: "75-601",
    city: "Koszalin",
  },
  {
    code: "75-602",
    city: "Koszalin",
  },
  {
    code: "75-603",
    city: "Koszalin",
  },
  {
    code: "75-604",
    city: "Koszalin",
  },
  {
    code: "75-605",
    city: "Koszalin",
  },
  {
    code: "75-606",
    city: "Koszalin",
  },
  {
    code: "75-607",
    city: "Koszalin",
  },
  {
    code: "75-608",
    city: "Koszalin",
  },
  {
    code: "75-609",
    city: "Koszalin",
  },
  {
    code: "75-610",
    city: "Koszalin",
  },
  {
    code: "75-611",
    city: "Koszalin",
  },
  {
    code: "75-612",
    city: "Koszalin",
  },
  {
    code: "75-613",
    city: "Koszalin",
  },
  {
    code: "75-614",
    city: "Koszalin",
  },
  {
    code: "75-615",
    city: "Koszalin",
  },
  {
    code: "75-616",
    city: "Koszalin",
  },
  {
    code: "75-617",
    city: "Koszalin",
  },
  {
    code: "75-620",
    city: "Koszalin",
  },
  {
    code: "75-621",
    city: "Koszalin",
  },
  {
    code: "75-622",
    city: "Koszalin",
  },
  {
    code: "75-623",
    city: "Koszalin",
  },
  {
    code: "75-625",
    city: "Koszalin",
  },
  {
    code: "75-626",
    city: "Koszalin",
  },
  {
    code: "75-627",
    city: "Koszalin",
  },
  {
    code: "75-628",
    city: "Koszalin",
  },
  {
    code: "75-629",
    city: "Koszalin",
  },
  {
    code: "75-630",
    city: "Koszalin",
  },
  {
    code: "75-631",
    city: "Koszalin",
  },
  {
    code: "75-632",
    city: "Koszalin",
  },
  {
    code: "75-633",
    city: "Koszalin",
  },
  {
    code: "75-634",
    city: "Koszalin",
  },
  {
    code: "75-635",
    city: "Koszalin",
  },
  {
    code: "75-636",
    city: "Koszalin",
  },
  {
    code: "75-637",
    city: "Koszalin",
  },
  {
    code: "75-638",
    city: "Koszalin",
  },
  {
    code: "75-639",
    city: "Koszalin",
  },
  {
    code: "75-640",
    city: "Koszalin",
  },
  {
    code: "75-641",
    city: "Koszalin",
  },
  {
    code: "75-642",
    city: "Koszalin",
  },
  {
    code: "75-643",
    city: "Koszalin",
  },
  {
    code: "75-644",
    city: "Koszalin",
  },
  {
    code: "75-645",
    city: "Koszalin",
  },
  {
    code: "75-646",
    city: "Koszalin",
  },
  {
    code: "75-647",
    city: "Koszalin",
  },
  {
    code: "75-648",
    city: "Koszalin",
  },
  {
    code: "75-649",
    city: "Koszalin",
  },
  {
    code: "75-650",
    city: "Koszalin",
  },
  {
    code: "75-651",
    city: "Koszalin",
  },
  {
    code: "75-652",
    city: "Koszalin",
  },
  {
    code: "75-653",
    city: "Koszalin",
  },
  {
    code: "75-654",
    city: "Koszalin",
  },
  {
    code: "75-655",
    city: "Koszalin",
  },
  {
    code: "75-656",
    city: "Koszalin",
  },
  {
    code: "75-657",
    city: "Koszalin",
  },
  {
    code: "75-658",
    city: "Koszalin",
  },
  {
    code: "75-659",
    city: "Koszalin",
  },
  {
    code: "75-660",
    city: "Koszalin",
  },
  {
    code: "75-661",
    city: "Koszalin",
  },
  {
    code: "75-662",
    city: "Koszalin",
  },
  {
    code: "75-663",
    city: "Koszalin",
  },
  {
    code: "75-664",
    city: "Koszalin",
  },
  {
    code: "75-665",
    city: "Koszalin",
  },
  {
    code: "75-666",
    city: "Koszalin",
  },
  {
    code: "75-667",
    city: "Koszalin",
  },
  {
    code: "75-668",
    city: "Koszalin",
  },
  {
    code: "75-669",
    city: "Koszalin",
  },
  {
    code: "75-670",
    city: "Koszalin",
  },
  {
    code: "75-671",
    city: "Koszalin",
  },
  {
    code: "75-672",
    city: "Koszalin",
  },
  {
    code: "75-673",
    city: "Koszalin",
  },
  {
    code: "75-674",
    city: "Koszalin",
  },
  {
    code: "75-675",
    city: "Koszalin",
  },
  {
    code: "75-676",
    city: "Koszalin",
  },
  {
    code: "75-677",
    city: "Koszalin",
  },
  {
    code: "75-678",
    city: "Koszalin",
  },
  {
    code: "75-679",
    city: "Koszalin",
  },
  {
    code: "75-680",
    city: "Koszalin",
  },
  {
    code: "75-681",
    city: "Koszalin",
  },
  {
    code: "75-682",
    city: "Koszalin",
  },
  {
    code: "75-683",
    city: "Koszalin",
  },
  {
    code: "75-684",
    city: "Koszalin",
  },
  {
    code: "75-685",
    city: "Koszalin",
  },
  {
    code: "75-686",
    city: "Koszalin",
  },
  {
    code: "75-687",
    city: "Koszalin",
  },
  {
    code: "75-688",
    city: "Koszalin",
  },
  {
    code: "75-689",
    city: "Koszalin",
  },
  {
    code: "75-690",
    city: "Koszalin",
  },
  {
    code: "75-691",
    city: "Koszalin",
  },
  {
    code: "75-692",
    city: "Koszalin",
  },
  {
    code: "75-693",
    city: "Koszalin",
  },
  {
    code: "75-694",
    city: "Koszalin",
  },
  {
    code: "75-695",
    city: "Koszalin",
  },
  {
    code: "75-696",
    city: "Koszalin",
  },
  {
    code: "75-697",
    city: "Koszalin",
  },
  {
    code: "75-698",
    city: "Koszalin",
  },
  {
    code: "75-699",
    city: "Koszalin",
  },
  {
    code: "75-700",
    city: "Koszalin",
  },
  {
    code: "75-701",
    city: "Koszalin",
  },
  {
    code: "75-702",
    city: "Koszalin",
  },
  {
    code: "75-703",
    city: "Koszalin",
  },
  {
    code: "75-704",
    city: "Koszalin",
  },
  {
    code: "75-705",
    city: "Koszalin",
  },
  {
    code: "75-706",
    city: "Koszalin",
  },
  {
    code: "75-707",
    city: "Koszalin",
  },
  {
    code: "75-708",
    city: "Koszalin",
  },
  {
    code: "75-709",
    city: "Koszalin",
  },
  {
    code: "75-710",
    city: "Koszalin",
  },
  {
    code: "75-711",
    city: "Koszalin",
  },
  {
    code: "75-712",
    city: "Koszalin",
  },
  {
    code: "75-713",
    city: "Koszalin",
  },
  {
    code: "75-714",
    city: "Koszalin",
  },
  {
    code: "75-715",
    city: "Koszalin",
  },
  {
    code: "75-716",
    city: "Koszalin",
  },
  {
    code: "75-717",
    city: "Koszalin",
  },
  {
    code: "75-718",
    city: "Koszalin",
  },
  {
    code: "75-719",
    city: "Koszalin",
  },
  {
    code: "75-720",
    city: "Koszalin",
  },
  {
    code: "75-721",
    city: "Koszalin",
  },
  {
    code: "75-722",
    city: "Koszalin",
  },
  {
    code: "75-723",
    city: "Koszalin",
  },
  {
    code: "75-724",
    city: "Koszalin",
  },
  {
    code: "75-726",
    city: "Koszalin",
  },
  {
    code: "75-727",
    city: "Koszalin",
  },
  {
    code: "75-728",
    city: "Koszalin",
  },
  {
    code: "75-729",
    city: "Koszalin",
  },
  {
    code: "75-731",
    city: "Koszalin",
  },
  {
    code: "75-732",
    city: "Koszalin",
  },
  {
    code: "75-733",
    city: "Koszalin",
  },
  {
    code: "75-734",
    city: "Koszalin",
  },
  {
    code: "75-736",
    city: "Koszalin",
  },
  {
    code: "75-737",
    city: "Koszalin",
  },
  {
    code: "75-738",
    city: "Koszalin",
  },
  {
    code: "75-800",
    city: "Koszalin",
  },
  {
    code: "75-801",
    city: "Koszalin",
  },
  {
    code: "75-802",
    city: "Koszalin",
  },
  {
    code: "75-803",
    city: "Koszalin",
  },
  {
    code: "75-804",
    city: "Koszalin",
  },
  {
    code: "75-805",
    city: "Koszalin",
  },
  {
    code: "75-806",
    city: "Koszalin",
  },
  {
    code: "75-807",
    city: "Koszalin",
  },
  {
    code: "75-808",
    city: "Koszalin",
  },
  {
    code: "75-809",
    city: "Koszalin",
  },
  {
    code: "75-810",
    city: "Koszalin",
  },
  {
    code: "75-811",
    city: "Koszalin",
  },
  {
    code: "75-812",
    city: "Koszalin",
  },
  {
    code: "75-813",
    city: "Koszalin",
  },
  {
    code: "75-814",
    city: "Koszalin",
  },
  {
    code: "75-815",
    city: "Koszalin",
  },
  {
    code: "75-816",
    city: "Koszalin",
  },
  {
    code: "75-817",
    city: "Koszalin",
  },
  {
    code: "75-818",
    city: "Koszalin",
  },
  {
    code: "75-819",
    city: "Koszalin",
  },
  {
    code: "75-820",
    city: "Koszalin",
  },
  {
    code: "75-821",
    city: "Koszalin",
  },
  {
    code: "75-823",
    city: "Koszalin",
  },
  {
    code: "75-824",
    city: "Koszalin",
  },
  {
    code: "75-825",
    city: "Koszalin",
  },
  {
    code: "75-826",
    city: "Koszalin",
  },
  {
    code: "75-827",
    city: "Koszalin",
  },
  {
    code: "75-828",
    city: "Koszalin",
  },
  {
    code: "75-829",
    city: "Koszalin",
  },
  {
    code: "75-831",
    city: "Koszalin",
  },
  {
    code: "75-832",
    city: "Koszalin",
  },
  {
    code: "75-833",
    city: "Koszalin",
  },
  {
    code: "75-834",
    city: "Koszalin",
  },
  {
    code: "75-835",
    city: "Koszalin",
  },
  {
    code: "75-836",
    city: "Koszalin",
  },
  {
    code: "75-837",
    city: "Koszalin",
  },
  {
    code: "75-838",
    city: "Koszalin",
  },
  {
    code: "75-839",
    city: "Koszalin",
  },
  {
    code: "75-840",
    city: "Koszalin",
  },
  {
    code: "75-841",
    city: "Koszalin",
  },
  {
    code: "75-842",
    city: "Koszalin",
  },
  {
    code: "75-843",
    city: "Koszalin",
  },
  {
    code: "75-844",
    city: "Koszalin",
  },
  {
    code: "75-845",
    city: "Koszalin",
  },
  {
    code: "75-846",
    city: "Koszalin",
  },
  {
    code: "75-847",
    city: "Koszalin",
  },
  {
    code: "75-848",
    city: "Koszalin",
  },
  {
    code: "75-849",
    city: "Koszalin",
  },
  {
    code: "75-850",
    city: "Koszalin",
  },
  {
    code: "75-851",
    city: "Koszalin",
  },
  {
    code: "75-900",
    city: "Koszalin",
  },
  {
    code: "75-901",
    city: "Koszalin",
  },
  {
    code: "75-903",
    city: "Koszalin",
  },
  {
    code: "76-002",
    city: "Łazy",
  },
  {
    code: "76-003",
    city: "Sucha Koszalińska",
  },
  {
    code: "76-004",
    city: "Sianów",
  },
  {
    code: "76-006",
    city: "Rekowo",
  },
  {
    code: "76-009",
    city: "Bonin",
  },
  {
    code: "76-010",
    city: "Polanów",
  },
  {
    code: "76-012",
    city: "Żydowo",
  },
  {
    code: "76-015",
    city: "Manowo",
  },
  {
    code: "76-020",
    city: "Bobolice",
  },
  {
    code: "76-024",
    city: "Świeszyno",
  },
  {
    code: "76-031",
    city: "Mścice",
  },
  {
    code: "76-032",
    city: "Mielno",
  },
  {
    code: "76-034",
    city: "Sarbinowo",
  },
  {
    code: "76-035",
    city: "Tymień",
  },
  {
    code: "76-037",
    city: "Będzino",
  },
  {
    code: "76-038",
    city: "Dobrzyca",
  },
  {
    code: "76-039",
    city: "Biesiekierz",
  },
  {
    code: "76-042",
    city: "Rosnowo",
  },
  {
    code: "76-100",
    city: "Sławno",
  },
  {
    code: "76-107",
    city: "Jarosławiec",
  },
  {
    code: "76-113",
    city: "Postomino",
  },
  {
    code: "76-123",
    city: "Tychowo",
  },
  {
    code: "76-129",
    city: "Ostrowiec",
  },
  {
    code: "76-142",
    city: "Malechowo",
  },
  {
    code: "76-150",
    city: "Darłowo",
  },
  {
    code: "76-153",
    city: "Darłowo",
  },
  {
    code: "76-156",
    city: "Dąbki",
  },
  {
    code: "76-200",
    city: "Słupsk",
  },
  {
    code: "76-201",
    city: "Słupsk",
  },
  {
    code: "76-202",
    city: "Słupsk",
  },
  {
    code: "76-203",
    city: "Słupsk",
  },
  {
    code: "76-204",
    city: "Słupsk",
  },
  {
    code: "76-205",
    city: "Słupsk",
  },
  {
    code: "76-206",
    city: "Słupsk",
  },
  {
    code: "76-207",
    city: "Słupsk",
  },
  {
    code: "76-208",
    city: "Słupsk",
  },
  {
    code: "76-209",
    city: "Słupsk",
  },
  {
    code: "76-210",
    city: "Słupsk",
  },
  {
    code: "76-211",
    city: "Objazda",
  },
  {
    code: "76-212",
    city: "Rowy",
  },
  {
    code: "76-213",
    city: "Gardna Wielka",
  },
  {
    code: "76-214",
    city: "Smołdzino",
  },
  {
    code: "76-215",
    city: "Słupsk",
  },
  {
    code: "76-216",
    city: "Słupsk",
  },
  {
    code: "76-217",
    city: "Siemianice",
  },
  {
    code: "76-218",
    city: "Słupsk",
  },
  {
    code: "76-219",
    city: "Jezierzyce",
  },
  {
    code: "76-220",
    city: "Główczyce",
  },
  {
    code: "76-230",
    city: "Potęgowo",
  },
  {
    code: "76-231",
    city: "Damnica",
  },
  {
    code: "76-242",
    city: "Łupawa",
  },
  {
    code: "76-243",
    city: "Mikorowo",
  },
  {
    code: "76-245",
    city: "Płaszewo",
  },
  {
    code: "76-246",
    city: "Borzęcino",
  },
  {
    code: "76-248",
    city: "Dębnica Kaszubska",
  },
  {
    code: "76-251",
    city: "Kobylnica",
  },
  {
    code: "76-252",
    city: "Kwakowo",
  },
  {
    code: "76-256",
    city: "Sycewice",
  },
  {
    code: "76-270",
    city: "Ustka",
  },
  {
    code: "76-271",
    city: "Ustka",
  },
  {
    code: "76-272",
    city: "Ustka",
  },
  {
    code: "76-273",
    city: "Ustka",
  },
  {
    code: "76-274",
    city: "Ustka",
  },
  {
    code: "76-280",
    city: "Słupsk",
  },
  {
    code: "77-100",
    city: "Bytów",
  },
  {
    code: "77-101",
    city: "Bytów",
  },
  {
    code: "77-102",
    city: "Bytów",
  },
  {
    code: "77-112",
    city: "Motarzyno",
  },
  {
    code: "77-113",
    city: "Budowo",
  },
  {
    code: "77-114",
    city: "Gostkowo",
  },
  {
    code: "77-115",
    city: "Nożyno",
  },
  {
    code: "77-116",
    city: "Czarna Dąbrówka",
  },
  {
    code: "77-121",
    city: "Pomysk Wielki",
  },
  {
    code: "77-122",
    city: "Jasień",
  },
  {
    code: "77-123",
    city: "Rokity",
  },
  {
    code: "77-124",
    city: "Parchowo",
  },
  {
    code: "77-127",
    city: "Nakla",
  },
  {
    code: "77-130",
    city: "Lipnica",
  },
  {
    code: "77-131",
    city: "Rekowo",
  },
  {
    code: "77-132",
    city: "Niezabyszewo",
  },
  {
    code: "77-133",
    city: "Tuchomie",
  },
  {
    code: "77-134",
    city: "Trzebiatkowa",
  },
  {
    code: "77-138",
    city: "Borowy Młyn",
  },
  {
    code: "77-139",
    city: "Brzeźno Szlacheckie",
  },
  {
    code: "77-140",
    city: "Kołczygłowy",
  },
  {
    code: "77-141",
    city: "Borzytuchom",
  },
  {
    code: "77-143",
    city: "Studzienice",
  },
  {
    code: "77-200",
    city: "Miastko",
  },
  {
    code: "77-201",
    city: "Miastko",
  },
  {
    code: "77-203",
    city: "Dretyń",
  },
  {
    code: "77-207",
    city: "Piaszczyna",
  },
  {
    code: "77-220",
    city: "Koczała",
  },
  {
    code: "77-223",
    city: "Przytocko",
  },
  {
    code: "77-230",
    city: "Kępice",
  },
  {
    code: "77-231",
    city: "Korzybie",
  },
  {
    code: "77-232",
    city: "Barcino",
  },
  {
    code: "77-233",
    city: "Zielin",
  },
  {
    code: "77-235",
    city: "Trzebielino",
  },
  {
    code: "77-300",
    city: "Człuchów",
  },
  {
    code: "77-301",
    city: "Człuchów",
  },
  {
    code: "77-302",
    city: "Człuchów",
  },
  {
    code: "77-304",
    city: "Rzeczenica",
  },
  {
    code: "77-310",
    city: "Debrzno",
  },
  {
    code: "77-314",
    city: "Barkowo",
  },
  {
    code: "77-317",
    city: "Wierzchowo",
  },
  {
    code: "77-318",
    city: "Stare Gronowo",
  },
  {
    code: "77-320",
    city: "Przechlewo",
  },
  {
    code: "77-323",
    city: "Polnica",
  },
  {
    code: "77-324",
    city: "Bińcze",
  },
  {
    code: "77-326",
    city: "Wyczechy",
  },
  {
    code: "77-330",
    city: "Czarne",
  },
  {
    code: "77-400",
    city: "Złotów",
  },
  {
    code: "77-416",
    city: "Tarnówka",
  },
  {
    code: "77-420",
    city: "Lipka",
  },
  {
    code: "77-424",
    city: "Zakrzewo",
  },
  {
    code: "77-430",
    city: "Krajenka",
  },
  {
    code: "78-100",
    city: "Kołobrzeg",
  },
  {
    code: "78-101",
    city: "Kołobrzeg",
  },
  {
    code: "78-102",
    city: "Kołobrzeg",
  },
  {
    code: "78-103",
    city: "Kołobrzeg",
  },
  {
    code: "78-104",
    city: "Kołobrzeg",
  },
  {
    code: "78-105",
    city: "Kołobrzeg",
  },
  {
    code: "78-106",
    city: "Kołobrzeg",
  },
  {
    code: "78-111",
    city: "Ustronie Morskie",
  },
  {
    code: "78-113",
    city: "Dygowo",
  },
  {
    code: "78-114",
    city: "Wrzosowo",
  },
  {
    code: "78-120",
    city: "Gościno",
  },
  {
    code: "78-123",
    city: "Siemyśl",
  },
  {
    code: "78-125",
    city: "Rymań",
  },
  {
    code: "78-131",
    city: "Dźwirzyno",
  },
  {
    code: "78-132",
    city: "Grzybowo",
  },
  {
    code: "78-133",
    city: "Drzonowo",
  },
  {
    code: "78-200",
    city: "Białogard",
  },
  {
    code: "78-201",
    city: "Białogard",
  },
  {
    code: "78-202",
    city: "Białogard",
  },
  {
    code: "78-210",
    city: "Białogard",
  },
  {
    code: "78-220",
    city: "Tychowo",
  },
  {
    code: "78-230",
    city: "Karlino",
  },
  {
    code: "78-300",
    city: "Świdwin",
  },
  {
    code: "78-301",
    city: "Świdwin",
  },
  {
    code: "78-311",
    city: "Rusinowo",
  },
  {
    code: "78-314",
    city: "Sławoborze",
  },
  {
    code: "78-316",
    city: "Brzeżno",
  },
  {
    code: "78-320",
    city: "Połczyn-Zdrój",
  },
  {
    code: "78-325",
    city: "Redło",
  },
  {
    code: "78-331",
    city: "Rąbino",
  },
  {
    code: "78-400",
    city: "Szczecinek",
  },
  {
    code: "78-401",
    city: "Szczecinek",
  },
  {
    code: "78-402",
    city: "Szczecinek",
  },
  {
    code: "78-403",
    city: "Szczecinek",
  },
  {
    code: "78-404",
    city: "Szczecinek",
  },
  {
    code: "78-405",
    city: "Szczecinek",
  },
  {
    code: "78-410",
    city: "Szczecinek",
  },
  {
    code: "78-411",
    city: "Wierzchowo",
  },
  {
    code: "78-421",
    city: "Drzonowo",
  },
  {
    code: "78-423",
    city: "Żółtnica",
  },
  {
    code: "78-425",
    city: "Biały Bór",
  },
  {
    code: "78-431",
    city: "Turowo",
  },
  {
    code: "78-444",
    city: "Polne",
  },
  {
    code: "78-445",
    city: "Łubowo",
  },
  {
    code: "78-446",
    city: "Silnowo",
  },
  {
    code: "78-449",
    city: "Borne Sulinowo",
  },
  {
    code: "78-450",
    city: "Grzmiąca",
  },
  {
    code: "78-460",
    city: "Barwice",
  },
  {
    code: "78-461",
    city: "Stary Chwalim",
  },
  {
    code: "78-500",
    city: "Drawsko Pomorskie",
  },
  {
    code: "78-504",
    city: "Rydzewo",
  },
  {
    code: "78-506",
    city: "Ostrowice",
  },
  {
    code: "78-513",
    city: "Mielenko Drawskie",
  },
  {
    code: "78-520",
    city: "Złocieniec",
  },
  {
    code: "78-523",
    city: "Nowe Worowo",
  },
  {
    code: "78-524",
    city: "Złocieniec",
  },
  {
    code: "78-530",
    city: "Wierzchowo",
  },
  {
    code: "78-540",
    city: "Kalisz Pomorski",
  },
  {
    code: "78-550",
    city: "Czaplinek",
  },
  {
    code: "78-552",
    city: "Kluczewo",
  },
  {
    code: "78-553",
    city: "Broczyno",
  },
  {
    code: "78-600",
    city: "Wałcz",
  },
  {
    code: "78-601",
    city: "Wałcz",
  },
  {
    code: "78-603",
    city: "Wałcz",
  },
  {
    code: "78-604",
    city: "Wałcz",
  },
  {
    code: "78-607",
    city: "Dębołęka",
  },
  {
    code: "78-609",
    city: "Karsibór",
  },
  {
    code: "78-627",
    city: "Różewo",
  },
  {
    code: "78-630",
    city: "Człopa",
  },
  {
    code: "78-640",
    city: "Tuczno",
  },
  {
    code: "78-641",
    city: "Lubiesz",
  },
  {
    code: "78-642",
    city: "Strączno",
  },
  {
    code: "78-650",
    city: "Mirosławiec",
  },
  {
    code: "78-651",
    city: "Mirosławiec Górny",
  },
  {
    code: "80-001",
    city: "Gdańsk",
  },
  {
    code: "80-003",
    city: "Gdańsk",
  },
  {
    code: "80-007",
    city: "Gdańsk",
  },
  {
    code: "80-008",
    city: "Gdańsk",
  },
  {
    code: "80-009",
    city: "Gdańsk",
  },
  {
    code: "80-010",
    city: "Gdańsk",
  },
  {
    code: "80-011",
    city: "Gdańsk",
  },
  {
    code: "80-012",
    city: "Gdańsk",
  },
  {
    code: "80-013",
    city: "Gdańsk",
  },
  {
    code: "80-014",
    city: "Gdańsk",
  },
  {
    code: "80-016",
    city: "Gdańsk",
  },
  {
    code: "80-017",
    city: "Gdańsk",
  },
  {
    code: "80-018",
    city: "Gdańsk",
  },
  {
    code: "80-019",
    city: "Gdańsk",
  },
  {
    code: "80-020",
    city: "Gdańsk",
  },
  {
    code: "80-021",
    city: "Gdańsk",
  },
  {
    code: "80-022",
    city: "Gdańsk",
  },
  {
    code: "80-024",
    city: "Gdańsk",
  },
  {
    code: "80-025",
    city: "Gdańsk",
  },
  {
    code: "80-026",
    city: "Gdańsk",
  },
  {
    code: "80-027",
    city: "Gdańsk",
  },
  {
    code: "80-028",
    city: "Gdańsk",
  },
  {
    code: "80-029",
    city: "Gdańsk",
  },
  {
    code: "80-030",
    city: "Gdańsk",
  },
  {
    code: "80-031",
    city: "Gdańsk",
  },
  {
    code: "80-032",
    city: "Gdańsk",
  },
  {
    code: "80-033",
    city: "Gdańsk",
  },
  {
    code: "80-034",
    city: "Gdańsk",
  },
  {
    code: "80-035",
    city: "Gdańsk",
  },
  {
    code: "80-036",
    city: "Gdańsk",
  },
  {
    code: "80-037",
    city: "Gdańsk",
  },
  {
    code: "80-038",
    city: "Gdańsk",
  },
  {
    code: "80-039",
    city: "Gdańsk",
  },
  {
    code: "80-041",
    city: "Gdańsk",
  },
  {
    code: "80-042",
    city: "Gdańsk",
  },
  {
    code: "80-043",
    city: "Gdańsk",
  },
  {
    code: "80-044",
    city: "Gdańsk",
  },
  {
    code: "80-045",
    city: "Gdańsk",
  },
  {
    code: "80-046",
    city: "Gdańsk",
  },
  {
    code: "80-047",
    city: "Gdańsk",
  },
  {
    code: "80-048",
    city: "Gdańsk",
  },
  {
    code: "80-049",
    city: "Gdańsk",
  },
  {
    code: "80-050",
    city: "Gdańsk",
  },
  {
    code: "80-051",
    city: "Gdańsk",
  },
  {
    code: "80-052",
    city: "Gdańsk",
  },
  {
    code: "80-053",
    city: "Gdańsk",
  },
  {
    code: "80-054",
    city: "Gdańsk",
  },
  {
    code: "80-055",
    city: "Gdańsk",
  },
  {
    code: "80-056",
    city: "Gdańsk",
  },
  {
    code: "80-057",
    city: "Gdańsk",
  },
  {
    code: "80-058",
    city: "Gdańsk",
  },
  {
    code: "80-059",
    city: "Gdańsk",
  },
  {
    code: "80-060",
    city: "Gdańsk",
  },
  {
    code: "80-061",
    city: "Gdańsk",
  },
  {
    code: "80-062",
    city: "Gdańsk",
  },
  {
    code: "80-063",
    city: "Gdańsk",
  },
  {
    code: "80-064",
    city: "Gdańsk",
  },
  {
    code: "80-065",
    city: "Gdańsk",
  },
  {
    code: "80-066",
    city: "Gdańsk",
  },
  {
    code: "80-067",
    city: "Gdańsk",
  },
  {
    code: "80-068",
    city: "Gdańsk",
  },
  {
    code: "80-069",
    city: "Gdańsk",
  },
  {
    code: "80-070",
    city: "Gdańsk",
  },
  {
    code: "80-071",
    city: "Gdańsk",
  },
  {
    code: "80-073",
    city: "Gdańsk",
  },
  {
    code: "80-074",
    city: "Gdańsk",
  },
  {
    code: "80-075",
    city: "Gdańsk",
  },
  {
    code: "80-076",
    city: "Gdańsk",
  },
  {
    code: "80-077",
    city: "Gdańsk",
  },
  {
    code: "80-078",
    city: "Gdańsk",
  },
  {
    code: "80-097",
    city: "Gdańsk",
  },
  {
    code: "80-103",
    city: "Gdańsk",
  },
  {
    code: "80-104",
    city: "Gdańsk",
  },
  {
    code: "80-105",
    city: "Gdańsk",
  },
  {
    code: "80-107",
    city: "Gdańsk",
  },
  {
    code: "80-108",
    city: "Gdańsk",
  },
  {
    code: "80-110",
    city: "Gdańsk",
  },
  {
    code: "80-111",
    city: "Gdańsk",
  },
  {
    code: "80-112",
    city: "Gdańsk",
  },
  {
    code: "80-113",
    city: "Gdańsk",
  },
  {
    code: "80-114",
    city: "Gdańsk",
  },
  {
    code: "80-117",
    city: "Gdańsk",
  },
  {
    code: "80-118",
    city: "Gdańsk",
  },
  {
    code: "80-119",
    city: "Gdańsk",
  },
  {
    code: "80-120",
    city: "Gdańsk",
  },
  {
    code: "80-121",
    city: "Gdańsk",
  },
  {
    code: "80-122",
    city: "Gdańsk",
  },
  {
    code: "80-123",
    city: "Gdańsk",
  },
  {
    code: "80-124",
    city: "Gdańsk",
  },
  {
    code: "80-125",
    city: "Gdańsk",
  },
  {
    code: "80-126",
    city: "Gdańsk",
  },
  {
    code: "80-127",
    city: "Gdańsk",
  },
  {
    code: "80-128",
    city: "Gdańsk",
  },
  {
    code: "80-129",
    city: "Gdańsk",
  },
  {
    code: "80-132",
    city: "Gdańsk",
  },
  {
    code: "80-133",
    city: "Gdańsk",
  },
  {
    code: "80-134",
    city: "Gdańsk",
  },
  {
    code: "80-135",
    city: "Gdańsk",
  },
  {
    code: "80-136",
    city: "Gdańsk",
  },
  {
    code: "80-137",
    city: "Gdańsk",
  },
  {
    code: "80-138",
    city: "Gdańsk",
  },
  {
    code: "80-141",
    city: "Gdańsk",
  },
  {
    code: "80-143",
    city: "Gdańsk",
  },
  {
    code: "80-146",
    city: "Gdańsk",
  },
  {
    code: "80-148",
    city: "Gdańsk",
  },
  {
    code: "80-150",
    city: "Gdańsk",
  },
  {
    code: "80-151",
    city: "Gdańsk",
  },
  {
    code: "80-152",
    city: "Gdańsk",
  },
  {
    code: "80-153",
    city: "Gdańsk",
  },
  {
    code: "80-154",
    city: "Gdańsk",
  },
  {
    code: "80-156",
    city: "Gdańsk",
  },
  {
    code: "80-158",
    city: "Gdańsk",
  },
  {
    code: "80-163",
    city: "Gdańsk",
  },
  {
    code: "80-165",
    city: "Gdańsk",
  },
  {
    code: "80-169",
    city: "Gdańsk",
  },
  {
    code: "80-170",
    city: "Gdańsk",
  },
  {
    code: "80-171",
    city: "Gdańsk",
  },
  {
    code: "80-172",
    city: "Gdańsk",
  },
  {
    code: "80-174",
    city: "Gdańsk",
  },
  {
    code: "80-175",
    city: "Gdańsk",
  },
  {
    code: "80-176",
    city: "Gdańsk",
  },
  {
    code: "80-177",
    city: "Gdańsk",
  },
  {
    code: "80-178",
    city: "Gdańsk",
  },
  {
    code: "80-180",
    city: "Gdańsk",
  },
  {
    code: "80-190",
    city: "Gdańsk",
  },
  {
    code: "80-201",
    city: "Gdańsk",
  },
  {
    code: "80-202",
    city: "Gdańsk",
  },
  {
    code: "80-203",
    city: "Gdańsk",
  },
  {
    code: "80-204",
    city: "Gdańsk",
  },
  {
    code: "80-206",
    city: "Gdańsk",
  },
  {
    code: "80-207",
    city: "Gdańsk",
  },
  {
    code: "80-208",
    city: "Gdańsk",
  },
  {
    code: "80-209",
    city: "Chwaszczyno",
  },
  {
    code: "80-210",
    city: "Gdańsk",
  },
  {
    code: "80-211",
    city: "Gdańsk",
  },
  {
    code: "80-212",
    city: "Gdańsk",
  },
  {
    code: "80-213",
    city: "Gdańsk",
  },
  {
    code: "80-214",
    city: "Gdańsk",
  },
  {
    code: "80-215",
    city: "Gdańsk",
  },
  {
    code: "80-217",
    city: "Gdańsk",
  },
  {
    code: "80-218",
    city: "Gdańsk",
  },
  {
    code: "80-219",
    city: "Gdańsk",
  },
  {
    code: "80-223",
    city: "Gdańsk",
  },
  {
    code: "80-224",
    city: "Gdańsk",
  },
  {
    code: "80-227",
    city: "Gdańsk",
  },
  {
    code: "80-229",
    city: "Gdańsk",
  },
  {
    code: "80-230",
    city: "Gdańsk",
  },
  {
    code: "80-231",
    city: "Gdańsk",
  },
  {
    code: "80-232",
    city: "Gdańsk",
  },
  {
    code: "80-233",
    city: "Gdańsk",
  },
  {
    code: "80-235",
    city: "Gdańsk",
  },
  {
    code: "80-236",
    city: "Gdańsk",
  },
  {
    code: "80-239",
    city: "Gdańsk",
  },
  {
    code: "80-240",
    city: "Gdańsk",
  },
  {
    code: "80-241",
    city: "Gdańsk",
  },
  {
    code: "80-243",
    city: "Gdańsk",
  },
  {
    code: "80-244",
    city: "Gdańsk",
  },
  {
    code: "80-245",
    city: "Gdańsk",
  },
  {
    code: "80-246",
    city: "Gdańsk",
  },
  {
    code: "80-249",
    city: "Gdańsk",
  },
  {
    code: "80-250",
    city: "Gdańsk",
  },
  {
    code: "80-251",
    city: "Gdańsk",
  },
  {
    code: "80-252",
    city: "Gdańsk",
  },
  {
    code: "80-253",
    city: "Gdańsk",
  },
  {
    code: "80-255",
    city: "Gdańsk",
  },
  {
    code: "80-258",
    city: "Gdańsk",
  },
  {
    code: "80-260",
    city: "Gdańsk",
  },
  {
    code: "80-261",
    city: "Gdańsk",
  },
  {
    code: "80-262",
    city: "Gdańsk",
  },
  {
    code: "80-264",
    city: "Gdańsk",
  },
  {
    code: "80-265",
    city: "Gdańsk",
  },
  {
    code: "80-266",
    city: "Gdańsk",
  },
  {
    code: "80-267",
    city: "Gdańsk",
  },
  {
    code: "80-268",
    city: "Gdańsk",
  },
  {
    code: "80-270",
    city: "Gdańsk",
  },
  {
    code: "80-271",
    city: "Gdańsk",
  },
  {
    code: "80-272",
    city: "Gdańsk",
  },
  {
    code: "80-274",
    city: "Gdańsk",
  },
  {
    code: "80-275",
    city: "Gdańsk",
  },
  {
    code: "80-276",
    city: "Gdańsk",
  },
  {
    code: "80-277",
    city: "Gdańsk",
  },
  {
    code: "80-278",
    city: "Gdańsk",
  },
  {
    code: "80-279",
    city: "Gdańsk",
  },
  {
    code: "80-281",
    city: "Gdańsk",
  },
  {
    code: "80-282",
    city: "Gdańsk",
  },
  {
    code: "80-283",
    city: "Gdańsk",
  },
  {
    code: "80-284",
    city: "Gdańsk",
  },
  {
    code: "80-286",
    city: "Gdańsk",
  },
  {
    code: "80-287",
    city: "Gdańsk",
  },
  {
    code: "80-288",
    city: "Gdańsk",
  },
  {
    code: "80-289",
    city: "Gdańsk",
  },
  {
    code: "80-291",
    city: "Gdańsk",
  },
  {
    code: "80-292",
    city: "Gdańsk",
  },
  {
    code: "80-293",
    city: "Gdańsk",
  },
  {
    code: "80-294",
    city: "Gdańsk",
  },
  {
    code: "80-296",
    city: "Gdańsk",
  },
  {
    code: "80-297",
    city: "Banino",
  },
  {
    code: "80-298",
    city: "Gdańsk",
  },
  {
    code: "80-299",
    city: "Gdańsk",
  },
  {
    code: "80-300",
    city: "Gdańsk",
  },
  {
    code: "80-301",
    city: "Gdańsk",
  },
  {
    code: "80-302",
    city: "Gdańsk",
  },
  {
    code: "80-303",
    city: "Gdańsk",
  },
  {
    code: "80-304",
    city: "Gdańsk",
  },
  {
    code: "80-305",
    city: "Gdańsk",
  },
  {
    code: "80-306",
    city: "Gdańsk",
  },
  {
    code: "80-307",
    city: "Gdańsk",
  },
  {
    code: "80-308",
    city: "Gdańsk",
  },
  {
    code: "80-309",
    city: "Gdańsk",
  },
  {
    code: "80-310",
    city: "Gdańsk",
  },
  {
    code: "80-311",
    city: "Gdańsk",
  },
  {
    code: "80-312",
    city: "Gdańsk",
  },
  {
    code: "80-313",
    city: "Gdańsk",
  },
  {
    code: "80-314",
    city: "Gdańsk",
  },
  {
    code: "80-315",
    city: "Gdańsk",
  },
  {
    code: "80-316",
    city: "Gdańsk",
  },
  {
    code: "80-317",
    city: "Gdańsk",
  },
  {
    code: "80-318",
    city: "Gdańsk",
  },
  {
    code: "80-319",
    city: "Gdańsk",
  },
  {
    code: "80-320",
    city: "Gdańsk",
  },
  {
    code: "80-321",
    city: "Gdańsk",
  },
  {
    code: "80-322",
    city: "Gdańsk",
  },
  {
    code: "80-323",
    city: "Gdańsk",
  },
  {
    code: "80-324",
    city: "Gdańsk",
  },
  {
    code: "80-325",
    city: "Gdańsk",
  },
  {
    code: "80-326",
    city: "Gdańsk",
  },
  {
    code: "80-327",
    city: "Gdańsk",
  },
  {
    code: "80-328",
    city: "Gdańsk",
  },
  {
    code: "80-329",
    city: "Gdańsk",
  },
  {
    code: "80-330",
    city: "Gdańsk",
  },
  {
    code: "80-331",
    city: "Gdańsk",
  },
  {
    code: "80-332",
    city: "Gdańsk",
  },
  {
    code: "80-333",
    city: "Gdańsk",
  },
  {
    code: "80-334",
    city: "Gdańsk",
  },
  {
    code: "80-335",
    city: "Gdańsk",
  },
  {
    code: "80-336",
    city: "Gdańsk",
  },
  {
    code: "80-337",
    city: "Gdańsk",
  },
  {
    code: "80-338",
    city: "Gdańsk",
  },
  {
    code: "80-339",
    city: "Gdańsk",
  },
  {
    code: "80-340",
    city: "Gdańsk",
  },
  {
    code: "80-341",
    city: "Gdańsk",
  },
  {
    code: "80-342",
    city: "Gdańsk",
  },
  {
    code: "80-343",
    city: "Gdańsk",
  },
  {
    code: "80-344",
    city: "Gdańsk",
  },
  {
    code: "80-345",
    city: "Gdańsk",
  },
  {
    code: "80-346",
    city: "Gdańsk",
  },
  {
    code: "80-347",
    city: "Gdańsk",
  },
  {
    code: "80-348",
    city: "Gdańsk",
  },
  {
    code: "80-349",
    city: "Gdańsk",
  },
  {
    code: "80-350",
    city: "Gdańsk",
  },
  {
    code: "80-351",
    city: "Gdańsk",
  },
  {
    code: "80-352",
    city: "Gdańsk",
  },
  {
    code: "80-353",
    city: "Gdańsk",
  },
  {
    code: "80-354",
    city: "Gdańsk",
  },
  {
    code: "80-355",
    city: "Gdańsk",
  },
  {
    code: "80-356",
    city: "Gdańsk",
  },
  {
    code: "80-357",
    city: "Gdańsk",
  },
  {
    code: "80-358",
    city: "Gdańsk",
  },
  {
    code: "80-359",
    city: "Gdańsk",
  },
  {
    code: "80-360",
    city: "Gdańsk",
  },
  {
    code: "80-361",
    city: "Gdańsk",
  },
  {
    code: "80-362",
    city: "Gdańsk",
  },
  {
    code: "80-363",
    city: "Gdańsk",
  },
  {
    code: "80-364",
    city: "Gdańsk",
  },
  {
    code: "80-365",
    city: "Gdańsk",
  },
  {
    code: "80-366",
    city: "Gdańsk",
  },
  {
    code: "80-367",
    city: "Gdańsk",
  },
  {
    code: "80-368",
    city: "Gdańsk",
  },
  {
    code: "80-369",
    city: "Gdańsk",
  },
  {
    code: "80-371",
    city: "Gdańsk",
  },
  {
    code: "80-373",
    city: "Gdańsk",
  },
  {
    code: "80-374",
    city: "Gdańsk",
  },
  {
    code: "80-375",
    city: "Gdańsk",
  },
  {
    code: "80-376",
    city: "Gdańsk",
  },
  {
    code: "80-377",
    city: "Gdańsk",
  },
  {
    code: "80-378",
    city: "Gdańsk",
  },
  {
    code: "80-379",
    city: "Gdańsk",
  },
  {
    code: "80-380",
    city: "Gdańsk",
  },
  {
    code: "80-381",
    city: "Gdańsk",
  },
  {
    code: "80-382",
    city: "Gdańsk",
  },
  {
    code: "80-383",
    city: "Gdańsk",
  },
  {
    code: "80-384",
    city: "Gdańsk",
  },
  {
    code: "80-385",
    city: "Gdańsk",
  },
  {
    code: "80-386",
    city: "Gdańsk",
  },
  {
    code: "80-387",
    city: "Gdańsk",
  },
  {
    code: "80-388",
    city: "Gdańsk",
  },
  {
    code: "80-389",
    city: "Gdańsk",
  },
  {
    code: "80-390",
    city: "Gdańsk",
  },
  {
    code: "80-391",
    city: "Gdańsk",
  },
  {
    code: "80-392",
    city: "Gdańsk",
  },
  {
    code: "80-393",
    city: "Gdańsk",
  },
  {
    code: "80-394",
    city: "Gdańsk",
  },
  {
    code: "80-395",
    city: "Gdańsk",
  },
  {
    code: "80-396",
    city: "Gdańsk",
  },
  {
    code: "80-397",
    city: "Gdańsk",
  },
  {
    code: "80-398",
    city: "Gdańsk",
  },
  {
    code: "80-399",
    city: "Gdańsk",
  },
  {
    code: "80-401",
    city: "Gdańsk",
  },
  {
    code: "80-402",
    city: "Gdańsk",
  },
  {
    code: "80-403",
    city: "Gdańsk",
  },
  {
    code: "80-404",
    city: "Gdańsk",
  },
  {
    code: "80-405",
    city: "Gdańsk",
  },
  {
    code: "80-406",
    city: "Gdańsk",
  },
  {
    code: "80-407",
    city: "Gdańsk",
  },
  {
    code: "80-408",
    city: "Gdańsk",
  },
  {
    code: "80-409",
    city: "Gdańsk",
  },
  {
    code: "80-410",
    city: "Gdańsk",
  },
  {
    code: "80-411",
    city: "Gdańsk",
  },
  {
    code: "80-412",
    city: "Gdańsk",
  },
  {
    code: "80-413",
    city: "Gdańsk",
  },
  {
    code: "80-414",
    city: "Gdańsk",
  },
  {
    code: "80-415",
    city: "Gdańsk",
  },
  {
    code: "80-416",
    city: "Gdańsk",
  },
  {
    code: "80-417",
    city: "Gdańsk",
  },
  {
    code: "80-418",
    city: "Gdańsk",
  },
  {
    code: "80-419",
    city: "Gdańsk",
  },
  {
    code: "80-420",
    city: "Gdańsk",
  },
  {
    code: "80-421",
    city: "Gdańsk",
  },
  {
    code: "80-422",
    city: "Gdańsk",
  },
  {
    code: "80-423",
    city: "Gdańsk",
  },
  {
    code: "80-424",
    city: "Gdańsk",
  },
  {
    code: "80-425",
    city: "Gdańsk",
  },
  {
    code: "80-426",
    city: "Gdańsk",
  },
  {
    code: "80-427",
    city: "Gdańsk",
  },
  {
    code: "80-430",
    city: "Gdańsk",
  },
  {
    code: "80-431",
    city: "Gdańsk",
  },
  {
    code: "80-432",
    city: "Gdańsk",
  },
  {
    code: "80-433",
    city: "Gdańsk",
  },
  {
    code: "80-434",
    city: "Gdańsk",
  },
  {
    code: "80-435",
    city: "Gdańsk",
  },
  {
    code: "80-437",
    city: "Gdańsk",
  },
  {
    code: "80-438",
    city: "Gdańsk",
  },
  {
    code: "80-440",
    city: "Gdańsk",
  },
  {
    code: "80-441",
    city: "Gdańsk",
  },
  {
    code: "80-442",
    city: "Gdańsk",
  },
  {
    code: "80-443",
    city: "Gdańsk",
  },
  {
    code: "80-444",
    city: "Gdańsk",
  },
  {
    code: "80-445",
    city: "Gdańsk",
  },
  {
    code: "80-446",
    city: "Gdańsk",
  },
  {
    code: "80-447",
    city: "Gdańsk",
  },
  {
    code: "80-448",
    city: "Gdańsk",
  },
  {
    code: "80-449",
    city: "Gdańsk",
  },
  {
    code: "80-450",
    city: "Gdańsk",
  },
  {
    code: "80-451",
    city: "Gdańsk",
  },
  {
    code: "80-452",
    city: "Gdańsk",
  },
  {
    code: "80-453",
    city: "Gdańsk",
  },
  {
    code: "80-454",
    city: "Gdańsk",
  },
  {
    code: "80-455",
    city: "Gdańsk",
  },
  {
    code: "80-456",
    city: "Gdańsk",
  },
  {
    code: "80-457",
    city: "Gdańsk",
  },
  {
    code: "80-460",
    city: "Gdańsk",
  },
  {
    code: "80-461",
    city: "Gdańsk",
  },
  {
    code: "80-462",
    city: "Gdańsk",
  },
  {
    code: "80-463",
    city: "Gdańsk",
  },
  {
    code: "80-464",
    city: "Gdańsk",
  },
  {
    code: "80-465",
    city: "Gdańsk",
  },
  {
    code: "80-471",
    city: "Gdańsk",
  },
  {
    code: "80-472",
    city: "Gdańsk",
  },
  {
    code: "80-473",
    city: "Gdańsk",
  },
  {
    code: "80-502",
    city: "Gdańsk",
  },
  {
    code: "80-503",
    city: "Gdańsk",
  },
  {
    code: "80-504",
    city: "Gdańsk",
  },
  {
    code: "80-506",
    city: "Gdańsk",
  },
  {
    code: "80-507",
    city: "Gdańsk",
  },
  {
    code: "80-508",
    city: "Gdańsk",
  },
  {
    code: "80-509",
    city: "Gdańsk",
  },
  {
    code: "80-510",
    city: "Gdańsk",
  },
  {
    code: "80-511",
    city: "Gdańsk",
  },
  {
    code: "80-512",
    city: "Gdańsk",
  },
  {
    code: "80-513",
    city: "Gdańsk",
  },
  {
    code: "80-514",
    city: "Gdańsk",
  },
  {
    code: "80-515",
    city: "Gdańsk",
  },
  {
    code: "80-516",
    city: "Gdańsk",
  },
  {
    code: "80-518",
    city: "Gdańsk",
  },
  {
    code: "80-519",
    city: "Gdańsk",
  },
  {
    code: "80-520",
    city: "Gdańsk",
  },
  {
    code: "80-522",
    city: "Gdańsk",
  },
  {
    code: "80-523",
    city: "Gdańsk",
  },
  {
    code: "80-524",
    city: "Gdańsk",
  },
  {
    code: "80-526",
    city: "Gdańsk",
  },
  {
    code: "80-528",
    city: "Gdańsk",
  },
  {
    code: "80-529",
    city: "Gdańsk",
  },
  {
    code: "80-530",
    city: "Gdańsk",
  },
  {
    code: "80-531",
    city: "Gdańsk",
  },
  {
    code: "80-532",
    city: "Gdańsk",
  },
  {
    code: "80-533",
    city: "Gdańsk",
  },
  {
    code: "80-534",
    city: "Gdańsk",
  },
  {
    code: "80-535",
    city: "Gdańsk",
  },
  {
    code: "80-536",
    city: "Gdańsk",
  },
  {
    code: "80-537",
    city: "Gdańsk",
  },
  {
    code: "80-538",
    city: "Gdańsk",
  },
  {
    code: "80-539",
    city: "Gdańsk",
  },
  {
    code: "80-540",
    city: "Gdańsk",
  },
  {
    code: "80-541",
    city: "Gdańsk",
  },
  {
    code: "80-542",
    city: "Gdańsk",
  },
  {
    code: "80-543",
    city: "Gdańsk",
  },
  {
    code: "80-544",
    city: "Gdańsk",
  },
  {
    code: "80-545",
    city: "Gdańsk",
  },
  {
    code: "80-546",
    city: "Gdańsk",
  },
  {
    code: "80-547",
    city: "Gdańsk",
  },
  {
    code: "80-548",
    city: "Gdańsk",
  },
  {
    code: "80-549",
    city: "Gdańsk",
  },
  {
    code: "80-550",
    city: "Gdańsk",
  },
  {
    code: "80-551",
    city: "Gdańsk",
  },
  {
    code: "80-553",
    city: "Gdańsk",
  },
  {
    code: "80-554",
    city: "Gdańsk",
  },
  {
    code: "80-555",
    city: "Gdańsk",
  },
  {
    code: "80-556",
    city: "Gdańsk",
  },
  {
    code: "80-557",
    city: "Gdańsk",
  },
  {
    code: "80-560",
    city: "Gdańsk",
  },
  {
    code: "80-561",
    city: "Gdańsk",
  },
  {
    code: "80-562",
    city: "Gdańsk",
  },
  {
    code: "80-563",
    city: "Gdańsk",
  },
  {
    code: "80-564",
    city: "Gdańsk",
  },
  {
    code: "80-600",
    city: "Gdańsk",
  },
  {
    code: "80-601",
    city: "Gdańsk",
  },
  {
    code: "80-603",
    city: "Gdańsk",
  },
  {
    code: "80-604",
    city: "Gdańsk",
  },
  {
    code: "80-605",
    city: "Gdańsk",
  },
  {
    code: "80-606",
    city: "Gdańsk",
  },
  {
    code: "80-607",
    city: "Gdańsk",
  },
  {
    code: "80-608",
    city: "Gdańsk",
  },
  {
    code: "80-609",
    city: "Gdańsk",
  },
  {
    code: "80-610",
    city: "Gdańsk",
  },
  {
    code: "80-611",
    city: "Gdańsk",
  },
  {
    code: "80-612",
    city: "Gdańsk",
  },
  {
    code: "80-613",
    city: "Gdańsk",
  },
  {
    code: "80-614",
    city: "Gdańsk",
  },
  {
    code: "80-616",
    city: "Gdańsk",
  },
  {
    code: "80-617",
    city: "Gdańsk",
  },
  {
    code: "80-618",
    city: "Gdańsk",
  },
  {
    code: "80-620",
    city: "Gdańsk",
  },
  {
    code: "80-621",
    city: "Gdańsk",
  },
  {
    code: "80-622",
    city: "Gdańsk",
  },
  {
    code: "80-623",
    city: "Gdańsk",
  },
  {
    code: "80-624",
    city: "Gdańsk",
  },
  {
    code: "80-625",
    city: "Gdańsk",
  },
  {
    code: "80-626",
    city: "Gdańsk",
  },
  {
    code: "80-627",
    city: "Gdańsk",
  },
  {
    code: "80-628",
    city: "Gdańsk",
  },
  {
    code: "80-629",
    city: "Gdańsk",
  },
  {
    code: "80-631",
    city: "Gdańsk",
  },
  {
    code: "80-632",
    city: "Gdańsk",
  },
  {
    code: "80-633",
    city: "Gdańsk",
  },
  {
    code: "80-634",
    city: "Gdańsk",
  },
  {
    code: "80-635",
    city: "Gdańsk",
  },
  {
    code: "80-636",
    city: "Gdańsk",
  },
  {
    code: "80-637",
    city: "Gdańsk",
  },
  {
    code: "80-638",
    city: "Gdańsk",
  },
  {
    code: "80-641",
    city: "Gdańsk",
  },
  {
    code: "80-642",
    city: "Gdańsk",
  },
  {
    code: "80-643",
    city: "Gdańsk",
  },
  {
    code: "80-644",
    city: "Gdańsk",
  },
  {
    code: "80-645",
    city: "Gdańsk",
  },
  {
    code: "80-646",
    city: "Gdańsk",
  },
  {
    code: "80-647",
    city: "Gdańsk",
  },
  {
    code: "80-648",
    city: "Gdańsk",
  },
  {
    code: "80-652",
    city: "Gdańsk",
  },
  {
    code: "80-653",
    city: "Gdańsk",
  },
  {
    code: "80-654",
    city: "Gdańsk",
  },
  {
    code: "80-656",
    city: "Gdańsk",
  },
  {
    code: "80-658",
    city: "Gdańsk",
  },
  {
    code: "80-660",
    city: "Gdańsk",
  },
  {
    code: "80-663",
    city: "Gdańsk",
  },
  {
    code: "80-665",
    city: "Gdańsk",
  },
  {
    code: "80-680",
    city: "Gdańsk",
  },
  {
    code: "80-690",
    city: "Gdańsk",
  },
  {
    code: "80-691",
    city: "Gdańsk",
  },
  {
    code: "80-701",
    city: "Gdańsk",
  },
  {
    code: "80-702",
    city: "Gdańsk",
  },
  {
    code: "80-703",
    city: "Gdańsk",
  },
  {
    code: "80-704",
    city: "Gdańsk",
  },
  {
    code: "80-705",
    city: "Gdańsk",
  },
  {
    code: "80-706",
    city: "Gdańsk",
  },
  {
    code: "80-707",
    city: "Gdańsk",
  },
  {
    code: "80-708",
    city: "Gdańsk",
  },
  {
    code: "80-711",
    city: "Gdańsk",
  },
  {
    code: "80-715",
    city: "Gdańsk",
  },
  {
    code: "80-716",
    city: "Gdańsk",
  },
  {
    code: "80-717",
    city: "Gdańsk",
  },
  {
    code: "80-718",
    city: "Gdańsk",
  },
  {
    code: "80-719",
    city: "Gdańsk",
  },
  {
    code: "80-720",
    city: "Gdańsk",
  },
  {
    code: "80-721",
    city: "Gdańsk",
  },
  {
    code: "80-722",
    city: "Gdańsk",
  },
  {
    code: "80-723",
    city: "Gdańsk",
  },
  {
    code: "80-724",
    city: "Gdańsk",
  },
  {
    code: "80-725",
    city: "Gdańsk",
  },
  {
    code: "80-726",
    city: "Gdańsk",
  },
  {
    code: "80-727",
    city: "Gdańsk",
  },
  {
    code: "80-728",
    city: "Gdańsk",
  },
  {
    code: "80-729",
    city: "Gdańsk",
  },
  {
    code: "80-730",
    city: "Gdańsk",
  },
  {
    code: "80-731",
    city: "Gdańsk",
  },
  {
    code: "80-732",
    city: "Gdańsk",
  },
  {
    code: "80-733",
    city: "Gdańsk",
  },
  {
    code: "80-734",
    city: "Gdańsk",
  },
  {
    code: "80-735",
    city: "Gdańsk",
  },
  {
    code: "80-736",
    city: "Gdańsk",
  },
  {
    code: "80-737",
    city: "Gdańsk",
  },
  {
    code: "80-738",
    city: "Gdańsk",
  },
  {
    code: "80-739",
    city: "Gdańsk",
  },
  {
    code: "80-740",
    city: "Gdańsk",
  },
  {
    code: "80-741",
    city: "Gdańsk",
  },
  {
    code: "80-742",
    city: "Gdańsk",
  },
  {
    code: "80-743",
    city: "Gdańsk",
  },
  {
    code: "80-744",
    city: "Gdańsk",
  },
  {
    code: "80-745",
    city: "Gdańsk",
  },
  {
    code: "80-746",
    city: "Gdańsk",
  },
  {
    code: "80-747",
    city: "Gdańsk",
  },
  {
    code: "80-748",
    city: "Gdańsk",
  },
  {
    code: "80-749",
    city: "Gdańsk",
  },
  {
    code: "80-750",
    city: "Gdańsk",
  },
  {
    code: "80-751",
    city: "Gdańsk",
  },
  {
    code: "80-752",
    city: "Gdańsk",
  },
  {
    code: "80-753",
    city: "Gdańsk",
  },
  {
    code: "80-754",
    city: "Gdańsk",
  },
  {
    code: "80-755",
    city: "Gdańsk",
  },
  {
    code: "80-756",
    city: "Gdańsk",
  },
  {
    code: "80-757",
    city: "Gdańsk",
  },
  {
    code: "80-758",
    city: "Gdańsk",
  },
  {
    code: "80-759",
    city: "Gdańsk",
  },
  {
    code: "80-760",
    city: "Gdańsk",
  },
  {
    code: "80-761",
    city: "Gdańsk",
  },
  {
    code: "80-762",
    city: "Gdańsk",
  },
  {
    code: "80-763",
    city: "Gdańsk",
  },
  {
    code: "80-764",
    city: "Gdańsk",
  },
  {
    code: "80-765",
    city: "Gdańsk",
  },
  {
    code: "80-766",
    city: "Gdańsk",
  },
  {
    code: "80-767",
    city: "Gdańsk",
  },
  {
    code: "80-768",
    city: "Gdańsk",
  },
  {
    code: "80-769",
    city: "Gdańsk",
  },
  {
    code: "80-770",
    city: "Gdańsk",
  },
  {
    code: "80-771",
    city: "Gdańsk",
  },
  {
    code: "80-772",
    city: "Gdańsk",
  },
  {
    code: "80-774",
    city: "Gdańsk",
  },
  {
    code: "80-776",
    city: "Gdańsk",
  },
  {
    code: "80-777",
    city: "Gdańsk",
  },
  {
    code: "80-778",
    city: "Gdańsk",
  },
  {
    code: "80-791",
    city: "Gdańsk",
  },
  {
    code: "80-792",
    city: "Gdańsk",
  },
  {
    code: "80-800",
    city: "Gdańsk",
  },
  {
    code: "80-801",
    city: "Gdańsk",
  },
  {
    code: "80-802",
    city: "Gdańsk",
  },
  {
    code: "80-803",
    city: "Gdańsk",
  },
  {
    code: "80-804",
    city: "Gdańsk",
  },
  {
    code: "80-805",
    city: "Gdańsk",
  },
  {
    code: "80-806",
    city: "Gdańsk",
  },
  {
    code: "80-807",
    city: "Gdańsk",
  },
  {
    code: "80-808",
    city: "Gdańsk",
  },
  {
    code: "80-809",
    city: "Gdańsk",
  },
  {
    code: "80-810",
    city: "Gdańsk",
  },
  {
    code: "80-811",
    city: "Gdańsk",
  },
  {
    code: "80-812",
    city: "Gdańsk",
  },
  {
    code: "80-813",
    city: "Gdańsk",
  },
  {
    code: "80-814",
    city: "Gdańsk",
  },
  {
    code: "80-815",
    city: "Gdańsk",
  },
  {
    code: "80-817",
    city: "Gdańsk",
  },
  {
    code: "80-818",
    city: "Gdańsk",
  },
  {
    code: "80-819",
    city: "Gdańsk",
  },
  {
    code: "80-820",
    city: "Gdańsk",
  },
  {
    code: "80-821",
    city: "Gdańsk",
  },
  {
    code: "80-822",
    city: "Gdańsk",
  },
  {
    code: "80-823",
    city: "Gdańsk",
  },
  {
    code: "80-824",
    city: "Gdańsk",
  },
  {
    code: "80-825",
    city: "Gdańsk",
  },
  {
    code: "80-826",
    city: "Gdańsk",
  },
  {
    code: "80-827",
    city: "Gdańsk",
  },
  {
    code: "80-828",
    city: "Gdańsk",
  },
  {
    code: "80-830",
    city: "Gdańsk",
  },
  {
    code: "80-831",
    city: "Gdańsk",
  },
  {
    code: "80-832",
    city: "Gdańsk",
  },
  {
    code: "80-833",
    city: "Gdańsk",
  },
  {
    code: "80-834",
    city: "Gdańsk",
  },
  {
    code: "80-835",
    city: "Gdańsk",
  },
  {
    code: "80-836",
    city: "Gdańsk",
  },
  {
    code: "80-837",
    city: "Gdańsk",
  },
  {
    code: "80-838",
    city: "Gdańsk",
  },
  {
    code: "80-839",
    city: "Gdańsk",
  },
  {
    code: "80-840",
    city: "Gdańsk",
  },
  {
    code: "80-841",
    city: "Gdańsk",
  },
  {
    code: "80-842",
    city: "Gdańsk",
  },
  {
    code: "80-843",
    city: "Gdańsk",
  },
  {
    code: "80-844",
    city: "Gdańsk",
  },
  {
    code: "80-845",
    city: "Gdańsk",
  },
  {
    code: "80-846",
    city: "Gdańsk",
  },
  {
    code: "80-847",
    city: "Gdańsk",
  },
  {
    code: "80-848",
    city: "Gdańsk",
  },
  {
    code: "80-849",
    city: "Gdańsk",
  },
  {
    code: "80-850",
    city: "Gdańsk",
  },
  {
    code: "80-851",
    city: "Gdańsk",
  },
  {
    code: "80-852",
    city: "Gdańsk",
  },
  {
    code: "80-853",
    city: "Gdańsk",
  },
  {
    code: "80-854",
    city: "Gdańsk",
  },
  {
    code: "80-855",
    city: "Gdańsk",
  },
  {
    code: "80-856",
    city: "Gdańsk",
  },
  {
    code: "80-857",
    city: "Gdańsk",
  },
  {
    code: "80-858",
    city: "Gdańsk",
  },
  {
    code: "80-859",
    city: "Gdańsk",
  },
  {
    code: "80-860",
    city: "Gdańsk",
  },
  {
    code: "80-861",
    city: "Gdańsk",
  },
  {
    code: "80-862",
    city: "Gdańsk",
  },
  {
    code: "80-863",
    city: "Gdańsk",
  },
  {
    code: "80-864",
    city: "Gdańsk",
  },
  {
    code: "80-865",
    city: "Gdańsk",
  },
  {
    code: "80-866",
    city: "Gdańsk",
  },
  {
    code: "80-867",
    city: "Gdańsk",
  },
  {
    code: "80-868",
    city: "Gdańsk",
  },
  {
    code: "80-869",
    city: "Gdańsk",
  },
  {
    code: "80-870",
    city: "Gdańsk",
  },
  {
    code: "80-871",
    city: "Gdańsk",
  },
  {
    code: "80-873",
    city: "Gdańsk",
  },
  {
    code: "80-874",
    city: "Gdańsk",
  },
  {
    code: "80-875",
    city: "Gdańsk",
  },
  {
    code: "80-876",
    city: "Gdańsk",
  },
  {
    code: "80-877",
    city: "Gdańsk",
  },
  {
    code: "80-878",
    city: "Gdańsk",
  },
  {
    code: "80-880",
    city: "Gdańsk",
  },
  {
    code: "80-881",
    city: "Gdańsk",
  },
  {
    code: "80-882",
    city: "Gdańsk",
  },
  {
    code: "80-883",
    city: "Gdańsk",
  },
  {
    code: "80-884",
    city: "Gdańsk",
  },
  {
    code: "80-885",
    city: "Gdańsk",
  },
  {
    code: "80-886",
    city: "Gdańsk",
  },
  {
    code: "80-887",
    city: "Gdańsk",
  },
  {
    code: "80-888",
    city: "Gdańsk",
  },
  {
    code: "80-890",
    city: "Gdańsk",
  },
  {
    code: "80-891",
    city: "Gdańsk",
  },
  {
    code: "80-893",
    city: "Gdańsk",
  },
  {
    code: "80-894",
    city: "Gdańsk",
  },
  {
    code: "80-895",
    city: "Gdańsk",
  },
  {
    code: "80-900",
    city: "Gdańsk",
  },
  {
    code: "80-917",
    city: "Gdańsk",
  },
  {
    code: "80-940",
    city: "Gdańsk",
  },
  {
    code: "80-952",
    city: "Gdańsk",
  },
  {
    code: "80-953",
    city: "Gdańsk",
  },
  {
    code: "80-955",
    city: "Gdańsk",
  },
  {
    code: "80-958",
    city: "Gdańsk",
  },
  {
    code: "80-961",
    city: "Gdańsk",
  },
  {
    code: "80-962",
    city: "Gdańsk",
  },
  {
    code: "80-963",
    city: "Gdańsk",
  },
  {
    code: "80-964",
    city: "Gdańsk",
  },
  {
    code: "80-980",
    city: "Gdańsk",
  },
  {
    code: "81-000",
    city: "Gdynia",
  },
  {
    code: "81-001",
    city: "Gdynia",
  },
  {
    code: "81-002",
    city: "Gdynia",
  },
  {
    code: "81-003",
    city: "Gdynia",
  },
  {
    code: "81-004",
    city: "Gdynia",
  },
  {
    code: "81-005",
    city: "Gdynia",
  },
  {
    code: "81-006",
    city: "Gdynia",
  },
  {
    code: "81-007",
    city: "Gdynia",
  },
  {
    code: "81-008",
    city: "Gdynia",
  },
  {
    code: "81-009",
    city: "Gdynia",
  },
  {
    code: "81-010",
    city: "Gdynia",
  },
  {
    code: "81-012",
    city: "Gdynia",
  },
  {
    code: "81-015",
    city: "Gdynia",
  },
  {
    code: "81-016",
    city: "Gdynia",
  },
  {
    code: "81-017",
    city: "Gdynia",
  },
  {
    code: "81-018",
    city: "Gdynia",
  },
  {
    code: "81-019",
    city: "Gdynia",
  },
  {
    code: "81-020",
    city: "Gdynia",
  },
  {
    code: "81-021",
    city: "Gdynia",
  },
  {
    code: "81-022",
    city: "Gdynia",
  },
  {
    code: "81-023",
    city: "Gdynia",
  },
  {
    code: "81-024",
    city: "Gdynia",
  },
  {
    code: "81-025",
    city: "Gdynia",
  },
  {
    code: "81-028",
    city: "Gdynia",
  },
  {
    code: "81-029",
    city: "Gdynia",
  },
  {
    code: "81-033",
    city: "Gdynia",
  },
  {
    code: "81-034",
    city: "Gdynia",
  },
  {
    code: "81-035",
    city: "Gdynia",
  },
  {
    code: "81-036",
    city: "Gdynia",
  },
  {
    code: "81-037",
    city: "Gdynia",
  },
  {
    code: "81-040",
    city: "Gdynia",
  },
  {
    code: "81-041",
    city: "Gdynia",
  },
  {
    code: "81-042",
    city: "Gdynia",
  },
  {
    code: "81-044",
    city: "Gdynia",
  },
  {
    code: "81-045",
    city: "Gdynia",
  },
  {
    code: "81-047",
    city: "Gdynia",
  },
  {
    code: "81-048",
    city: "Gdynia",
  },
  {
    code: "81-049",
    city: "Gdynia",
  },
  {
    code: "81-050",
    city: "Gdynia",
  },
  {
    code: "81-051",
    city: "Gdynia",
  },
  {
    code: "81-052",
    city: "Gdynia",
  },
  {
    code: "81-053",
    city: "Gdynia",
  },
  {
    code: "81-055",
    city: "Gdynia",
  },
  {
    code: "81-056",
    city: "Gdynia",
  },
  {
    code: "81-057",
    city: "Gdynia",
  },
  {
    code: "81-058",
    city: "Gdynia",
  },
  {
    code: "81-059",
    city: "Gdynia",
  },
  {
    code: "81-060",
    city: "Gdynia",
  },
  {
    code: "81-061",
    city: "Gdynia",
  },
  {
    code: "81-062",
    city: "Gdynia",
  },
  {
    code: "81-063",
    city: "Gdynia",
  },
  {
    code: "81-064",
    city: "Gdynia",
  },
  {
    code: "81-065",
    city: "Gdynia",
  },
  {
    code: "81-066",
    city: "Gdynia",
  },
  {
    code: "81-068",
    city: "Gdynia",
  },
  {
    code: "81-072",
    city: "Gdynia",
  },
  {
    code: "81-074",
    city: "Gdynia",
  },
  {
    code: "81-075",
    city: "Gdynia",
  },
  {
    code: "81-076",
    city: "Gdynia",
  },
  {
    code: "81-077",
    city: "Gdynia",
  },
  {
    code: "81-078",
    city: "Gdynia",
  },
  {
    code: "81-079",
    city: "Gdynia",
  },
  {
    code: "81-080",
    city: "Gdynia",
  },
  {
    code: "81-081",
    city: "Gdynia",
  },
  {
    code: "81-082",
    city: "Gdynia",
  },
  {
    code: "81-083",
    city: "Gdynia",
  },
  {
    code: "81-084",
    city: "Gdynia",
  },
  {
    code: "81-085",
    city: "Gdynia",
  },
  {
    code: "81-086",
    city: "Gdynia",
  },
  {
    code: "81-087",
    city: "Gdynia",
  },
  {
    code: "81-089",
    city: "Gdynia",
  },
  {
    code: "81-092",
    city: "Gdynia",
  },
  {
    code: "81-094",
    city: "Gdynia",
  },
  {
    code: "81-095",
    city: "Gdynia",
  },
  {
    code: "81-097",
    city: "Gdynia",
  },
  {
    code: "81-100",
    city: "Gdynia",
  },
  {
    code: "81-101",
    city: "Gdynia",
  },
  {
    code: "81-102",
    city: "Gdynia",
  },
  {
    code: "81-103",
    city: "Gdynia",
  },
  {
    code: "81-104",
    city: "Gdynia",
  },
  {
    code: "81-105",
    city: "Gdynia",
  },
  {
    code: "81-106",
    city: "Gdynia",
  },
  {
    code: "81-107",
    city: "Gdynia",
  },
  {
    code: "81-108",
    city: "Gdynia",
  },
  {
    code: "81-109",
    city: "Gdynia",
  },
  {
    code: "81-110",
    city: "Gdynia",
  },
  {
    code: "81-111",
    city: "Gdynia",
  },
  {
    code: "81-112",
    city: "Gdynia",
  },
  {
    code: "81-113",
    city: "Gdynia",
  },
  {
    code: "81-114",
    city: "Gdynia",
  },
  {
    code: "81-115",
    city: "Gdynia",
  },
  {
    code: "81-116",
    city: "Gdynia",
  },
  {
    code: "81-117",
    city: "Gdynia",
  },
  {
    code: "81-118",
    city: "Gdynia",
  },
  {
    code: "81-120",
    city: "Gdynia",
  },
  {
    code: "81-121",
    city: "Gdynia",
  },
  {
    code: "81-122",
    city: "Gdynia",
  },
  {
    code: "81-123",
    city: "Gdynia",
  },
  {
    code: "81-124",
    city: "Gdynia",
  },
  {
    code: "81-125",
    city: "Gdynia",
  },
  {
    code: "81-127",
    city: "Gdynia",
  },
  {
    code: "81-130",
    city: "Gdynia",
  },
  {
    code: "81-131",
    city: "Gdynia",
  },
  {
    code: "81-132",
    city: "Gdynia",
  },
  {
    code: "81-133",
    city: "Gdynia",
  },
  {
    code: "81-134",
    city: "Gdynia",
  },
  {
    code: "81-136",
    city: "Gdynia",
  },
  {
    code: "81-137",
    city: "Gdynia",
  },
  {
    code: "81-138",
    city: "Gdynia",
  },
  {
    code: "81-146",
    city: "Gdynia",
  },
  {
    code: "81-147",
    city: "Gdynia",
  },
  {
    code: "81-148",
    city: "Gdynia",
  },
  {
    code: "81-149",
    city: "Gdynia",
  },
  {
    code: "81-150",
    city: "Gdynia",
  },
  {
    code: "81-151",
    city: "Gdynia",
  },
  {
    code: "81-152",
    city: "Gdynia",
  },
  {
    code: "81-153",
    city: "Gdynia",
  },
  {
    code: "81-154",
    city: "Gdynia",
  },
  {
    code: "81-155",
    city: "Gdynia",
  },
  {
    code: "81-156",
    city: "Gdynia",
  },
  {
    code: "81-157",
    city: "Gdynia",
  },
  {
    code: "81-158",
    city: "Gdynia",
  },
  {
    code: "81-159",
    city: "Gdynia",
  },
  {
    code: "81-160",
    city: "Gdynia",
  },
  {
    code: "81-161",
    city: "Gdynia",
  },
  {
    code: "81-162",
    city: "Gdynia",
  },
  {
    code: "81-163",
    city: "Gdynia",
  },
  {
    code: "81-164",
    city: "Gdynia",
  },
  {
    code: "81-165",
    city: "Gdynia",
  },
  {
    code: "81-166",
    city: "Gdynia",
  },
  {
    code: "81-167",
    city: "Gdynia",
  },
  {
    code: "81-168",
    city: "Gdynia",
  },
  {
    code: "81-169",
    city: "Gdynia",
  },
  {
    code: "81-170",
    city: "Gdynia",
  },
  {
    code: "81-171",
    city: "Gdynia",
  },
  {
    code: "81-172",
    city: "Gdynia",
  },
  {
    code: "81-173",
    city: "Gdynia",
  },
  {
    code: "81-174",
    city: "Gdynia",
  },
  {
    code: "81-175",
    city: "Gdynia",
  },
  {
    code: "81-176",
    city: "Gdynia",
  },
  {
    code: "81-177",
    city: "Gdynia",
  },
  {
    code: "81-178",
    city: "Gdynia",
  },
  {
    code: "81-179",
    city: "Gdynia",
  },
  {
    code: "81-180",
    city: "Gdynia",
  },
  {
    code: "81-181",
    city: "Gdynia",
  },
  {
    code: "81-182",
    city: "Gdynia",
  },
  {
    code: "81-183",
    city: "Gdynia",
  },
  {
    code: "81-184",
    city: "Gdynia",
  },
  {
    code: "81-185",
    city: "Gdynia",
  },
  {
    code: "81-187",
    city: "Gdynia",
  },
  {
    code: "81-188",
    city: "Gdynia",
  },
  {
    code: "81-189",
    city: "Gdynia",
  },
  {
    code: "81-190",
    city: "Gdynia",
  },
  {
    code: "81-191",
    city: "Gdynia",
  },
  {
    code: "81-192",
    city: "Gdynia",
  },
  {
    code: "81-193",
    city: "Gdynia",
  },
  {
    code: "81-194",
    city: "Gdynia",
  },
  {
    code: "81-195",
    city: "Gdynia",
  },
  {
    code: "81-197",
    city: "Gdynia",
  },
  {
    code: "81-198",
    city: "Kosakowo",
  },
  {
    code: "81-200",
    city: "Gdynia",
  },
  {
    code: "81-201",
    city: "Gdynia",
  },
  {
    code: "81-202",
    city: "Gdynia",
  },
  {
    code: "81-203",
    city: "Gdynia",
  },
  {
    code: "81-204",
    city: "Gdynia",
  },
  {
    code: "81-207",
    city: "Gdynia",
  },
  {
    code: "81-208",
    city: "Gdynia",
  },
  {
    code: "81-209",
    city: "Gdynia",
  },
  {
    code: "81-210",
    city: "Gdynia",
  },
  {
    code: "81-211",
    city: "Gdynia",
  },
  {
    code: "81-212",
    city: "Gdynia",
  },
  {
    code: "81-213",
    city: "Gdynia",
  },
  {
    code: "81-214",
    city: "Gdynia",
  },
  {
    code: "81-215",
    city: "Gdynia",
  },
  {
    code: "81-217",
    city: "Gdynia",
  },
  {
    code: "81-218",
    city: "Gdynia",
  },
  {
    code: "81-219",
    city: "Gdynia",
  },
  {
    code: "81-220",
    city: "Gdynia",
  },
  {
    code: "81-221",
    city: "Gdynia",
  },
  {
    code: "81-222",
    city: "Gdynia",
  },
  {
    code: "81-223",
    city: "Gdynia",
  },
  {
    code: "81-224",
    city: "Gdynia",
  },
  {
    code: "81-225",
    city: "Gdynia",
  },
  {
    code: "81-226",
    city: "Gdynia",
  },
  {
    code: "81-228",
    city: "Gdynia",
  },
  {
    code: "81-229",
    city: "Gdynia",
  },
  {
    code: "81-230",
    city: "Gdynia",
  },
  {
    code: "81-231",
    city: "Gdynia",
  },
  {
    code: "81-232",
    city: "Gdynia",
  },
  {
    code: "81-233",
    city: "Gdynia",
  },
  {
    code: "81-234",
    city: "Gdynia",
  },
  {
    code: "81-235",
    city: "Gdynia",
  },
  {
    code: "81-236",
    city: "Gdynia",
  },
  {
    code: "81-237",
    city: "Gdynia",
  },
  {
    code: "81-241",
    city: "Gdynia",
  },
  {
    code: "81-242",
    city: "Gdynia",
  },
  {
    code: "81-244",
    city: "Gdynia",
  },
  {
    code: "81-245",
    city: "Gdynia",
  },
  {
    code: "81-249",
    city: "Gdynia",
  },
  {
    code: "81-250",
    city: "Gdynia",
  },
  {
    code: "81-253",
    city: "Gdynia",
  },
  {
    code: "81-254",
    city: "Gdynia",
  },
  {
    code: "81-255",
    city: "Gdynia",
  },
  {
    code: "81-256",
    city: "Gdynia",
  },
  {
    code: "81-257",
    city: "Gdynia",
  },
  {
    code: "81-258",
    city: "Gdynia",
  },
  {
    code: "81-259",
    city: "Gdynia",
  },
  {
    code: "81-260",
    city: "Gdynia",
  },
  {
    code: "81-261",
    city: "Gdynia",
  },
  {
    code: "81-262",
    city: "Gdynia",
  },
  {
    code: "81-263",
    city: "Gdynia",
  },
  {
    code: "81-265",
    city: "Gdynia",
  },
  {
    code: "81-266",
    city: "Gdynia",
  },
  {
    code: "81-267",
    city: "Gdynia",
  },
  {
    code: "81-268",
    city: "Gdynia",
  },
  {
    code: "81-269",
    city: "Gdynia",
  },
  {
    code: "81-270",
    city: "Gdynia",
  },
  {
    code: "81-271",
    city: "Gdynia",
  },
  {
    code: "81-272",
    city: "Gdynia",
  },
  {
    code: "81-273",
    city: "Gdynia",
  },
  {
    code: "81-290",
    city: "Gdynia",
  },
  {
    code: "81-300",
    city: "Gdynia",
  },
  {
    code: "81-301",
    city: "Gdynia",
  },
  {
    code: "81-302",
    city: "Gdynia",
  },
  {
    code: "81-303",
    city: "Gdynia",
  },
  {
    code: "81-304",
    city: "Gdynia",
  },
  {
    code: "81-305",
    city: "Gdynia",
  },
  {
    code: "81-306",
    city: "Gdynia",
  },
  {
    code: "81-308",
    city: "Gdynia",
  },
  {
    code: "81-309",
    city: "Gdynia",
  },
  {
    code: "81-310",
    city: "Gdynia",
  },
  {
    code: "81-311",
    city: "Gdynia",
  },
  {
    code: "81-312",
    city: "Gdynia",
  },
  {
    code: "81-313",
    city: "Gdynia",
  },
  {
    code: "81-314",
    city: "Gdynia",
  },
  {
    code: "81-315",
    city: "Gdynia",
  },
  {
    code: "81-316",
    city: "Gdynia",
  },
  {
    code: "81-317",
    city: "Gdynia",
  },
  {
    code: "81-319",
    city: "Gdynia",
  },
  {
    code: "81-320",
    city: "Gdynia",
  },
  {
    code: "81-321",
    city: "Gdynia",
  },
  {
    code: "81-322",
    city: "Gdynia",
  },
  {
    code: "81-323",
    city: "Gdynia",
  },
  {
    code: "81-324",
    city: "Gdynia",
  },
  {
    code: "81-325",
    city: "Gdynia",
  },
  {
    code: "81-326",
    city: "Gdynia",
  },
  {
    code: "81-327",
    city: "Gdynia",
  },
  {
    code: "81-328",
    city: "Gdynia",
  },
  {
    code: "81-329",
    city: "Gdynia",
  },
  {
    code: "81-330",
    city: "Gdynia",
  },
  {
    code: "81-331",
    city: "Gdynia",
  },
  {
    code: "81-332",
    city: "Gdynia",
  },
  {
    code: "81-333",
    city: "Gdynia",
  },
  {
    code: "81-334",
    city: "Gdynia",
  },
  {
    code: "81-335",
    city: "Gdynia",
  },
  {
    code: "81-336",
    city: "Gdynia",
  },
  {
    code: "81-337",
    city: "Gdynia",
  },
  {
    code: "81-338",
    city: "Gdynia",
  },
  {
    code: "81-339",
    city: "Gdynia",
  },
  {
    code: "81-340",
    city: "Gdynia",
  },
  {
    code: "81-341",
    city: "Gdynia",
  },
  {
    code: "81-342",
    city: "Gdynia",
  },
  {
    code: "81-343",
    city: "Gdynia",
  },
  {
    code: "81-345",
    city: "Gdynia",
  },
  {
    code: "81-346",
    city: "Gdynia",
  },
  {
    code: "81-347",
    city: "Gdynia",
  },
  {
    code: "81-348",
    city: "Gdynia",
  },
  {
    code: "81-349",
    city: "Gdynia",
  },
  {
    code: "81-350",
    city: "Gdynia",
  },
  {
    code: "81-351",
    city: "Gdynia",
  },
  {
    code: "81-352",
    city: "Gdynia",
  },
  {
    code: "81-353",
    city: "Gdynia",
  },
  {
    code: "81-354",
    city: "Gdynia",
  },
  {
    code: "81-355",
    city: "Gdynia",
  },
  {
    code: "81-356",
    city: "Gdynia",
  },
  {
    code: "81-357",
    city: "Gdynia",
  },
  {
    code: "81-358",
    city: "Gdynia",
  },
  {
    code: "81-359",
    city: "Gdynia",
  },
  {
    code: "81-361",
    city: "Gdynia",
  },
  {
    code: "81-362",
    city: "Gdynia",
  },
  {
    code: "81-363",
    city: "Gdynia",
  },
  {
    code: "81-364",
    city: "Gdynia",
  },
  {
    code: "81-365",
    city: "Gdynia",
  },
  {
    code: "81-366",
    city: "Gdynia",
  },
  {
    code: "81-367",
    city: "Gdynia",
  },
  {
    code: "81-368",
    city: "Gdynia",
  },
  {
    code: "81-369",
    city: "Gdynia",
  },
  {
    code: "81-370",
    city: "Gdynia",
  },
  {
    code: "81-371",
    city: "Gdynia",
  },
  {
    code: "81-372",
    city: "Gdynia",
  },
  {
    code: "81-373",
    city: "Gdynia",
  },
  {
    code: "81-374",
    city: "Gdynia",
  },
  {
    code: "81-375",
    city: "Gdynia",
  },
  {
    code: "81-376",
    city: "Gdynia",
  },
  {
    code: "81-377",
    city: "Gdynia",
  },
  {
    code: "81-378",
    city: "Gdynia",
  },
  {
    code: "81-379",
    city: "Gdynia",
  },
  {
    code: "81-380",
    city: "Gdynia",
  },
  {
    code: "81-381",
    city: "Gdynia",
  },
  {
    code: "81-382",
    city: "Gdynia",
  },
  {
    code: "81-383",
    city: "Gdynia",
  },
  {
    code: "81-384",
    city: "Gdynia",
  },
  {
    code: "81-385",
    city: "Gdynia",
  },
  {
    code: "81-386",
    city: "Gdynia",
  },
  {
    code: "81-387",
    city: "Gdynia",
  },
  {
    code: "81-388",
    city: "Gdynia",
  },
  {
    code: "81-389",
    city: "Gdynia",
  },
  {
    code: "81-390",
    city: "Gdynia",
  },
  {
    code: "81-391",
    city: "Gdynia",
  },
  {
    code: "81-392",
    city: "Gdynia",
  },
  {
    code: "81-393",
    city: "Gdynia",
  },
  {
    code: "81-394",
    city: "Gdynia",
  },
  {
    code: "81-395",
    city: "Gdynia",
  },
  {
    code: "81-396",
    city: "Gdynia",
  },
  {
    code: "81-397",
    city: "Gdynia",
  },
  {
    code: "81-399",
    city: "Gdynia",
  },
  {
    code: "81-400",
    city: "Gdynia",
  },
  {
    code: "81-401",
    city: "Gdynia",
  },
  {
    code: "81-402",
    city: "Gdynia",
  },
  {
    code: "81-403",
    city: "Gdynia",
  },
  {
    code: "81-404",
    city: "Gdynia",
  },
  {
    code: "81-405",
    city: "Gdynia",
  },
  {
    code: "81-406",
    city: "Gdynia",
  },
  {
    code: "81-407",
    city: "Gdynia",
  },
  {
    code: "81-408",
    city: "Gdynia",
  },
  {
    code: "81-409",
    city: "Gdynia",
  },
  {
    code: "81-410",
    city: "Gdynia",
  },
  {
    code: "81-411",
    city: "Gdynia",
  },
  {
    code: "81-412",
    city: "Gdynia",
  },
  {
    code: "81-413",
    city: "Gdynia",
  },
  {
    code: "81-414",
    city: "Gdynia",
  },
  {
    code: "81-415",
    city: "Gdynia",
  },
  {
    code: "81-416",
    city: "Gdynia",
  },
  {
    code: "81-417",
    city: "Gdynia",
  },
  {
    code: "81-418",
    city: "Gdynia",
  },
  {
    code: "81-420",
    city: "Gdynia",
  },
  {
    code: "81-421",
    city: "Gdynia",
  },
  {
    code: "81-422",
    city: "Gdynia",
  },
  {
    code: "81-423",
    city: "Gdynia",
  },
  {
    code: "81-424",
    city: "Gdynia",
  },
  {
    code: "81-425",
    city: "Gdynia",
  },
  {
    code: "81-426",
    city: "Gdynia",
  },
  {
    code: "81-427",
    city: "Gdynia",
  },
  {
    code: "81-428",
    city: "Gdynia",
  },
  {
    code: "81-429",
    city: "Gdynia",
  },
  {
    code: "81-431",
    city: "Gdynia",
  },
  {
    code: "81-432",
    city: "Gdynia",
  },
  {
    code: "81-433",
    city: "Gdynia",
  },
  {
    code: "81-434",
    city: "Gdynia",
  },
  {
    code: "81-435",
    city: "Gdynia",
  },
  {
    code: "81-436",
    city: "Gdynia",
  },
  {
    code: "81-437",
    city: "Gdynia",
  },
  {
    code: "81-438",
    city: "Gdynia",
  },
  {
    code: "81-439",
    city: "Gdynia",
  },
  {
    code: "81-440",
    city: "Gdynia",
  },
  {
    code: "81-441",
    city: "Gdynia",
  },
  {
    code: "81-442",
    city: "Gdynia",
  },
  {
    code: "81-448",
    city: "Gdynia",
  },
  {
    code: "81-449",
    city: "Gdynia",
  },
  {
    code: "81-450",
    city: "Gdynia",
  },
  {
    code: "81-451",
    city: "Gdynia",
  },
  {
    code: "81-452",
    city: "Gdynia",
  },
  {
    code: "81-453",
    city: "Gdynia",
  },
  {
    code: "81-454",
    city: "Gdynia",
  },
  {
    code: "81-455",
    city: "Gdynia",
  },
  {
    code: "81-456",
    city: "Gdynia",
  },
  {
    code: "81-457",
    city: "Gdynia",
  },
  {
    code: "81-458",
    city: "Gdynia",
  },
  {
    code: "81-459",
    city: "Gdynia",
  },
  {
    code: "81-460",
    city: "Gdynia",
  },
  {
    code: "81-461",
    city: "Gdynia",
  },
  {
    code: "81-462",
    city: "Gdynia",
  },
  {
    code: "81-463",
    city: "Gdynia",
  },
  {
    code: "81-464",
    city: "Gdynia",
  },
  {
    code: "81-465",
    city: "Gdynia",
  },
  {
    code: "81-466",
    city: "Gdynia",
  },
  {
    code: "81-467",
    city: "Gdynia",
  },
  {
    code: "81-468",
    city: "Gdynia",
  },
  {
    code: "81-469",
    city: "Gdynia",
  },
  {
    code: "81-470",
    city: "Gdynia",
  },
  {
    code: "81-471",
    city: "Gdynia",
  },
  {
    code: "81-472",
    city: "Gdynia",
  },
  {
    code: "81-473",
    city: "Gdynia",
  },
  {
    code: "81-474",
    city: "Gdynia",
  },
  {
    code: "81-475",
    city: "Gdynia",
  },
  {
    code: "81-476",
    city: "Gdynia",
  },
  {
    code: "81-500",
    city: "Gdynia",
  },
  {
    code: "81-501",
    city: "Gdynia",
  },
  {
    code: "81-502",
    city: "Gdynia",
  },
  {
    code: "81-503",
    city: "Gdynia",
  },
  {
    code: "81-504",
    city: "Gdynia",
  },
  {
    code: "81-505",
    city: "Gdynia",
  },
  {
    code: "81-506",
    city: "Gdynia",
  },
  {
    code: "81-507",
    city: "Gdynia",
  },
  {
    code: "81-508",
    city: "Gdynia",
  },
  {
    code: "81-509",
    city: "Gdynia",
  },
  {
    code: "81-510",
    city: "Gdynia",
  },
  {
    code: "81-511",
    city: "Gdynia",
  },
  {
    code: "81-512",
    city: "Gdynia",
  },
  {
    code: "81-513",
    city: "Gdynia",
  },
  {
    code: "81-514",
    city: "Gdynia",
  },
  {
    code: "81-515",
    city: "Gdynia",
  },
  {
    code: "81-516",
    city: "Gdynia",
  },
  {
    code: "81-517",
    city: "Gdynia",
  },
  {
    code: "81-518",
    city: "Gdynia",
  },
  {
    code: "81-519",
    city: "Gdynia",
  },
  {
    code: "81-520",
    city: "Gdynia",
  },
  {
    code: "81-521",
    city: "Gdynia",
  },
  {
    code: "81-522",
    city: "Gdynia",
  },
  {
    code: "81-523",
    city: "Gdynia",
  },
  {
    code: "81-524",
    city: "Gdynia",
  },
  {
    code: "81-525",
    city: "Gdynia",
  },
  {
    code: "81-526",
    city: "Gdynia",
  },
  {
    code: "81-527",
    city: "Gdynia",
  },
  {
    code: "81-528",
    city: "Gdynia",
  },
  {
    code: "81-529",
    city: "Gdynia",
  },
  {
    code: "81-532",
    city: "Gdynia",
  },
  {
    code: "81-533",
    city: "Gdynia",
  },
  {
    code: "81-534",
    city: "Gdynia",
  },
  {
    code: "81-535",
    city: "Gdynia",
  },
  {
    code: "81-536",
    city: "Gdynia",
  },
  {
    code: "81-537",
    city: "Gdynia",
  },
  {
    code: "81-538",
    city: "Gdynia",
  },
  {
    code: "81-539",
    city: "Gdynia",
  },
  {
    code: "81-540",
    city: "Gdynia",
  },
  {
    code: "81-541",
    city: "Gdynia",
  },
  {
    code: "81-542",
    city: "Gdynia",
  },
  {
    code: "81-543",
    city: "Gdynia",
  },
  {
    code: "81-544",
    city: "Gdynia",
  },
  {
    code: "81-545",
    city: "Gdynia",
  },
  {
    code: "81-547",
    city: "Gdynia",
  },
  {
    code: "81-548",
    city: "Gdynia",
  },
  {
    code: "81-549",
    city: "Gdynia",
  },
  {
    code: "81-550",
    city: "Gdynia",
  },
  {
    code: "81-551",
    city: "Gdynia",
  },
  {
    code: "81-553",
    city: "Gdynia",
  },
  {
    code: "81-554",
    city: "Gdynia",
  },
  {
    code: "81-555",
    city: "Gdynia",
  },
  {
    code: "81-556",
    city: "Gdynia",
  },
  {
    code: "81-558",
    city: "Gdynia",
  },
  {
    code: "81-559",
    city: "Gdynia",
  },
  {
    code: "81-560",
    city: "Gdynia",
  },
  {
    code: "81-562",
    city: "Gdynia",
  },
  {
    code: "81-570",
    city: "Gdynia",
  },
  {
    code: "81-571",
    city: "Gdynia",
  },
  {
    code: "81-572",
    city: "Gdynia",
  },
  {
    code: "81-573",
    city: "Gdynia",
  },
  {
    code: "81-574",
    city: "Gdynia",
  },
  {
    code: "81-575",
    city: "Gdynia",
  },
  {
    code: "81-576",
    city: "Gdynia",
  },
  {
    code: "81-577",
    city: "Gdynia",
  },
  {
    code: "81-578",
    city: "Gdynia",
  },
  {
    code: "81-579",
    city: "Gdynia",
  },
  {
    code: "81-580",
    city: "Gdynia",
  },
  {
    code: "81-581",
    city: "Gdynia",
  },
  {
    code: "81-582",
    city: "Gdynia",
  },
  {
    code: "81-583",
    city: "Gdynia",
  },
  {
    code: "81-584",
    city: "Gdynia",
  },
  {
    code: "81-585",
    city: "Gdynia",
  },
  {
    code: "81-586",
    city: "Gdynia",
  },
  {
    code: "81-587",
    city: "Gdynia",
  },
  {
    code: "81-589",
    city: "Gdynia",
  },
  {
    code: "81-591",
    city: "Gdynia",
  },
  {
    code: "81-592",
    city: "Gdynia",
  },
  {
    code: "81-593",
    city: "Gdynia",
  },
  {
    code: "81-595",
    city: "Gdynia",
  },
  {
    code: "81-596",
    city: "Gdynia",
  },
  {
    code: "81-597",
    city: "Gdynia",
  },
  {
    code: "81-598",
    city: "Gdynia",
  },
  {
    code: "81-601",
    city: "Gdynia",
  },
  {
    code: "81-602",
    city: "Gdynia",
  },
  {
    code: "81-603",
    city: "Gdynia",
  },
  {
    code: "81-604",
    city: "Gdynia",
  },
  {
    code: "81-605",
    city: "Gdynia",
  },
  {
    code: "81-606",
    city: "Gdynia",
  },
  {
    code: "81-607",
    city: "Gdynia",
  },
  {
    code: "81-608",
    city: "Gdynia",
  },
  {
    code: "81-609",
    city: "Gdynia",
  },
  {
    code: "81-611",
    city: "Gdynia",
  },
  {
    code: "81-612",
    city: "Gdynia",
  },
  {
    code: "81-613",
    city: "Gdynia",
  },
  {
    code: "81-614",
    city: "Gdynia",
  },
  {
    code: "81-615",
    city: "Gdynia",
  },
  {
    code: "81-616",
    city: "Gdynia",
  },
  {
    code: "81-617",
    city: "Gdynia",
  },
  {
    code: "81-619",
    city: "Gdynia",
  },
  {
    code: "81-620",
    city: "Gdynia",
  },
  {
    code: "81-621",
    city: "Gdynia",
  },
  {
    code: "81-622",
    city: "Gdynia",
  },
  {
    code: "81-623",
    city: "Gdynia",
  },
  {
    code: "81-624",
    city: "Gdynia",
  },
  {
    code: "81-625",
    city: "Gdynia",
  },
  {
    code: "81-626",
    city: "Gdynia",
  },
  {
    code: "81-627",
    city: "Gdynia",
  },
  {
    code: "81-628",
    city: "Gdynia",
  },
  {
    code: "81-629",
    city: "Gdynia",
  },
  {
    code: "81-630",
    city: "Gdynia",
  },
  {
    code: "81-631",
    city: "Gdynia",
  },
  {
    code: "81-632",
    city: "Gdynia",
  },
  {
    code: "81-633",
    city: "Gdynia",
  },
  {
    code: "81-634",
    city: "Gdynia",
  },
  {
    code: "81-635",
    city: "Gdynia",
  },
  {
    code: "81-636",
    city: "Gdynia",
  },
  {
    code: "81-637",
    city: "Gdynia",
  },
  {
    code: "81-638",
    city: "Gdynia",
  },
  {
    code: "81-639",
    city: "Gdynia",
  },
  {
    code: "81-640",
    city: "Gdynia",
  },
  {
    code: "81-641",
    city: "Gdynia",
  },
  {
    code: "81-645",
    city: "Gdynia",
  },
  {
    code: "81-646",
    city: "Gdynia",
  },
  {
    code: "81-647",
    city: "Gdynia",
  },
  {
    code: "81-649",
    city: "Gdynia",
  },
  {
    code: "81-650",
    city: "Gdynia",
  },
  {
    code: "81-651",
    city: "Gdynia",
  },
  {
    code: "81-653",
    city: "Gdynia",
  },
  {
    code: "81-654",
    city: "Gdynia",
  },
  {
    code: "81-655",
    city: "Gdynia",
  },
  {
    code: "81-656",
    city: "Gdynia",
  },
  {
    code: "81-657",
    city: "Gdynia",
  },
  {
    code: "81-658",
    city: "Gdynia",
  },
  {
    code: "81-659",
    city: "Gdynia",
  },
  {
    code: "81-660",
    city: "Gdynia",
  },
  {
    code: "81-661",
    city: "Gdynia",
  },
  {
    code: "81-701",
    city: "Sopot",
  },
  {
    code: "81-702",
    city: "Sopot",
  },
  {
    code: "81-703",
    city: "Sopot",
  },
  {
    code: "81-704",
    city: "Sopot",
  },
  {
    code: "81-705",
    city: "Sopot",
  },
  {
    code: "81-706",
    city: "Sopot",
  },
  {
    code: "81-707",
    city: "Sopot",
  },
  {
    code: "81-708",
    city: "Sopot",
  },
  {
    code: "81-709",
    city: "Sopot",
  },
  {
    code: "81-710",
    city: "Sopot",
  },
  {
    code: "81-711",
    city: "Sopot",
  },
  {
    code: "81-712",
    city: "Sopot",
  },
  {
    code: "81-713",
    city: "Sopot",
  },
  {
    code: "81-714",
    city: "Sopot",
  },
  {
    code: "81-715",
    city: "Sopot",
  },
  {
    code: "81-716",
    city: "Sopot",
  },
  {
    code: "81-717",
    city: "Sopot",
  },
  {
    code: "81-718",
    city: "Sopot",
  },
  {
    code: "81-719",
    city: "Sopot",
  },
  {
    code: "81-720",
    city: "Sopot",
  },
  {
    code: "81-721",
    city: "Sopot",
  },
  {
    code: "81-722",
    city: "Sopot",
  },
  {
    code: "81-723",
    city: "Sopot",
  },
  {
    code: "81-724",
    city: "Sopot",
  },
  {
    code: "81-725",
    city: "Sopot",
  },
  {
    code: "81-726",
    city: "Sopot",
  },
  {
    code: "81-727",
    city: "Sopot",
  },
  {
    code: "81-728",
    city: "Sopot",
  },
  {
    code: "81-729",
    city: "Sopot",
  },
  {
    code: "81-730",
    city: "Sopot",
  },
  {
    code: "81-731",
    city: "Sopot",
  },
  {
    code: "81-732",
    city: "Sopot",
  },
  {
    code: "81-733",
    city: "Sopot",
  },
  {
    code: "81-734",
    city: "Sopot",
  },
  {
    code: "81-735",
    city: "Sopot",
  },
  {
    code: "81-736",
    city: "Sopot",
  },
  {
    code: "81-737",
    city: "Sopot",
  },
  {
    code: "81-738",
    city: "Sopot",
  },
  {
    code: "81-739",
    city: "Sopot",
  },
  {
    code: "81-740",
    city: "Sopot",
  },
  {
    code: "81-741",
    city: "Sopot",
  },
  {
    code: "81-742",
    city: "Sopot",
  },
  {
    code: "81-743",
    city: "Sopot",
  },
  {
    code: "81-744",
    city: "Sopot",
  },
  {
    code: "81-745",
    city: "Sopot",
  },
  {
    code: "81-746",
    city: "Sopot",
  },
  {
    code: "81-747",
    city: "Sopot",
  },
  {
    code: "81-748",
    city: "Sopot",
  },
  {
    code: "81-749",
    city: "Sopot",
  },
  {
    code: "81-750",
    city: "Sopot",
  },
  {
    code: "81-751",
    city: "Sopot",
  },
  {
    code: "81-752",
    city: "Sopot",
  },
  {
    code: "81-753",
    city: "Sopot",
  },
  {
    code: "81-754",
    city: "Sopot",
  },
  {
    code: "81-755",
    city: "Sopot",
  },
  {
    code: "81-756",
    city: "Sopot",
  },
  {
    code: "81-757",
    city: "Sopot",
  },
  {
    code: "81-758",
    city: "Sopot",
  },
  {
    code: "81-759",
    city: "Sopot",
  },
  {
    code: "81-760",
    city: "Sopot",
  },
  {
    code: "81-761",
    city: "Sopot",
  },
  {
    code: "81-762",
    city: "Sopot",
  },
  {
    code: "81-763",
    city: "Sopot",
  },
  {
    code: "81-764",
    city: "Sopot",
  },
  {
    code: "81-765",
    city: "Sopot",
  },
  {
    code: "81-767",
    city: "Sopot",
  },
  {
    code: "81-768",
    city: "Sopot",
  },
  {
    code: "81-769",
    city: "Sopot",
  },
  {
    code: "81-770",
    city: "Sopot",
  },
  {
    code: "81-771",
    city: "Sopot",
  },
  {
    code: "81-772",
    city: "Sopot",
  },
  {
    code: "81-773",
    city: "Sopot",
  },
  {
    code: "81-775",
    city: "Sopot",
  },
  {
    code: "81-776",
    city: "Sopot",
  },
  {
    code: "81-777",
    city: "Sopot",
  },
  {
    code: "81-778",
    city: "Sopot",
  },
  {
    code: "81-779",
    city: "Sopot",
  },
  {
    code: "81-780",
    city: "Sopot",
  },
  {
    code: "81-781",
    city: "Sopot",
  },
  {
    code: "81-782",
    city: "Sopot",
  },
  {
    code: "81-783",
    city: "Sopot",
  },
  {
    code: "81-784",
    city: "Sopot",
  },
  {
    code: "81-785",
    city: "Sopot",
  },
  {
    code: "81-786",
    city: "Sopot",
  },
  {
    code: "81-803",
    city: "Sopot",
  },
  {
    code: "81-804",
    city: "Sopot",
  },
  {
    code: "81-805",
    city: "Sopot",
  },
  {
    code: "81-806",
    city: "Sopot",
  },
  {
    code: "81-807",
    city: "Sopot",
  },
  {
    code: "81-808",
    city: "Sopot",
  },
  {
    code: "81-809",
    city: "Sopot",
  },
  {
    code: "81-810",
    city: "Sopot",
  },
  {
    code: "81-811",
    city: "Sopot",
  },
  {
    code: "81-812",
    city: "Sopot",
  },
  {
    code: "81-813",
    city: "Sopot",
  },
  {
    code: "81-814",
    city: "Sopot",
  },
  {
    code: "81-815",
    city: "Sopot",
  },
  {
    code: "81-816",
    city: "Sopot",
  },
  {
    code: "81-817",
    city: "Sopot",
  },
  {
    code: "81-818",
    city: "Sopot",
  },
  {
    code: "81-819",
    city: "Sopot",
  },
  {
    code: "81-820",
    city: "Sopot",
  },
  {
    code: "81-821",
    city: "Sopot",
  },
  {
    code: "81-822",
    city: "Sopot",
  },
  {
    code: "81-823",
    city: "Sopot",
  },
  {
    code: "81-824",
    city: "Sopot",
  },
  {
    code: "81-825",
    city: "Sopot",
  },
  {
    code: "81-826",
    city: "Sopot",
  },
  {
    code: "81-827",
    city: "Sopot",
  },
  {
    code: "81-828",
    city: "Sopot",
  },
  {
    code: "81-829",
    city: "Sopot",
  },
  {
    code: "81-830",
    city: "Sopot",
  },
  {
    code: "81-831",
    city: "Sopot",
  },
  {
    code: "81-832",
    city: "Sopot",
  },
  {
    code: "81-833",
    city: "Sopot",
  },
  {
    code: "81-834",
    city: "Sopot",
  },
  {
    code: "81-835",
    city: "Sopot",
  },
  {
    code: "81-836",
    city: "Sopot",
  },
  {
    code: "81-837",
    city: "Sopot",
  },
  {
    code: "81-838",
    city: "Sopot",
  },
  {
    code: "81-839",
    city: "Sopot",
  },
  {
    code: "81-840",
    city: "Sopot",
  },
  {
    code: "81-841",
    city: "Sopot",
  },
  {
    code: "81-842",
    city: "Sopot",
  },
  {
    code: "81-843",
    city: "Sopot",
  },
  {
    code: "81-844",
    city: "Sopot",
  },
  {
    code: "81-845",
    city: "Sopot",
  },
  {
    code: "81-846",
    city: "Sopot",
  },
  {
    code: "81-847",
    city: "Sopot",
  },
  {
    code: "81-848",
    city: "Sopot",
  },
  {
    code: "81-849",
    city: "Sopot",
  },
  {
    code: "81-850",
    city: "Sopot",
  },
  {
    code: "81-851",
    city: "Sopot",
  },
  {
    code: "81-852",
    city: "Sopot",
  },
  {
    code: "81-853",
    city: "Sopot",
  },
  {
    code: "81-854",
    city: "Sopot",
  },
  {
    code: "81-855",
    city: "Sopot",
  },
  {
    code: "81-856",
    city: "Sopot",
  },
  {
    code: "81-857",
    city: "Sopot",
  },
  {
    code: "81-859",
    city: "Sopot",
  },
  {
    code: "81-860",
    city: "Sopot",
  },
  {
    code: "81-861",
    city: "Sopot",
  },
  {
    code: "81-862",
    city: "Sopot",
  },
  {
    code: "81-864",
    city: "Sopot",
  },
  {
    code: "81-865",
    city: "Sopot",
  },
  {
    code: "81-866",
    city: "Sopot",
  },
  {
    code: "81-867",
    city: "Sopot",
  },
  {
    code: "81-868",
    city: "Sopot",
  },
  {
    code: "81-869",
    city: "Sopot",
  },
  {
    code: "81-870",
    city: "Sopot",
  },
  {
    code: "81-871",
    city: "Sopot",
  },
  {
    code: "81-872",
    city: "Sopot",
  },
  {
    code: "81-873",
    city: "Sopot",
  },
  {
    code: "81-874",
    city: "Sopot",
  },
  {
    code: "81-875",
    city: "Sopot",
  },
  {
    code: "81-876",
    city: "Sopot",
  },
  {
    code: "81-877",
    city: "Sopot",
  },
  {
    code: "81-878",
    city: "Sopot",
  },
  {
    code: "81-880",
    city: "Sopot",
  },
  {
    code: "81-881",
    city: "Sopot",
  },
  {
    code: "81-912",
    city: "Gdynia",
  },
  {
    code: "81-919",
    city: "Gdynia",
  },
  {
    code: "81-963",
    city: "Gdynia",
  },
  {
    code: "81-969",
    city: "Gdynia",
  },
  {
    code: "81-980",
    city: "Gdynia",
  },
  {
    code: "82-100",
    city: "Nowy Dwór Gdański",
  },
  {
    code: "82-103",
    city: "Stegna",
  },
  {
    code: "82-104",
    city: "Kąty Rybackie",
  },
  {
    code: "82-107",
    city: "Jantar",
  },
  {
    code: "82-110",
    city: "Sztutowo",
  },
  {
    code: "82-112",
    city: "Ostaszewo",
  },
  {
    code: "82-113",
    city: "Drewnica",
  },
  {
    code: "82-120",
    city: "Krynica Morska",
  },
  {
    code: "82-200",
    city: "Malbork",
  },
  {
    code: "82-201",
    city: "Malbork",
  },
  {
    code: "82-202",
    city: "Malbork",
  },
  {
    code: "82-203",
    city: "Malbork",
  },
  {
    code: "82-204",
    city: "Malbork",
  },
  {
    code: "82-205",
    city: "Malbork",
  },
  {
    code: "82-210",
    city: "Malbork",
  },
  {
    code: "82-213",
    city: "Miłoradz",
  },
  {
    code: "82-220",
    city: "Stare Pole",
  },
  {
    code: "82-224",
    city: "Lichnowy",
  },
  {
    code: "82-230",
    city: "Nowy Staw",
  },
  {
    code: "82-300",
    city: "Elbląg",
  },
  {
    code: "82-301",
    city: "Elbląg",
  },
  {
    code: "82-302",
    city: "Elbląg",
  },
  {
    code: "82-303",
    city: "Elbląg",
  },
  {
    code: "82-305",
    city: "Elbląg",
  },
  {
    code: "82-306",
    city: "Elbląg",
  },
  {
    code: "82-307",
    city: "Elbląg",
  },
  {
    code: "82-308",
    city: "Elbląg",
  },
  {
    code: "82-309",
    city: "Elbląg",
  },
  {
    code: "82-310",
    city: "Elbląg",
  },
  {
    code: "82-311",
    city: "Elbląg",
  },
  {
    code: "82-312",
    city: "Elbląg",
  },
  {
    code: "82-313",
    city: "Elbląg",
  },
  {
    code: "82-314",
    city: "Elbląg",
  },
  {
    code: "82-315",
    city: "Elbląg",
  },
  {
    code: "82-316",
    city: "Milejewo",
  },
  {
    code: "82-317",
    city: "Elbląg",
  },
  {
    code: "82-325",
    city: "Markusy",
  },
  {
    code: "82-331",
    city: "Jegłownik",
  },
  {
    code: "82-335",
    city: "Gronowo",
  },
  {
    code: "82-340",
    city: "Tolkmicko",
  },
  {
    code: "82-400",
    city: "Sztum",
  },
  {
    code: "82-410",
    city: "Stary Targ",
  },
  {
    code: "82-420",
    city: "Ryjewo",
  },
  {
    code: "82-433",
    city: "Mikołajki Pomorskie",
  },
  {
    code: "82-440",
    city: "Dzierzgoń",
  },
  {
    code: "82-450",
    city: "Stary Dzierzgoń",
  },
  {
    code: "82-500",
    city: "Kwidzyn",
  },
  {
    code: "82-501",
    city: "Kwidzyn",
  },
  {
    code: "82-502",
    city: "Kwidzyn",
  },
  {
    code: "82-503",
    city: "Kwidzyn",
  },
  {
    code: "82-504",
    city: "Kwidzyn",
  },
  {
    code: "82-505",
    city: "Kwidzyn",
  },
  {
    code: "82-520",
    city: "Gardeja",
  },
  {
    code: "82-522",
    city: "Sadlinki",
  },
  {
    code: "82-550",
    city: "Prabuty",
  },
  {
    code: "83-000",
    city: "Pruszcz Gdański",
  },
  {
    code: "83-004",
    city: "Pruszcz Gdański",
  },
  {
    code: "83-005",
    city: "Pruszcz Gdański",
  },
  {
    code: "83-010",
    city: "Straszyn",
  },
  {
    code: "83-011",
    city: "Wiślinka",
  },
  {
    code: "83-020",
    city: "Cedry Wielkie",
  },
  {
    code: "83-021",
    city: "Wiślina",
  },
  {
    code: "83-022",
    city: "Suchy Dąb",
  },
  {
    code: "83-031",
    city: "Łęgowo",
  },
  {
    code: "83-032",
    city: "Pszczółki",
  },
  {
    code: "83-033",
    city: "Sobowidz",
  },
  {
    code: "83-034",
    city: "Trąbki Wielkie",
  },
  {
    code: "83-041",
    city: "Mierzeszyn",
  },
  {
    code: "83-042",
    city: "Ełganowo",
  },
  {
    code: "83-047",
    city: "Przywidz",
  },
  {
    code: "83-050",
    city: "Kolbudy",
  },
  {
    code: "83-100",
    city: "Tczew",
  },
  {
    code: "83-101",
    city: "Tczew",
  },
  {
    code: "83-102",
    city: "Tczew",
  },
  {
    code: "83-110",
    city: "Tczew",
  },
  {
    code: "83-112",
    city: "Lubiszewo Tczewskie",
  },
  {
    code: "83-115",
    city: "Swarożyn",
  },
  {
    code: "83-120",
    city: "Subkowy",
  },
  {
    code: "83-121",
    city: "Rudno",
  },
  {
    code: "83-130",
    city: "Pelplin",
  },
  {
    code: "83-132",
    city: "Morzeszczyn",
  },
  {
    code: "83-133",
    city: "Gąsiorki",
  },
  {
    code: "83-135",
    city: "Mała Karczma",
  },
  {
    code: "83-136",
    city: "Opalenie",
  },
  {
    code: "83-140",
    city: "Gniew",
  },
  {
    code: "83-200",
    city: "Starogard Gdański",
  },
  {
    code: "83-201",
    city: "Starogard Gdański",
  },
  {
    code: "83-202",
    city: "Starogard Gdański",
  },
  {
    code: "83-203",
    city: "Starogard Gdański",
  },
  {
    code: "83-206",
    city: "Kleszczewo Kościerskie",
  },
  {
    code: "83-207",
    city: "Kokoszkowy",
  },
  {
    code: "83-209",
    city: "Godziszewo",
  },
  {
    code: "83-210",
    city: "Zblewo",
  },
  {
    code: "83-211",
    city: "Jabłowo",
  },
  {
    code: "83-212",
    city: "Bobowo",
  },
  {
    code: "83-220",
    city: "Skórcz",
  },
  {
    code: "83-221",
    city: "Osiek",
  },
  {
    code: "83-224",
    city: "Borzechowo",
  },
  {
    code: "83-230",
    city: "Smętowo Graniczne",
  },
  {
    code: "83-236",
    city: "Pogódki",
  },
  {
    code: "83-240",
    city: "Lubichowo",
  },
  {
    code: "83-242",
    city: "Osieczna",
  },
  {
    code: "83-243",
    city: "Szlachta",
  },
  {
    code: "83-250",
    city: "Skarszewy",
  },
  {
    code: "83-251",
    city: "Pinczyn",
  },
  {
    code: "83-260",
    city: "Kaliska",
  },
  {
    code: "83-262",
    city: "Czarna Woda",
  },
  {
    code: "83-300",
    city: "Kartuzy",
  },
  {
    code: "83-301",
    city: "Kartuzy",
  },
  {
    code: "83-304",
    city: "Przodkowo",
  },
  {
    code: "83-307",
    city: "Kiełpino",
  },
  {
    code: "83-312",
    city: "Hopowo",
  },
  {
    code: "83-314",
    city: "Somonino",
  },
  {
    code: "83-315",
    city: "Szymbark",
  },
  {
    code: "83-316",
    city: "Gołubie",
  },
  {
    code: "83-320",
    city: "Sulęczyno",
  },
  {
    code: "83-322",
    city: "Stężyca",
  },
  {
    code: "83-323",
    city: "Kamienica Szlachecka",
  },
  {
    code: "83-324",
    city: "Brodnica Górna",
  },
  {
    code: "83-328",
    city: "Sianowo",
  },
  {
    code: "83-330",
    city: "Żukowo",
  },
  {
    code: "83-331",
    city: "Przyjaźń",
  },
  {
    code: "83-332",
    city: "Dzierżążno",
  },
  {
    code: "83-333",
    city: "Chmielno",
  },
  {
    code: "83-334",
    city: "Miechucino",
  },
  {
    code: "83-340",
    city: "Sierakowice",
  },
  {
    code: "83-341",
    city: "Gowidlino",
  },
  {
    code: "83-400",
    city: "Kościerzyna",
  },
  {
    code: "83-401",
    city: "Kościerzyna",
  },
  {
    code: "83-403",
    city: "Grabowo Kościerskie",
  },
  {
    code: "83-404",
    city: "Nowa Karczma",
  },
  {
    code: "83-406",
    city: "Wąglikowice",
  },
  {
    code: "83-407",
    city: "Łubiana",
  },
  {
    code: "83-408",
    city: "Wdzydze",
  },
  {
    code: "83-409",
    city: "Korne",
  },
  {
    code: "83-420",
    city: "Liniewo",
  },
  {
    code: "83-422",
    city: "Nowy Barkoczyn",
  },
  {
    code: "83-423",
    city: "Wielki Klincz",
  },
  {
    code: "83-424",
    city: "Lipusz",
  },
  {
    code: "83-425",
    city: "Dziemiany",
  },
  {
    code: "83-430",
    city: "Stara Kiszewa",
  },
  {
    code: "83-431",
    city: "Stary Bukowiec",
  },
  {
    code: "83-440",
    city: "Karsin",
  },
  {
    code: "83-441",
    city: "Wiele",
  },
  {
    code: "84-100",
    city: "Puck",
  },
  {
    code: "84-103",
    city: "Łebcz",
  },
  {
    code: "84-104",
    city: "Władysławowo",
  },
  {
    code: "84-105",
    city: "Karwia",
  },
  {
    code: "84-106",
    city: "Leśniewo",
  },
  {
    code: "84-107",
    city: "Starzyno",
  },
  {
    code: "84-110",
    city: "Krokowa",
  },
  {
    code: "84-113",
    city: "Wierzchucino",
  },
  {
    code: "84-120",
    city: "Władysławowo",
  },
  {
    code: "84-122",
    city: "Żelistrzewo",
  },
  {
    code: "84-123",
    city: "Połchowo",
  },
  {
    code: "84-130",
    city: "Kuźnica",
  },
  {
    code: "84-140",
    city: "Jastarnia",
  },
  {
    code: "84-141",
    city: "Jastarnia Jurata",
  },
  {
    code: "84-150",
    city: "Hel",
  },
  {
    code: "84-200",
    city: "Wejherowo",
  },
  {
    code: "84-202",
    city: "Wejherowo",
  },
  {
    code: "84-204",
    city: "Wejherowo",
  },
  {
    code: "84-206",
    city: "Nowy Dwór Wejherowski",
  },
  {
    code: "84-207",
    city: "Koleczkowo",
  },
  {
    code: "84-208",
    city: "Kielno",
  },
  {
    code: "84-210",
    city: "Choczewo",
  },
  {
    code: "84-211",
    city: "Sasino",
  },
  {
    code: "84-214",
    city: "Bożepole Wielkie",
  },
  {
    code: "84-217",
    city: "Szemud",
  },
  {
    code: "84-218",
    city: "Łęczyce",
  },
  {
    code: "84-219",
    city: "Rozłazino",
  },
  {
    code: "84-220",
    city: "Strzebielino",
  },
  {
    code: "84-222",
    city: "Strzepcz",
  },
  {
    code: "84-223",
    city: "Linia",
  },
  {
    code: "84-230",
    city: "Rumia",
  },
  {
    code: "84-231",
    city: "Rumia",
  },
  {
    code: "84-232",
    city: "Rumia",
  },
  {
    code: "84-239",
    city: "Bolszewo",
  },
  {
    code: "84-240",
    city: "Reda",
  },
  {
    code: "84-241",
    city: "Gościcino",
  },
  {
    code: "84-242",
    city: "Luzino",
  },
  {
    code: "84-250",
    city: "Gniewino",
  },
  {
    code: "84-252",
    city: "Zamostne",
  },
  {
    code: "84-300",
    city: "Lębork",
  },
  {
    code: "84-301",
    city: "Lębork",
  },
  {
    code: "84-302",
    city: "Lębork",
  },
  {
    code: "84-303",
    city: "Lębork",
  },
  {
    code: "84-310",
    city: "Lębork",
  },
  {
    code: "84-312",
    city: "Cewice",
  },
  {
    code: "84-313",
    city: "Siemirowice",
  },
  {
    code: "84-315",
    city: "Maszewo Lęborskie",
  },
  {
    code: "84-350",
    city: "Łebień",
  },
  {
    code: "84-351",
    city: "Nowa Wieś Lęborska",
  },
  {
    code: "84-352",
    city: "Wicko",
  },
  {
    code: "84-353",
    city: "Mosty",
  },
  {
    code: "84-360",
    city: "Łeba",
  },
  {
    code: "85-001",
    city: "Bydgoszcz",
  },
  {
    code: "85-003",
    city: "Bydgoszcz",
  },
  {
    code: "85-004",
    city: "Bydgoszcz",
  },
  {
    code: "85-005",
    city: "Bydgoszcz",
  },
  {
    code: "85-006",
    city: "Bydgoszcz",
  },
  {
    code: "85-007",
    city: "Bydgoszcz",
  },
  {
    code: "85-008",
    city: "Bydgoszcz",
  },
  {
    code: "85-009",
    city: "Bydgoszcz",
  },
  {
    code: "85-010",
    city: "Bydgoszcz",
  },
  {
    code: "85-011",
    city: "Bydgoszcz",
  },
  {
    code: "85-012",
    city: "Bydgoszcz",
  },
  {
    code: "85-013",
    city: "Bydgoszcz",
  },
  {
    code: "85-014",
    city: "Bydgoszcz",
  },
  {
    code: "85-015",
    city: "Bydgoszcz",
  },
  {
    code: "85-016",
    city: "Bydgoszcz",
  },
  {
    code: "85-017",
    city: "Bydgoszcz",
  },
  {
    code: "85-018",
    city: "Bydgoszcz",
  },
  {
    code: "85-020",
    city: "Bydgoszcz",
  },
  {
    code: "85-021",
    city: "Bydgoszcz",
  },
  {
    code: "85-022",
    city: "Bydgoszcz",
  },
  {
    code: "85-023",
    city: "Bydgoszcz",
  },
  {
    code: "85-024",
    city: "Bydgoszcz",
  },
  {
    code: "85-026",
    city: "Bydgoszcz",
  },
  {
    code: "85-027",
    city: "Bydgoszcz",
  },
  {
    code: "85-028",
    city: "Bydgoszcz",
  },
  {
    code: "85-029",
    city: "Bydgoszcz",
  },
  {
    code: "85-030",
    city: "Bydgoszcz",
  },
  {
    code: "85-031",
    city: "Bydgoszcz",
  },
  {
    code: "85-032",
    city: "Bydgoszcz",
  },
  {
    code: "85-033",
    city: "Bydgoszcz",
  },
  {
    code: "85-034",
    city: "Bydgoszcz",
  },
  {
    code: "85-035",
    city: "Bydgoszcz",
  },
  {
    code: "85-036",
    city: "Bydgoszcz",
  },
  {
    code: "85-037",
    city: "Bydgoszcz",
  },
  {
    code: "85-038",
    city: "Bydgoszcz",
  },
  {
    code: "85-039",
    city: "Bydgoszcz",
  },
  {
    code: "85-040",
    city: "Bydgoszcz",
  },
  {
    code: "85-041",
    city: "Bydgoszcz",
  },
  {
    code: "85-042",
    city: "Bydgoszcz",
  },
  {
    code: "85-043",
    city: "Bydgoszcz",
  },
  {
    code: "85-044",
    city: "Bydgoszcz",
  },
  {
    code: "85-045",
    city: "Bydgoszcz",
  },
  {
    code: "85-046",
    city: "Bydgoszcz",
  },
  {
    code: "85-047",
    city: "Bydgoszcz",
  },
  {
    code: "85-048",
    city: "Bydgoszcz",
  },
  {
    code: "85-049",
    city: "Bydgoszcz",
  },
  {
    code: "85-050",
    city: "Bydgoszcz",
  },
  {
    code: "85-051",
    city: "Bydgoszcz",
  },
  {
    code: "85-052",
    city: "Bydgoszcz",
  },
  {
    code: "85-053",
    city: "Bydgoszcz",
  },
  {
    code: "85-054",
    city: "Bydgoszcz",
  },
  {
    code: "85-055",
    city: "Bydgoszcz",
  },
  {
    code: "85-056",
    city: "Bydgoszcz",
  },
  {
    code: "85-057",
    city: "Bydgoszcz",
  },
  {
    code: "85-058",
    city: "Bydgoszcz",
  },
  {
    code: "85-059",
    city: "Bydgoszcz",
  },
  {
    code: "85-060",
    city: "Bydgoszcz",
  },
  {
    code: "85-061",
    city: "Bydgoszcz",
  },
  {
    code: "85-062",
    city: "Bydgoszcz",
  },
  {
    code: "85-063",
    city: "Bydgoszcz",
  },
  {
    code: "85-064",
    city: "Bydgoszcz",
  },
  {
    code: "85-065",
    city: "Bydgoszcz",
  },
  {
    code: "85-066",
    city: "Bydgoszcz",
  },
  {
    code: "85-067",
    city: "Bydgoszcz",
  },
  {
    code: "85-068",
    city: "Bydgoszcz",
  },
  {
    code: "85-069",
    city: "Bydgoszcz",
  },
  {
    code: "85-070",
    city: "Bydgoszcz",
  },
  {
    code: "85-071",
    city: "Bydgoszcz",
  },
  {
    code: "85-072",
    city: "Bydgoszcz",
  },
  {
    code: "85-073",
    city: "Bydgoszcz",
  },
  {
    code: "85-074",
    city: "Bydgoszcz",
  },
  {
    code: "85-075",
    city: "Bydgoszcz",
  },
  {
    code: "85-076",
    city: "Bydgoszcz",
  },
  {
    code: "85-077",
    city: "Bydgoszcz",
  },
  {
    code: "85-078",
    city: "Bydgoszcz",
  },
  {
    code: "85-079",
    city: "Bydgoszcz",
  },
  {
    code: "85-080",
    city: "Bydgoszcz",
  },
  {
    code: "85-081",
    city: "Bydgoszcz",
  },
  {
    code: "85-082",
    city: "Bydgoszcz",
  },
  {
    code: "85-083",
    city: "Bydgoszcz",
  },
  {
    code: "85-084",
    city: "Bydgoszcz",
  },
  {
    code: "85-085",
    city: "Bydgoszcz",
  },
  {
    code: "85-086",
    city: "Bydgoszcz",
  },
  {
    code: "85-087",
    city: "Bydgoszcz",
  },
  {
    code: "85-088",
    city: "Bydgoszcz",
  },
  {
    code: "85-089",
    city: "Bydgoszcz",
  },
  {
    code: "85-090",
    city: "Bydgoszcz",
  },
  {
    code: "85-091",
    city: "Bydgoszcz",
  },
  {
    code: "85-092",
    city: "Bydgoszcz",
  },
  {
    code: "85-093",
    city: "Bydgoszcz",
  },
  {
    code: "85-094",
    city: "Bydgoszcz",
  },
  {
    code: "85-095",
    city: "Bydgoszcz",
  },
  {
    code: "85-096",
    city: "Bydgoszcz",
  },
  {
    code: "85-097",
    city: "Bydgoszcz",
  },
  {
    code: "85-098",
    city: "Bydgoszcz",
  },
  {
    code: "85-099",
    city: "Bydgoszcz",
  },
  {
    code: "85-100",
    city: "Bydgoszcz",
  },
  {
    code: "85-101",
    city: "Bydgoszcz",
  },
  {
    code: "85-102",
    city: "Bydgoszcz",
  },
  {
    code: "85-103",
    city: "Bydgoszcz",
  },
  {
    code: "85-104",
    city: "Bydgoszcz",
  },
  {
    code: "85-105",
    city: "Bydgoszcz",
  },
  {
    code: "85-106",
    city: "Bydgoszcz",
  },
  {
    code: "85-107",
    city: "Bydgoszcz",
  },
  {
    code: "85-108",
    city: "Bydgoszcz",
  },
  {
    code: "85-109",
    city: "Bydgoszcz",
  },
  {
    code: "85-110",
    city: "Bydgoszcz",
  },
  {
    code: "85-111",
    city: "Bydgoszcz",
  },
  {
    code: "85-112",
    city: "Bydgoszcz",
  },
  {
    code: "85-113",
    city: "Bydgoszcz",
  },
  {
    code: "85-114",
    city: "Bydgoszcz",
  },
  {
    code: "85-115",
    city: "Bydgoszcz",
  },
  {
    code: "85-116",
    city: "Bydgoszcz",
  },
  {
    code: "85-117",
    city: "Bydgoszcz",
  },
  {
    code: "85-118",
    city: "Bydgoszcz",
  },
  {
    code: "85-119",
    city: "Bydgoszcz",
  },
  {
    code: "85-120",
    city: "Bydgoszcz",
  },
  {
    code: "85-121",
    city: "Bydgoszcz",
  },
  {
    code: "85-122",
    city: "Bydgoszcz",
  },
  {
    code: "85-123",
    city: "Bydgoszcz",
  },
  {
    code: "85-124",
    city: "Bydgoszcz",
  },
  {
    code: "85-125",
    city: "Bydgoszcz",
  },
  {
    code: "85-126",
    city: "Bydgoszcz",
  },
  {
    code: "85-127",
    city: "Bydgoszcz",
  },
  {
    code: "85-128",
    city: "Bydgoszcz",
  },
  {
    code: "85-129",
    city: "Bydgoszcz",
  },
  {
    code: "85-130",
    city: "Bydgoszcz",
  },
  {
    code: "85-131",
    city: "Bydgoszcz",
  },
  {
    code: "85-132",
    city: "Bydgoszcz",
  },
  {
    code: "85-133",
    city: "Bydgoszcz",
  },
  {
    code: "85-134",
    city: "Bydgoszcz",
  },
  {
    code: "85-135",
    city: "Bydgoszcz",
  },
  {
    code: "85-136",
    city: "Bydgoszcz",
  },
  {
    code: "85-137",
    city: "Bydgoszcz",
  },
  {
    code: "85-138",
    city: "Bydgoszcz",
  },
  {
    code: "85-139",
    city: "Bydgoszcz",
  },
  {
    code: "85-140",
    city: "Bydgoszcz",
  },
  {
    code: "85-141",
    city: "Bydgoszcz",
  },
  {
    code: "85-142",
    city: "Bydgoszcz",
  },
  {
    code: "85-143",
    city: "Bydgoszcz",
  },
  {
    code: "85-144",
    city: "Bydgoszcz",
  },
  {
    code: "85-145",
    city: "Bydgoszcz",
  },
  {
    code: "85-146",
    city: "Bydgoszcz",
  },
  {
    code: "85-147",
    city: "Bydgoszcz",
  },
  {
    code: "85-148",
    city: "Bydgoszcz",
  },
  {
    code: "85-149",
    city: "Bydgoszcz",
  },
  {
    code: "85-150",
    city: "Bydgoszcz",
  },
  {
    code: "85-151",
    city: "Bydgoszcz",
  },
  {
    code: "85-152",
    city: "Bydgoszcz",
  },
  {
    code: "85-153",
    city: "Bydgoszcz",
  },
  {
    code: "85-154",
    city: "Bydgoszcz",
  },
  {
    code: "85-155",
    city: "Bydgoszcz",
  },
  {
    code: "85-156",
    city: "Bydgoszcz",
  },
  {
    code: "85-157",
    city: "Bydgoszcz",
  },
  {
    code: "85-158",
    city: "Bydgoszcz",
  },
  {
    code: "85-159",
    city: "Bydgoszcz",
  },
  {
    code: "85-160",
    city: "Bydgoszcz",
  },
  {
    code: "85-161",
    city: "Bydgoszcz",
  },
  {
    code: "85-162",
    city: "Bydgoszcz",
  },
  {
    code: "85-163",
    city: "Bydgoszcz",
  },
  {
    code: "85-164",
    city: "Bydgoszcz",
  },
  {
    code: "85-165",
    city: "Bydgoszcz",
  },
  {
    code: "85-166",
    city: "Bydgoszcz",
  },
  {
    code: "85-167",
    city: "Bydgoszcz",
  },
  {
    code: "85-168",
    city: "Bydgoszcz",
  },
  {
    code: "85-169",
    city: "Bydgoszcz",
  },
  {
    code: "85-170",
    city: "Bydgoszcz",
  },
  {
    code: "85-171",
    city: "Bydgoszcz",
  },
  {
    code: "85-172",
    city: "Bydgoszcz",
  },
  {
    code: "85-174",
    city: "Bydgoszcz",
  },
  {
    code: "85-176",
    city: "Bydgoszcz",
  },
  {
    code: "85-177",
    city: "Bydgoszcz",
  },
  {
    code: "85-178",
    city: "Bydgoszcz",
  },
  {
    code: "85-179",
    city: "Bydgoszcz",
  },
  {
    code: "85-181",
    city: "Bydgoszcz",
  },
  {
    code: "85-182",
    city: "Bydgoszcz",
  },
  {
    code: "85-183",
    city: "Bydgoszcz",
  },
  {
    code: "85-184",
    city: "Bydgoszcz",
  },
  {
    code: "85-185",
    city: "Bydgoszcz",
  },
  {
    code: "85-186",
    city: "Bydgoszcz",
  },
  {
    code: "85-188",
    city: "Bydgoszcz",
  },
  {
    code: "85-189",
    city: "Bydgoszcz",
  },
  {
    code: "85-195",
    city: "Bydgoszcz",
  },
  {
    code: "85-198",
    city: "Bydgoszcz",
  },
  {
    code: "85-200",
    city: "Bydgoszcz",
  },
  {
    code: "85-201",
    city: "Bydgoszcz",
  },
  {
    code: "85-202",
    city: "Bydgoszcz",
  },
  {
    code: "85-203",
    city: "Bydgoszcz",
  },
  {
    code: "85-204",
    city: "Bydgoszcz",
  },
  {
    code: "85-205",
    city: "Bydgoszcz",
  },
  {
    code: "85-206",
    city: "Bydgoszcz",
  },
  {
    code: "85-207",
    city: "Bydgoszcz",
  },
  {
    code: "85-208",
    city: "Bydgoszcz",
  },
  {
    code: "85-209",
    city: "Bydgoszcz",
  },
  {
    code: "85-210",
    city: "Bydgoszcz",
  },
  {
    code: "85-211",
    city: "Bydgoszcz",
  },
  {
    code: "85-212",
    city: "Bydgoszcz",
  },
  {
    code: "85-213",
    city: "Bydgoszcz",
  },
  {
    code: "85-214",
    city: "Bydgoszcz",
  },
  {
    code: "85-215",
    city: "Bydgoszcz",
  },
  {
    code: "85-216",
    city: "Bydgoszcz",
  },
  {
    code: "85-217",
    city: "Bydgoszcz",
  },
  {
    code: "85-218",
    city: "Bydgoszcz",
  },
  {
    code: "85-219",
    city: "Bydgoszcz",
  },
  {
    code: "85-220",
    city: "Bydgoszcz",
  },
  {
    code: "85-222",
    city: "Bydgoszcz",
  },
  {
    code: "85-223",
    city: "Bydgoszcz",
  },
  {
    code: "85-224",
    city: "Bydgoszcz",
  },
  {
    code: "85-225",
    city: "Bydgoszcz",
  },
  {
    code: "85-226",
    city: "Bydgoszcz",
  },
  {
    code: "85-227",
    city: "Bydgoszcz",
  },
  {
    code: "85-228",
    city: "Bydgoszcz",
  },
  {
    code: "85-229",
    city: "Bydgoszcz",
  },
  {
    code: "85-230",
    city: "Bydgoszcz",
  },
  {
    code: "85-231",
    city: "Bydgoszcz",
  },
  {
    code: "85-232",
    city: "Bydgoszcz",
  },
  {
    code: "85-233",
    city: "Bydgoszcz",
  },
  {
    code: "85-234",
    city: "Bydgoszcz",
  },
  {
    code: "85-235",
    city: "Bydgoszcz",
  },
  {
    code: "85-236",
    city: "Bydgoszcz",
  },
  {
    code: "85-237",
    city: "Bydgoszcz",
  },
  {
    code: "85-238",
    city: "Bydgoszcz",
  },
  {
    code: "85-239",
    city: "Bydgoszcz",
  },
  {
    code: "85-240",
    city: "Bydgoszcz",
  },
  {
    code: "85-241",
    city: "Bydgoszcz",
  },
  {
    code: "85-242",
    city: "Bydgoszcz",
  },
  {
    code: "85-300",
    city: "Bydgoszcz",
  },
  {
    code: "85-301",
    city: "Bydgoszcz",
  },
  {
    code: "85-302",
    city: "Bydgoszcz",
  },
  {
    code: "85-303",
    city: "Bydgoszcz",
  },
  {
    code: "85-304",
    city: "Bydgoszcz",
  },
  {
    code: "85-305",
    city: "Bydgoszcz",
  },
  {
    code: "85-306",
    city: "Bydgoszcz",
  },
  {
    code: "85-307",
    city: "Bydgoszcz",
  },
  {
    code: "85-308",
    city: "Bydgoszcz",
  },
  {
    code: "85-309",
    city: "Bydgoszcz",
  },
  {
    code: "85-311",
    city: "Bydgoszcz",
  },
  {
    code: "85-312",
    city: "Bydgoszcz",
  },
  {
    code: "85-313",
    city: "Bydgoszcz",
  },
  {
    code: "85-314",
    city: "Bydgoszcz",
  },
  {
    code: "85-315",
    city: "Bydgoszcz",
  },
  {
    code: "85-316",
    city: "Bydgoszcz",
  },
  {
    code: "85-317",
    city: "Bydgoszcz",
  },
  {
    code: "85-318",
    city: "Bydgoszcz",
  },
  {
    code: "85-319",
    city: "Bydgoszcz",
  },
  {
    code: "85-320",
    city: "Bydgoszcz",
  },
  {
    code: "85-321",
    city: "Bydgoszcz",
  },
  {
    code: "85-322",
    city: "Bydgoszcz",
  },
  {
    code: "85-323",
    city: "Bydgoszcz",
  },
  {
    code: "85-324",
    city: "Bydgoszcz",
  },
  {
    code: "85-325",
    city: "Bydgoszcz",
  },
  {
    code: "85-326",
    city: "Bydgoszcz",
  },
  {
    code: "85-327",
    city: "Bydgoszcz",
  },
  {
    code: "85-328",
    city: "Bydgoszcz",
  },
  {
    code: "85-329",
    city: "Bydgoszcz",
  },
  {
    code: "85-330",
    city: "Bydgoszcz",
  },
  {
    code: "85-331",
    city: "Bydgoszcz",
  },
  {
    code: "85-332",
    city: "Bydgoszcz",
  },
  {
    code: "85-333",
    city: "Bydgoszcz",
  },
  {
    code: "85-334",
    city: "Bydgoszcz",
  },
  {
    code: "85-335",
    city: "Bydgoszcz",
  },
  {
    code: "85-336",
    city: "Bydgoszcz",
  },
  {
    code: "85-337",
    city: "Bydgoszcz",
  },
  {
    code: "85-338",
    city: "Bydgoszcz",
  },
  {
    code: "85-339",
    city: "Bydgoszcz",
  },
  {
    code: "85-340",
    city: "Bydgoszcz",
  },
  {
    code: "85-341",
    city: "Bydgoszcz",
  },
  {
    code: "85-342",
    city: "Bydgoszcz",
  },
  {
    code: "85-343",
    city: "Bydgoszcz",
  },
  {
    code: "85-344",
    city: "Bydgoszcz",
  },
  {
    code: "85-345",
    city: "Bydgoszcz",
  },
  {
    code: "85-346",
    city: "Bydgoszcz",
  },
  {
    code: "85-347",
    city: "Bydgoszcz",
  },
  {
    code: "85-348",
    city: "Bydgoszcz",
  },
  {
    code: "85-349",
    city: "Bydgoszcz",
  },
  {
    code: "85-350",
    city: "Bydgoszcz",
  },
  {
    code: "85-351",
    city: "Bydgoszcz",
  },
  {
    code: "85-352",
    city: "Bydgoszcz",
  },
  {
    code: "85-353",
    city: "Bydgoszcz",
  },
  {
    code: "85-354",
    city: "Bydgoszcz",
  },
  {
    code: "85-355",
    city: "Bydgoszcz",
  },
  {
    code: "85-356",
    city: "Bydgoszcz",
  },
  {
    code: "85-357",
    city: "Bydgoszcz",
  },
  {
    code: "85-358",
    city: "Bydgoszcz",
  },
  {
    code: "85-359",
    city: "Bydgoszcz",
  },
  {
    code: "85-360",
    city: "Bydgoszcz",
  },
  {
    code: "85-361",
    city: "Bydgoszcz",
  },
  {
    code: "85-362",
    city: "Bydgoszcz",
  },
  {
    code: "85-363",
    city: "Bydgoszcz",
  },
  {
    code: "85-364",
    city: "Bydgoszcz",
  },
  {
    code: "85-365",
    city: "Bydgoszcz",
  },
  {
    code: "85-366",
    city: "Bydgoszcz",
  },
  {
    code: "85-367",
    city: "Bydgoszcz",
  },
  {
    code: "85-368",
    city: "Bydgoszcz",
  },
  {
    code: "85-369",
    city: "Bydgoszcz",
  },
  {
    code: "85-370",
    city: "Bydgoszcz",
  },
  {
    code: "85-371",
    city: "Bydgoszcz",
  },
  {
    code: "85-372",
    city: "Bydgoszcz",
  },
  {
    code: "85-373",
    city: "Bydgoszcz",
  },
  {
    code: "85-374",
    city: "Bydgoszcz",
  },
  {
    code: "85-375",
    city: "Bydgoszcz",
  },
  {
    code: "85-376",
    city: "Bydgoszcz",
  },
  {
    code: "85-377",
    city: "Bydgoszcz",
  },
  {
    code: "85-378",
    city: "Bydgoszcz",
  },
  {
    code: "85-379",
    city: "Bydgoszcz",
  },
  {
    code: "85-380",
    city: "Bydgoszcz",
  },
  {
    code: "85-381",
    city: "Bydgoszcz",
  },
  {
    code: "85-382",
    city: "Bydgoszcz",
  },
  {
    code: "85-383",
    city: "Bydgoszcz",
  },
  {
    code: "85-384",
    city: "Bydgoszcz",
  },
  {
    code: "85-385",
    city: "Bydgoszcz",
  },
  {
    code: "85-386",
    city: "Bydgoszcz",
  },
  {
    code: "85-387",
    city: "Bydgoszcz",
  },
  {
    code: "85-388",
    city: "Bydgoszcz",
  },
  {
    code: "85-389",
    city: "Bydgoszcz",
  },
  {
    code: "85-390",
    city: "Bydgoszcz",
  },
  {
    code: "85-391",
    city: "Bydgoszcz",
  },
  {
    code: "85-392",
    city: "Bydgoszcz",
  },
  {
    code: "85-395",
    city: "Bydgoszcz",
  },
  {
    code: "85-401",
    city: "Bydgoszcz",
  },
  {
    code: "85-402",
    city: "Bydgoszcz",
  },
  {
    code: "85-403",
    city: "Bydgoszcz",
  },
  {
    code: "85-404",
    city: "Bydgoszcz",
  },
  {
    code: "85-405",
    city: "Bydgoszcz",
  },
  {
    code: "85-406",
    city: "Bydgoszcz",
  },
  {
    code: "85-407",
    city: "Bydgoszcz",
  },
  {
    code: "85-408",
    city: "Bydgoszcz",
  },
  {
    code: "85-409",
    city: "Bydgoszcz",
  },
  {
    code: "85-410",
    city: "Bydgoszcz",
  },
  {
    code: "85-411",
    city: "Bydgoszcz",
  },
  {
    code: "85-412",
    city: "Bydgoszcz",
  },
  {
    code: "85-413",
    city: "Bydgoszcz",
  },
  {
    code: "85-414",
    city: "Bydgoszcz",
  },
  {
    code: "85-415",
    city: "Bydgoszcz",
  },
  {
    code: "85-416",
    city: "Bydgoszcz",
  },
  {
    code: "85-417",
    city: "Bydgoszcz",
  },
  {
    code: "85-418",
    city: "Bydgoszcz",
  },
  {
    code: "85-419",
    city: "Bydgoszcz",
  },
  {
    code: "85-420",
    city: "Bydgoszcz",
  },
  {
    code: "85-421",
    city: "Bydgoszcz",
  },
  {
    code: "85-422",
    city: "Bydgoszcz",
  },
  {
    code: "85-423",
    city: "Bydgoszcz",
  },
  {
    code: "85-424",
    city: "Bydgoszcz",
  },
  {
    code: "85-425",
    city: "Bydgoszcz",
  },
  {
    code: "85-426",
    city: "Bydgoszcz",
  },
  {
    code: "85-427",
    city: "Bydgoszcz",
  },
  {
    code: "85-428",
    city: "Bydgoszcz",
  },
  {
    code: "85-429",
    city: "Bydgoszcz",
  },
  {
    code: "85-430",
    city: "Bydgoszcz",
  },
  {
    code: "85-431",
    city: "Bydgoszcz",
  },
  {
    code: "85-432",
    city: "Bydgoszcz",
  },
  {
    code: "85-433",
    city: "Bydgoszcz",
  },
  {
    code: "85-434",
    city: "Bydgoszcz",
  },
  {
    code: "85-435",
    city: "Bydgoszcz",
  },
  {
    code: "85-436",
    city: "Bydgoszcz",
  },
  {
    code: "85-437",
    city: "Bydgoszcz",
  },
  {
    code: "85-438",
    city: "Bydgoszcz",
  },
  {
    code: "85-439",
    city: "Bydgoszcz",
  },
  {
    code: "85-440",
    city: "Bydgoszcz",
  },
  {
    code: "85-441",
    city: "Bydgoszcz",
  },
  {
    code: "85-443",
    city: "Bydgoszcz",
  },
  {
    code: "85-444",
    city: "Bydgoszcz",
  },
  {
    code: "85-445",
    city: "Bydgoszcz",
  },
  {
    code: "85-446",
    city: "Bydgoszcz",
  },
  {
    code: "85-447",
    city: "Bydgoszcz",
  },
  {
    code: "85-448",
    city: "Bydgoszcz",
  },
  {
    code: "85-449",
    city: "Bydgoszcz",
  },
  {
    code: "85-450",
    city: "Bydgoszcz",
  },
  {
    code: "85-451",
    city: "Bydgoszcz",
  },
  {
    code: "85-452",
    city: "Bydgoszcz",
  },
  {
    code: "85-453",
    city: "Bydgoszcz",
  },
  {
    code: "85-454",
    city: "Bydgoszcz",
  },
  {
    code: "85-455",
    city: "Bydgoszcz",
  },
  {
    code: "85-456",
    city: "Bydgoszcz",
  },
  {
    code: "85-457",
    city: "Bydgoszcz",
  },
  {
    code: "85-459",
    city: "Bydgoszcz",
  },
  {
    code: "85-460",
    city: "Bydgoszcz",
  },
  {
    code: "85-461",
    city: "Bydgoszcz",
  },
  {
    code: "85-462",
    city: "Bydgoszcz",
  },
  {
    code: "85-463",
    city: "Bydgoszcz",
  },
  {
    code: "85-464",
    city: "Bydgoszcz",
  },
  {
    code: "85-465",
    city: "Bydgoszcz",
  },
  {
    code: "85-466",
    city: "Bydgoszcz",
  },
  {
    code: "85-467",
    city: "Bydgoszcz",
  },
  {
    code: "85-468",
    city: "Bydgoszcz",
  },
  {
    code: "85-469",
    city: "Bydgoszcz",
  },
  {
    code: "85-470",
    city: "Bydgoszcz",
  },
  {
    code: "85-471",
    city: "Bydgoszcz",
  },
  {
    code: "85-472",
    city: "Bydgoszcz",
  },
  {
    code: "85-473",
    city: "Bydgoszcz",
  },
  {
    code: "85-474",
    city: "Bydgoszcz",
  },
  {
    code: "85-475",
    city: "Bydgoszcz",
  },
  {
    code: "85-476",
    city: "Bydgoszcz",
  },
  {
    code: "85-477",
    city: "Bydgoszcz",
  },
  {
    code: "85-479",
    city: "Bydgoszcz",
  },
  {
    code: "85-480",
    city: "Bydgoszcz",
  },
  {
    code: "85-481",
    city: "Bydgoszcz",
  },
  {
    code: "85-482",
    city: "Bydgoszcz",
  },
  {
    code: "85-483",
    city: "Bydgoszcz",
  },
  {
    code: "85-485",
    city: "Bydgoszcz",
  },
  {
    code: "85-501",
    city: "Bydgoszcz",
  },
  {
    code: "85-502",
    city: "Bydgoszcz",
  },
  {
    code: "85-503",
    city: "Bydgoszcz",
  },
  {
    code: "85-504",
    city: "Bydgoszcz",
  },
  {
    code: "85-505",
    city: "Bydgoszcz",
  },
  {
    code: "85-506",
    city: "Bydgoszcz",
  },
  {
    code: "85-507",
    city: "Bydgoszcz",
  },
  {
    code: "85-508",
    city: "Bydgoszcz",
  },
  {
    code: "85-509",
    city: "Bydgoszcz",
  },
  {
    code: "85-510",
    city: "Bydgoszcz",
  },
  {
    code: "85-511",
    city: "Bydgoszcz",
  },
  {
    code: "85-513",
    city: "Bydgoszcz",
  },
  {
    code: "85-514",
    city: "Bydgoszcz",
  },
  {
    code: "85-515",
    city: "Bydgoszcz",
  },
  {
    code: "85-516",
    city: "Bydgoszcz",
  },
  {
    code: "85-517",
    city: "Bydgoszcz",
  },
  {
    code: "85-518",
    city: "Bydgoszcz",
  },
  {
    code: "85-519",
    city: "Bydgoszcz",
  },
  {
    code: "85-520",
    city: "Bydgoszcz",
  },
  {
    code: "85-521",
    city: "Bydgoszcz",
  },
  {
    code: "85-522",
    city: "Bydgoszcz",
  },
  {
    code: "85-523",
    city: "Bydgoszcz",
  },
  {
    code: "85-524",
    city: "Bydgoszcz",
  },
  {
    code: "85-525",
    city: "Bydgoszcz",
  },
  {
    code: "85-526",
    city: "Bydgoszcz",
  },
  {
    code: "85-527",
    city: "Bydgoszcz",
  },
  {
    code: "85-528",
    city: "Bydgoszcz",
  },
  {
    code: "85-529",
    city: "Bydgoszcz",
  },
  {
    code: "85-530",
    city: "Bydgoszcz",
  },
  {
    code: "85-531",
    city: "Bydgoszcz",
  },
  {
    code: "85-532",
    city: "Bydgoszcz",
  },
  {
    code: "85-533",
    city: "Bydgoszcz",
  },
  {
    code: "85-534",
    city: "Bydgoszcz",
  },
  {
    code: "85-535",
    city: "Bydgoszcz",
  },
  {
    code: "85-536",
    city: "Bydgoszcz",
  },
  {
    code: "85-537",
    city: "Bydgoszcz",
  },
  {
    code: "85-539",
    city: "Bydgoszcz",
  },
  {
    code: "85-540",
    city: "Bydgoszcz",
  },
  {
    code: "85-541",
    city: "Bydgoszcz",
  },
  {
    code: "85-542",
    city: "Bydgoszcz",
  },
  {
    code: "85-543",
    city: "Bydgoszcz",
  },
  {
    code: "85-544",
    city: "Bydgoszcz",
  },
  {
    code: "85-545",
    city: "Bydgoszcz",
  },
  {
    code: "85-546",
    city: "Bydgoszcz",
  },
  {
    code: "85-547",
    city: "Bydgoszcz",
  },
  {
    code: "85-548",
    city: "Bydgoszcz",
  },
  {
    code: "85-549",
    city: "Bydgoszcz",
  },
  {
    code: "85-550",
    city: "Bydgoszcz",
  },
  {
    code: "85-551",
    city: "Bydgoszcz",
  },
  {
    code: "85-552",
    city: "Bydgoszcz",
  },
  {
    code: "85-553",
    city: "Bydgoszcz",
  },
  {
    code: "85-554",
    city: "Bydgoszcz",
  },
  {
    code: "85-555",
    city: "Bydgoszcz",
  },
  {
    code: "85-556",
    city: "Bydgoszcz",
  },
  {
    code: "85-557",
    city: "Bydgoszcz",
  },
  {
    code: "85-558",
    city: "Bydgoszcz",
  },
  {
    code: "85-560",
    city: "Bydgoszcz",
  },
  {
    code: "85-561",
    city: "Bydgoszcz",
  },
  {
    code: "85-562",
    city: "Bydgoszcz",
  },
  {
    code: "85-563",
    city: "Bydgoszcz",
  },
  {
    code: "85-564",
    city: "Bydgoszcz",
  },
  {
    code: "85-565",
    city: "Bydgoszcz",
  },
  {
    code: "85-566",
    city: "Bydgoszcz",
  },
  {
    code: "85-567",
    city: "Bydgoszcz",
  },
  {
    code: "85-568",
    city: "Bydgoszcz",
  },
  {
    code: "85-569",
    city: "Bydgoszcz",
  },
  {
    code: "85-570",
    city: "Bydgoszcz",
  },
  {
    code: "85-601",
    city: "Bydgoszcz",
  },
  {
    code: "85-602",
    city: "Bydgoszcz",
  },
  {
    code: "85-603",
    city: "Bydgoszcz",
  },
  {
    code: "85-604",
    city: "Bydgoszcz",
  },
  {
    code: "85-605",
    city: "Bydgoszcz",
  },
  {
    code: "85-606",
    city: "Bydgoszcz",
  },
  {
    code: "85-609",
    city: "Bydgoszcz",
  },
  {
    code: "85-613",
    city: "Bydgoszcz",
  },
  {
    code: "85-614",
    city: "Bydgoszcz",
  },
  {
    code: "85-615",
    city: "Bydgoszcz",
  },
  {
    code: "85-616",
    city: "Bydgoszcz",
  },
  {
    code: "85-617",
    city: "Bydgoszcz",
  },
  {
    code: "85-619",
    city: "Bydgoszcz",
  },
  {
    code: "85-620",
    city: "Bydgoszcz",
  },
  {
    code: "85-621",
    city: "Bydgoszcz",
  },
  {
    code: "85-622",
    city: "Bydgoszcz",
  },
  {
    code: "85-624",
    city: "Bydgoszcz",
  },
  {
    code: "85-625",
    city: "Bydgoszcz",
  },
  {
    code: "85-626",
    city: "Bydgoszcz",
  },
  {
    code: "85-627",
    city: "Bydgoszcz",
  },
  {
    code: "85-628",
    city: "Bydgoszcz",
  },
  {
    code: "85-630",
    city: "Bydgoszcz",
  },
  {
    code: "85-631",
    city: "Bydgoszcz",
  },
  {
    code: "85-632",
    city: "Bydgoszcz",
  },
  {
    code: "85-634",
    city: "Bydgoszcz",
  },
  {
    code: "85-635",
    city: "Bydgoszcz",
  },
  {
    code: "85-636",
    city: "Bydgoszcz",
  },
  {
    code: "85-637",
    city: "Bydgoszcz",
  },
  {
    code: "85-638",
    city: "Bydgoszcz",
  },
  {
    code: "85-640",
    city: "Bydgoszcz",
  },
  {
    code: "85-641",
    city: "Bydgoszcz",
  },
  {
    code: "85-642",
    city: "Bydgoszcz",
  },
  {
    code: "85-643",
    city: "Bydgoszcz",
  },
  {
    code: "85-644",
    city: "Bydgoszcz",
  },
  {
    code: "85-645",
    city: "Bydgoszcz",
  },
  {
    code: "85-646",
    city: "Bydgoszcz",
  },
  {
    code: "85-647",
    city: "Bydgoszcz",
  },
  {
    code: "85-650",
    city: "Bydgoszcz",
  },
  {
    code: "85-651",
    city: "Bydgoszcz",
  },
  {
    code: "85-652",
    city: "Bydgoszcz",
  },
  {
    code: "85-654",
    city: "Bydgoszcz",
  },
  {
    code: "85-655",
    city: "Bydgoszcz",
  },
  {
    code: "85-656",
    city: "Bydgoszcz",
  },
  {
    code: "85-657",
    city: "Bydgoszcz",
  },
  {
    code: "85-658",
    city: "Bydgoszcz",
  },
  {
    code: "85-659",
    city: "Bydgoszcz",
  },
  {
    code: "85-660",
    city: "Bydgoszcz",
  },
  {
    code: "85-661",
    city: "Bydgoszcz",
  },
  {
    code: "85-664",
    city: "Bydgoszcz",
  },
  {
    code: "85-665",
    city: "Bydgoszcz",
  },
  {
    code: "85-666",
    city: "Bydgoszcz",
  },
  {
    code: "85-667",
    city: "Bydgoszcz",
  },
  {
    code: "85-668",
    city: "Bydgoszcz",
  },
  {
    code: "85-669",
    city: "Bydgoszcz",
  },
  {
    code: "85-670",
    city: "Bydgoszcz",
  },
  {
    code: "85-671",
    city: "Bydgoszcz",
  },
  {
    code: "85-674",
    city: "Bydgoszcz",
  },
  {
    code: "85-675",
    city: "Bydgoszcz",
  },
  {
    code: "85-676",
    city: "Bydgoszcz",
  },
  {
    code: "85-677",
    city: "Bydgoszcz",
  },
  {
    code: "85-680",
    city: "Bydgoszcz",
  },
  {
    code: "85-681",
    city: "Bydgoszcz",
  },
  {
    code: "85-684",
    city: "Bydgoszcz",
  },
  {
    code: "85-685",
    city: "Bydgoszcz",
  },
  {
    code: "85-686",
    city: "Bydgoszcz",
  },
  {
    code: "85-687",
    city: "Bydgoszcz",
  },
  {
    code: "85-689",
    city: "Bydgoszcz",
  },
  {
    code: "85-700",
    city: "Bydgoszcz",
  },
  {
    code: "85-701",
    city: "Bydgoszcz",
  },
  {
    code: "85-703",
    city: "Bydgoszcz",
  },
  {
    code: "85-704",
    city: "Bydgoszcz",
  },
  {
    code: "85-707",
    city: "Bydgoszcz",
  },
  {
    code: "85-708",
    city: "Bydgoszcz",
  },
  {
    code: "85-709",
    city: "Bydgoszcz",
  },
  {
    code: "85-710",
    city: "Bydgoszcz",
  },
  {
    code: "85-711",
    city: "Bydgoszcz",
  },
  {
    code: "85-712",
    city: "Bydgoszcz",
  },
  {
    code: "85-713",
    city: "Bydgoszcz",
  },
  {
    code: "85-714",
    city: "Bydgoszcz",
  },
  {
    code: "85-717",
    city: "Bydgoszcz",
  },
  {
    code: "85-718",
    city: "Bydgoszcz",
  },
  {
    code: "85-719",
    city: "Bydgoszcz",
  },
  {
    code: "85-720",
    city: "Bydgoszcz",
  },
  {
    code: "85-721",
    city: "Bydgoszcz",
  },
  {
    code: "85-722",
    city: "Bydgoszcz",
  },
  {
    code: "85-723",
    city: "Bydgoszcz",
  },
  {
    code: "85-724",
    city: "Bydgoszcz",
  },
  {
    code: "85-726",
    city: "Bydgoszcz",
  },
  {
    code: "85-727",
    city: "Bydgoszcz",
  },
  {
    code: "85-728",
    city: "Bydgoszcz",
  },
  {
    code: "85-729",
    city: "Bydgoszcz",
  },
  {
    code: "85-734",
    city: "Bydgoszcz",
  },
  {
    code: "85-735",
    city: "Bydgoszcz",
  },
  {
    code: "85-736",
    city: "Bydgoszcz",
  },
  {
    code: "85-737",
    city: "Bydgoszcz",
  },
  {
    code: "85-738",
    city: "Bydgoszcz",
  },
  {
    code: "85-739",
    city: "Bydgoszcz",
  },
  {
    code: "85-741",
    city: "Bydgoszcz",
  },
  {
    code: "85-742",
    city: "Bydgoszcz",
  },
  {
    code: "85-748",
    city: "Bydgoszcz",
  },
  {
    code: "85-749",
    city: "Bydgoszcz",
  },
  {
    code: "85-750",
    city: "Bydgoszcz",
  },
  {
    code: "85-752",
    city: "Bydgoszcz",
  },
  {
    code: "85-753",
    city: "Bydgoszcz",
  },
  {
    code: "85-754",
    city: "Bydgoszcz",
  },
  {
    code: "85-755",
    city: "Bydgoszcz",
  },
  {
    code: "85-756",
    city: "Bydgoszcz",
  },
  {
    code: "85-757",
    city: "Bydgoszcz",
  },
  {
    code: "85-758",
    city: "Bydgoszcz",
  },
  {
    code: "85-766",
    city: "Bydgoszcz",
  },
  {
    code: "85-767",
    city: "Bydgoszcz",
  },
  {
    code: "85-768",
    city: "Bydgoszcz",
  },
  {
    code: "85-770",
    city: "Bydgoszcz",
  },
  {
    code: "85-771",
    city: "Bydgoszcz",
  },
  {
    code: "85-774",
    city: "Bydgoszcz",
  },
  {
    code: "85-775",
    city: "Bydgoszcz",
  },
  {
    code: "85-776",
    city: "Bydgoszcz",
  },
  {
    code: "85-777",
    city: "Bydgoszcz",
  },
  {
    code: "85-787",
    city: "Bydgoszcz",
  },
  {
    code: "85-788",
    city: "Bydgoszcz",
  },
  {
    code: "85-789",
    city: "Bydgoszcz",
  },
  {
    code: "85-790",
    city: "Bydgoszcz",
  },
  {
    code: "85-791",
    city: "Bydgoszcz",
  },
  {
    code: "85-792",
    city: "Bydgoszcz",
  },
  {
    code: "85-793",
    city: "Bydgoszcz",
  },
  {
    code: "85-794",
    city: "Bydgoszcz",
  },
  {
    code: "85-795",
    city: "Bydgoszcz",
  },
  {
    code: "85-796",
    city: "Bydgoszcz",
  },
  {
    code: "85-797",
    city: "Bydgoszcz",
  },
  {
    code: "85-798",
    city: "Bydgoszcz",
  },
  {
    code: "85-799",
    city: "Bydgoszcz",
  },
  {
    code: "85-800",
    city: "Bydgoszcz",
  },
  {
    code: "85-801",
    city: "Bydgoszcz",
  },
  {
    code: "85-802",
    city: "Bydgoszcz",
  },
  {
    code: "85-803",
    city: "Bydgoszcz",
  },
  {
    code: "85-804",
    city: "Bydgoszcz",
  },
  {
    code: "85-805",
    city: "Bydgoszcz",
  },
  {
    code: "85-806",
    city: "Bydgoszcz",
  },
  {
    code: "85-807",
    city: "Bydgoszcz",
  },
  {
    code: "85-808",
    city: "Bydgoszcz",
  },
  {
    code: "85-809",
    city: "Bydgoszcz",
  },
  {
    code: "85-810",
    city: "Bydgoszcz",
  },
  {
    code: "85-811",
    city: "Bydgoszcz",
  },
  {
    code: "85-812",
    city: "Bydgoszcz",
  },
  {
    code: "85-813",
    city: "Bydgoszcz",
  },
  {
    code: "85-814",
    city: "Bydgoszcz",
  },
  {
    code: "85-815",
    city: "Bydgoszcz",
  },
  {
    code: "85-816",
    city: "Bydgoszcz",
  },
  {
    code: "85-817",
    city: "Bydgoszcz",
  },
  {
    code: "85-818",
    city: "Bydgoszcz",
  },
  {
    code: "85-819",
    city: "Bydgoszcz",
  },
  {
    code: "85-820",
    city: "Bydgoszcz",
  },
  {
    code: "85-821",
    city: "Bydgoszcz",
  },
  {
    code: "85-822",
    city: "Bydgoszcz",
  },
  {
    code: "85-823",
    city: "Bydgoszcz",
  },
  {
    code: "85-824",
    city: "Bydgoszcz",
  },
  {
    code: "85-825",
    city: "Bydgoszcz",
  },
  {
    code: "85-826",
    city: "Bydgoszcz",
  },
  {
    code: "85-827",
    city: "Bydgoszcz",
  },
  {
    code: "85-828",
    city: "Bydgoszcz",
  },
  {
    code: "85-829",
    city: "Bydgoszcz",
  },
  {
    code: "85-830",
    city: "Bydgoszcz",
  },
  {
    code: "85-831",
    city: "Bydgoszcz",
  },
  {
    code: "85-832",
    city: "Bydgoszcz",
  },
  {
    code: "85-833",
    city: "Bydgoszcz",
  },
  {
    code: "85-834",
    city: "Bydgoszcz",
  },
  {
    code: "85-835",
    city: "Bydgoszcz",
  },
  {
    code: "85-836",
    city: "Bydgoszcz",
  },
  {
    code: "85-837",
    city: "Bydgoszcz",
  },
  {
    code: "85-838",
    city: "Bydgoszcz",
  },
  {
    code: "85-839",
    city: "Bydgoszcz",
  },
  {
    code: "85-840",
    city: "Bydgoszcz",
  },
  {
    code: "85-841",
    city: "Bydgoszcz",
  },
  {
    code: "85-843",
    city: "Bydgoszcz",
  },
  {
    code: "85-844",
    city: "Bydgoszcz",
  },
  {
    code: "85-845",
    city: "Bydgoszcz",
  },
  {
    code: "85-846",
    city: "Bydgoszcz",
  },
  {
    code: "85-847",
    city: "Bydgoszcz",
  },
  {
    code: "85-849",
    city: "Bydgoszcz",
  },
  {
    code: "85-850",
    city: "Bydgoszcz",
  },
  {
    code: "85-851",
    city: "Bydgoszcz",
  },
  {
    code: "85-852",
    city: "Bydgoszcz",
  },
  {
    code: "85-853",
    city: "Bydgoszcz",
  },
  {
    code: "85-854",
    city: "Bydgoszcz",
  },
  {
    code: "85-855",
    city: "Bydgoszcz",
  },
  {
    code: "85-856",
    city: "Bydgoszcz",
  },
  {
    code: "85-857",
    city: "Bydgoszcz",
  },
  {
    code: "85-858",
    city: "Bydgoszcz",
  },
  {
    code: "85-859",
    city: "Bydgoszcz",
  },
  {
    code: "85-860",
    city: "Bydgoszcz",
  },
  {
    code: "85-861",
    city: "Bydgoszcz",
  },
  {
    code: "85-862",
    city: "Bydgoszcz",
  },
  {
    code: "85-863",
    city: "Bydgoszcz",
  },
  {
    code: "85-864",
    city: "Bydgoszcz",
  },
  {
    code: "85-865",
    city: "Bydgoszcz",
  },
  {
    code: "85-866",
    city: "Bydgoszcz",
  },
  {
    code: "85-867",
    city: "Bydgoszcz",
  },
  {
    code: "85-868",
    city: "Bydgoszcz",
  },
  {
    code: "85-869",
    city: "Bydgoszcz",
  },
  {
    code: "85-870",
    city: "Bydgoszcz",
  },
  {
    code: "85-871",
    city: "Bydgoszcz",
  },
  {
    code: "85-872",
    city: "Bydgoszcz",
  },
  {
    code: "85-873",
    city: "Bydgoszcz",
  },
  {
    code: "85-874",
    city: "Bydgoszcz",
  },
  {
    code: "85-875",
    city: "Bydgoszcz",
  },
  {
    code: "85-876",
    city: "Bydgoszcz",
  },
  {
    code: "85-877",
    city: "Bydgoszcz",
  },
  {
    code: "85-879",
    city: "Bydgoszcz",
  },
  {
    code: "85-880",
    city: "Bydgoszcz",
  },
  {
    code: "85-881",
    city: "Bydgoszcz",
  },
  {
    code: "85-882",
    city: "Bydgoszcz",
  },
  {
    code: "85-883",
    city: "Bydgoszcz",
  },
  {
    code: "85-884",
    city: "Bydgoszcz",
  },
  {
    code: "85-885",
    city: "Bydgoszcz",
  },
  {
    code: "85-886",
    city: "Bydgoszcz",
  },
  {
    code: "85-888",
    city: "Bydgoszcz",
  },
  {
    code: "85-889",
    city: "Bydgoszcz",
  },
  {
    code: "85-890",
    city: "Bydgoszcz",
  },
  {
    code: "85-891",
    city: "Bydgoszcz",
  },
  {
    code: "85-892",
    city: "Bydgoszcz",
  },
  {
    code: "85-893",
    city: "Bydgoszcz",
  },
  {
    code: "85-894",
    city: "Bydgoszcz",
  },
  {
    code: "85-895",
    city: "Bydgoszcz",
  },
  {
    code: "85-900",
    city: "Bydgoszcz",
  },
  {
    code: "85-915",
    city: "Bydgoszcz",
  },
  {
    code: "85-940",
    city: "Bydgoszcz",
  },
  {
    code: "85-950",
    city: "Bydgoszcz",
  },
  {
    code: "85-980",
    city: "Bydgoszcz",
  },
  {
    code: "86-005",
    city: "Białe Błota",
  },
  {
    code: "86-008",
    city: "Koronowo",
  },
  {
    code: "86-010",
    city: "Koronowo",
  },
  {
    code: "86-011",
    city: "Wtelno",
  },
  {
    code: "86-013",
    city: "Mąkowarsko",
  },
  {
    code: "86-014",
    city: "Sicienko",
  },
  {
    code: "86-017",
    city: "Wierzchucin Królewski",
  },
  {
    code: "86-020",
    city: "Kotomierz",
  },
  {
    code: "86-021",
    city: "Maksymilianowo",
  },
  {
    code: "86-022",
    city: "Dobrcz",
  },
  {
    code: "86-031",
    city: "Osielsko",
  },
  {
    code: "86-032",
    city: "Niemcz",
  },
  {
    code: "86-050",
    city: "Solec Kujawski",
  },
  {
    code: "86-055",
    city: "Solec Kujawski",
  },
  {
    code: "86-060",
    city: "Nowa Wieś Wielka",
  },
  {
    code: "86-061",
    city: "Brzoza",
  },
  {
    code: "86-065",
    city: "Łochowo",
  },
  {
    code: "86-070",
    city: "Dąbrowa Chełmińska",
  },
  {
    code: "86-071",
    city: "Czarże",
  },
  {
    code: "86-100",
    city: "Świecie",
  },
  {
    code: "86-101",
    city: "Świecie",
  },
  {
    code: "86-102",
    city: "Świecie",
  },
  {
    code: "86-105",
    city: "Świecie",
  },
  {
    code: "86-111",
    city: "Gruczno",
  },
  {
    code: "86-120",
    city: "Pruszcz",
  },
  {
    code: "86-122",
    city: "Bukowiec",
  },
  {
    code: "86-130",
    city: "Laskowice",
  },
  {
    code: "86-131",
    city: "Jeżewo",
  },
  {
    code: "86-132",
    city: "Grupa",
  },
  {
    code: "86-134",
    city: "Dragacz",
  },
  {
    code: "86-140",
    city: "Drzycim",
  },
  {
    code: "86-141",
    city: "Lniano",
  },
  {
    code: "86-150",
    city: "Osie",
  },
  {
    code: "86-160",
    city: "Warlubie",
  },
  {
    code: "86-170",
    city: "Nowe",
  },
  {
    code: "86-173",
    city: "Nowe",
  },
  {
    code: "86-181",
    city: "Serock",
  },
  {
    code: "86-182",
    city: "Świekatowo",
  },
  {
    code: "86-200",
    city: "Chełmno",
  },
  {
    code: "86-202",
    city: "Chełmno",
  },
  {
    code: "86-203",
    city: "Chełmno",
  },
  {
    code: "86-208",
    city: "Podwiesk",
  },
  {
    code: "86-212",
    city: "Stolno",
  },
  {
    code: "86-221",
    city: "Papowo Biskupie",
  },
  {
    code: "86-230",
    city: "Lisewo",
  },
  {
    code: "86-253",
    city: "Kijewo Królewskie",
  },
  {
    code: "86-260",
    city: "Unisław",
  },
  {
    code: "86-300",
    city: "Grudziądz",
  },
  {
    code: "86-301",
    city: "Grudziądz",
  },
  {
    code: "86-302",
    city: "Grudziądz",
  },
  {
    code: "86-303",
    city: "Grudziądz",
  },
  {
    code: "86-304",
    city: "Grudziądz",
  },
  {
    code: "86-305",
    city: "Grudziądz",
  },
  {
    code: "86-306",
    city: "Grudziądz",
  },
  {
    code: "86-307",
    city: "Grudziądz",
  },
  {
    code: "86-308",
    city: "Grudziądz",
  },
  {
    code: "86-309",
    city: "Grudziądz",
  },
  {
    code: "86-311",
    city: "Grudziądz",
  },
  {
    code: "86-318",
    city: "Rogóźno",
  },
  {
    code: "86-320",
    city: "Łasin",
  },
  {
    code: "86-327",
    city: "Gruta",
  },
  {
    code: "86-330",
    city: "Mełno",
  },
  {
    code: "86-341",
    city: "Świecie nad Osą",
  },
  {
    code: "86-342",
    city: "Lisnowo",
  },
  {
    code: "86-380",
    city: "Grudziądz",
  },
  {
    code: "87-100",
    city: "Toruń",
  },
  {
    code: "87-101",
    city: "Toruń",
  },
  {
    code: "87-102",
    city: "Toruń",
  },
  {
    code: "87-103",
    city: "Toruń",
  },
  {
    code: "87-104",
    city: "Toruń",
  },
  {
    code: "87-105",
    city: "Toruń",
  },
  {
    code: "87-106",
    city: "Toruń",
  },
  {
    code: "87-107",
    city: "Toruń",
  },
  {
    code: "87-108",
    city: "Toruń",
  },
  {
    code: "87-109",
    city: "Toruń",
  },
  {
    code: "87-110",
    city: "Toruń",
  },
  {
    code: "87-111",
    city: "Toruń",
  },
  {
    code: "87-112",
    city: "Toruń",
  },
  {
    code: "87-113",
    city: "Toruń",
  },
  {
    code: "87-114",
    city: "Toruń",
  },
  {
    code: "87-115",
    city: "Toruń",
  },
  {
    code: "87-116",
    city: "Toruń",
  },
  {
    code: "87-117",
    city: "Toruń",
  },
  {
    code: "87-118",
    city: "Toruń",
  },
  {
    code: "87-119",
    city: "Toruń",
  },
  {
    code: "87-120",
    city: "Toruń",
  },
  {
    code: "87-122",
    city: "Grębocin",
  },
  {
    code: "87-123",
    city: "Dobrzejewice",
  },
  {
    code: "87-125",
    city: "Osiek",
  },
  {
    code: "87-126",
    city: "Obrowo",
  },
  {
    code: "87-133",
    city: "Rzęczkowo",
  },
  {
    code: "87-134",
    city: "Zławieś Wielka",
  },
  {
    code: "87-140",
    city: "Chełmża",
  },
  {
    code: "87-148",
    city: "Łysomice",
  },
  {
    code: "87-152",
    city: "Łubianka",
  },
  {
    code: "87-162",
    city: "Lubicz",
  },
  {
    code: "87-165",
    city: "Cierpice",
  },
  {
    code: "87-200",
    city: "Wąbrzeźno",
  },
  {
    code: "87-201",
    city: "Wąbrzeźno",
  },
  {
    code: "87-207",
    city: "Dębowa Łąka",
  },
  {
    code: "87-213",
    city: "Ryńsk",
  },
  {
    code: "87-214",
    city: "Płużnica",
  },
  {
    code: "87-220",
    city: "Radzyń Chełmiński",
  },
  {
    code: "87-222",
    city: "Książki",
  },
  {
    code: "87-300",
    city: "Brodnica",
  },
  {
    code: "87-301",
    city: "Brodnica",
  },
  {
    code: "87-302",
    city: "Brodnica",
  },
  {
    code: "87-305",
    city: "Zbiczno",
  },
  {
    code: "87-312",
    city: "Pokrzydowo",
  },
  {
    code: "87-313",
    city: "Brzozie",
  },
  {
    code: "87-320",
    city: "Górzno",
  },
  {
    code: "87-321",
    city: "Bartniczka",
  },
  {
    code: "87-322",
    city: "Jastrzębie",
  },
  {
    code: "87-326",
    city: "Nieżywięć",
  },
  {
    code: "87-327",
    city: "Bobrowo",
  },
  {
    code: "87-330",
    city: "Jabłonowo Pomorskie",
  },
  {
    code: "87-335",
    city: "Świedziebnia",
  },
  {
    code: "87-337",
    city: "Wąpielsk",
  },
  {
    code: "87-340",
    city: "Osiek",
  },
  {
    code: "87-400",
    city: "Golub-Dobrzyń",
  },
  {
    code: "87-401",
    city: "Golub-Dobrzyń",
  },
  {
    code: "87-404",
    city: "Radomin",
  },
  {
    code: "87-408",
    city: "Ciechocin",
  },
  {
    code: "87-410",
    city: "Kowalewo Pomorskie",
  },
  {
    code: "87-423",
    city: "Wrocki",
  },
  {
    code: "87-500",
    city: "Rypin",
  },
  {
    code: "87-501",
    city: "Rypin",
  },
  {
    code: "87-506",
    city: "Urszulewo",
  },
  {
    code: "87-510",
    city: "Skrwilno",
  },
  {
    code: "87-511",
    city: "Okalewo",
  },
  {
    code: "87-513",
    city: "Stępowo",
  },
  {
    code: "87-515",
    city: "Rogowo",
  },
  {
    code: "87-517",
    city: "Brzuze",
  },
  {
    code: "87-521",
    city: "Ugoszcz",
  },
  {
    code: "87-522",
    city: "Ostrowite",
  },
  {
    code: "87-600",
    city: "Lipno",
  },
  {
    code: "87-601",
    city: "Lipno",
  },
  {
    code: "87-602",
    city: "Chrostkowo",
  },
  {
    code: "87-603",
    city: "Wielgie",
  },
  {
    code: "87-605",
    city: "Tłuchowo",
  },
  {
    code: "87-606",
    city: "Chalin",
  },
  {
    code: "87-607",
    city: "Mokowo",
  },
  {
    code: "87-610",
    city: "Dobrzyń nad Wisłą",
  },
  {
    code: "87-611",
    city: "Grochowalsk",
  },
  {
    code: "87-615",
    city: "Łochocin",
  },
  {
    code: "87-617",
    city: "Bobrowniki",
  },
  {
    code: "87-618",
    city: "Brzeźno",
  },
  {
    code: "87-620",
    city: "Kikół",
  },
  {
    code: "87-630",
    city: "Skępe",
  },
  {
    code: "87-632",
    city: "Osówka",
  },
  {
    code: "87-640",
    city: "Czernikowo",
  },
  {
    code: "87-641",
    city: "Mazowsze",
  },
  {
    code: "87-645",
    city: "Zbójno",
  },
  {
    code: "87-700",
    city: "Aleksandrów Kujawski",
  },
  {
    code: "87-702",
    city: "Koneck",
  },
  {
    code: "87-703",
    city: "Łowiczek",
  },
  {
    code: "87-704",
    city: "Bądkowo",
  },
  {
    code: "87-705",
    city: "Siniarzewo",
  },
  {
    code: "87-706",
    city: "Sędzin",
  },
  {
    code: "87-707",
    city: "Zakrzewo",
  },
  {
    code: "87-708",
    city: "Straszewo",
  },
  {
    code: "87-710",
    city: "Służewo",
  },
  {
    code: "87-712",
    city: "Aleksandrów Kujawski",
  },
  {
    code: "87-720",
    city: "Ciechocinek",
  },
  {
    code: "87-721",
    city: "Raciążek",
  },
  {
    code: "87-722",
    city: "Ciechocinek",
  },
  {
    code: "87-730",
    city: "Nieszawa",
  },
  {
    code: "87-731",
    city: "Waganiec",
  },
  {
    code: "87-732",
    city: "Lubanie",
  },
  {
    code: "87-800",
    city: "Włocławek",
  },
  {
    code: "87-801",
    city: "Włocławek",
  },
  {
    code: "87-802",
    city: "Włocławek",
  },
  {
    code: "87-803",
    city: "Włocławek",
  },
  {
    code: "87-804",
    city: "Włocławek",
  },
  {
    code: "87-805",
    city: "Włocławek",
  },
  {
    code: "87-806",
    city: "Włocławek",
  },
  {
    code: "87-807",
    city: "Włocławek",
  },
  {
    code: "87-808",
    city: "Włocławek",
  },
  {
    code: "87-809",
    city: "Włocławek",
  },
  {
    code: "87-810",
    city: "Włocławek",
  },
  {
    code: "87-811",
    city: "Fabianki",
  },
  {
    code: "87-812",
    city: "Włocławek",
  },
  {
    code: "87-814",
    city: "Wieniec",
  },
  {
    code: "87-815",
    city: "Smólnik",
  },
  {
    code: "87-816",
    city: "Włocławek",
  },
  {
    code: "87-817",
    city: "Włocławek",
  },
  {
    code: "87-818",
    city: "Włocławek",
  },
  {
    code: "87-820",
    city: "Kowal",
  },
  {
    code: "87-821",
    city: "Baruchowo",
  },
  {
    code: "87-822",
    city: "Włocławek",
  },
  {
    code: "87-830",
    city: "Czerniewice",
  },
  {
    code: "87-840",
    city: "Lubień Kujawski",
  },
  {
    code: "87-850",
    city: "Choceń",
  },
  {
    code: "87-851",
    city: "Boniewo",
  },
  {
    code: "87-853",
    city: "Kruszyn",
  },
  {
    code: "87-860",
    city: "Chodecz",
  },
  {
    code: "87-865",
    city: "Izbica Kujawska",
  },
  {
    code: "87-866",
    city: "Błenna",
  },
  {
    code: "87-875",
    city: "Topólka",
  },
  {
    code: "87-880",
    city: "Brześć Kujawski",
  },
  {
    code: "87-890",
    city: "Lubraniec",
  },
  {
    code: "88-100",
    city: "Inowrocław",
  },
  {
    code: "88-101",
    city: "Inowrocław",
  },
  {
    code: "88-102",
    city: "Inowrocław",
  },
  {
    code: "88-103",
    city: "Inowrocław",
  },
  {
    code: "88-104",
    city: "Inowrocław",
  },
  {
    code: "88-105",
    city: "Inowrocław",
  },
  {
    code: "88-106",
    city: "Inowrocław",
  },
  {
    code: "88-107",
    city: "Inowrocław",
  },
  {
    code: "88-108",
    city: "Inowrocław",
  },
  {
    code: "88-109",
    city: "Inowrocław",
  },
  {
    code: "88-110",
    city: "Inowrocław",
  },
  {
    code: "88-111",
    city: "Rojewo",
  },
  {
    code: "88-115",
    city: "Inowrocław",
  },
  {
    code: "88-121",
    city: "Chełmce",
  },
  {
    code: "88-126",
    city: "Tuczno",
  },
  {
    code: "88-133",
    city: "Dąbrowa Biskupia",
  },
  {
    code: "88-140",
    city: "Gniewkowo",
  },
  {
    code: "88-150",
    city: "Kruszwica",
  },
  {
    code: "88-153",
    city: "Kruszwica",
  },
  {
    code: "88-160",
    city: "Janikowo",
  },
  {
    code: "88-170",
    city: "Pakość",
  },
  {
    code: "88-180",
    city: "Złotniki Kujawskie",
  },
  {
    code: "88-181",
    city: "Jaksice",
  },
  {
    code: "88-190",
    city: "Barcin",
  },
  {
    code: "88-192",
    city: "Piechcin",
  },
  {
    code: "88-193",
    city: "Barcin",
  },
  {
    code: "88-200",
    city: "Radziejów",
  },
  {
    code: "88-210",
    city: "Dobre",
  },
  {
    code: "88-220",
    city: "Osięciny",
  },
  {
    code: "88-230",
    city: "Piotrków Kujawski",
  },
  {
    code: "88-231",
    city: "Bytoń",
  },
  {
    code: "88-232",
    city: "Witowo",
  },
  {
    code: "88-235",
    city: "Nowa Wieś",
  },
  {
    code: "88-237",
    city: "Bycz",
  },
  {
    code: "88-300",
    city: "Mogilno",
  },
  {
    code: "88-306",
    city: "Dąbrowa",
  },
  {
    code: "88-312",
    city: "Przyjezierze",
  },
  {
    code: "88-320",
    city: "Strzelno",
  },
  {
    code: "88-324",
    city: "Jeziora Wielkie",
  },
  {
    code: "88-330",
    city: "Gębice",
  },
  {
    code: "88-400",
    city: "Żnin",
  },
  {
    code: "88-401",
    city: "Żnin",
  },
  {
    code: "88-402",
    city: "Żnin",
  },
  {
    code: "88-404",
    city: "Podobowice",
  },
  {
    code: "88-405",
    city: "Gorzyce",
  },
  {
    code: "88-409",
    city: "Biskupin",
  },
  {
    code: "88-410",
    city: "Gąsawa",
  },
  {
    code: "88-420",
    city: "Rogowo",
  },
  {
    code: "88-422",
    city: "Gościeszyn",
  },
  {
    code: "88-430",
    city: "Janowiec Wielkopolski",
  },
  {
    code: "89-100",
    city: "Nakło nad Notecią",
  },
  {
    code: "89-103",
    city: "Nakło nad Notecią",
  },
  {
    code: "89-104",
    city: "Nakło nad Notecią",
  },
  {
    code: "89-110",
    city: "Sadki",
  },
  {
    code: "89-115",
    city: "Mrocza",
  },
  {
    code: "89-120",
    city: "Potulice",
  },
  {
    code: "89-121",
    city: "Ślesin",
  },
  {
    code: "89-200",
    city: "Szubin",
  },
  {
    code: "89-203",
    city: "Rynarzewo",
  },
  {
    code: "89-205",
    city: "Tur",
  },
  {
    code: "89-210",
    city: "Łabiszyn",
  },
  {
    code: "89-240",
    city: "Kcynia",
  },
  {
    code: "89-241",
    city: "Gromadno",
  },
  {
    code: "89-300",
    city: "Wyrzysk",
  },
  {
    code: "89-310",
    city: "Łobżenica",
  },
  {
    code: "89-320",
    city: "Wysoka",
  },
  {
    code: "89-333",
    city: "Osiek nad Notecią",
  },
  {
    code: "89-340",
    city: "Białośliwie",
  },
  {
    code: "89-350",
    city: "Miasteczko Krajeńskie",
  },
  {
    code: "89-400",
    city: "Sępólno Krajeńskie",
  },
  {
    code: "89-410",
    city: "Więcbork",
  },
  {
    code: "89-412",
    city: "Sośno",
  },
  {
    code: "89-413",
    city: "Wąwelno",
  },
  {
    code: "89-422",
    city: "Sypniewo",
  },
  {
    code: "89-430",
    city: "Kamień Krajeński",
  },
  {
    code: "89-500",
    city: "Tuchola",
  },
  {
    code: "89-501",
    city: "Tuchola",
  },
  {
    code: "89-504",
    city: "Legbąd",
  },
  {
    code: "89-505",
    city: "Małe Gacno",
  },
  {
    code: "89-506",
    city: "Kęsowo",
  },
  {
    code: "89-510",
    city: "Bysław",
  },
  {
    code: "89-511",
    city: "Cekcyn",
  },
  {
    code: "89-512",
    city: "Iwiec",
  },
  {
    code: "89-520",
    city: "Gostycyn",
  },
  {
    code: "89-525",
    city: "Sucha",
  },
  {
    code: "89-526",
    city: "Lubiewo",
  },
  {
    code: "89-530",
    city: "Śliwice",
  },
  {
    code: "89-600",
    city: "Chojnice",
  },
  {
    code: "89-604",
    city: "Chojnice",
  },
  {
    code: "89-606",
    city: "Charzykowy",
  },
  {
    code: "89-607",
    city: "Konarzyny",
  },
  {
    code: "89-608",
    city: "Swornegacie",
  },
  {
    code: "89-620",
    city: "Chojnice",
  },
  {
    code: "89-632",
    city: "Brusy",
  },
  {
    code: "89-634",
    city: "Leśno",
  },
  {
    code: "89-642",
    city: "Rytel",
  },
  {
    code: "89-650",
    city: "Czersk",
  },
  {
    code: "89-651",
    city: "Gotelp",
  },
  {
    code: "89-652",
    city: "Łąg",
  },
  {
    code: "90-001",
    city: "Łódź",
  },
  {
    code: "90-002",
    city: "Łódź",
  },
  {
    code: "90-003",
    city: "Łódź",
  },
  {
    code: "90-004",
    city: "Łódź",
  },
  {
    code: "90-005",
    city: "Łódź",
  },
  {
    code: "90-006",
    city: "Łódź",
  },
  {
    code: "90-007",
    city: "Łódź",
  },
  {
    code: "90-008",
    city: "Łódź",
  },
  {
    code: "90-009",
    city: "Łódź",
  },
  {
    code: "90-010",
    city: "Łódź",
  },
  {
    code: "90-011",
    city: "Łódź",
  },
  {
    code: "90-012",
    city: "Łódź",
  },
  {
    code: "90-013",
    city: "Łódź",
  },
  {
    code: "90-014",
    city: "Łódź",
  },
  {
    code: "90-015",
    city: "Łódź",
  },
  {
    code: "90-018",
    city: "Łódź",
  },
  {
    code: "90-019",
    city: "Łódź",
  },
  {
    code: "90-020",
    city: "Łódź",
  },
  {
    code: "90-021",
    city: "Łódź",
  },
  {
    code: "90-022",
    city: "Łódź",
  },
  {
    code: "90-023",
    city: "Łódź",
  },
  {
    code: "90-024",
    city: "Łódź",
  },
  {
    code: "90-025",
    city: "Łódź",
  },
  {
    code: "90-026",
    city: "Łódź",
  },
  {
    code: "90-028",
    city: "Łódź",
  },
  {
    code: "90-029",
    city: "Łódź",
  },
  {
    code: "90-030",
    city: "Łódź",
  },
  {
    code: "90-031",
    city: "Łódź",
  },
  {
    code: "90-032",
    city: "Łódź",
  },
  {
    code: "90-033",
    city: "Łódź",
  },
  {
    code: "90-034",
    city: "Łódź",
  },
  {
    code: "90-035",
    city: "Łódź",
  },
  {
    code: "90-036",
    city: "Łódź",
  },
  {
    code: "90-037",
    city: "Łódź",
  },
  {
    code: "90-038",
    city: "Łódź",
  },
  {
    code: "90-039",
    city: "Łódź",
  },
  {
    code: "90-040",
    city: "Łódź",
  },
  {
    code: "90-042",
    city: "Łódź",
  },
  {
    code: "90-043",
    city: "Łódź",
  },
  {
    code: "90-045",
    city: "Łódź",
  },
  {
    code: "90-046",
    city: "Łódź",
  },
  {
    code: "90-047",
    city: "Łódź",
  },
  {
    code: "90-049",
    city: "Łódź",
  },
  {
    code: "90-050",
    city: "Łódź",
  },
  {
    code: "90-051",
    city: "Łódź",
  },
  {
    code: "90-052",
    city: "Łódź",
  },
  {
    code: "90-053",
    city: "Łódź",
  },
  {
    code: "90-054",
    city: "Łódź",
  },
  {
    code: "90-055",
    city: "Łódź",
  },
  {
    code: "90-056",
    city: "Łódź",
  },
  {
    code: "90-057",
    city: "Łódź",
  },
  {
    code: "90-058",
    city: "Łódź",
  },
  {
    code: "90-060",
    city: "Łódź",
  },
  {
    code: "90-061",
    city: "Łódź",
  },
  {
    code: "90-062",
    city: "Łódź",
  },
  {
    code: "90-063",
    city: "Łódź",
  },
  {
    code: "90-101",
    city: "Łódź",
  },
  {
    code: "90-102",
    city: "Łódź",
  },
  {
    code: "90-103",
    city: "Łódź",
  },
  {
    code: "90-105",
    city: "Łódź",
  },
  {
    code: "90-106",
    city: "Łódź",
  },
  {
    code: "90-107",
    city: "Łódź",
  },
  {
    code: "90-110",
    city: "Łódź",
  },
  {
    code: "90-111",
    city: "Łódź",
  },
  {
    code: "90-113",
    city: "Łódź",
  },
  {
    code: "90-114",
    city: "Łódź",
  },
  {
    code: "90-116",
    city: "Łódź",
  },
  {
    code: "90-117",
    city: "Łódź",
  },
  {
    code: "90-118",
    city: "Łódź",
  },
  {
    code: "90-119",
    city: "Łódź",
  },
  {
    code: "90-123",
    city: "Łódź",
  },
  {
    code: "90-124",
    city: "Łódź",
  },
  {
    code: "90-125",
    city: "Łódź",
  },
  {
    code: "90-126",
    city: "Łódź",
  },
  {
    code: "90-127",
    city: "Łódź",
  },
  {
    code: "90-128",
    city: "Łódź",
  },
  {
    code: "90-129",
    city: "Łódź",
  },
  {
    code: "90-130",
    city: "Łódź",
  },
  {
    code: "90-131",
    city: "Łódź",
  },
  {
    code: "90-132",
    city: "Łódź",
  },
  {
    code: "90-133",
    city: "Łódź",
  },
  {
    code: "90-135",
    city: "Łódź",
  },
  {
    code: "90-136",
    city: "Łódź",
  },
  {
    code: "90-137",
    city: "Łódź",
  },
  {
    code: "90-138",
    city: "Łódź",
  },
  {
    code: "90-139",
    city: "Łódź",
  },
  {
    code: "90-140",
    city: "Łódź",
  },
  {
    code: "90-141",
    city: "Łódź",
  },
  {
    code: "90-142",
    city: "Łódź",
  },
  {
    code: "90-143",
    city: "Łódź",
  },
  {
    code: "90-145",
    city: "Łódź",
  },
  {
    code: "90-146",
    city: "Łódź",
  },
  {
    code: "90-147",
    city: "Łódź",
  },
  {
    code: "90-148",
    city: "Łódź",
  },
  {
    code: "90-149",
    city: "Łódź",
  },
  {
    code: "90-150",
    city: "Łódź",
  },
  {
    code: "90-151",
    city: "Łódź",
  },
  {
    code: "90-153",
    city: "Łódź",
  },
  {
    code: "90-154",
    city: "Łódź",
  },
  {
    code: "90-155",
    city: "Łódź",
  },
  {
    code: "90-156",
    city: "Łódź",
  },
  {
    code: "90-157",
    city: "Łódź",
  },
  {
    code: "90-158",
    city: "Łódź",
  },
  {
    code: "90-159",
    city: "Łódź",
  },
  {
    code: "90-160",
    city: "Łódź",
  },
  {
    code: "90-161",
    city: "Łódź",
  },
  {
    code: "90-201",
    city: "Łódź",
  },
  {
    code: "90-202",
    city: "Łódź",
  },
  {
    code: "90-203",
    city: "Łódź",
  },
  {
    code: "90-204",
    city: "Łódź",
  },
  {
    code: "90-205",
    city: "Łódź",
  },
  {
    code: "90-206",
    city: "Łódź",
  },
  {
    code: "90-207",
    city: "Łódź",
  },
  {
    code: "90-208",
    city: "Łódź",
  },
  {
    code: "90-209",
    city: "Łódź",
  },
  {
    code: "90-210",
    city: "Łódź",
  },
  {
    code: "90-211",
    city: "Łódź",
  },
  {
    code: "90-212",
    city: "Łódź",
  },
  {
    code: "90-213",
    city: "Łódź",
  },
  {
    code: "90-214",
    city: "Łódź",
  },
  {
    code: "90-215",
    city: "Łódź",
  },
  {
    code: "90-216",
    city: "Łódź",
  },
  {
    code: "90-217",
    city: "Łódź",
  },
  {
    code: "90-218",
    city: "Łódź",
  },
  {
    code: "90-219",
    city: "Łódź",
  },
  {
    code: "90-220",
    city: "Łódź",
  },
  {
    code: "90-221",
    city: "Łódź",
  },
  {
    code: "90-222",
    city: "Łódź",
  },
  {
    code: "90-223",
    city: "Łódź",
  },
  {
    code: "90-224",
    city: "Łódź",
  },
  {
    code: "90-225",
    city: "Łódź",
  },
  {
    code: "90-226",
    city: "Łódź",
  },
  {
    code: "90-227",
    city: "Łódź",
  },
  {
    code: "90-228",
    city: "Łódź",
  },
  {
    code: "90-229",
    city: "Łódź",
  },
  {
    code: "90-231",
    city: "Łódź",
  },
  {
    code: "90-232",
    city: "Łódź",
  },
  {
    code: "90-233",
    city: "Łódź",
  },
  {
    code: "90-234",
    city: "Łódź",
  },
  {
    code: "90-235",
    city: "Łódź",
  },
  {
    code: "90-236",
    city: "Łódź",
  },
  {
    code: "90-237",
    city: "Łódź",
  },
  {
    code: "90-238",
    city: "Łódź",
  },
  {
    code: "90-241",
    city: "Łódź",
  },
  {
    code: "90-242",
    city: "Łódź",
  },
  {
    code: "90-243",
    city: "Łódź",
  },
  {
    code: "90-244",
    city: "Łódź",
  },
  {
    code: "90-245",
    city: "Łódź",
  },
  {
    code: "90-248",
    city: "Łódź",
  },
  {
    code: "90-249",
    city: "Łódź",
  },
  {
    code: "90-250",
    city: "Łódź",
  },
  {
    code: "90-251",
    city: "Łódź",
  },
  {
    code: "90-252",
    city: "Łódź",
  },
  {
    code: "90-253",
    city: "Łódź",
  },
  {
    code: "90-254",
    city: "Łódź",
  },
  {
    code: "90-255",
    city: "Łódź",
  },
  {
    code: "90-256",
    city: "Łódź",
  },
  {
    code: "90-257",
    city: "Łódź",
  },
  {
    code: "90-258",
    city: "Łódź",
  },
  {
    code: "90-259",
    city: "Łódź",
  },
  {
    code: "90-260",
    city: "Łódź",
  },
  {
    code: "90-261",
    city: "Łódź",
  },
  {
    code: "90-262",
    city: "Łódź",
  },
  {
    code: "90-263",
    city: "Łódź",
  },
  {
    code: "90-264",
    city: "Łódź",
  },
  {
    code: "90-265",
    city: "Łódź",
  },
  {
    code: "90-266",
    city: "Łódź",
  },
  {
    code: "90-267",
    city: "Łódź",
  },
  {
    code: "90-268",
    city: "Łódź",
  },
  {
    code: "90-269",
    city: "Łódź",
  },
  {
    code: "90-270",
    city: "Łódź",
  },
  {
    code: "90-271",
    city: "Łódź",
  },
  {
    code: "90-272",
    city: "Łódź",
  },
  {
    code: "90-273",
    city: "Łódź",
  },
  {
    code: "90-301",
    city: "Łódź",
  },
  {
    code: "90-302",
    city: "Łódź",
  },
  {
    code: "90-303",
    city: "Łódź",
  },
  {
    code: "90-306",
    city: "Łódź",
  },
  {
    code: "90-307",
    city: "Łódź",
  },
  {
    code: "90-312",
    city: "Łódź",
  },
  {
    code: "90-315",
    city: "Łódź",
  },
  {
    code: "90-316",
    city: "Łódź",
  },
  {
    code: "90-317",
    city: "Łódź",
  },
  {
    code: "90-318",
    city: "Łódź",
  },
  {
    code: "90-319",
    city: "Łódź",
  },
  {
    code: "90-322",
    city: "Łódź",
  },
  {
    code: "90-323",
    city: "Łódź",
  },
  {
    code: "90-324",
    city: "Łódź",
  },
  {
    code: "90-325",
    city: "Łódź",
  },
  {
    code: "90-326",
    city: "Łódź",
  },
  {
    code: "90-328",
    city: "Łódź",
  },
  {
    code: "90-329",
    city: "Łódź",
  },
  {
    code: "90-330",
    city: "Łódź",
  },
  {
    code: "90-331",
    city: "Łódź",
  },
  {
    code: "90-332",
    city: "Łódź",
  },
  {
    code: "90-333",
    city: "Łódź",
  },
  {
    code: "90-336",
    city: "Łódź",
  },
  {
    code: "90-337",
    city: "Łódź",
  },
  {
    code: "90-338",
    city: "Łódź",
  },
  {
    code: "90-339",
    city: "Łódź",
  },
  {
    code: "90-340",
    city: "Łódź",
  },
  {
    code: "90-341",
    city: "Łódź",
  },
  {
    code: "90-344",
    city: "Łódź",
  },
  {
    code: "90-345",
    city: "Łódź",
  },
  {
    code: "90-346",
    city: "Łódź",
  },
  {
    code: "90-347",
    city: "Łódź",
  },
  {
    code: "90-348",
    city: "Łódź",
  },
  {
    code: "90-349",
    city: "Łódź",
  },
  {
    code: "90-350",
    city: "Łódź",
  },
  {
    code: "90-351",
    city: "Łódź",
  },
  {
    code: "90-353",
    city: "Łódź",
  },
  {
    code: "90-354",
    city: "Łódź",
  },
  {
    code: "90-355",
    city: "Łódź",
  },
  {
    code: "90-357",
    city: "Łódź",
  },
  {
    code: "90-360",
    city: "Łódź",
  },
  {
    code: "90-361",
    city: "Łódź",
  },
  {
    code: "90-363",
    city: "Łódź",
  },
  {
    code: "90-364",
    city: "Łódź",
  },
  {
    code: "90-365",
    city: "Łódź",
  },
  {
    code: "90-368",
    city: "Łódź",
  },
  {
    code: "90-369",
    city: "Łódź",
  },
  {
    code: "90-401",
    city: "Łódź",
  },
  {
    code: "90-402",
    city: "Łódź",
  },
  {
    code: "90-403",
    city: "Łódź",
  },
  {
    code: "90-404",
    city: "Łódź",
  },
  {
    code: "90-406",
    city: "Łódź",
  },
  {
    code: "90-407",
    city: "Łódź",
  },
  {
    code: "90-408",
    city: "Łódź",
  },
  {
    code: "90-410",
    city: "Łódź",
  },
  {
    code: "90-411",
    city: "Łódź",
  },
  {
    code: "90-413",
    city: "Łódź",
  },
  {
    code: "90-414",
    city: "Łódź",
  },
  {
    code: "90-415",
    city: "Łódź",
  },
  {
    code: "90-416",
    city: "Łódź",
  },
  {
    code: "90-418",
    city: "Łódź",
  },
  {
    code: "90-419",
    city: "Łódź",
  },
  {
    code: "90-420",
    city: "Łódź",
  },
  {
    code: "90-421",
    city: "Łódź",
  },
  {
    code: "90-422",
    city: "Łódź",
  },
  {
    code: "90-423",
    city: "Łódź",
  },
  {
    code: "90-425",
    city: "Łódź",
  },
  {
    code: "90-426",
    city: "Łódź",
  },
  {
    code: "90-427",
    city: "Łódź",
  },
  {
    code: "90-428",
    city: "Łódź",
  },
  {
    code: "90-430",
    city: "Łódź",
  },
  {
    code: "90-431",
    city: "Łódź",
  },
  {
    code: "90-432",
    city: "Łódź",
  },
  {
    code: "90-434",
    city: "Łódź",
  },
  {
    code: "90-435",
    city: "Łódź",
  },
  {
    code: "90-436",
    city: "Łódź",
  },
  {
    code: "90-437",
    city: "Łódź",
  },
  {
    code: "90-440",
    city: "Łódź",
  },
  {
    code: "90-441",
    city: "Łódź",
  },
  {
    code: "90-442",
    city: "Łódź",
  },
  {
    code: "90-443",
    city: "Łódź",
  },
  {
    code: "90-446",
    city: "Łódź",
  },
  {
    code: "90-447",
    city: "Łódź",
  },
  {
    code: "90-448",
    city: "Łódź",
  },
  {
    code: "90-449",
    city: "Łódź",
  },
  {
    code: "90-450",
    city: "Łódź",
  },
  {
    code: "90-451",
    city: "Łódź",
  },
  {
    code: "90-452",
    city: "Łódź",
  },
  {
    code: "90-453",
    city: "Łódź",
  },
  {
    code: "90-456",
    city: "Łódź",
  },
  {
    code: "90-457",
    city: "Łódź",
  },
  {
    code: "90-458",
    city: "Łódź",
  },
  {
    code: "90-501",
    city: "Łódź",
  },
  {
    code: "90-502",
    city: "Łódź",
  },
  {
    code: "90-503",
    city: "Łódź",
  },
  {
    code: "90-505",
    city: "Łódź",
  },
  {
    code: "90-507",
    city: "Łódź",
  },
  {
    code: "90-508",
    city: "Łódź",
  },
  {
    code: "90-509",
    city: "Łódź",
  },
  {
    code: "90-510",
    city: "Łódź",
  },
  {
    code: "90-511",
    city: "Łódź",
  },
  {
    code: "90-513",
    city: "Łódź",
  },
  {
    code: "90-514",
    city: "Łódź",
  },
  {
    code: "90-515",
    city: "Łódź",
  },
  {
    code: "90-516",
    city: "Łódź",
  },
  {
    code: "90-517",
    city: "Łódź",
  },
  {
    code: "90-519",
    city: "Łódź",
  },
  {
    code: "90-520",
    city: "Łódź",
  },
  {
    code: "90-521",
    city: "Łódź",
  },
  {
    code: "90-522",
    city: "Łódź",
  },
  {
    code: "90-525",
    city: "Łódź",
  },
  {
    code: "90-526",
    city: "Łódź",
  },
  {
    code: "90-527",
    city: "Łódź",
  },
  {
    code: "90-528",
    city: "Łódź",
  },
  {
    code: "90-530",
    city: "Łódź",
  },
  {
    code: "90-531",
    city: "Łódź",
  },
  {
    code: "90-532",
    city: "Łódź",
  },
  {
    code: "90-536",
    city: "Łódź",
  },
  {
    code: "90-537",
    city: "Łódź",
  },
  {
    code: "90-539",
    city: "Łódź",
  },
  {
    code: "90-540",
    city: "Łódź",
  },
  {
    code: "90-541",
    city: "Łódź",
  },
  {
    code: "90-542",
    city: "Łódź",
  },
  {
    code: "90-543",
    city: "Łódź",
  },
  {
    code: "90-545",
    city: "Łódź",
  },
  {
    code: "90-546",
    city: "Łódź",
  },
  {
    code: "90-547",
    city: "Łódź",
  },
  {
    code: "90-549",
    city: "Łódź",
  },
  {
    code: "90-550",
    city: "Łódź",
  },
  {
    code: "90-552",
    city: "Łódź",
  },
  {
    code: "90-553",
    city: "Łódź",
  },
  {
    code: "90-554",
    city: "Łódź",
  },
  {
    code: "90-556",
    city: "Łódź",
  },
  {
    code: "90-557",
    city: "Łódź",
  },
  {
    code: "90-558",
    city: "Łódź",
  },
  {
    code: "90-559",
    city: "Łódź",
  },
  {
    code: "90-560",
    city: "Łódź",
  },
  {
    code: "90-561",
    city: "Łódź",
  },
  {
    code: "90-562",
    city: "Łódź",
  },
  {
    code: "90-563",
    city: "Łódź",
  },
  {
    code: "90-567",
    city: "Łódź",
  },
  {
    code: "90-568",
    city: "Łódź",
  },
  {
    code: "90-569",
    city: "Łódź",
  },
  {
    code: "90-570",
    city: "Łódź",
  },
  {
    code: "90-571",
    city: "Łódź",
  },
  {
    code: "90-601",
    city: "Łódź",
  },
  {
    code: "90-602",
    city: "Łódź",
  },
  {
    code: "90-603",
    city: "Łódź",
  },
  {
    code: "90-604",
    city: "Łódź",
  },
  {
    code: "90-606",
    city: "Łódź",
  },
  {
    code: "90-607",
    city: "Łódź",
  },
  {
    code: "90-608",
    city: "Łódź",
  },
  {
    code: "90-609",
    city: "Łódź",
  },
  {
    code: "90-612",
    city: "Łódź",
  },
  {
    code: "90-613",
    city: "Łódź",
  },
  {
    code: "90-615",
    city: "Łódź",
  },
  {
    code: "90-616",
    city: "Łódź",
  },
  {
    code: "90-617",
    city: "Łódź",
  },
  {
    code: "90-618",
    city: "Łódź",
  },
  {
    code: "90-619",
    city: "Łódź",
  },
  {
    code: "90-623",
    city: "Łódź",
  },
  {
    code: "90-624",
    city: "Łódź",
  },
  {
    code: "90-625",
    city: "Łódź",
  },
  {
    code: "90-626",
    city: "Łódź",
  },
  {
    code: "90-629",
    city: "Łódź",
  },
  {
    code: "90-630",
    city: "Łódź",
  },
  {
    code: "90-631",
    city: "Łódź",
  },
  {
    code: "90-632",
    city: "Łódź",
  },
  {
    code: "90-635",
    city: "Łódź",
  },
  {
    code: "90-636",
    city: "Łódź",
  },
  {
    code: "90-637",
    city: "Łódź",
  },
  {
    code: "90-638",
    city: "Łódź",
  },
  {
    code: "90-639",
    city: "Łódź",
  },
  {
    code: "90-640",
    city: "Łódź",
  },
  {
    code: "90-642",
    city: "Łódź",
  },
  {
    code: "90-643",
    city: "Łódź",
  },
  {
    code: "90-644",
    city: "Łódź",
  },
  {
    code: "90-645",
    city: "Łódź",
  },
  {
    code: "90-646",
    city: "Łódź",
  },
  {
    code: "90-647",
    city: "Łódź",
  },
  {
    code: "90-648",
    city: "Łódź",
  },
  {
    code: "90-701",
    city: "Łódź",
  },
  {
    code: "90-702",
    city: "Łódź",
  },
  {
    code: "90-703",
    city: "Łódź",
  },
  {
    code: "90-704",
    city: "Łódź",
  },
  {
    code: "90-706",
    city: "Łódź",
  },
  {
    code: "90-707",
    city: "Łódź",
  },
  {
    code: "90-708",
    city: "Łódź",
  },
  {
    code: "90-710",
    city: "Łódź",
  },
  {
    code: "90-711",
    city: "Łódź",
  },
  {
    code: "90-712",
    city: "Łódź",
  },
  {
    code: "90-713",
    city: "Łódź",
  },
  {
    code: "90-715",
    city: "Łódź",
  },
  {
    code: "90-716",
    city: "Łódź",
  },
  {
    code: "90-717",
    city: "Łódź",
  },
  {
    code: "90-718",
    city: "Łódź",
  },
  {
    code: "90-720",
    city: "Łódź",
  },
  {
    code: "90-721",
    city: "Łódź",
  },
  {
    code: "90-722",
    city: "Łódź",
  },
  {
    code: "90-723",
    city: "Łódź",
  },
  {
    code: "90-725",
    city: "Łódź",
  },
  {
    code: "90-727",
    city: "Łódź",
  },
  {
    code: "90-728",
    city: "Łódź",
  },
  {
    code: "90-729",
    city: "Łódź",
  },
  {
    code: "90-730",
    city: "Łódź",
  },
  {
    code: "90-731",
    city: "Łódź",
  },
  {
    code: "90-732",
    city: "Łódź",
  },
  {
    code: "90-734",
    city: "Łódź",
  },
  {
    code: "90-735",
    city: "Łódź",
  },
  {
    code: "90-736",
    city: "Łódź",
  },
  {
    code: "90-737",
    city: "Łódź",
  },
  {
    code: "90-739",
    city: "Łódź",
  },
  {
    code: "90-740",
    city: "Łódź",
  },
  {
    code: "90-741",
    city: "Łódź",
  },
  {
    code: "90-742",
    city: "Łódź",
  },
  {
    code: "90-743",
    city: "Łódź",
  },
  {
    code: "90-745",
    city: "Łódź",
  },
  {
    code: "90-746",
    city: "Łódź",
  },
  {
    code: "90-747",
    city: "Łódź",
  },
  {
    code: "90-748",
    city: "Łódź",
  },
  {
    code: "90-749",
    city: "Łódź",
  },
  {
    code: "90-750",
    city: "Łódź",
  },
  {
    code: "90-752",
    city: "Łódź",
  },
  {
    code: "90-753",
    city: "Łódź",
  },
  {
    code: "90-754",
    city: "Łódź",
  },
  {
    code: "90-755",
    city: "Łódź",
  },
  {
    code: "90-756",
    city: "Łódź",
  },
  {
    code: "90-757",
    city: "Łódź",
  },
  {
    code: "90-758",
    city: "Łódź",
  },
  {
    code: "90-759",
    city: "Łódź",
  },
  {
    code: "90-760",
    city: "Łódź",
  },
  {
    code: "90-762",
    city: "Łódź",
  },
  {
    code: "90-763",
    city: "Łódź",
  },
  {
    code: "90-764",
    city: "Łódź",
  },
  {
    code: "90-765",
    city: "Łódź",
  },
  {
    code: "90-766",
    city: "Łódź",
  },
  {
    code: "90-767",
    city: "Łódź",
  },
  {
    code: "90-768",
    city: "Łódź",
  },
  {
    code: "90-900",
    city: "Łódź",
  },
  {
    code: "90-920",
    city: "Łódź",
  },
  {
    code: "90-921",
    city: "Łódź",
  },
  {
    code: "90-924",
    city: "Łódź",
  },
  {
    code: "90-926",
    city: "Łódź",
  },
  {
    code: "90-928",
    city: "Łódź",
  },
  {
    code: "90-930",
    city: "Łódź",
  },
  {
    code: "90-940",
    city: "Łódź",
  },
  {
    code: "90-948",
    city: "Łódź",
  },
  {
    code: "90-950",
    city: "Łódź",
  },
  {
    code: "90-951",
    city: "Łódź",
  },
  {
    code: "90-952",
    city: "Łódź",
  },
  {
    code: "90-953",
    city: "Łódź",
  },
  {
    code: "90-954",
    city: "Łódź",
  },
  {
    code: "90-955",
    city: "Łódź",
  },
  {
    code: "90-957",
    city: "Łódź",
  },
  {
    code: "90-959",
    city: "Łódź",
  },
  {
    code: "90-960",
    city: "Łódź",
  },
  {
    code: "90-961",
    city: "Łódź",
  },
  {
    code: "90-962",
    city: "Łódź",
  },
  {
    code: "90-963",
    city: "Łódź",
  },
  {
    code: "90-964",
    city: "Łódź",
  },
  {
    code: "90-965",
    city: "Łódź",
  },
  {
    code: "90-966",
    city: "Łódź",
  },
  {
    code: "90-967",
    city: "Łódź",
  },
  {
    code: "90-968",
    city: "Łódź",
  },
  {
    code: "90-969",
    city: "Łódź",
  },
  {
    code: "90-970",
    city: "Łódź",
  },
  {
    code: "90-971",
    city: "Łódź",
  },
  {
    code: "90-972",
    city: "Łódź",
  },
  {
    code: "90-973",
    city: "Łódź",
  },
  {
    code: "90-974",
    city: "Łódź",
  },
  {
    code: "90-975",
    city: "Łódź",
  },
  {
    code: "90-976",
    city: "Łódź",
  },
  {
    code: "90-977",
    city: "Łódź",
  },
  {
    code: "90-978",
    city: "Łódź",
  },
  {
    code: "90-980",
    city: "Łódź",
  },
  {
    code: "90-981",
    city: "Łódź",
  },
  {
    code: "90-982",
    city: "Łódź",
  },
  {
    code: "90-983",
    city: "Łódź",
  },
  {
    code: "90-984",
    city: "Łódź",
  },
  {
    code: "90-985",
    city: "Łódź",
  },
  {
    code: "90-986",
    city: "Łódź",
  },
  {
    code: "90-987",
    city: "Łódź",
  },
  {
    code: "90-988",
    city: "Łódź",
  },
  {
    code: "90-989",
    city: "Łódź",
  },
  {
    code: "90-990",
    city: "Łódź",
  },
  {
    code: "90-991",
    city: "Łódź",
  },
  {
    code: "90-992",
    city: "Łódź",
  },
  {
    code: "90-993",
    city: "Łódź",
  },
  {
    code: "91-001",
    city: "Łódź",
  },
  {
    code: "91-002",
    city: "Łódź",
  },
  {
    code: "91-003",
    city: "Łódź",
  },
  {
    code: "91-004",
    city: "Łódź",
  },
  {
    code: "91-005",
    city: "Łódź",
  },
  {
    code: "91-006",
    city: "Łódź",
  },
  {
    code: "91-008",
    city: "Łódź",
  },
  {
    code: "91-009",
    city: "Łódź",
  },
  {
    code: "91-010",
    city: "Łódź",
  },
  {
    code: "91-012",
    city: "Łódź",
  },
  {
    code: "91-013",
    city: "Łódź",
  },
  {
    code: "91-015",
    city: "Łódź",
  },
  {
    code: "91-016",
    city: "Łódź",
  },
  {
    code: "91-017",
    city: "Łódź",
  },
  {
    code: "91-018",
    city: "Łódź",
  },
  {
    code: "91-020",
    city: "Łódź",
  },
  {
    code: "91-021",
    city: "Łódź",
  },
  {
    code: "91-022",
    city: "Łódź",
  },
  {
    code: "91-023",
    city: "Łódź",
  },
  {
    code: "91-024",
    city: "Łódź",
  },
  {
    code: "91-025",
    city: "Łódź",
  },
  {
    code: "91-026",
    city: "Łódź",
  },
  {
    code: "91-027",
    city: "Łódź",
  },
  {
    code: "91-028",
    city: "Łódź",
  },
  {
    code: "91-029",
    city: "Łódź",
  },
  {
    code: "91-030",
    city: "Łódź",
  },
  {
    code: "91-031",
    city: "Łódź",
  },
  {
    code: "91-032",
    city: "Łódź",
  },
  {
    code: "91-033",
    city: "Łódź",
  },
  {
    code: "91-034",
    city: "Łódź",
  },
  {
    code: "91-035",
    city: "Łódź",
  },
  {
    code: "91-036",
    city: "Łódź",
  },
  {
    code: "91-037",
    city: "Łódź",
  },
  {
    code: "91-038",
    city: "Łódź",
  },
  {
    code: "91-039",
    city: "Łódź",
  },
  {
    code: "91-040",
    city: "Łódź",
  },
  {
    code: "91-041",
    city: "Łódź",
  },
  {
    code: "91-042",
    city: "Łódź",
  },
  {
    code: "91-043",
    city: "Łódź",
  },
  {
    code: "91-044",
    city: "Łódź",
  },
  {
    code: "91-045",
    city: "Łódź",
  },
  {
    code: "91-046",
    city: "Łódź",
  },
  {
    code: "91-048",
    city: "Łódź",
  },
  {
    code: "91-049",
    city: "Łódź",
  },
  {
    code: "91-050",
    city: "Łódź",
  },
  {
    code: "91-051",
    city: "Łódź",
  },
  {
    code: "91-052",
    city: "Łódź",
  },
  {
    code: "91-053",
    city: "Łódź",
  },
  {
    code: "91-054",
    city: "Łódź",
  },
  {
    code: "91-055",
    city: "Łódź",
  },
  {
    code: "91-056",
    city: "Łódź",
  },
  {
    code: "91-058",
    city: "Łódź",
  },
  {
    code: "91-059",
    city: "Łódź",
  },
  {
    code: "91-061",
    city: "Łódź",
  },
  {
    code: "91-062",
    city: "Łódź",
  },
  {
    code: "91-063",
    city: "Łódź",
  },
  {
    code: "91-064",
    city: "Łódź",
  },
  {
    code: "91-065",
    city: "Łódź",
  },
  {
    code: "91-066",
    city: "Łódź",
  },
  {
    code: "91-067",
    city: "Łódź",
  },
  {
    code: "91-068",
    city: "Łódź",
  },
  {
    code: "91-069",
    city: "Łódź",
  },
  {
    code: "91-070",
    city: "Łódź",
  },
  {
    code: "91-071",
    city: "Łódź",
  },
  {
    code: "91-072",
    city: "Łódź",
  },
  {
    code: "91-073",
    city: "Łódź",
  },
  {
    code: "91-074",
    city: "Łódź",
  },
  {
    code: "91-075",
    city: "Łódź",
  },
  {
    code: "91-076",
    city: "Łódź",
  },
  {
    code: "91-078",
    city: "Łódź",
  },
  {
    code: "91-079",
    city: "Łódź",
  },
  {
    code: "91-080",
    city: "Łódź",
  },
  {
    code: "91-082",
    city: "Łódź",
  },
  {
    code: "91-083",
    city: "Łódź",
  },
  {
    code: "91-084",
    city: "Łódź",
  },
  {
    code: "91-085",
    city: "Łódź",
  },
  {
    code: "91-087",
    city: "Łódź",
  },
  {
    code: "91-088",
    city: "Łódź",
  },
  {
    code: "91-089",
    city: "Łódź",
  },
  {
    code: "91-090",
    city: "Łódź",
  },
  {
    code: "91-101",
    city: "Łódź",
  },
  {
    code: "91-102",
    city: "Łódź",
  },
  {
    code: "91-103",
    city: "Łódź",
  },
  {
    code: "91-104",
    city: "Łódź",
  },
  {
    code: "91-110",
    city: "Łódź",
  },
  {
    code: "91-111",
    city: "Łódź",
  },
  {
    code: "91-115",
    city: "Łódź",
  },
  {
    code: "91-116",
    city: "Łódź",
  },
  {
    code: "91-117",
    city: "Łódź",
  },
  {
    code: "91-120",
    city: "Łódź",
  },
  {
    code: "91-127",
    city: "Łódź",
  },
  {
    code: "91-128",
    city: "Łódź",
  },
  {
    code: "91-129",
    city: "Łódź",
  },
  {
    code: "91-130",
    city: "Łódź",
  },
  {
    code: "91-134",
    city: "Łódź",
  },
  {
    code: "91-135",
    city: "Łódź",
  },
  {
    code: "91-140",
    city: "Łódź",
  },
  {
    code: "91-141",
    city: "Łódź",
  },
  {
    code: "91-142",
    city: "Łódź",
  },
  {
    code: "91-143",
    city: "Łódź",
  },
  {
    code: "91-144",
    city: "Łódź",
  },
  {
    code: "91-148",
    city: "Łódź",
  },
  {
    code: "91-149",
    city: "Łódź",
  },
  {
    code: "91-150",
    city: "Łódź",
  },
  {
    code: "91-151",
    city: "Łódź",
  },
  {
    code: "91-154",
    city: "Łódź",
  },
  {
    code: "91-155",
    city: "Łódź",
  },
  {
    code: "91-156",
    city: "Łódź",
  },
  {
    code: "91-157",
    city: "Łódź",
  },
  {
    code: "91-158",
    city: "Łódź",
  },
  {
    code: "91-159",
    city: "Łódź",
  },
  {
    code: "91-160",
    city: "Łódź",
  },
  {
    code: "91-161",
    city: "Łódź",
  },
  {
    code: "91-162",
    city: "Łódź",
  },
  {
    code: "91-163",
    city: "Łódź",
  },
  {
    code: "91-164",
    city: "Łódź",
  },
  {
    code: "91-165",
    city: "Łódź",
  },
  {
    code: "91-166",
    city: "Łódź",
  },
  {
    code: "91-167",
    city: "Łódź",
  },
  {
    code: "91-168",
    city: "Łódź",
  },
  {
    code: "91-169",
    city: "Łódź",
  },
  {
    code: "91-170",
    city: "Łódź",
  },
  {
    code: "91-171",
    city: "Łódź",
  },
  {
    code: "91-172",
    city: "Łódź",
  },
  {
    code: "91-173",
    city: "Łódź",
  },
  {
    code: "91-174",
    city: "Łódź",
  },
  {
    code: "91-175",
    city: "Łódź",
  },
  {
    code: "91-176",
    city: "Łódź",
  },
  {
    code: "91-177",
    city: "Łódź",
  },
  {
    code: "91-178",
    city: "Łódź",
  },
  {
    code: "91-179",
    city: "Łódź",
  },
  {
    code: "91-180",
    city: "Łódź",
  },
  {
    code: "91-181",
    city: "Łódź",
  },
  {
    code: "91-182",
    city: "Łódź",
  },
  {
    code: "91-183",
    city: "Łódź",
  },
  {
    code: "91-184",
    city: "Łódź",
  },
  {
    code: "91-185",
    city: "Łódź",
  },
  {
    code: "91-186",
    city: "Łódź",
  },
  {
    code: "91-187",
    city: "Łódź",
  },
  {
    code: "91-188",
    city: "Łódź",
  },
  {
    code: "91-189",
    city: "Łódź",
  },
  {
    code: "91-201",
    city: "Łódź",
  },
  {
    code: "91-202",
    city: "Łódź",
  },
  {
    code: "91-203",
    city: "Łódź",
  },
  {
    code: "91-204",
    city: "Łódź",
  },
  {
    code: "91-205",
    city: "Łódź",
  },
  {
    code: "91-210",
    city: "Łódź",
  },
  {
    code: "91-211",
    city: "Łódź",
  },
  {
    code: "91-212",
    city: "Łódź",
  },
  {
    code: "91-213",
    city: "Łódź",
  },
  {
    code: "91-214",
    city: "Łódź",
  },
  {
    code: "91-215",
    city: "Łódź",
  },
  {
    code: "91-218",
    city: "Łódź",
  },
  {
    code: "91-219",
    city: "Łódź",
  },
  {
    code: "91-220",
    city: "Łódź",
  },
  {
    code: "91-221",
    city: "Łódź",
  },
  {
    code: "91-222",
    city: "Łódź",
  },
  {
    code: "91-223",
    city: "Łódź",
  },
  {
    code: "91-224",
    city: "Łódź",
  },
  {
    code: "91-225",
    city: "Łódź",
  },
  {
    code: "91-226",
    city: "Łódź",
  },
  {
    code: "91-227",
    city: "Łódź",
  },
  {
    code: "91-228",
    city: "Łódź",
  },
  {
    code: "91-229",
    city: "Łódź",
  },
  {
    code: "91-230",
    city: "Łódź",
  },
  {
    code: "91-231",
    city: "Łódź",
  },
  {
    code: "91-232",
    city: "Łódź",
  },
  {
    code: "91-233",
    city: "Łódź",
  },
  {
    code: "91-301",
    city: "Łódź",
  },
  {
    code: "91-302",
    city: "Łódź",
  },
  {
    code: "91-303",
    city: "Łódź",
  },
  {
    code: "91-304",
    city: "Łódź",
  },
  {
    code: "91-305",
    city: "Łódź",
  },
  {
    code: "91-306",
    city: "Łódź",
  },
  {
    code: "91-308",
    city: "Łódź",
  },
  {
    code: "91-309",
    city: "Łódź",
  },
  {
    code: "91-310",
    city: "Łódź",
  },
  {
    code: "91-311",
    city: "Łódź",
  },
  {
    code: "91-312",
    city: "Łódź",
  },
  {
    code: "91-314",
    city: "Łódź",
  },
  {
    code: "91-315",
    city: "Łódź",
  },
  {
    code: "91-316",
    city: "Łódź",
  },
  {
    code: "91-318",
    city: "Łódź",
  },
  {
    code: "91-320",
    city: "Łódź",
  },
  {
    code: "91-321",
    city: "Łódź",
  },
  {
    code: "91-322",
    city: "Łódź",
  },
  {
    code: "91-323",
    city: "Łódź",
  },
  {
    code: "91-324",
    city: "Łódź",
  },
  {
    code: "91-327",
    city: "Łódź",
  },
  {
    code: "91-328",
    city: "Łódź",
  },
  {
    code: "91-329",
    city: "Łódź",
  },
  {
    code: "91-333",
    city: "Łódź",
  },
  {
    code: "91-334",
    city: "Łódź",
  },
  {
    code: "91-335",
    city: "Łódź",
  },
  {
    code: "91-336",
    city: "Łódź",
  },
  {
    code: "91-337",
    city: "Łódź",
  },
  {
    code: "91-338",
    city: "Łódź",
  },
  {
    code: "91-340",
    city: "Łódź",
  },
  {
    code: "91-341",
    city: "Łódź",
  },
  {
    code: "91-342",
    city: "Łódź",
  },
  {
    code: "91-345",
    city: "Łódź",
  },
  {
    code: "91-346",
    city: "Łódź",
  },
  {
    code: "91-347",
    city: "Łódź",
  },
  {
    code: "91-348",
    city: "Łódź",
  },
  {
    code: "91-349",
    city: "Łódź",
  },
  {
    code: "91-350",
    city: "Łódź",
  },
  {
    code: "91-351",
    city: "Łódź",
  },
  {
    code: "91-355",
    city: "Łódź",
  },
  {
    code: "91-356",
    city: "Łódź",
  },
  {
    code: "91-357",
    city: "Łódź",
  },
  {
    code: "91-358",
    city: "Łódź",
  },
  {
    code: "91-359",
    city: "Łódź",
  },
  {
    code: "91-360",
    city: "Łódź",
  },
  {
    code: "91-362",
    city: "Łódź",
  },
  {
    code: "91-363",
    city: "Łódź",
  },
  {
    code: "91-364",
    city: "Łódź",
  },
  {
    code: "91-365",
    city: "Łódź",
  },
  {
    code: "91-366",
    city: "Łódź",
  },
  {
    code: "91-370",
    city: "Łódź",
  },
  {
    code: "91-371",
    city: "Łódź",
  },
  {
    code: "91-372",
    city: "Łódź",
  },
  {
    code: "91-373",
    city: "Łódź",
  },
  {
    code: "91-402",
    city: "Łódź",
  },
  {
    code: "91-403",
    city: "Łódź",
  },
  {
    code: "91-404",
    city: "Łódź",
  },
  {
    code: "91-408",
    city: "Łódź",
  },
  {
    code: "91-409",
    city: "Łódź",
  },
  {
    code: "91-410",
    city: "Łódź",
  },
  {
    code: "91-414",
    city: "Łódź",
  },
  {
    code: "91-415",
    city: "Łódź",
  },
  {
    code: "91-416",
    city: "Łódź",
  },
  {
    code: "91-417",
    city: "Łódź",
  },
  {
    code: "91-420",
    city: "Łódź",
  },
  {
    code: "91-421",
    city: "Łódź",
  },
  {
    code: "91-422",
    city: "Łódź",
  },
  {
    code: "91-423",
    city: "Łódź",
  },
  {
    code: "91-425",
    city: "Łódź",
  },
  {
    code: "91-426",
    city: "Łódź",
  },
  {
    code: "91-427",
    city: "Łódź",
  },
  {
    code: "91-430",
    city: "Łódź",
  },
  {
    code: "91-431",
    city: "Łódź",
  },
  {
    code: "91-432",
    city: "Łódź",
  },
  {
    code: "91-433",
    city: "Łódź",
  },
  {
    code: "91-434",
    city: "Łódź",
  },
  {
    code: "91-437",
    city: "Łódź",
  },
  {
    code: "91-438",
    city: "Łódź",
  },
  {
    code: "91-439",
    city: "Łódź",
  },
  {
    code: "91-440",
    city: "Łódź",
  },
  {
    code: "91-441",
    city: "Łódź",
  },
  {
    code: "91-444",
    city: "Łódź",
  },
  {
    code: "91-445",
    city: "Łódź",
  },
  {
    code: "91-446",
    city: "Łódź",
  },
  {
    code: "91-449",
    city: "Łódź",
  },
  {
    code: "91-450",
    city: "Łódź",
  },
  {
    code: "91-455",
    city: "Łódź",
  },
  {
    code: "91-456",
    city: "Łódź",
  },
  {
    code: "91-457",
    city: "Łódź",
  },
  {
    code: "91-458",
    city: "Łódź",
  },
  {
    code: "91-459",
    city: "Łódź",
  },
  {
    code: "91-462",
    city: "Łódź",
  },
  {
    code: "91-463",
    city: "Łódź",
  },
  {
    code: "91-464",
    city: "Łódź",
  },
  {
    code: "91-465",
    city: "Łódź",
  },
  {
    code: "91-468",
    city: "Łódź",
  },
  {
    code: "91-469",
    city: "Łódź",
  },
  {
    code: "91-470",
    city: "Łódź",
  },
  {
    code: "91-471",
    city: "Łódź",
  },
  {
    code: "91-473",
    city: "Łódź",
  },
  {
    code: "91-474",
    city: "Łódź",
  },
  {
    code: "91-475",
    city: "Łódź",
  },
  {
    code: "91-478",
    city: "Łódź",
  },
  {
    code: "91-479",
    city: "Łódź",
  },
  {
    code: "91-480",
    city: "Łódź",
  },
  {
    code: "91-481",
    city: "Łódź",
  },
  {
    code: "91-485",
    city: "Łódź",
  },
  {
    code: "91-486",
    city: "Łódź",
  },
  {
    code: "91-487",
    city: "Łódź",
  },
  {
    code: "91-488",
    city: "Łódź",
  },
  {
    code: "91-489",
    city: "Łódź",
  },
  {
    code: "91-490",
    city: "Łódź",
  },
  {
    code: "91-491",
    city: "Łódź",
  },
  {
    code: "91-492",
    city: "Łódź",
  },
  {
    code: "91-493",
    city: "Łódź",
  },
  {
    code: "91-495",
    city: "Łódź",
  },
  {
    code: "91-496",
    city: "Łódź",
  },
  {
    code: "91-497",
    city: "Łódź",
  },
  {
    code: "91-498",
    city: "Łódź",
  },
  {
    code: "91-502",
    city: "Łódź",
  },
  {
    code: "91-503",
    city: "Łódź",
  },
  {
    code: "91-504",
    city: "Łódź",
  },
  {
    code: "91-505",
    city: "Łódź",
  },
  {
    code: "91-506",
    city: "Łódź",
  },
  {
    code: "91-509",
    city: "Łódź",
  },
  {
    code: "91-510",
    city: "Łódź",
  },
  {
    code: "91-511",
    city: "Łódź",
  },
  {
    code: "91-512",
    city: "Łódź",
  },
  {
    code: "91-513",
    city: "Łódź",
  },
  {
    code: "91-514",
    city: "Łódź",
  },
  {
    code: "91-518",
    city: "Łódź",
  },
  {
    code: "91-519",
    city: "Łódź",
  },
  {
    code: "91-520",
    city: "Łódź",
  },
  {
    code: "91-521",
    city: "Łódź",
  },
  {
    code: "91-522",
    city: "Łódź",
  },
  {
    code: "91-523",
    city: "Łódź",
  },
  {
    code: "91-524",
    city: "Łódź",
  },
  {
    code: "91-526",
    city: "Łódź",
  },
  {
    code: "91-527",
    city: "Łódź",
  },
  {
    code: "91-528",
    city: "Łódź",
  },
  {
    code: "91-529",
    city: "Łódź",
  },
  {
    code: "91-530",
    city: "Łódź",
  },
  {
    code: "91-531",
    city: "Łódź",
  },
  {
    code: "91-533",
    city: "Łódź",
  },
  {
    code: "91-534",
    city: "Łódź",
  },
  {
    code: "91-535",
    city: "Łódź",
  },
  {
    code: "91-536",
    city: "Łódź",
  },
  {
    code: "91-601",
    city: "Łódź",
  },
  {
    code: "91-602",
    city: "Łódź",
  },
  {
    code: "91-603",
    city: "Łódź",
  },
  {
    code: "91-604",
    city: "Łódź",
  },
  {
    code: "91-605",
    city: "Łódź",
  },
  {
    code: "91-606",
    city: "Łódź",
  },
  {
    code: "91-609",
    city: "Łódź",
  },
  {
    code: "91-610",
    city: "Łódź",
  },
  {
    code: "91-611",
    city: "Łódź",
  },
  {
    code: "91-612",
    city: "Łódź",
  },
  {
    code: "91-613",
    city: "Łódź",
  },
  {
    code: "91-614",
    city: "Łódź",
  },
  {
    code: "91-615",
    city: "Łódź",
  },
  {
    code: "91-616",
    city: "Łódź",
  },
  {
    code: "91-701",
    city: "Łódź",
  },
  {
    code: "91-702",
    city: "Łódź",
  },
  {
    code: "91-703",
    city: "Łódź",
  },
  {
    code: "91-704",
    city: "Łódź",
  },
  {
    code: "91-705",
    city: "Łódź",
  },
  {
    code: "91-708",
    city: "Łódź",
  },
  {
    code: "91-709",
    city: "Łódź",
  },
  {
    code: "91-710",
    city: "Łódź",
  },
  {
    code: "91-711",
    city: "Łódź",
  },
  {
    code: "91-712",
    city: "Łódź",
  },
  {
    code: "91-713",
    city: "Łódź",
  },
  {
    code: "91-716",
    city: "Łódź",
  },
  {
    code: "91-717",
    city: "Łódź",
  },
  {
    code: "91-718",
    city: "Łódź",
  },
  {
    code: "91-719",
    city: "Łódź",
  },
  {
    code: "91-720",
    city: "Łódź",
  },
  {
    code: "91-725",
    city: "Łódź",
  },
  {
    code: "91-726",
    city: "Łódź",
  },
  {
    code: "91-727",
    city: "Łódź",
  },
  {
    code: "91-728",
    city: "Łódź",
  },
  {
    code: "91-729",
    city: "Łódź",
  },
  {
    code: "91-734",
    city: "Łódź",
  },
  {
    code: "91-735",
    city: "Łódź",
  },
  {
    code: "91-736",
    city: "Łódź",
  },
  {
    code: "91-737",
    city: "Łódź",
  },
  {
    code: "91-738",
    city: "Łódź",
  },
  {
    code: "91-739",
    city: "Łódź",
  },
  {
    code: "91-743",
    city: "Łódź",
  },
  {
    code: "91-744",
    city: "Łódź",
  },
  {
    code: "91-745",
    city: "Łódź",
  },
  {
    code: "91-746",
    city: "Łódź",
  },
  {
    code: "91-747",
    city: "Łódź",
  },
  {
    code: "91-748",
    city: "Łódź",
  },
  {
    code: "91-754",
    city: "Łódź",
  },
  {
    code: "91-755",
    city: "Łódź",
  },
  {
    code: "91-756",
    city: "Łódź",
  },
  {
    code: "91-757",
    city: "Łódź",
  },
  {
    code: "91-761",
    city: "Łódź",
  },
  {
    code: "91-762",
    city: "Łódź",
  },
  {
    code: "91-763",
    city: "Łódź",
  },
  {
    code: "91-764",
    city: "Łódź",
  },
  {
    code: "91-765",
    city: "Łódź",
  },
  {
    code: "91-766",
    city: "Łódź",
  },
  {
    code: "91-801",
    city: "Łódź",
  },
  {
    code: "91-802",
    city: "Łódź",
  },
  {
    code: "91-803",
    city: "Łódź",
  },
  {
    code: "91-804",
    city: "Łódź",
  },
  {
    code: "91-805",
    city: "Łódź",
  },
  {
    code: "91-806",
    city: "Łódź",
  },
  {
    code: "91-809",
    city: "Łódź",
  },
  {
    code: "91-810",
    city: "Łódź",
  },
  {
    code: "91-811",
    city: "Łódź",
  },
  {
    code: "91-812",
    city: "Łódź",
  },
  {
    code: "91-815",
    city: "Łódź",
  },
  {
    code: "91-816",
    city: "Łódź",
  },
  {
    code: "91-817",
    city: "Łódź",
  },
  {
    code: "91-818",
    city: "Łódź",
  },
  {
    code: "91-819",
    city: "Łódź",
  },
  {
    code: "91-822",
    city: "Łódź",
  },
  {
    code: "91-823",
    city: "Łódź",
  },
  {
    code: "91-824",
    city: "Łódź",
  },
  {
    code: "91-825",
    city: "Łódź",
  },
  {
    code: "91-826",
    city: "Łódź",
  },
  {
    code: "91-829",
    city: "Łódź",
  },
  {
    code: "91-830",
    city: "Łódź",
  },
  {
    code: "91-831",
    city: "Łódź",
  },
  {
    code: "91-832",
    city: "Łódź",
  },
  {
    code: "91-833",
    city: "Łódź",
  },
  {
    code: "91-834",
    city: "Łódź",
  },
  {
    code: "91-836",
    city: "Łódź",
  },
  {
    code: "91-837",
    city: "Łódź",
  },
  {
    code: "91-838",
    city: "Łódź",
  },
  {
    code: "91-839",
    city: "Łódź",
  },
  {
    code: "91-842",
    city: "Łódź",
  },
  {
    code: "91-843",
    city: "Łódź",
  },
  {
    code: "91-844",
    city: "Łódź",
  },
  {
    code: "91-845",
    city: "Łódź",
  },
  {
    code: "91-848",
    city: "Łódź",
  },
  {
    code: "91-849",
    city: "Łódź",
  },
  {
    code: "91-850",
    city: "Łódź",
  },
  {
    code: "91-851",
    city: "Łódź",
  },
  {
    code: "91-852",
    city: "Łódź",
  },
  {
    code: "91-853",
    city: "Łódź",
  },
  {
    code: "91-854",
    city: "Łódź",
  },
  {
    code: "91-855",
    city: "Łódź",
  },
  {
    code: "91-857",
    city: "Łódź",
  },
  {
    code: "91-858",
    city: "Łódź",
  },
  {
    code: "91-859",
    city: "Łódź",
  },
  {
    code: "91-860",
    city: "Łódź",
  },
  {
    code: "91-862",
    city: "Łódź",
  },
  {
    code: "91-863",
    city: "Łódź",
  },
  {
    code: "91-864",
    city: "Łódź",
  },
  {
    code: "91-865",
    city: "Łódź",
  },
  {
    code: "91-866",
    city: "Łódź",
  },
  {
    code: "91-867",
    city: "Łódź",
  },
  {
    code: "92-001",
    city: "Łódź",
  },
  {
    code: "92-002",
    city: "Łódź",
  },
  {
    code: "92-003",
    city: "Łódź",
  },
  {
    code: "92-005",
    city: "Łódź",
  },
  {
    code: "92-006",
    city: "Łódź",
  },
  {
    code: "92-007",
    city: "Łódź",
  },
  {
    code: "92-008",
    city: "Łódź",
  },
  {
    code: "92-009",
    city: "Łódź",
  },
  {
    code: "92-010",
    city: "Łódź",
  },
  {
    code: "92-013",
    city: "Łódź",
  },
  {
    code: "92-014",
    city: "Łódź",
  },
  {
    code: "92-015",
    city: "Łódź",
  },
  {
    code: "92-016",
    city: "Łódź",
  },
  {
    code: "92-017",
    city: "Łódź",
  },
  {
    code: "92-018",
    city: "Łódź",
  },
  {
    code: "92-101",
    city: "Łódź",
  },
  {
    code: "92-102",
    city: "Łódź",
  },
  {
    code: "92-103",
    city: "Łódź",
  },
  {
    code: "92-104",
    city: "Łódź",
  },
  {
    code: "92-107",
    city: "Łódź",
  },
  {
    code: "92-108",
    city: "Łódź",
  },
  {
    code: "92-109",
    city: "Łódź",
  },
  {
    code: "92-110",
    city: "Łódź",
  },
  {
    code: "92-111",
    city: "Łódź",
  },
  {
    code: "92-114",
    city: "Łódź",
  },
  {
    code: "92-115",
    city: "Łódź",
  },
  {
    code: "92-116",
    city: "Łódź",
  },
  {
    code: "92-117",
    city: "Łódź",
  },
  {
    code: "92-118",
    city: "Łódź",
  },
  {
    code: "92-119",
    city: "Łódź",
  },
  {
    code: "92-120",
    city: "Łódź",
  },
  {
    code: "92-121",
    city: "Łódź",
  },
  {
    code: "92-122",
    city: "Łódź",
  },
  {
    code: "92-123",
    city: "Łódź",
  },
  {
    code: "92-201",
    city: "Łódź",
  },
  {
    code: "92-202",
    city: "Łódź",
  },
  {
    code: "92-203",
    city: "Łódź",
  },
  {
    code: "92-204",
    city: "Łódź",
  },
  {
    code: "92-207",
    city: "Łódź",
  },
  {
    code: "92-208",
    city: "Łódź",
  },
  {
    code: "92-209",
    city: "Łódź",
  },
  {
    code: "92-210",
    city: "Łódź",
  },
  {
    code: "92-213",
    city: "Łódź",
  },
  {
    code: "92-214",
    city: "Łódź",
  },
  {
    code: "92-215",
    city: "Łódź",
  },
  {
    code: "92-216",
    city: "Łódź",
  },
  {
    code: "92-219",
    city: "Łódź",
  },
  {
    code: "92-220",
    city: "Łódź",
  },
  {
    code: "92-221",
    city: "Łódź",
  },
  {
    code: "92-223",
    city: "Łódź",
  },
  {
    code: "92-226",
    city: "Łódź",
  },
  {
    code: "92-227",
    city: "Łódź",
  },
  {
    code: "92-228",
    city: "Łódź",
  },
  {
    code: "92-229",
    city: "Łódź",
  },
  {
    code: "92-230",
    city: "Łódź",
  },
  {
    code: "92-231",
    city: "Łódź",
  },
  {
    code: "92-232",
    city: "Łódź",
  },
  {
    code: "92-235",
    city: "Łódź",
  },
  {
    code: "92-236",
    city: "Łódź",
  },
  {
    code: "92-237",
    city: "Łódź",
  },
  {
    code: "92-238",
    city: "Łódź",
  },
  {
    code: "92-301",
    city: "Łódź",
  },
  {
    code: "92-302",
    city: "Łódź",
  },
  {
    code: "92-303",
    city: "Łódź",
  },
  {
    code: "92-304",
    city: "Łódź",
  },
  {
    code: "92-305",
    city: "Łódź",
  },
  {
    code: "92-306",
    city: "Łódź",
  },
  {
    code: "92-307",
    city: "Łódź",
  },
  {
    code: "92-308",
    city: "Łódź",
  },
  {
    code: "92-309",
    city: "Łódź",
  },
  {
    code: "92-310",
    city: "Łódź",
  },
  {
    code: "92-311",
    city: "Łódź",
  },
  {
    code: "92-312",
    city: "Łódź",
  },
  {
    code: "92-313",
    city: "Łódź",
  },
  {
    code: "92-314",
    city: "Łódź",
  },
  {
    code: "92-315",
    city: "Łódź",
  },
  {
    code: "92-316",
    city: "Łódź",
  },
  {
    code: "92-317",
    city: "Łódź",
  },
  {
    code: "92-318",
    city: "Łódź",
  },
  {
    code: "92-319",
    city: "Łódź",
  },
  {
    code: "92-320",
    city: "Łódź",
  },
  {
    code: "92-321",
    city: "Łódź",
  },
  {
    code: "92-322",
    city: "Łódź",
  },
  {
    code: "92-323",
    city: "Łódź",
  },
  {
    code: "92-326",
    city: "Łódź",
  },
  {
    code: "92-327",
    city: "Łódź",
  },
  {
    code: "92-328",
    city: "Łódź",
  },
  {
    code: "92-331",
    city: "Łódź",
  },
  {
    code: "92-332",
    city: "Łódź",
  },
  {
    code: "92-333",
    city: "Łódź",
  },
  {
    code: "92-334",
    city: "Łódź",
  },
  {
    code: "92-335",
    city: "Łódź",
  },
  {
    code: "92-336",
    city: "Łódź",
  },
  {
    code: "92-337",
    city: "Łódź",
  },
  {
    code: "92-338",
    city: "Łódź",
  },
  {
    code: "92-339",
    city: "Łódź",
  },
  {
    code: "92-340",
    city: "Łódź",
  },
  {
    code: "92-401",
    city: "Łódź",
  },
  {
    code: "92-402",
    city: "Łódź",
  },
  {
    code: "92-403",
    city: "Łódź",
  },
  {
    code: "92-404",
    city: "Łódź",
  },
  {
    code: "92-405",
    city: "Łódź",
  },
  {
    code: "92-407",
    city: "Łódź",
  },
  {
    code: "92-408",
    city: "Łódź",
  },
  {
    code: "92-409",
    city: "Łódź",
  },
  {
    code: "92-410",
    city: "Łódź",
  },
  {
    code: "92-411",
    city: "Łódź",
  },
  {
    code: "92-412",
    city: "Łódź",
  },
  {
    code: "92-413",
    city: "Łódź",
  },
  {
    code: "92-414",
    city: "Łódź",
  },
  {
    code: "92-415",
    city: "Łódź",
  },
  {
    code: "92-416",
    city: "Łódź",
  },
  {
    code: "92-417",
    city: "Łódź",
  },
  {
    code: "92-418",
    city: "Łódź",
  },
  {
    code: "92-419",
    city: "Łódź",
  },
  {
    code: "92-423",
    city: "Łódź",
  },
  {
    code: "92-427",
    city: "Łódź",
  },
  {
    code: "92-430",
    city: "Łódź",
  },
  {
    code: "92-431",
    city: "Łódź",
  },
  {
    code: "92-432",
    city: "Łódź",
  },
  {
    code: "92-433",
    city: "Łódź",
  },
  {
    code: "92-434",
    city: "Łódź",
  },
  {
    code: "92-435",
    city: "Łódź",
  },
  {
    code: "92-436",
    city: "Łódź",
  },
  {
    code: "92-437",
    city: "Łódź",
  },
  {
    code: "92-438",
    city: "Łódź",
  },
  {
    code: "92-439",
    city: "Łódź",
  },
  {
    code: "92-440",
    city: "Łódź",
  },
  {
    code: "92-441",
    city: "Łódź",
  },
  {
    code: "92-442",
    city: "Łódź",
  },
  {
    code: "92-444",
    city: "Łódź",
  },
  {
    code: "92-445",
    city: "Łódź",
  },
  {
    code: "92-446",
    city: "Łódź",
  },
  {
    code: "92-447",
    city: "Łódź",
  },
  {
    code: "92-448",
    city: "Łódź",
  },
  {
    code: "92-501",
    city: "Łódź",
  },
  {
    code: "92-502",
    city: "Łódź",
  },
  {
    code: "92-503",
    city: "Łódź",
  },
  {
    code: "92-504",
    city: "Łódź",
  },
  {
    code: "92-507",
    city: "Łódź",
  },
  {
    code: "92-508",
    city: "Łódź",
  },
  {
    code: "92-510",
    city: "Łódź",
  },
  {
    code: "92-511",
    city: "Łódź",
  },
  {
    code: "92-512",
    city: "Łódź",
  },
  {
    code: "92-513",
    city: "Łódź",
  },
  {
    code: "92-514",
    city: "Łódź",
  },
  {
    code: "92-515",
    city: "Łódź",
  },
  {
    code: "92-516",
    city: "Łódź",
  },
  {
    code: "92-517",
    city: "Łódź",
  },
  {
    code: "92-518",
    city: "Łódź",
  },
  {
    code: "92-519",
    city: "Łódź",
  },
  {
    code: "92-520",
    city: "Łódź",
  },
  {
    code: "92-521",
    city: "Łódź",
  },
  {
    code: "92-522",
    city: "Łódź",
  },
  {
    code: "92-524",
    city: "Łódź",
  },
  {
    code: "92-525",
    city: "Łódź",
  },
  {
    code: "92-530",
    city: "Łódź",
  },
  {
    code: "92-531",
    city: "Łódź",
  },
  {
    code: "92-532",
    city: "Łódź",
  },
  {
    code: "92-533",
    city: "Łódź",
  },
  {
    code: "92-534",
    city: "Łódź",
  },
  {
    code: "92-535",
    city: "Łódź",
  },
  {
    code: "92-536",
    city: "Łódź",
  },
  {
    code: "92-537",
    city: "Łódź",
  },
  {
    code: "92-538",
    city: "Łódź",
  },
  {
    code: "92-539",
    city: "Łódź",
  },
  {
    code: "92-540",
    city: "Łódź",
  },
  {
    code: "92-541",
    city: "Łódź",
  },
  {
    code: "92-542",
    city: "Łódź",
  },
  {
    code: "92-543",
    city: "Łódź",
  },
  {
    code: "92-544",
    city: "Łódź",
  },
  {
    code: "92-545",
    city: "Łódź",
  },
  {
    code: "92-546",
    city: "Łódź",
  },
  {
    code: "92-547",
    city: "Łódź",
  },
  {
    code: "92-548",
    city: "Łódź",
  },
  {
    code: "92-549",
    city: "Łódź",
  },
  {
    code: "92-550",
    city: "Łódź",
  },
  {
    code: "92-601",
    city: "Łódź",
  },
  {
    code: "92-602",
    city: "Łódź",
  },
  {
    code: "92-603",
    city: "Łódź",
  },
  {
    code: "92-604",
    city: "Łódź",
  },
  {
    code: "92-605",
    city: "Łódź",
  },
  {
    code: "92-606",
    city: "Łódź",
  },
  {
    code: "92-607",
    city: "Łódź",
  },
  {
    code: "92-608",
    city: "Łódź",
  },
  {
    code: "92-609",
    city: "Łódź",
  },
  {
    code: "92-610",
    city: "Łódź",
  },
  {
    code: "92-611",
    city: "Łódź",
  },
  {
    code: "92-612",
    city: "Łódź",
  },
  {
    code: "92-613",
    city: "Łódź",
  },
  {
    code: "92-614",
    city: "Łódź",
  },
  {
    code: "92-615",
    city: "Łódź",
  },
  {
    code: "92-616",
    city: "Łódź",
  },
  {
    code: "92-617",
    city: "Łódź",
  },
  {
    code: "92-619",
    city: "Łódź",
  },
  {
    code: "92-620",
    city: "Łódź",
  },
  {
    code: "92-621",
    city: "Łódź",
  },
  {
    code: "92-622",
    city: "Łódź",
  },
  {
    code: "92-623",
    city: "Łódź",
  },
  {
    code: "92-624",
    city: "Łódź",
  },
  {
    code: "92-625",
    city: "Łódź",
  },
  {
    code: "92-626",
    city: "Łódź",
  },
  {
    code: "92-627",
    city: "Łódź",
  },
  {
    code: "92-629",
    city: "Łódź",
  },
  {
    code: "92-630",
    city: "Łódź",
  },
  {
    code: "92-631",
    city: "Łódź",
  },
  {
    code: "92-632",
    city: "Łódź",
  },
  {
    code: "92-633",
    city: "Łódź",
  },
  {
    code: "92-634",
    city: "Łódź",
  },
  {
    code: "92-635",
    city: "Łódź",
  },
  {
    code: "92-636",
    city: "Łódź",
  },
  {
    code: "92-637",
    city: "Łódź",
  },
  {
    code: "92-638",
    city: "Łódź",
  },
  {
    code: "92-639",
    city: "Łódź",
  },
  {
    code: "92-640",
    city: "Łódź",
  },
  {
    code: "92-641",
    city: "Łódź",
  },
  {
    code: "92-642",
    city: "Łódź",
  },
  {
    code: "92-643",
    city: "Łódź",
  },
  {
    code: "92-644",
    city: "Łódź",
  },
  {
    code: "92-645",
    city: "Łódź",
  },
  {
    code: "92-647",
    city: "Łódź",
  },
  {
    code: "92-648",
    city: "Łódź",
  },
  {
    code: "92-649",
    city: "Łódź",
  },
  {
    code: "92-701",
    city: "Łódź",
  },
  {
    code: "92-703",
    city: "Łódź",
  },
  {
    code: "92-704",
    city: "Łódź",
  },
  {
    code: "92-705",
    city: "Łódź",
  },
  {
    code: "92-706",
    city: "Łódź",
  },
  {
    code: "92-707",
    city: "Łódź",
  },
  {
    code: "92-708",
    city: "Łódź",
  },
  {
    code: "92-709",
    city: "Łódź",
  },
  {
    code: "92-710",
    city: "Łódź",
  },
  {
    code: "92-711",
    city: "Łódź",
  },
  {
    code: "92-712",
    city: "Łódź",
  },
  {
    code: "92-713",
    city: "Łódź",
  },
  {
    code: "92-714",
    city: "Łódź",
  },
  {
    code: "92-719",
    city: "Łódź",
  },
  {
    code: "92-720",
    city: "Łódź",
  },
  {
    code: "92-721",
    city: "Łódź",
  },
  {
    code: "92-722",
    city: "Łódź",
  },
  {
    code: "92-723",
    city: "Łódź",
  },
  {
    code: "92-724",
    city: "Łódź",
  },
  {
    code: "92-725",
    city: "Łódź",
  },
  {
    code: "92-726",
    city: "Łódź",
  },
  {
    code: "92-727",
    city: "Łódź",
  },
  {
    code: "92-728",
    city: "Łódź",
  },
  {
    code: "92-729",
    city: "Łódź",
  },
  {
    code: "92-730",
    city: "Łódź",
  },
  {
    code: "92-731",
    city: "Łódź",
  },
  {
    code: "92-732",
    city: "Łódź",
  },
  {
    code: "92-733",
    city: "Łódź",
  },
  {
    code: "92-734",
    city: "Łódź",
  },
  {
    code: "92-735",
    city: "Łódź",
  },
  {
    code: "92-736",
    city: "Łódź",
  },
  {
    code: "92-737",
    city: "Łódź",
  },
  {
    code: "92-738",
    city: "Łódź",
  },
  {
    code: "92-739",
    city: "Łódź",
  },
  {
    code: "92-740",
    city: "Łódź",
  },
  {
    code: "92-741",
    city: "Łódź",
  },
  {
    code: "92-742",
    city: "Łódź",
  },
  {
    code: "92-750",
    city: "Łódź",
  },
  {
    code: "92-751",
    city: "Łódź",
  },
  {
    code: "92-752",
    city: "Łódź",
  },
  {
    code: "92-753",
    city: "Łódź",
  },
  {
    code: "92-754",
    city: "Łódź",
  },
  {
    code: "92-760",
    city: "Łódź",
  },
  {
    code: "92-761",
    city: "Łódź",
  },
  {
    code: "92-770",
    city: "Łódź",
  },
  {
    code: "92-771",
    city: "Łódź",
  },
  {
    code: "92-772",
    city: "Łódź",
  },
  {
    code: "92-773",
    city: "Łódź",
  },
  {
    code: "92-774",
    city: "Łódź",
  },
  {
    code: "92-775",
    city: "Łódź",
  },
  {
    code: "92-776",
    city: "Łódź",
  },
  {
    code: "92-780",
    city: "Łódź",
  },
  {
    code: "92-781",
    city: "Łódź",
  },
  {
    code: "92-782",
    city: "Łódź",
  },
  {
    code: "92-783",
    city: "Łódź",
  },
  {
    code: "92-784",
    city: "Łódź",
  },
  {
    code: "93-001",
    city: "Łódź",
  },
  {
    code: "93-002",
    city: "Łódź",
  },
  {
    code: "93-003",
    city: "Łódź",
  },
  {
    code: "93-004",
    city: "Łódź",
  },
  {
    code: "93-005",
    city: "Łódź",
  },
  {
    code: "93-008",
    city: "Łódź",
  },
  {
    code: "93-009",
    city: "Łódź",
  },
  {
    code: "93-010",
    city: "Łódź",
  },
  {
    code: "93-011",
    city: "Łódź",
  },
  {
    code: "93-014",
    city: "Łódź",
  },
  {
    code: "93-015",
    city: "Łódź",
  },
  {
    code: "93-018",
    city: "Łódź",
  },
  {
    code: "93-019",
    city: "Łódź",
  },
  {
    code: "93-020",
    city: "Łódź",
  },
  {
    code: "93-021",
    city: "Łódź",
  },
  {
    code: "93-024",
    city: "Łódź",
  },
  {
    code: "93-025",
    city: "Łódź",
  },
  {
    code: "93-026",
    city: "Łódź",
  },
  {
    code: "93-029",
    city: "Łódź",
  },
  {
    code: "93-030",
    city: "Łódź",
  },
  {
    code: "93-031",
    city: "Łódź",
  },
  {
    code: "93-034",
    city: "Łódź",
  },
  {
    code: "93-035",
    city: "Łódź",
  },
  {
    code: "93-036",
    city: "Łódź",
  },
  {
    code: "93-037",
    city: "Łódź",
  },
  {
    code: "93-038",
    city: "Łódź",
  },
  {
    code: "93-101",
    city: "Łódź",
  },
  {
    code: "93-102",
    city: "Łódź",
  },
  {
    code: "93-105",
    city: "Łódź",
  },
  {
    code: "93-106",
    city: "Łódź",
  },
  {
    code: "93-109",
    city: "Łódź",
  },
  {
    code: "93-110",
    city: "Łódź",
  },
  {
    code: "93-113",
    city: "Łódź",
  },
  {
    code: "93-114",
    city: "Łódź",
  },
  {
    code: "93-115",
    city: "Łódź",
  },
  {
    code: "93-118",
    city: "Łódź",
  },
  {
    code: "93-119",
    city: "Łódź",
  },
  {
    code: "93-120",
    city: "Łódź",
  },
  {
    code: "93-121",
    city: "Łódź",
  },
  {
    code: "93-124",
    city: "Łódź",
  },
  {
    code: "93-126",
    city: "Łódź",
  },
  {
    code: "93-129",
    city: "Łódź",
  },
  {
    code: "93-130",
    city: "Łódź",
  },
  {
    code: "93-133",
    city: "Łódź",
  },
  {
    code: "93-134",
    city: "Łódź",
  },
  {
    code: "93-137",
    city: "Łódź",
  },
  {
    code: "93-138",
    city: "Łódź",
  },
  {
    code: "93-139",
    city: "Łódź",
  },
  {
    code: "93-140",
    city: "Łódź",
  },
  {
    code: "93-142",
    city: "Łódź",
  },
  {
    code: "93-143",
    city: "Łódź",
  },
  {
    code: "93-144",
    city: "Łódź",
  },
  {
    code: "93-148",
    city: "Łódź",
  },
  {
    code: "93-149",
    city: "Łódź",
  },
  {
    code: "93-150",
    city: "Łódź",
  },
  {
    code: "93-153",
    city: "Łódź",
  },
  {
    code: "93-154",
    city: "Łódź",
  },
  {
    code: "93-155",
    city: "Łódź",
  },
  {
    code: "93-156",
    city: "Łódź",
  },
  {
    code: "93-157",
    city: "Łódź",
  },
  {
    code: "93-159",
    city: "Łódź",
  },
  {
    code: "93-160",
    city: "Łódź",
  },
  {
    code: "93-161",
    city: "Łódź",
  },
  {
    code: "93-162",
    city: "Łódź",
  },
  {
    code: "93-165",
    city: "Łódź",
  },
  {
    code: "93-166",
    city: "Łódź",
  },
  {
    code: "93-167",
    city: "Łódź",
  },
  {
    code: "93-170",
    city: "Łódź",
  },
  {
    code: "93-171",
    city: "Łódź",
  },
  {
    code: "93-172",
    city: "Łódź",
  },
  {
    code: "93-173",
    city: "Łódź",
  },
  {
    code: "93-176",
    city: "Łódź",
  },
  {
    code: "93-177",
    city: "Łódź",
  },
  {
    code: "93-180",
    city: "Łódź",
  },
  {
    code: "93-181",
    city: "Łódź",
  },
  {
    code: "93-184",
    city: "Łódź",
  },
  {
    code: "93-185",
    city: "Łódź",
  },
  {
    code: "93-188",
    city: "Łódź",
  },
  {
    code: "93-189",
    city: "Łódź",
  },
  {
    code: "93-191",
    city: "Łódź",
  },
  {
    code: "93-192",
    city: "Łódź",
  },
  {
    code: "93-193",
    city: "Łódź",
  },
  {
    code: "93-201",
    city: "Łódź",
  },
  {
    code: "93-202",
    city: "Łódź",
  },
  {
    code: "93-203",
    city: "Łódź",
  },
  {
    code: "93-204",
    city: "Łódź",
  },
  {
    code: "93-208",
    city: "Łódź",
  },
  {
    code: "93-209",
    city: "Łódź",
  },
  {
    code: "93-210",
    city: "Łódź",
  },
  {
    code: "93-212",
    city: "Łódź",
  },
  {
    code: "93-213",
    city: "Łódź",
  },
  {
    code: "93-217",
    city: "Łódź",
  },
  {
    code: "93-218",
    city: "Łódź",
  },
  {
    code: "93-219",
    city: "Łódź",
  },
  {
    code: "93-220",
    city: "Łódź",
  },
  {
    code: "93-221",
    city: "Łódź",
  },
  {
    code: "93-222",
    city: "Łódź",
  },
  {
    code: "93-223",
    city: "Łódź",
  },
  {
    code: "93-224",
    city: "Łódź",
  },
  {
    code: "93-225",
    city: "Łódź",
  },
  {
    code: "93-228",
    city: "Łódź",
  },
  {
    code: "93-229",
    city: "Łódź",
  },
  {
    code: "93-230",
    city: "Łódź",
  },
  {
    code: "93-231",
    city: "Łódź",
  },
  {
    code: "93-232",
    city: "Łódź",
  },
  {
    code: "93-233",
    city: "Łódź",
  },
  {
    code: "93-235",
    city: "Łódź",
  },
  {
    code: "93-236",
    city: "Łódź",
  },
  {
    code: "93-237",
    city: "Łódź",
  },
  {
    code: "93-238",
    city: "Łódź",
  },
  {
    code: "93-239",
    city: "Łódź",
  },
  {
    code: "93-240",
    city: "Łódź",
  },
  {
    code: "93-241",
    city: "Łódź",
  },
  {
    code: "93-242",
    city: "Łódź",
  },
  {
    code: "93-243",
    city: "Łódź",
  },
  {
    code: "93-244",
    city: "Łódź",
  },
  {
    code: "93-245",
    city: "Łódź",
  },
  {
    code: "93-247",
    city: "Łódź",
  },
  {
    code: "93-248",
    city: "Łódź",
  },
  {
    code: "93-249",
    city: "Łódź",
  },
  {
    code: "93-252",
    city: "Łódź",
  },
  {
    code: "93-253",
    city: "Łódź",
  },
  {
    code: "93-254",
    city: "Łódź",
  },
  {
    code: "93-256",
    city: "Łódź",
  },
  {
    code: "93-257",
    city: "Łódź",
  },
  {
    code: "93-258",
    city: "Łódź",
  },
  {
    code: "93-259",
    city: "Łódź",
  },
  {
    code: "93-262",
    city: "Łódź",
  },
  {
    code: "93-263",
    city: "Łódź",
  },
  {
    code: "93-264",
    city: "Łódź",
  },
  {
    code: "93-266",
    city: "Łódź",
  },
  {
    code: "93-267",
    city: "Łódź",
  },
  {
    code: "93-271",
    city: "Łódź",
  },
  {
    code: "93-272",
    city: "Łódź",
  },
  {
    code: "93-273",
    city: "Łódź",
  },
  {
    code: "93-277",
    city: "Łódź",
  },
  {
    code: "93-278",
    city: "Łódź",
  },
  {
    code: "93-279",
    city: "Łódź",
  },
  {
    code: "93-280",
    city: "Łódź",
  },
  {
    code: "93-281",
    city: "Łódź",
  },
  {
    code: "93-285",
    city: "Łódź",
  },
  {
    code: "93-286",
    city: "Łódź",
  },
  {
    code: "93-302",
    city: "Łódź",
  },
  {
    code: "93-303",
    city: "Łódź",
  },
  {
    code: "93-304",
    city: "Łódź",
  },
  {
    code: "93-305",
    city: "Łódź",
  },
  {
    code: "93-308",
    city: "Łódź",
  },
  {
    code: "93-309",
    city: "Łódź",
  },
  {
    code: "93-310",
    city: "Łódź",
  },
  {
    code: "93-311",
    city: "Łódź",
  },
  {
    code: "93-312",
    city: "Łódź",
  },
  {
    code: "93-313",
    city: "Łódź",
  },
  {
    code: "93-315",
    city: "Łódź",
  },
  {
    code: "93-316",
    city: "Łódź",
  },
  {
    code: "93-317",
    city: "Łódź",
  },
  {
    code: "93-318",
    city: "Łódź",
  },
  {
    code: "93-319",
    city: "Łódź",
  },
  {
    code: "93-320",
    city: "Łódź",
  },
  {
    code: "93-321",
    city: "Łódź",
  },
  {
    code: "93-322",
    city: "Łódź",
  },
  {
    code: "93-323",
    city: "Łódź",
  },
  {
    code: "93-324",
    city: "Łódź",
  },
  {
    code: "93-325",
    city: "Łódź",
  },
  {
    code: "93-326",
    city: "Łódź",
  },
  {
    code: "93-327",
    city: "Łódź",
  },
  {
    code: "93-328",
    city: "Łódź",
  },
  {
    code: "93-329",
    city: "Łódź",
  },
  {
    code: "93-330",
    city: "Łódź",
  },
  {
    code: "93-331",
    city: "Łódź",
  },
  {
    code: "93-332",
    city: "Łódź",
  },
  {
    code: "93-333",
    city: "Łódź",
  },
  {
    code: "93-334",
    city: "Łódź",
  },
  {
    code: "93-335",
    city: "Łódź",
  },
  {
    code: "93-337",
    city: "Łódź",
  },
  {
    code: "93-338",
    city: "Łódź",
  },
  {
    code: "93-339",
    city: "Łódź",
  },
  {
    code: "93-340",
    city: "Łódź",
  },
  {
    code: "93-341",
    city: "Łódź",
  },
  {
    code: "93-342",
    city: "Łódź",
  },
  {
    code: "93-344",
    city: "Łódź",
  },
  {
    code: "93-345",
    city: "Łódź",
  },
  {
    code: "93-346",
    city: "Łódź",
  },
  {
    code: "93-347",
    city: "Łódź",
  },
  {
    code: "93-348",
    city: "Łódź",
  },
  {
    code: "93-349",
    city: "Łódź",
  },
  {
    code: "93-350",
    city: "Łódź",
  },
  {
    code: "93-351",
    city: "Łódź",
  },
  {
    code: "93-352",
    city: "Łódź",
  },
  {
    code: "93-353",
    city: "Łódź",
  },
  {
    code: "93-354",
    city: "Łódź",
  },
  {
    code: "93-355",
    city: "Łódź",
  },
  {
    code: "93-356",
    city: "Łódź",
  },
  {
    code: "93-357",
    city: "Łódź",
  },
  {
    code: "93-358",
    city: "Łódź",
  },
  {
    code: "93-359",
    city: "Łódź",
  },
  {
    code: "93-360",
    city: "Łódź",
  },
  {
    code: "93-361",
    city: "Łódź",
  },
  {
    code: "93-362",
    city: "Łódź",
  },
  {
    code: "93-363",
    city: "Łódź",
  },
  {
    code: "93-364",
    city: "Łódź",
  },
  {
    code: "93-365",
    city: "Łódź",
  },
  {
    code: "93-367",
    city: "Łódź",
  },
  {
    code: "93-368",
    city: "Łódź",
  },
  {
    code: "93-369",
    city: "Łódź",
  },
  {
    code: "93-370",
    city: "Łódź",
  },
  {
    code: "93-371",
    city: "Łódź",
  },
  {
    code: "93-372",
    city: "Łódź",
  },
  {
    code: "93-373",
    city: "Łódź",
  },
  {
    code: "93-374",
    city: "Łódź",
  },
  {
    code: "93-376",
    city: "Łódź",
  },
  {
    code: "93-377",
    city: "Łódź",
  },
  {
    code: "93-378",
    city: "Łódź",
  },
  {
    code: "93-379",
    city: "Łódź",
  },
  {
    code: "93-380",
    city: "Łódź",
  },
  {
    code: "93-385",
    city: "Łódź",
  },
  {
    code: "93-401",
    city: "Łódź",
  },
  {
    code: "93-402",
    city: "Łódź",
  },
  {
    code: "93-403",
    city: "Łódź",
  },
  {
    code: "93-404",
    city: "Łódź",
  },
  {
    code: "93-405",
    city: "Łódź",
  },
  {
    code: "93-406",
    city: "Łódź",
  },
  {
    code: "93-408",
    city: "Łódź",
  },
  {
    code: "93-409",
    city: "Łódź",
  },
  {
    code: "93-410",
    city: "Łódź",
  },
  {
    code: "93-411",
    city: "Łódź",
  },
  {
    code: "93-412",
    city: "Łódź",
  },
  {
    code: "93-413",
    city: "Łódź",
  },
  {
    code: "93-414",
    city: "Łódź",
  },
  {
    code: "93-415",
    city: "Łódź",
  },
  {
    code: "93-418",
    city: "Łódź",
  },
  {
    code: "93-419",
    city: "Łódź",
  },
  {
    code: "93-420",
    city: "Łódź",
  },
  {
    code: "93-423",
    city: "Łódź",
  },
  {
    code: "93-424",
    city: "Łódź",
  },
  {
    code: "93-425",
    city: "Łódź",
  },
  {
    code: "93-426",
    city: "Łódź",
  },
  {
    code: "93-427",
    city: "Łódź",
  },
  {
    code: "93-428",
    city: "Łódź",
  },
  {
    code: "93-429",
    city: "Łódź",
  },
  {
    code: "93-430",
    city: "Łódź",
  },
  {
    code: "93-431",
    city: "Łódź",
  },
  {
    code: "93-432",
    city: "Łódź",
  },
  {
    code: "93-433",
    city: "Łódź",
  },
  {
    code: "93-434",
    city: "Łódź",
  },
  {
    code: "93-435",
    city: "Łódź",
  },
  {
    code: "93-436",
    city: "Łódź",
  },
  {
    code: "93-438",
    city: "Łódź",
  },
  {
    code: "93-439",
    city: "Łódź",
  },
  {
    code: "93-440",
    city: "Łódź",
  },
  {
    code: "93-441",
    city: "Łódź",
  },
  {
    code: "93-442",
    city: "Łódź",
  },
  {
    code: "93-443",
    city: "Łódź",
  },
  {
    code: "93-446",
    city: "Łódź",
  },
  {
    code: "93-447",
    city: "Łódź",
  },
  {
    code: "93-448",
    city: "Łódź",
  },
  {
    code: "93-449",
    city: "Łódź",
  },
  {
    code: "93-450",
    city: "Łódź",
  },
  {
    code: "93-451",
    city: "Łódź",
  },
  {
    code: "93-452",
    city: "Łódź",
  },
  {
    code: "93-453",
    city: "Łódź",
  },
  {
    code: "93-454",
    city: "Łódź",
  },
  {
    code: "93-457",
    city: "Łódź",
  },
  {
    code: "93-458",
    city: "Łódź",
  },
  {
    code: "93-459",
    city: "Łódź",
  },
  {
    code: "93-460",
    city: "Łódź",
  },
  {
    code: "93-463",
    city: "Łódź",
  },
  {
    code: "93-464",
    city: "Łódź",
  },
  {
    code: "93-465",
    city: "Łódź",
  },
  {
    code: "93-466",
    city: "Łódź",
  },
  {
    code: "93-467",
    city: "Łódź",
  },
  {
    code: "93-468",
    city: "Łódź",
  },
  {
    code: "93-469",
    city: "Łódź",
  },
  {
    code: "93-472",
    city: "Łódź",
  },
  {
    code: "93-473",
    city: "Łódź",
  },
  {
    code: "93-474",
    city: "Łódź",
  },
  {
    code: "93-475",
    city: "Łódź",
  },
  {
    code: "93-476",
    city: "Łódź",
  },
  {
    code: "93-478",
    city: "Łódź",
  },
  {
    code: "93-479",
    city: "Łódź",
  },
  {
    code: "93-480",
    city: "Łódź",
  },
  {
    code: "93-481",
    city: "Łódź",
  },
  {
    code: "93-482",
    city: "Łódź",
  },
  {
    code: "93-485",
    city: "Łódź",
  },
  {
    code: "93-486",
    city: "Łódź",
  },
  {
    code: "93-487",
    city: "Łódź",
  },
  {
    code: "93-490",
    city: "Łódź",
  },
  {
    code: "93-491",
    city: "Łódź",
  },
  {
    code: "93-492",
    city: "Łódź",
  },
  {
    code: "93-493",
    city: "Łódź",
  },
  {
    code: "93-494",
    city: "Łódź",
  },
  {
    code: "93-501",
    city: "Łódź",
  },
  {
    code: "93-502",
    city: "Łódź",
  },
  {
    code: "93-503",
    city: "Łódź",
  },
  {
    code: "93-504",
    city: "Łódź",
  },
  {
    code: "93-505",
    city: "Łódź",
  },
  {
    code: "93-506",
    city: "Łódź",
  },
  {
    code: "93-509",
    city: "Łódź",
  },
  {
    code: "93-510",
    city: "Łódź",
  },
  {
    code: "93-513",
    city: "Łódź",
  },
  {
    code: "93-515",
    city: "Łódź",
  },
  {
    code: "93-516",
    city: "Łódź",
  },
  {
    code: "93-519",
    city: "Łódź",
  },
  {
    code: "93-520",
    city: "Łódź",
  },
  {
    code: "93-521",
    city: "Łódź",
  },
  {
    code: "93-522",
    city: "Łódź",
  },
  {
    code: "93-523",
    city: "Łódź",
  },
  {
    code: "93-524",
    city: "Łódź",
  },
  {
    code: "93-525",
    city: "Łódź",
  },
  {
    code: "93-526",
    city: "Łódź",
  },
  {
    code: "93-530",
    city: "Łódź",
  },
  {
    code: "93-531",
    city: "Łódź",
  },
  {
    code: "93-533",
    city: "Łódź",
  },
  {
    code: "93-534",
    city: "Łódź",
  },
  {
    code: "93-535",
    city: "Łódź",
  },
  {
    code: "93-536",
    city: "Łódź",
  },
  {
    code: "93-539",
    city: "Łódź",
  },
  {
    code: "93-540",
    city: "Łódź",
  },
  {
    code: "93-541",
    city: "Łódź",
  },
  {
    code: "93-542",
    city: "Łódź",
  },
  {
    code: "93-545",
    city: "Łódź",
  },
  {
    code: "93-546",
    city: "Łódź",
  },
  {
    code: "93-547",
    city: "Łódź",
  },
  {
    code: "93-548",
    city: "Łódź",
  },
  {
    code: "93-549",
    city: "Łódź",
  },
  {
    code: "93-552",
    city: "Łódź",
  },
  {
    code: "93-553",
    city: "Łódź",
  },
  {
    code: "93-554",
    city: "Łódź",
  },
  {
    code: "93-557",
    city: "Łódź",
  },
  {
    code: "93-558",
    city: "Łódź",
  },
  {
    code: "93-559",
    city: "Łódź",
  },
  {
    code: "93-562",
    city: "Łódź",
  },
  {
    code: "93-563",
    city: "Łódź",
  },
  {
    code: "93-564",
    city: "Łódź",
  },
  {
    code: "93-566",
    city: "Łódź",
  },
  {
    code: "93-569",
    city: "Łódź",
  },
  {
    code: "93-570",
    city: "Łódź",
  },
  {
    code: "93-571",
    city: "Łódź",
  },
  {
    code: "93-574",
    city: "Łódź",
  },
  {
    code: "93-575",
    city: "Łódź",
  },
  {
    code: "93-578",
    city: "Łódź",
  },
  {
    code: "93-579",
    city: "Łódź",
  },
  {
    code: "93-582",
    city: "Łódź",
  },
  {
    code: "93-583",
    city: "Łódź",
  },
  {
    code: "93-586",
    city: "Łódź",
  },
  {
    code: "93-588",
    city: "Łódź",
  },
  {
    code: "93-589",
    city: "Łódź",
  },
  {
    code: "93-590",
    city: "Łódź",
  },
  {
    code: "93-610",
    city: "Łódź",
  },
  {
    code: "93-611",
    city: "Łódź",
  },
  {
    code: "93-612",
    city: "Łódź",
  },
  {
    code: "93-613",
    city: "Łódź",
  },
  {
    code: "93-614",
    city: "Łódź",
  },
  {
    code: "93-615",
    city: "Łódź",
  },
  {
    code: "93-616",
    city: "Łódź",
  },
  {
    code: "93-617",
    city: "Łódź",
  },
  {
    code: "93-618",
    city: "Łódź",
  },
  {
    code: "93-619",
    city: "Łódź",
  },
  {
    code: "93-620",
    city: "Łódź",
  },
  {
    code: "93-621",
    city: "Łódź",
  },
  {
    code: "93-622",
    city: "Łódź",
  },
  {
    code: "93-623",
    city: "Łódź",
  },
  {
    code: "93-624",
    city: "Łódź",
  },
  {
    code: "93-631",
    city: "Łódź",
  },
  {
    code: "93-632",
    city: "Łódź",
  },
  {
    code: "93-633",
    city: "Łódź",
  },
  {
    code: "93-635",
    city: "Łódź",
  },
  {
    code: "93-636",
    city: "Łódź",
  },
  {
    code: "93-638",
    city: "Łódź",
  },
  {
    code: "93-640",
    city: "Łódź",
  },
  {
    code: "93-641",
    city: "Łódź",
  },
  {
    code: "93-642",
    city: "Łódź",
  },
  {
    code: "93-643",
    city: "Łódź",
  },
  {
    code: "93-645",
    city: "Łódź",
  },
  {
    code: "93-646",
    city: "Łódź",
  },
  {
    code: "93-647",
    city: "Łódź",
  },
  {
    code: "93-648",
    city: "Łódź",
  },
  {
    code: "93-649",
    city: "Łódź",
  },
  {
    code: "94-001",
    city: "Łódź",
  },
  {
    code: "94-002",
    city: "Łódź",
  },
  {
    code: "94-003",
    city: "Łódź",
  },
  {
    code: "94-004",
    city: "Łódź",
  },
  {
    code: "94-005",
    city: "Łódź",
  },
  {
    code: "94-006",
    city: "Łódź",
  },
  {
    code: "94-007",
    city: "Łódź",
  },
  {
    code: "94-010",
    city: "Łódź",
  },
  {
    code: "94-011",
    city: "Łódź",
  },
  {
    code: "94-012",
    city: "Łódź",
  },
  {
    code: "94-014",
    city: "Łódź",
  },
  {
    code: "94-015",
    city: "Łódź",
  },
  {
    code: "94-016",
    city: "Łódź",
  },
  {
    code: "94-017",
    city: "Łódź",
  },
  {
    code: "94-020",
    city: "Łódź",
  },
  {
    code: "94-021",
    city: "Łódź",
  },
  {
    code: "94-022",
    city: "Łódź",
  },
  {
    code: "94-023",
    city: "Łódź",
  },
  {
    code: "94-024",
    city: "Łódź",
  },
  {
    code: "94-025",
    city: "Łódź",
  },
  {
    code: "94-028",
    city: "Łódź",
  },
  {
    code: "94-029",
    city: "Łódź",
  },
  {
    code: "94-030",
    city: "Łódź",
  },
  {
    code: "94-031",
    city: "Łódź",
  },
  {
    code: "94-032",
    city: "Łódź",
  },
  {
    code: "94-035",
    city: "Łódź",
  },
  {
    code: "94-036",
    city: "Łódź",
  },
  {
    code: "94-037",
    city: "Łódź",
  },
  {
    code: "94-038",
    city: "Łódź",
  },
  {
    code: "94-039",
    city: "Łódź",
  },
  {
    code: "94-040",
    city: "Łódź",
  },
  {
    code: "94-041",
    city: "Łódź",
  },
  {
    code: "94-042",
    city: "Łódź",
  },
  {
    code: "94-043",
    city: "Łódź",
  },
  {
    code: "94-044",
    city: "Łódź",
  },
  {
    code: "94-045",
    city: "Łódź",
  },
  {
    code: "94-046",
    city: "Łódź",
  },
  {
    code: "94-047",
    city: "Łódź",
  },
  {
    code: "94-048",
    city: "Łódź",
  },
  {
    code: "94-049",
    city: "Łódź",
  },
  {
    code: "94-050",
    city: "Łódź",
  },
  {
    code: "94-051",
    city: "Łódź",
  },
  {
    code: "94-052",
    city: "Łódź",
  },
  {
    code: "94-053",
    city: "Łódź",
  },
  {
    code: "94-054",
    city: "Łódź",
  },
  {
    code: "94-055",
    city: "Łódź",
  },
  {
    code: "94-056",
    city: "Łódź",
  },
  {
    code: "94-058",
    city: "Łódź",
  },
  {
    code: "94-060",
    city: "Łódź",
  },
  {
    code: "94-101",
    city: "Łódź",
  },
  {
    code: "94-102",
    city: "Łódź",
  },
  {
    code: "94-103",
    city: "Łódź",
  },
  {
    code: "94-104",
    city: "Łódź",
  },
  {
    code: "94-105",
    city: "Łódź",
  },
  {
    code: "94-106",
    city: "Łódź",
  },
  {
    code: "94-107",
    city: "Łódź",
  },
  {
    code: "94-108",
    city: "Łódź",
  },
  {
    code: "94-109",
    city: "Łódź",
  },
  {
    code: "94-110",
    city: "Łódź",
  },
  {
    code: "94-111",
    city: "Łódź",
  },
  {
    code: "94-112",
    city: "Łódź",
  },
  {
    code: "94-113",
    city: "Łódź",
  },
  {
    code: "94-114",
    city: "Łódź",
  },
  {
    code: "94-115",
    city: "Łódź",
  },
  {
    code: "94-116",
    city: "Łódź",
  },
  {
    code: "94-117",
    city: "Łódź",
  },
  {
    code: "94-118",
    city: "Łódź",
  },
  {
    code: "94-119",
    city: "Łódź",
  },
  {
    code: "94-120",
    city: "Łódź",
  },
  {
    code: "94-121",
    city: "Łódź",
  },
  {
    code: "94-122",
    city: "Łódź",
  },
  {
    code: "94-123",
    city: "Łódź",
  },
  {
    code: "94-124",
    city: "Łódź",
  },
  {
    code: "94-125",
    city: "Łódź",
  },
  {
    code: "94-126",
    city: "Łódź",
  },
  {
    code: "94-127",
    city: "Łódź",
  },
  {
    code: "94-128",
    city: "Łódź",
  },
  {
    code: "94-129",
    city: "Łódź",
  },
  {
    code: "94-130",
    city: "Łódź",
  },
  {
    code: "94-131",
    city: "Łódź",
  },
  {
    code: "94-132",
    city: "Łódź",
  },
  {
    code: "94-133",
    city: "Łódź",
  },
  {
    code: "94-134",
    city: "Łódź",
  },
  {
    code: "94-201",
    city: "Łódź",
  },
  {
    code: "94-202",
    city: "Łódź",
  },
  {
    code: "94-203",
    city: "Łódź",
  },
  {
    code: "94-204",
    city: "Łódź",
  },
  {
    code: "94-205",
    city: "Łódź",
  },
  {
    code: "94-208",
    city: "Łódź",
  },
  {
    code: "94-209",
    city: "Łódź",
  },
  {
    code: "94-212",
    city: "Łódź",
  },
  {
    code: "94-213",
    city: "Łódź",
  },
  {
    code: "94-214",
    city: "Łódź",
  },
  {
    code: "94-215",
    city: "Łódź",
  },
  {
    code: "94-216",
    city: "Łódź",
  },
  {
    code: "94-217",
    city: "Łódź",
  },
  {
    code: "94-218",
    city: "Łódź",
  },
  {
    code: "94-221",
    city: "Łódź",
  },
  {
    code: "94-222",
    city: "Łódź",
  },
  {
    code: "94-223",
    city: "Łódź",
  },
  {
    code: "94-224",
    city: "Łódź",
  },
  {
    code: "94-225",
    city: "Łódź",
  },
  {
    code: "94-226",
    city: "Łódź",
  },
  {
    code: "94-227",
    city: "Łódź",
  },
  {
    code: "94-230",
    city: "Łódź",
  },
  {
    code: "94-231",
    city: "Łódź",
  },
  {
    code: "94-232",
    city: "Łódź",
  },
  {
    code: "94-233",
    city: "Łódź",
  },
  {
    code: "94-234",
    city: "Łódź",
  },
  {
    code: "94-235",
    city: "Łódź",
  },
  {
    code: "94-236",
    city: "Łódź",
  },
  {
    code: "94-237",
    city: "Łódź",
  },
  {
    code: "94-238",
    city: "Łódź",
  },
  {
    code: "94-239",
    city: "Łódź",
  },
  {
    code: "94-240",
    city: "Łódź",
  },
  {
    code: "94-241",
    city: "Łódź",
  },
  {
    code: "94-242",
    city: "Łódź",
  },
  {
    code: "94-243",
    city: "Łódź",
  },
  {
    code: "94-244",
    city: "Łódź",
  },
  {
    code: "94-245",
    city: "Łódź",
  },
  {
    code: "94-246",
    city: "Łódź",
  },
  {
    code: "94-247",
    city: "Łódź",
  },
  {
    code: "94-248",
    city: "Łódź",
  },
  {
    code: "94-249",
    city: "Łódź",
  },
  {
    code: "94-250",
    city: "Łódź",
  },
  {
    code: "94-251",
    city: "Łódź",
  },
  {
    code: "94-252",
    city: "Łódź",
  },
  {
    code: "94-253",
    city: "Łódź",
  },
  {
    code: "94-254",
    city: "Łódź",
  },
  {
    code: "94-255",
    city: "Łódź",
  },
  {
    code: "94-256",
    city: "Łódź",
  },
  {
    code: "94-257",
    city: "Łódź",
  },
  {
    code: "94-258",
    city: "Łódź",
  },
  {
    code: "94-259",
    city: "Łódź",
  },
  {
    code: "94-260",
    city: "Łódź",
  },
  {
    code: "94-261",
    city: "Łódź",
  },
  {
    code: "94-262",
    city: "Łódź",
  },
  {
    code: "94-263",
    city: "Łódź",
  },
  {
    code: "94-264",
    city: "Łódź",
  },
  {
    code: "94-265",
    city: "Łódź",
  },
  {
    code: "94-266",
    city: "Łódź",
  },
  {
    code: "94-267",
    city: "Łódź",
  },
  {
    code: "94-268",
    city: "Łódź",
  },
  {
    code: "94-269",
    city: "Łódź",
  },
  {
    code: "94-270",
    city: "Łódź",
  },
  {
    code: "94-271",
    city: "Łódź",
  },
  {
    code: "94-272",
    city: "Łódź",
  },
  {
    code: "94-273",
    city: "Łódź",
  },
  {
    code: "94-274",
    city: "Łódź",
  },
  {
    code: "94-275",
    city: "Łódź",
  },
  {
    code: "94-276",
    city: "Łódź",
  },
  {
    code: "94-277",
    city: "Łódź",
  },
  {
    code: "94-278",
    city: "Łódź",
  },
  {
    code: "94-279",
    city: "Łódź",
  },
  {
    code: "94-280",
    city: "Łódź",
  },
  {
    code: "94-281",
    city: "Łódź",
  },
  {
    code: "94-282",
    city: "Łódź",
  },
  {
    code: "94-283",
    city: "Łódź",
  },
  {
    code: "94-284",
    city: "Łódź",
  },
  {
    code: "94-285",
    city: "Łódź",
  },
  {
    code: "94-286",
    city: "Łódź",
  },
  {
    code: "94-287",
    city: "Łódź",
  },
  {
    code: "94-290",
    city: "Łódź",
  },
  {
    code: "94-291",
    city: "Łódź",
  },
  {
    code: "94-292",
    city: "Łódź",
  },
  {
    code: "94-301",
    city: "Łódź",
  },
  {
    code: "94-302",
    city: "Łódź",
  },
  {
    code: "94-303",
    city: "Łódź",
  },
  {
    code: "94-304",
    city: "Łódź",
  },
  {
    code: "94-305",
    city: "Łódź",
  },
  {
    code: "94-306",
    city: "Łódź",
  },
  {
    code: "94-307",
    city: "Łódź",
  },
  {
    code: "94-308",
    city: "Łódź",
  },
  {
    code: "94-310",
    city: "Łódź",
  },
  {
    code: "94-311",
    city: "Łódź",
  },
  {
    code: "94-312",
    city: "Łódź",
  },
  {
    code: "94-313",
    city: "Łódź",
  },
  {
    code: "94-314",
    city: "Łódź",
  },
  {
    code: "94-315",
    city: "Łódź",
  },
  {
    code: "94-316",
    city: "Łódź",
  },
  {
    code: "94-317",
    city: "Łódź",
  },
  {
    code: "94-319",
    city: "Łódź",
  },
  {
    code: "94-324",
    city: "Łódź",
  },
  {
    code: "94-325",
    city: "Łódź",
  },
  {
    code: "94-326",
    city: "Łódź",
  },
  {
    code: "94-327",
    city: "Łódź",
  },
  {
    code: "94-328",
    city: "Łódź",
  },
  {
    code: "94-329",
    city: "Łódź",
  },
  {
    code: "94-330",
    city: "Łódź",
  },
  {
    code: "94-331",
    city: "Łódź",
  },
  {
    code: "94-333",
    city: "Łódź",
  },
  {
    code: "94-334",
    city: "Łódź",
  },
  {
    code: "94-401",
    city: "Łódź",
  },
  {
    code: "94-402",
    city: "Łódź",
  },
  {
    code: "94-403",
    city: "Łódź",
  },
  {
    code: "94-404",
    city: "Łódź",
  },
  {
    code: "94-405",
    city: "Łódź",
  },
  {
    code: "94-406",
    city: "Łódź",
  },
  {
    code: "94-407",
    city: "Łódź",
  },
  {
    code: "94-408",
    city: "Łódź",
  },
  {
    code: "94-409",
    city: "Łódź",
  },
  {
    code: "94-410",
    city: "Łódź",
  },
  {
    code: "94-411",
    city: "Łódź",
  },
  {
    code: "94-412",
    city: "Łódź",
  },
  {
    code: "94-413",
    city: "Łódź",
  },
  {
    code: "95-001",
    city: "Biała",
  },
  {
    code: "95-002",
    city: "Maciejów",
  },
  {
    code: "95-006",
    city: "Brójce",
  },
  {
    code: "95-010",
    city: "Stryków",
  },
  {
    code: "95-011",
    city: "Bratoszewice",
  },
  {
    code: "95-015",
    city: "Głowno",
  },
  {
    code: "95-016",
    city: "Głowno",
  },
  {
    code: "95-020",
    city: "Andrespol",
  },
  {
    code: "95-030",
    city: "Rzgów",
  },
  {
    code: "95-035",
    city: "Ozorków",
  },
  {
    code: "95-036",
    city: "Ozorków",
  },
  {
    code: "95-039",
    city: "Sokolniki",
  },
  {
    code: "95-040",
    city: "Koluszki",
  },
  {
    code: "95-041",
    city: "Gałkówek",
  },
  {
    code: "95-043",
    city: "Leźnica Wielka-Osiedle",
  },
  {
    code: "95-045",
    city: "Parzęczew",
  },
  {
    code: "95-047",
    city: "Jeżów",
  },
  {
    code: "95-050",
    city: "Konstantynów Łódzki",
  },
  {
    code: "95-054",
    city: "Ksawerów",
  },
  {
    code: "95-060",
    city: "Brzeziny",
  },
  {
    code: "95-061",
    city: "Dmosin",
  },
  {
    code: "95-063",
    city: "Rogów",
  },
  {
    code: "95-069",
    city: "Aleksandrów Łódzki",
  },
  {
    code: "95-070",
    city: "Aleksandrów Łódzki",
  },
  {
    code: "95-071",
    city: "Rąbień",
  },
  {
    code: "95-073",
    city: "Grotniki",
  },
  {
    code: "95-080",
    city: "Tuszyn",
  },
  {
    code: "95-081",
    city: "Dłutów",
  },
  {
    code: "95-082",
    city: "Dobroń",
  },
  {
    code: "95-083",
    city: "Lutomiersk",
  },
  {
    code: "95-100",
    city: "Zgierz",
  },
  {
    code: "95-101",
    city: "Zgierz",
  },
  {
    code: "95-102",
    city: "Zgierz",
  },
  {
    code: "95-103",
    city: "Zgierz",
  },
  {
    code: "95-110",
    city: "Zgierz",
  },
  {
    code: "95-200",
    city: "Pabianice",
  },
  {
    code: "95-201",
    city: "Pabianice",
  },
  {
    code: "95-204",
    city: "Pabianice",
  },
  {
    code: "95-205",
    city: "Pabianice",
  },
  {
    code: "96-100",
    city: "Skierniewice",
  },
  {
    code: "96-101",
    city: "Skierniewice",
  },
  {
    code: "96-102",
    city: "Skierniewice",
  },
  {
    code: "96-103",
    city: "Skierniewice",
  },
  {
    code: "96-104",
    city: "Skierniewice",
  },
  {
    code: "96-106",
    city: "Skierniewice",
  },
  {
    code: "96-111",
    city: "Kowiesy",
  },
  {
    code: "96-115",
    city: "Nowy Kawęczyn",
  },
  {
    code: "96-116",
    city: "Dębowa Góra",
  },
  {
    code: "96-124",
    city: "Maków",
  },
  {
    code: "96-126",
    city: "Godzianów",
  },
  {
    code: "96-127",
    city: "Lipce Reymontowskie",
  },
  {
    code: "96-128",
    city: "Słupia",
  },
  {
    code: "96-130",
    city: "Głuchów",
  },
  {
    code: "96-200",
    city: "Rawa Mazowiecka",
  },
  {
    code: "96-201",
    city: "Rawa Mazowiecka",
  },
  {
    code: "96-206",
    city: "Sadkowice",
  },
  {
    code: "96-208",
    city: "Lubania",
  },
  {
    code: "96-214",
    city: "Cielądz",
  },
  {
    code: "96-230",
    city: "Biała Rawska",
  },
  {
    code: "96-232",
    city: "Regnów",
  },
  {
    code: "96-300",
    city: "Żyrardów",
  },
  {
    code: "96-301",
    city: "Żyrardów",
  },
  {
    code: "96-302",
    city: "Żyrardów",
  },
  {
    code: "96-304",
    city: "Żyrardów",
  },
  {
    code: "96-313",
    city: "Jaktorów",
  },
  {
    code: "96-314",
    city: "Baranów",
  },
  {
    code: "96-315",
    city: "Wiskitki",
  },
  {
    code: "96-316",
    city: "Międzyborów",
  },
  {
    code: "96-317",
    city: "Guzów",
  },
  {
    code: "96-320",
    city: "Mszczonów",
  },
  {
    code: "96-321",
    city: "Żabia Wola",
  },
  {
    code: "96-323",
    city: "Osuchów",
  },
  {
    code: "96-325",
    city: "Radziejowice",
  },
  {
    code: "96-330",
    city: "Puszcza Mariańska",
  },
  {
    code: "96-332",
    city: "Radziwiłłów",
  },
  {
    code: "96-500",
    city: "Sochaczew",
  },
  {
    code: "96-501",
    city: "Sochaczew",
  },
  {
    code: "96-503",
    city: "Sochaczew",
  },
  {
    code: "96-505",
    city: "Sochaczew",
  },
  {
    code: "96-512",
    city: "Młodzieszyn",
  },
  {
    code: "96-513",
    city: "Nowa Sucha",
  },
  {
    code: "96-514",
    city: "Rybno",
  },
  {
    code: "96-515",
    city: "Teresin",
  },
  {
    code: "96-516",
    city: "Szymanów",
  },
  {
    code: "96-520",
    city: "Iłów",
  },
  {
    code: "96-521",
    city: "Brzozów Nowy",
  },
  {
    code: "97-200",
    city: "Tomaszów Mazowiecki",
  },
  {
    code: "97-201",
    city: "Tomaszów Mazowiecki",
  },
  {
    code: "97-203",
    city: "Tomaszów Mazowiecki",
  },
  {
    code: "97-204",
    city: "Tomaszów Mazowiecki",
  },
  {
    code: "97-212",
    city: "Budziszewice",
  },
  {
    code: "97-213",
    city: "Smardzewice",
  },
  {
    code: "97-215",
    city: "Inowłódz",
  },
  {
    code: "97-216",
    city: "Czerniewice",
  },
  {
    code: "97-217",
    city: "Lubochnia",
  },
  {
    code: "97-220",
    city: "Rzeczyca",
  },
  {
    code: "97-221",
    city: "Rokiciny",
  },
  {
    code: "97-225",
    city: "Ujazd",
  },
  {
    code: "97-226",
    city: "Żelechlinek",
  },
  {
    code: "97-280",
    city: "Tomaszów Mazowiecki",
  },
  {
    code: "97-300",
    city: "Piotrków Trybunalski",
  },
  {
    code: "97-301",
    city: "Piotrków Trybunalski",
  },
  {
    code: "97-302",
    city: "Piotrków Trybunalski",
  },
  {
    code: "97-306",
    city: "Grabica",
  },
  {
    code: "97-308",
    city: "Piotrków Trybunalski",
  },
  {
    code: "97-309",
    city: "Piotrków Trybunalski",
  },
  {
    code: "97-310",
    city: "Moszczenica",
  },
  {
    code: "97-312",
    city: "Piotrków Trybunalski",
  },
  {
    code: "97-318",
    city: "Czarnocin",
  },
  {
    code: "97-319",
    city: "Będków",
  },
  {
    code: "97-320",
    city: "Wolbórz",
  },
  {
    code: "97-330",
    city: "Sulejów",
  },
  {
    code: "97-340",
    city: "Rozprza",
  },
  {
    code: "97-350",
    city: "Gorzkowice",
  },
  {
    code: "97-352",
    city: "Łęki Szlacheckie",
  },
  {
    code: "97-360",
    city: "Kamieńsk",
  },
  {
    code: "97-371",
    city: "Wola Krzysztoporska",
  },
  {
    code: "97-400",
    city: "Bełchatów",
  },
  {
    code: "97-403",
    city: "Drużbice",
  },
  {
    code: "97-406",
    city: "Bełchatów",
  },
  {
    code: "97-407",
    city: "Bełchatów",
  },
  {
    code: "97-408",
    city: "Bełchatów",
  },
  {
    code: "97-409",
    city: "Bełchatów",
  },
  {
    code: "97-410",
    city: "Kleszczów",
  },
  {
    code: "97-413",
    city: "Bełchatów",
  },
  {
    code: "97-415",
    city: "Kluki",
  },
  {
    code: "97-420",
    city: "Szczerców",
  },
  {
    code: "97-425",
    city: "Zelów",
  },
  {
    code: "97-427",
    city: "Rogowiec",
  },
  {
    code: "97-438",
    city: "Rusiec",
  },
  {
    code: "97-500",
    city: "Radomsko",
  },
  {
    code: "97-501",
    city: "Radomsko",
  },
  {
    code: "97-503",
    city: "Radomsko",
  },
  {
    code: "97-504",
    city: "Radomsko",
  },
  {
    code: "97-505",
    city: "Dobryszyce",
  },
  {
    code: "97-510",
    city: "Ręczno",
  },
  {
    code: "97-512",
    city: "Kodrąb",
  },
  {
    code: "97-515",
    city: "Masłowice",
  },
  {
    code: "97-524",
    city: "Kobiele Wielkie",
  },
  {
    code: "97-525",
    city: "Wielgomłyny",
  },
  {
    code: "97-532",
    city: "Żytno",
  },
  {
    code: "97-540",
    city: "Gidle",
  },
  {
    code: "97-545",
    city: "Gomunice",
  },
  {
    code: "97-561",
    city: "Ładzice",
  },
  {
    code: "97-565",
    city: "Lgota Wielka",
  },
  {
    code: "97-570",
    city: "Przedbórz",
  },
  {
    code: "98-100",
    city: "Łask",
  },
  {
    code: "98-105",
    city: "Wodzierady",
  },
  {
    code: "98-113",
    city: "Buczek",
  },
  {
    code: "98-160",
    city: "Sędziejowice",
  },
  {
    code: "98-161",
    city: "Zapolice",
  },
  {
    code: "98-170",
    city: "Widawa",
  },
  {
    code: "98-200",
    city: "Sieradz",
  },
  {
    code: "98-202",
    city: "Sieradz",
  },
  {
    code: "98-204",
    city: "Sieradz",
  },
  {
    code: "98-209",
    city: "Sieradz",
  },
  {
    code: "98-210",
    city: "Sieradz",
  },
  {
    code: "98-215",
    city: "Goszczanów",
  },
  {
    code: "98-220",
    city: "Zduńska Wola",
  },
  {
    code: "98-230",
    city: "Zduńska Wola",
  },
  {
    code: "98-231",
    city: "Zduńska Wola",
  },
  {
    code: "98-235",
    city: "Błaszki",
  },
  {
    code: "98-240",
    city: "Szadek",
  },
  {
    code: "98-260",
    city: "Burzenin",
  },
  {
    code: "98-270",
    city: "Złoczew",
  },
  {
    code: "98-273",
    city: "Klonowa",
  },
  {
    code: "98-275",
    city: "Brzeźnio",
  },
  {
    code: "98-277",
    city: "Brąszewice",
  },
  {
    code: "98-285",
    city: "Wróblew",
  },
  {
    code: "98-290",
    city: "Warta",
  },
  {
    code: "98-300",
    city: "Wieluń",
  },
  {
    code: "98-303",
    city: "Wieluń",
  },
  {
    code: "98-305",
    city: "Wieluń",
  },
  {
    code: "98-310",
    city: "Czarnożyły",
  },
  {
    code: "98-311",
    city: "Ostrówek",
  },
  {
    code: "98-313",
    city: "Konopnica",
  },
  {
    code: "98-320",
    city: "Osjaków",
  },
  {
    code: "98-324",
    city: "Wierzchlas",
  },
  {
    code: "98-330",
    city: "Pajęczno",
  },
  {
    code: "98-331",
    city: "Nowa Brzeźnica",
  },
  {
    code: "98-332",
    city: "Rząśnia",
  },
  {
    code: "98-335",
    city: "Pątnów",
  },
  {
    code: "98-337",
    city: "Strzelce Wielkie",
  },
  {
    code: "98-338",
    city: "Sulmierzyce",
  },
  {
    code: "98-345",
    city: "Mokrsko",
  },
  {
    code: "98-346",
    city: "Skomlin",
  },
  {
    code: "98-350",
    city: "Biała Druga",
  },
  {
    code: "98-354",
    city: "Siemkowice",
  },
  {
    code: "98-355",
    city: "Działoszyn",
  },
  {
    code: "98-358",
    city: "Kiełczygłów",
  },
  {
    code: "98-360",
    city: "Lututów",
  },
  {
    code: "98-400",
    city: "Wieruszów",
  },
  {
    code: "98-405",
    city: "Galewice",
  },
  {
    code: "98-410",
    city: "Czastary",
  },
  {
    code: "98-420",
    city: "Sokolniki",
  },
  {
    code: "98-430",
    city: "Bolesławiec",
  },
  {
    code: "98-432",
    city: "Łubnice",
  },
  {
    code: "99-100",
    city: "Łęczyca",
  },
  {
    code: "99-101",
    city: "Łęczyca",
  },
  {
    code: "99-104",
    city: "Siedlec",
  },
  {
    code: "99-105",
    city: "Mazew",
  },
  {
    code: "99-106",
    city: "Sobótka",
  },
  {
    code: "99-107",
    city: "Daszyna",
  },
  {
    code: "99-120",
    city: "Piątek",
  },
  {
    code: "99-122",
    city: "Góra Świętej Małgorzaty",
  },
  {
    code: "99-140",
    city: "Świnice Warckie",
  },
  {
    code: "99-150",
    city: "Grabów",
  },
  {
    code: "99-151",
    city: "Błonie",
  },
  {
    code: "99-200",
    city: "Poddębice",
  },
  {
    code: "99-205",
    city: "Dalików",
  },
  {
    code: "99-207",
    city: "Niemysłów",
  },
  {
    code: "99-210",
    city: "Uniejów",
  },
  {
    code: "99-220",
    city: "Wartkowice",
  },
  {
    code: "99-232",
    city: "Zadzim",
  },
  {
    code: "99-235",
    city: "Pęczniew",
  },
  {
    code: "99-300",
    city: "Kutno",
  },
  {
    code: "99-301",
    city: "Kutno",
  },
  {
    code: "99-302",
    city: "Kutno",
  },
  {
    code: "99-306",
    city: "Łanięta",
  },
  {
    code: "99-307",
    city: "Strzelce",
  },
  {
    code: "99-308",
    city: "Kaszewy Kościelne",
  },
  {
    code: "99-310",
    city: "Kutno",
  },
  {
    code: "99-311",
    city: "Bedlno",
  },
  {
    code: "99-312",
    city: "Plecka Dąbrowa",
  },
  {
    code: "99-313",
    city: "Załusin",
  },
  {
    code: "99-314",
    city: "Krzyżanów",
  },
  {
    code: "99-316",
    city: "Mirosławice",
  },
  {
    code: "99-319",
    city: "Dobrzelin",
  },
  {
    code: "99-320",
    city: "Żychlin",
  },
  {
    code: "99-322",
    city: "Oporów",
  },
  {
    code: "99-323",
    city: "Mnich",
  },
  {
    code: "99-331",
    city: "Byszew",
  },
  {
    code: "99-332",
    city: "Wysoka Wielka",
  },
  {
    code: "99-333",
    city: "Nowe",
  },
  {
    code: "99-335",
    city: "Witonia",
  },
  {
    code: "99-340",
    city: "Krośniewice",
  },
  {
    code: "99-350",
    city: "Ostrowy",
  },
  {
    code: "99-352",
    city: "Dąbrowice",
  },
  {
    code: "99-400",
    city: "Łowicz",
  },
  {
    code: "99-401",
    city: "Łowicz",
  },
  {
    code: "99-402",
    city: "Łowicz",
  },
  {
    code: "99-412",
    city: "Kiernozia",
  },
  {
    code: "99-413",
    city: "Chąśno",
  },
  {
    code: "99-414",
    city: "Kocierzew",
  },
  {
    code: "99-416",
    city: "Nieborów",
  },
  {
    code: "99-417",
    city: "Bolimów",
  },
  {
    code: "99-418",
    city: "Bełchów",
  },
  {
    code: "99-420",
    city: "Łyszkowice",
  },
  {
    code: "99-423",
    city: "Bielawy",
  },
  {
    code: "99-434",
    city: "Domaniewice",
  },
  {
    code: "99-440",
    city: "Zduny",
  },
  {
    code: "68-210",
    city: "Nowe Czaple",
  },
  {
    code: "31-877",
    city: "Kraków",
  },
  {
    code: "40-115",
    city: "Katowice",
  },
  {
    code: "80-257",
    city: "Gdańsk",
  },
  {
    code: "28-100",
    city: "Busko-Zdrój",
  },
  {
    code: "62-021",
    city: "Paczkowo",
  },
  {
    code: "30-350",
    city: "Kraków",
  },
  {
    code: "20-583",
    city: "Lublin",
  },
  {
    code: "30-633",
    city: "Kraków",
  },
  {
    code: "58-152",
    city: "Goczałków",
  },
  {
    code: "62-064",
    city: "Plewiska",
  },
  {
    code: "35-317",
    city: "Rzeszów",
  },
  {
    code: "02-701",
    city: "Warszawa",
  },
  {
    code: "81-590",
    city: "Gdynia",
  },
  {
    code: "26-110",
    city: "Michałów",
  },
  {
    code: "03-043",
    city: "Warszawa",
  },
  {
    code: "38-623",
    city: "Bóbrka",
  },
  {
    code: "64-553",
    city: "Grzebienisko",
  },
  {
    code: "45-920",
    city: "Opole",
  },
  {
    code: "68-114",
    city: "Tomaszowo",
  },
  {
    code: "45-940",
    city: "Opole",
  },
  {
    code: "61-696",
    city: "Poznań",
  },
  {
    code: "02-739",
    city: "Warszawa",
  },
  {
    code: "05-808",
    city: "Parzniew",
  },
  {
    code: "05-809",
    city: "Pruszków",
  },
  {
    code: "05-801",
    city: "Pruszków",
  },
  {
    code: "43-262",
    city: "Radostowice",
  },
  {
    code: "28-200",
    city: "Staszów",
  },
  {
    code: "81-594",
    city: "Gdynia",
  },
  {
    code: "85-458",
    city: "Bydgoszcz",
  },
  {
    code: "30-644",
    city: "Kraków",
  },
  {
    code: "31-876",
    city: "Kraków",
  },
]

export default post_codes
